(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2888],{

/***/ 67228:
/***/ (function(module) {

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 22858:
/***/ (function(module) {

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 81506:
/***/ (function(module) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 48926:
/***/ (function(module) {

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

module.exports = _asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 34575:
/***/ (function(module) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 69100:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(99489);

var isNativeReflectConstruct = __webpack_require__(57067);

function _construct(Parent, args, Class) {
  if (isNativeReflectConstruct()) {
    module.exports = _construct = Reflect.construct, module.exports.__esModule = true, module.exports["default"] = module.exports;
  } else {
    module.exports = _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) setPrototypeOf(instance, Class.prototype);
      return instance;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  }

  return _construct.apply(null, arguments);
}

module.exports = _construct, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 93913:
/***/ (function(module) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 59713:
/***/ (function(module) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 29754:
/***/ (function(module) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 2205:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(99489);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 95318:
/***/ (function(module) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 70430:
/***/ (function(module) {

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

module.exports = _isNativeFunction, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 57067:
/***/ (function(module) {

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

module.exports = _isNativeReflectConstruct, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 13884:
/***/ (function(module) {

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 80521:
/***/ (function(module) {

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 78585:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _typeof = (__webpack_require__(50008)["default"]);

var assertThisInitialized = __webpack_require__(81506);

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 99489:
/***/ (function(module) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 63038:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayWithHoles = __webpack_require__(22858);

var iterableToArrayLimit = __webpack_require__(13884);

var unsupportedIterableToArray = __webpack_require__(60379);

var nonIterableRest = __webpack_require__(80521);

function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}

module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 50008:
/***/ (function(module) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
}

module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 60379:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(67228);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}

module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 65957:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getPrototypeOf = __webpack_require__(29754);

var setPrototypeOf = __webpack_require__(99489);

var isNativeFunction = __webpack_require__(70430);

var construct = __webpack_require__(69100);

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  module.exports = _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return construct(Class, arguments, getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return setPrototypeOf(Wrapper, Class);
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _wrapNativeSuper(Class);
}

module.exports = _wrapNativeSuper, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 87757:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(35666);


/***/ }),

/***/ 25687:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "kG": function() { return /* binding */ invariant; }
/* harmony export */ });
/* unused harmony exports getMagnitude, repeat, setInternalSlot, setMultiInternalSlots, getInternalSlot, getMultiInternalSlots, isLiteralPart, defineProperty, UNICODE_EXTENSION_SEQUENCE_REGEX */
/**
 * Cannot do Math.log(x) / Math.log(10) bc if IEEE floating point issue
 * @param x number
 */
function getMagnitude(x) {
    // Cannot count string length via Number.toString because it may use scientific notation
    // for very small or very large numbers.
    return Math.floor(Math.log(x) * Math.LOG10E);
}
function repeat(s, times) {
    if (typeof s.repeat === 'function') {
        return s.repeat(times);
    }
    var arr = new Array(times);
    for (var i = 0; i < arr.length; i++) {
        arr[i] = s;
    }
    return arr.join('');
}
function setInternalSlot(map, pl, field, value) {
    if (!map.get(pl)) {
        map.set(pl, Object.create(null));
    }
    var slots = map.get(pl);
    slots[field] = value;
}
function setMultiInternalSlots(map, pl, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var k = _a[_i];
        setInternalSlot(map, pl, k, props[k]);
    }
}
function getInternalSlot(map, pl, field) {
    return getMultiInternalSlots(map, pl, field)[field];
}
function getMultiInternalSlots(map, pl) {
    var fields = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        fields[_i - 2] = arguments[_i];
    }
    var slots = map.get(pl);
    if (!slots) {
        throw new TypeError("".concat(pl, " InternalSlot has not been initialized"));
    }
    return fields.reduce(function (all, f) {
        all[f] = slots[f];
        return all;
    }, Object.create(null));
}
function isLiteralPart(patternPart) {
    return patternPart.type === 'literal';
}
/*
  17 ECMAScript Standard Built-in Objects:
    Every built-in Function object, including constructors, that is not
    identified as an anonymous function has a name property whose value
    is a String.

    Unless otherwise specified, the name property of a built-in Function
    object, if it exists, has the attributes { [[Writable]]: false,
    [[Enumerable]]: false, [[Configurable]]: true }.
*/
function defineProperty(target, name, _a) {
    var value = _a.value;
    Object.defineProperty(target, name, {
        configurable: true,
        enumerable: false,
        writable: true,
        value: value,
    });
}
var UNICODE_EXTENSION_SEQUENCE_REGEX = /-u(?:-[0-9a-z]{2,8})+/gi;
function invariant(condition, message, Err) {
    if (Err === void 0) { Err = Error; }
    if (!condition) {
        throw new Err(message);
    }
}


/***/ }),

/***/ 95957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ strategies; },
/* harmony export */   "Z": function() { return /* binding */ memoize; }
/* harmony export */ });
//
// Main
//
function memoize(fn, options) {
    var cache = options && options.cache ? options.cache : cacheDefault;
    var serializer = options && options.serializer ? options.serializer : serializerDefault;
    var strategy = options && options.strategy ? options.strategy : strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer,
    });
}
//
// Strategy
//
function isPrimitive(value) {
    return (value == null || typeof value === 'number' || typeof value === 'boolean'); // || typeof value === "string" 'unsafe' primitive for our needs
}
function monadic(fn, cache, serializer, arg) {
    var cacheKey = isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? monadic : variadic;
    return assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function strategyVariadic(fn, options) {
    return assemble(fn, this, variadic, options.cache.create(), options.serializer);
}
function strategyMonadic(fn, options) {
    return assemble(fn, this, monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var serializerDefault = function () {
    return JSON.stringify(arguments);
};
//
// Cache
//
function ObjectWithoutPrototypeCache() {
    this.cache = Object.create(null);
}
ObjectWithoutPrototypeCache.prototype.get = function (key) {
    return this.cache[key];
};
ObjectWithoutPrototypeCache.prototype.set = function (key, value) {
    this.cache[key] = value;
};
var cacheDefault = {
    create: function create() {
        // @ts-ignore
        return new ObjectWithoutPrototypeCache();
    },
};
var strategies = {
    variadic: strategyVariadic,
    monadic: strategyMonadic,
};


/***/ }),

/***/ 56096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "wD": function() { return /* reexport */ TYPE; },
  "VG": function() { return /* reexport */ isArgumentElement; },
  "rp": function() { return /* reexport */ isDateElement; },
  "Ii": function() { return /* reexport */ isDateTimeSkeleton; },
  "O4": function() { return /* reexport */ isLiteralElement; },
  "uf": function() { return /* reexport */ isNumberElement; },
  "Wh": function() { return /* reexport */ isNumberSkeleton; },
  "Jo": function() { return /* reexport */ isPluralElement; },
  "yx": function() { return /* reexport */ isPoundElement; },
  "Wi": function() { return /* reexport */ isSelectElement; },
  "HI": function() { return /* reexport */ isTagElement; },
  "pe": function() { return /* reexport */ isTimeElement; },
  "Qc": function() { return /* binding */ parse; }
});

// UNUSED EXPORTS: SKELETON_TYPE, createLiteralElement, createNumberElement

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/error.js
var ErrorKind;
(function (ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */
    ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */
    ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */
    ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */
    ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */
    ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */
    ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */
    ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */
    ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */
    ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */
    ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */
    ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */
    ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */
    ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */
    ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */
    ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */
    ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */
    ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */
    ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */
    ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */
    ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */
    ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */
    ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */
    ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */
    ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */
    ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */
    ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})(ErrorKind || (ErrorKind = {}));

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/types.js
var TYPE;
(function (TYPE) {
    /**
     * Raw text
     */
    TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */
    TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */
    TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */
    TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */
    TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */
    TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */
    TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */
    TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */
    TYPE[TYPE["tag"] = 8] = "tag";
})(TYPE || (TYPE = {}));
var SKELETON_TYPE;
(function (SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})(SKELETON_TYPE || (SKELETON_TYPE = {}));
/**
 * Type Guards
 */
function isLiteralElement(el) {
    return el.type === TYPE.literal;
}
function isArgumentElement(el) {
    return el.type === TYPE.argument;
}
function isNumberElement(el) {
    return el.type === TYPE.number;
}
function isDateElement(el) {
    return el.type === TYPE.date;
}
function isTimeElement(el) {
    return el.type === TYPE.time;
}
function isSelectElement(el) {
    return el.type === TYPE.select;
}
function isPluralElement(el) {
    return el.type === TYPE.plural;
}
function isPoundElement(el) {
    return el.type === TYPE.pound;
}
function isTagElement(el) {
    return el.type === TYPE.tag;
}
function isNumberSkeleton(el) {
    return !!(el && typeof el === 'object' && el.type === SKELETON_TYPE.number);
}
function isDateTimeSkeleton(el) {
    return !!(el && typeof el === 'object' && el.type === SKELETON_TYPE.dateTime);
}
function createLiteralElement(value) {
    return {
        type: TYPE.literal,
        value: value,
    };
}
function createNumberElement(value, style) {
    return {
        type: TYPE.number,
        value: value,
        style: style,
    };
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/regex.generated.js
// @generated from regex-gen.ts
var SPACE_SEPARATOR_REGEX = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-skeleton-parser/lib/date-time.js
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */
var DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
/**
 * Parse Date time skeleton into Intl.DateTimeFormatOptions
 * Ref: https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * @public
 * @param skeleton skeleton string
 */
function parseDateTimeSkeleton(skeleton) {
    var result = {};
    skeleton.replace(DATE_TIME_REGEX, function (match) {
        var len = match.length;
        switch (match[0]) {
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = ['numeric', '2-digit', 'short', 'long', 'narrow'][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = ['numeric', '2-digit'][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'short' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) {
                    throw new RangeError('`e..eee` (weekday) patterns are not supported');
                }
                result.weekday = ['short', 'long', 'narrow', 'short'][len - 4];
                break;
            case 'c':
                if (len < 4) {
                    throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                }
                result.weekday = ['short', 'long', 'narrow', 'short'][len - 4];
                break;
            // Period
            case 'a': // AM, PM
                result.hour12 = true;
                break;
            case 'b': // am, pm, noon, midnight
            case 'B': // flexible day periods
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = ['numeric', '2-digit'][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = ['numeric', '2-digit'][len - 1];
                break;
            // Second
            case 's':
                result.second = ['numeric', '2-digit'][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z': // 1..3, 4: specific non-location format
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z': // 1..3, 4, 5: The ISO8601 varios formats
            case 'O': // 1, 4: miliseconds in day short, long
            case 'v': // 1, 4: generic non-location format
            case 'V': // 1, 2, 3, 4: time zone ID or city
            case 'X': // 1, 2, 3, 4: The ISO8601 varios formats
            case 'x': // 1, 2, 3, 4: The ISO8601 varios formats
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-skeleton-parser/lib/regex.generated.js
// @generated from regex-gen.ts
var regex_generated_WHITE_SPACE_REGEX = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-skeleton-parser/lib/number.js


function parseNumberSkeletonFromString(skeleton) {
    if (skeleton.length === 0) {
        throw new Error('Number skeleton cannot be empty');
    }
    // Parse the skeleton
    var stringTokens = skeleton
        .split(regex_generated_WHITE_SPACE_REGEX)
        .filter(function (x) { return x.length > 0; });
    var tokens = [];
    for (var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++) {
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) {
            throw new Error('Invalid number skeleton');
        }
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for (var _a = 0, options_1 = options; _a < options_1.length; _a++) {
            var option = options_1[_a];
            if (option.length === 0) {
                throw new Error('Invalid number skeleton');
            }
        }
        tokens.push({ stem: stem, options: options });
    }
    return tokens;
}
function icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') {
        result.roundingPriority = 'morePrecision';
    }
    else if (str[str.length - 1] === 's') {
        result.roundingPriority = 'lessPrecision';
    }
    str.replace(SIGNIFICANT_PRECISION_REGEX, function (_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        }
        // @@@+ case
        else if (g2 === '+') {
            result.minimumSignificantDigits = g1.length;
        }
        // .### case
        else if (g1[0] === '#') {
            result.maximumSignificantDigits = g1.length;
        }
        // .@@## or .@@@ case
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits =
                g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function parseSign(str) {
    switch (str) {
        case 'sign-auto':
            return {
                signDisplay: 'auto',
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting',
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always',
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting',
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero',
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting',
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never',
            };
    }
}
function parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering',
        };
        stem = stem.slice(2);
    }
    else if (stem[0] === 'E') {
        result = {
            notation: 'scientific',
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        }
        else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!CONCISE_INTEGER_WIDTH_REGEX.test(stem)) {
            throw new Error('Malformed concise eng/scientific notation');
        }
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function parseNotationOptions(opt) {
    var result = {};
    var signOpts = parseSign(opt);
    if (signOpts) {
        return signOpts;
    }
    return result;
}
/**
 * https://github.com/unicode-org/icu/blob/master/docs/userguide/format_parse/numbers/skeletons.md#skeleton-stems-and-options
 */
function parseNumberSkeleton(tokens) {
    var result = {};
    for (var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++) {
        var token = tokens_1[_i];
        switch (token.stem) {
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, result), { notation: 'scientific' }), token.options.reduce(function (all, opt) { return ((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, all), parseNotationOptions(opt))); }, {}));
                continue;
            case 'engineering':
                result = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, result), { notation: 'engineering' }), token.options.reduce(function (all, opt) { return ((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, all), parseNotationOptions(opt))); }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) {
                    throw new RangeError('integer-width stems only accept a single optional option');
                }
                token.options[0].replace(INTEGER_WIDTH_REGEX, function (_, g1, g2, g3, g4, g5) {
                    if (g1) {
                        result.minimumIntegerDigits = g2.length;
                    }
                    else if (g3 && g4) {
                        throw new Error('We currently do not support maximum integer digits');
                    }
                    else if (g5) {
                        throw new Error('We currently do not support exact integer digits');
                    }
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if (CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if (FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) {
                throw new RangeError('Fraction-precision stems only accept a single optional option');
            }
            token.stem.replace(FRACTION_PRECISION_REGEX, function (_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') {
                    result.minimumFractionDigits = g1.length;
                }
                // .### case
                else if (g3 && g3[0] === '#') {
                    result.maximumFractionDigits = g3.length;
                }
                // .00## case
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                }
                else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') {
                result = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, result), { trailingZeroDisplay: 'stripIfInteger' });
            }
            else if (opt) {
                result = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, result), parseSignificantPrecision(opt));
            }
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if (SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, result), parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = parseSign(token.stem);
        if (signOpts) {
            result = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, result), signOpts);
        }
        var conciseScientificAndEngineeringOpts = parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) {
            result = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, result), conciseScientificAndEngineeringOpts);
        }
    }
    return result;
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/time-data.generated.js
// @generated from time-data-gen.ts
// prettier-ignore  
var timeData = {
    "AX": [
        "H"
    ],
    "BQ": [
        "H"
    ],
    "CP": [
        "H"
    ],
    "CZ": [
        "H"
    ],
    "DK": [
        "H"
    ],
    "FI": [
        "H"
    ],
    "ID": [
        "H"
    ],
    "IS": [
        "H"
    ],
    "ML": [
        "H"
    ],
    "NE": [
        "H"
    ],
    "RU": [
        "H"
    ],
    "SE": [
        "H"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "AS": [
        "h",
        "H"
    ],
    "BT": [
        "h",
        "H"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "GH": [
        "h",
        "H"
    ],
    "IN": [
        "h",
        "H"
    ],
    "LS": [
        "h",
        "H"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PW": [
        "h",
        "H"
    ],
    "SO": [
        "h",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WS": [
        "h",
        "H"
    ],
    "001": [
        "H",
        "h"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "AR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CL": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "CU": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BO": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-EC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-PE": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "GT": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "HN": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MX": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "NI": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "PY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "SV": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "UY": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "JP": [
        "H",
        "h",
        "K"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BO": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "EC": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "PE": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ]
};

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/date-time-pattern-generator.js

/**
 * Returns the best matching date time pattern if a date time skeleton
 * pattern is provided with a locale. Follows the Unicode specification:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#table-mapping-requested-time-skeletons-to-patterns
 * @param skeleton date time skeleton pattern that possibly includes j, J or C
 * @param locale
 */
function getBestPattern(skeleton, locale) {
    var skeletonCopy = '';
    for (var patternPos = 0; patternPos < skeleton.length; patternPos++) {
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while (patternPos + 1 < skeleton.length &&
                skeleton.charAt(patternPos + 1) === patternChar) {
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') {
                dayPeriodLen = 0;
            }
            while (dayPeriodLen-- > 0) {
                skeletonCopy += dayPeriodChar;
            }
            while (hourLen-- > 0) {
                skeletonCopy = hourChar + skeletonCopy;
            }
        }
        else if (patternChar === 'J') {
            skeletonCopy += 'H';
        }
        else {
            skeletonCopy += patternChar;
        }
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */
function getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined &&
        // @ts-ignore hourCycle(s) is not identified yet
        locale.hourCycles &&
        // @ts-ignore
        locale.hourCycles.length) {
        // @ts-ignore
        hourCycle = locale.hourCycles[0];
    }
    if (hourCycle) {
        switch (hourCycle) {
            case 'h24':
                return 'k';
            case 'h23':
                return 'H';
            case 'h12':
                return 'h';
            case 'h11':
                return 'K';
            default:
                throw new Error('Invalid hourCycle');
        }
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') {
        regionTag = locale.maximize().region;
    }
    var hourCycles = timeData[regionTag || ''] ||
        timeData[languageTag || ''] ||
        timeData["".concat(languageTag, "-001")] ||
        timeData["001"];
    return hourCycles[0];
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/parser.js
var _a;






var SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat(SPACE_SEPARATOR_REGEX.source, "*"));
var SPACE_SEPARATOR_END_REGEX = new RegExp("".concat(SPACE_SEPARATOR_REGEX.source, "*$"));
function createLocation(start, end) {
    return { start: start, end: end };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var hasNativeStartsWith = !!String.prototype.startsWith;
var hasNativeFromCodePoint = !!String.fromCodePoint;
var hasNativeFromEntries = !!Object.fromEntries;
var hasNativeCodePointAt = !!String.prototype.codePointAt;
var hasTrimStart = !!String.prototype.trimStart;
var hasTrimEnd = !!String.prototype.trimEnd;
var hasNativeIsSafeInteger = !!Number.isSafeInteger;
var isSafeInteger = hasNativeIsSafeInteger
    ? Number.isSafeInteger
    : function (n) {
        return (typeof n === 'number' &&
            isFinite(n) &&
            Math.floor(n) === n &&
            Math.abs(n) <= 0x1fffffffffffff);
    };
// IE11 does not support y and u.
var REGEX_SUPPORTS_U_AND_Y = true;
try {
    var re = RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */
    REGEX_SUPPORTS_U_AND_Y = ((_a = re.exec('a')) === null || _a === void 0 ? void 0 : _a[0]) === 'a';
}
catch (_) {
    REGEX_SUPPORTS_U_AND_Y = false;
}
var startsWith = hasNativeStartsWith
    ? // Native
        function startsWith(s, search, position) {
            return s.startsWith(search, position);
        }
    : // For IE11
        function startsWith(s, search, position) {
            return s.slice(position, position + search.length) === search;
        };
var fromCodePoint = hasNativeFromCodePoint
    ? String.fromCodePoint
    : // IE11
        function fromCodePoint() {
            var codePoints = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                codePoints[_i] = arguments[_i];
            }
            var elements = '';
            var length = codePoints.length;
            var i = 0;
            var code;
            while (length > i) {
                code = codePoints[i++];
                if (code > 0x10ffff)
                    throw RangeError(code + ' is not a valid code point');
                elements +=
                    code < 0x10000
                        ? String.fromCharCode(code)
                        : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, (code % 0x400) + 0xdc00);
            }
            return elements;
        };
var fromEntries = 
// native
hasNativeFromEntries
    ? Object.fromEntries
    : // Ponyfill
        function fromEntries(entries) {
            var obj = {};
            for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
                var _a = entries_1[_i], k = _a[0], v = _a[1];
                obj[k] = v;
            }
            return obj;
        };
var codePointAt = hasNativeCodePointAt
    ? // Native
        function codePointAt(s, index) {
            return s.codePointAt(index);
        }
    : // IE 11
        function codePointAt(s, index) {
            var size = s.length;
            if (index < 0 || index >= size) {
                return undefined;
            }
            var first = s.charCodeAt(index);
            var second;
            return first < 0xd800 ||
                first > 0xdbff ||
                index + 1 === size ||
                (second = s.charCodeAt(index + 1)) < 0xdc00 ||
                second > 0xdfff
                ? first
                : ((first - 0xd800) << 10) + (second - 0xdc00) + 0x10000;
        };
var trimStart = hasTrimStart
    ? // Native
        function trimStart(s) {
            return s.trimStart();
        }
    : // Ponyfill
        function trimStart(s) {
            return s.replace(SPACE_SEPARATOR_START_REGEX, '');
        };
var trimEnd = hasTrimEnd
    ? // Native
        function trimEnd(s) {
            return s.trimEnd();
        }
    : // Ponyfill
        function trimEnd(s) {
            return s.replace(SPACE_SEPARATOR_END_REGEX, '');
        };
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var matchIdentifierAtIndex;
if (REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var IDENTIFIER_PREFIX_RE_1 = RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
}
else {
    // IE11
    matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var match = [];
        while (true) {
            var c = codePointAt(s, index);
            if (c === undefined || _isWhiteSpace(c) || _isPatternSyntax(c)) {
                break;
            }
            match.push(c);
            index += c >= 0x10000 ? 2 : 1;
        }
        return fromCodePoint.apply(void 0, match);
    };
}
var Parser = /** @class */ (function () {
    function Parser(message, options) {
        if (options === void 0) { options = {}; }
        this.message = message;
        this.position = { offset: 0, line: 1, column: 1 };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function () {
        if (this.offset() !== 0) {
            throw Error('parser can only be used once');
        }
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function (nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while (!this.isEOF()) {
            var char = this.char();
            if (char === 123 /* `{` */) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) {
                    return result;
                }
                elements.push(result.val);
            }
            else if (char === 125 /* `}` */ && nestingLevel > 0) {
                break;
            }
            else if (char === 35 /* `#` */ &&
                (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: TYPE.pound,
                    location: createLocation(position, this.clonePosition()),
                });
            }
            else if (char === 60 /* `<` */ &&
                !this.ignoreTag &&
                this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) {
                    break;
                }
                else {
                    return this.error(ErrorKind.UNMATCHED_CLOSING_TAG, createLocation(this.clonePosition(), this.clonePosition()));
                }
            }
            else if (char === 60 /* `<` */ &&
                !this.ignoreTag &&
                _isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) {
                    return result;
                }
                elements.push(result.val);
            }
            else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) {
                    return result;
                }
                elements.push(result.val);
            }
        }
        return { val: elements, err: null };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */
    Parser.prototype.parseTag = function (nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) {
            // Self closing tag
            return {
                val: {
                    type: TYPE.literal,
                    value: "<".concat(tagName, "/>"),
                    location: createLocation(startPosition, this.clonePosition()),
                },
                err: null,
            };
        }
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) {
                return childrenResult;
            }
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !_isAlpha(this.char())) {
                    return this.error(ErrorKind.INVALID_TAG, createLocation(endTagStartPosition, this.clonePosition()));
                }
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) {
                    return this.error(ErrorKind.UNMATCHED_CLOSING_TAG, createLocation(closingTagNameStartPosition, this.clonePosition()));
                }
                this.bumpSpace();
                if (!this.bumpIf('>')) {
                    return this.error(ErrorKind.INVALID_TAG, createLocation(endTagStartPosition, this.clonePosition()));
                }
                return {
                    val: {
                        type: TYPE.tag,
                        value: tagName,
                        children: children,
                        location: createLocation(startPosition, this.clonePosition()),
                    },
                    err: null,
                };
            }
            else {
                return this.error(ErrorKind.UNCLOSED_TAG, createLocation(startPosition, this.clonePosition()));
            }
        }
        else {
            return this.error(ErrorKind.INVALID_TAG, createLocation(startPosition, this.clonePosition()));
        }
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */
    Parser.prototype.parseTagName = function () {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while (!this.isEOF() && _isPotentialElementNameChar(this.char())) {
            this.bump();
        }
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function (nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while (true) {
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = createLocation(start, this.clonePosition());
        return {
            val: { type: TYPE.literal, value: value, location: location },
            err: null,
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function () {
        if (!this.isEOF() &&
            this.char() === 60 /* `<` */ &&
            (this.ignoreTag ||
                // If at the opening tag or closing tag position, bail.
                !_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */
    Parser.prototype.tryParseQuote = function (parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */) {
            return null;
        }
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch (this.peek()) {
            case 39 /* `'` */:
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35: // '#'
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') {
                    break;
                }
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [this.char()]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while (!this.isEOF()) {
            var ch = this.char();
            if (ch === 39 /* `'` */) {
                if (this.peek() === 39 /* `'` */) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                }
                else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            }
            else {
                codePoints.push(ch);
            }
            this.bump();
        }
        return fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function (nestingLevel, parentArgType) {
        if (this.isEOF()) {
            return null;
        }
        var ch = this.char();
        if (ch === 60 /* `<` */ ||
            ch === 123 /* `{` */ ||
            (ch === 35 /* `#` */ &&
                (parentArgType === 'plural' || parentArgType === 'selectordinal')) ||
            (ch === 125 /* `}` */ && nestingLevel > 0)) {
            return null;
        }
        else {
            this.bump();
            return fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function (nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) {
            return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        }
        if (this.char() === 125 /* `}` */) {
            this.bump();
            return this.error(ErrorKind.EMPTY_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) {
            return this.error(ErrorKind.MALFORMED_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        }
        this.bumpSpace();
        if (this.isEOF()) {
            return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        }
        switch (this.char()) {
            // Simple argument: `{name}`
            case 125 /* `}` */: {
                this.bump(); // `}`
                return {
                    val: {
                        type: TYPE.argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: createLocation(openingBracePosition, this.clonePosition()),
                    },
                    err: null,
                };
            }
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */: {
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) {
                    return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
                }
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            }
            default:
                return this.error(ErrorKind.MALFORMED_ARGUMENT, createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */
    Parser.prototype.parseIdentifierIfPossible = function () {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = createLocation(startingPosition, endPosition);
        return { value: value, location: location };
    };
    Parser.prototype.parseArgumentOptions = function (nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch (argType) {
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error(ErrorKind.EXPECT_ARGUMENT_TYPE, createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time': {
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) {
                        return result;
                    }
                    var style = trimEnd(result.val);
                    if (style.length === 0) {
                        return this.error(ErrorKind.EXPECT_ARGUMENT_STYLE, createLocation(this.clonePosition(), this.clonePosition()));
                    }
                    var styleLocation = createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = { style: style, styleLocation: styleLocation };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) {
                    return argCloseResult;
                }
                var location_1 = createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) {
                            return result;
                        }
                        return {
                            val: { type: TYPE.number, value: value, location: location_1, style: result.val },
                            err: null,
                        };
                    }
                    else {
                        if (skeleton.length === 0) {
                            return this.error(ErrorKind.EXPECT_DATE_TIME_SKELETON, location_1);
                        }
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) {
                            dateTimePattern = getBestPattern(skeleton, this.locale);
                        }
                        var style = {
                            type: SKELETON_TYPE.dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons
                                ? parseDateTimeSkeleton(dateTimePattern)
                                : {},
                        };
                        var type = argType === 'date' ? TYPE.date : TYPE.time;
                        return {
                            val: { type: type, value: value, location: location_1, style: style },
                            err: null,
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number'
                            ? TYPE.number
                            : argType === 'date'
                                ? TYPE.date
                                : TYPE.time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null,
                    },
                    err: null,
                };
            }
            case 'plural':
            case 'selectordinal':
            case 'select': {
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) {
                    return this.error(ErrorKind.EXPECT_SELECT_ARGUMENT_OPTIONS, createLocation(typeEndPosition_1, (0,tslib_es6/* __assign */.pi)({}, typeEndPosition_1)));
                }
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) {
                        return this.error(ErrorKind.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, createLocation(this.clonePosition(), this.clonePosition()));
                    }
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger(ErrorKind.EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, ErrorKind.INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) {
                        return result;
                    }
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) {
                    return optionsResult;
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) {
                    return argCloseResult;
                }
                var location_2 = createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') {
                    return {
                        val: {
                            type: TYPE.select,
                            value: value,
                            options: fromEntries(optionsResult.val),
                            location: location_2,
                        },
                        err: null,
                    };
                }
                else {
                    return {
                        val: {
                            type: TYPE.plural,
                            value: value,
                            options: fromEntries(optionsResult.val),
                            offset: pluralOffset,
                            pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                            location: location_2,
                        },
                        err: null,
                    };
                }
            }
            default:
                return this.error(ErrorKind.INVALID_ARGUMENT_TYPE, createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function (openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */) {
            return this.error(ErrorKind.EXPECT_ARGUMENT_CLOSING_BRACE, createLocation(openingBracePosition, this.clonePosition()));
        }
        this.bump(); // `}`
        return { val: true, err: null };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */
    Parser.prototype.parseSimpleArgStyleIfPossible = function () {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while (!this.isEOF()) {
            var ch = this.char();
            switch (ch) {
                case 39 /* `'` */: {
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) {
                        return this.error(ErrorKind.UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, createLocation(apostrophePosition, this.clonePosition()));
                    }
                    this.bump();
                    break;
                }
                case 123 /* `{` */: {
                    nestedBraces += 1;
                    this.bump();
                    break;
                }
                case 125 /* `}` */: {
                    if (nestedBraces > 0) {
                        nestedBraces -= 1;
                    }
                    else {
                        return {
                            val: this.message.slice(startPosition.offset, this.offset()),
                            err: null,
                        };
                    }
                    break;
                }
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null,
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function (skeleton, location) {
        var tokens = [];
        try {
            tokens = parseNumberSkeletonFromString(skeleton);
        }
        catch (e) {
            return this.error(ErrorKind.INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: SKELETON_TYPE.number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons
                    ? parseNumberSkeleton(tokens)
                    : {},
            },
            err: null,
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */
    Parser.prototype.tryParsePluralOrSelectOptions = function (nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while (true) {
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger(ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR, ErrorKind.INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) {
                        return result;
                    }
                    selectorLocation = createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                }
                else {
                    break;
                }
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) {
                return this.error(parentArgType === 'select'
                    ? ErrorKind.DUPLICATE_SELECT_ARGUMENT_SELECTOR
                    : ErrorKind.DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            }
            if (selector === 'other') {
                hasOtherClause = true;
            }
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) {
                return this.error(parentArgType === 'select'
                    ? ErrorKind.EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT
                    : ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, createLocation(this.clonePosition(), this.clonePosition()));
            }
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) {
                return fragmentResult;
            }
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) {
                return argCloseResult;
            }
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: createLocation(openingBracePosition, this.clonePosition()),
                },
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            (_a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location);
        }
        if (options.length === 0) {
            return this.error(parentArgType === 'select'
                ? ErrorKind.EXPECT_SELECT_ARGUMENT_SELECTOR
                : ErrorKind.EXPECT_PLURAL_ARGUMENT_SELECTOR, createLocation(this.clonePosition(), this.clonePosition()));
        }
        if (this.requiresOtherClause && !hasOtherClause) {
            return this.error(ErrorKind.MISSING_OTHER_CLAUSE, createLocation(this.clonePosition(), this.clonePosition()));
        }
        return { val: options, err: null };
    };
    Parser.prototype.tryParseDecimalInteger = function (expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) {
        }
        else if (this.bumpIf('-')) {
            sign = -1;
        }
        var hasDigits = false;
        var decimal = 0;
        while (!this.isEOF()) {
            var ch = this.char();
            if (ch >= 48 /* `0` */ && ch <= 57 /* `9` */) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            }
            else {
                break;
            }
        }
        var location = createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) {
            return this.error(expectNumberError, location);
        }
        decimal *= sign;
        if (!isSafeInteger(decimal)) {
            return this.error(invalidNumberError, location);
        }
        return { val: decimal, err: null };
    };
    Parser.prototype.offset = function () {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function () {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function () {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column,
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */
    Parser.prototype.char = function () {
        var offset = this.position.offset;
        if (offset >= this.message.length) {
            throw Error('out of bound');
        }
        var code = codePointAt(this.message, offset);
        if (code === undefined) {
            throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        }
        return code;
    };
    Parser.prototype.error = function (kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location,
            },
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */
    Parser.prototype.bump = function () {
        if (this.isEOF()) {
            return;
        }
        var code = this.char();
        if (code === 10 /* '\n' */) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        }
        else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */
    Parser.prototype.bumpIf = function (prefix) {
        if (startsWith(this.message, prefix, this.offset())) {
            for (var i = 0; i < prefix.length; i++) {
                this.bump();
            }
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */
    Parser.prototype.bumpUntil = function (pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        }
        else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */
    Parser.prototype.bumpTo = function (targetOffset) {
        if (this.offset() > targetOffset) {
            throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        }
        targetOffset = Math.min(targetOffset, this.message.length);
        while (true) {
            var offset = this.offset();
            if (offset === targetOffset) {
                break;
            }
            if (offset > targetOffset) {
                throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            }
            this.bump();
            if (this.isEOF()) {
                break;
            }
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */
    Parser.prototype.bumpSpace = function () {
        while (!this.isEOF() && _isWhiteSpace(this.char())) {
            this.bump();
        }
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */
    Parser.prototype.peek = function () {
        if (this.isEOF()) {
            return null;
        }
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}());

/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */
function _isAlpha(codepoint) {
    return ((codepoint >= 97 && codepoint <= 122) ||
        (codepoint >= 65 && codepoint <= 90));
}
function _isAlphaOrSlash(codepoint) {
    return _isAlpha(codepoint) || codepoint === 47; /* '/' */
}
/** See `parseTag` function docs. */
function _isPotentialElementNameChar(c) {
    return (c === 45 /* '-' */ ||
        c === 46 /* '.' */ ||
        (c >= 48 && c <= 57) /* 0..9 */ ||
        c === 95 /* '_' */ ||
        (c >= 97 && c <= 122) /** a..z */ ||
        (c >= 65 && c <= 90) /* A..Z */ ||
        c == 0xb7 ||
        (c >= 0xc0 && c <= 0xd6) ||
        (c >= 0xd8 && c <= 0xf6) ||
        (c >= 0xf8 && c <= 0x37d) ||
        (c >= 0x37f && c <= 0x1fff) ||
        (c >= 0x200c && c <= 0x200d) ||
        (c >= 0x203f && c <= 0x2040) ||
        (c >= 0x2070 && c <= 0x218f) ||
        (c >= 0x2c00 && c <= 0x2fef) ||
        (c >= 0x3001 && c <= 0xd7ff) ||
        (c >= 0xf900 && c <= 0xfdcf) ||
        (c >= 0xfdf0 && c <= 0xfffd) ||
        (c >= 0x10000 && c <= 0xeffff));
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */
function _isWhiteSpace(c) {
    return ((c >= 0x0009 && c <= 0x000d) ||
        c === 0x0020 ||
        c === 0x0085 ||
        (c >= 0x200e && c <= 0x200f) ||
        c === 0x2028 ||
        c === 0x2029);
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */
function _isPatternSyntax(c) {
    return ((c >= 0x0021 && c <= 0x0023) ||
        c === 0x0024 ||
        (c >= 0x0025 && c <= 0x0027) ||
        c === 0x0028 ||
        c === 0x0029 ||
        c === 0x002a ||
        c === 0x002b ||
        c === 0x002c ||
        c === 0x002d ||
        (c >= 0x002e && c <= 0x002f) ||
        (c >= 0x003a && c <= 0x003b) ||
        (c >= 0x003c && c <= 0x003e) ||
        (c >= 0x003f && c <= 0x0040) ||
        c === 0x005b ||
        c === 0x005c ||
        c === 0x005d ||
        c === 0x005e ||
        c === 0x0060 ||
        c === 0x007b ||
        c === 0x007c ||
        c === 0x007d ||
        c === 0x007e ||
        c === 0x00a1 ||
        (c >= 0x00a2 && c <= 0x00a5) ||
        c === 0x00a6 ||
        c === 0x00a7 ||
        c === 0x00a9 ||
        c === 0x00ab ||
        c === 0x00ac ||
        c === 0x00ae ||
        c === 0x00b0 ||
        c === 0x00b1 ||
        c === 0x00b6 ||
        c === 0x00bb ||
        c === 0x00bf ||
        c === 0x00d7 ||
        c === 0x00f7 ||
        (c >= 0x2010 && c <= 0x2015) ||
        (c >= 0x2016 && c <= 0x2017) ||
        c === 0x2018 ||
        c === 0x2019 ||
        c === 0x201a ||
        (c >= 0x201b && c <= 0x201c) ||
        c === 0x201d ||
        c === 0x201e ||
        c === 0x201f ||
        (c >= 0x2020 && c <= 0x2027) ||
        (c >= 0x2030 && c <= 0x2038) ||
        c === 0x2039 ||
        c === 0x203a ||
        (c >= 0x203b && c <= 0x203e) ||
        (c >= 0x2041 && c <= 0x2043) ||
        c === 0x2044 ||
        c === 0x2045 ||
        c === 0x2046 ||
        (c >= 0x2047 && c <= 0x2051) ||
        c === 0x2052 ||
        c === 0x2053 ||
        (c >= 0x2055 && c <= 0x205e) ||
        (c >= 0x2190 && c <= 0x2194) ||
        (c >= 0x2195 && c <= 0x2199) ||
        (c >= 0x219a && c <= 0x219b) ||
        (c >= 0x219c && c <= 0x219f) ||
        c === 0x21a0 ||
        (c >= 0x21a1 && c <= 0x21a2) ||
        c === 0x21a3 ||
        (c >= 0x21a4 && c <= 0x21a5) ||
        c === 0x21a6 ||
        (c >= 0x21a7 && c <= 0x21ad) ||
        c === 0x21ae ||
        (c >= 0x21af && c <= 0x21cd) ||
        (c >= 0x21ce && c <= 0x21cf) ||
        (c >= 0x21d0 && c <= 0x21d1) ||
        c === 0x21d2 ||
        c === 0x21d3 ||
        c === 0x21d4 ||
        (c >= 0x21d5 && c <= 0x21f3) ||
        (c >= 0x21f4 && c <= 0x22ff) ||
        (c >= 0x2300 && c <= 0x2307) ||
        c === 0x2308 ||
        c === 0x2309 ||
        c === 0x230a ||
        c === 0x230b ||
        (c >= 0x230c && c <= 0x231f) ||
        (c >= 0x2320 && c <= 0x2321) ||
        (c >= 0x2322 && c <= 0x2328) ||
        c === 0x2329 ||
        c === 0x232a ||
        (c >= 0x232b && c <= 0x237b) ||
        c === 0x237c ||
        (c >= 0x237d && c <= 0x239a) ||
        (c >= 0x239b && c <= 0x23b3) ||
        (c >= 0x23b4 && c <= 0x23db) ||
        (c >= 0x23dc && c <= 0x23e1) ||
        (c >= 0x23e2 && c <= 0x2426) ||
        (c >= 0x2427 && c <= 0x243f) ||
        (c >= 0x2440 && c <= 0x244a) ||
        (c >= 0x244b && c <= 0x245f) ||
        (c >= 0x2500 && c <= 0x25b6) ||
        c === 0x25b7 ||
        (c >= 0x25b8 && c <= 0x25c0) ||
        c === 0x25c1 ||
        (c >= 0x25c2 && c <= 0x25f7) ||
        (c >= 0x25f8 && c <= 0x25ff) ||
        (c >= 0x2600 && c <= 0x266e) ||
        c === 0x266f ||
        (c >= 0x2670 && c <= 0x2767) ||
        c === 0x2768 ||
        c === 0x2769 ||
        c === 0x276a ||
        c === 0x276b ||
        c === 0x276c ||
        c === 0x276d ||
        c === 0x276e ||
        c === 0x276f ||
        c === 0x2770 ||
        c === 0x2771 ||
        c === 0x2772 ||
        c === 0x2773 ||
        c === 0x2774 ||
        c === 0x2775 ||
        (c >= 0x2794 && c <= 0x27bf) ||
        (c >= 0x27c0 && c <= 0x27c4) ||
        c === 0x27c5 ||
        c === 0x27c6 ||
        (c >= 0x27c7 && c <= 0x27e5) ||
        c === 0x27e6 ||
        c === 0x27e7 ||
        c === 0x27e8 ||
        c === 0x27e9 ||
        c === 0x27ea ||
        c === 0x27eb ||
        c === 0x27ec ||
        c === 0x27ed ||
        c === 0x27ee ||
        c === 0x27ef ||
        (c >= 0x27f0 && c <= 0x27ff) ||
        (c >= 0x2800 && c <= 0x28ff) ||
        (c >= 0x2900 && c <= 0x2982) ||
        c === 0x2983 ||
        c === 0x2984 ||
        c === 0x2985 ||
        c === 0x2986 ||
        c === 0x2987 ||
        c === 0x2988 ||
        c === 0x2989 ||
        c === 0x298a ||
        c === 0x298b ||
        c === 0x298c ||
        c === 0x298d ||
        c === 0x298e ||
        c === 0x298f ||
        c === 0x2990 ||
        c === 0x2991 ||
        c === 0x2992 ||
        c === 0x2993 ||
        c === 0x2994 ||
        c === 0x2995 ||
        c === 0x2996 ||
        c === 0x2997 ||
        c === 0x2998 ||
        (c >= 0x2999 && c <= 0x29d7) ||
        c === 0x29d8 ||
        c === 0x29d9 ||
        c === 0x29da ||
        c === 0x29db ||
        (c >= 0x29dc && c <= 0x29fb) ||
        c === 0x29fc ||
        c === 0x29fd ||
        (c >= 0x29fe && c <= 0x2aff) ||
        (c >= 0x2b00 && c <= 0x2b2f) ||
        (c >= 0x2b30 && c <= 0x2b44) ||
        (c >= 0x2b45 && c <= 0x2b46) ||
        (c >= 0x2b47 && c <= 0x2b4c) ||
        (c >= 0x2b4d && c <= 0x2b73) ||
        (c >= 0x2b74 && c <= 0x2b75) ||
        (c >= 0x2b76 && c <= 0x2b95) ||
        c === 0x2b96 ||
        (c >= 0x2b97 && c <= 0x2bff) ||
        (c >= 0x2e00 && c <= 0x2e01) ||
        c === 0x2e02 ||
        c === 0x2e03 ||
        c === 0x2e04 ||
        c === 0x2e05 ||
        (c >= 0x2e06 && c <= 0x2e08) ||
        c === 0x2e09 ||
        c === 0x2e0a ||
        c === 0x2e0b ||
        c === 0x2e0c ||
        c === 0x2e0d ||
        (c >= 0x2e0e && c <= 0x2e16) ||
        c === 0x2e17 ||
        (c >= 0x2e18 && c <= 0x2e19) ||
        c === 0x2e1a ||
        c === 0x2e1b ||
        c === 0x2e1c ||
        c === 0x2e1d ||
        (c >= 0x2e1e && c <= 0x2e1f) ||
        c === 0x2e20 ||
        c === 0x2e21 ||
        c === 0x2e22 ||
        c === 0x2e23 ||
        c === 0x2e24 ||
        c === 0x2e25 ||
        c === 0x2e26 ||
        c === 0x2e27 ||
        c === 0x2e28 ||
        c === 0x2e29 ||
        (c >= 0x2e2a && c <= 0x2e2e) ||
        c === 0x2e2f ||
        (c >= 0x2e30 && c <= 0x2e39) ||
        (c >= 0x2e3a && c <= 0x2e3b) ||
        (c >= 0x2e3c && c <= 0x2e3f) ||
        c === 0x2e40 ||
        c === 0x2e41 ||
        c === 0x2e42 ||
        (c >= 0x2e43 && c <= 0x2e4f) ||
        (c >= 0x2e50 && c <= 0x2e51) ||
        c === 0x2e52 ||
        (c >= 0x2e53 && c <= 0x2e7f) ||
        (c >= 0x3001 && c <= 0x3003) ||
        c === 0x3008 ||
        c === 0x3009 ||
        c === 0x300a ||
        c === 0x300b ||
        c === 0x300c ||
        c === 0x300d ||
        c === 0x300e ||
        c === 0x300f ||
        c === 0x3010 ||
        c === 0x3011 ||
        (c >= 0x3012 && c <= 0x3013) ||
        c === 0x3014 ||
        c === 0x3015 ||
        c === 0x3016 ||
        c === 0x3017 ||
        c === 0x3018 ||
        c === 0x3019 ||
        c === 0x301a ||
        c === 0x301b ||
        c === 0x301c ||
        c === 0x301d ||
        (c >= 0x301e && c <= 0x301f) ||
        c === 0x3020 ||
        c === 0x3030 ||
        c === 0xfd3e ||
        c === 0xfd3f ||
        (c >= 0xfe45 && c <= 0xfe46));
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/index.js




function pruneLocation(els) {
    els.forEach(function (el) {
        delete el.location;
        if (isSelectElement(el) || isPluralElement(el)) {
            for (var k in el.options) {
                delete el.options[k].location;
                pruneLocation(el.options[k].value);
            }
        }
        else if (isNumberElement(el) && isNumberSkeleton(el.style)) {
            delete el.style.location;
        }
        else if ((isDateElement(el) || isTimeElement(el)) &&
            isDateTimeSkeleton(el.style)) {
            delete el.style.location;
        }
        else if (isTagElement(el)) {
            pruneLocation(el.children);
        }
    });
}
function parse(message, opts) {
    if (opts === void 0) { opts = {}; }
    opts = (0,tslib_es6/* __assign */.pi)({ shouldParseSkeletons: true, requiresOtherClause: true }, opts);
    var result = new Parser(message, opts).parse();
    if (result.err) {
        var error = SyntaxError(ErrorKind[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) {
        pruneLocation(result.val);
    }
    return result.val;
}



/***/ }),

/***/ 88222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$6": function() { return /* binding */ MissingTranslationError; },
/* harmony export */   "OV": function() { return /* binding */ InvalidConfigError; },
/* harmony export */   "Qe": function() { return /* binding */ IntlFormatError; },
/* harmony export */   "Rw": function() { return /* binding */ IntlError; },
/* harmony export */   "X9": function() { return /* binding */ MessageFormatError; },
/* harmony export */   "bc": function() { return /* binding */ IntlErrorCode; },
/* harmony export */   "gb": function() { return /* binding */ MissingDataError; },
/* harmony export */   "wI": function() { return /* binding */ UnsupportedFormatterError; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70655);

var IntlErrorCode;
(function (IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})(IntlErrorCode || (IntlErrorCode = {}));
var IntlError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception
            ? exception instanceof Error
                ? exception
                : new Error(String(exception))
            : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, " \n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : '')) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === 'function') {
            // @ts-ignore just so we don't need to declare dep on @types/node
            Error.captureStackTrace(_this, IntlError);
        }
        return _this;
    }
    return IntlError;
}(Error));

var UnsupportedFormatterError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, IntlErrorCode.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}(IntlError));

var InvalidConfigError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, IntlErrorCode.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}(IntlError));

var MissingDataError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, IntlErrorCode.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}(IntlError));

var IntlFormatError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        return _super.call(this, IntlErrorCode.FORMAT_ERROR, "".concat(message, " \nLocale: ").concat(locale, "\n"), exception) || this;
    }
    return IntlFormatError;
}(IntlError));

var MessageFormatError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, " \nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, " \n"), locale, exception) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MessageFormatError;
}(IntlFormatError));

var MissingTranslationError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, IntlErrorCode.MISSING_TRANSLATION, "Missing message: \"".concat(descriptor.id, "\" for locale \"").concat(locale, "\", using ").concat(descriptor.defaultMessage ? 'default message' : 'id', " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}(IntlError));



/***/ }),

/***/ 82644:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L6": function() { return /* binding */ filterProps; },
/* harmony export */   "Sn": function() { return /* binding */ createIntlCache; },
/* harmony export */   "TB": function() { return /* binding */ getNamedFormat; },
/* harmony export */   "Z0": function() { return /* binding */ DEFAULT_INTL_CONFIG; },
/* harmony export */   "ax": function() { return /* binding */ createFormatters; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70655);
/* harmony import */ var intl_messageformat__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16284);
/* harmony import */ var _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95957);
/* harmony import */ var _error__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88222);




function filterProps(props, allowlist, defaults) {
    if (defaults === void 0) { defaults = {}; }
    return allowlist.reduce(function (filtered, name) {
        if (name in props) {
            filtered[name] = props[name];
        }
        else if (name in defaults) {
            filtered[name] = defaults[name];
        }
        return filtered;
    }, {});
}
var defaultErrorHandler = function (error) {
    // @ts-ignore just so we don't need to declare dep on @types/node
    if (false) {}
};
var defaultWarnHandler = function (warning) {
    // @ts-ignore just so we don't need to declare dep on @types/node
    if (false) {}
};
var DEFAULT_INTL_CONFIG = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: 'en',
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: defaultErrorHandler,
    onWarn: defaultWarnHandler,
};
function createIntlCache() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {},
    };
}
function createFastMemoizeCache(store) {
    return {
        create: function () {
            return {
                get: function (key) {
                    return store[key];
                },
                set: function (key, value) {
                    store[key] = value;
                },
            };
        },
    };
}
/**
 * Create intl formatters and populate cache
 * @param cache explicit cache to prevent leaking memory
 */
function createFormatters(cache) {
    if (cache === void 0) { cache = createIntlCache(); }
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__spreadArray */ .ev)([void 0], args, false)))();
    }, {
        cache: createFastMemoizeCache(cache.dateTime),
        strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* .strategies.variadic */ .A.variadic,
    });
    var getNumberFormat = (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__spreadArray */ .ev)([void 0], args, false)))();
    }, {
        cache: createFastMemoizeCache(cache.number),
        strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* .strategies.variadic */ .A.variadic,
    });
    var getPluralRules = (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function () {
        var _a;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__spreadArray */ .ev)([void 0], args, false)))();
    }, {
        cache: createFastMemoizeCache(cache.pluralRules),
        strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* .strategies.variadic */ .A.variadic,
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function (message, locales, overrideFormats, opts) {
            return new intl_messageformat__WEBPACK_IMPORTED_MODULE_2__/* .IntlMessageFormat */ .C(message, locales, overrideFormats, (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__assign */ .pi)({ formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules,
                } }, (opts || {})));
        }, {
            cache: createFastMemoizeCache(cache.message),
            strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* .strategies.variadic */ .A.variadic,
        }),
        getRelativeTimeFormat: (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__spreadArray */ .ev)([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.relativeTime),
            strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* .strategies.variadic */ .A.variadic,
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new (ListFormat.bind.apply(ListFormat, (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__spreadArray */ .ev)([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.list),
            strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* .strategies.variadic */ .A.variadic,
        }),
        getDisplayNames: (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new (DisplayNames.bind.apply(DisplayNames, (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__spreadArray */ .ev)([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.displayNames),
            strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_0__/* .strategies.variadic */ .A.variadic,
        }),
    };
}
function getNamedFormat(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) {
        format = formatType[name];
    }
    if (format) {
        return format;
    }
    onError(new _error__WEBPACK_IMPORTED_MODULE_3__/* .UnsupportedFormatterError */ .wI("No ".concat(type, " format named: ").concat(name)));
}


/***/ }),

/***/ 19985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "yl": function() { return /* binding */ flush; },
  "S1": function() { return /* binding */ init; }
});

// UNUSED EXPORTS: close, defaultIntegrations, forceLoad, lastEventId, onLoad, showReportDialog, wrap

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/logger.js
var esm_logger = __webpack_require__(12343);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/misc.js
var misc = __webpack_require__(62844);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/string.js
var string = __webpack_require__(57321);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/integrations/inboundfilters.js


// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
var DEFAULT_IGNORE_ERRORS = [/^Script error\.?$/, /^Javascript error: Script error\.? on line 0$/];

/** Options for the InboundFilters integration */

/** Inbound filters configurable by the user */
class InboundFilters  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'InboundFilters';}

  /**
   * @inheritDoc
   */
   __init() {this.name = InboundFilters.id;}

   constructor(  _options = {}) {;this._options = _options;InboundFilters.prototype.__init.call(this);}

  /**
   * @inheritDoc
   */
   setupOnce(addGlobalEventProcessor, getCurrentHub) {
    var eventProcess = (event) => {
      var hub = getCurrentHub();
      if (hub) {
        var self = hub.getIntegration(InboundFilters);
        if (self) {
          var client = hub.getClient();
          var clientOptions = client ? client.getOptions() : {};
          var options = _mergeOptions(self._options, clientOptions);
          return _shouldDropEvent(event, options) ? null : event;
        }
      }
      return event;
    };

    eventProcess.id = this.name;
    addGlobalEventProcessor(eventProcess);
  }
} InboundFilters.__initStatic();

/** JSDoc */
function _mergeOptions(
  internalOptions = {},
  clientOptions = {},
) {
  return {
    allowUrls: [...(internalOptions.allowUrls || []), ...(clientOptions.allowUrls || [])],
    denyUrls: [...(internalOptions.denyUrls || []), ...(clientOptions.denyUrls || [])],
    ignoreErrors: [
      ...(internalOptions.ignoreErrors || []),
      ...(clientOptions.ignoreErrors || []),
      ...DEFAULT_IGNORE_ERRORS,
    ],
    ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true,
  };
}

/** JSDoc */
function _shouldDropEvent(event, options) {
  if (options.ignoreInternal && _isSentryError(event)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0,misc/* getEventDescription */.jH)(event)}`);
    return true;
  }
  if (_isIgnoredError(event, options.ignoreErrors)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn(
        `Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0,misc/* getEventDescription */.jH)(event)}`,
      );
    return true;
  }
  if (_isDeniedUrl(event, options.denyUrls)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn(
        `Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0,misc/* getEventDescription */.jH)(
          event,
        )}.\nUrl: ${_getEventFilterUrl(event)}`,
      );
    return true;
  }
  if (!_isAllowedUrl(event, options.allowUrls)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn(
        `Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0,misc/* getEventDescription */.jH)(
          event,
        )}.\nUrl: ${_getEventFilterUrl(event)}`,
      );
    return true;
  }
  return false;
}

function _isIgnoredError(event, ignoreErrors) {
  if (!ignoreErrors || !ignoreErrors.length) {
    return false;
  }

  return _getPossibleEventMessages(event).some(message =>
    ignoreErrors.some(pattern => (0,string/* isMatchingPattern */.zC)(message, pattern)),
  );
}

function _isDeniedUrl(event, denyUrls) {
  // TODO: Use Glob instead?
  if (!denyUrls || !denyUrls.length) {
    return false;
  }
  var url = _getEventFilterUrl(event);
  return !url ? false : denyUrls.some(pattern => (0,string/* isMatchingPattern */.zC)(url, pattern));
}

function _isAllowedUrl(event, allowUrls) {
  // TODO: Use Glob instead?
  if (!allowUrls || !allowUrls.length) {
    return true;
  }
  var url = _getEventFilterUrl(event);
  return !url ? true : allowUrls.some(pattern => (0,string/* isMatchingPattern */.zC)(url, pattern));
}

function _getPossibleEventMessages(event) {
  if (event.message) {
    return [event.message];
  }
  if (event.exception) {
    try {
      const { type = '', value = '' } = (event.exception.values && event.exception.values[0]) || {};
      return [`${value}`, `${type}: ${value}`];
    } catch (oO) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error(`Cannot extract message for event ${(0,misc/* getEventDescription */.jH)(event)}`);
      return [];
    }
  }
  return [];
}

function _isSentryError(event) {
  try {
    // @ts-ignore can't be a sentry error if undefined
        return event.exception.values[0].type === 'SentryError';
  } catch (e) {
    // ignore
  }
  return false;
}

function _getLastValidUrl(frames = []) {
  for (let i = frames.length - 1; i >= 0; i--) {
    var frame = frames[i];

    if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') {
      return frame.filename || null;
    }
  }

  return null;
}

function _getEventFilterUrl(event) {
  try {
    let frames;
    try {
      // @ts-ignore we only care about frames if the whole thing here is defined
      frames = event.exception.values[0].stacktrace.frames;
    } catch (e) {
      // ignore
    }
    return frames ? _getLastValidUrl(frames) : null;
  } catch (oO) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error(`Cannot extract url for event ${(0,misc/* getEventDescription */.jH)(event)}`);
    return null;
  }
}


//# sourceMappingURL=inboundfilters.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/object.js
var object = __webpack_require__(20535);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/integrations/functiontostring.js


let originalFunctionToString;

/** Patch toString calls to return proper name for wrapped functions */
class FunctionToString  {constructor() { FunctionToString.prototype.__init.call(this); }
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'FunctionToString';}

  /**
   * @inheritDoc
   */
   __init() {this.name = FunctionToString.id;}

  /**
   * @inheritDoc
   */
   setupOnce() {
        originalFunctionToString = Function.prototype.toString;

        Function.prototype.toString = function ( ...args) {
      var context = (0,object/* getOriginalFunction */.HK)(this) || this;
      return originalFunctionToString.apply(context, args);
    };
  }
} FunctionToString.__initStatic();


//# sourceMappingURL=functiontostring.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/hub/esm/scope.js
var esm_scope = __webpack_require__(46769);
// EXTERNAL MODULE: ./node_modules/@sentry/hub/esm/hub.js
var esm_hub = __webpack_require__(38641);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/integration.js



var installedIntegrations = [];

/** Map of integrations assigned to a client */

/**
 * @private
 */
function filterDuplicates(integrations) {
  return integrations.reduce((acc, integrations) => {
    if (acc.every(accIntegration => integrations.name !== accIntegration.name)) {
      acc.push(integrations);
    }
    return acc;
  }, [] );
}

/** Gets integration to install */
function getIntegrationsToSetup(options) {
  var defaultIntegrations = (options.defaultIntegrations && [...options.defaultIntegrations]) || [];
  var userIntegrations = options.integrations;

  let integrations = [...filterDuplicates(defaultIntegrations)];

  if (Array.isArray(userIntegrations)) {
    // Filter out integrations that are also included in user options
    integrations = [
      ...integrations.filter(integrations =>
        userIntegrations.every(userIntegration => userIntegration.name !== integrations.name),
      ),
      // And filter out duplicated user options integrations
      ...filterDuplicates(userIntegrations),
    ];
  } else if (typeof userIntegrations === 'function') {
    integrations = userIntegrations(integrations);
    integrations = Array.isArray(integrations) ? integrations : [integrations];
  }

  // Make sure that if present, `Debug` integration will always run last
  var integrationsNames = integrations.map(i => i.name);
  var alwaysLastToRun = 'Debug';
  if (integrationsNames.indexOf(alwaysLastToRun) !== -1) {
    integrations.push(...integrations.splice(integrationsNames.indexOf(alwaysLastToRun), 1));
  }

  return integrations;
}

/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */
function setupIntegrations(integrations) {
  var integrationIndex = {};

  integrations.forEach(integration => {
    integrationIndex[integration.name] = integration;

    if (installedIntegrations.indexOf(integration.name) === -1) {
      integration.setupOnce(esm_scope/* addGlobalEventProcessor */.c, esm_hub/* getCurrentHub */.Gd);
      installedIntegrations.push(integration.name);
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(`Integration installed: ${integration.name}`);
    }
  });

  return integrationIndex;
}


//# sourceMappingURL=integration.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/sdk.js



/** A class object that can instantiate Client objects. */

/**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */
function initAndBind(
  clientClass,
  options,
) {
  if (options.debug === true) {
    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
      esm_logger/* logger.enable */.kg.enable();
    } else {
      // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
            console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
    }
  }
  var hub = (0,esm_hub/* getCurrentHub */.Gd)();
  var scope = hub.getScope();
  if (scope) {
    scope.update(options.initialScope);
  }

  var client = new clientClass(options);
  hub.bindClient(client);
}


//# sourceMappingURL=sdk.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/global.js
var esm_global = __webpack_require__(82991);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/stacktrace.js
var stacktrace = __webpack_require__(30360);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/supports.js
var supports = __webpack_require__(8823);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/syncpromise.js
var syncpromise = __webpack_require__(96893);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/instrument.js
var instrument = __webpack_require__(9732);
// EXTERNAL MODULE: ./node_modules/@sentry/hub/esm/session.js
var esm_session = __webpack_require__(95771);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/error.js
/** An error emitted by Sentry SDKs and related utilities. */
class SentryError extends Error {
  /** Display name of this error instance. */
  

   constructor( message, logLevel = 'warn') {
    super(message);this.message = message;;

    this.name = new.target.prototype.constructor.name;
    // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
    // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
    // instances of `SentryError` fail `obj instanceof SentryError` checks.
    Object.setPrototypeOf(this, new.target.prototype);
    this.logLevel = logLevel;
  }
}


//# sourceMappingURL=error.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/dsn.js


/** Regular expression used to parse a Dsn. */
var DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;

function isValidProtocol(protocol) {
  return protocol === 'http' || protocol === 'https';
}

/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */
function dsn_dsnToString(dsn, withPassword = false) {
  const { host, path, pass, port, projectId, protocol, publicKey } = dsn;
  return (
    `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` +
    `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`
  );
}

/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents
 */
function dsnFromString(str) {
  var match = DSN_REGEX.exec(str);

  if (!match) {
    throw new SentryError(`Invalid Sentry Dsn: ${str}`);
  }

  const [protocol, publicKey, pass = '', host, port = '', lastPath] = match.slice(1);
  let path = '';
  let projectId = lastPath;

  var split = projectId.split('/');
  if (split.length > 1) {
    path = split.slice(0, -1).join('/');
    projectId = split.pop() ;
  }

  if (projectId) {
    var projectMatch = projectId.match(/^\d+/);
    if (projectMatch) {
      projectId = projectMatch[0];
    }
  }

  return dsnFromComponents({ host, pass, path, projectId, port, protocol: protocol , publicKey });
}

function dsnFromComponents(components) {
  return {
    protocol: components.protocol,
    publicKey: components.publicKey || '',
    pass: components.pass || '',
    host: components.host,
    port: components.port || '',
    path: components.path || '',
    projectId: components.projectId,
  };
}

function validateDsn(dsn) {
  if (!(typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
    return;
  }

  const { port, projectId, protocol } = dsn;

  var requiredComponents = ['protocol', 'publicKey', 'host', 'projectId'];
  requiredComponents.forEach(component => {
    if (!dsn[component]) {
      throw new SentryError(`Invalid Sentry Dsn: ${component} missing`);
    }
  });

  if (!projectId.match(/^\d+$/)) {
    throw new SentryError(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
  }

  if (!isValidProtocol(protocol)) {
    throw new SentryError(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
  }

  if (port && isNaN(parseInt(port, 10))) {
    throw new SentryError(`Invalid Sentry Dsn: Invalid port ${port}`);
  }

  return true;
}

/** The Sentry Dsn, identifying a Sentry instance and project. */
function dsn_makeDsn(from) {
  var components = typeof from === 'string' ? dsnFromString(from) : dsnFromComponents(from);
  validateDsn(components);
  return components;
}


//# sourceMappingURL=dsn.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(67597);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/envelope.js


/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */
function createEnvelope(headers, items = []) {
  return [headers, items] ;
}

/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */
function addItemToEnvelope(envelope, newItem) {
  const [headers, items] = envelope;
  return [headers, [...items, newItem]] ;
}

/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 */
function forEachEnvelopeItem(
  envelope,
  callback,
) {
  var envelopeItems = envelope[1];
  envelopeItems.forEach((envelopeItem) => {
    var envelopeItemType = envelopeItem[0].type;
    callback(envelopeItem, envelopeItemType);
  });
}

function encodeUTF8(input, textEncoder) {
  var utf8 = textEncoder || new TextEncoder();
  return utf8.encode(input);
}

/**
 * Serializes an envelope.
 */
function serializeEnvelope(envelope, textEncoder) {
  const [envHeaders, items] = envelope;

  // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
  let parts = JSON.stringify(envHeaders);

  function append(next) {
    if (typeof parts === 'string') {
      parts = typeof next === 'string' ? parts + next : [encodeUTF8(parts, textEncoder), next];
    } else {
      parts.push(typeof next === 'string' ? encodeUTF8(next, textEncoder) : next);
    }
  }

  for (var item of items) {
    const [itemHeaders, payload] = item ;
    append(`\n${JSON.stringify(itemHeaders)}\n`);
    append(typeof payload === 'string' || payload instanceof Uint8Array ? payload : JSON.stringify(payload));
  }

  return typeof parts === 'string' ? parts : concatBuffers(parts);
}

function concatBuffers(buffers) {
  var totalLength = buffers.reduce((acc, buf) => acc + buf.length, 0);

  var merged = new Uint8Array(totalLength);
  let offset = 0;
  for (var buffer of buffers) {
    merged.set(buffer, offset);
    offset += buffer.length;
  }

  return merged;
}

/**
 * Creates attachment envelope items
 */
function createAttachmentEnvelopeItem(
  attachment,
  textEncoder,
) {
  var buffer = typeof attachment.data === 'string' ? encodeUTF8(attachment.data, textEncoder) : attachment.data;

  return [
    (0,object/* dropUndefinedKeys */.Jr)({
      type: 'attachment',
      length: buffer.length,
      filename: attachment.filename,
      content_type: attachment.contentType,
      attachment_type: attachment.attachmentType,
    }),
    buffer,
  ];
}

var ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
  session: 'session',
  sessions: 'session',
  attachment: 'attachment',
  transaction: 'transaction',
  event: 'error',
  client_report: 'internal',
  user_report: 'default',
};

/**
 * Maps the type of an envelope item to a data category.
 */
function envelopeItemTypeToDataCategory(type) {
  return ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}


//# sourceMappingURL=envelope.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/time.js
var time = __webpack_require__(21170);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/memo.js
/**
 * Helper to decycle json objects
 */
function memoBuilder() {
  var hasWeakSet = typeof WeakSet === 'function';
  var inner = hasWeakSet ? new WeakSet() : [];
  function memoize(obj) {
    if (hasWeakSet) {
      if (inner.has(obj)) {
        return true;
      }
      inner.add(obj);
      return false;
    }
        for (let i = 0; i < inner.length; i++) {
      var value = inner[i];
      if (value === obj) {
        return true;
      }
    }
    inner.push(obj);
    return false;
  }

  function unmemoize(obj) {
    if (hasWeakSet) {
      inner.delete(obj);
    } else {
      for (let i = 0; i < inner.length; i++) {
        if (inner[i] === obj) {
          inner.splice(i, 1);
          break;
        }
      }
    }
  }
  return [memoize, unmemoize];
}


//# sourceMappingURL=memo.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/normalize.js





/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output..
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */
function normalize(input, depth = +Infinity, maxProperties = +Infinity) {
  try {
    // since we're at the outermost level, we don't provide a key
    return visit('', input, depth, maxProperties);
  } catch (err) {
    return { ERROR: `**non-serializable** (${err})` };
  }
}

/** JSDoc */
function normalizeToSize(
    object,
  // Default Node.js REPL depth
  depth = 3,
  // 100kB, as 200kB is max payload size, so half sounds reasonable
  maxSize = 100 * 1024,
) {
  var normalized = normalize(object, depth);

  if (jsonSize(normalized) > maxSize) {
    return normalizeToSize(object, depth - 1, maxSize);
  }

  return normalized ;
}

/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */
function visit(
  key,
  value,
  depth = +Infinity,
  maxProperties = +Infinity,
  memo = memoBuilder(),
) {
  const [memoize, unmemoize] = memo;

  // Get the simple cases out of the way first
  if (value === null || (['number', 'boolean', 'string'].includes(typeof value) && !(0,is/* isNaN */.i2)(value))) {
    return value ;
  }

  var stringified = stringifyValue(key, value);

  // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
  // Everything else will have already been serialized, so if we don't see that pattern, we're done.
  if (!stringified.startsWith('[object ')) {
    return stringified;
  }

  // From here on, we can assert that `value` is either an object or an array.

  // Do not normalize objects that we know have already been normalized. As a general rule, the
  // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
  // have already been normalized.
  if ((value )['__sentry_skip_normalization__']) {
    return value ;
  }

  // We're also done if we've reached the max depth
  if (depth === 0) {
    // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
  }

  // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
  if (memoize(value)) {
    return '[Circular ~]';
  }

  // If the value has a `toJSON` method, we call it to extract more information
  var valueWithToJSON = value ;
  if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') {
    try {
      var jsonValue = valueWithToJSON.toJSON();
      // We need to normalize the return value of `.toJSON()` in case it has circular references
      return visit('', jsonValue, depth - 1, maxProperties, memo);
    } catch (err) {
      // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
  }

  // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
  // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
  // property/entry, and keep track of the number of items we add to it.
  var normalized = (Array.isArray(value) ? [] : {}) ;
  let numAdded = 0;

  // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
  // properties are non-enumerable and otherwise would get missed.
  var visitable = (0,object/* convertToPlainObject */.Sh)(value );

  for (var visitKey in visitable) {
    // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
    if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) {
      continue;
    }

    if (numAdded >= maxProperties) {
      normalized[visitKey] = '[MaxProperties ~]';
      break;
    }

    // Recursively visit all the child nodes
    var visitValue = visitable[visitKey];
    normalized[visitKey] = visit(visitKey, visitValue, depth - 1, maxProperties, memo);

    numAdded += 1;
  }

  // Once we've visited all the branches, remove the parent from memo storage
  unmemoize(value);

  // Return accumulated values
  return normalized;
}

/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */
function stringifyValue(
  key,
  // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
  // our internal use, it'll do
  value,
) {
  try {
    if (key === 'domain' && value && typeof value === 'object' && (value )._events) {
      return '[Domain]';
    }

    if (key === 'domainEmitter') {
      return '[DomainEmitter]';
    }

    // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
    // which won't throw if they are not present.

    if (typeof __webpack_require__.g !== 'undefined' && value === __webpack_require__.g) {
      return '[Global]';
    }

        if (typeof window !== 'undefined' && value === window) {
      return '[Window]';
    }

        if (typeof document !== 'undefined' && value === document) {
      return '[Document]';
    }

    // React's SyntheticEvent thingy
    if ((0,is/* isSyntheticEvent */.Cy)(value)) {
      return '[SyntheticEvent]';
    }

    if (typeof value === 'number' && value !== value) {
      return '[NaN]';
    }

    // this catches `undefined` (but not `null`, which is a primitive and can be serialized on its own)
    if (value === void 0) {
      return '[undefined]';
    }

    if (typeof value === 'function') {
      return `[Function: ${(0,stacktrace/* getFunctionName */.$P)(value)}]`;
    }

    if (typeof value === 'symbol') {
      return `[${String(value)}]`;
    }

    // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
    if (typeof value === 'bigint') {
      return `[BigInt: ${String(value)}]`;
    }

    // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
    // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
    // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
    // we can make sure that only plain objects come out that way.
    return `[object ${(Object.getPrototypeOf(value) ).constructor.name}]`;
  } catch (err) {
    return `**non-serializable** (${err})`;
  }
}

/** Calculates bytes size of input string */
function utf8Length(value) {
    return ~-encodeURI(value).split(/%..|./).length;
}

/** Calculates bytes size of input object */
function jsonSize(value) {
  return utf8Length(JSON.stringify(value));
}


//# sourceMappingURL=normalize.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/api.js


var SENTRY_API_VERSION = '7';

/** Returns the prefix to construct Sentry ingestion API endpoints. */
function getBaseApiEndpoint(dsn) {
  var protocol = dsn.protocol ? `${dsn.protocol}:` : '';
  var port = dsn.port ? `:${dsn.port}` : '';
  return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}

/** Returns the ingest API endpoint for target. */
function _getIngestEndpoint(dsn) {
  return `${getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}

/** Returns a URL-encoded string with auth config suitable for a query string. */
function _encodedAuth(dsn, sdkInfo) {
  return (0,object/* urlEncode */._j)({
    // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    sentry_key: dsn.publicKey,
    sentry_version: SENTRY_API_VERSION,
    ...(sdkInfo && { sentry_client: `${sdkInfo.name}/${sdkInfo.version}` }),
  });
}

/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */
function getEnvelopeEndpointWithUrlEncodedAuth(
  dsn,
  // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
  // options: ClientOptions = {} as ClientOptions,
  tunnelOrOptions = {} ,
) {
  // TODO (v8): Use this code instead
  // const { tunnel, _metadata = {} } = options;
  // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;

  var tunnel = typeof tunnelOrOptions === 'string' ? tunnelOrOptions : tunnelOrOptions.tunnel;
  var sdkInfo =
    typeof tunnelOrOptions === 'string' || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;

  return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, sdkInfo)}`;
}

/** Returns the url to the report dialog endpoint. */
function api_getReportDialogEndpoint(
  dsnLike,
  dialogOptions

,
) {
  var dsn = makeDsn(dsnLike);
  var endpoint = `${getBaseApiEndpoint(dsn)}embed/error-page/`;

  let encodedOptions = `dsn=${dsnToString(dsn)}`;
  for (var key in dialogOptions) {
    if (key === 'dsn') {
      continue;
    }

    if (key === 'user') {
      var user = dialogOptions.user;
      if (!user) {
        continue;
      }
      if (user.name) {
        encodedOptions += `&name=${encodeURIComponent(user.name)}`;
      }
      if (user.email) {
        encodedOptions += `&email=${encodeURIComponent(user.email)}`;
      }
    } else {
      encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key] )}`;
    }
  }

  return `${endpoint}?${encodedOptions}`;
}


//# sourceMappingURL=api.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/baggage.js
var esm_baggage = __webpack_require__(99181);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/envelope.js


/** Extract sdk info from from the API metadata */
function getSdkMetadataForEnvelopeHeader(metadata) {
  if (!metadata || !metadata.sdk) {
    return;
  }
  const { name, version } = metadata.sdk;
  return { name, version };
}

/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/
function enhanceEventWithSdkInfo(event, sdkInfo) {
  if (!sdkInfo) {
    return event;
  }
  event.sdk = event.sdk || {};
  event.sdk.name = event.sdk.name || sdkInfo.name;
  event.sdk.version = event.sdk.version || sdkInfo.version;
  event.sdk.integrations = [...(event.sdk.integrations || []), ...(sdkInfo.integrations || [])];
  event.sdk.packages = [...(event.sdk.packages || []), ...(sdkInfo.packages || [])];
  return event;
}

/** Creates an envelope from a Session */
function createSessionEnvelope(
  session,
  dsn,
  metadata,
  tunnel,
) {
  var sdkInfo = getSdkMetadataForEnvelopeHeader(metadata);
  var envelopeHeaders = {
    sent_at: new Date().toISOString(),
    ...(sdkInfo && { sdk: sdkInfo }),
    ...(!!tunnel && { dsn: dsn_dsnToString(dsn) }),
  };

  var envelopeItem =
    'aggregates' in session ? [{ type: 'sessions' }, session] : [{ type: 'session' }, session];

  return createEnvelope(envelopeHeaders, [envelopeItem]);
}

/**
 * Create an Envelope from an event.
 */
function createEventEnvelope(
  event,
  dsn,
  metadata,
  tunnel,
) {
  var sdkInfo = getSdkMetadataForEnvelopeHeader(metadata);
  var eventType = event.type || 'event';

  const { transactionSampling } = event.sdkProcessingMetadata || {};
  const { method: samplingMethod, rate: sampleRate } = transactionSampling || {};

  enhanceEventWithSdkInfo(event, metadata && metadata.sdk);

  var envelopeHeaders = createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn);

  // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
  // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
  // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
  // of this `delete`, lest we miss putting it back in the next time the property is in use.)
  delete event.sdkProcessingMetadata;

  var eventItem = [
    {
      type: eventType,
      sample_rates: [{ id: samplingMethod, rate: sampleRate }],
    },
    event,
  ];
  return createEnvelope(envelopeHeaders, [eventItem]);
}

function createEventEnvelopeHeaders(
  event,
  sdkInfo,
  tunnel,
  dsn,
) {
  var baggage = event.sdkProcessingMetadata && event.sdkProcessingMetadata.baggage;
  var dynamicSamplingContext = baggage && (0,esm_baggage/* getSentryBaggageItems */.Hk)(baggage);

  return {
    event_id: event.event_id ,
    sent_at: new Date().toISOString(),
    ...(sdkInfo && { sdk: sdkInfo }),
    ...(!!tunnel && { dsn: dsn_dsnToString(dsn) }),
    ...(event.type === 'transaction' &&
      dynamicSamplingContext && {
        trace: (0,object/* dropUndefinedKeys */.Jr)({ ...dynamicSamplingContext }) ,
      }),
  };
}


//# sourceMappingURL=envelope.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/baseclient.js






var ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";

/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */
class BaseClient {
  /** Options passed to the SDK. */
  

  /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */
  

  /** Array of set up integrations. */
   __init() {this._integrations = {};}

  /** Indicates whether this client's integrations have been set up. */
   __init2() {this._integrationsInitialized = false;}

  /** Number of calls being processed */
   __init3() {this._numProcessing = 0;}

  /** Holds flushable  */
   __init4() {this._outcomes = {};}

  /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */
   constructor(options) {;BaseClient.prototype.__init.call(this);BaseClient.prototype.__init2.call(this);BaseClient.prototype.__init3.call(this);BaseClient.prototype.__init4.call(this);
    this._options = options;
    if (options.dsn) {
      this._dsn = dsn_makeDsn(options.dsn);
      var url = getEnvelopeEndpointWithUrlEncodedAuth(this._dsn, options);
      this._transport = options.transport({
        recordDroppedEvent: this.recordDroppedEvent.bind(this),
        ...options.transportOptions,
        url,
      });
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('No DSN provided, client will not do anything.');
    }
  }

  /**
   * @inheritDoc
   */
     captureException(exception, hint, scope) {
    // ensure we haven't captured this very object before
    if ((0,misc/* checkOrSetAlreadyCaught */.YO)(exception)) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(ALREADY_SEEN_ERROR);
      return;
    }

    let eventId = hint && hint.event_id;

    this._process(
      this.eventFromException(exception, hint)
        .then(event => this._captureEvent(event, hint, scope))
        .then(result => {
          eventId = result;
        }),
    );

    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureMessage(
    message,
        level,
    hint,
    scope,
  ) {
    let eventId = hint && hint.event_id;

    var promisedEvent = (0,is/* isPrimitive */.pt)(message)
      ? this.eventFromMessage(String(message), level, hint)
      : this.eventFromException(message, hint);

    this._process(
      promisedEvent
        .then(event => this._captureEvent(event, hint, scope))
        .then(result => {
          eventId = result;
        }),
    );

    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureEvent(event, hint, scope) {
    // ensure we haven't captured this very object before
    if (hint && hint.originalException && (0,misc/* checkOrSetAlreadyCaught */.YO)(hint.originalException)) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(ALREADY_SEEN_ERROR);
      return;
    }

    let eventId = hint && hint.event_id;

    this._process(
      this._captureEvent(event, hint, scope).then(result => {
        eventId = result;
      }),
    );

    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureSession(session) {
    if (!this._isEnabled()) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('SDK not enabled, will not capture session.');
      return;
    }

    if (!(typeof session.release === 'string')) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('Discarded session because of missing or non-string release');
    } else {
      this.sendSession(session);
      // After sending, we set init false to indicate it's not the first occurrence
      (0,esm_session/* updateSession */.CT)(session, { init: false });
    }
  }

  /**
   * @inheritDoc
   */
   getDsn() {
    return this._dsn;
  }

  /**
   * @inheritDoc
   */
   getOptions() {
    return this._options;
  }

  /**
   * @inheritDoc
   */
   getTransport() {
    return this._transport;
  }

  /**
   * @inheritDoc
   */
   flush(timeout) {
    var transport = this._transport;
    if (transport) {
      return this._isClientDoneProcessing(timeout).then(clientFinished => {
        return transport.flush(timeout).then(transportFlushed => clientFinished && transportFlushed);
      });
    } else {
      return (0,syncpromise/* resolvedSyncPromise */.WD)(true);
    }
  }

  /**
   * @inheritDoc
   */
   close(timeout) {
    return this.flush(timeout).then(result => {
      this.getOptions().enabled = false;
      return result;
    });
  }

  /**
   * Sets up the integrations
   */
   setupIntegrations() {
    if (this._isEnabled() && !this._integrationsInitialized) {
      this._integrations = setupIntegrations(this._options.integrations);
      this._integrationsInitialized = true;
    }
  }

  /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   */
   getIntegrationById(integrationId) {
    return this._integrations[integrationId];
  }

  /**
   * @inheritDoc
   */
   getIntegration(integration) {
    try {
      return (this._integrations[integration.id] ) || null;
    } catch (_oO) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn(`Cannot retrieve integration ${integration.id} from the current Client`);
      return null;
    }
  }

  /**
   * @inheritDoc
   */
   sendEvent(event, hint = {}) {
    if (this._dsn) {
      let env = createEventEnvelope(event, this._dsn, this._options._metadata, this._options.tunnel);

      for (var attachment of hint.attachments || []) {
        env = addItemToEnvelope(
          env,
          createAttachmentEnvelopeItem(
            attachment,
            this._options.transportOptions && this._options.transportOptions.textEncoder,
          ),
        );
      }

      this._sendEnvelope(env);
    }
  }

  /**
   * @inheritDoc
   */
   sendSession(session) {
    if (this._dsn) {
      var env = createSessionEnvelope(session, this._dsn, this._options._metadata, this._options.tunnel);
      this._sendEnvelope(env);
    }
  }

  /**
   * @inheritDoc
   */
   recordDroppedEvent(reason, category) {
    if (this._options.sendClientReports) {
      // We want to track each category (error, transaction, session) separately
      // but still keep the distinction between different type of outcomes.
      // We could use nested maps, but it's much easier to read and type this way.
      // A correct type for map-based implementation if we want to go that route
      // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
      // With typescript 4.1 we could even use template literal types
      var key = `${reason}:${category}`;
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(`Adding outcome: "${key}"`);

      // The following works because undefined + 1 === NaN and NaN is falsy
      this._outcomes[key] = this._outcomes[key] + 1 || 1;
    }
  }

  /** Updates existing session based on the provided event */
   _updateSessionFromEvent(session, event) {
    let crashed = false;
    let errored = false;
    var exceptions = event.exception && event.exception.values;

    if (exceptions) {
      errored = true;

      for (var ex of exceptions) {
        var mechanism = ex.mechanism;
        if (mechanism && mechanism.handled === false) {
          crashed = true;
          break;
        }
      }
    }

    // A session is updated and that session update is sent in only one of the two following scenarios:
    // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
    // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
    var sessionNonTerminal = session.status === 'ok';
    var shouldUpdateAndSend = (sessionNonTerminal && session.errors === 0) || (sessionNonTerminal && crashed);

    if (shouldUpdateAndSend) {
      (0,esm_session/* updateSession */.CT)(session, {
        ...(crashed && { status: 'crashed' }),
        errors: session.errors || Number(errored || crashed),
      });
      this.captureSession(session);
    }
  }

  /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */
   _isClientDoneProcessing(timeout) {
    return new syncpromise/* SyncPromise */.cW(resolve => {
      let ticked = 0;
      var tick = 1;

      var interval = setInterval(() => {
        if (this._numProcessing == 0) {
          clearInterval(interval);
          resolve(true);
        } else {
          ticked += tick;
          if (timeout && ticked >= timeout) {
            clearInterval(interval);
            resolve(false);
          }
        }
      }, tick);
    });
  }

  /** Determines whether this SDK is enabled and a valid Dsn is present. */
   _isEnabled() {
    return this.getOptions().enabled !== false && this._dsn !== undefined;
  }

  /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */
   _prepareEvent(event, hint, scope) {
    const { normalizeDepth = 3, normalizeMaxBreadth = 1000 } = this.getOptions();
    var prepared = {
      ...event,
      event_id: event.event_id || hint.event_id || (0,misc/* uuid4 */.DM)(),
      timestamp: event.timestamp || (0,time/* dateTimestampInSeconds */.yW)(),
    };

    this._applyClientOptions(prepared);
    this._applyIntegrationsMetadata(prepared);

    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    let finalScope = scope;
    if (hint.captureContext) {
      finalScope = esm_scope/* Scope.clone */.s.clone(finalScope).update(hint.captureContext);
    }

    // We prepare the result here with a resolved Event.
    let result = (0,syncpromise/* resolvedSyncPromise */.WD)(prepared);

    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    if (finalScope) {
      // Collect attachments from the hint and scope
      var attachments = [...(hint.attachments || []), ...finalScope.getAttachments()];

      if (attachments.length) {
        hint.attachments = attachments;
      }

      // In case we have a hub we reassign it.
      result = finalScope.applyToEvent(prepared, hint);
    }

    return result.then(evt => {
      if (typeof normalizeDepth === 'number' && normalizeDepth > 0) {
        return this._normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
      }
      return evt;
    });
  }

  /**
   * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
   * Normalized keys:
   * - `breadcrumbs.data`
   * - `user`
   * - `contexts`
   * - `extra`
   * @param event Event
   * @returns Normalized event
   */
   _normalizeEvent(event, depth, maxBreadth) {
    if (!event) {
      return null;
    }

    var normalized = {
      ...event,
      ...(event.breadcrumbs && {
        breadcrumbs: event.breadcrumbs.map(b => ({
          ...b,
          ...(b.data && {
            data: normalize(b.data, depth, maxBreadth),
          }),
        })),
      }),
      ...(event.user && {
        user: normalize(event.user, depth, maxBreadth),
      }),
      ...(event.contexts && {
        contexts: normalize(event.contexts, depth, maxBreadth),
      }),
      ...(event.extra && {
        extra: normalize(event.extra, depth, maxBreadth),
      }),
    };

    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
      normalized.contexts.trace = event.contexts.trace;

      // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
      if (event.contexts.trace.data) {
        normalized.contexts.trace.data = normalize(event.contexts.trace.data, depth, maxBreadth);
      }
    }

    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) {
      normalized.spans = event.spans.map(span => {
        // We cannot use the spread operator here because `toJSON` on `span` is non-enumerable
        if (span.data) {
          span.data = normalize(span.data, depth, maxBreadth);
        }
        return span;
      });
    }

    return normalized;
  }

  /**
   *  Enhances event using the client configuration.
   *  It takes care of all "static" values like environment, release and `dist`,
   *  as well as truncating overly long values.
   * @param event event instance to be enhanced
   */
   _applyClientOptions(event) {
    var options = this.getOptions();
    const { environment, release, dist, maxValueLength = 250 } = options;

    if (!('environment' in event)) {
      event.environment = 'environment' in options ? environment : 'production';
    }

    if (event.release === undefined && release !== undefined) {
      event.release = release;
    }

    if (event.dist === undefined && dist !== undefined) {
      event.dist = dist;
    }

    if (event.message) {
      event.message = (0,string/* truncate */.$G)(event.message, maxValueLength);
    }

    var exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) {
      exception.value = (0,string/* truncate */.$G)(exception.value, maxValueLength);
    }

    var request = event.request;
    if (request && request.url) {
      request.url = (0,string/* truncate */.$G)(request.url, maxValueLength);
    }
  }

  /**
   * This function adds all used integrations to the SDK info in the event.
   * @param event The event that will be filled with all integrations.
   */
   _applyIntegrationsMetadata(event) {
    var integrationsArray = Object.keys(this._integrations);
    if (integrationsArray.length > 0) {
      event.sdk = event.sdk || {};
      event.sdk.integrations = [...(event.sdk.integrations || []), ...integrationsArray];
    }
  }

  /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */
   _captureEvent(event, hint = {}, scope) {
    return this._processEvent(event, hint, scope).then(
      finalEvent => {
        return finalEvent.event_id;
      },
      reason => {
        if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
          // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
          // control flow, log just the message (no stack) as a log-level log.
          var sentryError = reason ;
          if (sentryError.logLevel === 'log') {
            esm_logger/* logger.log */.kg.log(sentryError.message);
          } else {
            esm_logger/* logger.warn */.kg.warn(sentryError);
          }
        }
        return undefined;
      },
    );
  }

  /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */
   _processEvent(event, hint, scope) {
    const { beforeSend, sampleRate } = this.getOptions();

    if (!this._isEnabled()) {
      return (0,syncpromise/* rejectedSyncPromise */.$2)(new SentryError('SDK not enabled, will not capture event.', 'log'));
    }

    var isTransaction = event.type === 'transaction';
    // 1.0 === 100% events are sent
    // 0.0 === 0% events are sent
    // Sampling for transaction happens somewhere else
    if (!isTransaction && typeof sampleRate === 'number' && Math.random() > sampleRate) {
      this.recordDroppedEvent('sample_rate', 'error');
      return (0,syncpromise/* rejectedSyncPromise */.$2)(
        new SentryError(
          `Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`,
          'log',
        ),
      );
    }

    return this._prepareEvent(event, hint, scope)
      .then(prepared => {
        if (prepared === null) {
          this.recordDroppedEvent('event_processor', event.type || 'error');
          throw new SentryError('An event processor returned null, will not send event.', 'log');
        }

        var isInternalException = hint.data && (hint.data ).__sentry__ === true;
        if (isInternalException || isTransaction || !beforeSend) {
          return prepared;
        }

        var beforeSendResult = beforeSend(prepared, hint);
        return _ensureBeforeSendRv(beforeSendResult);
      })
      .then(processedEvent => {
        if (processedEvent === null) {
          this.recordDroppedEvent('before_send', event.type || 'error');
          throw new SentryError('`beforeSend` returned `null`, will not send event.', 'log');
        }

        var session = scope && scope.getSession();
        if (!isTransaction && session) {
          this._updateSessionFromEvent(session, processedEvent);
        }

        this.sendEvent(processedEvent, hint);
        return processedEvent;
      })
      .then(null, reason => {
        if (reason instanceof SentryError) {
          throw reason;
        }

        this.captureException(reason, {
          data: {
            __sentry__: true,
          },
          originalException: reason ,
        });
        throw new SentryError(
          `Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`,
        );
      });
  }

  /**
   * Occupies the client with processing and event
   */
   _process(promise) {
    this._numProcessing += 1;
    void promise.then(
      value => {
        this._numProcessing -= 1;
        return value;
      },
      reason => {
        this._numProcessing -= 1;
        return reason;
      },
    );
  }

  /**
   * @inheritdoc
   */
   _sendEnvelope(envelope) {
    if (this._transport && this._dsn) {
      this._transport.send(envelope).then(null, reason => {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error('Error while sending event:', reason);
      });
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error('Transport disabled');
    }
  }

  /**
   * Clears outcomes on this client and returns them.
   */
   _clearOutcomes() {
    var outcomes = this._outcomes;
    this._outcomes = {};
    return Object.keys(outcomes).map(key => {
      const [reason, category] = key.split(':') ;
      return {
        reason,
        category,
        quantity: outcomes[key],
      };
    });
  }

  /**
   * @inheritDoc
   */
    

}

/**
 * Verifies that return value of configured `beforeSend` is of expected type.
 */
function _ensureBeforeSendRv(rv) {
  var nullErr = '`beforeSend` method has to return `null` or a valid event.';
  if ((0,is/* isThenable */.J8)(rv)) {
    return rv.then(
      event => {
        if (!((0,is/* isPlainObject */.PO)(event) || event === null)) {
          throw new SentryError(nullErr);
        }
        return event;
      },
      e => {
        throw new SentryError(`beforeSend rejected with ${e}`);
      },
    );
  } else if (!((0,is/* isPlainObject */.PO)(rv) || rv === null)) {
    throw new SentryError(nullErr);
  }
  return rv;
}


//# sourceMappingURL=baseclient.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/version.js
var version = __webpack_require__(40105);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/clientreport.js



/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */
function createClientReportEnvelope(
  discarded_events,
  dsn,
  timestamp,
) {
  var clientReportItem = [
    { type: 'client_report' },
    {
      timestamp: timestamp || (0,time/* dateTimestampInSeconds */.yW)(),
      discarded_events,
    },
  ];
  return createEnvelope(dsn ? { dsn } : {}, [clientReportItem]);
}


//# sourceMappingURL=clientreport.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/eventbuilder.js


/**
 * This function creates an exception from a JavaScript Error
 */
function exceptionFromError(stackParser, ex) {
  // Get the frames first since Opera can lose the stack if we touch anything else first
  var frames = parseStackFrames(stackParser, ex);

  var exception = {
    type: ex && ex.name,
    value: extractMessage(ex),
  };

  if (frames.length) {
    exception.stacktrace = { frames };
  }

  if (exception.type === undefined && exception.value === '') {
    exception.value = 'Unrecoverable error caught';
  }

  return exception;
}

/**
 * @hidden
 */
function eventFromPlainObject(
  stackParser,
  exception,
  syntheticException,
  isUnhandledRejection,
) {
  var event = {
    exception: {
      values: [
        {
          type: (0,is/* isEvent */.cO)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
          value: `Non-Error ${
            isUnhandledRejection ? 'promise rejection' : 'exception'
          } captured with keys: ${(0,object/* extractExceptionKeysForMessage */.zf)(exception)}`,
        },
      ],
    },
    extra: {
      __serialized__: normalizeToSize(exception),
    },
  };

  if (syntheticException) {
    var frames = parseStackFrames(stackParser, syntheticException);
    if (frames.length) {
      // event.exception.values[0] has been set above
      (event.exception ).values[0].stacktrace = { frames };
    }
  }

  return event;
}

/**
 * @hidden
 */
function eventFromError(stackParser, ex) {
  return {
    exception: {
      values: [exceptionFromError(stackParser, ex)],
    },
  };
}

/** Parses stack frames from an error */
function parseStackFrames(
  stackParser,
  ex,
) {
  // Access and store the stacktrace property before doing ANYTHING
  // else to it because Opera is not very good at providing it
  // reliably in other circumstances.
  var stacktrace = ex.stacktrace || ex.stack || '';

  var popSize = getPopSize(ex);

  try {
    return stackParser(stacktrace, popSize);
  } catch (e) {
    // no-empty
  }

  return [];
}

// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
var reactMinifiedRegexp = /Minified React error #\d+;/i;

function getPopSize(ex) {
  if (ex) {
    if (typeof ex.framesToPop === 'number') {
      return ex.framesToPop;
    }

    if (reactMinifiedRegexp.test(ex.message)) {
      return 1;
    }
  }

  return 0;
}

/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */
function extractMessage(ex) {
  var message = ex && ex.message;
  if (!message) {
    return 'No error message';
  }
  if (message.error && typeof message.error.message === 'string') {
    return message.error.message;
  }
  return message;
}

/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */
function eventFromException(
  stackParser,
  exception,
  hint,
  attachStacktrace,
) {
  var syntheticException = (hint && hint.syntheticException) || undefined;
  var event = eventFromUnknownInput(stackParser, exception, syntheticException, attachStacktrace);
  (0,misc/* addExceptionMechanism */.EG)(event); // defaults to { type: 'generic', handled: true }
  event.level = 'error';
  if (hint && hint.event_id) {
    event.event_id = hint.event_id;
  }
  return (0,syncpromise/* resolvedSyncPromise */.WD)(event);
}

/**
 * Builds and Event from a Message
 * @hidden
 */
function eventFromMessage(
  stackParser,
  message,
    level = 'info',
  hint,
  attachStacktrace,
) {
  var syntheticException = (hint && hint.syntheticException) || undefined;
  var event = eventFromString(stackParser, message, syntheticException, attachStacktrace);
  event.level = level;
  if (hint && hint.event_id) {
    event.event_id = hint.event_id;
  }
  return (0,syncpromise/* resolvedSyncPromise */.WD)(event);
}

/**
 * @hidden
 */
function eventFromUnknownInput(
  stackParser,
  exception,
  syntheticException,
  attachStacktrace,
  isUnhandledRejection,
) {
  let event;

  if ((0,is/* isErrorEvent */.VW)(exception ) && (exception ).error) {
    // If it is an ErrorEvent with `error` property, extract it to get actual Error
    var errorEvent = exception ;
    return eventFromError(stackParser, errorEvent.error );
  }

  // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
  // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
  // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
  //
  // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
  // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
  // https://webidl.spec.whatwg.org/#es-DOMException-specialness
  if ((0,is/* isDOMError */.TX)(exception ) || (0,is/* isDOMException */.fm)(exception )) {
    var domException = exception ;

    if ('stack' in (exception )) {
      event = eventFromError(stackParser, exception );
    } else {
      var name = domException.name || ((0,is/* isDOMError */.TX)(domException) ? 'DOMError' : 'DOMException');
      var message = domException.message ? `${name}: ${domException.message}` : name;
      event = eventFromString(stackParser, message, syntheticException, attachStacktrace);
      (0,misc/* addExceptionTypeValue */.Db)(event, message);
    }
    if ('code' in domException) {
      event.tags = { ...event.tags, 'DOMException.code': `${domException.code}` };
    }

    return event;
  }
  if ((0,is/* isError */.VZ)(exception)) {
    // we have a real Error object, do nothing
    return eventFromError(stackParser, exception);
  }
  if ((0,is/* isPlainObject */.PO)(exception) || (0,is/* isEvent */.cO)(exception)) {
    // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
    // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
    // group on any key/value change.
    var objectException = exception ;
    event = eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
    (0,misc/* addExceptionMechanism */.EG)(event, {
      synthetic: true,
    });
    return event;
  }

  // If none of previous checks were valid, then it means that it's not:
  // - an instance of DOMError
  // - an instance of DOMException
  // - an instance of Event
  // - an instance of Error
  // - a valid ErrorEvent (one with an error property)
  // - a plain Object
  //
  // So bail out and capture it as a simple message:
  event = eventFromString(stackParser, exception , syntheticException, attachStacktrace);
  (0,misc/* addExceptionTypeValue */.Db)(event, `${exception}`, undefined);
  (0,misc/* addExceptionMechanism */.EG)(event, {
    synthetic: true,
  });

  return event;
}

/**
 * @hidden
 */
function eventFromString(
  stackParser,
  input,
  syntheticException,
  attachStacktrace,
) {
  var event = {
    message: input,
  };

  if (attachStacktrace && syntheticException) {
    var frames = parseStackFrames(stackParser, syntheticException);
    if (frames.length) {
      event.exception = {
        values: [{ value: input, stacktrace: { frames } }],
      };
    }
  }

  return event;
}


//# sourceMappingURL=eventbuilder.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/browser.js
var browser = __webpack_require__(58464);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/severity.js
// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.

var validSeverityLevels = ['fatal', 'error', 'warning', 'log', 'info', 'debug'];

/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */
function severityFromString(level) {
  return severityLevelFromString(level) ;
}

/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */
function severityLevelFromString(level) {
  return (level === 'warn' ? 'warning' : validSeverityLevels.includes(level) ? level : 'log') ;
}


//# sourceMappingURL=severity.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/url.js
var url = __webpack_require__(26956);
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/breadcrumbs.js



/** JSDoc */

var BREADCRUMB_INTEGRATION_ID = 'Breadcrumbs';

/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */
class Breadcrumbs  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = BREADCRUMB_INTEGRATION_ID;}

  /**
   * @inheritDoc
   */
   __init() {this.name = Breadcrumbs.id;}

  /**
   * Options of the breadcrumbs integration.
   */
  // This field is public, because we use it in the browser client to check if the `sentry` option is enabled.
  

  /**
   * @inheritDoc
   */
   constructor(options) {;Breadcrumbs.prototype.__init.call(this);
    this.options = {
      console: true,
      dom: true,
      fetch: true,
      history: true,
      sentry: true,
      xhr: true,
      ...options,
    };
  }

  /**
   * Instrument browser built-ins w/ breadcrumb capturing
   *  - Console API
   *  - DOM API (click/typing)
   *  - XMLHttpRequest API
   *  - Fetch API
   *  - History API
   */
   setupOnce() {
    if (this.options.console) {
      (0,instrument/* addInstrumentationHandler */.o)('console', _consoleBreadcrumb);
    }
    if (this.options.dom) {
      (0,instrument/* addInstrumentationHandler */.o)('dom', _domBreadcrumb(this.options.dom));
    }
    if (this.options.xhr) {
      (0,instrument/* addInstrumentationHandler */.o)('xhr', _xhrBreadcrumb);
    }
    if (this.options.fetch) {
      (0,instrument/* addInstrumentationHandler */.o)('fetch', _fetchBreadcrumb);
    }
    if (this.options.history) {
      (0,instrument/* addInstrumentationHandler */.o)('history', _historyBreadcrumb);
    }
  }
} Breadcrumbs.__initStatic();

/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */
function _domBreadcrumb(dom) {
    function _innerDomBreadcrumb(handlerData) {
    let target;
    let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;

    if (typeof keyAttrs === 'string') {
      keyAttrs = [keyAttrs];
    }

    // Accessing event.target can throw (see getsentry/raven-js#838, #768)
    try {
      target = handlerData.event.target
        ? (0,browser/* htmlTreeAsString */.R)(handlerData.event.target , keyAttrs)
        : (0,browser/* htmlTreeAsString */.R)(handlerData.event , keyAttrs);
    } catch (e) {
      target = '<unknown>';
    }

    if (target.length === 0) {
      return;
    }

    (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(
      {
        category: `ui.${handlerData.name}`,
        message: target,
      },
      {
        event: handlerData.event,
        name: handlerData.name,
        global: handlerData.global,
      },
    );
  }

  return _innerDomBreadcrumb;
}

/**
 * Creates breadcrumbs from console API calls
 */
function _consoleBreadcrumb(handlerData) {
  var breadcrumb = {
    category: 'console',
    data: {
      arguments: handlerData.args,
      logger: 'console',
    },
    level: severityLevelFromString(handlerData.level),
    message: (0,string/* safeJoin */.nK)(handlerData.args, ' '),
  };

  if (handlerData.level === 'assert') {
    if (handlerData.args[0] === false) {
      breadcrumb.message = `Assertion failed: ${(0,string/* safeJoin */.nK)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
      breadcrumb.data.arguments = handlerData.args.slice(1);
    } else {
      // Don't capture a breadcrumb for passed assertions
      return;
    }
  }

  (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(breadcrumb, {
    input: handlerData.args,
    level: handlerData.level,
  });
}

/**
 * Creates breadcrumbs from XHR API calls
 */
function _xhrBreadcrumb(handlerData) {
  if (handlerData.endTimestamp) {
    // We only capture complete, non-sentry requests
    if (handlerData.xhr.__sentry_own_request__) {
      return;
    }

    const { method, url, status_code, body } = handlerData.xhr.__sentry_xhr__ || {};

    (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(
      {
        category: 'xhr',
        data: {
          method,
          url,
          status_code,
        },
        type: 'http',
      },
      {
        xhr: handlerData.xhr,
        input: body,
      },
    );

    return;
  }
}

/**
 * Creates breadcrumbs from fetch API calls
 */
function _fetchBreadcrumb(handlerData) {
  // We only capture complete fetch requests
  if (!handlerData.endTimestamp) {
    return;
  }

  if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') {
    // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
    return;
  }

  if (handlerData.error) {
    (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(
      {
        category: 'fetch',
        data: handlerData.fetchData,
        level: 'error',
        type: 'http',
      },
      {
        data: handlerData.error,
        input: handlerData.args,
      },
    );
  } else {
    (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(
      {
        category: 'fetch',
        data: {
          ...handlerData.fetchData,
          status_code: handlerData.response.status,
        },
        type: 'http',
      },
      {
        input: handlerData.args,
        response: handlerData.response,
      },
    );
  }
}

/**
 * Creates breadcrumbs from history API calls
 */
function _historyBreadcrumb(handlerData) {
  var global = (0,esm_global/* getGlobalObject */.R)();
  let from = handlerData.from;
  let to = handlerData.to;
  var parsedLoc = (0,url/* parseUrl */.en)(global.location.href);
  let parsedFrom = (0,url/* parseUrl */.en)(from);
  var parsedTo = (0,url/* parseUrl */.en)(to);

  // Initial pushState doesn't provide `from` information
  if (!parsedFrom.path) {
    parsedFrom = parsedLoc;
  }

  // Use only the path component of the URL if the URL matches the current
  // document (almost all the time when using pushState)
  if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
    to = parsedTo.relative;
  }
  if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
    from = parsedFrom.relative;
  }

  (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb({
    category: 'navigation',
    data: {
      from,
      to,
    },
  });
}


//# sourceMappingURL=breadcrumbs.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/transports/utils.js


var global = (0,esm_global/* getGlobalObject */.R)();
let cachedFetchImpl;

/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * var f = window.fetch;
 * window.fetch = function () {
 *   var p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */
function getNativeFetchImplementation() {
  if (cachedFetchImpl) {
    return cachedFetchImpl;
  }

  // Fast path to avoid DOM I/O
  if ((0,supports/* isNativeFetch */.Du)(global.fetch)) {
    return (cachedFetchImpl = global.fetch.bind(global));
  }

  var document = global.document;
  let fetchImpl = global.fetch;
    if (document && typeof document.createElement === 'function') {
    try {
      var sandbox = document.createElement('iframe');
      sandbox.hidden = true;
      document.head.appendChild(sandbox);
      var contentWindow = sandbox.contentWindow;
      if (contentWindow && contentWindow.fetch) {
        fetchImpl = contentWindow.fetch;
      }
      document.head.removeChild(sandbox);
    } catch (e) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        esm_logger/* logger.warn */.kg.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
  }

  return (cachedFetchImpl = fetchImpl.bind(global));
  }

/**
 * Sends sdk client report using sendBeacon or fetch as a fallback if available
 *
 * @param url report endpoint
 * @param body report payload
 */
function sendReport(url, body) {
  var isRealNavigator = Object.prototype.toString.call(global && global.navigator) === '[object Navigator]';
  var hasSendBeacon = isRealNavigator && typeof global.navigator.sendBeacon === 'function';

  if (hasSendBeacon) {
    // Prevent illegal invocations - https://xgwang.me/posts/you-may-not-know-beacon/#it-may-throw-error%2C-be-sure-to-catch
    var sendBeacon = global.navigator.sendBeacon.bind(global.navigator);
    sendBeacon(url, body);
  } else if ((0,supports/* supportsFetch */.Ak)()) {
    var fetch = getNativeFetchImplementation();
    fetch(url, {
      body,
      method: 'POST',
      credentials: 'omit',
      keepalive: true,
    }).then(null, error => {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error(error);
    });
  }
}


//# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/client.js






var globalObject = (0,esm_global/* getGlobalObject */.R)();

/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */
class BrowserClient extends BaseClient {
  /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */
   constructor(options) {
    options._metadata = options._metadata || {};
    options._metadata.sdk = options._metadata.sdk || {
      name: 'sentry.javascript.browser',
      packages: [
        {
          name: 'npm:@sentry/browser',
          version: version/* SDK_VERSION */.J,
        },
      ],
      version: version/* SDK_VERSION */.J,
    };

    super(options);

    if (options.sendClientReports && globalObject.document) {
      globalObject.document.addEventListener('visibilitychange', () => {
        if (globalObject.document.visibilityState === 'hidden') {
          this._flushOutcomes();
        }
      });
    }
  }

  /**
   * @inheritDoc
   */
   eventFromException(exception, hint) {
    return eventFromException(this._options.stackParser, exception, hint, this._options.attachStacktrace);
  }

  /**
   * @inheritDoc
   */
   eventFromMessage(
    message,
        level = 'info',
    hint,
  ) {
    return eventFromMessage(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
  }

  /**
   * @inheritDoc
   */
   sendEvent(event, hint) {
    // We only want to add the sentry event breadcrumb when the user has the breadcrumb integration installed and
    // activated its `sentry` option.
    // We also do not want to use the `Breadcrumbs` class here directly, because we do not want it to be included in
    // bundles, if it is not used by the SDK.
    // This all sadly is a bit ugly, but we currently don't have a "pre-send" hook on the integrations so we do it this
    // way for now.
    var breadcrumbIntegration = this.getIntegrationById(BREADCRUMB_INTEGRATION_ID) ;
    if (
      breadcrumbIntegration &&
      // We check for definedness of `options`, even though it is not strictly necessary, because that access to
      // `.sentry` below does not throw, in case users provided their own integration with id "Breadcrumbs" that does
      // not have an`options` field
      breadcrumbIntegration.options &&
      breadcrumbIntegration.options.sentry
    ) {
      (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(
        {
          category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
          event_id: event.event_id,
          level: event.level,
          message: (0,misc/* getEventDescription */.jH)(event),
        },
        {
          event,
        },
      );
    }

    super.sendEvent(event, hint);
  }

  /**
   * @inheritDoc
   */
   _prepareEvent(event, hint, scope) {
    event.platform = event.platform || 'javascript';
    return super._prepareEvent(event, hint, scope);
  }

  /**
   * Sends client reports as an envelope.
   */
   _flushOutcomes() {
    var outcomes = this._clearOutcomes();

    if (outcomes.length === 0) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('No outcomes to send');
      return;
    }

    if (!this._dsn) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('No dsn provided, will not send outcomes');
      return;
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('Sending outcomes:', outcomes);

    var url = getEnvelopeEndpointWithUrlEncodedAuth(this._dsn, this._options);
    var envelope = createClientReportEnvelope(outcomes, this._options.tunnel && dsn_dsnToString(this._dsn));

    try {
      sendReport(url, serializeEnvelope(envelope));
    } catch (e) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error(e);
    }
  }
}


//# sourceMappingURL=client.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/stack-parsers.js


// global reference to slice
var UNKNOWN_FUNCTION = '?';

var OPERA10_PRIORITY = 10;
var OPERA11_PRIORITY = 20;
var CHROME_PRIORITY = 30;
var WINJS_PRIORITY = 40;
var GECKO_PRIORITY = 50;

function createFrame(filename, func, lineno, colno) {
  var frame = {
    filename,
    function: func,
    // All browser frames are considered in_app
    in_app: true,
  };

  if (lineno !== undefined) {
    frame.lineno = lineno;
  }

  if (colno !== undefined) {
    frame.colno = colno;
  }

  return frame;
}

// Chromium based browsers: Chrome, Brave, new Opera, new Edge
var chromeRegex =
  /^\s*at (?:(.*\).*?|.*?) ?\((?:address at )?)?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
var chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;

var chrome = line => {
  var parts = chromeRegex.exec(line);

  if (parts) {
    var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line

    if (isEval) {
      var subMatch = chromeEvalRegex.exec(parts[2]);

      if (subMatch) {
        // throw out eval line/column and use top-most line/column number
        parts[2] = subMatch[1]; // url
        parts[3] = subMatch[2]; // line
        parts[4] = subMatch[3]; // column
      }
    }

    // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
    // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
    const [func, filename] = extractSafariExtensionDetails(parts[1] || UNKNOWN_FUNCTION, parts[2]);

    return createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
  }

  return;
};

var chromeStackLineParser = [CHROME_PRIORITY, chrome];

// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
var geckoREgex =
  /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|safari-extension|safari-web-extension|capacitor)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
var geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;

var gecko = line => {
  var parts = geckoREgex.exec(line);

  if (parts) {
    var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
    if (isEval) {
      var subMatch = geckoEvalRegex.exec(parts[3]);

      if (subMatch) {
        // throw out eval line/column and use top-most line number
        parts[1] = parts[1] || 'eval';
        parts[3] = subMatch[1];
        parts[4] = subMatch[2];
        parts[5] = ''; // no column when eval
      }
    }

    let filename = parts[3];
    let func = parts[1] || UNKNOWN_FUNCTION;
    [func, filename] = extractSafariExtensionDetails(func, filename);

    return createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
  }

  return;
};

var geckoStackLineParser = [GECKO_PRIORITY, gecko];

var winjsRegex =
  /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;

var winjs = line => {
  var parts = winjsRegex.exec(line);

  return parts
    ? createFrame(parts[2], parts[1] || UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined)
    : undefined;
};

var winjsStackLineParser = [WINJS_PRIORITY, winjs];

var opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;

var opera10 = line => {
  var parts = opera10Regex.exec(line);
  return parts ? createFrame(parts[2], parts[3] || UNKNOWN_FUNCTION, +parts[1]) : undefined;
};

var opera10StackLineParser = [OPERA10_PRIORITY, opera10];

var opera11Regex =
  / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;

var opera11 = line => {
  var parts = opera11Regex.exec(line);
  return parts ? createFrame(parts[5], parts[3] || parts[4] || UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};

var opera11StackLineParser = [OPERA11_PRIORITY, opera11];

var defaultStackLineParsers = [chromeStackLineParser, geckoStackLineParser, winjsStackLineParser];

var defaultStackParser = (0,stacktrace/* createStackParser */.pE)(...defaultStackLineParsers);

/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */
var extractSafariExtensionDetails = (func, filename) => {
  var isSafariExtension = func.indexOf('safari-extension') !== -1;
  var isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;

  return isSafariExtension || isSafariWebExtension
    ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`,
      ]
    : [func, filename];
};


//# sourceMappingURL=stack-parsers.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/hub/esm/exports.js
var esm_exports = __webpack_require__(92876);
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/helpers.js



let ignoreOnError = 0;

/**
 * @hidden
 */
function shouldIgnoreOnError() {
  return ignoreOnError > 0;
}

/**
 * @hidden
 */
function ignoreNextOnError() {
  // onerror should trigger before setTimeout
  ignoreOnError += 1;
  setTimeout(() => {
    ignoreOnError -= 1;
  });
}

/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */
function wrap(
  fn,
  options

 = {},
  before,
  ) {
  // for future readers what this does is wrap a function and then create
  // a bi-directional wrapping between them.
  //
  // example: wrapped = wrap(original);
  //  original.__sentry_wrapped__ -> wrapped
  //  wrapped.__sentry_original__ -> original

  if (typeof fn !== 'function') {
    return fn;
  }

  try {
    // if we're dealing with a function that was previously wrapped, return
    // the original wrapper.
    var wrapper = fn.__sentry_wrapped__;
    if (wrapper) {
      return wrapper;
    }

    // We don't wanna wrap it twice
    if ((0,object/* getOriginalFunction */.HK)(fn)) {
      return fn;
    }
  } catch (e) {
    // Just accessing custom props in some Selenium environments
    // can cause a "Permission denied" exception (see raven-js#495).
    // Bail on wrapping and return the function as-is (defers to window.onerror).
    return fn;
  }

    // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
  var sentryWrapped = function () {
    var args = Array.prototype.slice.call(arguments);

    try {
      if (before && typeof before === 'function') {
        before.apply(this, arguments);
      }

            var wrappedArguments = args.map((arg) => wrap(arg, options));

      // Attempt to invoke user-land function
      // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
      //       means the sentry.javascript SDK caught an error invoking your application code. This
      //       is expected behavior and NOT indicative of a bug with sentry.javascript.
      return fn.apply(this, wrappedArguments);
    } catch (ex) {
      ignoreNextOnError();

      (0,esm_exports/* withScope */.$e)((scope) => {
        scope.addEventProcessor((event) => {
          if (options.mechanism) {
            (0,misc/* addExceptionTypeValue */.Db)(event, undefined, undefined);
            (0,misc/* addExceptionMechanism */.EG)(event, options.mechanism);
          }

          event.extra = {
            ...event.extra,
            arguments: args,
          };

          return event;
        });

        (0,esm_exports/* captureException */.Tb)(ex);
      });

      throw ex;
    }
  };
  
  // Accessing some objects may throw
  // ref: https://github.com/getsentry/sentry-javascript/issues/1168
  try {
    for (var property in fn) {
      if (Object.prototype.hasOwnProperty.call(fn, property)) {
        sentryWrapped[property] = fn[property];
      }
    }
  } catch (_oO) {} 
  // Signal that this function has been wrapped/filled already
  // for both debugging and to prevent it to being wrapped/filled twice
  (0,object/* markFunctionWrapped */.$Q)(sentryWrapped, fn);

  (0,object/* addNonEnumerableProperty */.xp)(fn, '__sentry_wrapped__', sentryWrapped);

  // Restore original function name (not all browsers allow that)
  try {
    var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name') ;
    if (descriptor.configurable) {
      Object.defineProperty(sentryWrapped, 'name', {
        get() {
          return fn.name;
        },
      });
    }
      } catch (_oO) {}

  return sentryWrapped;
}

/**
 * All properties the report dialog supports
 */


//# sourceMappingURL=helpers.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/trycatch.js



var DEFAULT_EVENT_TARGET = [
  'EventTarget',
  'Window',
  'Node',
  'ApplicationCache',
  'AudioTrackList',
  'ChannelMergerNode',
  'CryptoOperation',
  'EventSource',
  'FileReader',
  'HTMLUnknownElement',
  'IDBDatabase',
  'IDBRequest',
  'IDBTransaction',
  'KeyOperation',
  'MediaController',
  'MessagePort',
  'ModalWindow',
  'Notification',
  'SVGElementInstance',
  'Screen',
  'TextTrack',
  'TextTrackCue',
  'TextTrackList',
  'WebSocket',
  'WebSocketWorker',
  'Worker',
  'XMLHttpRequest',
  'XMLHttpRequestEventTarget',
  'XMLHttpRequestUpload',
];

/** Wrap timer functions and event targets to catch errors and provide better meta data */
class TryCatch  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'TryCatch';}

  /**
   * @inheritDoc
   */
   __init() {this.name = TryCatch.id;}

  /** JSDoc */
  

  /**
   * @inheritDoc
   */
   constructor(options) {;TryCatch.prototype.__init.call(this);
    this._options = {
      XMLHttpRequest: true,
      eventTarget: true,
      requestAnimationFrame: true,
      setInterval: true,
      setTimeout: true,
      ...options,
    };
  }

  /**
   * Wrap timer functions and event targets to catch errors
   * and provide better metadata.
   */
   setupOnce() {
    var global = (0,esm_global/* getGlobalObject */.R)();

    if (this._options.setTimeout) {
      (0,object/* fill */.hl)(global, 'setTimeout', _wrapTimeFunction);
    }

    if (this._options.setInterval) {
      (0,object/* fill */.hl)(global, 'setInterval', _wrapTimeFunction);
    }

    if (this._options.requestAnimationFrame) {
      (0,object/* fill */.hl)(global, 'requestAnimationFrame', _wrapRAF);
    }

    if (this._options.XMLHttpRequest && 'XMLHttpRequest' in global) {
      (0,object/* fill */.hl)(XMLHttpRequest.prototype, 'send', _wrapXHR);
    }

    var eventTargetOption = this._options.eventTarget;
    if (eventTargetOption) {
      var eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : DEFAULT_EVENT_TARGET;
      eventTarget.forEach(_wrapEventTarget);
    }
  }
} TryCatch.__initStatic();

/** JSDoc */
function _wrapTimeFunction(original) {
    return function ( ...args) {
    var originalCallback = args[0];
    args[0] = wrap(originalCallback, {
      mechanism: {
        data: { function: (0,stacktrace/* getFunctionName */.$P)(original) },
        handled: true,
        type: 'instrument',
      },
    });
    return original.apply(this, args);
  };
}

/** JSDoc */
function _wrapRAF(original) {
    return function ( callback) {
        return original.apply(this, [
      wrap(callback, {
        mechanism: {
          data: {
            function: 'requestAnimationFrame',
            handler: (0,stacktrace/* getFunctionName */.$P)(original),
          },
          handled: true,
          type: 'instrument',
        },
      }),
    ]);
  };
}

/** JSDoc */
function _wrapXHR(originalSend) {
    return function ( ...args) {
        var xhr = this;
    var xmlHttpRequestProps = ['onload', 'onerror', 'onprogress', 'onreadystatechange'];

    xmlHttpRequestProps.forEach(prop => {
      if (prop in xhr && typeof xhr[prop] === 'function') {
                (0,object/* fill */.hl)(xhr, prop, function (original) {
          var wrapOptions = {
            mechanism: {
              data: {
                function: prop,
                handler: (0,stacktrace/* getFunctionName */.$P)(original),
              },
              handled: true,
              type: 'instrument',
            },
          };

          // If Instrument integration has been called before TryCatch, get the name of original function
          var originalFunction = (0,object/* getOriginalFunction */.HK)(original);
          if (originalFunction) {
            wrapOptions.mechanism.data.handler = (0,stacktrace/* getFunctionName */.$P)(originalFunction);
          }

          // Otherwise wrap directly
          return wrap(original, wrapOptions);
        });
      }
    });

    return originalSend.apply(this, args);
  };
}

/** JSDoc */
function _wrapEventTarget(target) {
    var global = (0,esm_global/* getGlobalObject */.R)() ;
    var proto = global[target] && global[target].prototype;

    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
    return;
  }

  (0,object/* fill */.hl)(proto, 'addEventListener', function (original)

 {
    return function (
            
      eventName,
      fn,
      options,
    ) {
      try {
        if (typeof fn.handleEvent === 'function') {
          // ESlint disable explanation:
          //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
          //  introduce a bug here, because bind returns a new function that doesn't have our
          //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
          //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                    fn.handleEvent = wrap(fn.handleEvent, {
            mechanism: {
              data: {
                function: 'handleEvent',
                handler: (0,stacktrace/* getFunctionName */.$P)(fn),
                target,
              },
              handled: true,
              type: 'instrument',
            },
          });
        }
      } catch (err) {
        // can sometimes get 'Permission denied to access property "handle Event'
      }

      return original.apply(this, [
        eventName,
                wrap(fn , {
          mechanism: {
            data: {
              function: 'addEventListener',
              handler: (0,stacktrace/* getFunctionName */.$P)(fn),
              target,
            },
            handled: true,
            type: 'instrument',
          },
        }),
        options,
      ]);
    };
  });

  (0,object/* fill */.hl)(
    proto,
    'removeEventListener',
    function (
      originalRemoveEventListener,
          ) {
      return function (
                
        eventName,
        fn,
        options,
      ) {
        /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */
        var wrappedEventHandler = fn ;
        try {
          var originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
          if (originalEventHandler) {
            originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
          }
        } catch (e) {
          // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
        }
        return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
      };
    },
  );
}


//# sourceMappingURL=trycatch.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/globalhandlers.js





/** Global handlers */
class GlobalHandlers  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'GlobalHandlers';}

  /**
   * @inheritDoc
   */
   __init() {this.name = GlobalHandlers.id;}

  /** JSDoc */
  

  /**
   * Stores references functions to installing handlers. Will set to undefined
   * after they have been run so that they are not used twice.
   */
   __init2() {this._installFunc = {
    onerror: _installGlobalOnErrorHandler,
    onunhandledrejection: _installGlobalOnUnhandledRejectionHandler,
  };}

  /** JSDoc */
   constructor(options) {;GlobalHandlers.prototype.__init.call(this);GlobalHandlers.prototype.__init2.call(this);
    this._options = {
      onerror: true,
      onunhandledrejection: true,
      ...options,
    };
  }
  /**
   * @inheritDoc
   */
   setupOnce() {
    Error.stackTraceLimit = 50;
    var options = this._options;

    // We can disable guard-for-in as we construct the options object above + do checks against
    // `this._installFunc` for the property.
        for (var key in options) {
      var installFunc = this._installFunc[key ];
      if (installFunc && options[key ]) {
        globalHandlerLog(key);
        installFunc();
        this._installFunc[key ] = undefined;
      }
    }
  }
} GlobalHandlers.__initStatic();

/** JSDoc */
function _installGlobalOnErrorHandler() {
  (0,instrument/* addInstrumentationHandler */.o)(
    'error',
        (data) => {
      const [hub, stackParser, attachStacktrace] = getHubAndOptions();
      if (!hub.getIntegration(GlobalHandlers)) {
        return;
      }
      const { msg, url, line, column, error } = data;
      if (shouldIgnoreOnError() || (error && error.__sentry_own_request__)) {
        return;
      }

      var event =
        error === undefined && (0,is/* isString */.HD)(msg)
          ? _eventFromIncompleteOnError(msg, url, line, column)
          : _enhanceEventWithInitialFrame(
              eventFromUnknownInput(stackParser, error || msg, undefined, attachStacktrace, false),
              url,
              line,
              column,
            );

      event.level = 'error';

      addMechanismAndCapture(hub, error, event, 'onerror');
    },
  );
}

/** JSDoc */
function _installGlobalOnUnhandledRejectionHandler() {
  (0,instrument/* addInstrumentationHandler */.o)(
    'unhandledrejection',
        (e) => {
      const [hub, stackParser, attachStacktrace] = getHubAndOptions();
      if (!hub.getIntegration(GlobalHandlers)) {
        return;
      }
      let error = e;

      // dig the object of the rejection out of known event types
      try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in e) {
          error = e.reason;
        }
        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
        // https://github.com/getsentry/sentry-javascript/issues/2380
        else if ('detail' in e && 'reason' in e.detail) {
          error = e.detail.reason;
        }
      } catch (_oO) {
        // no-empty
      }

      if (shouldIgnoreOnError() || (error && error.__sentry_own_request__)) {
        return true;
      }

      var event = (0,is/* isPrimitive */.pt)(error)
        ? _eventFromRejectionWithPrimitive(error)
        : eventFromUnknownInput(stackParser, error, undefined, attachStacktrace, true);

      event.level = 'error';

      addMechanismAndCapture(hub, error, event, 'onunhandledrejection');
      return;
    },
  );
}

/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */
function _eventFromRejectionWithPrimitive(reason) {
  return {
    exception: {
      values: [
        {
          type: 'UnhandledRejection',
          // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
          value: `Non-Error promise rejection captured with value: ${String(reason)}`,
        },
      ],
    },
  };
}

/**
 * This function creates a stack from an old, error-less onerror handler.
 */
function _eventFromIncompleteOnError(msg, url, line, column) {
  var ERROR_TYPES_RE =
    /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;

  // If 'message' is ErrorEvent, get real message from inside
  let message = (0,is/* isErrorEvent */.VW)(msg) ? msg.message : msg;
  let name = 'Error';

  var groups = message.match(ERROR_TYPES_RE);
  if (groups) {
    name = groups[1];
    message = groups[2];
  }

  var event = {
    exception: {
      values: [
        {
          type: name,
          value: message,
        },
      ],
    },
  };

  return _enhanceEventWithInitialFrame(event, url, line, column);
}

/** JSDoc */
function _enhanceEventWithInitialFrame(event, url, line, column) {
  // event.exception
  var e = (event.exception = event.exception || {});
  // event.exception.values
  var ev = (e.values = e.values || []);
  // event.exception.values[0]
  var ev0 = (ev[0] = ev[0] || {});
  // event.exception.values[0].stacktrace
  var ev0s = (ev0.stacktrace = ev0.stacktrace || {});
  // event.exception.values[0].stacktrace.frames
  var ev0sf = (ev0s.frames = ev0s.frames || []);

  var colno = isNaN(parseInt(column, 10)) ? undefined : column;
  var lineno = isNaN(parseInt(line, 10)) ? undefined : line;
  var filename = (0,is/* isString */.HD)(url) && url.length > 0 ? url : (0,browser/* getLocationHref */.l)();

  // event.exception.values[0].stacktrace.frames
  if (ev0sf.length === 0) {
    ev0sf.push({
      colno,
      filename,
      function: '?',
      in_app: true,
      lineno,
    });
  }

  return event;
}

function globalHandlerLog(type) {
  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(`Global Handler attached: ${type}`);
}

function addMechanismAndCapture(hub, error, event, type) {
  (0,misc/* addExceptionMechanism */.EG)(event, {
    handled: false,
    type,
  });
  hub.captureEvent(event, {
    originalException: error,
  });
}

function getHubAndOptions() {
  var hub = (0,esm_hub/* getCurrentHub */.Gd)();
  var client = hub.getClient();
  var options = (client && client.getOptions()) || {
    stackParser: () => [],
    attachStacktrace: false,
  };
  return [hub, options.stackParser, options.attachStacktrace];
}


//# sourceMappingURL=globalhandlers.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/linkederrors.js




var DEFAULT_KEY = 'cause';
var DEFAULT_LIMIT = 5;

/** Adds SDK info to an event. */
class LinkedErrors  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'LinkedErrors';}

  /**
   * @inheritDoc
   */
    __init() {this.name = LinkedErrors.id;}

  /**
   * @inheritDoc
   */
  

  /**
   * @inheritDoc
   */
  

  /**
   * @inheritDoc
   */
   constructor(options = {}) {;LinkedErrors.prototype.__init.call(this);
    this._key = options.key || DEFAULT_KEY;
    this._limit = options.limit || DEFAULT_LIMIT;
  }

  /**
   * @inheritDoc
   */
   setupOnce() {
    var client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();
    if (!client) {
      return;
    }
    (0,esm_scope/* addGlobalEventProcessor */.c)((event, hint) => {
      var self = (0,esm_hub/* getCurrentHub */.Gd)().getIntegration(LinkedErrors);
      return self ? _handler(client.getOptions().stackParser, self._key, self._limit, event, hint) : event;
    });
  }
} LinkedErrors.__initStatic();

/**
 * @inheritDoc
 */
function _handler(
  parser,
  key,
  limit,
  event,
  hint,
) {
  if (!event.exception || !event.exception.values || !hint || !(0,is/* isInstanceOf */.V9)(hint.originalException, Error)) {
    return event;
  }
  var linkedErrors = _walkErrorTree(parser, limit, hint.originalException , key);
  event.exception.values = [...linkedErrors, ...event.exception.values];
  return event;
}

/**
 * JSDOC
 */
function _walkErrorTree(
  parser,
  limit,
  error,
  key,
  stack = [],
) {
  if (!(0,is/* isInstanceOf */.V9)(error[key], Error) || stack.length + 1 >= limit) {
    return stack;
  }
  var exception = exceptionFromError(parser, error[key]);
  return _walkErrorTree(parser, limit, error[key], key, [exception, ...stack]);
}


//# sourceMappingURL=linkederrors.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/dedupe.js


/** Deduplication filter */
class Dedupe  {constructor() { Dedupe.prototype.__init.call(this); }
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'Dedupe';}

  /**
   * @inheritDoc
   */
   __init() {this.name = Dedupe.id;}

  /**
   * @inheritDoc
   */
  

  /**
   * @inheritDoc
   */
   setupOnce(addGlobalEventProcessor, getCurrentHub) {
    var eventProcessor = currentEvent => {
      var self = getCurrentHub().getIntegration(Dedupe);
      if (self) {
        // Juuust in case something goes wrong
        try {
          if (dedupe_shouldDropEvent(currentEvent, self._previousEvent)) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('Event dropped due to being a duplicate of previously captured event.');
            return null;
          }
        } catch (_oO) {
          return (self._previousEvent = currentEvent);
        }

        return (self._previousEvent = currentEvent);
      }
      return currentEvent;
    };

    eventProcessor.id = this.name;
    addGlobalEventProcessor(eventProcessor);
  }
} Dedupe.__initStatic();

/** JSDoc */
function dedupe_shouldDropEvent(currentEvent, previousEvent) {
  if (!previousEvent) {
    return false;
  }

  if (_isSameMessageEvent(currentEvent, previousEvent)) {
    return true;
  }

  if (_isSameExceptionEvent(currentEvent, previousEvent)) {
    return true;
  }

  return false;
}

/** JSDoc */
function _isSameMessageEvent(currentEvent, previousEvent) {
  var currentMessage = currentEvent.message;
  var previousMessage = previousEvent.message;

  // If neither event has a message property, they were both exceptions, so bail out
  if (!currentMessage && !previousMessage) {
    return false;
  }

  // If only one event has a stacktrace, but not the other one, they are not the same
  if ((currentMessage && !previousMessage) || (!currentMessage && previousMessage)) {
    return false;
  }

  if (currentMessage !== previousMessage) {
    return false;
  }

  if (!_isSameFingerprint(currentEvent, previousEvent)) {
    return false;
  }

  if (!_isSameStacktrace(currentEvent, previousEvent)) {
    return false;
  }

  return true;
}

/** JSDoc */
function _isSameExceptionEvent(currentEvent, previousEvent) {
  var previousException = _getExceptionFromEvent(previousEvent);
  var currentException = _getExceptionFromEvent(currentEvent);

  if (!previousException || !currentException) {
    return false;
  }

  if (previousException.type !== currentException.type || previousException.value !== currentException.value) {
    return false;
  }

  if (!_isSameFingerprint(currentEvent, previousEvent)) {
    return false;
  }

  if (!_isSameStacktrace(currentEvent, previousEvent)) {
    return false;
  }

  return true;
}

/** JSDoc */
function _isSameStacktrace(currentEvent, previousEvent) {
  let currentFrames = _getFramesFromEvent(currentEvent);
  let previousFrames = _getFramesFromEvent(previousEvent);

  // If neither event has a stacktrace, they are assumed to be the same
  if (!currentFrames && !previousFrames) {
    return true;
  }

  // If only one event has a stacktrace, but not the other one, they are not the same
  if ((currentFrames && !previousFrames) || (!currentFrames && previousFrames)) {
    return false;
  }

  currentFrames = currentFrames ;
  previousFrames = previousFrames ;

  // If number of frames differ, they are not the same
  if (previousFrames.length !== currentFrames.length) {
    return false;
  }

  // Otherwise, compare the two
  for (let i = 0; i < previousFrames.length; i++) {
    var frameA = previousFrames[i];
    var frameB = currentFrames[i];

    if (
      frameA.filename !== frameB.filename ||
      frameA.lineno !== frameB.lineno ||
      frameA.colno !== frameB.colno ||
      frameA.function !== frameB.function
    ) {
      return false;
    }
  }

  return true;
}

/** JSDoc */
function _isSameFingerprint(currentEvent, previousEvent) {
  let currentFingerprint = currentEvent.fingerprint;
  let previousFingerprint = previousEvent.fingerprint;

  // If neither event has a fingerprint, they are assumed to be the same
  if (!currentFingerprint && !previousFingerprint) {
    return true;
  }

  // If only one event has a fingerprint, but not the other one, they are not the same
  if ((currentFingerprint && !previousFingerprint) || (!currentFingerprint && previousFingerprint)) {
    return false;
  }

  currentFingerprint = currentFingerprint ;
  previousFingerprint = previousFingerprint ;

  // Otherwise, compare the two
  try {
    return !!(currentFingerprint.join('') === previousFingerprint.join(''));
  } catch (_oO) {
    return false;
  }
}

/** JSDoc */
function _getExceptionFromEvent(event) {
  return event.exception && event.exception.values && event.exception.values[0];
}

/** JSDoc */
function _getFramesFromEvent(event) {
  var exception = event.exception;

  if (exception) {
    try {
      // @ts-ignore Object could be undefined
      return exception.values[0].stacktrace.frames;
    } catch (_oO) {
      return undefined;
    }
  }
  return undefined;
}


//# sourceMappingURL=dedupe.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/httpcontext.js



var httpcontext_global = (0,esm_global/* getGlobalObject */.R)();

/** HttpContext integration collects information about HTTP request headers */
class HttpContext  {constructor() { HttpContext.prototype.__init.call(this); }
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'HttpContext';}

  /**
   * @inheritDoc
   */
   __init() {this.name = HttpContext.id;}

  /**
   * @inheritDoc
   */
   setupOnce() {
    (0,esm_scope/* addGlobalEventProcessor */.c)((event) => {
      if ((0,esm_hub/* getCurrentHub */.Gd)().getIntegration(HttpContext)) {
        // if none of the information we want exists, don't bother
        if (!httpcontext_global.navigator && !httpcontext_global.location && !httpcontext_global.document) {
          return event;
        }

        // grab as much info as exists and add it to the event
        var url = (event.request && event.request.url) || (httpcontext_global.location && httpcontext_global.location.href);
        const { referrer } = httpcontext_global.document || {};
        const { userAgent } = httpcontext_global.navigator || {};

        var headers = {
          ...(event.request && event.request.headers),
          ...(referrer && { Referer: referrer }),
          ...(userAgent && { 'User-Agent': userAgent }),
        };
        var request = { ...(url && { url }), headers };

        return { ...event, request };
      }
      return event;
    });
  }
} HttpContext.__initStatic();


//# sourceMappingURL=httpcontext.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/promisebuffer.js



/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */
function makePromiseBuffer(limit) {
  var buffer = [];

  function isReady() {
    return limit === undefined || buffer.length < limit;
  }

  /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */
  function remove(task) {
    return buffer.splice(buffer.indexOf(task), 1)[0];
  }

  /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */
  function add(taskProducer) {
    if (!isReady()) {
      return (0,syncpromise/* rejectedSyncPromise */.$2)(new SentryError('Not adding Promise due to buffer limit reached.'));
    }

    // start the task and add its promise to the queue
    var task = taskProducer();
    if (buffer.indexOf(task) === -1) {
      buffer.push(task);
    }
    void task
      .then(() => remove(task))
      // Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
      // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
      // have promises, so TS has to polyfill when down-compiling.)
      .then(null, () =>
        remove(task).then(null, () => {
          // We have to add another catch here because `remove()` starts a new promise chain.
        }),
      );
    return task;
  }

  /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */
  function drain(timeout) {
    return new syncpromise/* SyncPromise */.cW((resolve, reject) => {
      let counter = buffer.length;

      if (!counter) {
        return resolve(true);
      }

      // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
      var capturedSetTimeout = setTimeout(() => {
        if (timeout && timeout > 0) {
          resolve(false);
        }
      }, timeout);

      // if all promises resolve in time, cancel the timer and resolve to `true`
      buffer.forEach(item => {
        void (0,syncpromise/* resolvedSyncPromise */.WD)(item).then(() => {
                    if (!--counter) {
            clearTimeout(capturedSetTimeout);
            resolve(true);
          }
        }, reject);
      });
    });
  }

  return {
    $: buffer,
    add,
    drain,
  };
}


//# sourceMappingURL=promisebuffer.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/ratelimit.js
// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend

var DEFAULT_RETRY_AFTER = 60 * 1000; // 60 seconds

/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */
function parseRetryAfterHeader(header, now = Date.now()) {
  var headerDelay = parseInt(`${header}`, 10);
  if (!isNaN(headerDelay)) {
    return headerDelay * 1000;
  }

  var headerDate = Date.parse(`${header}`);
  if (!isNaN(headerDate)) {
    return headerDate - now;
  }

  return DEFAULT_RETRY_AFTER;
}

/**
 * Gets the time that given category is disabled until for rate limiting
 */
function disabledUntil(limits, category) {
  return limits[category] || limits.all || 0;
}

/**
 * Checks if a category is rate limited
 */
function isRateLimited(limits, category, now = Date.now()) {
  return disabledUntil(limits, category) > now;
}

/**
 * Update ratelimits from incoming headers.
 * Returns true if headers contains a non-empty rate limiting header.
 */
function updateRateLimits(
  limits,
  { statusCode, headers },
  now = Date.now(),
) {
  var updatedRateLimits = {
    ...limits,
  };

  // "The name is case-insensitive."
  // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
  var rateLimitHeader = headers && headers['x-sentry-rate-limits'];
  var retryAfterHeader = headers && headers['retry-after'];

  if (rateLimitHeader) {
    /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     */
    for (var limit of rateLimitHeader.trim().split(',')) {
      const [retryAfter, categories] = limit.split(':', 2);
      var headerDelay = parseInt(retryAfter, 10);
      var delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
      if (!categories) {
        updatedRateLimits.all = now + delay;
      } else {
        for (var category of categories.split(';')) {
          updatedRateLimits[category] = now + delay;
        }
      }
    }
  } else if (retryAfterHeader) {
    updatedRateLimits.all = now + parseRetryAfterHeader(retryAfterHeader, now);
  } else if (statusCode === 429) {
    updatedRateLimits.all = now + 60 * 1000;
  }

  return updatedRateLimits;
}


//# sourceMappingURL=ratelimit.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/transports/base.js


var DEFAULT_TRANSPORT_BUFFER_SIZE = 30;

/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */
function createTransport(
  options,
  makeRequest,
  buffer = makePromiseBuffer(options.bufferSize || DEFAULT_TRANSPORT_BUFFER_SIZE),
) {
  let rateLimits = {};

  var flush = (timeout) => buffer.drain(timeout);

  function send(envelope) {
    var filteredEnvelopeItems = [];

    // Drop rate limited items from envelope
    forEachEnvelopeItem(envelope, (item, type) => {
      var envelopeItemDataCategory = envelopeItemTypeToDataCategory(type);
      if (isRateLimited(rateLimits, envelopeItemDataCategory)) {
        options.recordDroppedEvent('ratelimit_backoff', envelopeItemDataCategory);
      } else {
        filteredEnvelopeItems.push(item);
      }
    });

    // Skip sending if envelope is empty after filtering out rate limited events
    if (filteredEnvelopeItems.length === 0) {
      return (0,syncpromise/* resolvedSyncPromise */.WD)();
    }

        var filteredEnvelope = createEnvelope(envelope[0], filteredEnvelopeItems );

    // Creates client report for each item in an envelope
    var recordEnvelopeLoss = (reason) => {
      forEachEnvelopeItem(filteredEnvelope, (_, type) => {
        options.recordDroppedEvent(reason, envelopeItemTypeToDataCategory(type));
      });
    };

    var requestTask = () =>
      makeRequest({ body: serializeEnvelope(filteredEnvelope, options.textEncoder) }).then(
        response => {
          // We don't want to throw on NOK responses, but we want to at least log them
          if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
          }

          rateLimits = updateRateLimits(rateLimits, response);
        },
        error => {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error('Failed while sending event:', error);
          recordEnvelopeLoss('network_error');
        },
      );

    return buffer.add(requestTask).then(
      result => result,
      error => {
        if (error instanceof SentryError) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error('Skipped sending event due to full buffer');
          recordEnvelopeLoss('queue_overflow');
          return (0,syncpromise/* resolvedSyncPromise */.WD)();
        } else {
          throw error;
        }
      },
    );
  }

  return {
    send,
    flush,
  };
}


//# sourceMappingURL=base.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/transports/fetch.js



/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */
function makeFetchTransport(
  options,
  nativeFetch = getNativeFetchImplementation(),
) {
  function makeRequest(request) {
    var requestOptions = {
      body: request.body,
      method: 'POST',
      referrerPolicy: 'origin',
      headers: options.headers,
      ...options.fetchOptions,
    };

    return nativeFetch(options.url, requestOptions).then(response => ({
      statusCode: response.status,
      headers: {
        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
        'retry-after': response.headers.get('Retry-After'),
      },
    }));
  }

  return createTransport(options, makeRequest);
}


//# sourceMappingURL=fetch.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/transports/xhr.js



/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */
var XHR_READYSTATE_DONE = 4;

/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */
function makeXHRTransport(options) {
  function makeRequest(request) {
    return new syncpromise/* SyncPromise */.cW((resolve, reject) => {
      var xhr = new XMLHttpRequest();

      xhr.onerror = reject;

      xhr.onreadystatechange = () => {
        if (xhr.readyState === XHR_READYSTATE_DONE) {
          resolve({
            statusCode: xhr.status,
            headers: {
              'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
              'retry-after': xhr.getResponseHeader('Retry-After'),
            },
          });
        }
      };

      xhr.open('POST', options.url);

      for (var header in options.headers) {
        if (Object.prototype.hasOwnProperty.call(options.headers, header)) {
          xhr.setRequestHeader(header, options.headers[header]);
        }
      }

      xhr.send(request.body);
    });
  }

  return createTransport(options, makeRequest);
}


//# sourceMappingURL=xhr.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/sdk.js
















var defaultIntegrations = [
  new InboundFilters(),
  new FunctionToString(),
  new TryCatch(),
  new Breadcrumbs(),
  new GlobalHandlers(),
  new LinkedErrors(),
  new Dedupe(),
  new HttpContext(),
];

/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */
function init(options = {}) {
  if (options.defaultIntegrations === undefined) {
    options.defaultIntegrations = defaultIntegrations;
  }
  if (options.release === undefined) {
    var window = (0,esm_global/* getGlobalObject */.R)();
    // This supports the variable that sentry-webpack-plugin injects
    if (window.SENTRY_RELEASE && window.SENTRY_RELEASE.id) {
      options.release = window.SENTRY_RELEASE.id;
    }
  }
  if (options.autoSessionTracking === undefined) {
    options.autoSessionTracking = true;
  }
  if (options.sendClientReports === undefined) {
    options.sendClientReports = true;
  }

  var clientOptions = {
    ...options,
    stackParser: (0,stacktrace/* stackParserFromStackParserOptions */.Sq)(options.stackParser || defaultStackParser),
    integrations: getIntegrationsToSetup(options),
    transport: options.transport || ((0,supports/* supportsFetch */.Ak)() ? makeFetchTransport : makeXHRTransport),
  };

  initAndBind(BrowserClient, clientOptions);

  if (options.autoSessionTracking) {
    startSessionTracking();
  }
}

/**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */
function showReportDialog(options = {}, hub = getCurrentHub()) {
  // doesn't work without a document (React Native)
  var global = getGlobalObject();
  if (!global.document) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error('Global document not defined in showReportDialog call');
    return;
  }

  const { client, scope } = hub.getStackTop();
  var dsn = options.dsn || (client && client.getDsn());
  if (!dsn) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error('DSN not configured for showReportDialog call');
    return;
  }

  if (scope) {
    options.user = {
      ...scope.getUser(),
      ...options.user,
    };
  }

  if (!options.eventId) {
    options.eventId = hub.lastEventId();
  }

  var script = global.document.createElement('script');
  script.async = true;
  script.src = getReportDialogEndpoint(dsn, options);

  if (options.onLoad) {
        script.onload = options.onLoad;
  }

  var injectionPoint = global.document.head || global.document.body;
  if (injectionPoint) {
    injectionPoint.appendChild(script);
  } else {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error('Not injecting report dialog. No injection point found in HTML');
  }
}

/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */
function lastEventId() {
  return getCurrentHub().lastEventId();
}

/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function forceLoad() {
  // Noop
}

/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function onLoad(callback) {
  callback();
}

/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */
function flush(timeout) {
  var client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();
  if (client) {
    return client.flush(timeout);
  }
  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('Cannot flush events. No client defined.');
  return (0,syncpromise/* resolvedSyncPromise */.WD)(false);
}

/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */
function sdk_close(timeout) {
  var client = getCurrentHub().getClient();
  if (client) {
    return client.close(timeout);
  }
  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn('Cannot flush events and disable SDK. No client defined.');
  return resolvedSyncPromise(false);
}

/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */
function sdk_wrap(fn) {
  return wrap$1(fn)();
}

function startSessionOnHub(hub) {
  hub.startSession({ ignoreDuration: true });
  hub.captureSession();
}

/**
 * Enable automatic Session Tracking for the initial page load.
 */
function startSessionTracking() {
  var window = (0,esm_global/* getGlobalObject */.R)();
  var document = window.document;

  if (typeof document === 'undefined') {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
    return;
  }

  var hub = (0,esm_hub/* getCurrentHub */.Gd)();

  // The only way for this to be false is for there to be a version mismatch between @sentry/browser (>= 6.0.0) and
  // @sentry/hub (< 5.27.0). In the simple case, there won't ever be such a mismatch, because the two packages are
  // pinned at the same version in package.json, but there are edge cases where it's possible. See
  // https://github.com/getsentry/sentry-javascript/issues/3207 and
  // https://github.com/getsentry/sentry-javascript/issues/3234 and
  // https://github.com/getsentry/sentry-javascript/issues/3278.
  if (!hub.captureSession) {
    return;
  }

  // The session duration for browser sessions does not track a meaningful
  // concept that can be used as a metric.
  // Automatically captured sessions are akin to page views, and thus we
  // discard their duration.
  startSessionOnHub(hub);

  // We want to create a session for every navigation as well
  (0,instrument/* addInstrumentationHandler */.o)('history', ({ from, to }) => {
    // Don't create an additional session for the initial route or if the location did not change
    if (!(from === undefined || from === to)) {
      startSessionOnHub((0,esm_hub/* getCurrentHub */.Gd)());
    }
  });
}


//# sourceMappingURL=sdk.js.map


/***/ }),

/***/ 40105:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ SDK_VERSION; }
/* harmony export */ });
var SDK_VERSION = '7.11.1';


//# sourceMappingURL=version.js.map


/***/ }),

/***/ 92876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$e": function() { return /* binding */ withScope; },
/* harmony export */   "Tb": function() { return /* binding */ captureException; },
/* harmony export */   "e": function() { return /* binding */ configureScope; }
/* harmony export */ });
/* unused harmony exports addBreadcrumb, captureEvent, captureMessage, setContext, setExtra, setExtras, setTag, setTags, setUser, startTransaction */
/* harmony import */ var _hub_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38641);


// Note: All functions in this file are typed with a return value of `ReturnType<Hub[HUB_FUNCTION]>`,
// where HUB_FUNCTION is some method on the Hub class.
//
// This is done to make sure the top level SDK methods stay in sync with the hub methods.
// Although every method here has an explicit return type, some of them (that map to void returns) do not
// contain `return` keywords. This is done to save on bundle size, as `return` is not minifiable.

/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception An exception-like object.
 * @param captureContext Additional scope data to apply to exception event.
 * @returns The generated eventId.
 */
function captureException(exception, captureContext) {
  return (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().captureException(exception, { captureContext });
}

/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param Severity Define the level of the message.
 * @returns The generated eventId.
 */
function captureMessage(
  message,
    captureContext,
) {
  // This is necessary to provide explicit scopes upgrade, without changing the original
  // arity of the `captureMessage(message, level)` method.
  var level = typeof captureContext === 'string' ? captureContext : undefined;
  var context = typeof captureContext !== 'string' ? { captureContext } : undefined;
  return getCurrentHub().captureMessage(message, level, context);
}

/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @returns The generated eventId.
 */
function captureEvent(event, hint) {
  return getCurrentHub().captureEvent(event, hint);
}

/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 */
function configureScope(callback) {
  (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().configureScope(callback);
}

/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */
function addBreadcrumb(breadcrumb) {
  getCurrentHub().addBreadcrumb(breadcrumb);
}

/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */
function setContext(name, context) {
  getCurrentHub().setContext(name, context);
}

/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */
function setExtras(extras) {
  getCurrentHub().setExtras(extras);
}

/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */
function setExtra(key, extra) {
  getCurrentHub().setExtra(key, extra);
}

/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */
function setTags(tags) {
  getCurrentHub().setTags(tags);
}

/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */
function setTag(key, value) {
  getCurrentHub().setTag(key, value);
}

/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */
function setUser(user) {
  getCurrentHub().setUser(user);
}

/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 *
 * @param callback that will be enclosed into push/popScope.
 */
function withScope(callback) {
  (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().withScope(callback);
}

/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.finish()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 */
function startTransaction(
  context,
  customSamplingContext,
) {
  return getCurrentHub().startTransaction(
    {
      metadata: { source: 'custom' },
      ...context,
    },
    customSamplingContext,
  );
}


//# sourceMappingURL=exports.js.map


/***/ }),

/***/ 38641:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gd": function() { return /* binding */ getCurrentHub; },
/* harmony export */   "cu": function() { return /* binding */ getMainCarrier; }
/* harmony export */ });
/* unused harmony exports API_VERSION, Hub, getHubFromCarrier, makeMain, setHubOnCarrier */
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62844);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21170);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12343);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82991);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92448);
/* harmony import */ var _scope_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46769);
/* harmony import */ var _session_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95771);




/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */
var API_VERSION = 4;

/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */
var DEFAULT_BREADCRUMBS = 100;

/**
 * A layer in the process stack.
 * @hidden
 */

/**
 * @inheritDoc
 */
class Hub  {
  /** Is a {@link Layer}[] containing the client and scope */
    __init() {this._stack = [{}];}

  /** Contains the last event id of a captured event.  */
  

  /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   */
   constructor(client, scope = new _scope_js__WEBPACK_IMPORTED_MODULE_0__/* .Scope */ .s(),   _version = API_VERSION) {;this._version = _version;Hub.prototype.__init.call(this);
    this.getStackTop().scope = scope;
    if (client) {
      this.bindClient(client);
    }
  }

  /**
   * @inheritDoc
   */
   isOlderThan(version) {
    return this._version < version;
  }

  /**
   * @inheritDoc
   */
   bindClient(client) {
    var top = this.getStackTop();
    top.client = client;
    if (client && client.setupIntegrations) {
      client.setupIntegrations();
    }
  }

  /**
   * @inheritDoc
   */
   pushScope() {
    // We want to clone the content of prev scope
    var scope = _scope_js__WEBPACK_IMPORTED_MODULE_0__/* .Scope.clone */ .s.clone(this.getScope());
    this.getStack().push({
      client: this.getClient(),
      scope,
    });
    return scope;
  }

  /**
   * @inheritDoc
   */
   popScope() {
    if (this.getStack().length <= 1) return false;
    return !!this.getStack().pop();
  }

  /**
   * @inheritDoc
   */
   withScope(callback) {
    var scope = this.pushScope();
    try {
      callback(scope);
    } finally {
      this.popScope();
    }
  }

  /**
   * @inheritDoc
   */
   getClient() {
    return this.getStackTop().client ;
  }

  /** Returns the scope of the top stack. */
   getScope() {
    return this.getStackTop().scope;
  }

  /** Returns the scope stack for domains or the process. */
   getStack() {
    return this._stack;
  }

  /** Returns the topmost scope layer in the order domain > local > process. */
   getStackTop() {
    return this._stack[this._stack.length - 1];
  }

  /**
   * @inheritDoc
   */
     captureException(exception, hint) {
    var eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)());
    var syntheticException = new Error('Sentry syntheticException');
    this._withClient((client, scope) => {
      client.captureException(
        exception,
        {
          originalException: exception,
          syntheticException,
          ...hint,
          event_id: eventId,
        },
        scope,
      );
    });
    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureMessage(
    message,
        level,
    hint,
  ) {
    var eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)());
    var syntheticException = new Error(message);
    this._withClient((client, scope) => {
      client.captureMessage(
        message,
        level,
        {
          originalException: message,
          syntheticException,
          ...hint,
          event_id: eventId,
        },
        scope,
      );
    });
    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureEvent(event, hint) {
    var eventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)();
    if (event.type !== 'transaction') {
      this._lastEventId = eventId;
    }

    this._withClient((client, scope) => {
      client.captureEvent(event, { ...hint, event_id: eventId }, scope);
    });
    return eventId;
  }

  /**
   * @inheritDoc
   */
   lastEventId() {
    return this._lastEventId;
  }

  /**
   * @inheritDoc
   */
   addBreadcrumb(breadcrumb, hint) {
    const { scope, client } = this.getStackTop();

    if (!scope || !client) return;

        const { beforeBreadcrumb = null, maxBreadcrumbs = DEFAULT_BREADCRUMBS } =
      (client.getOptions && client.getOptions()) || {};

    if (maxBreadcrumbs <= 0) return;

    var timestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dateTimestampInSeconds */ .yW)();
    var mergedBreadcrumb = { timestamp, ...breadcrumb };
    var finalBreadcrumb = beforeBreadcrumb
      ? ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .consoleSandbox */ .Cf)(() => beforeBreadcrumb(mergedBreadcrumb, hint)) )
      : mergedBreadcrumb;

    if (finalBreadcrumb === null) return;

    scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
  }

  /**
   * @inheritDoc
   */
   setUser(user) {
    var scope = this.getScope();
    if (scope) scope.setUser(user);
  }

  /**
   * @inheritDoc
   */
   setTags(tags) {
    var scope = this.getScope();
    if (scope) scope.setTags(tags);
  }

  /**
   * @inheritDoc
   */
   setExtras(extras) {
    var scope = this.getScope();
    if (scope) scope.setExtras(extras);
  }

  /**
   * @inheritDoc
   */
   setTag(key, value) {
    var scope = this.getScope();
    if (scope) scope.setTag(key, value);
  }

  /**
   * @inheritDoc
   */
   setExtra(key, extra) {
    var scope = this.getScope();
    if (scope) scope.setExtra(key, extra);
  }

  /**
   * @inheritDoc
   */
     setContext(name, context) {
    var scope = this.getScope();
    if (scope) scope.setContext(name, context);
  }

  /**
   * @inheritDoc
   */
   configureScope(callback) {
    const { scope, client } = this.getStackTop();
    if (scope && client) {
      callback(scope);
    }
  }

  /**
   * @inheritDoc
   */
   run(callback) {
    var oldHub = makeMain(this);
    try {
      callback(this);
    } finally {
      makeMain(oldHub);
    }
  }

  /**
   * @inheritDoc
   */
   getIntegration(integration) {
    var client = this.getClient();
    if (!client) return null;
    try {
      return client.getIntegration(integration);
    } catch (_oO) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.warn */ .kg.warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
      return null;
    }
  }

  /**
   * @inheritDoc
   */
   startTransaction(context, customSamplingContext) {
    return this._callExtensionMethod('startTransaction', context, customSamplingContext);
  }

  /**
   * @inheritDoc
   */
   traceHeaders() {
    return this._callExtensionMethod('traceHeaders');
  }

  /**
   * @inheritDoc
   */
   captureSession(endSession = false) {
    // both send the update and pull the session from the scope
    if (endSession) {
      return this.endSession();
    }

    // only send the update
    this._sendSessionUpdate();
  }

  /**
   * @inheritDoc
   */
   endSession() {
    var layer = this.getStackTop();
    var scope = layer && layer.scope;
    var session = scope && scope.getSession();
    if (session) {
      (0,_session_js__WEBPACK_IMPORTED_MODULE_4__/* .closeSession */ .RJ)(session);
    }
    this._sendSessionUpdate();

    // the session is over; take it off of the scope
    if (scope) {
      scope.setSession();
    }
  }

  /**
   * @inheritDoc
   */
   startSession(context) {
    const { scope, client } = this.getStackTop();
    const { release, environment } = (client && client.getOptions()) || {};

    // Will fetch userAgent if called from browser sdk
    var global = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .getGlobalObject */ .R)();
    const { userAgent } = global.navigator || {};

    var session = (0,_session_js__WEBPACK_IMPORTED_MODULE_4__/* .makeSession */ .Hv)({
      release,
      environment,
      ...(scope && { user: scope.getUser() }),
      ...(userAgent && { userAgent }),
      ...context,
    });

    if (scope) {
      // End existing session if there's one
      var currentSession = scope.getSession && scope.getSession();
      if (currentSession && currentSession.status === 'ok') {
        (0,_session_js__WEBPACK_IMPORTED_MODULE_4__/* .updateSession */ .CT)(currentSession, { status: 'exited' });
      }
      this.endSession();

      // Afterwards we set the new session on the scope
      scope.setSession(session);
    }

    return session;
  }

  /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   */
   shouldSendDefaultPii() {
    var client = this.getClient();
    var options = client && client.getOptions();
    return Boolean(options && options.sendDefaultPii);
  }

  /**
   * Sends the current Session on the scope
   */
   _sendSessionUpdate() {
    const { scope, client } = this.getStackTop();
    if (!scope) return;

    var session = scope.getSession();
    if (session) {
      if (client && client.captureSession) {
        client.captureSession(session);
      }
    }
  }

  /**
   * Internal helper function to call a method on the top client if it exists.
   *
   * @param method The method to call on the client.
   * @param args Arguments to pass to the client function.
   */
   _withClient(callback) {
    const { scope, client } = this.getStackTop();
    if (client) {
      callback(client, scope);
    }
  }

  /**
   * Calls global extension method and binding current instance to the function call
   */
  // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
     _callExtensionMethod(method, ...args) {
    var carrier = getMainCarrier();
    var sentry = carrier.__SENTRY__;
    if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') {
      return sentry.extensions[method].apply(this, args);
    }
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.warn */ .kg.warn(`Extension method ${method} couldn't be found, doing nothing.`);
  }
}

/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/
function getMainCarrier() {
  var carrier = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .getGlobalObject */ .R)();
  carrier.__SENTRY__ = carrier.__SENTRY__ || {
    extensions: {},
    hub: undefined,
  };
  return carrier;
}

/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 */
function makeMain(hub) {
  var registry = getMainCarrier();
  var oldHub = getHubFromCarrier(registry);
  setHubOnCarrier(registry, hub);
  return oldHub;
}

/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 */
function getCurrentHub() {
  // Get main carrier (global for every environment)
  var registry = getMainCarrier();

  // If there's no hub, or its an old API, assign a new one
  if (!hasHubOnCarrier(registry) || getHubFromCarrier(registry).isOlderThan(API_VERSION)) {
    setHubOnCarrier(registry, new Hub());
  }

  // Prefer domains over global if they are there (applicable only to Node environment)
  if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .isNodeEnv */ .KV)()) {
    return getHubFromActiveDomain(registry);
  }
  // Return hub that lives on a global object
  return getHubFromCarrier(registry);
}

/**
 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
 * @returns discovered hub
 */
function getHubFromActiveDomain(registry) {
  try {
    var sentry = getMainCarrier().__SENTRY__;
    var activeDomain = sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;

    // If there's no active domain, just return global hub
    if (!activeDomain) {
      return getHubFromCarrier(registry);
    }

    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!hasHubOnCarrier(activeDomain) || getHubFromCarrier(activeDomain).isOlderThan(API_VERSION)) {
      var registryHubTopStack = getHubFromCarrier(registry).getStackTop();
      setHubOnCarrier(activeDomain, new Hub(registryHubTopStack.client, _scope_js__WEBPACK_IMPORTED_MODULE_0__/* .Scope.clone */ .s.clone(registryHubTopStack.scope)));
    }

    // Return hub that lives on a domain
    return getHubFromCarrier(activeDomain);
  } catch (_Oo) {
    // Return hub that lives on a global object
    return getHubFromCarrier(registry);
  }
}

/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */
function hasHubOnCarrier(carrier) {
  return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}

/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */
function getHubFromCarrier(carrier) {
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .getGlobalSingleton */ .Y)('hub', () => new Hub(), carrier);
}

/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */
function setHubOnCarrier(carrier, hub) {
  if (!carrier) return false;
  var __SENTRY__ = (carrier.__SENTRY__ = carrier.__SENTRY__ || {});
  __SENTRY__.hub = hub;
  return true;
}


//# sourceMappingURL=hub.js.map


/***/ }),

/***/ 46769:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ addGlobalEventProcessor; },
/* harmony export */   "s": function() { return /* binding */ Scope; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67597);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21170);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96893);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12343);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82991);
/* harmony import */ var _session_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95771);



/**
 * Absolute maximum number of breadcrumbs added to an event.
 * The `maxBreadcrumbs` option cannot be higher than this value.
 */
var MAX_BREADCRUMBS = 100;

/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */
class Scope  {
  /** Flag if notifying is happening. */
  

  /** Callback for client to receive scope changes. */
  

  /** Callback list that will be called after {@link applyToEvent}. */
  

  /** Array of breadcrumbs. */
  

  /** User */
  

  /** Tags */
  

  /** Extra */
  

  /** Contexts */
  

  /** Attachments */
  

  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  

  /** Fingerprint */
  

  /** Severity */
    

  /** Transaction Name */
  

  /** Span */
  

  /** Session */
  

  /** Request Mode Session Status */
  

   constructor() {
    this._notifyingListeners = false;
    this._scopeListeners = [];
    this._eventProcessors = [];
    this._breadcrumbs = [];
    this._attachments = [];
    this._user = {};
    this._tags = {};
    this._extra = {};
    this._contexts = {};
    this._sdkProcessingMetadata = {};
  }

  /**
   * Inherit values from the parent scope.
   * @param scope to clone.
   */
   static clone(scope) {
    var newScope = new Scope();
    if (scope) {
      newScope._breadcrumbs = [...scope._breadcrumbs];
      newScope._tags = { ...scope._tags };
      newScope._extra = { ...scope._extra };
      newScope._contexts = { ...scope._contexts };
      newScope._user = scope._user;
      newScope._level = scope._level;
      newScope._span = scope._span;
      newScope._session = scope._session;
      newScope._transactionName = scope._transactionName;
      newScope._fingerprint = scope._fingerprint;
      newScope._eventProcessors = [...scope._eventProcessors];
      newScope._requestSession = scope._requestSession;
      newScope._attachments = [...scope._attachments];
    }
    return newScope;
  }

  /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */
   addScopeListener(callback) {
    this._scopeListeners.push(callback);
  }

  /**
   * @inheritDoc
   */
   addEventProcessor(callback) {
    this._eventProcessors.push(callback);
    return this;
  }

  /**
   * @inheritDoc
   */
   setUser(user) {
    this._user = user || {};
    if (this._session) {
      (0,_session_js__WEBPACK_IMPORTED_MODULE_0__/* .updateSession */ .CT)(this._session, { user });
    }
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getUser() {
    return this._user;
  }

  /**
   * @inheritDoc
   */
   getRequestSession() {
    return this._requestSession;
  }

  /**
   * @inheritDoc
   */
   setRequestSession(requestSession) {
    this._requestSession = requestSession;
    return this;
  }

  /**
   * @inheritDoc
   */
   setTags(tags) {
    this._tags = {
      ...this._tags,
      ...tags,
    };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setTag(key, value) {
    this._tags = { ...this._tags, [key]: value };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setExtras(extras) {
    this._extra = {
      ...this._extra,
      ...extras,
    };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setExtra(key, extra) {
    this._extra = { ...this._extra, [key]: extra };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setFingerprint(fingerprint) {
    this._fingerprint = fingerprint;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setLevel(
        level,
  ) {
    this._level = level;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setTransactionName(name) {
    this._transactionName = name;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setContext(key, context) {
    if (context === null) {
            delete this._contexts[key];
    } else {
      this._contexts = { ...this._contexts, [key]: context };
    }

    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setSpan(span) {
    this._span = span;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getSpan() {
    return this._span;
  }

  /**
   * @inheritDoc
   */
   getTransaction() {
    // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
    // have a pointer to the currently-active transaction.
    var span = this.getSpan();
    return span && span.transaction;
  }

  /**
   * @inheritDoc
   */
   setSession(session) {
    if (!session) {
      delete this._session;
    } else {
      this._session = session;
    }
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getSession() {
    return this._session;
  }

  /**
   * @inheritDoc
   */
   update(captureContext) {
    if (!captureContext) {
      return this;
    }

    if (typeof captureContext === 'function') {
      var updatedScope = (captureContext )(this);
      return updatedScope instanceof Scope ? updatedScope : this;
    }

    if (captureContext instanceof Scope) {
      this._tags = { ...this._tags, ...captureContext._tags };
      this._extra = { ...this._extra, ...captureContext._extra };
      this._contexts = { ...this._contexts, ...captureContext._contexts };
      if (captureContext._user && Object.keys(captureContext._user).length) {
        this._user = captureContext._user;
      }
      if (captureContext._level) {
        this._level = captureContext._level;
      }
      if (captureContext._fingerprint) {
        this._fingerprint = captureContext._fingerprint;
      }
      if (captureContext._requestSession) {
        this._requestSession = captureContext._requestSession;
      }
    } else if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isPlainObject */ .PO)(captureContext)) {
            captureContext = captureContext ;
      this._tags = { ...this._tags, ...captureContext.tags };
      this._extra = { ...this._extra, ...captureContext.extra };
      this._contexts = { ...this._contexts, ...captureContext.contexts };
      if (captureContext.user) {
        this._user = captureContext.user;
      }
      if (captureContext.level) {
        this._level = captureContext.level;
      }
      if (captureContext.fingerprint) {
        this._fingerprint = captureContext.fingerprint;
      }
      if (captureContext.requestSession) {
        this._requestSession = captureContext.requestSession;
      }
    }

    return this;
  }

  /**
   * @inheritDoc
   */
   clear() {
    this._breadcrumbs = [];
    this._tags = {};
    this._extra = {};
    this._user = {};
    this._contexts = {};
    this._level = undefined;
    this._transactionName = undefined;
    this._fingerprint = undefined;
    this._requestSession = undefined;
    this._span = undefined;
    this._session = undefined;
    this._notifyScopeListeners();
    this._attachments = [];
    return this;
  }

  /**
   * @inheritDoc
   */
   addBreadcrumb(breadcrumb, maxBreadcrumbs) {
    var maxCrumbs = typeof maxBreadcrumbs === 'number' ? Math.min(maxBreadcrumbs, MAX_BREADCRUMBS) : MAX_BREADCRUMBS;

    // No data has been changed, so don't notify scope listeners
    if (maxCrumbs <= 0) {
      return this;
    }

    var mergedBreadcrumb = {
      timestamp: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dateTimestampInSeconds */ .yW)(),
      ...breadcrumb,
    };
    this._breadcrumbs = [...this._breadcrumbs, mergedBreadcrumb].slice(-maxCrumbs);
    this._notifyScopeListeners();

    return this;
  }

  /**
   * @inheritDoc
   */
   clearBreadcrumbs() {
    this._breadcrumbs = [];
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   addAttachment(attachment) {
    this._attachments.push(attachment);
    return this;
  }

  /**
   * @inheritDoc
   */
   getAttachments() {
    return this._attachments;
  }

  /**
   * @inheritDoc
   */
   clearAttachments() {
    this._attachments = [];
    return this;
  }

  /**
   * Applies the current context and fingerprint to the event.
   * Note that breadcrumbs will be added by the client.
   * Also if the event has already breadcrumbs on it, we do not merge them.
   * @param event Event
   * @param hint May contain additional information about the original exception.
   * @hidden
   */
   applyToEvent(event, hint = {}) {
    if (this._extra && Object.keys(this._extra).length) {
      event.extra = { ...this._extra, ...event.extra };
    }
    if (this._tags && Object.keys(this._tags).length) {
      event.tags = { ...this._tags, ...event.tags };
    }
    if (this._user && Object.keys(this._user).length) {
      event.user = { ...this._user, ...event.user };
    }
    if (this._contexts && Object.keys(this._contexts).length) {
      event.contexts = { ...this._contexts, ...event.contexts };
    }
    if (this._level) {
      event.level = this._level;
    }
    if (this._transactionName) {
      event.transaction = this._transactionName;
    }

    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (this._span) {
      event.contexts = { trace: this._span.getTraceContext(), ...event.contexts };
      var transactionName = this._span.transaction && this._span.transaction.name;
      if (transactionName) {
        event.tags = { transaction: transactionName, ...event.tags };
      }
    }

    this._applyFingerprint(event);

    event.breadcrumbs = [...(event.breadcrumbs || []), ...this._breadcrumbs];
    event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;

    event.sdkProcessingMetadata = { ...event.sdkProcessingMetadata, ...this._sdkProcessingMetadata };

    return this._notifyEventProcessors([...getGlobalEventProcessors(), ...this._eventProcessors], event, hint);
  }

  /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */
   setSDKProcessingMetadata(newData) {
    this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...newData };

    return this;
  }

  /**
   * This will be called after {@link applyToEvent} is finished.
   */
   _notifyEventProcessors(
    processors,
    event,
    hint,
    index = 0,
  ) {
    return new _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .SyncPromise */ .cW((resolve, reject) => {
      var processor = processors[index];
      if (event === null || typeof processor !== 'function') {
        resolve(event);
      } else {
        var result = processor({ ...event }, hint) ;

        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
          processor.id &&
          result === null &&
          _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log(`Event processor "${processor.id}" dropped event`);

        if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isThenable */ .J8)(result)) {
          void result
            .then(final => this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve))
            .then(null, reject);
        } else {
          void this._notifyEventProcessors(processors, result, hint, index + 1)
            .then(resolve)
            .then(null, reject);
        }
      }
    });
  }

  /**
   * This will be called on every set call.
   */
   _notifyScopeListeners() {
    // We need this check for this._notifyingListeners to be able to work on scope during updates
    // If this check is not here we'll produce endless recursion when something is done with the scope
    // during the callback.
    if (!this._notifyingListeners) {
      this._notifyingListeners = true;
      this._scopeListeners.forEach(callback => {
        callback(this);
      });
      this._notifyingListeners = false;
    }
  }

  /**
   * Applies fingerprint from the scope to the event if there's one,
   * uses message if there's one instead or get rid of empty fingerprint
   */
   _applyFingerprint(event) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint
      ? Array.isArray(event.fingerprint)
        ? event.fingerprint
        : [event.fingerprint]
      : [];

    // If we have something on the scope, then merge it with event
    if (this._fingerprint) {
      event.fingerprint = event.fingerprint.concat(this._fingerprint);
    }

    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) {
      delete event.fingerprint;
    }
  }
}

/**
 * Returns the global event processors.
 */
function getGlobalEventProcessors() {
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .getGlobalSingleton */ .Y)('globalEventProcessors', () => []);
}

/**
 * Add a EventProcessor to be kept globally.
 * @param callback EventProcessor to add
 */
function addGlobalEventProcessor(callback) {
  getGlobalEventProcessors().push(callback);
}


//# sourceMappingURL=scope.js.map


/***/ }),

/***/ 95771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CT": function() { return /* binding */ updateSession; },
/* harmony export */   "Hv": function() { return /* binding */ makeSession; },
/* harmony export */   "RJ": function() { return /* binding */ closeSession; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21170);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62844);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20535);


/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */
function makeSession(context) {
  // Both timestamp and started are in seconds since the UNIX epoch.
  var startingTime = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .timestampInSeconds */ .ph)();

  var session = {
    sid: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)(),
    init: true,
    timestamp: startingTime,
    started: startingTime,
    duration: 0,
    status: 'ok',
    errors: 0,
    ignoreDuration: false,
    toJSON: () => sessionToJSON(session),
  };

  if (context) {
    updateSession(session, context);
  }

  return session;
}

/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */
function updateSession(session, context = {}) {
  if (context.user) {
    if (!session.ipAddress && context.user.ip_address) {
      session.ipAddress = context.user.ip_address;
    }

    if (!session.did && !context.did) {
      session.did = context.user.id || context.user.email || context.user.username;
    }
  }

  session.timestamp = context.timestamp || (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .timestampInSeconds */ .ph)();

  if (context.ignoreDuration) {
    session.ignoreDuration = context.ignoreDuration;
  }
  if (context.sid) {
    // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)();
  }
  if (context.init !== undefined) {
    session.init = context.init;
  }
  if (!session.did && context.did) {
    session.did = `${context.did}`;
  }
  if (typeof context.started === 'number') {
    session.started = context.started;
  }
  if (session.ignoreDuration) {
    session.duration = undefined;
  } else if (typeof context.duration === 'number') {
    session.duration = context.duration;
  } else {
    var duration = session.timestamp - session.started;
    session.duration = duration >= 0 ? duration : 0;
  }
  if (context.release) {
    session.release = context.release;
  }
  if (context.environment) {
    session.environment = context.environment;
  }
  if (!session.ipAddress && context.ipAddress) {
    session.ipAddress = context.ipAddress;
  }
  if (!session.userAgent && context.userAgent) {
    session.userAgent = context.userAgent;
  }
  if (typeof context.errors === 'number') {
    session.errors = context.errors;
  }
  if (context.status) {
    session.status = context.status;
  }
}

/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */
function closeSession(session, status) {
  let context = {};
  if (status) {
    context = { status };
  } else if (session.status === 'ok') {
    context = { status: 'exited' };
  }

  updateSession(session, context);
}

/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */
function sessionToJSON(session) {
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dropUndefinedKeys */ .Jr)({
    sid: `${session.sid}`,
    init: session.init,
    // Make sure that sec is converted to ms for date constructor
    started: new Date(session.started * 1000).toISOString(),
    timestamp: new Date(session.timestamp * 1000).toISOString(),
    status: session.status,
    errors: session.errors,
    did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
    duration: session.duration,
    attrs: {
      release: session.release,
      environment: session.environment,
      ip_address: session.ipAddress,
      user_agent: session.userAgent,
    },
  });
}


//# sourceMappingURL=session.js.map


/***/ }),

/***/ 62758:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ro": function() { return /* binding */ addExtensionMethods; },
  "lb": function() { return /* binding */ startIdleTransaction; }
});

// UNUSED EXPORTS: _addTracingExtensions

// EXTERNAL MODULE: ./node_modules/@sentry/hub/esm/hub.js
var hub = __webpack_require__(38641);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(12343);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(67597);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/node.js + 1 modules
var node = __webpack_require__(92448);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/instrument.js
var instrument = __webpack_require__(9732);
// EXTERNAL MODULE: ./node_modules/@sentry/tracing/esm/utils.js
var utils = __webpack_require__(63233);
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/errors.js



/**
 * Configures global error listeners
 */
function registerErrorInstrumentation() {
  (0,instrument/* addInstrumentationHandler */.o)('error', errorCallback);
  (0,instrument/* addInstrumentationHandler */.o)('unhandledrejection', errorCallback);
}

/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */
function errorCallback() {
  var activeTransaction = (0,utils/* getActiveTransaction */.x1)();
  if (activeTransaction) {
    var status = 'internal_error';
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log(`[Tracing] Transaction: ${status} -> Global error occured`);
    activeTransaction.setStatus(status);
  }
}


//# sourceMappingURL=errors.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/tracing/esm/idletransaction.js
var idletransaction = __webpack_require__(16458);
// EXTERNAL MODULE: ./node_modules/@sentry/tracing/esm/transaction.js
var esm_transaction = __webpack_require__(33391);
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/hubextensions.js
/* module decorator */ module = __webpack_require__.hmd(module);







/** Returns all trace headers that are currently on the top scope. */
function traceHeaders() {
  var scope = this.getScope();
  if (scope) {
    var span = scope.getSpan();
    if (span) {
      return {
        'sentry-trace': span.toTraceparent(),
      };
    }
  }
  return {};
}

/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * @param transaction: The transaction needing a sampling decision
 * @param options: The current client's options, so we can access `tracesSampleRate` and/or `tracesSampler`
 * @param samplingContext: Default and user-provided data which may be used to help make the decision
 *
 * @returns The given transaction with its `sampled` value set
 */
function sample(
  transaction,
  options,
  samplingContext,
) {
  // nothing to do if tracing is not enabled
  if (!(0,utils/* hasTracingEnabled */.zu)(options)) {
    transaction.sampled = false;
    return transaction;
  }

  // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
  if (transaction.sampled !== undefined) {
    transaction.setMetadata({
      transactionSampling: { method: 'explicitly_set' },
    });
    return transaction;
  }

  // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` were defined, so one of these should
  // work; prefer the hook if so
  let sampleRate;
  if (typeof options.tracesSampler === 'function') {
    sampleRate = options.tracesSampler(samplingContext);
    transaction.setMetadata({
      transactionSampling: {
        method: 'client_sampler',
        // cast to number in case it's a boolean
        rate: Number(sampleRate),
      },
    });
  } else if (samplingContext.parentSampled !== undefined) {
    sampleRate = samplingContext.parentSampled;
    transaction.setMetadata({
      transactionSampling: { method: 'inheritance' },
    });
  } else {
    sampleRate = options.tracesSampleRate;
    transaction.setMetadata({
      transactionSampling: {
        method: 'client_rate',
        // cast to number in case it's a boolean
        rate: Number(sampleRate),
      },
    });
  }

  // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
  // only valid values are booleans or numbers between 0 and 1.)
  if (!isValidSampleRate(sampleRate)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn('[Tracing] Discarding transaction because of invalid sample rate.');
    transaction.sampled = false;
    return transaction;
  }

  // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
  if (!sampleRate) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.log */.kg.log(
        `[Tracing] Discarding transaction because ${
          typeof options.tracesSampler === 'function'
            ? 'tracesSampler returned 0 or false'
            : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'
        }`,
      );
    transaction.sampled = false;
    return transaction;
  }

  // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
  // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
  transaction.sampled = Math.random() < (sampleRate );

  // if we're not going to keep it, we're done
  if (!transaction.sampled) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.log */.kg.log(
        `[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(
          sampleRate,
        )})`,
      );
    return transaction;
  }

  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log(`[Tracing] starting ${transaction.op} transaction - ${transaction.name}`);
  return transaction;
}

/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */
function isValidSampleRate(rate) {
  // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    if ((0,is/* isNaN */.i2)(rate) || !(typeof rate === 'number' || typeof rate === 'boolean')) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.warn */.kg.warn(
        `[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(
          rate,
        )} of type ${JSON.stringify(typeof rate)}.`,
      );
    return false;
  }

  // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
  if (rate < 0 || rate > 1) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.warn */.kg.warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${rate}.`);
    return false;
  }
  return true;
}

/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */
function _startTransaction(
  
  transactionContext,
  customSamplingContext,
) {
  var client = this.getClient();
  var options = (client && client.getOptions()) || {};

  let transaction = new esm_transaction/* Transaction */.Y(transactionContext, this);
  transaction = sample(transaction, options, {
    parentSampled: transactionContext.parentSampled,
    transactionContext,
    ...customSamplingContext,
  });
  if (transaction.sampled) {
    transaction.initSpanRecorder(options._experiments && (options._experiments.maxSpans ));
  }
  return transaction;
}

/**
 * Create new idle transaction.
 */
function startIdleTransaction(
  hub,
  transactionContext,
  idleTimeout,
  finalTimeout,
  onScope,
  customSamplingContext,
) {
  var client = hub.getClient();
  var options = (client && client.getOptions()) || {};

  let transaction = new idletransaction/* IdleTransaction */.io(transactionContext, hub, idleTimeout, finalTimeout, onScope);
  transaction = sample(transaction, options, {
    parentSampled: transactionContext.parentSampled,
    transactionContext,
    ...customSamplingContext,
  });
  if (transaction.sampled) {
    transaction.initSpanRecorder(options._experiments && (options._experiments.maxSpans ));
  }
  return transaction;
}

/**
 * @private
 */
function _addTracingExtensions() {
  var carrier = (0,hub/* getMainCarrier */.cu)();
  if (!carrier.__SENTRY__) {
    return;
  }
  carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
  if (!carrier.__SENTRY__.extensions.startTransaction) {
    carrier.__SENTRY__.extensions.startTransaction = _startTransaction;
  }
  if (!carrier.__SENTRY__.extensions.traceHeaders) {
    carrier.__SENTRY__.extensions.traceHeaders = traceHeaders;
  }
}

/**
 * @private
 */
function _autoloadDatabaseIntegrations() {
  var carrier = (0,hub/* getMainCarrier */.cu)();
  if (!carrier.__SENTRY__) {
    return;
  }

  var packageToIntegrationMapping = {
    mongodb() {
      var integration = (0,node/* dynamicRequire */.l$)(module, './integrations/node/mongo') 

;
      return new integration.Mongo();
    },
    mongoose() {
      var integration = (0,node/* dynamicRequire */.l$)(module, './integrations/node/mongo') 

;
      return new integration.Mongo({ mongoose: true });
    },
    mysql() {
      var integration = (0,node/* dynamicRequire */.l$)(module, './integrations/node/mysql') 

;
      return new integration.Mysql();
    },
    pg() {
      var integration = (0,node/* dynamicRequire */.l$)(module, './integrations/node/postgres') 

;
      return new integration.Postgres();
    },
  };

  var mappedPackages = Object.keys(packageToIntegrationMapping)
    .filter(moduleName => !!(0,node/* loadModule */.$y)(moduleName))
    .map(pkg => {
      try {
        return packageToIntegrationMapping[pkg]();
      } catch (e) {
        return undefined;
      }
    })
    .filter(p => p) ;

  if (mappedPackages.length > 0) {
    carrier.__SENTRY__.integrations = [...(carrier.__SENTRY__.integrations || []), ...mappedPackages];
  }
}

/**
 * This patches the global object and injects the Tracing extensions methods
 */
function addExtensionMethods() {
  _addTracingExtensions();

  // Detect and automatically load specified integrations.
  if ((0,node/* isNodeEnv */.KV)()) {
    _autoloadDatabaseIntegrations();
  }

  // If an error happens globally, we should make sure transaction status is set to error.
  registerErrorInstrumentation();
}


//# sourceMappingURL=hubextensions.js.map


/***/ }),

/***/ 16458:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "io": function() { return /* binding */ IdleTransaction; },
/* harmony export */   "mg": function() { return /* binding */ DEFAULT_FINAL_TIMEOUT; },
/* harmony export */   "nT": function() { return /* binding */ DEFAULT_IDLE_TIMEOUT; }
/* harmony export */ });
/* unused harmony exports HEARTBEAT_INTERVAL, IdleTransactionSpanRecorder */
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21170);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12343);
/* harmony import */ var _span_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55334);
/* harmony import */ var _transaction_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33391);




var DEFAULT_IDLE_TIMEOUT = 1000;
var DEFAULT_FINAL_TIMEOUT = 30000;
var HEARTBEAT_INTERVAL = 5000;

/**
 * @inheritDoc
 */
class IdleTransactionSpanRecorder extends _span_js__WEBPACK_IMPORTED_MODULE_0__/* .SpanRecorder */ .gB {
   constructor(
      _pushActivity,
      _popActivity,
     transactionSpanId,
    maxlen,
  ) {
    super(maxlen);this._pushActivity = _pushActivity;this._popActivity = _popActivity;this.transactionSpanId = transactionSpanId;;
  }

  /**
   * @inheritDoc
   */
   add(span) {
    // We should make sure we do not push and pop activities for
    // the transaction that this span recorder belongs to.
    if (span.spanId !== this.transactionSpanId) {
      // We patch span.finish() to pop an activity after setting an endTimestamp.
      span.finish = (endTimestamp) => {
        span.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)();
        this._popActivity(span.spanId);
      };

      // We should only push new activities if the span does not have an end timestamp.
      if (span.endTimestamp === undefined) {
        this._pushActivity(span.spanId);
      }
    }

    super.add(span);
  }
}

/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */
class IdleTransaction extends _transaction_js__WEBPACK_IMPORTED_MODULE_2__/* .Transaction */ .Y {
  // Activities store a list of active spans
   __init() {this.activities = {};}

  // Track state of activities in previous heartbeat
  

  // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
   __init2() {this._heartbeatCounter = 0;}

  // We should not use heartbeat if we finished a transaction
   __init3() {this._finished = false;}

    __init4() {this._beforeFinishCallbacks = [];}

  /**
   * Timer that tracks Transaction idleTimeout
   */
  

   constructor(
    transactionContext,
      _idleHub,
    /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */
      _idleTimeout = DEFAULT_IDLE_TIMEOUT,
    /**
     * The final value in ms that a transaction cannot exceed
     */
      _finalTimeout = DEFAULT_FINAL_TIMEOUT,
    // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
      _onScope = false,
  ) {
    super(transactionContext, _idleHub);this._idleHub = _idleHub;this._idleTimeout = _idleTimeout;this._finalTimeout = _finalTimeout;this._onScope = _onScope;IdleTransaction.prototype.__init.call(this);IdleTransaction.prototype.__init2.call(this);IdleTransaction.prototype.__init3.call(this);IdleTransaction.prototype.__init4.call(this);;

    if (_onScope) {
      // There should only be one active transaction on the scope
      clearActiveTransaction(_idleHub);

      // We set the transaction here on the scope so error events pick up the trace
      // context and attach it to the error.
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(`Setting idle transaction on scope. Span ID: ${this.spanId}`);
      _idleHub.configureScope(scope => scope.setSpan(this));
    }

    this._startIdleTimeout();
    setTimeout(() => {
      if (!this._finished) {
        this.setStatus('deadline_exceeded');
        this.finish();
      }
    }, this._finalTimeout);
  }

  /** {@inheritDoc} */
   finish(endTimestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)()) {
    this._finished = true;
    this.activities = {};

    if (this.spanRecorder) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] finishing IdleTransaction', new Date(endTimestamp * 1000).toISOString(), this.op);

      for (var callback of this._beforeFinishCallbacks) {
        callback(this, endTimestamp);
      }

      this.spanRecorder.spans = this.spanRecorder.spans.filter((span) => {
        // If we are dealing with the transaction itself, we just return it
        if (span.spanId === this.spanId) {
          return true;
        }

        // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
        if (!span.endTimestamp) {
          span.endTimestamp = endTimestamp;
          span.setStatus('cancelled');
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
            _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] cancelling span since transaction ended early', JSON.stringify(span, undefined, 2));
        }

        var keepSpan = span.startTimestamp < endTimestamp;
        if (!keepSpan) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
            _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(
              '[Tracing] discarding Span since it happened after Transaction was finished',
              JSON.stringify(span, undefined, 2),
            );
        }
        return keepSpan;
      });

      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] flushing IdleTransaction');
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] No active IdleTransaction');
    }

    // if `this._onScope` is `true`, the transaction put itself on the scope when it started
    if (this._onScope) {
      clearActiveTransaction(this._idleHub);
    }

    return super.finish(endTimestamp);
  }

  /**
   * Register a callback function that gets excecuted before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */
   registerBeforeFinishCallback(callback) {
    this._beforeFinishCallbacks.push(callback);
  }

  /**
   * @inheritDoc
   */
   initSpanRecorder(maxlen) {
    if (!this.spanRecorder) {
      var pushActivity = (id) => {
        if (this._finished) {
          return;
        }
        this._pushActivity(id);
      };
      var popActivity = (id) => {
        if (this._finished) {
          return;
        }
        this._popActivity(id);
      };

      this.spanRecorder = new IdleTransactionSpanRecorder(pushActivity, popActivity, this.spanId, maxlen);

      // Start heartbeat so that transactions do not run forever.
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('Starting heartbeat');
      this._pingHeartbeat();
    }
    this.spanRecorder.add(this);
  }

  /**
   * Cancels the existing idletimeout, if there is one
   */
   _cancelIdleTimeout() {
    if (this._idleTimeoutID) {
      clearTimeout(this._idleTimeoutID);
      this._idleTimeoutID = undefined;
    }
  }

  /**
   * Creates an idletimeout
   */
   _startIdleTimeout(endTimestamp) {
    this._cancelIdleTimeout();
    this._idleTimeoutID = setTimeout(() => {
      if (!this._finished && Object.keys(this.activities).length === 0) {
        this.finish(endTimestamp);
      }
    }, this._idleTimeout);
  }

  /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */
   _pushActivity(spanId) {
    this._cancelIdleTimeout();
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(`[Tracing] pushActivity: ${spanId}`);
    this.activities[spanId] = true;
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] new activities count', Object.keys(this.activities).length);
  }

  /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */
   _popActivity(spanId) {
    if (this.activities[spanId]) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(`[Tracing] popActivity ${spanId}`);
            delete this.activities[spanId];
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] new activities count', Object.keys(this.activities).length);
    }

    if (Object.keys(this.activities).length === 0) {
      // We need to add the timeout here to have the real endtimestamp of the transaction
      // Remember timestampWithMs is in seconds, timeout is in ms
      var endTimestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)() + this._idleTimeout / 1000;
      this._startIdleTimeout(endTimestamp);
    }
  }

  /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */
   _beat() {
    // We should not be running heartbeat if the idle transaction is finished.
    if (this._finished) {
      return;
    }

    var heartbeatString = Object.keys(this.activities).join('');

    if (heartbeatString === this._prevHeartbeatString) {
      this._heartbeatCounter += 1;
    } else {
      this._heartbeatCounter = 1;
    }

    this._prevHeartbeatString = heartbeatString;

    if (this._heartbeatCounter >= 3) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] Transaction finished because of no change for 3 heart beats');
      this.setStatus('deadline_exceeded');
      this.finish();
    } else {
      this._pingHeartbeat();
    }
  }

  /**
   * Pings the heartbeat
   */
   _pingHeartbeat() {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`);
    setTimeout(() => {
      this._beat();
    }, HEARTBEAT_INTERVAL);
  }
}

/**
 * Reset transaction on scope to `undefined`
 */
function clearActiveTransaction(hub) {
  var scope = hub.getScope();
  if (scope) {
    var transaction = scope.getTransaction();
    if (transaction) {
      scope.setSpan(undefined);
    }
  }
}


//# sourceMappingURL=idletransaction.js.map


/***/ }),

/***/ 55334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dr": function() { return /* binding */ Span; },
/* harmony export */   "gB": function() { return /* binding */ SpanRecorder; }
/* harmony export */ });
/* unused harmony export spanStatusfromHttpCode */
/* harmony import */ var _sentry_utils_esm_buildPolyfills__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45375);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62844);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21170);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12343);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20535);



/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */
class SpanRecorder {
   __init() {this.spans = [];}

   constructor(maxlen = 1000) {;SpanRecorder.prototype.__init.call(this);
    this._maxlen = maxlen;
  }

  /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */
   add(span) {
    if (this.spans.length > this._maxlen) {
      span.spanRecorder = undefined;
    } else {
      this.spans.push(span);
    }
  }
}

/**
 * Span contains all data about a span
 */
class Span  {
  /**
   * @inheritDoc
   */
   __init2() {this.traceId = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .uuid4 */ .DM)();}

  /**
   * @inheritDoc
   */
   __init3() {this.spanId = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .uuid4 */ .DM)().substring(16);}

  /**
   * @inheritDoc
   */
  

  /**
   * Internal keeper of the status
   */
  

  /**
   * @inheritDoc
   */
  

  /**
   * Timestamp in seconds when the span was created.
   */
   __init4() {this.startTimestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)();}

  /**
   * Timestamp in seconds when the span ended.
   */
  

  /**
   * @inheritDoc
   */
  

  /**
   * @inheritDoc
   */
  

  /**
   * @inheritDoc
   */
   __init5() {this.tags = {};}

  /**
   * @inheritDoc
   */
     __init6() {this.data = {};}

  /**
   * List of spans that were finalized
   */
  

  /**
   * @inheritDoc
   */
  

  /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */
   constructor(spanContext) {;Span.prototype.__init2.call(this);Span.prototype.__init3.call(this);Span.prototype.__init4.call(this);Span.prototype.__init5.call(this);Span.prototype.__init6.call(this);
    if (!spanContext) {
      return this;
    }
    if (spanContext.traceId) {
      this.traceId = spanContext.traceId;
    }
    if (spanContext.spanId) {
      this.spanId = spanContext.spanId;
    }
    if (spanContext.parentSpanId) {
      this.parentSpanId = spanContext.parentSpanId;
    }
    // We want to include booleans as well here
    if ('sampled' in spanContext) {
      this.sampled = spanContext.sampled;
    }
    if (spanContext.op) {
      this.op = spanContext.op;
    }
    if (spanContext.description) {
      this.description = spanContext.description;
    }
    if (spanContext.data) {
      this.data = spanContext.data;
    }
    if (spanContext.tags) {
      this.tags = spanContext.tags;
    }
    if (spanContext.status) {
      this.status = spanContext.status;
    }
    if (spanContext.startTimestamp) {
      this.startTimestamp = spanContext.startTimestamp;
    }
    if (spanContext.endTimestamp) {
      this.endTimestamp = spanContext.endTimestamp;
    }
  }

  /**
   * @inheritDoc
   */
   startChild(
    spanContext,
  ) {
    var childSpan = new Span({
      ...spanContext,
      parentSpanId: this.spanId,
      sampled: this.sampled,
      traceId: this.traceId,
    });

    childSpan.spanRecorder = this.spanRecorder;
    if (childSpan.spanRecorder) {
      childSpan.spanRecorder.add(childSpan);
    }

    childSpan.transaction = this.transaction;

    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && childSpan.transaction) {
      var opStr = (spanContext && spanContext.op) || '< unknown op >';
      var nameStr = childSpan.transaction.name || '< unknown name >';
      var idStr = childSpan.transaction.spanId;

      var logMessage = `[Tracing] Starting '${opStr}' span on transaction '${nameStr}' (${idStr}).`;
      childSpan.transaction.metadata.spanMetadata[childSpan.spanId] = { logMessage };
      _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.log */ .kg.log(logMessage);
    }

    return childSpan;
  }

  /**
   * @inheritDoc
   */
   setTag(key, value) {
    this.tags = { ...this.tags, [key]: value };
    return this;
  }

  /**
   * @inheritDoc
   */
     setData(key, value) {
    this.data = { ...this.data, [key]: value };
    return this;
  }

  /**
   * @inheritDoc
   */
   setStatus(value) {
    this.status = value;
    return this;
  }

  /**
   * @inheritDoc
   */
   setHttpStatus(httpStatus) {
    this.setTag('http.status_code', String(httpStatus));
    var spanStatus = spanStatusfromHttpCode(httpStatus);
    if (spanStatus !== 'unknown_error') {
      this.setStatus(spanStatus);
    }
    return this;
  }

  /**
   * @inheritDoc
   */
   isSuccess() {
    return this.status === 'ok';
  }

  /**
   * @inheritDoc
   */
   finish(endTimestamp) {
    if (
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      // Don't call this for transactions
      this.transaction &&
      this.transaction.spanId !== this.spanId
    ) {
      const { logMessage } = this.transaction.metadata.spanMetadata[this.spanId];
      if (logMessage) {
        _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.log */ .kg.log((logMessage ).replace('Starting', 'Finishing'));
      }
    }

    this.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)();
  }

  /**
   * @inheritDoc
   */
   toTraceparent() {
    let sampledString = '';
    if (this.sampled !== undefined) {
      sampledString = this.sampled ? '-1' : '-0';
    }
    return `${this.traceId}-${this.spanId}${sampledString}`;
  }

  /**
   * @inheritDoc
   */
   toContext() {
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .dropUndefinedKeys */ .Jr)({
      data: this.data,
      description: this.description,
      endTimestamp: this.endTimestamp,
      op: this.op,
      parentSpanId: this.parentSpanId,
      sampled: this.sampled,
      spanId: this.spanId,
      startTimestamp: this.startTimestamp,
      status: this.status,
      tags: this.tags,
      traceId: this.traceId,
    });
  }

  /**
   * @inheritDoc
   */
   updateWithContext(spanContext) {
    this.data = (0,_sentry_utils_esm_buildPolyfills__WEBPACK_IMPORTED_MODULE_4__/* ._nullishCoalesce */ .h)(spanContext.data, () => ( {}));
    this.description = spanContext.description;
    this.endTimestamp = spanContext.endTimestamp;
    this.op = spanContext.op;
    this.parentSpanId = spanContext.parentSpanId;
    this.sampled = spanContext.sampled;
    this.spanId = (0,_sentry_utils_esm_buildPolyfills__WEBPACK_IMPORTED_MODULE_4__/* ._nullishCoalesce */ .h)(spanContext.spanId, () => ( this.spanId));
    this.startTimestamp = (0,_sentry_utils_esm_buildPolyfills__WEBPACK_IMPORTED_MODULE_4__/* ._nullishCoalesce */ .h)(spanContext.startTimestamp, () => ( this.startTimestamp));
    this.status = spanContext.status;
    this.tags = (0,_sentry_utils_esm_buildPolyfills__WEBPACK_IMPORTED_MODULE_4__/* ._nullishCoalesce */ .h)(spanContext.tags, () => ( {}));
    this.traceId = (0,_sentry_utils_esm_buildPolyfills__WEBPACK_IMPORTED_MODULE_4__/* ._nullishCoalesce */ .h)(spanContext.traceId, () => ( this.traceId));

    return this;
  }

  /**
   * @inheritDoc
   */
   getTraceContext()

 {
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .dropUndefinedKeys */ .Jr)({
      data: Object.keys(this.data).length > 0 ? this.data : undefined,
      description: this.description,
      op: this.op,
      parent_span_id: this.parentSpanId,
      span_id: this.spanId,
      status: this.status,
      tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
      trace_id: this.traceId,
    });
  }

  /**
   * @inheritDoc
   */
   toJSON()

 {
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .dropUndefinedKeys */ .Jr)({
      data: Object.keys(this.data).length > 0 ? this.data : undefined,
      description: this.description,
      op: this.op,
      parent_span_id: this.parentSpanId,
      span_id: this.spanId,
      start_timestamp: this.startTimestamp,
      status: this.status,
      tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
      timestamp: this.endTimestamp,
      trace_id: this.traceId,
    });
  }
}

/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */
function spanStatusfromHttpCode(httpStatus) {
  if (httpStatus < 400 && httpStatus >= 100) {
    return 'ok';
  }

  if (httpStatus >= 400 && httpStatus < 500) {
    switch (httpStatus) {
      case 401:
        return 'unauthenticated';
      case 403:
        return 'permission_denied';
      case 404:
        return 'not_found';
      case 409:
        return 'already_exists';
      case 413:
        return 'failed_precondition';
      case 429:
        return 'resource_exhausted';
      default:
        return 'invalid_argument';
    }
  }

  if (httpStatus >= 500 && httpStatus < 600) {
    switch (httpStatus) {
      case 501:
        return 'unimplemented';
      case 503:
        return 'unavailable';
      case 504:
        return 'deadline_exceeded';
      default:
        return 'internal_error';
    }
  }

  return 'unknown_error';
}


//# sourceMappingURL=span.js.map


/***/ }),

/***/ 33391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ Transaction; }
/* harmony export */ });
/* harmony import */ var _sentry_utils_esm_buildPolyfills__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45375);
/* harmony import */ var _sentry_hub__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38641);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12343);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20535);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99181);
/* harmony import */ var _span_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55334);





/** JSDoc */
class Transaction extends _span_js__WEBPACK_IMPORTED_MODULE_0__/* .Span */ .Dr  {
  

  /**
   * The reference to the current hub.
   */
  

   __init() {this._measurements = {};}

  /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   */
   constructor(transactionContext, hub) {
    super(transactionContext);Transaction.prototype.__init.call(this);;

    this._hub = hub || (0,_sentry_hub__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentHub */ .Gd)();

    this._name = transactionContext.name || '';

    this.metadata = {
      ...transactionContext.metadata,
      spanMetadata: {},
    };

    this._trimEnd = transactionContext.trimEnd;

    // this is because transactions are also spans, and spans have a transaction pointer
    this.transaction = this;
  }

  /** Getter for `name` property */
   get name() {
    return this._name;
  }

  /** Setter for `name` property, which also sets `source` */
   set name(newName) {
    this._name = newName;
    this.metadata.source = 'custom';
  }

  /**
   * JSDoc
   */
   setName(name, source = 'custom') {
    this.name = name;
    this.metadata.source = source;
  }

  /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */
   initSpanRecorder(maxlen = 1000) {
    if (!this.spanRecorder) {
      this.spanRecorder = new _span_js__WEBPACK_IMPORTED_MODULE_0__/* .SpanRecorder */ .gB(maxlen);
    }
    this.spanRecorder.add(this);
  }

  /**
   * @inheritDoc
   */
   setMeasurement(name, value, unit = '') {
    this._measurements[name] = { value, unit };
  }

  /**
   * @inheritDoc
   */
   setMetadata(newMetadata) {
    this.metadata = { ...this.metadata, ...newMetadata };
  }

  /**
   * @inheritDoc
   */
   finish(endTimestamp) {
    // This transaction is already finished, so we should not flush it again.
    if (this.endTimestamp !== undefined) {
      return undefined;
    }

    if (!this.name) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.warn */ .kg.warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
      this.name = '<unlabeled transaction>';
    }

    // just sets the end timestamp
    super.finish(endTimestamp);

    if (this.sampled !== true) {
      // At this point if `sampled !== true` we want to discard the transaction.
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.log */ .kg.log('[Tracing] Discarding transaction because its trace was not chosen to be sampled.');

      var client = this._hub.getClient();
      if (client) {
        client.recordDroppedEvent('sample_rate', 'transaction');
      }

      return undefined;
    }

    var finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter(s => s !== this && s.endTimestamp) : [];

    if (this._trimEnd && finishedSpans.length > 0) {
      this.endTimestamp = finishedSpans.reduce((prev, current) => {
        if (prev.endTimestamp && current.endTimestamp) {
          return prev.endTimestamp > current.endTimestamp ? prev : current;
        }
        return prev;
      }).endTimestamp;
    }

    var metadata = this.metadata;

    var transaction = {
      contexts: {
        trace: this.getTraceContext(),
      },
      spans: finishedSpans,
      start_timestamp: this.startTimestamp,
      tags: this.tags,
      timestamp: this.endTimestamp,
      transaction: this.name,
      type: 'transaction',
      sdkProcessingMetadata: {
        ...metadata,
        baggage: this.getBaggage(),
      },
      ...(metadata.source && {
        transaction_info: {
          source: metadata.source,
        },
      }),
    };

    var hasMeasurements = Object.keys(this._measurements).length > 0;

    if (hasMeasurements) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.log */ .kg.log(
          '[Measurements] Adding measurements to transaction',
          JSON.stringify(this._measurements, undefined, 2),
        );
      transaction.measurements = this._measurements;
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.log */ .kg.log(`[Tracing] Finishing ${this.op} transaction: ${this.name}.`);

    return this._hub.captureEvent(transaction);
  }

  /**
   * @inheritDoc
   */
   toContext() {
    var spanContext = super.toContext();

    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .dropUndefinedKeys */ .Jr)({
      ...spanContext,
      name: this.name,
      trimEnd: this._trimEnd,
    });
  }

  /**
   * @inheritDoc
   */
   updateWithContext(transactionContext) {
    super.updateWithContext(transactionContext);

    this.name = (0,_sentry_utils_esm_buildPolyfills__WEBPACK_IMPORTED_MODULE_4__/* ._nullishCoalesce */ .h)(transactionContext.name, () => ( ''));

    this._trimEnd = transactionContext.trimEnd;

    return this;
  }

  /**
   * @inheritdoc
   *
   * @experimental
   */
   getBaggage() {
    var existingBaggage = this.metadata.baggage;

    // Only add Sentry baggage items to baggage, if baggage does not exist yet or it is still
    // empty and mutable
    var finalBaggage =
      !existingBaggage || (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .isBaggageMutable */ .Gp)(existingBaggage)
        ? this._populateBaggageWithSentryValues(existingBaggage)
        : existingBaggage;

    // Update the baggage stored on the transaction.
    this.metadata.baggage = finalBaggage;

    return finalBaggage;
  }

  /**
   * Collects and adds data to the passed baggage object.
   *
   * Note: This function does not explicitly check if the passed baggage object is allowed
   * to be modified. Implicitly, `setBaggageValue` will not make modification to the object
   * if it was already set immutable.
   *
   * After adding the data, the baggage object is set immutable to prevent further modifications.
   *
   * @param baggage
   *
   * @returns modified and immutable baggage object
   */
   _populateBaggageWithSentryValues(baggage = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .createBaggage */ .Hn)({})) {
    var hub = this._hub || (0,_sentry_hub__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentHub */ .Gd)();
    var client = hub && hub.getClient();

    if (!client) return baggage;

    const { environment, release } = client.getOptions() || {};
    const { publicKey: public_key } = client.getDsn() || {};

    var sample_rate =
      this.metadata &&
      this.metadata.transactionSampling &&
      this.metadata.transactionSampling.rate &&
      this.metadata.transactionSampling.rate.toString();

    var scope = hub.getScope();
    const { segment: user_segment } = (scope && scope.getUser()) || {};

    var source = this.metadata.source;
    var transaction = source && source !== 'url' ? this.name : undefined;

    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .createBaggage */ .Hn)(
      (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .dropUndefinedKeys */ .Jr)({
        environment,
        release,
        transaction,
        user_segment,
        public_key,
        trace_id: this.traceId,
        sample_rate,
        ...(0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .getSentryBaggageItems */ .Hk)(baggage), // keep user-added values
      } ),
      '',
      false, // set baggage immutable
    );
  }
}


//# sourceMappingURL=transaction.js.map


/***/ }),

/***/ 63233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "XL": function() { return /* binding */ msToSec; },
/* harmony export */   "x1": function() { return /* binding */ getActiveTransaction; },
/* harmony export */   "zu": function() { return /* binding */ hasTracingEnabled; }
/* harmony export */ });
/* unused harmony export secToMs */
/* harmony import */ var _sentry_hub__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38641);



/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */
function hasTracingEnabled(
  maybeOptions,
) {
  var client = (0,_sentry_hub__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().getClient();
  var options = maybeOptions || (client && client.getOptions());
  return !!options && ('tracesSampleRate' in options || 'tracesSampler' in options);
}

/** Grabs active transaction off scope, if any */
function getActiveTransaction(maybeHub) {
  var hub = maybeHub || (0,_sentry_hub__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)();
  var scope = hub.getScope();
  return scope && (scope.getTransaction() );
}

/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */
function msToSec(time) {
  return time / 1000;
}

/**
 * Converts from seconds to milliseconds
 * @param time time in seconds
 */
function secToMs(time) {
  return time * 1000;
}


//# sourceMappingURL=utils.js.map


/***/ }),

/***/ 99181:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gp": function() { return /* binding */ isBaggageMutable; },
/* harmony export */   "Hk": function() { return /* binding */ getSentryBaggageItems; },
/* harmony export */   "Hn": function() { return /* binding */ createBaggage; },
/* harmony export */   "J8": function() { return /* binding */ mergeAndSerializeBaggage; },
/* harmony export */   "XM": function() { return /* binding */ parseBaggageHeader; },
/* harmony export */   "bU": function() { return /* binding */ BAGGAGE_HEADER_NAME; },
/* harmony export */   "rg": function() { return /* binding */ parseBaggageSetMutability; }
/* harmony export */ });
/* unused harmony exports MAX_BAGGAGE_STRING_LENGTH, SENTRY_BAGGAGE_KEY_PREFIX, SENTRY_BAGGAGE_KEY_PREFIX_REGEX, getBaggageValue, getThirdPartyBaggage, isSentryBaggageEmpty, serializeBaggage, setBaggageImmutable, setBaggageValue */
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67597);
/* harmony import */ var _logger_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12343);



var BAGGAGE_HEADER_NAME = 'baggage';

var SENTRY_BAGGAGE_KEY_PREFIX = 'sentry-';

var SENTRY_BAGGAGE_KEY_PREFIX_REGEX = /^sentry-/;

/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */
var MAX_BAGGAGE_STRING_LENGTH = 8192;

/** Create an instance of Baggage */
function createBaggage(initItems, baggageString = '', mutable = true) {
  return [{ ...initItems }, baggageString, mutable];
}

/** Get a value from baggage */
function getBaggageValue(baggage, key) {
  return baggage[0][key];
}

/** Add a value to baggage */
function setBaggageValue(baggage, key, value) {
  if (isBaggageMutable(baggage)) {
    baggage[0][key] = value;
  }
}

/** Check if the Sentry part of the passed baggage (i.e. the first element in the tuple) is empty */
function isSentryBaggageEmpty(baggage) {
  return Object.keys(baggage[0]).length === 0;
}

/** Returns Sentry specific baggage values */
function getSentryBaggageItems(baggage) {
  return baggage[0];
}

/**
 * Returns 3rd party baggage string of @param baggage
 * @param baggage
 */
function getThirdPartyBaggage(baggage) {
  return baggage[1];
}

/**
 * Checks if baggage is mutable
 * @param baggage
 * @returns true if baggage is mutable, else false
 */
function isBaggageMutable(baggage) {
  return baggage[2];
}

/**
 * Sets the passed baggage immutable
 * @param baggage
 */
function setBaggageImmutable(baggage) {
  baggage[2] = false;
}

/** Serialize a baggage object */
function serializeBaggage(baggage) {
  return Object.keys(baggage[0]).reduce((prev, key) => {
    var val = baggage[0][key] ;
    var baggageEntry = `${SENTRY_BAGGAGE_KEY_PREFIX}${encodeURIComponent(key)}=${encodeURIComponent(val)}`;
    var newVal = prev === '' ? baggageEntry : `${prev},${baggageEntry}`;
    if (newVal.length > MAX_BAGGAGE_STRING_LENGTH) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        _logger_js__WEBPACK_IMPORTED_MODULE_0__/* .logger.warn */ .kg.warn(`Not adding key: ${key} with val: ${val} to baggage due to exceeding baggage size limits.`);
      return prev;
    } else {
      return newVal;
    }
  }, baggage[1]);
}

/**
 * Parse a baggage header from a string or a string array and return a Baggage object
 *
 * If @param includeThirdPartyEntries is set to true, third party baggage entries are added to the Baggage object
 * (This is necessary for merging potentially pre-existing baggage headers in outgoing requests with
 * our `sentry-` values)
 */
function parseBaggageHeader(
  inputBaggageValue,
  includeThirdPartyEntries = false,
) {
  // Adding this check here because we got reports of this function failing due to the input value
  // not being a string. This debug log might help us determine what's going on here.
  if ((!Array.isArray(inputBaggageValue) && !(0,_is_js__WEBPACK_IMPORTED_MODULE_1__/* .isString */ .HD)(inputBaggageValue)) || typeof inputBaggageValue === 'number') {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      _logger_js__WEBPACK_IMPORTED_MODULE_0__/* .logger.warn */ .kg.warn(
        '[parseBaggageHeader] Received input value of incompatible type: ',
        typeof inputBaggageValue,
        inputBaggageValue,
      );

    // Gonna early-return an empty baggage object so that we don't fail later on
    return createBaggage({}, '');
  }

  var baggageEntries = ((0,_is_js__WEBPACK_IMPORTED_MODULE_1__/* .isString */ .HD)(inputBaggageValue) ? inputBaggageValue : inputBaggageValue.join(','))
    .split(',')
    .map(entry => entry.trim())
    .filter(entry => entry !== '' && (includeThirdPartyEntries || SENTRY_BAGGAGE_KEY_PREFIX_REGEX.test(entry)));

  return baggageEntries.reduce(
    ([baggageObj, baggageString], curr) => {
      const [key, val] = curr.split('=');
      if (SENTRY_BAGGAGE_KEY_PREFIX_REGEX.test(key)) {
        var baggageKey = decodeURIComponent(key.split('-')[1]);
        return [
          {
            ...baggageObj,
            [baggageKey]: decodeURIComponent(val),
          },
          baggageString,
          true,
        ];
      } else {
        return [baggageObj, baggageString === '' ? curr : `${baggageString},${curr}`, true];
      }
    },
    [{}, '', true],
  );
}

/**
 * Merges the baggage header we saved from the incoming request (or meta tag) with
 * a possibly created or modified baggage header by a third party that's been added
 * to the outgoing request header.
 *
 * In case @param headerBaggageString exists, we can safely add the the 3rd party part of @param headerBaggage
 * with our @param incomingBaggage. This is possible because if we modified anything beforehand,
 * it would only affect parts of the sentry baggage (@see Baggage interface).
 *
 * @param incomingBaggage the baggage header of the incoming request that might contain sentry entries
 * @param thirdPartyBaggageHeader possibly existing baggage header string or string[] added from a third
 *        party to the request headers
 *
 * @return a merged and serialized baggage string to be propagated with the outgoing request
 */
function mergeAndSerializeBaggage(incomingBaggage, thirdPartyBaggageHeader) {
  if (!incomingBaggage && !thirdPartyBaggageHeader) {
    return '';
  }

  var headerBaggage = (thirdPartyBaggageHeader && parseBaggageHeader(thirdPartyBaggageHeader, true)) || undefined;
  var thirdPartyHeaderBaggage = headerBaggage && getThirdPartyBaggage(headerBaggage);

  var finalBaggage = createBaggage((incomingBaggage && incomingBaggage[0]) || {}, thirdPartyHeaderBaggage || '');
  return serializeBaggage(finalBaggage);
}

/**
 * Helper function that takes a raw baggage string (if available) and the processed sentry-trace header
 * data (if available), parses the baggage string and creates a Baggage object
 * If there is no baggage string, it will create an empty Baggage object.
 * In a second step, this functions determines if the created Baggage object should be set immutable
 * to prevent mutation of the Sentry data.
 *
 * Extracted this logic to a function because it's duplicated in a lot of places.
 *
 * @param rawBaggageValue
 * @param sentryTraceHeader
 */
function parseBaggageSetMutability(
  rawBaggageValue,
  sentryTraceHeader,
) {
  var baggage = parseBaggageHeader(rawBaggageValue || '');

  // Because we are always creating a Baggage object by calling `parseBaggageHeader` above
  // (either a filled one or an empty one, even if we didn't get a `baggage` header),
  // we only need to check if we have a sentry-trace header or not. As soon as we have it,
  // we set baggage immutable. In case we don't get a sentry-trace header, we can assume that
  // this SDK is the head of the trace and thus we still permit mutation at this time.
  // There is one exception though, which is that we get a baggage-header with `sentry-`
  // items but NO sentry-trace header. In this case we also set the baggage immutable for now
  // but if smoething like this would ever happen, we should revisit this and determine
  // what this would actually mean for the trace (i.e. is this SDK the head?, what happened
  // before that we don't have a sentry-trace header?, etc)
  (sentryTraceHeader || !isSentryBaggageEmpty(baggage)) && setBaggageImmutable(baggage);

  return baggage;
}


//# sourceMappingURL=baggage.js.map


/***/ }),

/***/ 58464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ htmlTreeAsString; },
/* harmony export */   "l": function() { return /* binding */ getLocationHref; }
/* harmony export */ });
/* harmony import */ var _global_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82991);
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);



/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function htmlTreeAsString(elem, keyAttrs) {
  

  // try/catch both:
  // - accessing event.target (see getsentry/raven-js#838, #768)
  // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
  // - can throw an exception in some circumstances.
  try {
    let currentElem = elem ;
    var MAX_TRAVERSE_HEIGHT = 5;
    var MAX_OUTPUT_LEN = 80;
    var out = [];
    let height = 0;
    let len = 0;
    var separator = ' > ';
    var sepLength = separator.length;
    let nextStr;

        while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
      nextStr = _htmlElementAsString(currentElem, keyAttrs);
      // bail out if
      // - nextStr is the 'html' element
      // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
      //   (ignore this limit if we are on the first iteration)
      if (nextStr === 'html' || (height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN)) {
        break;
      }

      out.push(nextStr);

      len += nextStr.length;
      currentElem = currentElem.parentNode;
    }

    return out.reverse().join(separator);
  } catch (_oO) {
    return '<unknown>';
  }
}

/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function _htmlElementAsString(el, keyAttrs) {
  var elem = el 

;

  var out = [];
  let className;
  let classes;
  let key;
  let attr;
  let i;

  if (!elem || !elem.tagName) {
    return '';
  }

  out.push(elem.tagName.toLowerCase());

  // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
  var keyAttrPairs =
    keyAttrs && keyAttrs.length
      ? keyAttrs.filter(keyAttr => elem.getAttribute(keyAttr)).map(keyAttr => [keyAttr, elem.getAttribute(keyAttr)])
      : null;

  if (keyAttrPairs && keyAttrPairs.length) {
    keyAttrPairs.forEach(keyAttrPair => {
      out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
  } else {
    if (elem.id) {
      out.push(`#${elem.id}`);
    }

        className = elem.className;
    if (className && (0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(className)) {
      classes = className.split(/\s+/);
      for (i = 0; i < classes.length; i++) {
        out.push(`.${classes[i]}`);
      }
    }
  }
  var allowedAttrs = ['type', 'name', 'title', 'alt'];
  for (i = 0; i < allowedAttrs.length; i++) {
    key = allowedAttrs[i];
    attr = elem.getAttribute(key);
    if (attr) {
      out.push(`[${key}="${attr}"]`);
    }
  }
  return out.join('');
}

/**
 * A safe form of location.href
 */
function getLocationHref() {
  var global = (0,_global_js__WEBPACK_IMPORTED_MODULE_1__/* .getGlobalObject */ .R)();
  try {
    return global.document.location.href;
  } catch (oO) {
    return '';
  }
}


//# sourceMappingURL=browser.js.map


/***/ }),

/***/ 45375:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ _nullishCoalesce; }
/* harmony export */ });
/**
 * Polyfill for the nullish coalescing operator (`??`).
 *
 * Note that the RHS is wrapped in a function so that if it's a computed value, that evaluation won't happen unless the
 * LHS evaluates to a nullish value, to mimic the operator's short-circuiting behavior.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 *
 * @param lhs The value of the expression to the left of the `??`
 * @param rhsFn A function returning the value of the expression to the right of the `??`
 * @returns The LHS value, unless it's `null` or `undefined`, in which case, the RHS value
 */
function _nullishCoalesce(lhs, rhsFn) {
  // by checking for loose equality to `null`, we catch both `null` and `undefined`
  return lhs != null ? lhs : rhsFn();
}

// Sucrase version:
// function _nullishCoalesce(lhs, rhsFn) {
//   if (lhs != null) {
//     return lhs;
//   } else {
//     return rhsFn();
//   }
// }


//# sourceMappingURL=_nullishCoalesce.js.map


/***/ }),

/***/ 82991:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ getGlobalObject; },
/* harmony export */   "Y": function() { return /* binding */ getGlobalSingleton; }
/* harmony export */ });
/* harmony import */ var _node_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92448);


/** Internal */

var fallbackGlobalObject = {};

/**
 * Safely get global scope object
 *
 * @returns Global scope object
 */
function getGlobalObject() {
  return (
    (0,_node_js__WEBPACK_IMPORTED_MODULE_0__/* .isNodeEnv */ .KV)()
      ? __webpack_require__.g
      : typeof window !== 'undefined'       ? window       : typeof self !== 'undefined'
      ? self
      : fallbackGlobalObject
  ) ;
}

/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `getGlobalObject`'s return value
 * @returns the singleton
 */
function getGlobalSingleton(name, creator, obj) {
  var global = (obj || getGlobalObject()) ;
  var __SENTRY__ = (global.__SENTRY__ = global.__SENTRY__ || {});
  var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
  return singleton;
}


//# sourceMappingURL=global.js.map


/***/ }),

/***/ 9732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ addInstrumentationHandler; }
/* harmony export */ });
/* harmony import */ var _global_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82991);
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67597);
/* harmony import */ var _logger_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12343);
/* harmony import */ var _object_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20535);
/* harmony import */ var _stacktrace_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30360);
/* harmony import */ var _supports_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8823);







var global = (0,_global_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)();

/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */

var handlers = {};
var instrumented = {};

/** Instruments given API */
function instrument(type) {
  if (instrumented[type]) {
    return;
  }

  instrumented[type] = true;

  switch (type) {
    case 'console':
      instrumentConsole();
      break;
    case 'dom':
      instrumentDOM();
      break;
    case 'xhr':
      instrumentXHR();
      break;
    case 'fetch':
      instrumentFetch();
      break;
    case 'history':
      instrumentHistory();
      break;
    case 'error':
      instrumentError();
      break;
    case 'unhandledrejection':
      instrumentUnhandledRejection();
      break;
    default:
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _logger_js__WEBPACK_IMPORTED_MODULE_1__/* .logger.warn */ .kg.warn('unknown instrumentation type:', type);
      return;
  }
}

/**
 * Add handler that will be called when given type of instrumentation triggers.
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addInstrumentationHandler(type, callback) {
  handlers[type] = handlers[type] || [];
  (handlers[type] ).push(callback);
  instrument(type);
}

/** JSDoc */
function triggerHandlers(type, data) {
  if (!type || !handlers[type]) {
    return;
  }

  for (var handler of handlers[type] || []) {
    try {
      handler(data);
    } catch (e) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        _logger_js__WEBPACK_IMPORTED_MODULE_1__/* .logger.error */ .kg.error(
          `Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0,_stacktrace_js__WEBPACK_IMPORTED_MODULE_2__/* .getFunctionName */ .$P)(handler)}\nError:`,
          e,
        );
    }
  }
}

/** JSDoc */
function instrumentConsole() {
  if (!('console' in global)) {
    return;
  }

  _logger_js__WEBPACK_IMPORTED_MODULE_1__/* .CONSOLE_LEVELS.forEach */ .RU.forEach(function (level) {
    if (!(level in global.console)) {
      return;
    }

    (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(global.console, level, function (originalConsoleMethod) {
      return function (...args) {
        triggerHandlers('console', { args, level });

        // this fails for some browsers. :(
        if (originalConsoleMethod) {
          originalConsoleMethod.apply(global.console, args);
        }
      };
    });
  });
}

/** JSDoc */
function instrumentFetch() {
  if (!(0,_supports_js__WEBPACK_IMPORTED_MODULE_4__/* .supportsNativeFetch */ .t$)()) {
    return;
  }

  (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(global, 'fetch', function (originalFetch) {
    return function (...args) {
      var handlerData = {
        args,
        fetchData: {
          method: getFetchMethod(args),
          url: getFetchUrl(args),
        },
        startTimestamp: Date.now(),
      };

      triggerHandlers('fetch', {
        ...handlerData,
      });

            return originalFetch.apply(global, args).then(
        (response) => {
          triggerHandlers('fetch', {
            ...handlerData,
            endTimestamp: Date.now(),
            response,
          });
          return response;
        },
        (error) => {
          triggerHandlers('fetch', {
            ...handlerData,
            endTimestamp: Date.now(),
            error,
          });
          // NOTE: If you are a Sentry user, and you are seeing this stack frame,
          //       it means the sentry.javascript SDK caught an error invoking your application code.
          //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
          throw error;
        },
      );
    };
  });
}

/** Extract `method` from fetch call arguments */
function getFetchMethod(fetchArgs = []) {
  if ('Request' in global && (0,_is_js__WEBPACK_IMPORTED_MODULE_5__/* .isInstanceOf */ .V9)(fetchArgs[0], Request) && fetchArgs[0].method) {
    return String(fetchArgs[0].method).toUpperCase();
  }
  if (fetchArgs[1] && fetchArgs[1].method) {
    return String(fetchArgs[1].method).toUpperCase();
  }
  return 'GET';
}

/** Extract `url` from fetch call arguments */
function getFetchUrl(fetchArgs = []) {
  if (typeof fetchArgs[0] === 'string') {
    return fetchArgs[0];
  }
  if ('Request' in global && (0,_is_js__WEBPACK_IMPORTED_MODULE_5__/* .isInstanceOf */ .V9)(fetchArgs[0], Request)) {
    return fetchArgs[0].url;
  }
  return String(fetchArgs[0]);
}

/** JSDoc */
function instrumentXHR() {
  if (!('XMLHttpRequest' in global)) {
    return;
  }

  var xhrproto = XMLHttpRequest.prototype;

  (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(xhrproto, 'open', function (originalOpen) {
    return function ( ...args) {
            var xhr = this;
      var url = args[1];
      var xhrInfo = (xhr.__sentry_xhr__ = {
                method: (0,_is_js__WEBPACK_IMPORTED_MODULE_5__/* .isString */ .HD)(args[0]) ? args[0].toUpperCase() : args[0],
        url: args[1],
      });

      // if Sentry key appears in URL, don't capture it as a request
            if ((0,_is_js__WEBPACK_IMPORTED_MODULE_5__/* .isString */ .HD)(url) && xhrInfo.method === 'POST' && url.match(/sentry_key/)) {
        xhr.__sentry_own_request__ = true;
      }

      var onreadystatechangeHandler = function () {
        if (xhr.readyState === 4) {
          try {
            // touching statusCode in some platforms throws
            // an exception
            xhrInfo.status_code = xhr.status;
          } catch (e) {
            /* do nothing */
          }

          triggerHandlers('xhr', {
            args,
            endTimestamp: Date.now(),
            startTimestamp: Date.now(),
            xhr,
          });
        }
      };

      if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') {
        (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(xhr, 'onreadystatechange', function (original) {
          return function (...readyStateArgs) {
            onreadystatechangeHandler();
            return original.apply(xhr, readyStateArgs);
          };
        });
      } else {
        xhr.addEventListener('readystatechange', onreadystatechangeHandler);
      }

      return originalOpen.apply(xhr, args);
    };
  });

  (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(xhrproto, 'send', function (originalSend) {
    return function ( ...args) {
      if (this.__sentry_xhr__ && args[0] !== undefined) {
        this.__sentry_xhr__.body = args[0];
      }

      triggerHandlers('xhr', {
        args,
        startTimestamp: Date.now(),
        xhr: this,
      });

      return originalSend.apply(this, args);
    };
  });
}

let lastHref;

/** JSDoc */
function instrumentHistory() {
  if (!(0,_supports_js__WEBPACK_IMPORTED_MODULE_4__/* .supportsHistory */ .Bf)()) {
    return;
  }

  var oldOnPopState = global.onpopstate;
  global.onpopstate = function ( ...args) {
    var to = global.location.href;
    // keep track of the current URL state, as we always receive only the updated state
    var from = lastHref;
    lastHref = to;
    triggerHandlers('history', {
      from,
      to,
    });
    if (oldOnPopState) {
      // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
      // https://github.com/getsentry/sentry-javascript/issues/3344
      // https://github.com/bugsnag/bugsnag-js/issues/469
      try {
        return oldOnPopState.apply(this, args);
      } catch (_oO) {
        // no-empty
      }
    }
  };

  /** @hidden */
  function historyReplacementFunction(originalHistoryFunction) {
    return function ( ...args) {
      var url = args.length > 2 ? args[2] : undefined;
      if (url) {
        // coerce to string (this is what pushState does)
        var from = lastHref;
        var to = String(url);
        // keep track of the current URL state, as we always receive only the updated state
        lastHref = to;
        triggerHandlers('history', {
          from,
          to,
        });
      }
      return originalHistoryFunction.apply(this, args);
    };
  }

  (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(global.history, 'pushState', historyReplacementFunction);
  (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(global.history, 'replaceState', historyReplacementFunction);
}

var debounceDuration = 1000;
let debounceTimerID;
let lastCapturedEvent;

/**
 * Decide whether the current event should finish the debounce of previously captured one.
 * @param previous previously captured event
 * @param current event to be captured
 */
function shouldShortcircuitPreviousDebounce(previous, current) {
  // If there was no previous event, it should always be swapped for the new one.
  if (!previous) {
    return true;
  }

  // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
  if (previous.type !== current.type) {
    return true;
  }

  try {
    // If both events have the same type, it's still possible that actions were performed on different targets.
    // e.g. 2 clicks on different buttons.
    if (previous.target !== current.target) {
      return true;
    }
  } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
  }

  // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
  // to which an event listener was attached), we treat them as the same action, as we want to capture
  // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
  return false;
}

/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */
function shouldSkipDOMEvent(event) {
  // We are only interested in filtering `keypress` events for now.
  if (event.type !== 'keypress') {
    return false;
  }

  try {
    var target = event.target ;

    if (!target || !target.tagName) {
      return true;
    }

    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
      return false;
    }
  } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
  }

  return true;
}

/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param handler function that will be triggered
 * @param globalListener indicates whether event was captured by the global event listener
 * @returns wrapped breadcrumb events handler
 * @hidden
 */
function makeDOMEventHandler(handler, globalListener = false) {
  return (event) => {
    // It's possible this handler might trigger multiple times for the same
    // event (e.g. event propagation through node ancestors).
    // Ignore if we've already captured that event.
    if (!event || lastCapturedEvent === event) {
      return;
    }

    // We always want to skip _some_ events.
    if (shouldSkipDOMEvent(event)) {
      return;
    }

    var name = event.type === 'keypress' ? 'input' : event.type;

    // If there is no debounce timer, it means that we can safely capture the new event and store it for future comparisons.
    if (debounceTimerID === undefined) {
      handler({
        event: event,
        name,
        global: globalListener,
      });
      lastCapturedEvent = event;
    }
    // If there is a debounce awaiting, see if the new event is different enough to treat it as a unique one.
    // If that's the case, emit the previous event and store locally the newly-captured DOM event.
    else if (shouldShortcircuitPreviousDebounce(lastCapturedEvent, event)) {
      handler({
        event: event,
        name,
        global: globalListener,
      });
      lastCapturedEvent = event;
    }

    // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
    clearTimeout(debounceTimerID);
    debounceTimerID = global.setTimeout(() => {
      debounceTimerID = undefined;
    }, debounceDuration);
  };
}

/** JSDoc */
function instrumentDOM() {
  if (!('document' in global)) {
    return;
  }

  // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
  // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
  // we instrument `addEventListener` so that we don't end up attaching this handler twice.
  var triggerDOMHandler = triggerHandlers.bind(null, 'dom');
  var globalDOMEventHandler = makeDOMEventHandler(triggerDOMHandler, true);
  global.document.addEventListener('click', globalDOMEventHandler, false);
  global.document.addEventListener('keypress', globalDOMEventHandler, false);

  // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
  // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
  // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
  // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
  // guaranteed to fire at least once.)
  ['EventTarget', 'Node'].forEach((target) => {
        var proto = (global )[target] && (global )[target].prototype;
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
      return;
    }

    (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(proto, 'addEventListener', function (originalAddEventListener) {
      return function (
        
        type,
        listener,
        options,
      ) {
        if (type === 'click' || type == 'keypress') {
          try {
            var el = this ;
            var handlers = (el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {});
            var handlerForType = (handlers[type] = handlers[type] || { refCount: 0 });

            if (!handlerForType.handler) {
              var handler = makeDOMEventHandler(triggerDOMHandler);
              handlerForType.handler = handler;
              originalAddEventListener.call(this, type, handler, options);
            }

            handlerForType.refCount += 1;
          } catch (e) {
            // Accessing dom properties is always fragile.
            // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
          }
        }

        return originalAddEventListener.call(this, type, listener, options);
      };
    });

    (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(
      proto,
      'removeEventListener',
      function (originalRemoveEventListener) {
        return function (
          
          type,
          listener,
          options,
        ) {
          if (type === 'click' || type == 'keypress') {
            try {
              var el = this ;
              var handlers = el.__sentry_instrumentation_handlers__ || {};
              var handlerForType = handlers[type];

              if (handlerForType) {
                handlerForType.refCount -= 1;
                // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                if (handlerForType.refCount <= 0) {
                  originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                  handlerForType.handler = undefined;
                  delete handlers[type];                 }

                // If there are no longer any custom handlers of any type on this element, cleanup everything.
                if (Object.keys(handlers).length === 0) {
                  delete el.__sentry_instrumentation_handlers__;
                }
              }
            } catch (e) {
              // Accessing dom properties is always fragile.
              // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
            }
          }

          return originalRemoveEventListener.call(this, type, listener, options);
        };
      },
    );
  });
}

let _oldOnErrorHandler = null;
/** JSDoc */
function instrumentError() {
  _oldOnErrorHandler = global.onerror;

  global.onerror = function (msg, url, line, column, error) {
    triggerHandlers('error', {
      column,
      error,
      line,
      msg,
      url,
    });

    if (_oldOnErrorHandler) {
            return _oldOnErrorHandler.apply(this, arguments);
    }

    return false;
  };
}

let _oldOnUnhandledRejectionHandler = null;
/** JSDoc */
function instrumentUnhandledRejection() {
  _oldOnUnhandledRejectionHandler = global.onunhandledrejection;

  global.onunhandledrejection = function (e) {
    triggerHandlers('unhandledrejection', e);

    if (_oldOnUnhandledRejectionHandler) {
            return _oldOnUnhandledRejectionHandler.apply(this, arguments);
    }

    return true;
  };
}


//# sourceMappingURL=instrument.js.map


/***/ }),

/***/ 67597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cy": function() { return /* binding */ isSyntheticEvent; },
/* harmony export */   "HD": function() { return /* binding */ isString; },
/* harmony export */   "J8": function() { return /* binding */ isThenable; },
/* harmony export */   "Kj": function() { return /* binding */ isRegExp; },
/* harmony export */   "PO": function() { return /* binding */ isPlainObject; },
/* harmony export */   "TX": function() { return /* binding */ isDOMError; },
/* harmony export */   "V9": function() { return /* binding */ isInstanceOf; },
/* harmony export */   "VW": function() { return /* binding */ isErrorEvent; },
/* harmony export */   "VZ": function() { return /* binding */ isError; },
/* harmony export */   "cO": function() { return /* binding */ isEvent; },
/* harmony export */   "fm": function() { return /* binding */ isDOMException; },
/* harmony export */   "i2": function() { return /* binding */ isNaN; },
/* harmony export */   "kK": function() { return /* binding */ isElement; },
/* harmony export */   "pt": function() { return /* binding */ isPrimitive; }
/* harmony export */ });
var objectToString = Object.prototype.toString;

/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isError(wat) {
  switch (objectToString.call(wat)) {
    case '[object Error]':
    case '[object Exception]':
    case '[object DOMException]':
      return true;
    default:
      return isInstanceOf(wat, Error);
  }
}

function isBuiltin(wat, ty) {
  return objectToString.call(wat) === `[object ${ty}]`;
}

/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isErrorEvent(wat) {
  return isBuiltin(wat, 'ErrorEvent');
}

/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMError(wat) {
  return isBuiltin(wat, 'DOMError');
}

/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMException(wat) {
  return isBuiltin(wat, 'DOMException');
}

/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isString(wat) {
  return isBuiltin(wat, 'String');
}

/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPrimitive(wat) {
  return wat === null || (typeof wat !== 'object' && typeof wat !== 'function');
}

/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPlainObject(wat) {
  return isBuiltin(wat, 'Object');
}

/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isEvent(wat) {
  return typeof Event !== 'undefined' && isInstanceOf(wat, Event);
}

/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isElement(wat) {
  return typeof Element !== 'undefined' && isInstanceOf(wat, Element);
}

/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isRegExp(wat) {
  return isBuiltin(wat, 'RegExp');
}

/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */
function isThenable(wat) {
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}

/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isSyntheticEvent(wat) {
  return isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}

/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isNaN(wat) {
  return typeof wat === 'number' && wat !== wat;
}

/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */
function isInstanceOf(wat, base) {
  try {
    return wat instanceof base;
  } catch (_e) {
    return false;
  }
}


//# sourceMappingURL=is.js.map


/***/ }),

/***/ 12343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cf": function() { return /* binding */ consoleSandbox; },
/* harmony export */   "RU": function() { return /* binding */ CONSOLE_LEVELS; },
/* harmony export */   "kg": function() { return /* binding */ logger; }
/* harmony export */ });
/* harmony import */ var _global_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82991);


// TODO: Implement different loggers for different environments
var global = (0,_global_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)();

/** Prefix for logging strings */
var PREFIX = 'Sentry Logger ';

var CONSOLE_LEVELS = ['debug', 'info', 'warn', 'error', 'log', 'assert', 'trace'] ;

/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */
function consoleSandbox(callback) {
  var global = (0,_global_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)();

  if (!('console' in global)) {
    return callback();
  }

  var originalConsole = global.console ;
  var wrappedLevels = {};

  // Restore all wrapped console methods
  CONSOLE_LEVELS.forEach(level => {
    // TODO(v7): Remove this check as it's only needed for Node 6
    var originalWrappedFunc =
      originalConsole[level] && (originalConsole[level] ).__sentry_original__;
    if (level in global.console && originalWrappedFunc) {
      wrappedLevels[level] = originalConsole[level] ;
      originalConsole[level] = originalWrappedFunc ;
    }
  });

  try {
    return callback();
  } finally {
    // Revert restoration to wrapped state
    Object.keys(wrappedLevels).forEach(level => {
      originalConsole[level] = wrappedLevels[level ];
    });
  }
}

function makeLogger() {
  let enabled = false;
  var logger = {
    enable: () => {
      enabled = true;
    },
    disable: () => {
      enabled = false;
    },
  };

  if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
    CONSOLE_LEVELS.forEach(name => {
            logger[name] = (...args) => {
        if (enabled) {
          consoleSandbox(() => {
            global.console[name](`${PREFIX}[${name}]:`, ...args);
          });
        }
      };
    });
  } else {
    CONSOLE_LEVELS.forEach(name => {
      logger[name] = () => undefined;
    });
  }

  return logger ;
}

// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
let logger;
if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
  logger = (0,_global_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalSingleton */ .Y)('logger', makeLogger);
} else {
  logger = makeLogger();
}


//# sourceMappingURL=logger.js.map


/***/ }),

/***/ 62844:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DM": function() { return /* binding */ uuid4; },
/* harmony export */   "Db": function() { return /* binding */ addExceptionTypeValue; },
/* harmony export */   "EG": function() { return /* binding */ addExceptionMechanism; },
/* harmony export */   "YO": function() { return /* binding */ checkOrSetAlreadyCaught; },
/* harmony export */   "jH": function() { return /* binding */ getEventDescription; }
/* harmony export */ });
/* unused harmony exports addContextToFrame, parseSemver */
/* harmony import */ var _global_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82991);
/* harmony import */ var _object_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20535);




/**
 * Extended Window interface that allows for Crypto API usage in IE browsers
 */

/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */
function uuid4() {
  var global = (0,_global_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)() ;
  var crypto = (global.crypto || global.msCrypto) ;

  if (crypto && crypto.randomUUID) {
    return crypto.randomUUID().replace(/-/g, '');
  }

  var getRandomByte =
    crypto && crypto.getRandomValues ? () => crypto.getRandomValues(new Uint8Array(1))[0] : () => Math.random() * 16;

  // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
  // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
  return (([1e7] ) + 1e3 + 4e3 + 8e3 + 1e11).replace(/[018]/g, c =>
        ((c ) ^ ((getRandomByte() & 15) >> ((c ) / 4))).toString(16),
  );
}

function getFirstException(event) {
  return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}

/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */
function getEventDescription(event) {
  const { message, event_id: eventId } = event;
  if (message) {
    return message;
  }

  var firstException = getFirstException(event);
  if (firstException) {
    if (firstException.type && firstException.value) {
      return `${firstException.type}: ${firstException.value}`;
    }
    return firstException.type || firstException.value || eventId || '<unknown>';
  }
  return eventId || '<unknown>';
}

/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */
function addExceptionTypeValue(event, value, type) {
  var exception = (event.exception = event.exception || {});
  var values = (exception.values = exception.values || []);
  var firstException = (values[0] = values[0] || {});
  if (!firstException.value) {
    firstException.value = value || '';
  }
  if (!firstException.type) {
    firstException.type = type || 'Error';
  }
}

/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */
function addExceptionMechanism(event, newMechanism) {
  var firstException = getFirstException(event);
  if (!firstException) {
    return;
  }

  var defaultMechanism = { type: 'generic', handled: true };
  var currentMechanism = firstException.mechanism;
  firstException.mechanism = { ...defaultMechanism, ...currentMechanism, ...newMechanism };

  if (newMechanism && 'data' in newMechanism) {
    var mergedData = { ...(currentMechanism && currentMechanism.data), ...newMechanism.data };
    firstException.mechanism.data = mergedData;
  }
}

// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var SEMVER_REGEXP =
  /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;

/**
 * Represents Semantic Versioning object
 */

/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */
function parseSemver(input) {
  var match = input.match(SEMVER_REGEXP) || [];
  var major = parseInt(match[1], 10);
  var minor = parseInt(match[2], 10);
  var patch = parseInt(match[3], 10);
  return {
    buildmetadata: match[5],
    major: isNaN(major) ? undefined : major,
    minor: isNaN(minor) ? undefined : minor,
    patch: isNaN(patch) ? undefined : patch,
    prerelease: match[4],
  };
}

/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */
function addContextToFrame(lines, frame, linesOfContext = 5) {
  var lineno = frame.lineno || 0;
  var maxLines = lines.length;
  var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);

  frame.pre_context = lines
    .slice(Math.max(0, sourceLine - linesOfContext), sourceLine)
    .map((line) => snipLine(line, 0));

  frame.context_line = snipLine(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);

  frame.post_context = lines
    .slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext)
    .map((line) => snipLine(line, 0));
}

/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */
function checkOrSetAlreadyCaught(exception) {
    if (exception && (exception ).__sentry_captured__) {
    return true;
  }

  try {
    // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
    // `ExtraErrorData` integration
    (0,_object_js__WEBPACK_IMPORTED_MODULE_1__/* .addNonEnumerableProperty */ .xp)(exception , '__sentry_captured__', true);
  } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
  }

  return false;
}


//# sourceMappingURL=misc.js.map


/***/ }),

/***/ 92448:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l$": function() { return /* binding */ dynamicRequire; },
  "KV": function() { return /* binding */ isNodeEnv; },
  "$y": function() { return /* binding */ loadModule; }
});

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/env.js
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */

/**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */
function isBrowserBundle() {
  return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}


//# sourceMappingURL=env.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/node.js
/* module decorator */ module = __webpack_require__.hmd(module);
/* provided dependency */ var process = __webpack_require__(34155);


/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */

/**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */
function isNodeEnv() {
  // explicitly check for browser bundles as those can be optimized statically
  // by terser/rollup.
  return (
    !isBrowserBundle() &&
    Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]'
  );
}

/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */
function dynamicRequire(mod, request) {
    return mod.require(request);
}

/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */
function loadModule(moduleName) {
  let mod;

  try {
    mod = dynamicRequire(module, moduleName);
  } catch (e) {
    // no-empty
  }

  try {
    const { cwd } = dynamicRequire(module, 'process');
    mod = dynamicRequire(module, `${cwd()}/node_modules/${moduleName}`) ;
  } catch (e) {
    // no-empty
  }

  return mod;
}


//# sourceMappingURL=node.js.map


/***/ }),

/***/ 20535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$Q": function() { return /* binding */ markFunctionWrapped; },
/* harmony export */   "HK": function() { return /* binding */ getOriginalFunction; },
/* harmony export */   "Jr": function() { return /* binding */ dropUndefinedKeys; },
/* harmony export */   "Sh": function() { return /* binding */ convertToPlainObject; },
/* harmony export */   "_j": function() { return /* binding */ urlEncode; },
/* harmony export */   "hl": function() { return /* binding */ fill; },
/* harmony export */   "xp": function() { return /* binding */ addNonEnumerableProperty; },
/* harmony export */   "zf": function() { return /* binding */ extractExceptionKeysForMessage; }
/* harmony export */ });
/* unused harmony export objectify */
/* harmony import */ var _browser_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58464);
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);
/* harmony import */ var _string_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57321);




/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */
function fill(source, name, replacementFactory) {
  if (!(name in source)) {
    return;
  }

  var original = source[name] ;
  var wrapped = replacementFactory(original) ;

  // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
  // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
  if (typeof wrapped === 'function') {
    try {
      markFunctionWrapped(wrapped, original);
    } catch (_Oo) {
      // This can throw if multiple fill happens on a global object like XMLHttpRequest
      // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
  }

  source[name] = wrapped;
}

/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */
function addNonEnumerableProperty(obj, name, value) {
  Object.defineProperty(obj, name, {
    // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
    value: value,
    writable: true,
    configurable: true,
  });
}

/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */
function markFunctionWrapped(wrapped, original) {
  var proto = original.prototype || {};
  wrapped.prototype = original.prototype = proto;
  addNonEnumerableProperty(wrapped, '__sentry_original__', original);
}

/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */
function getOriginalFunction(func) {
  return func.__sentry_original__;
}

/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */
function urlEncode(object) {
  return Object.keys(object)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`)
    .join('&');
}

/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */
function convertToPlainObject(
  value,
)

 {
  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isError */ .VZ)(value)) {
    return {
      message: value.message,
      name: value.name,
      stack: value.stack,
      ...getOwnProperties(value),
    };
  } else if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isEvent */ .cO)(value)) {
    var newObj

 = {
      type: value.type,
      target: serializeEventTarget(value.target),
      currentTarget: serializeEventTarget(value.currentTarget),
      ...getOwnProperties(value),
    };

    if (typeof CustomEvent !== 'undefined' && (0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isInstanceOf */ .V9)(value, CustomEvent)) {
      newObj.detail = value.detail;
    }

    return newObj;
  } else {
    return value;
  }
}

/** Creates a string representation of the target of an `Event` object */
function serializeEventTarget(target) {
  try {
    return (0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isElement */ .kK)(target) ? (0,_browser_js__WEBPACK_IMPORTED_MODULE_1__/* .htmlTreeAsString */ .R)(target) : Object.prototype.toString.call(target);
  } catch (_oO) {
    return '<unknown>';
  }
}

/** Filters out all but an object's own properties */
function getOwnProperties(obj) {
  if (typeof obj === 'object' && obj !== null) {
    var extractedProps = {};
    for (var property in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, property)) {
        extractedProps[property] = (obj )[property];
      }
    }
    return extractedProps;
  } else {
    return {};
  }
}

/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */
function extractExceptionKeysForMessage(exception, maxLength = 40) {
  var keys = Object.keys(convertToPlainObject(exception));
  keys.sort();

  if (!keys.length) {
    return '[object has no keys]';
  }

  if (keys[0].length >= maxLength) {
    return (0,_string_js__WEBPACK_IMPORTED_MODULE_2__/* .truncate */ .$G)(keys[0], maxLength);
  }

  for (let includedKeys = keys.length; includedKeys > 0; includedKeys--) {
    var serialized = keys.slice(0, includedKeys).join(', ');
    if (serialized.length > maxLength) {
      continue;
    }
    if (includedKeys === keys.length) {
      return serialized;
    }
    return (0,_string_js__WEBPACK_IMPORTED_MODULE_2__/* .truncate */ .$G)(serialized, maxLength);
  }

  return '';
}

/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */
function dropUndefinedKeys(inputValue) {
  // This map keeps track of what already visited nodes map to.
  // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
  // references as the input object.
  var memoizationMap = new Map();

  // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
  return _dropUndefinedKeys(inputValue, memoizationMap);
}

function _dropUndefinedKeys(inputValue, memoizationMap) {
  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isPlainObject */ .PO)(inputValue)) {
    // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
    var memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) {
      return memoVal ;
    }

    var returnValue = {};
    // Store the mapping of this value in case we visit it again, in case of circular data
    memoizationMap.set(inputValue, returnValue);

    for (var key of Object.keys(inputValue)) {
      if (typeof inputValue[key] !== 'undefined') {
        returnValue[key] = _dropUndefinedKeys(inputValue[key], memoizationMap);
      }
    }

    return returnValue ;
  }

  if (Array.isArray(inputValue)) {
    // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
    var memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) {
      return memoVal ;
    }

    var returnValue = [];
    // Store the mapping of this value in case we visit it again, in case of circular data
    memoizationMap.set(inputValue, returnValue);

    inputValue.forEach((item) => {
      returnValue.push(_dropUndefinedKeys(item, memoizationMap));
    });

    return returnValue ;
  }

  return inputValue;
}

/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */
function objectify(wat) {
  let objectified;
  switch (true) {
    case wat === undefined || wat === null:
      objectified = new String(wat);
      break;

    // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
    // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
    // an object in order to wrap it.
    case typeof wat === 'symbol' || typeof wat === 'bigint':
      objectified = Object(wat);
      break;

    // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
    case isPrimitive(wat):
            objectified = new (wat ).constructor(wat);
      break;

    // by process of elimination, at this point we know that `wat` must already be an object
    default:
      objectified = wat;
      break;
  }
  return objectified;
}


//# sourceMappingURL=object.js.map


/***/ }),

/***/ 30360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$P": function() { return /* binding */ getFunctionName; },
/* harmony export */   "Sq": function() { return /* binding */ stackParserFromStackParserOptions; },
/* harmony export */   "pE": function() { return /* binding */ createStackParser; }
/* harmony export */ });
/* unused harmony exports nodeStackLineParser, stripSentryFramesAndReverse */


var STACKTRACE_LIMIT = 50;

/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */
function createStackParser(...parsers) {
  var sortedParsers = parsers.sort((a, b) => a[0] - b[0]).map(p => p[1]);

  return (stack, skipFirst = 0) => {
    var frames = [];

    for (var line of stack.split('\n').slice(skipFirst)) {
      // https://github.com/getsentry/sentry-javascript/issues/5459
      // Remove webpack (error: *) wrappers
      var cleanedLine = line.replace(/\(error: (.*)\)/, '$1');

      for (var parser of sortedParsers) {
        var frame = parser(cleanedLine);

        if (frame) {
          frames.push(frame);
          break;
        }
      }
    }

    return stripSentryFramesAndReverse(frames);
  };
}

/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */
function stackParserFromStackParserOptions(stackParser) {
  if (Array.isArray(stackParser)) {
    return createStackParser(...stackParser);
  }
  return stackParser;
}

/**
 * @hidden
 */
function stripSentryFramesAndReverse(stack) {
  if (!stack.length) {
    return [];
  }

  let localStack = stack;

  var firstFrameFunction = localStack[0].function || '';
  var lastFrameFunction = localStack[localStack.length - 1].function || '';

  // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
  if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) {
    localStack = localStack.slice(1);
  }

  // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
  if (lastFrameFunction.indexOf('sentryWrapped') !== -1) {
    localStack = localStack.slice(0, -1);
  }

  // The frame where the crash happened, should be the last entry in the array
  return localStack
    .slice(0, STACKTRACE_LIMIT)
    .map(frame => ({
      ...frame,
      filename: frame.filename || localStack[0].filename,
      function: frame.function || '?',
    }))
    .reverse();
}

var defaultFunctionName = '<anonymous>';

/**
 * Safely extract function name from itself
 */
function getFunctionName(fn) {
  try {
    if (!fn || typeof fn !== 'function') {
      return defaultFunctionName;
    }
    return fn.name || defaultFunctionName;
  } catch (e) {
    // Just accessing custom props in some Selenium environments
    // can cause a "Permission denied" exception (see raven-js#495).
    return defaultFunctionName;
  }
}

function node(getModule) {
  var FILENAME_MATCH = /^\s*[-]{4,}$/;
  var FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;

    return (line) => {
    if (line.match(FILENAME_MATCH)) {
      return {
        filename: line,
      };
    }

    var lineMatch = line.match(FULL_MATCH);
    if (!lineMatch) {
      return undefined;
    }

    let object;
    let method;
    let functionName;
    let typeName;
    let methodName;

    if (lineMatch[1]) {
      functionName = lineMatch[1];

      let methodStart = functionName.lastIndexOf('.');
      if (functionName[methodStart - 1] === '.') {
                methodStart--;
      }

      if (methodStart > 0) {
        object = functionName.substr(0, methodStart);
        method = functionName.substr(methodStart + 1);
        var objectEnd = object.indexOf('.Module');
        if (objectEnd > 0) {
          functionName = functionName.substr(objectEnd + 1);
          object = object.substr(0, objectEnd);
        }
      }
      typeName = undefined;
    }

    if (method) {
      typeName = object;
      methodName = method;
    }

    if (method === '<anonymous>') {
      methodName = undefined;
      functionName = undefined;
    }

    if (functionName === undefined) {
      methodName = methodName || '<anonymous>';
      functionName = typeName ? `${typeName}.${methodName}` : methodName;
    }

    var filename = _optionalChain([lineMatch, 'access', _ => _[2], 'optionalAccess', _2 => _2.startsWith, 'call', _3 => _3('file://')]) ? lineMatch[2].substr(7) : lineMatch[2];
    var isNative = lineMatch[5] === 'native';
    var isInternal =
      isNative || (filename && !filename.startsWith('/') && !filename.startsWith('.') && filename.indexOf(':\\') !== 1);

    // in_app is all that's not an internal Node function or a module within node_modules
    // note that isNative appears to return true even for node core libraries
    // see https://github.com/getsentry/raven-node/issues/176
    var in_app = !isInternal && filename !== undefined && !filename.includes('node_modules/');

    return {
      filename,
      module: _optionalChain([getModule, 'optionalCall', _4 => _4(filename)]),
      function: functionName,
      lineno: parseInt(lineMatch[3], 10) || undefined,
      colno: parseInt(lineMatch[4], 10) || undefined,
      in_app,
    };
  };
}

/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */
function nodeStackLineParser(getModule) {
  return [90, node(getModule)];
}


//# sourceMappingURL=stacktrace.js.map


/***/ }),

/***/ 57321:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$G": function() { return /* binding */ truncate; },
/* harmony export */   "nK": function() { return /* binding */ safeJoin; },
/* harmony export */   "zC": function() { return /* binding */ isMatchingPattern; }
/* harmony export */ });
/* unused harmony exports escapeStringForRegex, snipLine */
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);


/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */
function truncate(str, max = 0) {
  if (typeof str !== 'string' || max === 0) {
    return str;
  }
  return str.length <= max ? str : `${str.substr(0, max)}...`;
}

/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */
function snipLine(line, colno) {
  let newLine = line;
  var lineLength = newLine.length;
  if (lineLength <= 150) {
    return newLine;
  }
  if (colno > lineLength) {
        colno = lineLength;
  }

  let start = Math.max(colno - 60, 0);
  if (start < 5) {
    start = 0;
  }

  let end = Math.min(start + 140, lineLength);
  if (end > lineLength - 5) {
    end = lineLength;
  }
  if (end === lineLength) {
    start = Math.max(end - 140, 0);
  }

  newLine = newLine.slice(start, end);
  if (start > 0) {
    newLine = `'{snip} ${newLine}`;
  }
  if (end < lineLength) {
    newLine += ' {snip}';
  }

  return newLine;
}

/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */
function safeJoin(input, delimiter) {
  if (!Array.isArray(input)) {
    return '';
  }

  var output = [];
    for (let i = 0; i < input.length; i++) {
    var value = input[i];
    try {
      output.push(String(value));
    } catch (e) {
      output.push('[value cannot be serialized]');
    }
  }

  return output.join(delimiter);
}

/**
 * Checks if the value matches a regex or includes the string
 * @param value The string value to be checked against
 * @param pattern Either a regex or a string that must be contained in value
 */
function isMatchingPattern(value, pattern) {
  if (!(0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(value)) {
    return false;
  }

  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isRegExp */ .Kj)(pattern)) {
    return pattern.test(value);
  }
  if (typeof pattern === 'string') {
    return value.indexOf(pattern) !== -1;
  }
  return false;
}

/**
 * Given a string, escape characters which have meaning in the regex grammar, such that the result is safe to feed to
 * `new RegExp()`.
 *
 * Based on https://github.com/sindresorhus/escape-string-regexp. Vendored to a) reduce the size by skipping the runtime
 * type-checking, and b) ensure it gets down-compiled for old versions of Node (the published package only supports Node
 * 12+).
 *
 * @param regexString The string to escape
 * @returns An version of the string with all special regex characters escaped
 */
function escapeStringForRegex(regexString) {
  // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
  // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
  return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}


//# sourceMappingURL=string.js.map


/***/ }),

/***/ 8823:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ak": function() { return /* binding */ supportsFetch; },
/* harmony export */   "Bf": function() { return /* binding */ supportsHistory; },
/* harmony export */   "Du": function() { return /* binding */ isNativeFetch; },
/* harmony export */   "t$": function() { return /* binding */ supportsNativeFetch; }
/* harmony export */ });
/* unused harmony exports supportsDOMError, supportsDOMException, supportsErrorEvent, supportsReferrerPolicy, supportsReportingObserver */
/* harmony import */ var _global_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82991);
/* harmony import */ var _logger_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12343);



/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */
function supportsErrorEvent() {
  try {
    new ErrorEvent('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMError() {
  try {
    // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
    // 1 argument required, but only 0 present.
    // @ts-ignore It really needs 1 argument, not 0.
    new DOMError('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMException() {
  try {
    new DOMException('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */
function supportsFetch() {
  if (!('fetch' in (0,_global_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)())) {
    return false;
  }

  try {
    new Headers();
    new Request('');
    new Response();
    return true;
  } catch (e) {
    return false;
  }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */
function isNativeFetch(func) {
  return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}

/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */
function supportsNativeFetch() {
  if (!supportsFetch()) {
    return false;
  }

  var global = (0,_global_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)();

  // Fast path to avoid DOM I/O
    if (isNativeFetch(global.fetch)) {
    return true;
  }

  // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
  // so create a "pure" iframe to see if that has native fetch
  let result = false;
  var doc = global.document;
    if (doc && typeof (doc.createElement ) === 'function') {
    try {
      var sandbox = doc.createElement('iframe');
      sandbox.hidden = true;
      doc.head.appendChild(sandbox);
      if (sandbox.contentWindow && sandbox.contentWindow.fetch) {
                result = isNativeFetch(sandbox.contentWindow.fetch);
      }
      doc.head.removeChild(sandbox);
    } catch (err) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        _logger_js__WEBPACK_IMPORTED_MODULE_1__/* .logger.warn */ .kg.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
  }

  return result;
}

/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */
function supportsReportingObserver() {
  return 'ReportingObserver' in getGlobalObject();
}

/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */
function supportsReferrerPolicy() {
  // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
  // (see https://caniuse.com/#feat=referrer-policy),
  // it doesn't. And it throws an exception instead of ignoring this parameter...
  // REF: https://github.com/getsentry/raven-js/issues/1233

  if (!supportsFetch()) {
    return false;
  }

  try {
    new Request('_', {
      referrerPolicy: 'origin' ,
    });
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */
function supportsHistory() {
  // NOTE: in Chrome App environment, touching history.pushState, *even inside
  //       a try/catch block*, will cause Chrome to output an error to console.error
  // borrowed from: https://github.com/angular/angular.js/pull/13945/files
  var global = (0,_global_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)();
      var chrome = (global ).chrome;
  var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    var hasHistoryApi = 'history' in global && !!global.history.pushState && !!global.history.replaceState;

  return !isChromePackagedApp && hasHistoryApi;
}


//# sourceMappingURL=supports.js.map


/***/ }),

/***/ 96893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$2": function() { return /* binding */ rejectedSyncPromise; },
/* harmony export */   "WD": function() { return /* binding */ resolvedSyncPromise; },
/* harmony export */   "cW": function() { return /* binding */ SyncPromise; }
/* harmony export */ });
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);


/** SyncPromise internal states */
var States; (function (States) {
  /** Pending */
  var PENDING = 0; States[States["PENDING"] = PENDING] = "PENDING";
  /** Resolved / OK */
  var RESOLVED = 1; States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
  /** Rejected / Error */
  var REJECTED = 2; States[States["REJECTED"] = REJECTED] = "REJECTED";
})(States || (States = {}));

// Overloads so we can call resolvedSyncPromise without arguments and generic argument

/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */
function resolvedSyncPromise(value) {
  return new SyncPromise(resolve => {
    resolve(value);
  });
}

/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */
function rejectedSyncPromise(reason) {
  return new SyncPromise((_, reject) => {
    reject(reason);
  });
}

/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */
class SyncPromise {
   __init() {this._state = States.PENDING;}
   __init2() {this._handlers = [];}
  

   constructor(
    executor,
  ) {;SyncPromise.prototype.__init.call(this);SyncPromise.prototype.__init2.call(this);SyncPromise.prototype.__init3.call(this);SyncPromise.prototype.__init4.call(this);SyncPromise.prototype.__init5.call(this);SyncPromise.prototype.__init6.call(this);
    try {
      executor(this._resolve, this._reject);
    } catch (e) {
      this._reject(e);
    }
  }

  /** JSDoc */
   then(
    onfulfilled,
    onrejected,
  ) {
    return new SyncPromise((resolve, reject) => {
      this._handlers.push([
        false,
        result => {
          if (!onfulfilled) {
            // TODO: ¯\_(ツ)_/¯
            // TODO: FIXME
            resolve(result );
          } else {
            try {
              resolve(onfulfilled(result));
            } catch (e) {
              reject(e);
            }
          }
        },
        reason => {
          if (!onrejected) {
            reject(reason);
          } else {
            try {
              resolve(onrejected(reason));
            } catch (e) {
              reject(e);
            }
          }
        },
      ]);
      this._executeHandlers();
    });
  }

  /** JSDoc */
   catch(
    onrejected,
  ) {
    return this.then(val => val, onrejected);
  }

  /** JSDoc */
   finally(onfinally) {
    return new SyncPromise((resolve, reject) => {
      let val;
      let isRejected;

      return this.then(
        value => {
          isRejected = false;
          val = value;
          if (onfinally) {
            onfinally();
          }
        },
        reason => {
          isRejected = true;
          val = reason;
          if (onfinally) {
            onfinally();
          }
        },
      ).then(() => {
        if (isRejected) {
          reject(val);
          return;
        }

        resolve(val );
      });
    });
  }

  /** JSDoc */
    __init3() {this._resolve = (value) => {
    this._setResult(States.RESOLVED, value);
  };}

  /** JSDoc */
    __init4() {this._reject = (reason) => {
    this._setResult(States.REJECTED, reason);
  };}

  /** JSDoc */
    __init5() {this._setResult = (state, value) => {
    if (this._state !== States.PENDING) {
      return;
    }

    if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isThenable */ .J8)(value)) {
      void (value ).then(this._resolve, this._reject);
      return;
    }

    this._state = state;
    this._value = value;

    this._executeHandlers();
  };}

  /** JSDoc */
    __init6() {this._executeHandlers = () => {
    if (this._state === States.PENDING) {
      return;
    }

    var cachedHandlers = this._handlers.slice();
    this._handlers = [];

    cachedHandlers.forEach(handler => {
      if (handler[0]) {
        return;
      }

      if (this._state === States.RESOLVED) {
                handler[1](this._value );
      }

      if (this._state === States.REJECTED) {
        handler[2](this._value);
      }

      handler[0] = true;
    });
  };}
}


//# sourceMappingURL=syncpromise.js.map


/***/ }),

/***/ 21170:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z1": function() { return /* binding */ browserPerformanceTimeOrigin; },
/* harmony export */   "_I": function() { return /* binding */ timestampWithMs; },
/* harmony export */   "ph": function() { return /* binding */ timestampInSeconds; },
/* harmony export */   "yW": function() { return /* binding */ dateTimestampInSeconds; }
/* harmony export */ });
/* unused harmony exports _browserPerformanceTimeOriginMode, usingPerformanceAPI */
/* harmony import */ var _global_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82991);
/* harmony import */ var _node_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92448);
/* module decorator */ module = __webpack_require__.hmd(module);



/**
 * An object that can return the current timestamp in seconds since the UNIX epoch.
 */

/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */
var dateTimestampSource = {
  nowSeconds: () => Date.now() / 1000,
};

/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */

/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */
function getBrowserPerformance() {
  const { performance } = (0,_global_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)();
  if (!performance || !performance.now) {
    return undefined;
  }

  // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
  //
  // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
  // performance.now() gives a date arbitrarily in the past.
  //
  // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
  // undefined.
  //
  // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
  // interact with data coming out of performance entries.
  //
  // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
  // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
  // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
  // observed skews that can be as long as days, weeks or months.
  //
  // See https://github.com/getsentry/sentry-javascript/issues/2590.
  //
  // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
  // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
  // transactions of long-lived web pages.
  var timeOrigin = Date.now() - performance.now();

  return {
    now: () => performance.now(),
    timeOrigin,
  };
}

/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */
function getNodePerformance() {
  try {
    var perfHooks = (0,_node_js__WEBPACK_IMPORTED_MODULE_1__/* .dynamicRequire */ .l$)(module, 'perf_hooks') ;
    return perfHooks.performance;
  } catch (_) {
    return undefined;
  }
}

/**
 * The Performance API implementation for the current platform, if available.
 */
var platformPerformance = (0,_node_js__WEBPACK_IMPORTED_MODULE_1__/* .isNodeEnv */ .KV)() ? getNodePerformance() : getBrowserPerformance();

var timestampSource =
  platformPerformance === undefined
    ? dateTimestampSource
    : {
        nowSeconds: () => (platformPerformance.timeOrigin + platformPerformance.now()) / 1000,
      };

/**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);

/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * See `usingPerformanceAPI` to test whether the Performance API is used.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);

// Re-exported with an old name for backwards-compatibility.
var timestampWithMs = timestampInSeconds;

/**
 * A boolean that is true when timestampInSeconds uses the Performance API to produce monotonic timestamps.
 */
var usingPerformanceAPI = platformPerformance !== undefined;

/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */
let _browserPerformanceTimeOriginMode;

/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */
var browserPerformanceTimeOrigin = (() => {
  // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
  // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
  // data as reliable if they are within a reasonable threshold of the current time.

  const { performance } = (0,_global_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .R)();
  if (!performance || !performance.now) {
    _browserPerformanceTimeOriginMode = 'none';
    return undefined;
  }

  var threshold = 3600 * 1000;
  var performanceNow = performance.now();
  var dateNow = Date.now();

  // if timeOrigin isn't available set delta to threshold so it isn't used
  var timeOriginDelta = performance.timeOrigin
    ? Math.abs(performance.timeOrigin + performanceNow - dateNow)
    : threshold;
  var timeOriginIsReliable = timeOriginDelta < threshold;

  // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
  // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
  // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
  // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
  // Date API.
    var navigationStart = performance.timing && performance.timing.navigationStart;
  var hasNavigationStart = typeof navigationStart === 'number';
  // if navigationStart isn't available set delta to threshold so it isn't used
  var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
  var navigationStartIsReliable = navigationStartDelta < threshold;

  if (timeOriginIsReliable || navigationStartIsReliable) {
    // Use the more reliable time origin
    if (timeOriginDelta <= navigationStartDelta) {
      _browserPerformanceTimeOriginMode = 'timeOrigin';
      return performance.timeOrigin;
    } else {
      _browserPerformanceTimeOriginMode = 'navigationStart';
      return navigationStart;
    }
  }

  // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
  _browserPerformanceTimeOriginMode = 'dateNow';
  return dateNow;
})();


//# sourceMappingURL=time.js.map


/***/ }),

/***/ 26956:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "en": function() { return /* binding */ parseUrl; },
/* harmony export */   "rt": function() { return /* binding */ stripUrlQueryAndFragment; }
/* harmony export */ });
/* unused harmony export getNumberOfUrlSegments */
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */
function parseUrl(url)

 {
  if (!url) {
    return {};
  }

  var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);

  if (!match) {
    return {};
  }

  // coerce to undefined values to empty string so we don't get 'undefined'
  var query = match[6] || '';
  var fragment = match[8] || '';
  return {
    host: match[4],
    path: match[5],
    protocol: match[2],
    relative: match[5] + query + fragment, // everything minus origin
  };
}

/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */
function stripUrlQueryAndFragment(urlPath) {
    return urlPath.split(/[\?#]/, 1)[0];
}

/**
 * Returns number of URL segments of a passed string URL.
 */
function getNumberOfUrlSegments(url) {
  // split at '/' or at '\/' to split regex urls correctly
  return url.split(/\\?\//).filter(s => s.length > 0 && s !== ',').length;
}


//# sourceMappingURL=url.js.map


/***/ }),

/***/ 16395:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var _global = (typeof window !== 'undefined' ? window : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"18c2f524c3d56ced58b0b0253895c4ba51b18ba4"};

/***/ }),

/***/ 76489:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.parse = parse;
exports.serialize = serialize;

/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode = encodeURIComponent;
var pairSplitRegExp = /; */;

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var pairs = str.split(pairSplitRegExp);
  var dec = opt.decode || decode;

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var eq_idx = pair.indexOf('=');

    // skip things that don't look like key=value
    if (eq_idx < 0) {
      continue;
    }

    var key = pair.substr(0, eq_idx).trim()
    var val = pair.substr(++eq_idx, pair.length).trim();

    // quoted values
    if ('"' == val[0]) {
      val = val.slice(1, -1);
    }

    // only assign once
    if (undefined == obj[key]) {
      obj[key] = tryDecode(val, dec);
    }
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;

    if (isNaN(maxAge) || !isFinite(maxAge)) {
      throw new TypeError('option maxAge is invalid')
    }

    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      case 'none':
        str += '; SameSite=None';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ }),

/***/ 8679:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(59864);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 16284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ IntlMessageFormat; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70655);
/* harmony import */ var _formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56096);
/* harmony import */ var _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95957);
/* harmony import */ var _formatters__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61092);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/




// -- MessageFormat --------------------------------------------------------
function mergeConfig(c1, c2) {
    if (!c2) {
        return c1;
    }
    return (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, (c1 || {})), (c2 || {})), Object.keys(c1).reduce(function (all, k) {
        all[k] = (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, c1[k]), (c2[k] || {}));
        return all;
    }, {}));
}
function mergeConfigs(defaultConfig, configs) {
    if (!configs) {
        return defaultConfig;
    }
    return Object.keys(defaultConfig).reduce(function (all, k) {
        all[k] = mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, defaultConfig));
}
function createFastMemoizeCache(store) {
    return {
        create: function () {
            return {
                get: function (key) {
                    return store[key];
                },
                set: function (key, value) {
                    store[key] = value;
                },
            };
        },
    };
}
function createDefaultFormatters(cache) {
    if (cache === void 0) { cache = {
        number: {},
        dateTime: {},
        pluralRules: {},
    }; }
    return {
        getNumberFormat: (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__spreadArray */ .ev)([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.number),
            strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_1__/* .strategies.variadic */ .A.variadic,
        }),
        getDateTimeFormat: (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__spreadArray */ .ev)([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.dateTime),
            strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_1__/* .strategies.variadic */ .A.variadic,
        }),
        getPluralRules: (0,_formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__spreadArray */ .ev)([void 0], args, false)))();
        }, {
            cache: createFastMemoizeCache(cache.pluralRules),
            strategy: _formatjs_fast_memoize__WEBPACK_IMPORTED_MODULE_1__/* .strategies.variadic */ .A.variadic,
        }),
    };
}
var IntlMessageFormat = /** @class */ (function () {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        var _this = this;
        if (locales === void 0) { locales = IntlMessageFormat.defaultLocale; }
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {},
        };
        this.format = function (values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) {
                return parts[0].value;
            }
            var result = parts.reduce(function (all, part) {
                if (!all.length ||
                    part.type !== _formatters__WEBPACK_IMPORTED_MODULE_3__/* .PART_TYPE.literal */ .du.literal ||
                    typeof all[all.length - 1] !== 'string') {
                    all.push(part.value);
                }
                else {
                    all[all.length - 1] += part.value;
                }
                return all;
            }, []);
            if (result.length <= 1) {
                return result[0] || '';
            }
            return result;
        };
        this.formatToParts = function (values) {
            return (0,_formatters__WEBPACK_IMPORTED_MODULE_3__/* .formatToParts */ .FK)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function () { return ({
            locale: _this.resolvedLocale.toString(),
        }); };
        this.getAst = function () { return _this.ast; };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) {
                throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            }
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, {
                ignoreTag: opts === null || opts === void 0 ? void 0 : opts.ignoreTag,
                locale: this.resolvedLocale,
            });
        }
        else {
            this.ast = message;
        }
        if (!Array.isArray(this.ast)) {
            throw new TypeError('A message must be provided as a String or AST.');
        }
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters =
            (opts && opts.formatters) || createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function () {
            if (!IntlMessageFormat.memoizedDefaultLocale) {
                IntlMessageFormat.memoizedDefaultLocale =
                    new Intl.NumberFormat().resolvedOptions().locale;
            }
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function (locales) {
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) {
            return new Intl.Locale(supportedLocales[0]);
        }
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = _formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .parse */ .Qc;
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0,
            },
            currency: {
                style: 'currency',
            },
            percent: {
                style: 'percent',
            },
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit',
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric',
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric',
            },
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric',
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short',
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short',
            },
        },
    };
    return IntlMessageFormat;
}());



/***/ }),

/***/ 11050:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C8": function() { return /* binding */ InvalidValueError; },
/* harmony export */   "HR": function() { return /* binding */ MissingValueError; },
/* harmony export */   "YR": function() { return /* binding */ InvalidValueTypeError; },
/* harmony export */   "jK": function() { return /* binding */ ErrorCode; },
/* harmony export */   "u_": function() { return /* binding */ FormatError; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70655);

var ErrorCode;
(function (ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})(ErrorCode || (ErrorCode = {}));
var FormatError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function () {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error));

var InvalidValueError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), ErrorCode.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}(FormatError));

var InvalidValueTypeError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), ErrorCode.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}(FormatError));

var MissingValueError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__/* .__extends */ .ZT)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), ErrorCode.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}(FormatError));



/***/ }),

/***/ 61092:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FK": function() { return /* binding */ formatToParts; },
/* harmony export */   "Gt": function() { return /* binding */ isFormatXMLElementFn; },
/* harmony export */   "du": function() { return /* binding */ PART_TYPE; }
/* harmony export */ });
/* harmony import */ var _formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56096);
/* harmony import */ var _error__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11050);


var PART_TYPE;
(function (PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})(PART_TYPE || (PART_TYPE = {}));
function mergeLiteral(parts) {
    if (parts.length < 2) {
        return parts;
    }
    return parts.reduce(function (all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart ||
            lastPart.type !== PART_TYPE.literal ||
            part.type !== PART_TYPE.literal) {
            all.push(part);
        }
        else {
            lastPart.value += part.value;
        }
        return all;
    }, []);
}
function isFormatXMLElementFn(el) {
    return typeof el === 'function';
}
// TODO(skeleton): add skeleton support
function formatToParts(els, locales, formatters, formats, values, currentPluralValue, 
// For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isLiteralElement */ .O4)(els[0])) {
        return [
            {
                type: PART_TYPE.literal,
                value: els[0].value,
            },
        ];
    }
    var result = [];
    for (var _i = 0, els_1 = els; _i < els_1.length; _i++) {
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isLiteralElement */ .O4)(el)) {
            result.push({
                type: PART_TYPE.literal,
                value: el.value,
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isPoundElement */ .yx)(el)) {
            if (typeof currentPluralValue === 'number') {
                result.push({
                    type: PART_TYPE.literal,
                    value: formatters.getNumberFormat(locales).format(currentPluralValue),
                });
            }
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) {
            throw new _error__WEBPACK_IMPORTED_MODULE_1__/* .MissingValueError */ .HR(varName, originalMessage);
        }
        var value = values[varName];
        if ((0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isArgumentElement */ .VG)(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') {
                value =
                    typeof value === 'string' || typeof value === 'number'
                        ? String(value)
                        : '';
            }
            result.push({
                type: typeof value === 'string' ? PART_TYPE.literal : PART_TYPE.object,
                value: value,
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isDateElement */ .rp)(el)) {
            var style = typeof el.style === 'string'
                ? formats.date[el.style]
                : (0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isDateTimeSkeleton */ .Ii)(el.style)
                    ? el.style.parsedOptions
                    : undefined;
            result.push({
                type: PART_TYPE.literal,
                value: formatters
                    .getDateTimeFormat(locales, style)
                    .format(value),
            });
            continue;
        }
        if ((0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isTimeElement */ .pe)(el)) {
            var style = typeof el.style === 'string'
                ? formats.time[el.style]
                : (0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isDateTimeSkeleton */ .Ii)(el.style)
                    ? el.style.parsedOptions
                    : formats.time.medium;
            result.push({
                type: PART_TYPE.literal,
                value: formatters
                    .getDateTimeFormat(locales, style)
                    .format(value),
            });
            continue;
        }
        if ((0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isNumberElement */ .uf)(el)) {
            var style = typeof el.style === 'string'
                ? formats.number[el.style]
                : (0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isNumberSkeleton */ .Wh)(el.style)
                    ? el.style.parsedOptions
                    : undefined;
            if (style && style.scale) {
                value =
                    value *
                        (style.scale || 1);
            }
            result.push({
                type: PART_TYPE.literal,
                value: formatters
                    .getNumberFormat(locales, style)
                    .format(value),
            });
            continue;
        }
        if ((0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isTagElement */ .HI)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!isFormatXMLElementFn(formatFn)) {
                throw new _error__WEBPACK_IMPORTED_MODULE_1__/* .InvalidValueTypeError */ .YR(value_1, 'function', originalMessage);
            }
            var parts = formatToParts(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function (p) { return p.value; }));
            if (!Array.isArray(chunks)) {
                chunks = [chunks];
            }
            result.push.apply(result, chunks.map(function (c) {
                return {
                    type: typeof c === 'string' ? PART_TYPE.literal : PART_TYPE.object,
                    value: c,
                };
            }));
        }
        if ((0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isSelectElement */ .Wi)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) {
                throw new _error__WEBPACK_IMPORTED_MODULE_1__/* .InvalidValueError */ .C8(el.value, value, Object.keys(el.options), originalMessage);
            }
            result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0,_formatjs_icu_messageformat_parser__WEBPACK_IMPORTED_MODULE_0__/* .isPluralElement */ .Jo)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) {
                    throw new _error__WEBPACK_IMPORTED_MODULE_1__/* .FormatError */ .u_("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", _error__WEBPACK_IMPORTED_MODULE_1__/* .ErrorCode.MISSING_INTL_API */ .jK.MISSING_INTL_API, originalMessage);
                }
                var rule = formatters
                    .getPluralRules(locales, { type: el.pluralType })
                    .select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) {
                throw new _error__WEBPACK_IMPORTED_MODULE_1__/* .InvalidValueError */ .C8(el.value, value, Object.keys(el.options), originalMessage);
            }
            result.push.apply(result, formatToParts(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return mergeLiteral(result);
}


/***/ }),

/***/ 29548:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(95318);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.BroadcastChannel = BroadcastChannel;
exports.apiBaseUrl = apiBaseUrl;
exports.fetchData = fetchData;
exports.now = now;

var _regenerator = _interopRequireDefault(__webpack_require__(87757));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(59713));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(48926));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function fetchData(_x, _x2, _x3) {
  return _fetchData.apply(this, arguments);
}

function _fetchData() {
  _fetchData = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee(path, __NEXTAUTH, logger) {
    var _ref,
        ctx,
        _ref$req,
        req,
        url,
        options,
        res,
        data,
        _args = arguments;

    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref = _args.length > 3 && _args[3] !== undefined ? _args[3] : {}, ctx = _ref.ctx, _ref$req = _ref.req, req = _ref$req === void 0 ? ctx === null || ctx === void 0 ? void 0 : ctx.req : _ref$req;
            url = "".concat(apiBaseUrl(__NEXTAUTH), "/").concat(path);
            _context.prev = 2;
            options = req !== null && req !== void 0 && req.headers.cookie ? {
              headers: {
                cookie: req.headers.cookie
              }
            } : {};
            _context.next = 6;
            return fetch(url, options);

          case 6:
            res = _context.sent;
            _context.next = 9;
            return res.json();

          case 9:
            data = _context.sent;

            if (res.ok) {
              _context.next = 12;
              break;
            }

            throw data;

          case 12:
            return _context.abrupt("return", Object.keys(data).length > 0 ? data : null);

          case 15:
            _context.prev = 15;
            _context.t0 = _context["catch"](2);
            logger.error("CLIENT_FETCH_ERROR", {
              error: _context.t0,
              url: url
            });
            return _context.abrupt("return", null);

          case 19:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 15]]);
  }));
  return _fetchData.apply(this, arguments);
}

function apiBaseUrl(__NEXTAUTH) {
  if (typeof window === "undefined") {
    return "".concat(__NEXTAUTH.baseUrlServer).concat(__NEXTAUTH.basePathServer);
  }

  return __NEXTAUTH.basePath;
}

function now() {
  return Math.floor(Date.now() / 1000);
}

function BroadcastChannel() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "nextauth.message";
  return {
    receive: function receive(onReceive) {
      var handler = function handler(event) {
        var _event$newValue;

        if (event.key !== name) return;
        var message = JSON.parse((_event$newValue = event.newValue) !== null && _event$newValue !== void 0 ? _event$newValue : "{}");
        if ((message === null || message === void 0 ? void 0 : message.event) !== "session" || !(message !== null && message !== void 0 && message.data)) return;
        onReceive(message);
      };

      window.addEventListener("storage", handler);
      return function () {
        return window.removeEventListener("storage", handler);
      };
    },
    post: function post(message) {
      if (typeof window === "undefined") return;
      localStorage.setItem(name, JSON.stringify(_objectSpread(_objectSpread({}, message), {}, {
        timestamp: now()
      })));
    }
  };
}

/***/ }),

/***/ 36925:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(95318);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.UnsupportedStrategy = exports.UnknownError = exports.OAuthCallbackError = exports.MissingSecret = exports.MissingAuthorize = exports.MissingAdapter = exports.MissingAPIRoute = exports.InvalidCallbackUrl = exports.AccountNotLinkedError = void 0;
exports.adapterErrorHandler = adapterErrorHandler;
exports.capitalize = capitalize;
exports.eventsErrorHandler = eventsErrorHandler;
exports.upperSnake = upperSnake;

var _regenerator = _interopRequireDefault(__webpack_require__(87757));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(48926));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(81506));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(59713));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(34575));

var _createClass2 = _interopRequireDefault(__webpack_require__(93913));

var _inherits2 = _interopRequireDefault(__webpack_require__(2205));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(78585));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(29754));

var _wrapNativeSuper2 = _interopRequireDefault(__webpack_require__(65957));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var UnknownError = function (_Error) {
  (0, _inherits2.default)(UnknownError, _Error);

  var _super = _createSuper(UnknownError);

  function UnknownError(error) {
    var _message;

    var _this;

    (0, _classCallCheck2.default)(this, UnknownError);
    _this = _super.call(this, (_message = error === null || error === void 0 ? void 0 : error.message) !== null && _message !== void 0 ? _message : error);
    _this.name = "UnknownError";
    _this.code = error.code;

    if (error instanceof Error) {
      _this.stack = error.stack;
    }

    return _this;
  }

  (0, _createClass2.default)(UnknownError, [{
    key: "toJSON",
    value: function toJSON() {
      return {
        name: this.name,
        message: this.message,
        stack: this.stack
      };
    }
  }]);
  return UnknownError;
}((0, _wrapNativeSuper2.default)(Error));

exports.UnknownError = UnknownError;

var OAuthCallbackError = function (_UnknownError) {
  (0, _inherits2.default)(OAuthCallbackError, _UnknownError);

  var _super2 = _createSuper(OAuthCallbackError);

  function OAuthCallbackError() {
    var _this2;

    (0, _classCallCheck2.default)(this, OAuthCallbackError);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "name", "OAuthCallbackError");
    return _this2;
  }

  return (0, _createClass2.default)(OAuthCallbackError);
}(UnknownError);

exports.OAuthCallbackError = OAuthCallbackError;

var AccountNotLinkedError = function (_UnknownError2) {
  (0, _inherits2.default)(AccountNotLinkedError, _UnknownError2);

  var _super3 = _createSuper(AccountNotLinkedError);

  function AccountNotLinkedError() {
    var _this3;

    (0, _classCallCheck2.default)(this, AccountNotLinkedError);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this3 = _super3.call.apply(_super3, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this3), "name", "AccountNotLinkedError");
    return _this3;
  }

  return (0, _createClass2.default)(AccountNotLinkedError);
}(UnknownError);

exports.AccountNotLinkedError = AccountNotLinkedError;

var MissingAPIRoute = function (_UnknownError3) {
  (0, _inherits2.default)(MissingAPIRoute, _UnknownError3);

  var _super4 = _createSuper(MissingAPIRoute);

  function MissingAPIRoute() {
    var _this4;

    (0, _classCallCheck2.default)(this, MissingAPIRoute);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this4 = _super4.call.apply(_super4, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this4), "name", "MissingAPIRouteError");
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this4), "code", "MISSING_NEXTAUTH_API_ROUTE_ERROR");
    return _this4;
  }

  return (0, _createClass2.default)(MissingAPIRoute);
}(UnknownError);

exports.MissingAPIRoute = MissingAPIRoute;

var MissingSecret = function (_UnknownError4) {
  (0, _inherits2.default)(MissingSecret, _UnknownError4);

  var _super5 = _createSuper(MissingSecret);

  function MissingSecret() {
    var _this5;

    (0, _classCallCheck2.default)(this, MissingSecret);

    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    _this5 = _super5.call.apply(_super5, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this5), "name", "MissingSecretError");
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this5), "code", "NO_SECRET");
    return _this5;
  }

  return (0, _createClass2.default)(MissingSecret);
}(UnknownError);

exports.MissingSecret = MissingSecret;

var MissingAuthorize = function (_UnknownError5) {
  (0, _inherits2.default)(MissingAuthorize, _UnknownError5);

  var _super6 = _createSuper(MissingAuthorize);

  function MissingAuthorize() {
    var _this6;

    (0, _classCallCheck2.default)(this, MissingAuthorize);

    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    _this6 = _super6.call.apply(_super6, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this6), "name", "MissingAuthorizeError");
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this6), "code", "CALLBACK_CREDENTIALS_HANDLER_ERROR");
    return _this6;
  }

  return (0, _createClass2.default)(MissingAuthorize);
}(UnknownError);

exports.MissingAuthorize = MissingAuthorize;

var MissingAdapter = function (_UnknownError6) {
  (0, _inherits2.default)(MissingAdapter, _UnknownError6);

  var _super7 = _createSuper(MissingAdapter);

  function MissingAdapter() {
    var _this7;

    (0, _classCallCheck2.default)(this, MissingAdapter);

    for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
      args[_key6] = arguments[_key6];
    }

    _this7 = _super7.call.apply(_super7, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this7), "name", "MissingAdapterError");
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this7), "code", "EMAIL_REQUIRES_ADAPTER_ERROR");
    return _this7;
  }

  return (0, _createClass2.default)(MissingAdapter);
}(UnknownError);

exports.MissingAdapter = MissingAdapter;

var UnsupportedStrategy = function (_UnknownError7) {
  (0, _inherits2.default)(UnsupportedStrategy, _UnknownError7);

  var _super8 = _createSuper(UnsupportedStrategy);

  function UnsupportedStrategy() {
    var _this8;

    (0, _classCallCheck2.default)(this, UnsupportedStrategy);

    for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
      args[_key7] = arguments[_key7];
    }

    _this8 = _super8.call.apply(_super8, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this8), "name", "UnsupportedStrategyError");
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this8), "code", "CALLBACK_CREDENTIALS_JWT_ERROR");
    return _this8;
  }

  return (0, _createClass2.default)(UnsupportedStrategy);
}(UnknownError);

exports.UnsupportedStrategy = UnsupportedStrategy;

var InvalidCallbackUrl = function (_UnknownError8) {
  (0, _inherits2.default)(InvalidCallbackUrl, _UnknownError8);

  var _super9 = _createSuper(InvalidCallbackUrl);

  function InvalidCallbackUrl() {
    var _this9;

    (0, _classCallCheck2.default)(this, InvalidCallbackUrl);

    for (var _len8 = arguments.length, args = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
      args[_key8] = arguments[_key8];
    }

    _this9 = _super9.call.apply(_super9, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this9), "name", "InvalidCallbackUrl");
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this9), "code", "INVALID_CALLBACK_URL_ERROR");
    return _this9;
  }

  return (0, _createClass2.default)(InvalidCallbackUrl);
}(UnknownError);

exports.InvalidCallbackUrl = InvalidCallbackUrl;

function upperSnake(s) {
  return s.replace(/([A-Z])/g, "_$1").toUpperCase();
}

function capitalize(s) {
  return "".concat(s[0].toUpperCase()).concat(s.slice(1));
}

function eventsErrorHandler(methods, logger) {
  return Object.keys(methods).reduce(function (acc, name) {
    acc[name] = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee() {
      var method,
          _args = arguments;
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              method = methods[name];
              _context.next = 4;
              return method.apply(void 0, _args);

            case 4:
              return _context.abrupt("return", _context.sent);

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              logger.error("".concat(upperSnake(name), "_EVENT_ERROR"), _context.t0);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    }));
    return acc;
  }, {});
}

function adapterErrorHandler(adapter, logger) {
  if (!adapter) return;
  return Object.keys(adapter).reduce(function (acc, name) {
    acc[name] = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee2() {
      var _len9,
          args,
          _key9,
          method,
          e,
          _args2 = arguments;

      return _regenerator.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;

              for (_len9 = _args2.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
                args[_key9] = _args2[_key9];
              }

              logger.debug("adapter_".concat(name), {
                args: args
              });
              method = adapter[name];
              _context2.next = 6;
              return method.apply(void 0, args);

            case 6:
              return _context2.abrupt("return", _context2.sent);

            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](0);
              logger.error("adapter_error_".concat(name), _context2.t0);
              e = new UnknownError(_context2.t0);
              e.name = "".concat(capitalize(name), "Error");
              throw e;

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 9]]);
    }));
    return acc;
  }, {});
}

/***/ }),

/***/ 33299:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(34155);


var _interopRequireDefault = __webpack_require__(95318);

var _typeof = __webpack_require__(50008);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
var _exportNames = {
  useSession: true,
  getSession: true,
  getCsrfToken: true,
  getProviders: true,
  signIn: true,
  signOut: true,
  SessionProvider: true
};
exports.SessionProvider = SessionProvider;
exports.getCsrfToken = getCsrfToken;
exports.getProviders = getProviders;
exports.getSession = getSession;
exports.signIn = signIn;
exports.signOut = signOut;
exports.useSession = useSession;

var _regenerator = _interopRequireDefault(__webpack_require__(87757));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(59713));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(63038));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(48926));

var React = _interopRequireWildcard(__webpack_require__(67294));

var _logger2 = _interopRequireWildcard(__webpack_require__(26553));

var _parseUrl = _interopRequireDefault(__webpack_require__(30762));

var _utils = __webpack_require__(29548);

var _jsxRuntime = __webpack_require__(85893);

var _types = __webpack_require__(527);

Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _types[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _types[key];
    }
  });
});

var _process$env$NEXTAUTH, _ref, _process$env$NEXTAUTH2, _process$env$NEXTAUTH3;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var __NEXTAUTH = {
  baseUrl: (0, _parseUrl.default)((_process$env$NEXTAUTH = process.env.NEXTAUTH_URL) !== null && _process$env$NEXTAUTH !== void 0 ? _process$env$NEXTAUTH : process.env.VERCEL_URL).origin,
  basePath: (0, _parseUrl.default)(process.env.NEXTAUTH_URL).path,
  baseUrlServer: (0, _parseUrl.default)((_ref = (_process$env$NEXTAUTH2 = process.env.NEXTAUTH_URL_INTERNAL) !== null && _process$env$NEXTAUTH2 !== void 0 ? _process$env$NEXTAUTH2 : process.env.NEXTAUTH_URL) !== null && _ref !== void 0 ? _ref : process.env.VERCEL_URL).origin,
  basePathServer: (0, _parseUrl.default)((_process$env$NEXTAUTH3 = process.env.NEXTAUTH_URL_INTERNAL) !== null && _process$env$NEXTAUTH3 !== void 0 ? _process$env$NEXTAUTH3 : process.env.NEXTAUTH_URL).path,
  _lastSync: 0,
  _session: undefined,
  _getSession: function _getSession() {}
};
var broadcast = (0, _utils.BroadcastChannel)();
var logger = (0, _logger2.proxyLogger)(_logger2.default, __NEXTAUTH.basePath);
var SessionContext = React.createContext(undefined);

function useSession(options) {
  var value = React.useContext(SessionContext);

  if (!value && "production" !== "production") {}

  var _ref2 = options !== null && options !== void 0 ? options : {},
      required = _ref2.required,
      onUnauthenticated = _ref2.onUnauthenticated;

  var requiredAndNotLoading = required && value.status === "unauthenticated";
  React.useEffect(function () {
    if (requiredAndNotLoading) {
      var url = "/api/auth/signin?".concat(new URLSearchParams({
        error: "SessionRequired",
        callbackUrl: window.location.href
      }));
      if (onUnauthenticated) onUnauthenticated();else window.location.href = url;
    }
  }, [requiredAndNotLoading, onUnauthenticated]);

  if (requiredAndNotLoading) {
    return {
      data: value.data,
      status: "loading"
    };
  }

  return value;
}

function getSession(_x) {
  return _getSession2.apply(this, arguments);
}

function _getSession2() {
  _getSession2 = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee2(params) {
    var _params$broadcast;

    var session;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return (0, _utils.fetchData)("session", __NEXTAUTH, logger, params);

          case 2:
            session = _context2.sent;

            if ((_params$broadcast = params === null || params === void 0 ? void 0 : params.broadcast) !== null && _params$broadcast !== void 0 ? _params$broadcast : true) {
              broadcast.post({
                event: "session",
                data: {
                  trigger: "getSession"
                }
              });
            }

            return _context2.abrupt("return", session);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getSession2.apply(this, arguments);
}

function getCsrfToken(_x2) {
  return _getCsrfToken.apply(this, arguments);
}

function _getCsrfToken() {
  _getCsrfToken = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee3(params) {
    var response;
    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return (0, _utils.fetchData)("csrf", __NEXTAUTH, logger, params);

          case 2:
            response = _context3.sent;
            return _context3.abrupt("return", response === null || response === void 0 ? void 0 : response.csrfToken);

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _getCsrfToken.apply(this, arguments);
}

function getProviders() {
  return _getProviders.apply(this, arguments);
}

function _getProviders() {
  _getProviders = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee4() {
    return _regenerator.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return (0, _utils.fetchData)("providers", __NEXTAUTH, logger);

          case 2:
            return _context4.abrupt("return", _context4.sent);

          case 3:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _getProviders.apply(this, arguments);
}

function signIn(_x3, _x4, _x5) {
  return _signIn.apply(this, arguments);
}

function _signIn() {
  _signIn = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee5(provider, options, authorizationParams) {
    var _ref5, _ref5$callbackUrl, callbackUrl, _ref5$redirect, redirect, baseUrl, providers, isCredentials, isEmail, isSupportingReturn, signInUrl, _signInUrl, res, data, _data$url, url, error;

    return _regenerator.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _ref5 = options !== null && options !== void 0 ? options : {}, _ref5$callbackUrl = _ref5.callbackUrl, callbackUrl = _ref5$callbackUrl === void 0 ? window.location.href : _ref5$callbackUrl, _ref5$redirect = _ref5.redirect, redirect = _ref5$redirect === void 0 ? true : _ref5$redirect;
            baseUrl = (0, _utils.apiBaseUrl)(__NEXTAUTH);
            _context5.next = 4;
            return getProviders();

          case 4:
            providers = _context5.sent;

            if (providers) {
              _context5.next = 8;
              break;
            }

            window.location.href = "".concat(baseUrl, "/error");
            return _context5.abrupt("return");

          case 8:
            if (!(!provider || !(provider in providers))) {
              _context5.next = 11;
              break;
            }

            window.location.href = "".concat(baseUrl, "/signin?").concat(new URLSearchParams({
              callbackUrl: callbackUrl
            }));
            return _context5.abrupt("return");

          case 11:
            isCredentials = providers[provider].type === "credentials";
            isEmail = providers[provider].type === "email";
            isSupportingReturn = isCredentials || isEmail;
            signInUrl = "".concat(baseUrl, "/").concat(isCredentials ? "callback" : "signin", "/").concat(provider);
            _signInUrl = "".concat(signInUrl, "?").concat(new URLSearchParams(authorizationParams));
            _context5.t0 = fetch;
            _context5.t1 = _signInUrl;
            _context5.t2 = {
              "Content-Type": "application/x-www-form-urlencoded"
            };
            _context5.t3 = URLSearchParams;
            _context5.t4 = _objectSpread;
            _context5.t5 = _objectSpread({}, options);
            _context5.t6 = {};
            _context5.next = 25;
            return getCsrfToken();

          case 25:
            _context5.t7 = _context5.sent;
            _context5.t8 = callbackUrl;
            _context5.t9 = {
              csrfToken: _context5.t7,
              callbackUrl: _context5.t8,
              json: true
            };
            _context5.t10 = (0, _context5.t4)(_context5.t5, _context5.t6, _context5.t9);
            _context5.t11 = new _context5.t3(_context5.t10);
            _context5.t12 = {
              method: "post",
              headers: _context5.t2,
              body: _context5.t11
            };
            _context5.next = 33;
            return (0, _context5.t0)(_context5.t1, _context5.t12);

          case 33:
            res = _context5.sent;
            _context5.next = 36;
            return res.json();

          case 36:
            data = _context5.sent;

            if (!(redirect || !isSupportingReturn)) {
              _context5.next = 42;
              break;
            }

            url = (_data$url = data.url) !== null && _data$url !== void 0 ? _data$url : callbackUrl;
            window.location.href = url;
            if (url.includes("#")) window.location.reload();
            return _context5.abrupt("return");

          case 42:
            error = new URL(data.url).searchParams.get("error");

            if (!res.ok) {
              _context5.next = 46;
              break;
            }

            _context5.next = 46;
            return __NEXTAUTH._getSession({
              event: "storage"
            });

          case 46:
            return _context5.abrupt("return", {
              error: error,
              status: res.status,
              ok: res.ok,
              url: error ? null : data.url
            });

          case 47:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _signIn.apply(this, arguments);
}

function signOut(_x6) {
  return _signOut.apply(this, arguments);
}

function _signOut() {
  _signOut = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee6(options) {
    var _options$redirect;

    var _ref6, _ref6$callbackUrl, callbackUrl, baseUrl, fetchOptions, res, data, _data$url2, url;

    return _regenerator.default.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _ref6 = options !== null && options !== void 0 ? options : {}, _ref6$callbackUrl = _ref6.callbackUrl, callbackUrl = _ref6$callbackUrl === void 0 ? window.location.href : _ref6$callbackUrl;
            baseUrl = (0, _utils.apiBaseUrl)(__NEXTAUTH);
            _context6.t0 = {
              "Content-Type": "application/x-www-form-urlencoded"
            };
            _context6.t1 = URLSearchParams;
            _context6.next = 6;
            return getCsrfToken();

          case 6:
            _context6.t2 = _context6.sent;
            _context6.t3 = callbackUrl;
            _context6.t4 = {
              csrfToken: _context6.t2,
              callbackUrl: _context6.t3,
              json: true
            };
            _context6.t5 = new _context6.t1(_context6.t4);
            fetchOptions = {
              method: "post",
              headers: _context6.t0,
              body: _context6.t5
            };
            _context6.next = 13;
            return fetch("".concat(baseUrl, "/signout"), fetchOptions);

          case 13:
            res = _context6.sent;
            _context6.next = 16;
            return res.json();

          case 16:
            data = _context6.sent;
            broadcast.post({
              event: "session",
              data: {
                trigger: "signout"
              }
            });

            if (!((_options$redirect = options === null || options === void 0 ? void 0 : options.redirect) !== null && _options$redirect !== void 0 ? _options$redirect : true)) {
              _context6.next = 23;
              break;
            }

            url = (_data$url2 = data.url) !== null && _data$url2 !== void 0 ? _data$url2 : callbackUrl;
            window.location.href = url;
            if (url.includes("#")) window.location.reload();
            return _context6.abrupt("return");

          case 23:
            _context6.next = 25;
            return __NEXTAUTH._getSession({
              event: "storage"
            });

          case 25:
            return _context6.abrupt("return", data);

          case 26:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _signOut.apply(this, arguments);
}

function SessionProvider(props) {
  var children = props.children,
      basePath = props.basePath;
  if (basePath) __NEXTAUTH.basePath = basePath;
  var hasInitialSession = props.session !== undefined;
  __NEXTAUTH._lastSync = hasInitialSession ? (0, _utils.now)() : 0;

  var _React$useState = React.useState(function () {
    if (hasInitialSession) __NEXTAUTH._session = props.session;
    return props.session;
  }),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      session = _React$useState2[0],
      setSession = _React$useState2[1];

  var _React$useState3 = React.useState(!hasInitialSession),
      _React$useState4 = (0, _slicedToArray2.default)(_React$useState3, 2),
      loading = _React$useState4[0],
      setLoading = _React$useState4[1];

  React.useEffect(function () {
    __NEXTAUTH._getSession = (0, _asyncToGenerator2.default)(_regenerator.default.mark(function _callee() {
      var _ref4,
          event,
          storageEvent,
          _args = arguments;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _ref4 = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, event = _ref4.event;
              _context.prev = 1;
              storageEvent = event === "storage";

              if (!(storageEvent || __NEXTAUTH._session === undefined)) {
                _context.next = 10;
                break;
              }

              __NEXTAUTH._lastSync = (0, _utils.now)();
              _context.next = 7;
              return getSession({
                broadcast: !storageEvent
              });

            case 7:
              __NEXTAUTH._session = _context.sent;
              setSession(__NEXTAUTH._session);
              return _context.abrupt("return");

            case 10:
              if (!(!event || __NEXTAUTH._session === null || (0, _utils.now)() < __NEXTAUTH._lastSync)) {
                _context.next = 12;
                break;
              }

              return _context.abrupt("return");

            case 12:
              __NEXTAUTH._lastSync = (0, _utils.now)();
              _context.next = 15;
              return getSession();

            case 15:
              __NEXTAUTH._session = _context.sent;
              setSession(__NEXTAUTH._session);
              _context.next = 22;
              break;

            case 19:
              _context.prev = 19;
              _context.t0 = _context["catch"](1);
              logger.error("CLIENT_SESSION_ERROR", _context.t0);

            case 22:
              _context.prev = 22;
              setLoading(false);
              return _context.finish(22);

            case 25:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 19, 22, 25]]);
    }));

    __NEXTAUTH._getSession();

    return function () {
      __NEXTAUTH._lastSync = 0;
      __NEXTAUTH._session = undefined;

      __NEXTAUTH._getSession = function () {};
    };
  }, []);
  React.useEffect(function () {
    var unsubscribe = broadcast.receive(function () {
      return __NEXTAUTH._getSession({
        event: "storage"
      });
    });
    return function () {
      return unsubscribe();
    };
  }, []);
  React.useEffect(function () {
    var _props$refetchOnWindo = props.refetchOnWindowFocus,
        refetchOnWindowFocus = _props$refetchOnWindo === void 0 ? true : _props$refetchOnWindo;

    var visibilityHandler = function visibilityHandler() {
      if (refetchOnWindowFocus && document.visibilityState === "visible") __NEXTAUTH._getSession({
        event: "visibilitychange"
      });
    };

    document.addEventListener("visibilitychange", visibilityHandler, false);
    return function () {
      return document.removeEventListener("visibilitychange", visibilityHandler, false);
    };
  }, [props.refetchOnWindowFocus]);
  React.useEffect(function () {
    var refetchInterval = props.refetchInterval;

    if (refetchInterval) {
      var refetchIntervalTimer = setInterval(function () {
        if (__NEXTAUTH._session) {
          __NEXTAUTH._getSession({
            event: "poll"
          });
        }
      }, refetchInterval * 1000);
      return function () {
        return clearInterval(refetchIntervalTimer);
      };
    }
  }, [props.refetchInterval]);
  var value = React.useMemo(function () {
    return {
      data: session,
      status: loading ? "loading" : session ? "authenticated" : "unauthenticated"
    };
  }, [session, loading]);
  return (0, _jsxRuntime.jsx)(SessionContext.Provider, {
    value: value,
    children: children
  });
}

/***/ }),

/***/ 527:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

/***/ }),

/***/ 26553:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(95318);

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
exports.proxyLogger = proxyLogger;
exports.setLogger = setLogger;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(59713));

var _errors = __webpack_require__(36925);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function formatError(o) {
  if (o instanceof Error && !(o instanceof _errors.UnknownError)) {
    return {
      message: o.message,
      stack: o.stack,
      name: o.name
    };
  }

  if (hasErrorProperty(o)) {
    var _o$message;

    o.error = formatError(o.error);
    o.message = (_o$message = o.message) !== null && _o$message !== void 0 ? _o$message : o.error.message;
  }

  return o;
}

function hasErrorProperty(x) {
  return !!(x !== null && x !== void 0 && x.error);
}

var _logger = {
  error: function error(code, metadata) {
    metadata = formatError(metadata);
    console.error("[next-auth][error][".concat(code, "]"), "\nhttps://next-auth.js.org/errors#".concat(code.toLowerCase()), metadata.message, metadata);
  },
  warn: function warn(code) {
    console.warn("[next-auth][warn][".concat(code, "]"), "\nhttps://next-auth.js.org/warnings#".concat(code.toLowerCase()));
  },
  debug: function debug(code, metadata) {
    console.log("[next-auth][debug][".concat(code, "]"), metadata);
  }
};

function setLogger() {
  var newLogger = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var debug = arguments.length > 1 ? arguments[1] : undefined;
  if (!debug) _logger.debug = function () {};
  if (newLogger.error) _logger.error = newLogger.error;
  if (newLogger.warn) _logger.warn = newLogger.warn;
  if (newLogger.debug) _logger.debug = newLogger.debug;
}

var _default = _logger;
exports["default"] = _default;

function proxyLogger() {
  var logger = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _logger;
  var basePath = arguments.length > 1 ? arguments[1] : undefined;

  try {
    if (typeof window === "undefined") {
      return logger;
    }

    var clientLogger = {};

    var _loop = function _loop(level) {
      clientLogger[level] = function (code, metadata) {
        _logger[level](code, metadata);

        if (level === "error") {
          metadata = formatError(metadata);
        }

        ;
        metadata.client = true;
        var url = "".concat(basePath, "/_log");
        var body = new URLSearchParams(_objectSpread({
          level: level,
          code: code
        }, metadata));

        if (navigator.sendBeacon) {
          return navigator.sendBeacon(url, body);
        }

        return fetch(url, {
          method: "POST",
          body: body,
          keepalive: true
        });
      };
    };

    for (var level in logger) {
      _loop(level);
    }

    return clientLogger;
  } catch (_unused) {
    return _logger;
  }
}

/***/ }),

/***/ 30762:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = parseUrl;

function parseUrl(url) {
  var _url2;

  const defaultUrl = new URL("http://localhost:3000/api/auth");

  if (url && !url.startsWith("http")) {
    url = `https://${url}`;
  }

  const _url = new URL((_url2 = url) !== null && _url2 !== void 0 ? _url2 : defaultUrl);

  const path = (_url.pathname === "/" ? defaultUrl.pathname : _url.pathname).replace(/\/$/, "");
  const base = `${_url.origin}${path}`;
  return {
    origin: _url.origin,
    host: _url.host,
    path,
    base,
    toString: () => base
  };
}

/***/ }),

/***/ 2962:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PB": function() { return /* binding */ NextSeo; },
/* harmony export */   "lX": function() { return /* binding */ DefaultSeo; }
/* harmony export */ });
/* unused harmony exports ArticleJsonLd, BrandJsonLd, BreadcrumbJsonLd, CarouselJsonLd, CollectionPageJsonLd, CorporateContactJsonLd, CourseJsonLd, DatasetJsonLd, EventJsonLd, FAQPageJsonLd, HowToJsonLd, JobPostingJsonLd, LocalBusinessJsonLd, LogoJsonLd, NewsArticleJsonLd, OrganizationJsonLd, ProductJsonLd, ProfilePageJsonLd, QAPageJsonLd, RecipeJsonLd, SiteLinksSearchBoxJsonLd, SocialProfileJsonLd, SoftwareAppJsonLd, VideoGameJsonLd, VideoJsonLd, WebPageJsonLd */
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);



function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var defaults = {
  templateTitle: '',
  noindex: false,
  nofollow: false,
  defaultOpenGraphImageWidth: 0,
  defaultOpenGraphImageHeight: 0,
  defaultOpenGraphVideoWidth: 0,
  defaultOpenGraphVideoHeight: 0
};

var buildOpenGraphMediaTags = function buildOpenGraphMediaTags(mediaType, media, _temp) {
  if (media === void 0) {
    media = [];
  }

  var _ref = _temp === void 0 ? {} : _temp,
      defaultWidth = _ref.defaultWidth,
      defaultHeight = _ref.defaultHeight;

  return media.reduce(function (tags, medium, index) {
    tags.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("meta", {
      key: "og:" + mediaType + ":0" + index,
      property: "og:" + mediaType,
      content: medium.url
    }));

    if (medium.alt) {
      tags.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("meta", {
        key: "og:" + mediaType + ":alt0" + index,
        property: "og:" + mediaType + ":alt",
        content: medium.alt
      }));
    }

    if (medium.secureUrl) {
      tags.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("meta", {
        key: "og:" + mediaType + ":secure_url0" + index,
        property: "og:" + mediaType + ":secure_url",
        content: medium.secureUrl.toString()
      }));
    }

    if (medium.type) {
      tags.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("meta", {
        key: "og:" + mediaType + ":type0" + index,
        property: "og:" + mediaType + ":type",
        content: medium.type.toString()
      }));
    }

    if (medium.width) {
      tags.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("meta", {
        key: "og:" + mediaType + ":width0" + index,
        property: "og:" + mediaType + ":width",
        content: medium.width.toString()
      }));
    } else if (defaultWidth) {
      tags.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("meta", {
        key: "og:" + mediaType + ":width0" + index,
        property: "og:" + mediaType + ":width",
        content: defaultWidth.toString()
      }));
    }

    if (medium.height) {
      tags.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("meta", {
        key: "og:" + mediaType + ":height" + index,
        property: "og:" + mediaType + ":height",
        content: medium.height.toString()
      }));
    } else if (defaultHeight) {
      tags.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("meta", {
        key: "og:" + mediaType + ":height" + index,
        property: "og:" + mediaType + ":height",
        content: defaultHeight.toString()
      }));
    }

    return tags;
  }, []);
};

var buildTags = function buildTags(config) {
  var _config$openGraph, _config$openGraph3, _config$additionalLin;

  var tagsToRender = [];

  if (config.titleTemplate) {
    defaults.templateTitle = config.titleTemplate;
  }

  var updatedTitle = '';

  if (config.title) {
    updatedTitle = config.title;

    if (defaults.templateTitle) {
      updatedTitle = defaults.templateTitle.replace(/%s/g, function () {
        return updatedTitle;
      });
    }
  } else if (config.defaultTitle) {
    updatedTitle = config.defaultTitle;
  }

  if (updatedTitle) {
    tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("title", {
      key: "title"
    }, updatedTitle));
  }

  var noindex = config.noindex || defaults.noindex || config.dangerouslySetAllPagesToNoIndex;
  var nofollow = config.nofollow || defaults.nofollow || config.dangerouslySetAllPagesToNoFollow;
  var robotsParams = '';

  if (config.robotsProps) {
    var _config$robotsProps = config.robotsProps,
        nosnippet = _config$robotsProps.nosnippet,
        maxSnippet = _config$robotsProps.maxSnippet,
        maxImagePreview = _config$robotsProps.maxImagePreview,
        maxVideoPreview = _config$robotsProps.maxVideoPreview,
        noarchive = _config$robotsProps.noarchive,
        noimageindex = _config$robotsProps.noimageindex,
        notranslate = _config$robotsProps.notranslate,
        unavailableAfter = _config$robotsProps.unavailableAfter;
    robotsParams = "" + (nosnippet ? ',nosnippet' : '') + (maxSnippet ? ",max-snippet:" + maxSnippet : '') + (maxImagePreview ? ",max-image-preview:" + maxImagePreview : '') + (noarchive ? ',noarchive' : '') + (unavailableAfter ? ",unavailable_after:" + unavailableAfter : '') + (noimageindex ? ',noimageindex' : '') + (maxVideoPreview ? ",max-video-preview:" + maxVideoPreview : '') + (notranslate ? ',notranslate' : '');
  }

  if (noindex || nofollow) {
    if (config.dangerouslySetAllPagesToNoIndex) {
      defaults.noindex = true;
    }

    if (config.dangerouslySetAllPagesToNoFollow) {
      defaults.nofollow = true;
    }

    tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("meta", {
      key: "robots",
      name: "robots",
      content: (noindex ? 'noindex' : 'index') + "," + (nofollow ? 'nofollow' : 'follow') + robotsParams
    }));
  } else {
    tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("meta", {
      key: "robots",
      name: "robots",
      content: "index,follow" + robotsParams
    }));
  }

  if (config.description) {
    tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("meta", {
      key: "description",
      name: "description",
      content: config.description
    }));
  }

  if (config.mobileAlternate) {
    tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("link", {
      rel: "alternate",
      key: "mobileAlternate",
      media: config.mobileAlternate.media,
      href: config.mobileAlternate.href
    }));
  }

  if (config.languageAlternates && config.languageAlternates.length > 0) {
    config.languageAlternates.forEach(function (languageAlternate) {
      tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("link", {
        rel: "alternate",
        key: "languageAlternate-" + languageAlternate.hrefLang,
        hrefLang: languageAlternate.hrefLang,
        href: languageAlternate.href
      }));
    });
  }

  if (config.twitter) {
    if (config.twitter.cardType) {
      tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("meta", {
        key: "twitter:card",
        name: "twitter:card",
        content: config.twitter.cardType
      }));
    }

    if (config.twitter.site) {
      tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("meta", {
        key: "twitter:site",
        name: "twitter:site",
        content: config.twitter.site
      }));
    }

    if (config.twitter.handle) {
      tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("meta", {
        key: "twitter:creator",
        name: "twitter:creator",
        content: config.twitter.handle
      }));
    }
  }

  if (config.facebook) {
    if (config.facebook.appId) {
      tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("meta", {
        key: "fb:app_id",
        property: "fb:app_id",
        content: config.facebook.appId
      }));
    }
  }

  if ((_config$openGraph = config.openGraph) != null && _config$openGraph.title || updatedTitle) {
    var _config$openGraph2;

    tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("meta", {
      key: "og:title",
      property: "og:title",
      content: ((_config$openGraph2 = config.openGraph) == null ? void 0 : _config$openGraph2.title) || updatedTitle
    }));
  }

  if ((_config$openGraph3 = config.openGraph) != null && _config$openGraph3.description || config.description) {
    var _config$openGraph4;

    tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("meta", {
      key: "og:description",
      property: "og:description",
      content: ((_config$openGraph4 = config.openGraph) == null ? void 0 : _config$openGraph4.description) || config.description
    }));
  }

  if (config.openGraph) {
    if (config.openGraph.url || config.canonical) {
      tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("meta", {
        key: "og:url",
        property: "og:url",
        content: config.openGraph.url || config.canonical
      }));
    }

    if (config.openGraph.type) {
      var type = config.openGraph.type.toLowerCase();
      tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("meta", {
        key: "og:type",
        property: "og:type",
        content: type
      }));

      if (type === 'profile' && config.openGraph.profile) {
        if (config.openGraph.profile.firstName) {
          tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("meta", {
            key: "profile:first_name",
            property: "profile:first_name",
            content: config.openGraph.profile.firstName
          }));
        }

        if (config.openGraph.profile.lastName) {
          tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("meta", {
            key: "profile:last_name",
            property: "profile:last_name",
            content: config.openGraph.profile.lastName
          }));
        }

        if (config.openGraph.profile.username) {
          tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("meta", {
            key: "profile:username",
            property: "profile:username",
            content: config.openGraph.profile.username
          }));
        }

        if (config.openGraph.profile.gender) {
          tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("meta", {
            key: "profile:gender",
            property: "profile:gender",
            content: config.openGraph.profile.gender
          }));
        }
      } else if (type === 'book' && config.openGraph.book) {
        if (config.openGraph.book.authors && config.openGraph.book.authors.length) {
          config.openGraph.book.authors.forEach(function (author, index) {
            tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("meta", {
              key: "book:author:0" + index,
              property: "book:author",
              content: author
            }));
          });
        }

        if (config.openGraph.book.isbn) {
          tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("meta", {
            key: "book:isbn",
            property: "book:isbn",
            content: config.openGraph.book.isbn
          }));
        }

        if (config.openGraph.book.releaseDate) {
          tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("meta", {
            key: "book:release_date",
            property: "book:release_date",
            content: config.openGraph.book.releaseDate
          }));
        }

        if (config.openGraph.book.tags && config.openGraph.book.tags.length) {
          config.openGraph.book.tags.forEach(function (tag, index) {
            tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("meta", {
              key: "book:tag:0" + index,
              property: "book:tag",
              content: tag
            }));
          });
        }
      } else if (type === 'article' && config.openGraph.article) {
        if (config.openGraph.article.publishedTime) {
          tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("meta", {
            key: "article:published_time",
            property: "article:published_time",
            content: config.openGraph.article.publishedTime
          }));
        }

        if (config.openGraph.article.modifiedTime) {
          tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("meta", {
            key: "article:modified_time",
            property: "article:modified_time",
            content: config.openGraph.article.modifiedTime
          }));
        }

        if (config.openGraph.article.expirationTime) {
          tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("meta", {
            key: "article:expiration_time",
            property: "article:expiration_time",
            content: config.openGraph.article.expirationTime
          }));
        }

        if (config.openGraph.article.authors && config.openGraph.article.authors.length) {
          config.openGraph.article.authors.forEach(function (author, index) {
            tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("meta", {
              key: "article:author:0" + index,
              property: "article:author",
              content: author
            }));
          });
        }

        if (config.openGraph.article.section) {
          tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("meta", {
            key: "article:section",
            property: "article:section",
            content: config.openGraph.article.section
          }));
        }

        if (config.openGraph.article.tags && config.openGraph.article.tags.length) {
          config.openGraph.article.tags.forEach(function (tag, index) {
            tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("meta", {
              key: "article:tag:0" + index,
              property: "article:tag",
              content: tag
            }));
          });
        }
      } else if ((type === 'video.movie' || type === 'video.episode' || type === 'video.tv_show' || type === 'video.other') && config.openGraph.video) {
        if (config.openGraph.video.actors && config.openGraph.video.actors.length) {
          config.openGraph.video.actors.forEach(function (actor, index) {
            if (actor.profile) {
              tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("meta", {
                key: "video:actor:0" + index,
                property: "video:actor",
                content: actor.profile
              }));
            }

            if (actor.role) {
              tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("meta", {
                key: "video:actor:role:0" + index,
                property: "video:actor:role",
                content: actor.role
              }));
            }
          });
        }

        if (config.openGraph.video.directors && config.openGraph.video.directors.length) {
          config.openGraph.video.directors.forEach(function (director, index) {
            tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("meta", {
              key: "video:director:0" + index,
              property: "video:director",
              content: director
            }));
          });
        }

        if (config.openGraph.video.writers && config.openGraph.video.writers.length) {
          config.openGraph.video.writers.forEach(function (writer, index) {
            tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("meta", {
              key: "video:writer:0" + index,
              property: "video:writer",
              content: writer
            }));
          });
        }

        if (config.openGraph.video.duration) {
          tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("meta", {
            key: "video:duration",
            property: "video:duration",
            content: config.openGraph.video.duration.toString()
          }));
        }

        if (config.openGraph.video.releaseDate) {
          tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("meta", {
            key: "video:release_date",
            property: "video:release_date",
            content: config.openGraph.video.releaseDate
          }));
        }

        if (config.openGraph.video.tags && config.openGraph.video.tags.length) {
          config.openGraph.video.tags.forEach(function (tag, index) {
            tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("meta", {
              key: "video:tag:0" + index,
              property: "video:tag",
              content: tag
            }));
          });
        }

        if (config.openGraph.video.series) {
          tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("meta", {
            key: "video:series",
            property: "video:series",
            content: config.openGraph.video.series
          }));
        }
      }
    } // images


    if (config.defaultOpenGraphImageWidth) {
      defaults.defaultOpenGraphImageWidth = config.defaultOpenGraphImageWidth;
    }

    if (config.defaultOpenGraphImageHeight) {
      defaults.defaultOpenGraphImageHeight = config.defaultOpenGraphImageHeight;
    }

    if (config.openGraph.images && config.openGraph.images.length) {
      tagsToRender.push.apply(tagsToRender, buildOpenGraphMediaTags('image', config.openGraph.images, {
        defaultWidth: defaults.defaultOpenGraphImageWidth,
        defaultHeight: defaults.defaultOpenGraphImageHeight
      }));
    } // videos


    if (config.defaultOpenGraphVideoWidth) {
      defaults.defaultOpenGraphVideoWidth = config.defaultOpenGraphVideoWidth;
    }

    if (config.defaultOpenGraphVideoHeight) {
      defaults.defaultOpenGraphVideoHeight = config.defaultOpenGraphVideoHeight;
    }

    if (config.openGraph.videos && config.openGraph.videos.length) {
      tagsToRender.push.apply(tagsToRender, buildOpenGraphMediaTags('video', config.openGraph.videos, {
        defaultWidth: defaults.defaultOpenGraphVideoWidth,
        defaultHeight: defaults.defaultOpenGraphVideoHeight
      }));
    }

    if (config.openGraph.locale) {
      tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("meta", {
        key: "og:locale",
        property: "og:locale",
        content: config.openGraph.locale
      }));
    }

    if (config.openGraph.site_name) {
      tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("meta", {
        key: "og:site_name",
        property: "og:site_name",
        content: config.openGraph.site_name
      }));
    }
  }

  if (config.canonical) {
    tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("link", {
      rel: "canonical",
      href: config.canonical,
      key: "canonical"
    }));
  }

  if (config.additionalMetaTags && config.additionalMetaTags.length > 0) {
    config.additionalMetaTags.forEach(function (tag) {
      var _ref2, _ref3, _tag$keyOverride;

      tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("meta", _extends({
        key: "meta:" + ((_ref2 = (_ref3 = (_tag$keyOverride = tag.keyOverride) != null ? _tag$keyOverride : tag.name) != null ? _ref3 : tag.property) != null ? _ref2 : tag.httpEquiv)
      }, tag)));
    });
  }

  if ((_config$additionalLin = config.additionalLinkTags) != null && _config$additionalLin.length) {
    config.additionalLinkTags.forEach(function (tag) {
      var _tag$keyOverride2;

      tagsToRender.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement("link", _extends({
        key: "link" + ((_tag$keyOverride2 = tag.keyOverride) != null ? _tag$keyOverride2 : tag.href) + tag.rel
      }, tag)));
    });
  }

  return tagsToRender;
};

var DefaultSeo = /*#__PURE__*/function (_Component) {
  _inheritsLoose(DefaultSeo, _Component);

  function DefaultSeo() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = DefaultSeo.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        title = _this$props.title,
        titleTemplate = _this$props.titleTemplate,
        defaultTitle = _this$props.defaultTitle,
        _this$props$dangerous = _this$props.dangerouslySetAllPagesToNoIndex,
        dangerouslySetAllPagesToNoIndex = _this$props$dangerous === void 0 ? false : _this$props$dangerous,
        _this$props$dangerous2 = _this$props.dangerouslySetAllPagesToNoFollow,
        dangerouslySetAllPagesToNoFollow = _this$props$dangerous2 === void 0 ? false : _this$props$dangerous2,
        description = _this$props.description,
        canonical = _this$props.canonical,
        facebook = _this$props.facebook,
        openGraph = _this$props.openGraph,
        additionalMetaTags = _this$props.additionalMetaTags,
        twitter = _this$props.twitter,
        defaultOpenGraphImageWidth = _this$props.defaultOpenGraphImageWidth,
        defaultOpenGraphImageHeight = _this$props.defaultOpenGraphImageHeight,
        defaultOpenGraphVideoWidth = _this$props.defaultOpenGraphVideoWidth,
        defaultOpenGraphVideoHeight = _this$props.defaultOpenGraphVideoHeight,
        mobileAlternate = _this$props.mobileAlternate,
        languageAlternates = _this$props.languageAlternates,
        additionalLinkTags = _this$props.additionalLinkTags,
        robotsProps = _this$props.robotsProps;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement((next_head__WEBPACK_IMPORTED_MODULE_0___default()), null, buildTags({
      title: title,
      titleTemplate: titleTemplate,
      defaultTitle: defaultTitle,
      dangerouslySetAllPagesToNoIndex: dangerouslySetAllPagesToNoIndex,
      dangerouslySetAllPagesToNoFollow: dangerouslySetAllPagesToNoFollow,
      description: description,
      canonical: canonical,
      facebook: facebook,
      openGraph: openGraph,
      additionalMetaTags: additionalMetaTags,
      twitter: twitter,
      defaultOpenGraphImageWidth: defaultOpenGraphImageWidth,
      defaultOpenGraphImageHeight: defaultOpenGraphImageHeight,
      defaultOpenGraphVideoWidth: defaultOpenGraphVideoWidth,
      defaultOpenGraphVideoHeight: defaultOpenGraphVideoHeight,
      mobileAlternate: mobileAlternate,
      languageAlternates: languageAlternates,
      additionalLinkTags: additionalLinkTags,
      robotsProps: robotsProps
    }));
  };

  return DefaultSeo;
}(react__WEBPACK_IMPORTED_MODULE_1__.Component);

var NextSeo = /*#__PURE__*/function (_Component) {
  _inheritsLoose(NextSeo, _Component);

  function NextSeo() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = NextSeo.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        title = _this$props.title,
        _this$props$noindex = _this$props.noindex,
        noindex = _this$props$noindex === void 0 ? false : _this$props$noindex,
        nofollow = _this$props.nofollow,
        robotsProps = _this$props.robotsProps,
        description = _this$props.description,
        canonical = _this$props.canonical,
        openGraph = _this$props.openGraph,
        facebook = _this$props.facebook,
        twitter = _this$props.twitter,
        additionalMetaTags = _this$props.additionalMetaTags,
        titleTemplate = _this$props.titleTemplate,
        defaultTitle = _this$props.defaultTitle,
        mobileAlternate = _this$props.mobileAlternate,
        languageAlternates = _this$props.languageAlternates,
        additionalLinkTags = _this$props.additionalLinkTags;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.createElement((next_head__WEBPACK_IMPORTED_MODULE_0___default()), null, buildTags({
      title: title,
      noindex: noindex,
      nofollow: nofollow,
      robotsProps: robotsProps,
      description: description,
      canonical: canonical,
      facebook: facebook,
      openGraph: openGraph,
      additionalMetaTags: additionalMetaTags,
      twitter: twitter,
      titleTemplate: titleTemplate,
      defaultTitle: defaultTitle,
      mobileAlternate: mobileAlternate,
      languageAlternates: languageAlternates,
      additionalLinkTags: additionalLinkTags
    }));
  };

  return NextSeo;
}(react__WEBPACK_IMPORTED_MODULE_1__.Component);

var toJson = function toJson(type, jsonld) {
  var _jsonld$id = jsonld.id,
      id = _jsonld$id === void 0 ? undefined : _jsonld$id;

  var updated = _extends({}, id ? {
    '@id': jsonld.id
  } : {}, jsonld);

  delete updated.id;
  return {
    __html: JSON.stringify(_extends({
      '@context': 'https://schema.org',
      '@type': type
    }, updated), safeJsonLdReplacer)
  };
};

var ESCAPE_ENTITIES = Object.freeze({
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&apos;'
});
var ESCAPE_REGEX = new RegExp("[" + Object.keys(ESCAPE_ENTITIES).join('') + "]", 'g');

var ESCAPE_REPLACER = function ESCAPE_REPLACER(t) {
  return ESCAPE_ENTITIES[t];
};
/**
 * A replacer for JSON.stringify to strip JSON-LD of illegal HTML entities
 * per https://www.w3.org/TR/json-ld11/#restrictions-for-contents-of-json-ld-script-elements
 */


var safeJsonLdReplacer = function () {
  // Replace per https://www.w3.org/TR/json-ld11/#restrictions-for-contents-of-json-ld-script-elements
  // Solution from https://stackoverflow.com/a/5499821/864313
  return function (_, value) {
    switch (typeof value) {
      case 'object':
        // Omit null values.
        if (value === null) {
          return undefined;
        }

        return value;
      // JSON.stringify will recursively call replacer.

      case 'number':
      case 'boolean':
      case 'bigint':
        return value;
      // These values are not risky.

      case 'string':
        return value.replace(ESCAPE_REGEX, ESCAPE_REPLACER);

      default:
        {

          return undefined;
        }
    }
  };
}(); // Utility: Assert never

function JsonLd(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'Thing' : _ref$type,
      keyOverride = _ref.keyOverride,
      scriptKey = _ref.scriptKey,
      _ref$scriptId = _ref.scriptId,
      scriptId = _ref$scriptId === void 0 ? undefined : _ref$scriptId,
      rest = _objectWithoutPropertiesLoose(_ref, ["type", "keyOverride", "scriptKey", "scriptId"]);

  return /*#__PURE__*/React.createElement(Head, null, /*#__PURE__*/React.createElement("script", {
    type: "application/ld+json",
    id: scriptId,
    dangerouslySetInnerHTML: toJson(type, _extends({}, rest)),
    key: "jsonld-" + scriptKey + (keyOverride ? "-" + keyOverride : '')
  }));
}

/**
 * Include name and url
 * @param author
 * @returns
 */
function includeNameAndUrl(author) {
  return typeof author === 'object' && !!(author.name && author.url);
}
/**
 * Generate author information
 * @param author
 * @returns
 */


function generateAuthorInfo(author) {
  if (typeof author === 'string') {
    return {
      '@type': 'Person',
      name: author
    };
  } else if (includeNameAndUrl(author)) {
    return {
      '@type': 'Person',
      name: author.name,
      url: author.url
    };
  }

  return;
}

function setAuthor(author) {
  if (Array.isArray(author)) {
    return author.map(function (item) {
      return generateAuthorInfo(item);
    }).filter(function (item) {
      return !!item;
    });
  } else if (author) {
    return generateAuthorInfo(author);
  }

  return;
}

function setImage(image) {
  if (image) {
    return {
      '@type': 'ImageObject',
      url: image
    };
  }

  return undefined;
}

function setPublisher(publisherName, publisherLogo) {
  if (!publisherName) {
    return undefined;
  }

  return {
    '@type': 'Organization',
    name: publisherName,
    logo: setImage(publisherLogo)
  };
}

function setReviewRating(rating) {
  if (rating) {
    return _extends({}, rating, {
      '@type': 'Rating'
    });
  }

  return undefined;
}

function setReviews(reviews) {
  function mapReview(_ref) {
    var reviewRating = _ref.reviewRating,
        author = _ref.author,
        publisher = _ref.publisher,
        rest = _objectWithoutPropertiesLoose(_ref, ["reviewRating", "author", "publisher"]);

    return _extends({}, rest, {
      '@type': 'Review'
    }, author && {
      author: setAuthor(author)
    }, reviewRating && {
      reviewRating: setReviewRating(reviewRating)
    }, publisher && {
      publisher: setPublisher(publisher.name)
    });
  }

  if (Array.isArray(reviews)) {
    return reviews.map(mapReview);
  } else if (reviews) {
    return mapReview(reviews);
  }

  return undefined;
}

function setNutrition(calories) {
  if (calories) {
    return {
      '@type': 'NutritionInformation',
      calories: calories + " calories"
    };
  }

  return undefined;
}

function setAggregateRating(aggregateRating) {
  if (aggregateRating) {
    return {
      '@type': 'AggregateRating',
      ratingCount: aggregateRating.ratingCount,
      reviewCount: aggregateRating.reviewCount,
      bestRating: aggregateRating.bestRating,
      ratingValue: aggregateRating.ratingValue
    };
  }

  return undefined;
}

function setClip(clips) {
  function mapClip(clip) {
    return _extends({}, clip, {
      '@type': 'Clip'
    });
  }

  if (Array.isArray(clips)) {
    return clips.map(mapClip);
  } else if (clips) {
    return mapClip(clips);
  }

  return undefined;
}

function setInteractionStatistic(watchCount) {
  if (watchCount) {
    return {
      '@type': 'InteractionCounter',
      interactionType: 'https://schema.org/WatchAction',
      userInteractionCount: watchCount
    };
  }

  return undefined;
}

function setBroadcastEvent(publication) {
  function mapBroadcastEvent(publication) {
    return _extends({}, publication, {
      '@type': 'BroadcastEvent'
    });
  }

  if (publication) {
    if (Array.isArray(publication)) {
      return publication.map(mapBroadcastEvent);
    }

    return mapBroadcastEvent(publication);
  }

  return undefined;
}

function setVideo(video, setContext) {
  if (setContext === void 0) {
    setContext = false;
  }

  function mapVideo(_ref, context) {
    var thumbnailUrls = _ref.thumbnailUrls,
        hasPart = _ref.hasPart,
        watchCount = _ref.watchCount,
        publication = _ref.publication,
        rest = _objectWithoutPropertiesLoose(_ref, ["thumbnailUrls", "hasPart", "watchCount", "publication"]);

    return _extends({}, rest, {
      '@type': 'VideoObject'
    }, context && {
      '@context': 'https://schema.org'
    }, {
      thumbnailUrl: thumbnailUrls,
      hasPart: setClip(hasPart),
      interactionStatistic: setInteractionStatistic(watchCount),
      publication: setBroadcastEvent(publication)
    });
  }

  if (video) {
    return mapVideo(video, setContext);
  }

  return undefined;
}

function setInstruction(instruction) {
  if (instruction) {
    return _extends({}, instruction, {
      '@type': 'HowToStep'
    });
  }

  return undefined;
}

function CarouselJsonLd(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'Carousel' : _ref$type,
      keyOverride = _ref.keyOverride,
      ofType = _ref.ofType,
      data = _ref.data;

  function generateList(data, ofType) {
    switch (ofType) {
      case 'default':
        return data.map(function (item, index) {
          return {
            '@type': 'ListItem',
            position: "" + (index + 1),
            url: item.url
          };
        });

      case 'course':
        return data.map(function (item, index) {
          return {
            '@type': 'ListItem',
            position: "" + (index + 1),
            item: {
              '@context': 'https://schema.org',
              '@type': 'Course',
              url: item.url,
              name: item.courseName,
              description: item.description,
              provider: {
                '@type': 'Organization',
                name: item.providerName,
                sameAs: item.providerUrl
              }
            }
          };
        });

      case 'movie':
        return data.map(function (item, index) {
          return {
            '@type': 'ListItem',
            position: "" + (index + 1),
            item: {
              '@context': 'https://schema.org',
              '@type': 'Movie',
              name: item.name,
              url: item.url,
              image: item.image,
              dateCreated: item.dateCreated,
              director: item.director ? Array.isArray(item.director) ? item.director.map(function (director) {
                return {
                  '@type': 'Person',
                  name: director.name
                };
              }) : {
                '@type': 'Person',
                name: item.director.name
              } : undefined,
              review: setReviews(item.review)
            }
          };
        });

      case 'recipe':
        return data.map(function (_ref2, index) {
          var authorName = _ref2.authorName,
              images = _ref2.images,
              yields = _ref2.yields,
              category = _ref2.category,
              calories = _ref2.calories,
              aggregateRating = _ref2.aggregateRating,
              video = _ref2.video,
              ingredients = _ref2.ingredients,
              instructions = _ref2.instructions,
              cuisine = _ref2.cuisine,
              rest = _objectWithoutPropertiesLoose(_ref2, ["authorName", "images", "yields", "category", "calories", "aggregateRating", "video", "ingredients", "instructions", "cuisine"]);

          return {
            '@type': 'ListItem',
            position: "" + (index + 1),
            item: _extends({
              '@context': 'https://schema.org',
              '@type': 'Recipe'
            }, rest, {
              author: setAuthor(authorName),
              image: images,
              recipeYield: yields,
              recipeCategory: category,
              recipeCuisine: cuisine,
              nutrition: setNutrition(calories),
              aggregateRating: setAggregateRating(aggregateRating),
              video: setVideo(video),
              recipeIngredient: ingredients,
              recipeInstructions: instructions.map(setInstruction)
            })
          };
        });
    }
  }

  var d = {
    '@type': 'ItemList',
    itemListElement: generateList(data, ofType)
  };
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, d, {
    scriptKey: "Carousel"
  }));
}

function NewsArticleJsonLd(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'NewsArticle' : _ref$type,
      keyOverride = _ref.keyOverride,
      url = _ref.url,
      title = _ref.title,
      images = _ref.images,
      section = _ref.section,
      dateCreated = _ref.dateCreated,
      datePublished = _ref.datePublished,
      dateModified = _ref.dateModified,
      authorName = _ref.authorName,
      publisherName = _ref.publisherName,
      publisherLogo = _ref.publisherLogo,
      body = _ref.body,
      rest = _objectWithoutPropertiesLoose(_ref, ["type", "keyOverride", "url", "title", "images", "section", "dateCreated", "datePublished", "dateModified", "authorName", "publisherName", "publisherLogo", "body"]);

  var data = _extends({}, rest, {
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': url
    },
    headline: title,
    image: images,
    articleSection: section,
    dateCreated: dateCreated || datePublished,
    datePublished: datePublished,
    dateModified: dateModified || datePublished,
    author: setAuthor(authorName),
    publisher: setPublisher(publisherName, publisherLogo),
    articleBody: body
  });

  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "NewsArticle"
  }));
}

function JobPostingJsonLd(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'JobPosting' : _ref$type,
      keyOverride = _ref.keyOverride,
      baseSalary = _ref.baseSalary,
      hiringOrganization = _ref.hiringOrganization,
      applicantLocationRequirements = _ref.applicantLocationRequirements,
      jobLocation = _ref.jobLocation,
      rest = _objectWithoutPropertiesLoose(_ref, ["type", "keyOverride", "baseSalary", "hiringOrganization", "applicantLocationRequirements", "jobLocation"]);

  function setBaseSalary(baseSalary) {
    if (baseSalary) {
      return {
        '@type': 'MonetaryAmount',
        currency: baseSalary.currency,
        value: _extends({
          '@type': 'QuantitativeValue',
          unitText: baseSalary.unitText
        }, Array.isArray(baseSalary.value) ? {
          minValue: baseSalary.value[0],
          maxValue: baseSalary.value[1]
        } : {
          value: baseSalary.value
        })
      };
    }

    return undefined;
  }

  function setHiringOrganization(org) {
    return {
      '@type': 'Organization',
      name: org.name,
      sameAs: org.sameAs,
      logo: org.logo
    };
  }

  function setJobLocation(location) {
    if (location) {
      return {
        '@type': 'Place',
        address: {
          '@type': 'PostalAddress',
          addressCountry: location.addressCountry,
          addressLocality: location.addressLocality,
          addressRegion: location.addressRegion,
          postalCode: location.postalCode,
          streetAddress: location.streetAddress
        }
      };
    }

    return undefined;
  }

  function setApplicantLocationRequirements(requirements) {
    if (requirements) {
      return {
        '@type': 'Country',
        name: requirements
      };
    }

    return undefined;
  }

  var data = _extends({}, rest, {
    baseSalary: setBaseSalary(baseSalary),
    hiringOrganization: setHiringOrganization(hiringOrganization),
    jobLocation: setJobLocation(jobLocation),
    applicantLocationRequirements: setApplicantLocationRequirements(applicantLocationRequirements)
  });

  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "JobPosting"
  }));
}

function setAddress(address) {
  if (address) {
    return _extends({
      '@type': 'PostalAddress'
    }, address);
  }

  return undefined;
}

function setGeo(geo) {
  if (geo) {
    return _extends({}, geo, {
      '@type': 'GeoCoordinates'
    });
  }

  return undefined;
}

function setAction(action) {
  if (action) {
    return {
      '@type': action.actionType,
      name: action.actionName,
      target: action.target
    };
  }

  return undefined;
}

function setGeoCircle(geoCircle) {
  if (geoCircle) {
    return {
      '@type': 'GeoCircle',
      geoMidpoint: {
        '@type': 'GeoCoordinates',
        latitude: geoCircle.geoMidpoint.latitude,
        longitude: geoCircle.geoMidpoint.longitude
      },
      geoRadius: geoCircle.geoRadius
    };
  }

  return undefined;
}

function setOffer(offer) {
  function setPriceSpecification(priceSpecification) {
    if (priceSpecification) {
      return {
        '@type': priceSpecification.type,
        priceCurrency: priceSpecification.priceCurrency,
        price: priceSpecification.price
      };
    }

    return undefined;
  }

  function setItemOffered(itemOffered) {
    if (itemOffered) {
      return _extends({}, itemOffered, {
        '@type': 'Service'
      });
    }

    return undefined;
  }

  if (offer) {
    return _extends({}, offer, {
      '@type': 'Offer',
      priceSpecification: setPriceSpecification(offer.priceSpecification),
      itemOffered: setItemOffered(offer.itemOffered)
    });
  }

  return undefined;
}

function setOpeningHours(openingHours) {
  if (openingHours) {
    return _extends({}, openingHours, {
      '@type': 'OpeningHoursSpecification'
    });
  }

  return undefined;
}

function LocalBusinessJsonLd(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'LocalBusiness' : _ref$type,
      keyOverride = _ref.keyOverride,
      address = _ref.address,
      geo = _ref.geo,
      rating = _ref.rating,
      review = _ref.review,
      action = _ref.action,
      areaServed = _ref.areaServed,
      makesOffer = _ref.makesOffer,
      openingHours = _ref.openingHours,
      images = _ref.images,
      rest = _objectWithoutPropertiesLoose(_ref, ["type", "keyOverride", "address", "geo", "rating", "review", "action", "areaServed", "makesOffer", "openingHours", "images"]);

  var data = _extends({}, rest, {
    image: images,
    address: setAddress(address),
    geo: setGeo(geo),
    aggregateRating: setAggregateRating(rating),
    review: setReviews(review),
    potentialAction: setAction(action),
    areaServed: areaServed && areaServed.map(setGeoCircle),
    makesOffer: makesOffer == null ? void 0 : makesOffer.map(setOffer),
    openingHoursSpecification: Array.isArray(openingHours) ? openingHours.map(setOpeningHours) : setOpeningHours(openingHours)
  });

  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "LocalBusiness"
  }));
}

function QAPageJsonLd(_ref) {
  var _mainEntity$author, _mainEntity$acceptedA, _mainEntity$acceptedA2;

  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'QAPage' : _ref$type,
      keyOverride = _ref.keyOverride,
      mainEntity = _ref.mainEntity,
      rest = _objectWithoutPropertiesLoose(_ref, ["type", "keyOverride", "mainEntity"]);

  var data = _extends({}, rest, {
    mainEntity: _extends({}, mainEntity, {
      '@type': 'Question',
      author: setAuthor((_mainEntity$author = mainEntity.author) == null ? void 0 : _mainEntity$author.name)
    }, mainEntity.acceptedAnswer && {
      acceptedAnswer: _extends({}, mainEntity.acceptedAnswer, {
        '@type': 'Answer',
        author: setAuthor((_mainEntity$acceptedA = mainEntity.acceptedAnswer) == null ? void 0 : (_mainEntity$acceptedA2 = _mainEntity$acceptedA.author) == null ? void 0 : _mainEntity$acceptedA2.name)
      })
    }, mainEntity.suggestedAnswer && {
      suggestedAnswer: mainEntity.suggestedAnswer.map(function (_ref2) {
        var _rest$author;

        var upvoteCount = _ref2.upvoteCount,
            rest = _objectWithoutPropertiesLoose(_ref2, ["upvoteCount"]);

        return _extends({}, rest, {
          '@type': 'Answer',
          upvoteCount: upvoteCount || 0,
          author: setAuthor((_rest$author = rest.author) == null ? void 0 : _rest$author.name)
        });
      })
    })
  });

  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "QAPage"
  }));
}

function setItemListElements(items) {
  if (items && items.length) {
    return items.map(function (item) {
      return {
        '@type': 'ListItem',
        position: item.position,
        item: {
          '@id': item.item,
          name: item.name
        }
      };
    });
  }

  return undefined;
}

function ProfilePageJsonLd(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'ProfilePage' : _ref$type,
      keyOverride = _ref.keyOverride,
      breadcrumb = _ref.breadcrumb,
      rest = _objectWithoutPropertiesLoose(_ref, ["type", "keyOverride", "breadcrumb"]);

  var data = _extends({}, rest, {
    breadcrumb: Array.isArray(breadcrumb) ? {
      '@type': 'BreadcrumbList',
      itemListElement: setItemListElements(breadcrumb)
    } : breadcrumb
  });

  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "ProfilePage"
  }));
}

function SiteLinksSearchBoxJsonLd(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'WebSite' : _ref$type,
      keyOverride = _ref.keyOverride,
      potentialActions = _ref.potentialActions,
      rest = _objectWithoutPropertiesLoose(_ref, ["type", "keyOverride", "potentialActions"]);

  function setPotentialAction(action) {
    if (action) {
      var target = action.target,
          queryInput = action.queryInput;
      return {
        '@type': 'SearchAction',
        target: target + "={" + queryInput + "}",
        'query-input': "required name=" + queryInput
      };
    }

    return undefined;
  }

  var data = _extends({}, rest, {
    potentialAction: potentialActions.map(setPotentialAction)
  });

  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "jsonld-siteLinksSearchBox"
  }));
}

function RecipeJsonLd(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'Recipe' : _ref$type,
      keyOverride = _ref.keyOverride,
      authorName = _ref.authorName,
      images = _ref.images,
      yields = _ref.yields,
      category = _ref.category,
      cuisine = _ref.cuisine,
      calories = _ref.calories,
      aggregateRating = _ref.aggregateRating,
      video = _ref.video,
      ingredients = _ref.ingredients,
      instructions = _ref.instructions,
      rest = _objectWithoutPropertiesLoose(_ref, ["type", "keyOverride", "authorName", "images", "yields", "category", "cuisine", "calories", "aggregateRating", "video", "ingredients", "instructions"]);

  var data = _extends({}, rest, {
    author: setAuthor(authorName),
    image: images,
    recipeYield: yields,
    recipeCategory: category,
    recipeCuisine: cuisine,
    nutrition: setNutrition(calories),
    aggregateRating: setAggregateRating(aggregateRating),
    video: setVideo(video),
    recipeIngredient: ingredients,
    recipeInstructions: instructions.map(setInstruction)
  });

  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "recipe"
  }));
}

function setLocation(location) {
  if (!location) {
    return undefined;
  }

  if ('url' in location) {
    return setVirtualLocation(location);
  } else {
    return setPlace(location);
  }
}

function setVirtualLocation(location) {
  return _extends({}, location, {
    '@type': 'VirtualLocation'
  });
}

function setPlace(location) {
  return _extends({}, location, {
    address: setAddress(location.address),
    '@type': 'Place'
  });
}

function setPerformer(performer) {
  if (performer) {
    var type = performer.type,
        restPerformer = _objectWithoutPropertiesLoose(performer, ["type"]);

    return _extends({}, restPerformer, {
      '@type': type || 'PerformingGroup'
    });
  }

  return undefined;
}

function setOffers(offers) {
  function mapOffer(_ref) {
    var seller = _ref.seller,
        rest = _objectWithoutPropertiesLoose(_ref, ["seller"]);

    return _extends({}, rest, {
      '@type': 'Offer'
    }, seller && {
      seller: {
        '@type': 'Organization',
        name: seller.name
      }
    });
  }

  if (Array.isArray(offers)) {
    return offers.map(mapOffer);
  } else if (offers) {
    return mapOffer(offers);
  }

  return undefined;
}

function setAggregateOffer(aggregateOffer) {
  if (aggregateOffer) {
    return {
      '@type': 'AggregateOffer',
      priceCurrency: aggregateOffer.priceCurrency,
      highPrice: aggregateOffer.highPrice,
      lowPrice: aggregateOffer.lowPrice,
      offerCount: aggregateOffer.offerCount,
      offers: setOffers(aggregateOffer.offers)
    };
  }

  return undefined;
}

function setOrganizer(organizer) {
  if (organizer) {
    var type = organizer.type,
        restOrganizer = _objectWithoutPropertiesLoose(organizer, ["type"]);

    return _extends({}, restOrganizer, {
      '@type': type || 'Person'
    });
  }

  return undefined;
}

function EventJsonLd(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'Event' : _ref$type,
      keyOverride = _ref.keyOverride,
      location = _ref.location,
      images = _ref.images,
      offers = _ref.offers,
      aggregateOffer = _ref.aggregateOffer,
      performers = _ref.performers,
      organizer = _ref.organizer,
      eventStatus = _ref.eventStatus,
      eventAttendanceMode = _ref.eventAttendanceMode,
      rest = _objectWithoutPropertiesLoose(_ref, ["type", "keyOverride", "location", "images", "offers", "aggregateOffer", "performers", "organizer", "eventStatus", "eventAttendanceMode"]);

  var data = _extends({}, rest, {
    location: setLocation(location),
    image: images,
    offers: offers ? setOffers(offers) : setAggregateOffer(aggregateOffer),
    performer: Array.isArray(performers) ? performers.map(setPerformer) : setPerformer(performers),
    organizer: Array.isArray(organizer) ? organizer.map(setOrganizer) : setOrganizer(organizer),
    eventStatus: "https://schema.org/" + eventStatus,
    eventAttendanceMode: "https://schema.org/" + eventAttendanceMode
  });

  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "Event"
  }));
}

function setContactPoint(contactPoint) {
  if (contactPoint) {
    return _extends({}, contactPoint, {
      '@type': 'ContactPoint'
    });
  }

  return undefined;
}

function CorporateContactJsonLd(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'Organization' : _ref$type,
      keyOverride = _ref.keyOverride,
      contactPoint = _ref.contactPoint,
      rest = _objectWithoutPropertiesLoose(_ref, ["type", "keyOverride", "contactPoint"]);

  var data = _extends({}, rest, {
    contactPoint: contactPoint.map(setContactPoint)
  });

  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "CorporateContact"
  }));
}

function setCreativeWork(creativeWork) {
  if (creativeWork) {
    return _extends({}, creativeWork, {
      '@type': 'CreativeWork'
    });
  }

  return undefined;
}

function CollectionPageJsonLd(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'CollectionPage' : _ref$type,
      keyOverride = _ref.keyOverride,
      hasPart = _ref.hasPart,
      rest = _objectWithoutPropertiesLoose(_ref, ["type", "keyOverride", "hasPart"]);

  var data = _extends({}, rest, {
    hasPart: hasPart.map(setCreativeWork)
  });

  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "CollectionPage"
  }));
}

function setManufacturer(manufacturer) {
  if (manufacturer && (manufacturer.manufacturerName || manufacturer.manufacturerLogo)) {
    return {
      '@type': 'Organization',
      name: manufacturer.manufacturerName,
      logo: setImage(manufacturer.manufacturerLogo)
    };
  }

  return undefined;
}

function setBrand(brand) {
  if (brand) {
    return {
      '@type': 'Brand',
      name: brand
    };
  }

  return undefined;
}

function ProductJsonLd(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'Product' : _ref$type,
      keyOverride = _ref.keyOverride,
      images = _ref.images,
      brand = _ref.brand,
      reviews = _ref.reviews,
      aggregateRating = _ref.aggregateRating,
      manufacturerLogo = _ref.manufacturerLogo,
      manufacturerName = _ref.manufacturerName,
      offers = _ref.offers,
      aggregateOffer = _ref.aggregateOffer,
      productName = _ref.productName,
      rest = _objectWithoutPropertiesLoose(_ref, ["type", "keyOverride", "images", "brand", "reviews", "aggregateRating", "manufacturerLogo", "manufacturerName", "offers", "aggregateOffer", "productName"]);

  var data = _extends({}, rest, {
    image: images,
    brand: setBrand(brand),
    review: setReviews(reviews),
    aggregateRating: setAggregateRating(aggregateRating),
    manufacturer: setManufacturer({
      manufacturerLogo: manufacturerLogo,
      manufacturerName: manufacturerName
    }),
    offers: offers ? setOffers(offers) : setAggregateOffer(aggregateOffer),
    name: productName
  });

  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "Product"
  }));
}

function SoftwareAppJsonLd(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'SoftwareApplication' : _ref$type,
      keyOverride = _ref.keyOverride,
      priceCurrency = _ref.priceCurrency,
      price = _ref.price,
      aggregateRating = _ref.aggregateRating,
      review = _ref.review,
      rest = _objectWithoutPropertiesLoose(_ref, ["type", "keyOverride", "priceCurrency", "price", "aggregateRating", "review"]);

  var data = _extends({}, rest, {
    offers: {
      '@type': 'Offer',
      price: price,
      priceCurrency: priceCurrency
    },
    aggregateRating: setAggregateRating(aggregateRating),
    review: setReviews(review)
  });

  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "SoftwareApp"
  }));
}

function VideoJsonLd(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'Video' : _ref$type,
      keyOverride = _ref.keyOverride,
      rest = _objectWithoutPropertiesLoose(_ref, ["type", "keyOverride"]);

  var data = setVideo(rest, true);
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "Video"
  }));
}

function setProducer(producer) {
  if (producer) {
    return {
      '@type': 'Organization',
      sameAs: producer.url,
      name: producer.name
    };
  }

  return undefined;
}

function setProvider(provider) {
  if (provider) {
    return {
      '@type': provider.type || 'Organization',
      name: provider.name,
      sameAs: provider.url
    };
  }

  return undefined;
}

function VideoGameJsonLd(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'VideoGame' : _ref$type,
      keyOverride = _ref.keyOverride,
      aggregateRating = _ref.aggregateRating,
      trailer = _ref.trailer,
      reviews = _ref.reviews,
      image = _ref.image,
      authorName = _ref.authorName,
      provider = _ref.provider,
      producerName = _ref.producerName,
      producerUrl = _ref.producerUrl,
      offers = _ref.offers,
      operatingSystemName = _ref.operatingSystemName,
      platformName = _ref.platformName,
      translatorName = _ref.translatorName,
      languageName = _ref.languageName,
      genreName = _ref.genreName,
      publisherName = _ref.publisherName,
      rest = _objectWithoutPropertiesLoose(_ref, ["type", "keyOverride", "aggregateRating", "trailer", "reviews", "image", "authorName", "provider", "producerName", "producerUrl", "offers", "operatingSystemName", "platformName", "translatorName", "languageName", "genreName", "publisherName"]);

  var data = _extends({}, rest, {
    aggregateRating: setAggregateRating(aggregateRating),
    trailer: setVideo(trailer),
    review: setReviews(reviews),
    image: setImage(image),
    author: setAuthor(authorName),
    provider: setProvider(provider),
    producer: setProducer({
      name: producerName,
      url: producerUrl
    }),
    offers: setOffers(offers),
    operatingSystem: operatingSystemName,
    gamePlatform: platformName,
    translator: translatorName,
    inLanguage: languageName,
    genre: genreName,
    publisher: publisherName
  });

  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "VideoGame"
  }));
}

function setContactPoints(contactPoint) {
  if (contactPoint && contactPoint.length) {
    return contactPoint.map(function (contactPoint) {
      return _extends({
        '@type': 'ContactPoint'
      }, contactPoint);
    });
  }

  return undefined;
}

function OrganizationJsonLd(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'Organization' : _ref$type,
      keyOverride = _ref.keyOverride,
      address = _ref.address,
      contactPoints = _ref.contactPoints,
      rest = _objectWithoutPropertiesLoose(_ref, ["type", "keyOverride", "address", "contactPoints"]);

  var data = _extends({}, rest, {
    address: setAddress(address),
    contactPoints: setContactPoints(contactPoints)
  });

  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "organization"
  }));
}

function setQuestions(questions) {
  if (questions && questions.length) {
    return questions.map(function (question) {
      return {
        '@type': 'Question',
        name: question.questionName,
        acceptedAnswer: {
          '@type': 'Answer',
          text: question.acceptedAnswerText
        }
      };
    });
  }

  return undefined;
}

function FAQPageJsonLd(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'FAQPage' : _ref$type,
      keyOverride = _ref.keyOverride,
      mainEntity = _ref.mainEntity,
      rest = _objectWithoutPropertiesLoose(_ref, ["type", "keyOverride", "mainEntity"]);

  var data = _extends({}, rest, {
    mainEntity: setQuestions(mainEntity)
  });

  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "faq-page"
  }));
}

function LogoJsonLd(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'Organization' : _ref$type,
      keyOverride = _ref.keyOverride,
      rest = _objectWithoutPropertiesLoose(_ref, ["type", "keyOverride"]);

  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, rest, {
    scriptKey: "Logo"
  }));
}

function DatasetJsonLd(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'Dataset' : _ref$type,
      keyOverride = _ref.keyOverride,
      rest = _objectWithoutPropertiesLoose(_ref, ["type", "keyOverride"]);

  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, rest, {
    scriptKey: "dataset"
  }));
}

function CourseJsonLd(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'Course' : _ref$type,
      keyOverride = _ref.keyOverride,
      courseName = _ref.courseName,
      provider = _ref.provider,
      rest = _objectWithoutPropertiesLoose(_ref, ["type", "keyOverride", "courseName", "provider"]);

  var data = _extends({
    name: courseName
  }, rest, {
    provider: setProvider(provider)
  });

  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "course"
  }));
}

function BreadCrumbJsonLd(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'BreadcrumbList' : _ref$type,
      keyOverride = _ref.keyOverride,
      itemListElements = _ref.itemListElements;
  var data = {
    itemListElement: setItemListElements(itemListElements)
  };
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "breadcrumb"
  }));
}

function BrandJsonLd(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'Brand' : _ref$type,
      id = _ref.id,
      keyOverride = _ref.keyOverride,
      aggregateRating = _ref.aggregateRating,
      rest = _objectWithoutPropertiesLoose(_ref, ["type", "id", "keyOverride", "aggregateRating"]);

  var data = _extends({
    aggregateRating: setAggregateRating(aggregateRating),
    '@id': id
  }, rest);

  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "brand"
  }));
}

function ArticleJsonLd(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'Article' : _ref$type,
      keyOverride = _ref.keyOverride,
      url = _ref.url,
      title = _ref.title,
      images = _ref.images,
      datePublished = _ref.datePublished,
      dateModified = _ref.dateModified,
      authorName = _ref.authorName,
      _ref$publisherName = _ref.publisherName,
      publisherName = _ref$publisherName === void 0 ? undefined : _ref$publisherName,
      _ref$publisherLogo = _ref.publisherLogo,
      publisherLogo = _ref$publisherLogo === void 0 ? undefined : _ref$publisherLogo,
      description = _ref.description;
  var data = {
    datePublished: datePublished,
    description: description,
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': url
    },
    headline: title,
    image: images,
    dateModified: dateModified || datePublished,
    author: setAuthor(authorName),
    publisher: setPublisher(publisherName, publisherLogo)
  };
  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "article"
  }));
}

function setReviewedBy(reviewedBy) {
  if (reviewedBy) {
    return _extends({
      '@type': (reviewedBy == null ? void 0 : reviewedBy.type) || 'Organization'
    }, reviewedBy);
  }

  return undefined;
}

function WebPageJsonLd(_ref) {
  var keyOverride = _ref.keyOverride,
      reviewedBy = _ref.reviewedBy,
      rest = _objectWithoutPropertiesLoose(_ref, ["keyOverride", "reviewedBy"]);

  var data = _extends({}, rest, {
    reviewedBy: setReviewedBy(reviewedBy)
  });

  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    keyOverride: keyOverride
  }, data, {
    type: "WebPage",
    scriptKey: "WebPage"
  }));
}

function SocialProfileJsonLd(_ref) {
  var type = _ref.type,
      keyOverride = _ref.keyOverride,
      rest = _objectWithoutPropertiesLoose(_ref, ["type", "keyOverride"]);

  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, rest, {
    scriptKey: "social"
  }));
}

function setCost(cost) {
  if (cost) {
    return _extends({}, cost, {
      '@type': 'MonetaryAmount'
    });
  }

  return undefined;
}

function setSupply(supply) {
  if (supply) {
    return supply.map(function (supplyItem) {
      return {
        '@type': 'HowToSupply',
        name: supplyItem
      };
    });
  }

  return undefined;
}

function setTool(tool) {
  if (tool) {
    return tool.map(function (toolItem) {
      return {
        '@type': 'HowToTool',
        name: toolItem
      };
    });
  }

  return undefined;
}

function setStep(step) {
  if (step) {
    return step.map(function (stepElement) {
      var itemListElement = stepElement.itemListElement,
          image = stepElement.image;
      var currentListElements = itemListElement == null ? void 0 : itemListElement.map(function (_ref) {
        var type = _ref.type,
            text = _ref.text;
        return {
          '@type': type,
          text: text
        };
      });
      return _extends({}, stepElement, {
        '@type': 'HowToStep',
        itemListElement: currentListElements,
        image: setImage(image)
      });
    });
  }

  return undefined;
}

function howToJsonLd(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'HowTo' : _ref$type,
      keyOverride = _ref.keyOverride,
      image = _ref.image,
      estimatedCost = _ref.estimatedCost,
      supply = _ref.supply,
      tool = _ref.tool,
      step = _ref.step,
      rest = _objectWithoutPropertiesLoose(_ref, ["type", "keyOverride", "image", "estimatedCost", "supply", "tool", "step"]);

  var data = _extends({}, rest, {
    image: setImage(image),
    estimatedCost: setCost(estimatedCost),
    supply: setSupply(supply),
    tool: setTool(tool),
    step: setStep(step)
  });

  return /*#__PURE__*/React.createElement(JsonLd, _extends({
    type: type,
    keyOverride: keyOverride
  }, data, {
    scriptKey: "howTo"
  }));
}




/***/ }),

/***/ 6840:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(96758);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 77944:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E9": function() { return /* reexport */ COOKIES; },
  "Jj": function() { return /* reexport */ on_accept; },
  "iY": function() { return /* reexport */ on_region_change; },
  "Qt": function() { return /* reexport */ on_revoke; }
});

// EXTERNAL MODULE: ./framework/api/utils/maxify/index.ts + 5 modules
var maxify = __webpack_require__(55469);
// EXTERNAL MODULE: ./constants/index.ts + 15 modules
var constants = __webpack_require__(47041);
;// CONCATENATED MODULE: ./components/CookieControl/Klaviyo/constants.ts
var COOKIES = [
    "_fbp",
    "__kla_id",
    "kl_sessionid",
    "__cf_bm",
    "OptanonConsent",
    "kl_csrftoken",
    "OptanonAlertBoxClosed",
    "_ga",
    "ABTastySession",
    "__kla_off",
    "_kx", 
];
var SCRIPT_SRC = "https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=";

;// CONCATENATED MODULE: ./components/CookieControl/Klaviyo/on-accept.ts
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable no-underscore-dangle */ 


var onAccept = function(locale) {
    if (true) {
        var scriptEl = document.getElementById("klaviyo");
        if (!scriptEl) {
            var region = (0,maxify/* getRegion */.ur)(locale);
            var regionalApiKey = constants/* KLAVIYO_CREDS_REGION_MAP */.C2T[region].companyId;
            var script = document.createElement("script");
            script.type = "text/javascript";
            script.async = true;
            script.src = SCRIPT_SRC + regionalApiKey;
            script.id = "klaviyo";
            var firstScript = document.getElementsByTagName("script")[0];
            firstScript.parentNode.insertBefore(script, firstScript);
        }
        document.cookie = "__kla_off=false";
    }
};
/* harmony default export */ var on_accept = (onAccept);

;// CONCATENATED MODULE: ./components/CookieControl/Klaviyo/on-revoke.ts
/* eslint-disable no-underscore-dangle */ var onRevoke = function() {
    if (true) {
        document.cookie = "__kla_off=true";
    }
};
/* harmony default export */ var on_revoke = (onRevoke);

;// CONCATENATED MODULE: ./components/CookieControl/Klaviyo/on-region-change.ts



var onRegionChange = function(locale) {
    var scriptEl = document.getElementById("klaviyo");
    if (scriptEl) scriptEl.remove();
    var region = (0,maxify/* getRegion */.ur)(locale);
    var regionalApiKey = constants/* KLAVIYO_CREDS_REGION_MAP */.C2T[region].companyId;
    var script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.src = SCRIPT_SRC + regionalApiKey;
    script.id = "klaviyo";
    var firstScript = document.getElementsByTagName("script")[0];
    firstScript.parentNode.insertBefore(script, firstScript);
};
/* harmony default export */ var on_region_change = (onRegionChange);

;// CONCATENATED MODULE: ./components/CookieControl/Klaviyo/index.ts







/***/ }),

/***/ 47041:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b4W": function() { return /* reexport */ BRANDING_DEFAULT; },
  "FL2": function() { return /* reexport */ CONSENT_COOKIE_EXPIRY; },
  "dLl": function() { return /* reexport */ CONTENT_TYPE_CATEGORY; },
  "mtp": function() { return /* reexport */ CONTENT_TYPE_COLLECTION; },
  "gnx": function() { return /* reexport */ CONTENT_TYPE_LEGAL_HUB; },
  "Cj6": function() { return /* reexport */ CONTENT_TYPE_NEWS_CATEGORY; },
  "eTE": function() { return /* reexport */ CONTENT_TYPE_ROUTE_MAP; },
  "HcD": function() { return /* reexport */ COUNTRY_CODE_TO_COUNTRY_NAME_MAP; },
  "RBF": function() { return /* reexport */ COUNTRY_CODE_TO_REGION_NAME_MAP; },
  "g5B": function() { return /* reexport */ COUNTRY_NAME_AUSTRALIA; },
  "fWs": function() { return /* reexport */ COUNTRY_NAME_AUSTRIA; },
  "Bhw": function() { return /* reexport */ COUNTRY_NAME_BELGIUM; },
  "YvK": function() { return /* reexport */ COUNTRY_NAME_CANADA; },
  "jjo": function() { return /* reexport */ COUNTRY_NAME_FRANCE; },
  "s9G": function() { return /* reexport */ COUNTRY_NAME_GERMANY; },
  "WMh": function() { return /* reexport */ COUNTRY_NAME_ITALY; },
  "$mh": function() { return /* reexport */ COUNTRY_NAME_JAPAN; },
  "fny": function() { return /* reexport */ COUNTRY_NAME_LUXEMBOURG; },
  "Is1": function() { return /* reexport */ COUNTRY_NAME_NETHERLANDS; },
  "pQb": function() { return /* reexport */ COUNTRY_NAME_NEW_ZEALAND; },
  "gVM": function() { return /* reexport */ COUNTRY_NAME_SPAIN; },
  "KJN": function() { return /* reexport */ COUNTRY_NAME_UNITED_KINGDOM; },
  "bUY": function() { return /* reexport */ COUNTRY_NAME_UNITED_STATES; },
  "A1M": function() { return /* reexport */ COUNTRY_TO_COUNTRY_CODE_MAP; },
  "ss5": function() { return /* reexport */ DEFAULT_COUNTRY_CODE; },
  "NZ0": function() { return /* reexport */ DEFAULT_LANGUAGE_CODE; },
  "ZWN": function() { return /* reexport */ DEFAULT_LOCALE; },
  "Znm": function() { return /* reexport */ DESCRIPTION_ANALYTICS; },
  "yVv": function() { return /* reexport */ DESCRIPTION_MARKETING; },
  "SOU": function() { return /* reexport */ EUROPE; },
  "ld6": function() { return /* reexport */ GEOIP_CONTINENT_TO_LOCATION_MAP; },
  "i2Q": function() { return /* reexport */ HEAP_ID_COOKIE_NAME; },
  "C2T": function() { return /* reexport */ KLAVIYO_CREDS_REGION_MAP; },
  "E9q": function() { return /* reexport */ LABEL_ANALYTICS; },
  "_sm": function() { return /* reexport */ LABEL_MARKETING; },
  "a2c": function() { return /* reexport */ LANGUAGES; },
  "ACo": function() { return /* reexport */ LOCALHOST_OVERRIDE_DEST; },
  "BgR": function() { return /* reexport */ LOCALHOST_OVERRIDE_SRC; },
  "Lmo": function() { return /* reexport */ LOCATIONS; },
  "uTf": function() { return /* reexport */ MAXIFY_DEFAULT_REGION; },
  "vm3": function() { return /* reexport */ MAXIFY_REGION_MAP; },
  "J8U": function() { return /* reexport */ MAXIFY_TOKEN_COOKIE_NAME; },
  "GfA": function() { return /* reexport */ MINIMAL_PROFILE_LINKS; },
  "rgm": function() { return /* reexport */ ui/* MODAL_ARIA_LABEL_MAP */.rg; },
  "fDE": function() { return /* reexport */ ui/* MODAL_NOTICE_PAGE */.fD; },
  "Iyg": function() { return /* reexport */ ui/* MODAL_VIEW_FORGOT */.Iy; },
  "efJ": function() { return /* reexport */ ui/* MODAL_VIEW_LOGIN */.ef; },
  "t$$": function() { return /* reexport */ ui/* MODAL_VIEW_RESET */.t$; },
  "tVq": function() { return /* reexport */ ui/* MODAL_VIEW_SIGNUP */.tV; },
  "XiA": function() { return /* reexport */ NECESSARY_COOKIES; },
  "H5A": function() { return /* reexport */ NORTHERN_AMERICA; },
  "ceB": function() { return /* reexport */ OCEANIA; },
  "Wn2": function() { return /* reexport */ PAGE_TYPE_ABOUT; },
  "Otd": function() { return /* reexport */ PAGE_TYPE_BUILD; },
  "rf$": function() { return /* reexport */ PAGE_TYPE_CAREERS; },
  "ScT": function() { return /* reexport */ PAGE_TYPE_HOME; },
  "F7S": function() { return /* reexport */ PAGE_TYPE_NEWS; },
  "ldl": function() { return /* reexport */ PAGE_TYPE_RETAILERS; },
  "cC0": function() { return /* reexport */ PAGE_TYPE_REVIEWS; },
  "uCv": function() { return /* reexport */ PAGE_TYPE_SUPPORT; },
  "ox5": function() { return /* reexport */ PAGE_TYPE_USER; },
  "Myu": function() { return /* reexport */ ROUTE_AUTH; },
  "fOR": function() { return /* reexport */ ROUTE_BUILD; },
  "SyD": function() { return /* reexport */ ROUTE_LEGAL; },
  "Ggo": function() { return /* reexport */ ROUTE_OAUTH; },
  "QZb": function() { return /* reexport */ ROUTE_SUPPORT; },
  "nIU": function() { return /* reexport */ SEO_DEFAULTS; },
  "h6Y": function() { return /* reexport */ SHOPIFY_CART_ID_COOKIE_NAME; },
  "eEW": function() { return /* reexport */ STAGING; },
  "RFD": function() { return /* reexport */ SUPPORTED_LOCALES; },
  "F9o": function() { return /* reexport */ SUPPORTED_LOCATION; },
  "qHr": function() { return /* reexport */ SYSTEM_COOKIE_MAX_AGE; },
  "Cgq": function() { return /* reexport */ SYSTEM_GEOIP_COOKIE_NAME; },
  "A9k": function() { return /* reexport */ SYSTEM_LOCALE_COOKIE_NAME; },
  "lD3": function() { return /* reexport */ TEXT; },
  "B6F": function() { return /* reexport */ USERNAME_PATTERN_REGEX; },
  "IPS": function() { return /* reexport */ getLocales; },
  "WVX": function() { return /* reexport */ getStatement; }
});

// UNUSED EXPORTS: AFFIRM_API_KEY, AFFIRM_LARGE_SIZE, AFFIRM_SCRIPT_URL, AFFIRM_SMALL_SIZE, ANSI, ASIA, AUSTRALIA_COUNTRY_CODE, AUSTRIA_COUNTRY_CODE, BAMBOOHR_EMBED_ENDPOINT, BELGIUM_COUNTRY_CODE, CAM_CTA, CAM_DOWNLOAD_PATH, CANADA_COUNTRY_CODE, CATEGORY_FILTER, CAT_NAMES, CONFIGURATOR_BUILD_COLORS, CONFIGURATOR_CASES_FILTER, CONFIGURATOR_CATEGORY_CASE, CONFIGURATOR_CATEGORY_CHIPSET, CONFIGURATOR_CATEGORY_COOLING, CONFIGURATOR_CATEGORY_CPU, CONFIGURATOR_CATEGORY_EXTRAS, CONFIGURATOR_CATEGORY_GPU, CONFIGURATOR_CATEGORY_LIGHTING, CONFIGURATOR_CATEGORY_MONITORS, CONFIGURATOR_CATEGORY_MOTHERBOARDS, CONFIGURATOR_CATEGORY_PERIPHERALS, CONFIGURATOR_CATEGORY_POWER_SUPPLY, CONFIGURATOR_CATEGORY_RAM, CONFIGURATOR_CATEGORY_SERVICES, CONFIGURATOR_CATEGORY_SOFTWARE, CONFIGURATOR_CATEGORY_STORAGE, CONFIGURATOR_CHIPSET_FILTER, CONFIGURATOR_COOLING_FILTER, CONFIGURATOR_DEFAULT_CHIPSET, CONFIGURATOR_DEFAULT_PRICE, CONFIGURATOR_DEFAULT_PRODUCT, CONFIGURATOR_FILTER_MAP, CONFIGURATOR_RULETYPES_MAP, CONFIGURATOR_RULE_TITLE, CONFIGURATOR_STORAGE_FILTER, CONFIG_NAV_LINKS, CONTENT_TYPE_LEGAL, CONTENT_TYPE_NEWS, CONTENT_TYPE_NOTICE, CONTENT_TYPE_PAGE, CONTENT_TYPE_PRODUCT, COOKIE_CONTROL_COOKIE_NAME, CORRELATION_HEADER, CURRENCY_CODE_AU, CURRENCY_CODE_CA, CURRENCY_CODE_EU, CURRENCY_CODE_JP, CURRENCY_CODE_NZ, CURRENCY_CODE_UK, CURRENCY_CODE_US, CURRENCY_MAP_PER_COUNTRY_CODE, CURRENCY_SYMBOL_MAP, CUSTOMER_TOKEN_COOKIE, DATOCMS_API_URL, DEFAULT_DATE_FORMAT, DEFAULT_VARIANT_REGION, DEVELOPMENT, DEVELOPMENT_URL, DE_QWERTZ, DUTCH_LANGUAGE_CODE, ELASTIC_INDEX_TIMEOUT, ENVIRONMENT_URL_MAP, EN_QWERTY, EXTERNAL_NAV_LOCALES, FALLBACK_NAV_SLUG, FPS_BUTTON_LABEL, FRANCE_COUNTRY_CODE, FRENCH_LANGUAGE_CODE, FR_AZERTY, GEOIP_CONTINENT_AFRICA, GEOIP_CONTINENT_ANTARCTICA, GEOIP_CONTINENT_ASIA, GEOIP_CONTINENT_EUROPE, GEOIP_CONTINENT_NORTH_AMERICA, GEOIP_CONTINENT_OCEANIA, GEOIP_CONTINENT_REGION_TO_LOCATION_MAP, GEOIP_CONTINENT_SOUTH_AMERICA, GEOIP_COUNTRY_TO_LOCATION_MAP, GERMANY_COUNTRY_CODE, GERMAN_LANGUAGE_CODE, HELP_CTA, ISO, ITALIAN_LANGUAGE_CODE, ITALY_COUNTRY_CODE, JAPAN_COUNTRY_CODE, KB_CABLE_NAME_MAP, KB_NAME_MAP, KLAVIYO_COMPANY_ID_AU, KLAVIYO_COMPANY_ID_EU, KLAVIYO_COMPANY_ID_NA, KLAVIYO_COMPANY_ID_NZ, KLAVIYO_COMPANY_ID_UK, KLAVIYO_KEY_AU, KLAVIYO_KEY_EU, KLAVIYO_KEY_NA, KLAVIYO_KEY_NZ, KLAVIYO_KEY_UK, KLAVIYO_LIST_ID_REGION_MAP, KLAVIYO_LIST_NEWSLETTER, KLAVIYO_LIST_NEWSLETTER_NZ, KLAVIYO_LIST_NEWSLETTER_UK, KLAVIYO_LIST_STOCK_NOTIFICATION, KLAVIYO_SIGN_UP_COMPANY_ID_REGION_MAP, LEGENDS_ANSI, LEGENDS_ISO, LOCAL, LOCAL_URL, LOW_STOCK_THRESHOLD, LUXEMBOURG_COUNTRY_CODE, MAXIFY_CURRENCY_MAP_PER_REGION, MAXIFY_LOCALE_MAP, MAXIFY_LOCALE_MAP_MULTIPLE_LOCALES_PER_LANG, MAXIFY_REGION_EUROPE, MAXIFY_REGION_NEW_ZEALAND, MAXIFY_REGION_NORTHERN_AMERICA, MAXIFY_REGION_OCEANIA, MAXIFY_REGION_UNITED_KINGDOM, MAX_FPS, MAX_ORDER_THRESHOLD, MAX_ORDER_THRESHOLD_COOLING, MAX_ORDER_THRESHOLD_MONITORS, MAX_ORDER_THRESHOLD_RAM, MAX_ORDER_THRESHOLD_STORAGE, MODAL_ARIA_BLD_INFO_HELP, MODAL_ARIA_EMAIL_SIGN_UP, MODAL_ARIA_LABEL_BLD_MORE_INFO, MODAL_ARIA_LABEL_BLD_OPTIONS, MODAL_ARIA_LABEL_BLD_SUMMARY, MODAL_ARIA_LABEL_EXPLORE, MODAL_ARIA_LABEL_EXTRAS, MODAL_ARIA_LABEL_FORGOT, MODAL_ARIA_LABEL_LOGIN, MODAL_ARIA_LABEL_MODAL_LOAD_BLD_KB, MODAL_ARIA_LABEL_MODAL_LOAD_BLD_PC, MODAL_ARIA_LABEL_MODAL_SHARE_BLD_KB, MODAL_ARIA_LABEL_MODAL_SHARE_BLD_PC, MODAL_ARIA_LABEL_MODAL_VIEW_BLD_ISSUES, MODAL_ARIA_LABEL_RESET, MODAL_ARIA_LABEL_SIGNUP, MODAL_ARIA_NOTIFICATION_SIGNUP_VIEW, MODAL_ARIA_PRODUCT_DETAILS, MODAL_ARIA_PRODUCT_POLICY, MODAL_ARIA_UPSELL_VIEW, MODAL_LOAD_BLD_KB, MODAL_LOAD_BLD_PC, MODAL_NOTIFICATION_SIGNUP_VIEW, MODAL_SHARE_BLD_KB, MODAL_SHARE_BLD_PC, MODAL_VIEW_BLD_EXTRAS, MODAL_VIEW_BLD_INFO_HELP, MODAL_VIEW_BLD_ISSUES, MODAL_VIEW_BLD_MORE_INFO, MODAL_VIEW_BLD_OPTIONS, MODAL_VIEW_BLD_SUMMARY, MODAL_VIEW_EMAIL_SIGN_UP, MODAL_VIEW_EXPLORE, MODAL_VIEW_PRODUCT_DETAILS, MODAL_VIEW_PRODUCT_POLICY, MODAL_VIEW_SР, NETHERLANDS_COUNTRY_CODE, NEWS_LIST_PER_PAGE_COUNT, NEW_ZEALAND_COUNTRY_CODE, NEXTAUTH_COOKIE_CALLBACK_URL, NEXTAUTH_COOKIE_CSRF_TOKEN, NEXTAUTH_COOKIE_SESSION_TOKEN, NZXT_LIGHT_GRAY_50, NZXT_S3_BUCKET, NZXT_WHITE, OIDC_FEDERATED_GOOGLE_STATE_COOKIE_NAME, OIDC_INTERACTION_COOKIE_NAME, OIDC_INTERACTION_RESUME_COOKIE_NAME, OIDC_INTERACTION_RESUME_SIG_COOKIE_NAME, OIDC_INTERACTION_SIG_COOKIE_NAME, OIDC_SESSION_COOKIE_NAME, OIDC_SESSION_LEGACY_COOKIE_NAME, OIDC_SESSION_LEGACY_SIG_COOKIE_NAME, OIDC_SESSION_SIG_COOKIE_NAME, PAGE_TYPE_COLLECTION, PAGE_TYPE_LEGAL, PAGE_TYPE_NOTICE, PAGE_TYPE_PARTNER, PAGE_TYPE_PARTNER_PROGRAM, PAGE_TYPE_REFURBISHED, PAGE_TYPE_ROOT, PAGE_TYPE_SALE, PAGE_TYPE_SOFTWARE, PRICE_OPTIONS_LABEL, PRODUCTION, PRODUCTION_URL, PROFILE_LINKS, REGION_NAME_ASIA, REGION_NAME_EUROPE, REGION_NAME_NORTH_AMERICA, REGION_NAME_OCEANIA, REGION_NAME_UNITED_KINGDOM, REGION_TO_REGION_NAME_MAP, REVALIDATE_FALLBACK, REVALIDATE_NOT_FOUND, REVALIDATE_STANDARD, REVALIDATE_VALUES, REVIEWS_LIST_PER_PAGE_COUNT, ROUTE_ABOUT, ROUTE_BUILD_KEYBOARD, ROUTE_BUILD_PC, ROUTE_BUILD_SUMMARY, ROUTE_CAM, ROUTE_CAREERS, ROUTE_CATEGORY, ROUTE_COLLECTION, ROUTE_HOME, ROUTE_NEWS, ROUTE_NEWS_CATEGORY, ROUTE_NOTICE, ROUTE_ORDER_TRACKING, ROUTE_PARTNER, ROUTE_PARTNER_PROGRAM, ROUTE_PRODUCT, ROUTE_REFURBISHED, ROUTE_RETAILERS, ROUTE_REVIEWS, ROUTE_ROOT, ROUTE_SALE, ROUTE_SEARCH, ROUTE_SOFTWARE, ROUTE_USER, ROUTE_USER_SAVED_BLD, SIGNIFYD_SCRIPT_URL, SM_NAV_HEIGHT, SM_NAV_HEIGHT_NUM, SPAIN_COUNTRY_CODE, SPANISH_LANGUAGE_CODE, STAGING_URL, SUMMARY_ROW_TRANSLATION_MAP, SUPPORT_URL_MAP, SYSTEM_IS_PARTNER_COOKIE_NAME, TITLE_BLOG, TITLE_COMMUNITY, TITLE_CONTACT, TITLE_GAMING_PC, TITLE_HOME, TITLE_PC_BUILDING, TITLE_PC_SOFTWARE, TITLE_PERIPHERALS, TITLE_PRIVACY, TITLE_SUPPORT, UK_QWERTY, UNITED_KINGDOM_COUNTRY_CODE, USER_EMAIL_COOKIE_NAME, ZENDESK_ARTICLES_URL, ZENDESK_BRAND_ID_CAM, ZENDESK_BRAND_ID_DEFAULT, ZENDESK_CHAT_KEY, ZENDESK_CUSTOM_FIELD_ID_CONTACT, ZENDESK_CUSTOM_FIELD_ID_PRODUCT, ZENDESK_CUSTOM_FIELD_ID_REGION, ZENDESK_ID_COOKIE_NAME, ZENDESK_SCRIPT_SRC, ZENDESK_TICKET_URL, ZENDESK_WIDGET_CONFIG, ZENDESK_WIDGET_CONFIG_LG_BUILD, ZENDESK_WIDGET_CONFIG_SM_BUILD

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./constants/language.ts
var DEFAULT_LANGUAGE_CODE = "en";
var GERMAN_LANGUAGE_CODE = "de";
var DUTCH_LANGUAGE_CODE = "nl";
var FRENCH_LANGUAGE_CODE = "fr";
var ITALIAN_LANGUAGE_CODE = "it";
var SPANISH_LANGUAGE_CODE = "es";
var LANGUAGES = [
    {
        label: "English",
        value: DEFAULT_LANGUAGE_CODE
    },
    {
        label: "Deutsch",
        value: GERMAN_LANGUAGE_CODE
    },
    {
        label: "Dutch",
        value: DUTCH_LANGUAGE_CODE
    },
    {
        label: "Fran\xe7ais",
        value: FRENCH_LANGUAGE_CODE
    },
    {
        label: "Italiano",
        value: ITALIAN_LANGUAGE_CODE
    },
    {
        label: "Espa\xf1ol",
        value: SPANISH_LANGUAGE_CODE
    }, 
];

;// CONCATENATED MODULE: ./constants/nav-links.ts
/* eslint-disable max-len */ 

// TODO - clean up these placeholders, for the header/footer component
var TITLE_HOME = "Home";
var TITLE_BLOG = "Blog";
var TITLE_CONTACT = "Contact";
var TITLE_PC_BUILDING = "PC Building";
var TITLE_GAMING_PC = "Gaming PCs";
var TITLE_PERIPHERALS = "Peripherals";
var TITLE_PC_SOFTWARE = "Software";
var TITLE_SUPPORT = "Support";
var TITLE_COMMUNITY = "Community";
var TITLE_PRIVACY = "PRIVACY & LEGAL";
var MINIMAL_PROFILE_LINKS = [
    {
        title: "user_settings_title",
        href: "/user/settings"
    },
    {
        title: "user_saved_builds_heading",
        href: "/user/saved-bld"
    }, 
];
var PROFILE_LINKS = [
    {
        title: "user_settings_title",
        href: "/user/settings"
    },
    {
        title: "user_saved_builds_heading",
        href: "/user/saved-bld"
    },
    {
        title: "user_order_history_heading",
        href: "/user/order-history"
    },
    {
        title: "user_support_heading",
        href: "/user/support"
    }, 
];
var _obj;
var SUPPORT_URL_MAP = (_obj = {}, (0,_define_property/* default */.Z)(_obj, DEFAULT_LANGUAGE_CODE, "https://support.nzxt.com/hc/en-us"), (0,_define_property/* default */.Z)(_obj, GERMAN_LANGUAGE_CODE, "https://support.nzxt.com/hc/de"), (0,_define_property/* default */.Z)(_obj, DUTCH_LANGUAGE_CODE, "https://support.nzxt.com/hc/nl"), (0,_define_property/* default */.Z)(_obj, FRENCH_LANGUAGE_CODE, "https://support.nzxt.com/hc/fr"), (0,_define_property/* default */.Z)(_obj, ITALIAN_LANGUAGE_CODE, "https://support.nzxt.com/hc/it"), (0,_define_property/* default */.Z)(_obj, SPANISH_LANGUAGE_CODE, "https://support.nzxt.com/hc/es"), _obj);
var FALLBACK_NAV_SLUG = "main";
var CONFIG_NAV_LINKS = [
    {
        title: "All",
        href: "/build"
    },
    {
        title: "PC",
        href: "/build/pc"
    },
    {
        title: "Keyboard",
        href: "/build/keyboard"
    }, 
];

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
;// CONCATENATED MODULE: ./constants/location.ts
/* provided dependency */ var process = __webpack_require__(34155);




// TODO - clean up these placeholders, for the footer component
var DEFAULT_COUNTRY_CODE = "US";
var CANADA_COUNTRY_CODE = "CA";
var GERMANY_COUNTRY_CODE = "DE";
var UNITED_KINGDOM_COUNTRY_CODE = "GB";
var BELGIUM_COUNTRY_CODE = "BE";
var AUSTRIA_COUNTRY_CODE = "AT";
var FRANCE_COUNTRY_CODE = "FR";
var ITALY_COUNTRY_CODE = "IT";
var LUXEMBOURG_COUNTRY_CODE = "LU";
var NETHERLANDS_COUNTRY_CODE = "NL";
var SPAIN_COUNTRY_CODE = "ES";
var AUSTRALIA_COUNTRY_CODE = "AU";
var NEW_ZEALAND_COUNTRY_CODE = "NZ";
var JAPAN_COUNTRY_CODE = "JP";
// Default locale, needs to match default provided in next.config.js
var DEFAULT_LOCALE = "en-US";
// Supported locales. Must be kept in sync with locales in next.config.js
var SUPPORTED_LOCALES = [
    "en-US",
    "en-CA",
    "en-BE",
    "en-FR",
    "en-IT",
    "en-DE",
    "en-LU",
    "en-NL",
    "en-AU",
    "en-AT",
    "de-US",
    "de-CA",
    "de-BE",
    "de-FR",
    "de-IT",
    "de-DE",
    "de-LU",
    "de-NL",
    "de-AU",
    "de-AT",
    "nl-US",
    "nl-CA",
    "nl-BE",
    "nl-FR",
    "nl-IT",
    "nl-DE",
    "nl-LU",
    "nl-NL",
    "nl-AU",
    "nl-AT",
    "fr-US",
    "fr-CA",
    "fr-BE",
    "fr-FR",
    "fr-IT",
    "fr-DE",
    "fr-LU",
    "fr-NL",
    "fr-AU",
    "fr-AT",
    "it-US",
    "it-CA",
    "it-BE",
    "it-FR",
    "it-IT",
    "it-DE",
    "it-LU",
    "it-NL",
    "it-AU",
    "it-AT",
    "es-US",
    "es-CA",
    "es-BE",
    "es-FR",
    "es-IT",
    "es-DE",
    "es-LU",
    "es-NL",
    "es-AU",
    "es-AT",
    "en-NZ",
    "de-NZ",
    "nl-NZ",
    "fr-NZ",
    "it-NZ", 
].concat((0,_to_consumable_array/* default */.Z)(process.env.NEXT_PUBLIC_FEATURE_ENABLE_JAPAN === "true" ? [
    "en-JP",
    "de-JP",
    "nl-JP",
    "fr-JP",
    "it-JP"
] : []), [
    "en-GB",
    "de-GB",
    "nl-GB",
    "fr-GB",
    "it-GB",
    "en-ES",
    "de-ES",
    "nl-ES",
    "fr-ES",
    "it-ES",
    "es-ES",
    "es-GB", 
]);
// Locales used to fetch nav data for external consumption (Zendesk)
var EXTERNAL_NAV_LOCALES = [
    "en-US",
    "de-US",
    "nl-US",
    "fr-US",
    "it-US",
    "en-ES",
    "en-GB",
    "en-NZ", 
].concat((0,_to_consumable_array/* default */.Z)(process.env.NEXT_PUBLIC_FEATURE_ENABLE_JAPAN === "true" ? [
    "en-JP"
] : []), [
    "es-US", 
]);
// Region values accepted by Maxify, controls underlying Shopify instance
var MAXIFY_REGION_NORTHERN_AMERICA = "northernAmerica";
var MAXIFY_REGION_EUROPE = "europe";
var MAXIFY_REGION_OCEANIA = "oceania";
var MAXIFY_REGION_UNITED_KINGDOM = "unitedKingdom";
var MAXIFY_REGION_NEW_ZEALAND = "newZealand";
// NOTE - the below regions are not yet populated with data in Maxify
// export const REGION_CENTRAL_AMERICA = 'centralAmerica';
// export const REGION_SOUTH_AMERICA = 'southAmerica';
// export const REGION_AFRICA = 'africa';
// export const REGION_ASIA = 'asia';
var MAXIFY_DEFAULT_REGION = MAXIFY_REGION_NORTHERN_AMERICA;
var location_obj;
// TODO - add all countries that should map to a region
var MAXIFY_REGION_MAP = (location_obj = {}, (0,_define_property/* default */.Z)(location_obj, DEFAULT_COUNTRY_CODE, MAXIFY_REGION_NORTHERN_AMERICA), (0,_define_property/* default */.Z)(location_obj, AUSTRALIA_COUNTRY_CODE, MAXIFY_REGION_OCEANIA), (0,_define_property/* default */.Z)(location_obj, BELGIUM_COUNTRY_CODE, MAXIFY_REGION_EUROPE), (0,_define_property/* default */.Z)(location_obj, AUSTRIA_COUNTRY_CODE, MAXIFY_REGION_EUROPE), (0,_define_property/* default */.Z)(location_obj, GERMANY_COUNTRY_CODE, MAXIFY_REGION_EUROPE), (0,_define_property/* default */.Z)(location_obj, FRANCE_COUNTRY_CODE, MAXIFY_REGION_EUROPE), (0,_define_property/* default */.Z)(location_obj, ITALY_COUNTRY_CODE, MAXIFY_REGION_EUROPE), (0,_define_property/* default */.Z)(location_obj, LUXEMBOURG_COUNTRY_CODE, MAXIFY_REGION_EUROPE), (0,_define_property/* default */.Z)(location_obj, NETHERLANDS_COUNTRY_CODE, MAXIFY_REGION_EUROPE), (0,_define_property/* default */.Z)(location_obj, CANADA_COUNTRY_CODE, MAXIFY_REGION_NORTHERN_AMERICA), (0,_define_property/* default */.Z)(location_obj, SPAIN_COUNTRY_CODE, MAXIFY_REGION_EUROPE), (0,_define_property/* default */.Z)(location_obj, UNITED_KINGDOM_COUNTRY_CODE, MAXIFY_REGION_UNITED_KINGDOM), (0,_define_property/* default */.Z)(location_obj, NEW_ZEALAND_COUNTRY_CODE, MAXIFY_REGION_NEW_ZEALAND), location_obj);
var GEOIP_CONTINENT_NORTH_AMERICA = "NA";
var GEOIP_CONTINENT_EUROPE = "EU";
var GEOIP_CONTINENT_OCEANIA = "OC";
var GEOIP_CONTINENT_ASIA = "AS";
var GEOIP_CONTINENT_SOUTH_AMERICA = "SA";
var GEOIP_CONTINENT_AFRICA = "AF";
var GEOIP_CONTINENT_ANTARCTICA = "AN";
var _obj1;
// maps the continent result from the geoip service to a location code
var GEOIP_CONTINENT_REGION_TO_LOCATION_MAP = (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, GEOIP_CONTINENT_NORTH_AMERICA, DEFAULT_COUNTRY_CODE), (0,_define_property/* default */.Z)(_obj1, GEOIP_CONTINENT_EUROPE, GERMANY_COUNTRY_CODE), (0,_define_property/* default */.Z)(_obj1, "".concat(GEOIP_CONTINENT_EUROPE, "-GB"), UNITED_KINGDOM_COUNTRY_CODE), (0,_define_property/* default */.Z)(_obj1, GEOIP_CONTINENT_OCEANIA, AUSTRALIA_COUNTRY_CODE), (0,_define_property/* default */.Z)(_obj1, GEOIP_CONTINENT_ASIA, DEFAULT_COUNTRY_CODE), (0,_define_property/* default */.Z)(_obj1, GEOIP_CONTINENT_SOUTH_AMERICA, DEFAULT_COUNTRY_CODE), (0,_define_property/* default */.Z)(_obj1, GEOIP_CONTINENT_AFRICA, DEFAULT_COUNTRY_CODE), (0,_define_property/* default */.Z)(_obj1, GEOIP_CONTINENT_ANTARCTICA, DEFAULT_COUNTRY_CODE), (0,_define_property/* default */.Z)(_obj1, "BE", "BE"), (0,_define_property/* default */.Z)(_obj1, "FR", "FR"), (0,_define_property/* default */.Z)(_obj1, "IT", "IT"), (0,_define_property/* default */.Z)(_obj1, "AT", "AT"), (0,_define_property/* default */.Z)(_obj1, "LU", "LU"), (0,_define_property/* default */.Z)(_obj1, "NL", "NL"), (0,_define_property/* default */.Z)(_obj1, "NZ", "NZ"), (0,_define_property/* default */.Z)(_obj1, "ES", "ES"), _obj1);
var GEOIP_CONTINENT_TO_LOCATION_MAP = function(param) {
    var continentCode = param.continentCode, countryCode = param.countryCode;
    var continentRegionKey = countryCode === "GB" ? "".concat(continentCode, "-GB") : continentCode;
    return GEOIP_CONTINENT_REGION_TO_LOCATION_MAP[countryCode] || GEOIP_CONTINENT_REGION_TO_LOCATION_MAP[continentRegionKey];
};
var SUPPORTED_LOCATION = (0,_object_spread/* default */.Z)({
    US: "US",
    CA: "CA",
    BE: "BE",
    FR: "FR",
    IT: "IT",
    AT: "AT",
    DE: "DE",
    LU: "LU",
    NL: "NL",
    ES: "ES",
    AU: "AU",
    GB: "GB",
    NZ: "NZ"
}, process.env.NEXT_PUBLIC_FEATURE_ENABLE_JAPAN === "true" ? {
    JP: "JP"
} : {});
var GEOIP_COUNTRY_TO_LOCATION_MAP = function(param) {
    var continentCode = param.continentCode, countryCode = param.countryCode;
    var continentRegionKey = countryCode === "GB" ? "".concat(continentCode, "-GB") : continentCode;
    return GEOIP_CONTINENT_REGION_TO_LOCATION_MAP[continentRegionKey];
};
// pretty names for regions
var REGION_NAME_EUROPE = "Europe";
var REGION_NAME_NORTH_AMERICA = "North America";
var REGION_NAME_OCEANIA = "Oceania";
var REGION_NAME_UNITED_KINGDOM = "United Kingdom";
var REGION_NAME_ASIA = "ASIA";
var COUNTRY_NAME_UNITED_STATES = "United States";
var COUNTRY_NAME_UNITED_KINGDOM = "United Kingdom";
var COUNTRY_NAME_BELGIUM = "Belgium";
var COUNTRY_NAME_FRANCE = "France";
var COUNTRY_NAME_ITALY = "Italy";
var COUNTRY_NAME_GERMANY = "Germany";
var COUNTRY_NAME_LUXEMBOURG = "Luxembourg";
var COUNTRY_NAME_AUSTRALIA = "Australia";
var COUNTRY_NAME_NEW_ZEALAND = "New Zealand";
var COUNTRY_NAME_JAPAN = "Japan";
var COUNTRY_NAME_SPAIN = "Spain";
var COUNTRY_NAME_NETHERLANDS = "Netherlands";
var COUNTRY_NAME_CANADA = "Canada";
var COUNTRY_NAME_AUSTRIA = "Austria";
// values for the region selector
var LOCATIONS = [
    {
        label: REGION_NAME_NORTH_AMERICA,
        value: DEFAULT_COUNTRY_CODE
    },
    {
        label: REGION_NAME_EUROPE,
        value: GERMANY_COUNTRY_CODE
    },
    {
        label: REGION_NAME_OCEANIA,
        value: AUSTRALIA_COUNTRY_CODE
    },
    {
        label: REGION_NAME_UNITED_KINGDOM,
        value: UNITED_KINGDOM_COUNTRY_CODE
    }, 
];
// values for the country selector
var NORTHERN_AMERICA = [
    {
        label: COUNTRY_NAME_UNITED_STATES,
        value: DEFAULT_COUNTRY_CODE
    },
    {
        label: COUNTRY_NAME_CANADA,
        value: CANADA_COUNTRY_CODE
    }, 
];
var EUROPE = [
    {
        label: COUNTRY_NAME_AUSTRIA,
        value: AUSTRIA_COUNTRY_CODE
    },
    {
        label: COUNTRY_NAME_BELGIUM,
        value: BELGIUM_COUNTRY_CODE
    },
    {
        label: COUNTRY_NAME_FRANCE,
        value: FRANCE_COUNTRY_CODE
    },
    {
        label: COUNTRY_NAME_ITALY,
        value: ITALY_COUNTRY_CODE
    },
    {
        label: COUNTRY_NAME_GERMANY,
        value: GERMANY_COUNTRY_CODE
    },
    {
        label: COUNTRY_NAME_LUXEMBOURG,
        value: LUXEMBOURG_COUNTRY_CODE
    },
    {
        label: COUNTRY_NAME_NETHERLANDS,
        value: NETHERLANDS_COUNTRY_CODE
    },
    {
        label: COUNTRY_NAME_SPAIN,
        value: SPAIN_COUNTRY_CODE
    },
    {
        label: COUNTRY_NAME_UNITED_KINGDOM,
        value: UNITED_KINGDOM_COUNTRY_CODE
    }, 
];
var OCEANIA = [
    {
        label: COUNTRY_NAME_AUSTRALIA,
        value: AUSTRALIA_COUNTRY_CODE
    },
    {
        label: COUNTRY_NAME_NEW_ZEALAND,
        value: NEW_ZEALAND_COUNTRY_CODE
    }, 
];
var ASIA = (0,_to_consumable_array/* default */.Z)(process.env.NEXT_PUBLIC_FEATURE_ENABLE_JAPAN === "true" ? [
    {
        label: COUNTRY_NAME_JAPAN,
        value: JAPAN_COUNTRY_CODE
    }, 
] : []);
var _obj2;
// maps country code to pretty region names
var COUNTRY_CODE_TO_REGION_NAME_MAP = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((_obj2 = {}, (0,_define_property/* default */.Z)(_obj2, DEFAULT_COUNTRY_CODE, REGION_NAME_NORTH_AMERICA), (0,_define_property/* default */.Z)(_obj2, AUSTRALIA_COUNTRY_CODE, REGION_NAME_OCEANIA), (0,_define_property/* default */.Z)(_obj2, UNITED_KINGDOM_COUNTRY_CODE, REGION_NAME_UNITED_KINGDOM), (0,_define_property/* default */.Z)(_obj2, AUSTRIA_COUNTRY_CODE, REGION_NAME_EUROPE), (0,_define_property/* default */.Z)(_obj2, BELGIUM_COUNTRY_CODE, REGION_NAME_EUROPE), (0,_define_property/* default */.Z)(_obj2, FRANCE_COUNTRY_CODE, REGION_NAME_EUROPE), (0,_define_property/* default */.Z)(_obj2, ITALY_COUNTRY_CODE, REGION_NAME_EUROPE), (0,_define_property/* default */.Z)(_obj2, GERMANY_COUNTRY_CODE, REGION_NAME_EUROPE), (0,_define_property/* default */.Z)(_obj2, LUXEMBOURG_COUNTRY_CODE, REGION_NAME_EUROPE), (0,_define_property/* default */.Z)(_obj2, NETHERLANDS_COUNTRY_CODE, REGION_NAME_EUROPE), (0,_define_property/* default */.Z)(_obj2, CANADA_COUNTRY_CODE, REGION_NAME_NORTH_AMERICA), (0,_define_property/* default */.Z)(_obj2, SPAIN_COUNTRY_CODE, REGION_NAME_EUROPE), _obj2), process.env.NEXT_PUBLIC_FEATURE_ENABLE_JAPAN === "true" ? (0,_define_property/* default */.Z)({}, JAPAN_COUNTRY_CODE, REGION_NAME_ASIA) : {}), (0,_define_property/* default */.Z)({}, NEW_ZEALAND_COUNTRY_CODE, REGION_NAME_OCEANIA));
var _obj3;
// maps country code to pretty country names
var COUNTRY_CODE_TO_COUNTRY_NAME_MAP = (0,_object_spread/* default */.Z)((_obj3 = {}, (0,_define_property/* default */.Z)(_obj3, DEFAULT_COUNTRY_CODE, COUNTRY_NAME_UNITED_STATES), (0,_define_property/* default */.Z)(_obj3, AUSTRALIA_COUNTRY_CODE, COUNTRY_NAME_AUSTRALIA), (0,_define_property/* default */.Z)(_obj3, UNITED_KINGDOM_COUNTRY_CODE, COUNTRY_NAME_UNITED_KINGDOM), (0,_define_property/* default */.Z)(_obj3, AUSTRIA_COUNTRY_CODE, COUNTRY_NAME_AUSTRIA), (0,_define_property/* default */.Z)(_obj3, BELGIUM_COUNTRY_CODE, COUNTRY_NAME_BELGIUM), (0,_define_property/* default */.Z)(_obj3, FRANCE_COUNTRY_CODE, COUNTRY_NAME_FRANCE), (0,_define_property/* default */.Z)(_obj3, ITALY_COUNTRY_CODE, COUNTRY_NAME_ITALY), (0,_define_property/* default */.Z)(_obj3, GERMANY_COUNTRY_CODE, COUNTRY_NAME_GERMANY), (0,_define_property/* default */.Z)(_obj3, LUXEMBOURG_COUNTRY_CODE, COUNTRY_NAME_LUXEMBOURG), (0,_define_property/* default */.Z)(_obj3, NETHERLANDS_COUNTRY_CODE, COUNTRY_NAME_NETHERLANDS), (0,_define_property/* default */.Z)(_obj3, CANADA_COUNTRY_CODE, COUNTRY_NAME_CANADA), (0,_define_property/* default */.Z)(_obj3, SPAIN_COUNTRY_CODE, COUNTRY_NAME_SPAIN), (0,_define_property/* default */.Z)(_obj3, NEW_ZEALAND_COUNTRY_CODE, COUNTRY_NAME_NEW_ZEALAND), _obj3), process.env.NEXT_PUBLIC_FEATURE_ENABLE_JAPAN === "true" ? (0,_define_property/* default */.Z)({}, JAPAN_COUNTRY_CODE, COUNTRY_NAME_JAPAN) : {});
var _obj4;
// maps country name to country code
var COUNTRY_TO_COUNTRY_CODE_MAP = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((_obj4 = {}, (0,_define_property/* default */.Z)(_obj4, COUNTRY_NAME_UNITED_STATES, DEFAULT_COUNTRY_CODE), (0,_define_property/* default */.Z)(_obj4, COUNTRY_NAME_AUSTRALIA, AUSTRALIA_COUNTRY_CODE), (0,_define_property/* default */.Z)(_obj4, COUNTRY_NAME_UNITED_KINGDOM, UNITED_KINGDOM_COUNTRY_CODE), (0,_define_property/* default */.Z)(_obj4, COUNTRY_NAME_AUSTRIA, AUSTRIA_COUNTRY_CODE), (0,_define_property/* default */.Z)(_obj4, COUNTRY_NAME_BELGIUM, BELGIUM_COUNTRY_CODE), (0,_define_property/* default */.Z)(_obj4, COUNTRY_NAME_FRANCE, FRANCE_COUNTRY_CODE), (0,_define_property/* default */.Z)(_obj4, COUNTRY_NAME_ITALY, ITALY_COUNTRY_CODE), (0,_define_property/* default */.Z)(_obj4, COUNTRY_NAME_GERMANY, GERMANY_COUNTRY_CODE), (0,_define_property/* default */.Z)(_obj4, COUNTRY_NAME_LUXEMBOURG, LUXEMBOURG_COUNTRY_CODE), (0,_define_property/* default */.Z)(_obj4, COUNTRY_NAME_NETHERLANDS, NETHERLANDS_COUNTRY_CODE), (0,_define_property/* default */.Z)(_obj4, COUNTRY_NAME_CANADA, CANADA_COUNTRY_CODE), (0,_define_property/* default */.Z)(_obj4, COUNTRY_NAME_SPAIN, SPAIN_COUNTRY_CODE), _obj4), process.env.NEXT_PUBLIC_FEATURE_ENABLE_JAPAN === "true" ? (0,_define_property/* default */.Z)({}, COUNTRY_NAME_JAPAN, JAPAN_COUNTRY_CODE) : {}), (0,_define_property/* default */.Z)({}, COUNTRY_NAME_NEW_ZEALAND, NEW_ZEALAND_COUNTRY_CODE));
var _obj5;
// maps region code to pretty region names
var REGION_TO_REGION_NAME_MAP = (_obj5 = {}, (0,_define_property/* default */.Z)(_obj5, MAXIFY_REGION_NORTHERN_AMERICA, REGION_NAME_NORTH_AMERICA), (0,_define_property/* default */.Z)(_obj5, MAXIFY_REGION_EUROPE, REGION_NAME_EUROPE), (0,_define_property/* default */.Z)(_obj5, MAXIFY_REGION_OCEANIA, REGION_NAME_OCEANIA), (0,_define_property/* default */.Z)(_obj5, MAXIFY_REGION_UNITED_KINGDOM, REGION_NAME_UNITED_KINGDOM), _obj5);
// Locale values accepted by Maxify, these map to the language of the content returned
var MAXIFY_LOCALE_MAP = {
    af: "af_ZA",
    ar: "ar_SA",
    az: "az_AZ",
    be: "be_BY",
    bg: "bg_BG",
    bn: "bn_BD",
    bs: "bs_BA",
    ca: "ca_ES",
    cs: "cs_CZ",
    cy: "cy_GB",
    da: "da_DK",
    de: "de_DE",
    el: "el_GR",
    en: "en_US",
    eo: "eo",
    es: "es_ES",
    et: "et_EE",
    eu: "eu_ES",
    fa: "fa_IR",
    fi: "fi_FI",
    fr: "fr_FR",
    gl: "gl_ES",
    he: "he_IL",
    hi: "hi_IN",
    hr: "hr_HR",
    hu: "hu_HU",
    id: "id_ID",
    is: "is_IS",
    it: "it_IT",
    ja: "ja_JP",
    km: "km_KH",
    kn: "kn_IN",
    ko: "ko_KR",
    lo: "lo_LA",
    lt: "lt_LT",
    lv: "lv_LV",
    mk: "mk_MK",
    mn: "mn_MN",
    ms: "ms_MY",
    nb: "nb_NO",
    ne: "ne_NP",
    nl: "nl_NL",
    nn: "nn_NO",
    or: "or_IN",
    pl: "pl_PL",
    pt: "pt_BR",
    rm: "rm_CH",
    ro: "ro_RO",
    ru: "ru_RU",
    sk: "sk_SK",
    sl: "sl_SI",
    sr: "sr_BA",
    sv: "sv_SE",
    sw: "sw_KE",
    ta: "ta_IN",
    th: "th_TH",
    tl: "tl_PH",
    tf: "tr_TR",
    tt: "tt_RU",
    uk: "uk_UA",
    ur: "ur_PK",
    uz: "uz_UZ",
    vi: "vi_VN",
    wo: "wo_SN",
    zh: "zh_CN"
};
// special cases - where a language might have more than 1 accepted locale
var MAXIFY_LOCALE_MAP_MULTIPLE_LOCALES_PER_LANG = {
    en_GB: "en_GB",
    en_US: "en_US",
    en_AU: "en_AU",
    zh_CN: "zh_CN",
    zh_HK: "zh_HK"
};
var CURRENCY_CODE_US = "USD";
var CURRENCY_CODE_EU = "EUR";
var CURRENCY_CODE_AU = "AUD";
var CURRENCY_CODE_UK = "GBP";
var CURRENCY_CODE_NZ = "NZD";
var CURRENCY_CODE_CA = "CAD";
var CURRENCY_CODE_JP = "JPY";
var _obj6;
var MAXIFY_CURRENCY_MAP_PER_REGION = (_obj6 = {}, (0,_define_property/* default */.Z)(_obj6, MAXIFY_REGION_NORTHERN_AMERICA, CURRENCY_CODE_US), (0,_define_property/* default */.Z)(_obj6, MAXIFY_REGION_EUROPE, CURRENCY_CODE_EU), (0,_define_property/* default */.Z)(_obj6, MAXIFY_REGION_OCEANIA, CURRENCY_CODE_AU), (0,_define_property/* default */.Z)(_obj6, MAXIFY_REGION_UNITED_KINGDOM, CURRENCY_CODE_UK), (0,_define_property/* default */.Z)(_obj6, MAXIFY_REGION_NEW_ZEALAND, CURRENCY_CODE_NZ), _obj6);
var _obj7;
var CURRENCY_MAP_PER_COUNTRY_CODE = (0,_object_spread/* default */.Z)((_obj7 = {}, (0,_define_property/* default */.Z)(_obj7, DEFAULT_COUNTRY_CODE, CURRENCY_CODE_US), (0,_define_property/* default */.Z)(_obj7, AUSTRIA_COUNTRY_CODE, CURRENCY_CODE_EU), (0,_define_property/* default */.Z)(_obj7, FRANCE_COUNTRY_CODE, CURRENCY_CODE_EU), (0,_define_property/* default */.Z)(_obj7, GERMANY_COUNTRY_CODE, CURRENCY_CODE_EU), (0,_define_property/* default */.Z)(_obj7, BELGIUM_COUNTRY_CODE, CURRENCY_CODE_EU), (0,_define_property/* default */.Z)(_obj7, ITALY_COUNTRY_CODE, CURRENCY_CODE_EU), (0,_define_property/* default */.Z)(_obj7, LUXEMBOURG_COUNTRY_CODE, CURRENCY_CODE_EU), (0,_define_property/* default */.Z)(_obj7, NETHERLANDS_COUNTRY_CODE, CURRENCY_CODE_EU), (0,_define_property/* default */.Z)(_obj7, AUSTRALIA_COUNTRY_CODE, CURRENCY_CODE_AU), (0,_define_property/* default */.Z)(_obj7, UNITED_KINGDOM_COUNTRY_CODE, CURRENCY_CODE_UK), (0,_define_property/* default */.Z)(_obj7, CANADA_COUNTRY_CODE, CURRENCY_CODE_CA), (0,_define_property/* default */.Z)(_obj7, SPAIN_COUNTRY_CODE, CURRENCY_CODE_EU), (0,_define_property/* default */.Z)(_obj7, NEW_ZEALAND_COUNTRY_CODE, CURRENCY_CODE_NZ), _obj7), process.env.NEXT_PUBLIC_FEATURE_ENABLE_JAPAN === "true" ? (0,_define_property/* default */.Z)({}, JAPAN_COUNTRY_CODE, CURRENCY_CODE_JP) : {});
var _obj8;
var CURRENCY_SYMBOL_MAP = (_obj8 = {}, (0,_define_property/* default */.Z)(_obj8, CURRENCY_CODE_US, "$"), (0,_define_property/* default */.Z)(_obj8, CURRENCY_CODE_EU, "€"), (0,_define_property/* default */.Z)(_obj8, CURRENCY_CODE_AU, "AU$"), (0,_define_property/* default */.Z)(_obj8, CURRENCY_CODE_NZ, "NZ$"), (0,_define_property/* default */.Z)(_obj8, CURRENCY_CODE_UK, "\xa3"), (0,_define_property/* default */.Z)(_obj8, CURRENCY_CODE_CA, "CA$"), (0,_define_property/* default */.Z)(_obj8, CURRENCY_CODE_JP, "\xa5"), _obj8);

;// CONCATENATED MODULE: ./constants/head.ts
// supported config options: https://github.com/garmeeh/next-seo
// eslint-disable-next-line import/prefer-default-export
var SEO_DEFAULTS = {
    titleTemplate: "%s | NZXT",
    additionalMetaTags: [
        {
            name: "viewport",
            content: "width=device-width, initial-scale=1"
        }, 
    ],
    openGraph: {
        type: "website",
        locale: "en_US",
        url: "https://nzxt.com/",
        site_name: "NZXT"
    },
    twitter: {
        handle: "@NZXT",
        site: "@NZXT",
        cardType: "summary_large_image"
    }
};

;// CONCATENATED MODULE: ./constants/environments.ts

var LOCAL = "local";
var DEVELOPMENT = "development";
var STAGING = "staging";
var PRODUCTION = "production";
var LOCAL_URL = "http://localhost:3001";
var DEVELOPMENT_URL = "https://puce-auth.nzxt.com";
var STAGING_URL = "https://chartreuse-auth.nzxt.com";
var PRODUCTION_URL = "https://auth.nzxt.com";
var environments_obj;
var ENVIRONMENT_URL_MAP = (environments_obj = {}, (0,_define_property/* default */.Z)(environments_obj, LOCAL, LOCAL_URL), (0,_define_property/* default */.Z)(environments_obj, DEVELOPMENT, DEVELOPMENT_URL), (0,_define_property/* default */.Z)(environments_obj, STAGING, STAGING_URL), (0,_define_property/* default */.Z)(environments_obj, PRODUCTION, PRODUCTION_URL), environments_obj);

;// CONCATENATED MODULE: ./constants/system.ts
var MAXIFY_TOKEN_COOKIE_NAME = "MAXIFY_TOKEN_2";
var SHOPIFY_CART_ID_COOKIE_NAME = "S_CART_ID";
var ZENDESK_ID_COOKIE_NAME = "ZENDESK_ID";
var HEAP_ID_COOKIE_NAME = "HEAP_ID";
var SYSTEM_LOCALE_COOKIE_NAME = "NEXT_LOCALE";
var SYSTEM_GEOIP_COOKIE_NAME = "SYSTEM_GEOIP";
var SYSTEM_IS_PARTNER_COOKIE_NAME = "IS_PARTNER";
var COOKIE_CONTROL_COOKIE_NAME = "CookieControl";
var USER_EMAIL_COOKIE_NAME = "USER_EMAIL";
var SYSTEM_COOKIE_MAX_AGE = 7 * 24 * 60 * 60;
var LOW_STOCK_THRESHOLD = 10;
var MAX_ORDER_THRESHOLD = 10;
var NEWS_LIST_PER_PAGE_COUNT = 10;
var REVIEWS_LIST_PER_PAGE_COUNT = 16;
var DEFAULT_DATE_FORMAT = {
    month: "long",
    day: "2-digit",
    year: "numeric"
};
var REVALIDATE_NOT_FOUND = 10;
var REVALIDATE_FALLBACK = 45;
var REVALIDATE_STANDARD = 600;
var REVALIDATE_VALUES = {
    notFound: REVALIDATE_NOT_FOUND,
    fallback: REVALIDATE_FALLBACK,
    standard: REVALIDATE_STANDARD
};
var ELASTIC_INDEX_TIMEOUT = 6000;

// EXTERNAL MODULE: ./constants/ui.ts
var ui = __webpack_require__(66138);
;// CONCATENATED MODULE: ./constants/routes.ts
// Route string

var ROUTE_CATEGORY = "category";
var ROUTE_COLLECTION = "collection";
var ROUTE_PRODUCT = "product";
var ROUTE_ABOUT = "about";
var ROUTE_REFURBISHED = "refurbished";
var ROUTE_LEGAL = "legal";
var ROUTE_NEWS = "news";
var ROUTE_NEWS_CATEGORY = "news/category";
var ROUTE_SOFTWARE = "software";
var ROUTE_RETAILERS = "retailers";
var ROUTE_CAREERS = "careers";
var ROUTE_ROOT = "";
var ROUTE_BUILD = "build";
var ROUTE_BUILD_KEYBOARD = "keyboard";
var ROUTE_BUILD_PC = "pc";
var ROUTE_BUILD_SUMMARY = "summary";
var ROUTE_ORDER_TRACKING = "order-tracking";
var ROUTE_SEARCH = "search";
var ROUTE_SUPPORT = "support";
var ROUTE_USER = "user";
var ROUTE_USER_SAVED_BLD = "saved-bld";
var ROUTE_REVIEWS = "reviews";
var ROUTE_HOME = "home";
var ROUTE_AUTH = "auth";
var ROUTE_OAUTH = "oauth";
var ROUTE_CAM = "cam";
var ROUTE_NOTICE = "notice";
var ROUTE_PARTNER = "partner";
var ROUTE_SALE = "sale";
var ROUTE_PARTNER_PROGRAM = "partner-program";
// Content type/model string
var CONTENT_TYPE_CATEGORY = "category";
var CONTENT_TYPE_COLLECTION = "collection";
var CONTENT_TYPE_PRODUCT = "product";
var CONTENT_TYPE_PAGE = "page";
var CONTENT_TYPE_LEGAL = "legal";
var CONTENT_TYPE_LEGAL_HUB = "legal_hub";
var CONTENT_TYPE_NEWS = "news";
var CONTENT_TYPE_NEWS_CATEGORY = "news_category";
var CONTENT_TYPE_NOTICE = "notice";
// Page types
var PAGE_TYPE_ABOUT = "about";
var PAGE_TYPE_SOFTWARE = "software";
var PAGE_TYPE_RETAILERS = "retailers";
var PAGE_TYPE_CAREERS = "careers";
var PAGE_TYPE_ROOT = "root";
var PAGE_TYPE_BUILD = "build";
var PAGE_TYPE_SUPPORT = "support";
var PAGE_TYPE_USER = "user";
var PAGE_TYPE_NEWS = "news";
var PAGE_TYPE_HOME = "home";
var PAGE_TYPE_REFURBISHED = "refurbished";
var PAGE_TYPE_REVIEWS = "reviews";
var PAGE_TYPE_LEGAL = "legal";
var PAGE_TYPE_NOTICE = "notice";
var PAGE_TYPE_COLLECTION = "collection";
var PAGE_TYPE_PARTNER = "partner";
var PAGE_TYPE_SALE = "sale";
var PAGE_TYPE_PARTNER_PROGRAM = "partner-program";
// External Page
var NZXT_S3_BUCKET = "https://nzxt-app.nzxt.com";
var CAM_DOWNLOAD_PATH = "NZXT-CAM-Setup.exe";
var routes_obj;
var CONTENT_TYPE_ROUTE_MAP = (routes_obj = {}, (0,_define_property/* default */.Z)(routes_obj, CONTENT_TYPE_CATEGORY, ROUTE_CATEGORY), (0,_define_property/* default */.Z)(routes_obj, CONTENT_TYPE_COLLECTION, ROUTE_COLLECTION), (0,_define_property/* default */.Z)(routes_obj, CONTENT_TYPE_PRODUCT, ROUTE_PRODUCT), (0,_define_property/* default */.Z)(routes_obj, CONTENT_TYPE_NEWS, ROUTE_NEWS), (0,_define_property/* default */.Z)(routes_obj, CONTENT_TYPE_LEGAL, ROUTE_LEGAL), (0,_define_property/* default */.Z)(routes_obj, CONTENT_TYPE_LEGAL_HUB, ROUTE_LEGAL), (0,_define_property/* default */.Z)(routes_obj, CONTENT_TYPE_NOTICE, ROUTE_NOTICE), (0,_define_property/* default */.Z)(routes_obj, CONTENT_TYPE_NEWS_CATEGORY, ROUTE_NEWS_CATEGORY), (0,_define_property/* default */.Z)(routes_obj, PAGE_TYPE_ABOUT, ROUTE_ABOUT), (0,_define_property/* default */.Z)(routes_obj, PAGE_TYPE_HOME, ROUTE_HOME), (0,_define_property/* default */.Z)(routes_obj, PAGE_TYPE_SOFTWARE, ROUTE_SOFTWARE), (0,_define_property/* default */.Z)(routes_obj, PAGE_TYPE_RETAILERS, ROUTE_RETAILERS), (0,_define_property/* default */.Z)(routes_obj, PAGE_TYPE_BUILD, ROUTE_BUILD), (0,_define_property/* default */.Z)(routes_obj, PAGE_TYPE_SUPPORT, ROUTE_SUPPORT), (0,_define_property/* default */.Z)(routes_obj, PAGE_TYPE_USER, ROUTE_USER), (0,_define_property/* default */.Z)(routes_obj, PAGE_TYPE_NEWS, ROUTE_NEWS), (0,_define_property/* default */.Z)(routes_obj, PAGE_TYPE_CAREERS, ROUTE_CAREERS), (0,_define_property/* default */.Z)(routes_obj, PAGE_TYPE_ROOT, ROUTE_ROOT), (0,_define_property/* default */.Z)(routes_obj, PAGE_TYPE_REFURBISHED, ROUTE_REFURBISHED), (0,_define_property/* default */.Z)(routes_obj, PAGE_TYPE_REVIEWS, ROUTE_REVIEWS), (0,_define_property/* default */.Z)(routes_obj, PAGE_TYPE_COLLECTION, ROUTE_COLLECTION), (0,_define_property/* default */.Z)(routes_obj, PAGE_TYPE_PARTNER, ROUTE_PARTNER), (0,_define_property/* default */.Z)(routes_obj, PAGE_TYPE_SALE, ROUTE_SALE), routes_obj);

;// CONCATENATED MODULE: ./constants/camCta.ts

var CAM_CTA = {
    title: "cam_title",
    description: "cam_description",
    logo: "/logo/nzxt-cam.svg",
    firstButton: {
        linkType: "primary",
        linkLabel: "free_download",
        asButton: true,
        externalLinkRef: {
            url: "".concat(NZXT_S3_BUCKET, "/").concat(CAM_DOWNLOAD_PATH)
        },
        id: "free_download_cam"
    },
    smallPrint: "cam_windows_10",
    background: "dark grey"
};
var HELP_CTA = {
    title: "help_amp_support",
    description: "help_description",
    firstButton: {
        linkType: "primary",
        linkLabel: "help_and_support",
        _modelApiKey: ROUTE_SUPPORT,
        internalLink: {
            _modelApiKey: CONTENT_TYPE_PAGE,
            pageType: ROUTE_SUPPORT,
            slug: ROUTE_SUPPORT,
            id: "help-path"
        },
        asButton: true,
        id: "explore_cam"
    },
    background: "blue"
};

;// CONCATENATED MODULE: ./constants/auth.ts
/* eslint-disable max-len */ /* eslint-disable import/prefer-default-export */ var CUSTOMER_TOKEN_COOKIE = "customerToken";
var NEXTAUTH_COOKIE_SESSION_TOKEN = "next-auth.session-token";
var NEXTAUTH_COOKIE_CALLBACK_URL = "next-auth.callback-url";
var NEXTAUTH_COOKIE_CSRF_TOKEN = "next-auth.csrf-token";
var USERNAME_PATTERN_REGEX = /(?=^.{6,30}$)^(?!\.)(?!.*\.$)(?!.*?\.\.)[a-zA-Z0-9.]+$/g;
/* OIDC cookies */ var OIDC_INTERACTION_COOKIE_NAME = "_interaction";
var OIDC_INTERACTION_SIG_COOKIE_NAME = "_interaction.sig";
var OIDC_INTERACTION_RESUME_COOKIE_NAME = "_interaction_resume";
var OIDC_INTERACTION_RESUME_SIG_COOKIE_NAME = "_interaction_resume.sig";
var OIDC_SESSION_COOKIE_NAME = "_session";
var OIDC_SESSION_SIG_COOKIE_NAME = "_session.sig";
var OIDC_SESSION_LEGACY_COOKIE_NAME = "_session.legacy";
var OIDC_SESSION_LEGACY_SIG_COOKIE_NAME = "_session.legacy.sig";
var OIDC_FEDERATED_GOOGLE_STATE_COOKIE_NAME = "google.state";

;// CONCATENATED MODULE: ./constants/cookie-control.ts
/* eslint-disable @typescript-eslint/no-explicit-any */ 





// system
var LOCALHOST_OVERRIDE_SRC = "https://apikeys.civiccomputing.com/c/v?d=localhost&";
var LOCALHOST_OVERRIDE_DEST = "https://apikeys.civiccomputing.com/c/v?d=nzxt.com&";
var CONSENT_COOKIE_EXPIRY = 1825;
var STATEMENT_UPDATED = "07/10/2022";
var COOKIE_POLICY_URL = "legal/cookie-policy";
// cookie configuration
var NECESSARY_COOKIES = [
    CUSTOMER_TOKEN_COOKIE,
    NEXTAUTH_COOKIE_SESSION_TOKEN,
    NEXTAUTH_COOKIE_CALLBACK_URL,
    NEXTAUTH_COOKIE_CSRF_TOKEN,
    MAXIFY_TOKEN_COOKIE_NAME,
    "".concat(SHOPIFY_CART_ID_COOKIE_NAME, "_").concat(DEFAULT_COUNTRY_CODE),
    "".concat(SHOPIFY_CART_ID_COOKIE_NAME, "_").concat(CANADA_COUNTRY_CODE),
    "".concat(SHOPIFY_CART_ID_COOKIE_NAME, "_").concat(GERMANY_COUNTRY_CODE),
    "".concat(SHOPIFY_CART_ID_COOKIE_NAME, "_").concat(UNITED_KINGDOM_COUNTRY_CODE),
    "".concat(SHOPIFY_CART_ID_COOKIE_NAME, "_").concat(BELGIUM_COUNTRY_CODE),
    "".concat(SHOPIFY_CART_ID_COOKIE_NAME, "_").concat(AUSTRIA_COUNTRY_CODE),
    "".concat(SHOPIFY_CART_ID_COOKIE_NAME, "_").concat(FRANCE_COUNTRY_CODE),
    "".concat(SHOPIFY_CART_ID_COOKIE_NAME, "_").concat(ITALY_COUNTRY_CODE),
    "".concat(SHOPIFY_CART_ID_COOKIE_NAME, "_").concat(LUXEMBOURG_COUNTRY_CODE),
    "".concat(SHOPIFY_CART_ID_COOKIE_NAME, "_").concat(NETHERLANDS_COUNTRY_CODE),
    "".concat(SHOPIFY_CART_ID_COOKIE_NAME, "_").concat(SPAIN_COUNTRY_CODE),
    "".concat(SHOPIFY_CART_ID_COOKIE_NAME, "_").concat(AUSTRALIA_COUNTRY_CODE),
    "".concat(SHOPIFY_CART_ID_COOKIE_NAME, "_").concat(NEW_ZEALAND_COUNTRY_CODE),
    "".concat(SHOPIFY_CART_ID_COOKIE_NAME, "_").concat(JAPAN_COUNTRY_CODE),
    ZENDESK_ID_COOKIE_NAME,
    HEAP_ID_COOKIE_NAME,
    SYSTEM_LOCALE_COOKIE_NAME,
    SYSTEM_GEOIP_COOKIE_NAME,
    SYSTEM_IS_PARTNER_COOKIE_NAME,
    USER_EMAIL_COOKIE_NAME,
    "FPID",
    "_vercel_jwt",
    OIDC_INTERACTION_COOKIE_NAME,
    OIDC_INTERACTION_SIG_COOKIE_NAME,
    OIDC_INTERACTION_RESUME_COOKIE_NAME,
    OIDC_INTERACTION_RESUME_SIG_COOKIE_NAME,
    OIDC_SESSION_COOKIE_NAME,
    OIDC_SESSION_SIG_COOKIE_NAME,
    OIDC_SESSION_LEGACY_COOKIE_NAME,
    OIDC_SESSION_LEGACY_SIG_COOKIE_NAME,
    OIDC_FEDERATED_GOOGLE_STATE_COOKIE_NAME, 
];
// text/verbiage
var TEXT = {
    notifyTitle: "NZXT uses cookies to enhance your user experience, improve our websites, and deliver ads that may interest you.",
    notifyDescription: "We use cookies to optimize site functionality and give you the best possible experience.",
    accept: "Accept All Cookies",
    necessaryTitle: "Essential",
    necessaryDescription: "Essential cookies are necessary for our services to function properly and to help identify and prevent security risks. We may also use these cookies to remember your settings and preferences.",
    acceptRecommended: "Accept All Cookies"
};
var STATEMENT = {
    description: "Learn More",
    name: "in our Cookie Policy",
    url: COOKIE_POLICY_URL,
    updated: STATEMENT_UPDATED
};
var STATEMENT_DE = {
    description: "Erfahre mehr \xfcber",
    name: "unsere Cookie-Richtlinien",
    url: COOKIE_POLICY_URL,
    updated: STATEMENT_UPDATED
};
var STATEMENT_FR = {
    description: "Pour en savoir plus, ss",
    name: "consultez notre politique en mati\xe8re de cookies",
    url: COOKIE_POLICY_URL,
    updated: STATEMENT_UPDATED
};
var STATEMENT_IT = {
    description: "Per maggiori informazioni, ",
    name: "consulta la nostra Informativa sui cookie",
    url: COOKIE_POLICY_URL,
    updated: STATEMENT_UPDATED
};
var STATEMENT_NL = {
    description: "Kom meer te weten",
    name: "in ons cookiebeleid",
    url: COOKIE_POLICY_URL,
    updated: STATEMENT_UPDATED
};
var STATEMENT_ES = {
    description: "M\xe1s informaci\xf3n",
    name: "en nuestra Pol\xedtica de Cookies",
    url: COOKIE_POLICY_URL,
    updated: STATEMENT_UPDATED
};
var getStatement = function(locale, statement) {
    var statementObj = statement || STATEMENT;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, statementObj), {
        url: locale && locale !== DEFAULT_LOCALE ? "/".concat(locale, "/").concat(COOKIE_POLICY_URL) : "/".concat(COOKIE_POLICY_URL)
    });
};
var LABEL_ANALYTICS = "Analytics and Performance";
var DESCRIPTION_ANALYTICS = "Analytics cookies collect information about how you interact with our services to help us improve them.";
var LABEL_MARKETING = "Social Media and Marketing";
var DESCRIPTION_MARKETING = "Social Media and Marketing cookies let you connect to your social networks and share content from our websites through social media.  We also use these to deliver ads, make ads more relevant, and track ad campaigns.";
var LOCALE_DE = {
    locale: GERMAN_LANGUAGE_CODE,
    text: {
        title: "Diese Seite verwendet Cookies, um Informationen auf deinem Computer zu speichern.",
        intro: "Einige dieser Cookies sind unerl\xe4sslich, w\xe4hrend uns andere helfen, deine Nutzererfahrung zu verbessern, indem sie uns Einblicke gew\xe4hren, wie die Seite genutzt wird.",
        settings: "Einstellungen",
        notifyTitle: "NZXT verwendet Cookies, um die Nutzererfahrung und unsere Website zu verbessern und um dir Werbung anzubieten, die f\xfcr dich interessant sein k\xf6nnte.",
        notifyDescription: "Wir verwenden Cookies, um die Website-Funktionen zu optimieren und dir die beste Benutzererfahrung zu erm\xf6glichen.",
        accept: "Alle Cookies akzeptieren",
        reject: "Ablehnen",
        necessaryTitle: "Unerl\xe4sslich",
        necessaryDescription: "Unerl\xe4ssliche Cookies sind notwendig, damit unsere Dienste richtig funktionieren k\xf6nnen und um dabei zu helfen, Sicherheitsl\xfccken zu erkennen und zu verhindern. Wir nutzen diese Cookies gegebenenfalls auch, um deine Einstellungen und Vorlieben zu speichern.",
        acceptRecommended: "Alle Cookies akzeptieren",
        statement: STATEMENT_DE,
        optionalCookies: [
            {
                label: "Analysen und Leistung",
                description: "Analyse-Cookies sammeln Informationen dar\xfcber, wie du mit unseren Angeboten interagierst und helfen uns dabei, diese zu verbessern."
            },
            {
                label: "Social Media und Marketing",
                description: "Mit Social Media- und Marketing-Cookies kannst du dich mit deinen sozialen Netzwerken verbinden und Inhalte von unseren Websites \xfcber soziale Medien teilen. Wir verwenden diese Cookies auch, um Werbeanzeigen zu schalten, die Relevanz von Werbeanzeigen zu erh\xf6hen und Werbekampagnen zu \xfcberwachen."
            }, 
        ]
    }
};
var LOCALE_FR = {
    locale: FRENCH_LANGUAGE_CODE,
    text: {
        title: "Ce site utilise des cookies pour stocker des informations sur votre ordinateur.",
        intro: "Certains de ces cookies sont essentiels, tandis que d'autres nous aident \xe0 am\xe9liorer votre exp\xe9rience en nous donnant des informations sur la fa\xe7on dont le site est utilis\xe9.",
        settings: "Param\xe8tres",
        notifyTitle: "NZXT utilise des cookies pour am\xe9liorer votre exp\xe9rience utilisateur, am\xe9liorer nos sites Web et diffuser des publicit\xe9s susceptibles de vous int\xe9resser.",
        notifyDescription: "Nous utilisons des cookies pour optimiser la fonctionnalit\xe9 du site et vous offrir la meilleure exp\xe9rience possible.",
        accept: "Accepter tous les cookies",
        reject: "Je refuse",
        necessaryTitle: "Essentiels",
        necessaryDescription: "Les cookies essentiels sont n\xe9cessaires au bon fonctionnement de nos services et \xe0 l'identification et \xe0 la pr\xe9vention des risques de s\xe9curit\xe9. Nous pouvons \xe9galement utiliser ces cookies pour m\xe9moriser vos param\xe8tres et pr\xe9f\xe9rences.",
        acceptRecommended: "Accepter tous les cookies",
        statement: STATEMENT_FR,
        optionalCookies: [
            {
                label: "Analyse et performance",
                description: "Les cookies d'analyse collectent des informations sur la fa\xe7on dont vous interagissez avec nos services pour nous aider \xe0 les am\xe9liorer."
            },
            {
                label: "M\xe9dias sociaux et marketing",
                description: "Les cookies de r\xe9seaux sociaux et de marketing vous permettent de vous connecter \xe0 vos r\xe9seaux sociaux et de partager le contenu de nos sites Web via les r\xe9seaux sociaux. Nous utilisons \xe9galement ces cookies pour placer des publicit\xe9s, augmenter la pertinence des publicit\xe9s et surveiller les campagnes publicitaires."
            }, 
        ]
    }
};
var LOCALE_IT = {
    locale: ITALIAN_LANGUAGE_CODE,
    text: {
        title: "Questo sito utilizza i cookie per memorizzare informazioni sul tuo computer.",
        intro: "Alcuni di questi cookie sono essenziali, altri ci aiutano a migliorare la tua esperienza fornendoci indicazioni su come si utilizza il sito.",
        settings: "Impostazioni",
        notifyTitle: "NZXT utilizza i cookie per valorizzare la tua esperienza di utente, migliorare i nostri siti web e proporre annunci che potrebbero essere di tuo interesse.",
        notifyDescription: "Utilizziamo i cookie per ottimizzare la funzionalit\xe0 del sito e offrirti la miglior esperienza possibile.",
        accept: "Accetta tutti i cookie",
        reject: "Non accetto",
        necessaryTitle: "Essenziali",
        necessaryDescription: "I cookie essenziali sono necessari per il corretto funzionamento dei nostri servizi e al fine di individuare e prevenire rischi per la sicurezza. Possiamo utilizzare questi cookie anche per ricordare le tue impostazioni e preferenze.",
        acceptRecommended: "Accetta tutti i cookie",
        statement: STATEMENT_IT,
        optionalCookies: [
            {
                label: "Analitici e di performance",
                description: "I cookie analitici raccolgono informazioni sulle modalit\xe0 in cui interagisci con i nostri servizi e questo ci aiuter\xe0 a migliorarli."
            },
            {
                label: "Social media e marketing",
                description: "I cookie di social media e marketing ti consentono di connetterti ai tuoi social network e condividere contenuti dai nostri siti Web attraverso i social media. Utilizziamo questi cookie anche per inserire annunci pubblicitari, aumentare la rilevanza degli annunci e monitorare le campagne pubblicitarie."
            }, 
        ]
    }
};
var LOCALE_NL = {
    locale: DUTCH_LANGUAGE_CODE,
    text: {
        title: "Deze site maakt gebruik van cookies om informatie op je computer op te slaan.",
        intro: "Enkele van deze cookies zijn essentieel, terwijl andere ons helpen om je ervaring te verbeteren door inzicht te bieden in hoe de site wordt gebruikt.",
        settings: "Instellingen",
        notifyTitle: "NZXT maakt gebruik van cookies die je gebruikerservaring verbeteren, onze websites verbeteren en advertenties weergeven die je mogelijk interessant vindt.",
        notifyDescription: "We maken gebruik van cookies voor een optimaal werkende website en om je de beste ervaring te bieden.",
        accept: "Alle cookies accepteren",
        reject: "Weigeren",
        necessaryTitle: "Essentieel",
        necessaryDescription: "Essenti\xeble cookies zijn noodzakelijk voor onze diensten om correct te werken en om veiligheidsrisico's te identificeren en te voorkomen. We kunnen deze cookies ook gebruiken om je instellingen en voorkeuren te onthouden.",
        acceptRecommended: "Alle cookies accepteren",
        statement: STATEMENT_NL,
        optionalCookies: [
            {
                label: "Analyses en prestaties",
                description: "Analytische cookies verzamelen informatie over hoe je interactie hebt met onze diensten zodat wij deze kunnen verbeteren."
            },
            {
                label: "Sociale media en marketing",
                description: "Met sociale media- en marketingcookies kunt u verbinding maken met uw sociale netwerken en inhoud van onze websites delen via sociale media. We gebruiken deze cookies ook om advertenties te plaatsen, de relevantie van advertenties te vergroten en advertentiecampagnes te monitoren."
            }, 
        ]
    }
};
var LOCALE_ES = {
    locale: SPANISH_LANGUAGE_CODE,
    text: {
        title: "Este sitio utiliza cookies para almacenar informaci\xf3n en su ordenador.",
        intro: "Algunas de estas cookies son esenciales, otras nos ayudan a mejorar su experiencia al proporcionarnos informaci\xf3n sobre c\xf3mo utiliza el sitio.",
        settings: "Ajustes",
        notifyTitle: "NZXT utiliza cookies para mejorar su experiencia de usuario, mejorar nuestros sitios web y publicar anuncios que puedan ser de su inter\xe9s.",
        notifyDescription: "Utilizamos cookies para optimizar la funcionalidad del sitio y ofrecerle la mejor experiencia posible.",
        accept: "Aceptar todas las cookies",
        reject: "No acepto",
        necessaryTitle: "Esenciales",
        necessaryDescription: "Las cookies esenciales son necesarias para el correcto funcionamiento de nuestros servicios y para detectar y prevenir riesgos de seguridad. Tambi\xe9n podemos utilizar estas cookies para recordar sus ajustes y preferencias.",
        acceptRecommended: "Aceptar todas las cookies",
        statement: STATEMENT_ES,
        optionalCookies: [
            {
                label: "An\xe1lisis y rendimiento",
                description: "Las cookies anal\xedticas recogen informaci\xf3n sobre c\xf3mo interact\xfaa usted con nuestros servicios, lo que nos ayudar\xe1 a mejorarlos."
            },
            {
                label: "Redes sociales y marketing",
                description: "Las cookies de redes sociales y de marketing le permiten conectarse a sus redes sociales y compartir el contenido de nuestros sitios web a trav\xe9s de las redes sociales. Tambi\xe9n utilizamos estas cookies para colocar anuncios, aumentar la relevancia de los anuncios y supervisar las campa\xf1as publicitarias."
            }, 
        ]
    }
};
var getLocales = function(locale) {
    var de = LOCALE_DE;
    de.text.statement = getStatement(locale, STATEMENT_DE);
    var fr = LOCALE_FR;
    fr.text.statement = getStatement(locale, STATEMENT_FR);
    var it = LOCALE_IT;
    it.text.statement = getStatement(locale, STATEMENT_IT);
    var nl = LOCALE_NL;
    nl.text.statement = getStatement(locale, STATEMENT_NL);
    var es = LOCALE_ES;
    es.text.statement = getStatement(locale, STATEMENT_ES);
    return [
        de,
        fr,
        it,
        nl,
        es
    ];
};
// style configuration
var BRANDING_DEFAULT = {
    fontFamily: "Gotham SSm,-apple-system,BlinkMacSystemFont,Roboto,Helvetica Neue,sans-serif",
    fontColor: "#F8F8F8",
    fontSizeTitle: "22px",
    fontSizeIntro: "12px",
    backgroundColor: "rgba(50, 50, 50, 0.9)",
    toggleColor: "rgba(50, 50, 50, 0.9)",
    buttonIcon: null,
    buttonIconWidth: "64px",
    buttonIconHeight: "64px",
    removeIcon: true,
    removeAbout: true,
    acceptBackground: "#F8F8F8",
    acceptText: "#4a4a4a"
};

;// CONCATENATED MODULE: ./constants/configurator.ts
// default build options

var CONFIGURATOR_DEFAULT_CHIPSET = "intel";
var CONFIGURATOR_DEFAULT_PRODUCT = 260;
var CONFIGURATOR_DEFAULT_PRICE = "2000";
var MAX_ORDER_THRESHOLD_RAM = 2;
var MAX_ORDER_THRESHOLD_STORAGE = 3;
var MAX_ORDER_THRESHOLD_COOLING = 4;
var MAX_ORDER_THRESHOLD_MONITORS = 3;
var CONFIGURATOR_CATEGORY_RAM = "RAM";
var CONFIGURATOR_CATEGORY_STORAGE = "Storage";
var CONFIGURATOR_CATEGORY_COOLING = "Cooling";
var CONFIGURATOR_CATEGORY_EXTRAS = "Extras";
var CONFIGURATOR_CATEGORY_LIGHTING = "Lighting";
var CONFIGURATOR_CATEGORY_MONITORS = "Monitors";
var CONFIGURATOR_CATEGORY_SERVICES = "Services";
var CONFIGURATOR_CATEGORY_PERIPHERALS = "Peripherals";
var CONFIGURATOR_CATEGORY_SOFTWARE = "Software";
var CONFIGURATOR_CATEGORY_CASE = "Case";
var CONFIGURATOR_CATEGORY_MOTHERBOARDS = "Motherboards";
var CONFIGURATOR_CATEGORY_POWER_SUPPLY = "Power Supplies";
var CONFIGURATOR_CATEGORY_GPU = "GPU";
var CONFIGURATOR_CATEGORY_CPU = "CPU";
var CONFIGURATOR_CATEGORY_CHIPSET = "Chipset";
// access high quality assets based off of current build
var CONFIGURATOR_BUILD_COLORS = "Colors";
var CONFIGURATOR_RULE_ADD = "add";
var CONFIGURATOR_RULE_ENABLE = "enable";
// const CONFIGURATOR_RULE_DISABLE_ALL = 'disable-all';
var CONFIGURATOR_RULE_ENABLE_ALL = "enable-all";
var CONFIGURATOR_RULE_MESSAGE = "message";
var CONFIGURATOR_RULE_PREVENT = "prevent";
var CONFIGURATOR_RULE_RESET = "reset";
var CONFIGURATOR_RULE_SWITCH = "switch";
var configurator_obj;
var CONFIGURATOR_RULETYPES_MAP = (configurator_obj = {}, (0,_define_property/* default */.Z)(configurator_obj, CONFIGURATOR_RULE_ADD, "info"), (0,_define_property/* default */.Z)(configurator_obj, CONFIGURATOR_RULE_ENABLE, "success"), // [CONFIGURATOR_RULE_DISABLE_ALL]: 'info',
(0,_define_property/* default */.Z)(configurator_obj, CONFIGURATOR_RULE_ENABLE_ALL, "success"), (0,_define_property/* default */.Z)(configurator_obj, CONFIGURATOR_RULE_MESSAGE, "info"), (0,_define_property/* default */.Z)(configurator_obj, CONFIGURATOR_RULE_PREVENT, "error"), (0,_define_property/* default */.Z)(configurator_obj, CONFIGURATOR_RULE_RESET, "info"), (0,_define_property/* default */.Z)(configurator_obj, CONFIGURATOR_RULE_SWITCH, "info"), configurator_obj);
var configurator_obj1;
var CONFIGURATOR_RULE_TITLE = (configurator_obj1 = {}, (0,_define_property/* default */.Z)(configurator_obj1, CONFIGURATOR_RULE_ADD, "build_change_label"), (0,_define_property/* default */.Z)(configurator_obj1, CONFIGURATOR_RULE_ENABLE, "success_label"), // [CONFIGURATOR_RULE_DISABLE_ALL]: 'build_info_message',
(0,_define_property/* default */.Z)(configurator_obj1, CONFIGURATOR_RULE_ENABLE_ALL, "success_label"), (0,_define_property/* default */.Z)(configurator_obj1, CONFIGURATOR_RULE_MESSAGE, "build_info_message"), (0,_define_property/* default */.Z)(configurator_obj1, CONFIGURATOR_RULE_PREVENT, "invalid_action_label"), (0,_define_property/* default */.Z)(configurator_obj1, CONFIGURATOR_RULE_RESET, "build_change_label"), (0,_define_property/* default */.Z)(configurator_obj1, CONFIGURATOR_RULE_SWITCH, "build_change_label"), configurator_obj1);
var CONFIGURATOR_STORAGE_FILTER = [
    {
        label: "SSD",
        value: "ssd"
    },
    {
        label: "HDD",
        value: "hdd"
    }, 
];
var CONFIGURATOR_CASES_FILTER = [
    {
        label: "H710",
        value: "h710"
    },
    {
        label: "H510",
        value: "h510"
    },
    {
        label: "H210",
        value: "h210"
    },
    {
        label: "H1",
        value: "h1"
    }, 
];
var CONFIGURATOR_COOLING_FILTER = [
    {
        label: "Air",
        value: "fans"
    },
    {
        label: "Liquid",
        value: "aio"
    }, 
];
var CONFIGURATOR_CHIPSET_FILTER = [
    {
        label: "Intel",
        value: "intel"
    },
    {
        label: "AMD",
        value: "amd"
    }, 
];
var configurator_obj2;
var CONFIGURATOR_FILTER_MAP = (configurator_obj2 = {}, (0,_define_property/* default */.Z)(configurator_obj2, CONFIGURATOR_CATEGORY_STORAGE, CONFIGURATOR_STORAGE_FILTER), (0,_define_property/* default */.Z)(configurator_obj2, CONFIGURATOR_CATEGORY_COOLING, CONFIGURATOR_COOLING_FILTER), (0,_define_property/* default */.Z)(configurator_obj2, CONFIGURATOR_CATEGORY_CASE, CONFIGURATOR_CASES_FILTER), (0,_define_property/* default */.Z)(configurator_obj2, CONFIGURATOR_CATEGORY_MOTHERBOARDS, CONFIGURATOR_CHIPSET_FILTER), (0,_define_property/* default */.Z)(configurator_obj2, CONFIGURATOR_CATEGORY_GPU, CONFIGURATOR_CHIPSET_FILTER), (0,_define_property/* default */.Z)(configurator_obj2, CONFIGURATOR_CATEGORY_CPU, CONFIGURATOR_CHIPSET_FILTER), configurator_obj2);
// TODO: const these?
var SUMMARY_ROW_TRANSLATION_MAP = {
    case: "custom_bld_case",
    cpu: "custom_bld_cpu",
    gpu: "custom_bld_gpu",
    motherboard: "custom_bld_motherboard",
    ram: "custom_bld_ram",
    ssd: "custom_bld_ssd",
    cpuCooler: "custom_bld_caseCooling",
    powerSupply: "custom_bld_powerSupplies",
    software: "custom_bld_software",
    services: "custom_bld_services",
    monitors: "custom_bld_monitors",
    peripherals: "custom_bld_peripherals",
    hdd: "custom_bld_hdd",
    extras: "custom_bld_extras",
    specials: "custom_bld_specials",
    rgbs: "custom_bld_rgb_lighting",
    audio: "custom_bld_audio",
    caseFans: "custom_bld_fans",
    colors: "custom_bld_colors"
};
var CAT_NAMES = {
    chipset: {
        externalCatName: "custom_bld_chipset",
        internalCatName: "chipset",
        nextCategoryExternal: "custom_bld_case",
        nextCategoryInternal: "case",
        previousCategoryExternal: "custom_bld_chipset",
        previousCategoryInternal: "chipset"
    },
    case: {
        externalCatName: "custom_bld_case",
        internalCatName: "case",
        previousCategoryExternal: "custom_bld_chipset",
        previousCategoryInternal: "chipset",
        nextCategoryExternal: "custom_bld_caseCooling",
        nextCategoryInternal: "caseCooling"
    },
    cooling: {
        externalCatName: "custom_bld_caseCooling",
        internalCatName: "caseCooling",
        previousCategoryExternal: "custom_bld_case",
        previousCategoryInternal: "case",
        nextCategoryExternal: "custom_bld_motherboards",
        nextCategoryInternal: "motherboards"
    },
    motherboards: {
        externalCatName: "custom_bld_motherboards",
        internalCatName: "motherboards",
        previousCategoryExternal: "custom_bld_caseCooling",
        previousCategoryInternal: "caseCooling",
        nextCategoryExternal: "custom_bld_gpu",
        nextCategoryInternal: "gpu"
    },
    gpu: {
        externalCatName: "custom_bld_gpu",
        internalCatName: "gpu",
        previousCategoryExternal: "custom_bld_motherboards",
        previousCategoryInternal: "motherboards",
        nextCategoryExternal: "custom_bld_cpu",
        nextCategoryInternal: "cpu"
    },
    cpu: {
        externalCatName: "custom_bld_cpu",
        internalCatName: "cpu",
        previousCategoryExternal: "custom_bld_gpu",
        previousCategoryInternal: "gpu",
        nextCategoryExternal: "custom_bld_powerSupplies",
        nextCategoryInternal: "powerSupplies"
    },
    powerSupplies: {
        externalCatName: "custom_bld_powerSupplies",
        internalCatName: "powerSupplies",
        previousCategoryExternal: "custom_bld_cpu",
        previousCategoryInternal: "cpu",
        nextCategoryExternal: "custom_bld_ram",
        nextCategoryInternal: "ram"
    },
    ram: {
        externalCatName: "custom_bld_ram",
        internalCatName: "ram",
        previousCategoryExternal: "custom_bld_powerSupplies",
        previousCategoryInternal: "powerSupplies",
        nextCategoryExternal: "custom_bld_storage",
        nextCategoryInternal: "storage"
    },
    storage: {
        externalCatName: "custom_bld_storage",
        internalCatName: "storage",
        previousCategoryExternal: "custom_bld_ram",
        previousCategoryInternal: "ram",
        nextCategoryExternal: "custom_bld_monitors",
        nextCategoryInternal: "monitors"
    },
    monitors: {
        externalCatName: "custom_bld_monitors",
        internalCatName: "monitors",
        previousCategoryExternal: "custom_bld_storage",
        previousCategoryInternal: "storage",
        nextCategoryExternal: "custom_bld_peripherals",
        nextCategoryInternal: "peripherals"
    },
    peripherals: {
        externalCatName: "custom_bld_peripherals",
        internalCatName: "peripherals",
        previousCategoryExternal: "custom_bld_monitors",
        previousCategoryInternal: "monitors",
        nextCategoryExternal: "custom_bld_lighting",
        nextCategoryInternal: "rgbs"
    },
    lighting: {
        externalCatName: "custom_bld_rgb_lighting",
        internalCatName: "rgbs",
        previousCategoryExternal: "custom_bld_peripherals",
        previousCategoryInternal: "peripherals",
        nextCategoryExternal: "custom_bld_extras",
        nextCategoryInternal: "extras"
    },
    extras: {
        externalCatName: "custom_bld_extras",
        internalCatName: "extras",
        previousCategoryExternal: "custom_bld_rgb_lighting",
        previousCategoryInternal: "rgbs",
        nextCategoryExternal: "custom_bld_software",
        nextCategoryInternal: "software"
    },
    software: {
        externalCatName: "custom_bld_software",
        internalCatName: "software",
        previousCategoryExternal: "custom_bld_extras",
        previousCategoryInternal: "extras",
        nextCategoryExternal: "custom_bld_services",
        nextCategoryInternal: "services"
    },
    services: {
        externalCatName: "custom_bld_services",
        internalCatName: "services",
        previousCategoryExternal: "custom_bld_software",
        previousCategoryInternal: "software",
        nextCategoryExternal: "summary",
        nextCategoryInternal: "summary"
    }
};
var CATEGORY_FILTER = {
    core: [
        "chipset",
        "case",
        "motherboards",
        "caseCooling",
        "gpu",
        "cpu",
        "powerSupplies",
        "ram",
        "storage", 
    ],
    addOns: [
        "rgbs",
        "monitors",
        "peripherals",
        "extras",
        "software",
        "services"
    ]
};
// KB LANGS
var EN_QWERTY = "en-qwerty";
var UK_QWERTY = "uk-qwerty";
var DE_QWERTZ = "de-qwertz";
var FR_AZERTY = "fr-azerty";
// KB LEGENDS
var LEGENDS_ISO = {
    "fr-azerty": {
        black: "06-Legends-FR-Black.png",
        grey: "06-Legends-FR-Cool-Gray.png",
        inverted: "06-Legends-FR-Inverted.png",
        mixed: "06-Legends-FR-Mixed.png"
    },
    "de-qwertz": {
        black: "06-Legends-GE-Black.png",
        grey: "06-Legends-GE-Cool-Gray.png",
        inverted: "06-Legends-GE-Inverted.png",
        mixed: "06-Legends-GE-Mixed.png"
    },
    "uk-qwerty": {
        black: "06-Legends-UK-Black.png",
        grey: "06-Legends-UK-Cool-Gray.png",
        inverted: "06-Legends-UK-Inverted.png",
        mixed: "06-Legends-UK-Mixed.png"
    },
    "en-qwerty": {
        black: "06-Legends-UK-Black.png",
        grey: "06-Legends-UK-Cool-Gray.png",
        inverted: "06-Legends-UK-Inverted.png",
        mixed: "06-Legends-UK-Mixed.png"
    }
};
var LEGENDS_ANSI = {
    "en-qwerty": {
        black: "06-Legends-EN-Black.png",
        grey: "06-Legends-EN-Cool-Gray.png",
        inverted: "06-Legends-EN-Inverted.png",
        mixed: "06-Legends-EN-Mixed.png"
    }
};

;// CONCATENATED MODULE: ./constants/zendesk.ts
var ZENDESK_CUSTOM_FIELD_ID_REGION = 22491970;
var ZENDESK_CUSTOM_FIELD_ID_PRODUCT = 22642170;
var ZENDESK_CUSTOM_FIELD_ID_CONTACT = 22478634;
var ZENDESK_BRAND_ID_CAM = "114094740213";
var ZENDESK_BRAND_ID_DEFAULT = "36634";
var ZENDESK_ARTICLES_URL = "https://support.nzxt.com/hc/en-us";
var ZENDESK_TICKET_URL = "https://support.nzxt.com/hc/en-us/requests/new";
var ZENDESK_CHAT_KEY = "d0bd149e-0db2-435e-b7b3-4382195620c3";
var ZENDESK_SCRIPT_SRC = "https://static.zdassets.com/ekr/snippet.js?key=";
var LAUNCHER = {
    label: {
        "*": "Support",
        en: "Support",
        de: "Hilfe",
        fr: "Service d'assistance",
        it: "Servizio clienti",
        nl: "Support",
        es: "Soporte"
    }
};
var ZENDESK_WIDGET_CONFIG = {
    webWidget: {
        position: {
            horizontal: "right"
        },
        color: {
            theme: "#313234"
        },
        zIndex: 40,
        offset: {
            vertical: "10px",
            mobile: {
                horizontal: "10px",
                vertical: "62px"
            }
        },
        launcher: LAUNCHER
    }
};
var BLD_OFFSET = {
    vertical: "82px",
    mobile: {
        horizontal: "10px",
        vertical: "110px"
    }
};
var ZENDESK_WIDGET_CONFIG_LG_BUILD = {
    webWidget: {
        position: {
            horizontal: "left"
        },
        color: {
            theme: "#121214"
        },
        zIndex: 40,
        offset: BLD_OFFSET,
        launcher: LAUNCHER
    }
};
var ZENDESK_WIDGET_CONFIG_SM_BUILD = {
    webWidget: {
        position: {
            horizontal: "right"
        },
        color: {
            theme: "#121214"
        },
        zIndex: 40,
        offset: BLD_OFFSET,
        launcher: LAUNCHER
    }
};

;// CONCATENATED MODULE: ./constants/products.ts
var MAX_FPS = 130;
var DEFAULT_VARIANT_REGION = "variantsNorthernamerica";
var FPS_BUTTON_LABEL = [
    {
        label: "1080",
        value: "1080"
    },
    {
        label: "1440",
        value: "1440"
    }, 
];
var PRICE_OPTIONS_LABEL = [
    {
        label: "1000",
        value: "1000"
    },
    {
        label: "1500",
        value: "1500"
    },
    {
        label: "2000",
        value: "2000"
    },
    {
        label: "2500",
        value: "2500"
    }, 
];

;// CONCATENATED MODULE: ./constants/klaviyo.ts


var KLAVIYO_COMPANY_ID_NA = "M8RPxA";
var KLAVIYO_COMPANY_ID_EU = "Y9kvGQ";
var KLAVIYO_COMPANY_ID_AU = "UR6hve";
var KLAVIYO_COMPANY_ID_UK = "Y2VZHK";
var KLAVIYO_COMPANY_ID_NZ = "SySbg6";
var KLAVIYO_KEY_NA = "pk_c9922934b0e628a4b3863c4910a33729c3";
var KLAVIYO_KEY_EU = "pk_2e88bcffebc9ac82fc45154803d9f05644";
var KLAVIYO_KEY_AU = "pk_9f57791a13da597aaadf65fab3c067a555";
var KLAVIYO_KEY_UK = "pk_8a6e7795bd79f250aaf005d79420cc939d";
var KLAVIYO_KEY_NZ = "pk_1e8ef6a63b84cfec99c3aa1b3bb991ffa9";
var klaviyo_obj;
var KLAVIYO_CREDS_REGION_MAP = (klaviyo_obj = {}, (0,_define_property/* default */.Z)(klaviyo_obj, MAXIFY_REGION_NORTHERN_AMERICA, {
    companyId: KLAVIYO_COMPANY_ID_NA,
    key: KLAVIYO_KEY_NA
}), (0,_define_property/* default */.Z)(klaviyo_obj, MAXIFY_REGION_EUROPE, {
    companyId: KLAVIYO_COMPANY_ID_EU,
    key: KLAVIYO_KEY_EU
}), (0,_define_property/* default */.Z)(klaviyo_obj, MAXIFY_REGION_OCEANIA, {
    companyId: KLAVIYO_COMPANY_ID_AU,
    key: KLAVIYO_KEY_AU
}), (0,_define_property/* default */.Z)(klaviyo_obj, MAXIFY_REGION_UNITED_KINGDOM, {
    companyId: KLAVIYO_COMPANY_ID_UK,
    key: KLAVIYO_KEY_UK
}), (0,_define_property/* default */.Z)(klaviyo_obj, MAXIFY_REGION_NEW_ZEALAND, {
    companyId: KLAVIYO_COMPANY_ID_NZ,
    key: KLAVIYO_KEY_NZ
}), klaviyo_obj);
var KLAVIYO_LIST_STOCK_NOTIFICATION = "TxZ9eX";
var KLAVIYO_LIST_NEWSLETTER = "SeahJ8";
var KLAVIYO_LIST_NEWSLETTER_UK = "Xr5Gi2";
var KLAVIYO_LIST_NEWSLETTER_NZ = "TuYva8";
var klaviyo_obj1;
var KLAVIYO_LIST_ID_REGION_MAP = (klaviyo_obj1 = {}, (0,_define_property/* default */.Z)(klaviyo_obj1, MAXIFY_REGION_NORTHERN_AMERICA, KLAVIYO_LIST_NEWSLETTER), (0,_define_property/* default */.Z)(klaviyo_obj1, MAXIFY_REGION_EUROPE, KLAVIYO_LIST_NEWSLETTER), (0,_define_property/* default */.Z)(klaviyo_obj1, MAXIFY_REGION_OCEANIA, KLAVIYO_LIST_NEWSLETTER), (0,_define_property/* default */.Z)(klaviyo_obj1, MAXIFY_REGION_UNITED_KINGDOM, KLAVIYO_LIST_NEWSLETTER_UK), (0,_define_property/* default */.Z)(klaviyo_obj1, MAXIFY_REGION_NEW_ZEALAND, KLAVIYO_LIST_NEWSLETTER_NZ), klaviyo_obj1);
var klaviyo_obj2;
var KLAVIYO_SIGN_UP_COMPANY_ID_REGION_MAP = (klaviyo_obj2 = {}, (0,_define_property/* default */.Z)(klaviyo_obj2, MAXIFY_REGION_NORTHERN_AMERICA, KLAVIYO_KEY_NA), (0,_define_property/* default */.Z)(klaviyo_obj2, MAXIFY_REGION_EUROPE, KLAVIYO_KEY_NA), (0,_define_property/* default */.Z)(klaviyo_obj2, MAXIFY_REGION_OCEANIA, KLAVIYO_KEY_NA), (0,_define_property/* default */.Z)(klaviyo_obj2, MAXIFY_REGION_UNITED_KINGDOM, KLAVIYO_KEY_UK), (0,_define_property/* default */.Z)(klaviyo_obj2, MAXIFY_REGION_NEW_ZEALAND, KLAVIYO_KEY_NZ), klaviyo_obj2);

;// CONCATENATED MODULE: ./constants/keyboard.ts
var ANSI = "ansi";
var ISO = "iso";
var KB_NAME_MAP = {
    minitkl: "MiniTKL",
    tkl: "Tenkeyless",
    full: "Full Size"
};
var KB_CABLE_NAME_MAP = {
    KeyboardBase: {
        minitkl: "MiniTKL",
        tkl: "Tenkeyless",
        full: "Full Size"
    },
    cable: {
        coiled: "Coiled",
        straight: "Straight"
    }
};

;// CONCATENATED MODULE: ./constants/index.ts






















/***/ }),

/***/ 66138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Iy": function() { return /* binding */ MODAL_VIEW_FORGOT; },
/* harmony export */   "ef": function() { return /* binding */ MODAL_VIEW_LOGIN; },
/* harmony export */   "fD": function() { return /* binding */ MODAL_NOTICE_PAGE; },
/* harmony export */   "rg": function() { return /* binding */ MODAL_ARIA_LABEL_MAP; },
/* harmony export */   "t$": function() { return /* binding */ MODAL_VIEW_RESET; },
/* harmony export */   "tV": function() { return /* binding */ MODAL_VIEW_SIGNUP; }
/* harmony export */ });
/* unused harmony exports MODAL_VIEW_SР, MODAL_VIEW_BLD_OPTIONS, MODAL_VIEW_BLD_MORE_INFO, MODAL_VIEW_BLD_SUMMARY, MODAL_VIEW_EXPLORE, MODAL_VIEW_BLD_EXTRAS, MODAL_VIEW_BLD_ISSUES, MODAL_LOAD_BLD_PC, MODAL_LOAD_BLD_KB, MODAL_SHARE_BLD_PC, MODAL_SHARE_BLD_KB, MODAL_NOTIFICATION_SIGNUP_VIEW, MODAL_VIEW_BLD_INFO_HELP, MODAL_VIEW_PRODUCT_DETAILS, MODAL_VIEW_EMAIL_SIGN_UP, MODAL_VIEW_PRODUCT_POLICY, AFFIRM_LARGE_SIZE, AFFIRM_SMALL_SIZE, MODAL_ARIA_LABEL_SIGNUP, MODAL_ARIA_LABEL_LOGIN, MODAL_ARIA_LABEL_FORGOT, MODAL_ARIA_LABEL_RESET, MODAL_ARIA_LABEL_BLD_OPTIONS, MODAL_ARIA_LABEL_BLD_MORE_INFO, MODAL_ARIA_LABEL_BLD_SUMMARY, MODAL_ARIA_LABEL_EXPLORE, MODAL_ARIA_LABEL_EXTRAS, MODAL_ARIA_LABEL_MODAL_VIEW_BLD_ISSUES, MODAL_ARIA_LABEL_MODAL_LOAD_BLD_PC, MODAL_ARIA_LABEL_MODAL_LOAD_BLD_KB, MODAL_ARIA_LABEL_MODAL_SHARE_BLD_PC, MODAL_ARIA_LABEL_MODAL_SHARE_BLD_KB, MODAL_ARIA_NOTIFICATION_SIGNUP_VIEW, MODAL_ARIA_BLD_INFO_HELP, MODAL_ARIA_EMAIL_SIGN_UP, MODAL_ARIA_PRODUCT_POLICY, MODAL_ARIA_PRODUCT_DETAILS, MODAL_ARIA_UPSELL_VIEW, NZXT_WHITE, NZXT_LIGHT_GRAY_50, SM_NAV_HEIGHT_NUM, SM_NAV_HEIGHT */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);
// Modal Views

var MODAL_VIEW_SIGNUP = "SIGNUP_VIEW";
var MODAL_VIEW_LOGIN = "LOGIN_VIEW";
var MODAL_VIEW_FORGOT = "FORGOT_VIEW";
var MODAL_VIEW_RESET = "RESET_VIEW";
var MODAL_VIEW_SР = "RESET_VIEW";
var MODAL_VIEW_BLD_OPTIONS = "BLD_OPTIONS";
var MODAL_VIEW_BLD_MORE_INFO = "BLD_MORE_INFO";
var MODAL_VIEW_BLD_SUMMARY = "BLD_SUMMARY";
var MODAL_VIEW_EXPLORE = "EXPLORE";
var MODAL_VIEW_BLD_EXTRAS = "BLD_EXTRAS";
var MODAL_VIEW_BLD_ISSUES = "BLD_ISSUES";
var MODAL_LOAD_BLD_PC = "LOAD_BLD_PC";
var MODAL_LOAD_BLD_KB = "LOAD_BLD_KB";
var MODAL_SHARE_BLD_PC = "SHARE_BLD_PC";
var MODAL_SHARE_BLD_KB = "SHARE_BLD_KB";
var MODAL_NOTIFICATION_SIGNUP_VIEW = "NOTIFICATION_SIGN_UP_VIEW";
var MODAL_VIEW_BLD_INFO_HELP = "BLD_INFO_HELP";
var MODAL_VIEW_PRODUCT_DETAILS = "PRODUCT_DETAILS";
var MODAL_VIEW_EMAIL_SIGN_UP = "MODAL_VIEW_EMAIL_SIGN_UP";
var MODAL_VIEW_PRODUCT_POLICY = "MODAL_VIEW_PRODUCT_POLICY";
var AFFIRM_LARGE_SIZE = "AFFIRM_LARGE_SIZE";
var AFFIRM_SMALL_SIZE = "AFFIRM_SMALL_SIZE";
var MODAL_NOTICE_PAGE = "NOTICE_PAGE";
// Modal aria labels
var MODAL_ARIA_LABEL_SIGNUP = "Sign up Form";
var MODAL_ARIA_LABEL_LOGIN = "Login Form";
var MODAL_ARIA_LABEL_FORGOT = "Forgot password form";
var MODAL_ARIA_LABEL_RESET = "Reset password form";
var MODAL_ARIA_LABEL_BLD_OPTIONS = "BLD Options";
var MODAL_ARIA_LABEL_BLD_MORE_INFO = "BLD More Info";
var MODAL_ARIA_LABEL_BLD_SUMMARY = "BLD Summary";
var MODAL_ARIA_LABEL_EXPLORE = "Explore BLD Category";
var MODAL_ARIA_LABEL_EXTRAS = "BLD Extras";
var MODAL_ARIA_LABEL_MODAL_VIEW_BLD_ISSUES = "BLD Issue";
var MODAL_ARIA_LABEL_MODAL_LOAD_BLD_PC = "Load BLD PC";
var MODAL_ARIA_LABEL_MODAL_LOAD_BLD_KB = "Load BLD KB";
var MODAL_ARIA_LABEL_MODAL_SHARE_BLD_PC = "Share BLD PC";
var MODAL_ARIA_LABEL_MODAL_SHARE_BLD_KB = "Share BLD KB";
var MODAL_ARIA_NOTIFICATION_SIGNUP_VIEW = "Sign Up for Notifications";
var MODAL_ARIA_BLD_INFO_HELP = "Category details";
var MODAL_ARIA_EMAIL_SIGN_UP = "Sign Up for Emails";
var MODAL_ARIA_PRODUCT_POLICY = "Product Policy Information";
var MODAL_ARIA_PRODUCT_DETAILS = "Product Details";
var MODAL_ARIA_UPSELL_VIEW = "Additional Products for Purchase";
var _obj;
var MODAL_ARIA_LABEL_MAP = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, MODAL_VIEW_SIGNUP, MODAL_ARIA_LABEL_SIGNUP), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, MODAL_VIEW_LOGIN, MODAL_ARIA_LABEL_LOGIN), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, MODAL_VIEW_FORGOT, MODAL_ARIA_LABEL_FORGOT), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, MODAL_VIEW_RESET, MODAL_ARIA_LABEL_RESET), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, MODAL_VIEW_BLD_OPTIONS, MODAL_ARIA_LABEL_BLD_OPTIONS), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, MODAL_VIEW_BLD_MORE_INFO, MODAL_ARIA_LABEL_BLD_MORE_INFO), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, MODAL_VIEW_EXPLORE, MODAL_ARIA_LABEL_EXPLORE), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, MODAL_VIEW_BLD_SUMMARY, MODAL_ARIA_LABEL_BLD_SUMMARY), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, MODAL_VIEW_BLD_EXTRAS, MODAL_ARIA_LABEL_EXTRAS), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, MODAL_VIEW_BLD_ISSUES, MODAL_ARIA_LABEL_MODAL_VIEW_BLD_ISSUES), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, MODAL_LOAD_BLD_PC, MODAL_ARIA_LABEL_MODAL_LOAD_BLD_PC), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, MODAL_LOAD_BLD_KB, MODAL_ARIA_LABEL_MODAL_LOAD_BLD_KB), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, MODAL_SHARE_BLD_PC, MODAL_ARIA_LABEL_MODAL_SHARE_BLD_PC), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, MODAL_SHARE_BLD_KB, MODAL_ARIA_LABEL_MODAL_SHARE_BLD_KB), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, MODAL_NOTIFICATION_SIGNUP_VIEW, MODAL_ARIA_NOTIFICATION_SIGNUP_VIEW), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, MODAL_VIEW_BLD_INFO_HELP, MODAL_ARIA_BLD_INFO_HELP), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, MODAL_VIEW_EMAIL_SIGN_UP, MODAL_ARIA_EMAIL_SIGN_UP), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, MODAL_VIEW_PRODUCT_POLICY, MODAL_ARIA_PRODUCT_POLICY), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, MODAL_VIEW_PRODUCT_DETAILS, MODAL_ARIA_PRODUCT_DETAILS), _obj);
// Color Values
var NZXT_WHITE = "FFFFFF";
var NZXT_LIGHT_GRAY_50 = "#F5F5F8";
// NAV HEIGHTS
var SM_NAV_HEIGHT_NUM = 65;
var SM_NAV_HEIGHT = "65px";


/***/ }),

/***/ 55469:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ur": function() { return /* reexport */ get_region_getRegion; },
  "LP": function() { return /* reexport */ get_token; },
  "o4": function() { return /* reexport */ set_token; }
});

// UNUSED EXPORTS: getLang, getMaxifyHeaders

// EXTERNAL MODULE: ./constants/index.ts + 15 modules
var constants = __webpack_require__(47041);
;// CONCATENATED MODULE: ./framework/api/utils/maxify/get-lang.ts

function get_lang_getLang(locale) {
    // these are special cases specific to English and Chinese
    if (MAXIFY_LOCALE_MAP_MULTIPLE_LOCALES_PER_LANG[locale]) {
        return MAXIFY_LOCALE_MAP_MULTIPLE_LOCALES_PER_LANG[locale];
    }
    var parsedLocale = locale ? locale.split("-")[0] : DEFAULT_LOCALE.split("-")[0];
    return MAXIFY_LOCALE_MAP[parsedLocale.toLowerCase()];
};

;// CONCATENATED MODULE: ./framework/api/utils/maxify/get-region.ts

function get_region_getRegion(locale) {
    var parsedLocale = locale ? locale.split("-")[1] : constants/* DEFAULT_LOCALE.split */.ZWN.split("-")[1];
    return constants/* MAXIFY_REGION_MAP */.vm3[parsedLocale === null || parsedLocale === void 0 ? void 0 : parsedLocale.toUpperCase()] || constants/* MAXIFY_DEFAULT_REGION */.uTf;
};

// EXTERNAL MODULE: ./node_modules/nookies/dist/index.js
var dist = __webpack_require__(62286);
;// CONCATENATED MODULE: ./framework/api/utils/maxify/get-token.ts


var get_token_getToken = function() {
    var cookies = (0,dist.parseCookies)();
    return cookies[constants/* MAXIFY_TOKEN_COOKIE_NAME */.J8U];
};
/* harmony default export */ var get_token = (get_token_getToken);

// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 4 modules
var v4 = __webpack_require__(25934);
;// CONCATENATED MODULE: ./framework/api/utils/maxify/set-token.ts



var setToken = function(locale, prevToken) {
    (0,dist.setCookie)(null, constants/* MAXIFY_TOKEN_COOKIE_NAME */.J8U, "".concat(prevToken || (0,v4/* default */.Z)(), "-").concat(locale), {
        maxAge: constants/* SYSTEM_COOKIE_MAX_AGE */.qHr,
        expires: new Date(Date.now() + constants/* SYSTEM_COOKIE_MAX_AGE */.qHr * 1000),
        secure: "production" === "production",
        path: "/",
        sameSite: "lax"
    });
};
/* harmony default export */ var set_token = (setToken);

;// CONCATENATED MODULE: ./framework/api/utils/maxify/get-maxify-headers.ts



function getMaxifyHeaders(locale) {
    return {
        locale: getLang(locale),
        region: getRegion(locale),
        token: getToken() || " "
    };
};

;// CONCATENATED MODULE: ./framework/api/utils/maxify/index.ts








/***/ }),

/***/ 56560:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Tb": function() { return /* reexport */ get_shopify_cart_cookie; },
  "HR": function() { return /* reexport */ set_shopify_cart_cookie; }
});

// UNUSED EXPORTS: fetchAndSetShopifyCartCookie

// EXTERNAL MODULE: ./node_modules/nookies/dist/index.js
var dist = __webpack_require__(62286);
// EXTERNAL MODULE: ./constants/index.ts + 15 modules
var constants = __webpack_require__(47041);
;// CONCATENATED MODULE: ./framework/api/utils/shopify-cart-cookie/get-shopify-cart-cookie.ts


var getShopifyCartCookie = function() {
    var country = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : constants/* DEFAULT_COUNTRY_CODE */.ss5;
    var cookies = (0,dist.parseCookies)();
    return cookies["".concat(constants/* SHOPIFY_CART_ID_COOKIE_NAME */.h6Y, "_").concat(country)];
};
/* harmony default export */ var get_shopify_cart_cookie = (getShopifyCartCookie);

;// CONCATENATED MODULE: ./framework/api/utils/shopify-cart-cookie/set-shopify-cart-cookie.ts
/* eslint-disable default-param-last */ 

var setShopifyCartCookie = function() {
    var country = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : constants/* DEFAULT_COUNTRY_CODE */.ss5, cartId = arguments.length > 1 ? arguments[1] : void 0;
    (0,dist.setCookie)(null, "".concat(constants/* SHOPIFY_CART_ID_COOKIE_NAME */.h6Y, "_").concat(country), cartId, {
        maxAge: constants/* SYSTEM_COOKIE_MAX_AGE */.qHr,
        expires: new Date(Date.now() + constants/* SYSTEM_COOKIE_MAX_AGE */.qHr * 1000),
        secure: "production" === "production",
        path: "/",
        sameSite: "lax"
    });
};
/* harmony default export */ var set_shopify_cart_cookie = (setShopifyCartCookie);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
;// CONCATENATED MODULE: ./framework/api/utils/shopify-cart-cookie/fetch-and-set-shopify-cart-cookie.ts




var fetchAndSetShopifyCartCookie = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var country, cartId, data, _args = arguments;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    country = _args.length > 0 && _args[0] !== void 0 ? _args[0] : constants/* DEFAULT_COUNTRY_CODE */.ss5;
                    if (false) {}
                    _ctx.prev = 2;
                    _ctx.next = 5;
                    return fetch("/api/maxify/cart", {
                        method: "PATCH"
                    }).then(function(r) {
                        return r.json();
                    });
                case 5:
                    cartId = _ctx.sent;
                    data = cartId.data;
                    set_shopify_cart_cookie(country, data);
                    _ctx.next = 13;
                    break;
                case 10:
                    _ctx.prev = 10;
                    _ctx.t0 = _ctx["catch"](2);
                    // eslint-disable-next-line no-console
                    console.log(_ctx.t0);
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                2,
                10
            ]
        ]);
    }));
    return function fetchAndSetShopifyCartCookie() {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var fetch_and_set_shopify_cart_cookie = ((/* unused pure expression or super */ null && (fetchAndSetShopifyCartCookie)));

;// CONCATENATED MODULE: ./framework/api/utils/shopify-cart-cookie/index.ts






/***/ }),

/***/ 2165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ cart_use_add_item; }
});

// UNUSED EXPORTS: extendHook, fetcher

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./framework/utils/use-action.tsx
var use_action = __webpack_require__(62253);
;// CONCATENATED MODULE: ./framework/commerce/cart/use-add-item.tsx

var useAddItem = use_action/* default */.Z;
/* harmony default export */ var use_add_item = (useAddItem);

// EXTERNAL MODULE: ./framework/utils/errors.ts + 12 modules
var errors = __webpack_require__(2063);
// EXTERNAL MODULE: ./framework/cart/use-cart.tsx + 1 modules
var use_cart = __webpack_require__(37305);
;// CONCATENATED MODULE: ./framework/cart/use-add-item.tsx
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable @typescript-eslint/no-non-null-assertion */ 







var defaultOpts = {
    url: "/api/maxify/cart",
    method: "POST"
};
var fetcher = function(options, param, fetch) {
    var item = param.item;
    if (!Array.isArray(item) && item.quantity && (!Number.isInteger(item.quantity) || item.quantity < 1)) {
        throw new errors/* CommerceError */.yG({
            message: "The item quantity has to be a valid integer greater than 0"
        });
    }
    if (Array.isArray(item) && item.some(function(i) {
        return i.quantity && (!Number.isInteger(i.quantity) || i.quantity < 1);
    })) {
        throw new errors/* CommerceError */.yG({
            message: "The item quantity has to be a valid integer greater than 0"
        });
    }
    return fetch((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, defaultOpts, options), {
        body: {
            item: item
        }
    }));
};
function extendHook(customFetcher) {
    var useAddItem = function() {
        var mutate = (0,use_cart/* default */.ZP)().mutate;
        var fn = use_add_item(defaultOpts, customFetcher);
        return (0,react.useCallback)(function() {
            var _addItem = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(input) {
                var data;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return fn({
                                item: input
                            });
                        case 2:
                            data = _ctx.sent;
                            _ctx.next = 5;
                            return mutate(data, false);
                        case 5:
                            return _ctx.abrupt("return", data);
                        case 6:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            function addItem(input) {
                return _addItem.apply(this, arguments);
            }
            return addItem;
        }(), [
            fn,
            mutate
        ]);
    };
    useAddItem.extend = extendHook;
    return useAddItem;
}
/* harmony default export */ var cart_use_add_item = (extendHook(fetcher));


/***/ }),

/***/ 37305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ use_cart; }
});

// UNUSED EXPORTS: extendHook, fetcher

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./constants/index.ts + 15 modules
var constants = __webpack_require__(47041);
// EXTERNAL MODULE: ./utils/parse-locale.ts
var parse_locale = __webpack_require__(24343);
// EXTERNAL MODULE: ./framework/api/utils/shopify-cart-cookie/index.ts + 3 modules
var shopify_cart_cookie = __webpack_require__(56560);
// EXTERNAL MODULE: ./framework/utils/use-data.tsx + 1 modules
var use_data = __webpack_require__(81261);
;// CONCATENATED MODULE: ./framework/commerce/cart/use-cart.tsx
/* eslint-disable @typescript-eslint/explicit-function-return-type */ 
function use_cart_useCart(options, input, fetcherFn, swrOptions) {
    var response = (0,use_data/* default */.Z)(options, input, fetcherFn, swrOptions);
    return Object.assign(response, {
        isEmpty: true,
        count: 0
    });
};

;// CONCATENATED MODULE: ./framework/cart/use-cart.tsx
/* eslint-disable @typescript-eslint/explicit-function-return-type */ 






var defaultOpts = {
    url: "/api/maxify/cart",
    method: "GET"
};
var fetcher = function(options, param, fetch) {
    var cartId = param.cartId;
    return cartId ? fetch((0,_object_spread/* default */.Z)({}, defaultOpts, options)) : null;
};
function extendHook(customFetcher, swrOptions) {
    var useCart = function() {
        var router = (0,next_router.useRouter)();
        var locale = router.locale;
        var parsedLocale = (0,parse_locale/* default */.Z)(constants/* DEFAULT_LOCALE */.ZWN, locale);
        var country = parsedLocale[1] || constants/* DEFAULT_COUNTRY_CODE */.ss5;
        var response = use_cart_useCart(defaultOpts, [
            [
                "cartId",
                (0,shopify_cart_cookie/* getShopifyCartCookie */.Tb)(country)
            ]
        ], customFetcher, (0,_object_spread/* default */.Z)({
            revalidateOnFocus: false
        }, swrOptions));
        // Uses a getter to only calculate the prop when required
        // response.data is also a getter and it's better to not trigger it early
        Object.defineProperty(response, "isEmpty", {
            get: function get() {
                var ref, ref1, ref2;
                return ((ref = response.data) === null || ref === void 0 ? void 0 : (ref1 = ref.lines) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.edges) === null || ref2 === void 0 ? void 0 : ref2.length) <= 0;
            },
            set: function(x) {
                return x;
            }
        });
        Object.defineProperty(response, "count", {
            get: function get() {
                var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
                var ref9;
                var noBuildItems = (ref9 = (ref = response.data) === null || ref === void 0 ? void 0 : (ref1 = ref.lines) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.edges) === null || ref2 === void 0 ? void 0 : ref2.filter(function(i) {
                    var ref, ref1;
                    return !(i === null || i === void 0 ? void 0 : (ref = i.node) === null || ref === void 0 ? void 0 : (ref1 = ref.attributes) === null || ref1 === void 0 ? void 0 : ref1.some(function(a) {
                        return a.key === "build_number";
                    }));
                })) !== null && ref9 !== void 0 ? ref9 : [];
                var ref10;
                var warrItems = (ref10 = (ref3 = response.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.lines) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.edges) === null || ref5 === void 0 ? void 0 : ref5.filter(function(i) {
                    var ref, ref1, ref2, ref3, ref4;
                    return (i === null || i === void 0 ? void 0 : (ref = i.node) === null || ref === void 0 ? void 0 : (ref1 = ref.attributes) === null || ref1 === void 0 ? void 0 : ref1.some(function(a) {
                        return a.key === "build_number";
                    })) && (i === null || i === void 0 ? void 0 : (ref2 = i.node) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.merchandise) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.title) === null || ref4 === void 0 ? void 0 : ref4.includes("Extended Warranty"));
                })) !== null && ref10 !== void 0 ? ref10 : [];
                var items = (0,_to_consumable_array/* default */.Z)(noBuildItems).concat((0,_to_consumable_array/* default */.Z)(warrItems));
                var ref11;
                var itemQtys = items.map(function(n) {
                    var ref;
                    return (ref11 = n === null || n === void 0 ? void 0 : (ref = n.node) === null || ref === void 0 ? void 0 : ref.quantity) !== null && ref11 !== void 0 ? ref11 : 0;
                });
                var itemCount = itemQtys.length > 0 ? itemQtys.reduce(function(prev, current) {
                    return prev + current;
                }, 0) : 0;
                var ref12;
                var buildItems = (ref12 = (ref6 = response.data) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.lines) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.edges) === null || ref8 === void 0 ? void 0 : ref8.filter(function(i) {
                    var ref, ref1;
                    return i === null || i === void 0 ? void 0 : (ref = i.node) === null || ref === void 0 ? void 0 : (ref1 = ref.attributes) === null || ref1 === void 0 ? void 0 : ref1.some(function(a) {
                        return a.key === "build_number";
                    });
                })) !== null && ref12 !== void 0 ? ref12 : [];
                var _value;
                var buildNumbers = (0,_to_consumable_array/* default */.Z)(new Set(buildItems.map(function(i) {
                    var ref, ref1;
                    return (_value = i === null || i === void 0 ? void 0 : (ref = i.node) === null || ref === void 0 ? void 0 : (ref1 = ref.attributes) === null || ref1 === void 0 ? void 0 : ref1.find(function(a) {
                        return a.key === "build_number";
                    }).value) !== null && _value !== void 0 ? _value : null;
                })));
                var buildQtys = {};
                buildNumbers.forEach(function(buildNo) {
                    var ref;
                    var bld = buildItems.find(function(b) {
                        var ref, ref1;
                        return b === null || b === void 0 ? void 0 : (ref = b.node) === null || ref === void 0 ? void 0 : (ref1 = ref.attributes) === null || ref1 === void 0 ? void 0 : ref1.find(function(a) {
                            return a.key === "build_number" && a.value === buildNo;
                        });
                    });
                    var ref1;
                    buildQtys[buildNo] = (ref1 = bld === null || bld === void 0 ? void 0 : (ref = bld.node) === null || ref === void 0 ? void 0 : ref.quantity) !== null && ref1 !== void 0 ? ref1 : 0;
                });
                var buildCount = Object.keys(buildQtys).map(function(k) {
                    return buildQtys[k];
                }).reduce(function(prev, current) {
                    return prev + current;
                }, 0);
                return itemCount + buildCount;
            },
            set: function(x) {
                return x;
            }
        });
        return response;
    };
    useCart.extend = extendHook;
    return useCart;
}
/* harmony default export */ var use_cart = (extendHook(fetcher));


/***/ }),

/***/ 84634:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ CommerceProvider; },
/* harmony export */   "a": function() { return /* binding */ useCommerce; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/ban-types */ 


var Commerce = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({});
function CommerceProvider(param) {
    var children = param.children, config = param.config;
    if (!config) {
        throw new Error("CommerceProvider requires a valid config object");
    }
    var fetcherRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(config.fetcher);
    var cfg = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return {
            fetcherRef: fetcherRef,
            locale: config.locale,
            cartCookie: config.cartCookie,
            cartCookieValue: config.cartCookieValue,
            shopifyCartCookie: config.shopifyCartCookie
        };
    }, [
        config.locale,
        config.cartCookie,
        config.cartCookieValue,
        config.shopifyCartCookie, 
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Commerce.Provider, {
        value: cfg,
        children: children
    });
}
function useCommerce() {
    return (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(Commerce);
}


/***/ }),

/***/ 43695:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SN": function() { return /* binding */ CommerceProvider; },
/* harmony export */   "aF": function() { return /* binding */ useCommerce; }
/* harmony export */ });
/* unused harmony export maxifyConfig */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(99534);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47041);
/* harmony import */ var _utils_errors__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2063);
/* harmony import */ var _commerce__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84634);
/* harmony import */ var _api_utils_maxify__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(55469);
/* harmony import */ var _api_utils_shopify_cart_cookie__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(56560);
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable @typescript-eslint/no-non-null-assertion */ /* eslint-disable @typescript-eslint/explicit-function-return-type */ 










function getText(res) {
    return _getText.apply(this, arguments);
}
function _getText() {
    _getText = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(res) {
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.prev = 0;
                    _ctx.next = 3;
                    return res.text();
                case 3:
                    _ctx.t0 = _ctx.sent;
                    if (_ctx.t0) {
                        _ctx.next = 6;
                        break;
                    }
                    _ctx.t0 = res.statusText;
                case 6:
                    return _ctx.abrupt("return", _ctx.t0);
                case 9:
                    _ctx.prev = 9;
                    _ctx.t1 = _ctx["catch"](0);
                    return _ctx.abrupt("return", res.statusText);
                case 12:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                0,
                9
            ]
        ]);
    }));
    return _getText.apply(this, arguments);
}
function getError(res) {
    return _getError.apply(this, arguments);
}
function _getError() {
    _getError = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(res) {
        var ref, data;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    if (!((ref = res.headers.get("Content-Type")) === null || ref === void 0 ? void 0 : ref.includes("application/json"))) {
                        _ctx.next = 6;
                        break;
                    }
                    _ctx.next = 4;
                    return res.json();
                case 4:
                    data = _ctx.sent;
                    return _ctx.abrupt("return", new _utils_errors__WEBPACK_IMPORTED_MODULE_4__/* .FetcherError */ .T4({
                        errors: data.errors,
                        status: res.status
                    }));
                case 6:
                    _ctx.t0 = _utils_errors__WEBPACK_IMPORTED_MODULE_4__/* .FetcherError */ .T4;
                    _ctx.next = 9;
                    return getText(res);
                case 9:
                    _ctx.t1 = _ctx.sent;
                    _ctx.t2 = res.status;
                    _ctx.t3 = {
                        message: _ctx.t1,
                        status: _ctx.t2
                    };
                    return _ctx.abrupt("return", new _ctx.t0(_ctx.t3));
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getError.apply(this, arguments);
}
var maxifyConfig = {
    locale: _constants__WEBPACK_IMPORTED_MODULE_3__/* .DEFAULT_LOCALE */ .ZWN,
    cartCookie: _constants__WEBPACK_IMPORTED_MODULE_3__/* .MAXIFY_TOKEN_COOKIE_NAME */ .J8U,
    cartCookieValue: (0,_api_utils_maxify__WEBPACK_IMPORTED_MODULE_6__/* .getToken */ .LP)(),
    shopifyCartCookie: (0,_api_utils_shopify_cart_cookie__WEBPACK_IMPORTED_MODULE_7__/* .getShopifyCartCookie */ .Tb)(_constants__WEBPACK_IMPORTED_MODULE_3__/* .DEFAULT_LOCALE */ .ZWN),
    fetcher: function fetcher(param) {
        var url = param.url, _method = param.method, method = _method === void 0 ? "GET" : _method, variables = param.variables, bodyObj = param.body;
        return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var hasBody, body, headers, res, data;
            return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        hasBody = Boolean(variables || bodyObj);
                        body = hasBody ? JSON.stringify(variables ? {
                            variables: variables
                        } : bodyObj) : undefined;
                        headers = hasBody ? {
                            "Content-Type": "application/json"
                        } : undefined;
                        _ctx.next = 5;
                        return fetch(url, {
                            method: method,
                            body: body,
                            headers: headers
                        });
                    case 5:
                        res = _ctx.sent;
                        if (!res.ok) {
                            _ctx.next = 11;
                            break;
                        }
                        _ctx.next = 9;
                        return res.json();
                    case 9:
                        data = _ctx.sent.data;
                        return _ctx.abrupt("return", data);
                    case 11:
                        _ctx.next = 13;
                        return getError(res);
                    case 13:
                        throw _ctx.sent;
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    }
};
function CommerceProvider(_param) {
    var children = _param.children, config = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_commerce__WEBPACK_IMPORTED_MODULE_5__/* .CommerceProvider */ .S, {
        config: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, maxifyConfig, config),
        children: children
    });
}
var useCommerce = function() {
    return (0,_commerce__WEBPACK_IMPORTED_MODULE_5__/* .useCommerce */ .a)();
};


/***/ }),

/***/ 2063:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "yG": function() { return /* binding */ CommerceError; },
  "O1": function() { return /* binding */ ERROR_CODES; },
  "T4": function() { return /* binding */ FetcherError; },
  "H4": function() { return /* binding */ getErrorMessageKey; }
});

// UNUSED EXPORTS: getErrorMessageKeys

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_set_prototype_of.mjs
function setPrototypeOf(o, p) {
  setPrototypeOf = Object.setPrototypeOf || function setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return setPrototypeOf(o, p);
}

function _setPrototypeOf(o, p) {
  return setPrototypeOf(o, p);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs


function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_construct.mjs


function isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () { }));
    return true;
  } catch (e) {
    return false;
  }
}

function construct(Parent, args, Class) {
  if (isNativeReflectConstruct()) {
    construct = Reflect.construct;
  } else {
    construct = function construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return construct.apply(null, arguments);
}

function _construct(Parent, args, Class) {
  return construct.apply(null, arguments);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_is_native_function.mjs
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_get_prototype_of.mjs
function getPrototypeOf(o) {
  getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return getPrototypeOf(o);
}

function _getPrototypeOf(o) {
  return getPrototypeOf(o);
}
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_wrap_native_super.mjs





function wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  wrapNativeSuper = function wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return wrapNativeSuper(Class);
}

function _wrapNativeSuper(Class) {
  return wrapNativeSuper(Class);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_is_native_reflect_construct.mjs
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { }));
        return true;
    } catch (e) {
        return false;
    }
}
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_type_of.mjs
function _typeof(obj) {
    "@swc/helpers - typeof";
    return obj && obj.constructor === Symbol ? "symbol" : typeof obj;
};

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_possible_constructor_return.mjs



function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs




function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived),
            result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
;// CONCATENATED MODULE: ./framework/utils/errors.ts
/* eslint-disable max-classes-per-file */ /* eslint-disable @typescript-eslint/no-non-null-assertion */ 





var CommerceError = /*#__PURE__*/ function(Error1) {
    "use strict";
    _inherits(CommerceError, Error1);
    var _super = _createSuper(CommerceError);
    function CommerceError(param) {
        var message = param.message, code = param.code, errors = param.errors;
        _classCallCheck(this, CommerceError);
        var _this;
        var error = message ? (0,_object_spread/* default */.Z)({
            message: message
        }, code ? {
            code: code
        } : {}) : errors[0];
        _this = _super.call(this, error.message);
        _this.errors = message ? [
            error
        ] : errors;
        if (error.code) _this.code = error.code;
        return _this;
    }
    return CommerceError;
}(_wrapNativeSuper(Error));
var FetcherError = /*#__PURE__*/ function(CommerceError) {
    "use strict";
    _inherits(FetcherError, CommerceError);
    var _super = _createSuper(FetcherError);
    function FetcherError(options) {
        _classCallCheck(this, FetcherError);
        var _this;
        _this = _super.call(this, options);
        _this.status = options.status;
        return _this;
    }
    return FetcherError;
}(CommerceError);
var ERROR_CODES;
(function(ERROR_CODES) {
    ERROR_CODES["Generic"] = "UNKNOWN_ERROR";
    ERROR_CODES["EmailRequired"] = "EMAIL_REQUIRED";
    ERROR_CODES["ResourceExhausted"] = "RESOURCE_EXHAUSTED";
    ERROR_CODES["InvalidArgument"] = "INVALID_ARGUMENT";
    ERROR_CODES["UnAuthenticated"] = "UNAUTHENTICATED";
    ERROR_CODES["InvalidAccessToken"] = "INVALID_ACCESS_TOKEN";
    ERROR_CODES["NotFound"] = "NOT_FOUND";
    ERROR_CODES["UniquePasswordRequired"] = "UNIQUE_PASSWORD_REQUIRED";
    ERROR_CODES["InvalidCurrentPassword"] = "INVALID_CURRENT_PASSWORD";
    ERROR_CODES["InvalidPassword"] = "INVALID_PASSWORD";
    ERROR_CODES["InvalidUsername"] = "INVALID_USERNAME";
    ERROR_CODES["TokenExpired"] = "TOKEN_EXPIRED";
    ERROR_CODES["TokenInvalid"] = "TOKEN_INVALID";
    ERROR_CODES["EmailAlreadyExists"] = "EMAIL_ALREADY_EXISTS";
    ERROR_CODES["EmailNotVerified"] = "EMAIL_NOT_VERIFIED";
    ERROR_CODES["EmailAlreadyVerified"] = "EMAIL_ALREADY_VERIFIED";
    ERROR_CODES["UsernameAlreadyExists"] = "USERNAME_ALREADY_EXISTS";
    ERROR_CODES["CredentialsSignin"] = "CredentialsSignin";
    ERROR_CODES["SubscriptionFailed"] = "SUBSCRIPTION_FAILED";
    ERROR_CODES["RefreshAccessTokenError"] = "RefreshAccessTokenError";
    ERROR_CODES["LocalAccountExists"] = "LocalAccountExists";
    ERROR_CODES["GoogleAccountExists"] = "GoogleAccountExists";
})(ERROR_CODES || (ERROR_CODES = {}));
var _obj;
var ERROR_MESSAGES = (_obj = {}, (0,_define_property/* default */.Z)(_obj, ERROR_CODES.Generic, "error_generic"), (0,_define_property/* default */.Z)(_obj, ERROR_CODES.EmailRequired, "user_forgot_required_email"), (0,_define_property/* default */.Z)(_obj, ERROR_CODES.ResourceExhausted, "error_too_many_requests"), (0,_define_property/* default */.Z)(_obj, ERROR_CODES.InvalidArgument, "error_invalid_request"), (0,_define_property/* default */.Z)(_obj, ERROR_CODES.UnAuthenticated, "user_login_wrong_email_or_password"), (0,_define_property/* default */.Z)(_obj, ERROR_CODES.InvalidAccessToken, "error_invalid_token"), (0,_define_property/* default */.Z)(_obj, ERROR_CODES.NotFound, "error_user_not_found"), (0,_define_property/* default */.Z)(_obj, ERROR_CODES.UniquePasswordRequired, "error_reset_password_same_as_old_password"), (0,_define_property/* default */.Z)(_obj, ERROR_CODES.InvalidCurrentPassword, "invalid_current_password"), (0,_define_property/* default */.Z)(_obj, ERROR_CODES.InvalidPassword, "password_pattern_message"), (0,_define_property/* default */.Z)(_obj, ERROR_CODES.InvalidUsername, "username_full_pattern_message"), (0,_define_property/* default */.Z)(_obj, ERROR_CODES.TokenExpired, "error_reset_password_link_expired"), (0,_define_property/* default */.Z)(_obj, ERROR_CODES.TokenInvalid, "error_reset_password_link_invalid"), (0,_define_property/* default */.Z)(_obj, ERROR_CODES.EmailAlreadyExists, "error_email_exists"), (0,_define_property/* default */.Z)(_obj, ERROR_CODES.EmailNotVerified, "error_email_not_verified"), (0,_define_property/* default */.Z)(_obj, ERROR_CODES.EmailAlreadyVerified, "error_email_already_verified"), (0,_define_property/* default */.Z)(_obj, ERROR_CODES.UsernameAlreadyExists, "error_username_unavailable"), (0,_define_property/* default */.Z)(_obj, ERROR_CODES.CredentialsSignin, "user_login_wrong_email_or_password"), (0,_define_property/* default */.Z)(_obj, ERROR_CODES.SubscriptionFailed, "error_newsletter_subscription"), (0,_define_property/* default */.Z)(_obj, ERROR_CODES.RefreshAccessTokenError, "error_session_expired"), (0,_define_property/* default */.Z)(_obj, ERROR_CODES.LocalAccountExists, "error_local_account_exists"), (0,_define_property/* default */.Z)(_obj, ERROR_CODES.GoogleAccountExists, "error_google_account_exists"), _obj);
var getErrorMessageKeys = function() {
    var errors = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return errors.reduce(function(keys, error) {
        var key = ERROR_MESSAGES[error.code];
        if (key) {
            keys.push(key);
        }
        return keys;
    }, []);
};
var getErrorMessageKey = function(errors) {
    var messageKeys = getErrorMessageKeys(errors);
    return messageKeys.length ? messageKeys[0] : null;
};


/***/ }),

/***/ 62253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useAction; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _commerce__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(84634);
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ 

function useAction(options, fetcher) {
    var fetcherRef = (0,_commerce__WEBPACK_IMPORTED_MODULE_1__/* .useCommerce */ .a)().fetcherRef;
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(input) {
        return fetcher(options, input, fetcherRef.current);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        fetcher
    ]);
};


/***/ }),

/***/ 81261:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ use_data; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
// EXTERNAL MODULE: ./node_modules/next-auth/react/index.js
var react = __webpack_require__(33299);
// EXTERNAL MODULE: ./framework/utils/errors.ts + 12 modules
var errors = __webpack_require__(2063);
// EXTERNAL MODULE: ./framework/index.tsx
var framework = __webpack_require__(43695);
;// CONCATENATED MODULE: ./framework/utils/use-data.tsx
/* eslint-disable no-param-reassign */ /* eslint-disable @typescript-eslint/no-non-null-assertion */ /* eslint-disable no-console */ /* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-function-return-type */ 







var useData = function(options, input, fetcherFn, swrOptions) {
    var fetcherRef = (0,framework/* useCommerce */.aF)().fetcherRef;
    var fetcher = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(url, query, method) {
            var _len, args, _key, _args = arguments;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        for(_len = _args.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++){
                            args[_key - 3] = _args[_key];
                        }
                        _ctx.prev = 1;
                        _ctx.next = 4;
                        return fetcherFn({
                            url: url,
                            query: query,
                            method: method
                        }, // Transform the input array into an object
                        args.reduce(function(obj, val, i) {
                            obj[input[i][0]] = val;
                            return obj;
                        }, {}), fetcherRef.current);
                    case 4:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 7:
                        _ctx.prev = 7;
                        _ctx.t0 = _ctx["catch"](1);
                        // SWR will not log errors, but any error that's not an instance
                        // of CommerceError is not welcomed by this hook
                        if (!_instanceof(_ctx.t0, errors/* CommerceError */.yG)) {
                            console.error(_ctx.t0);
                        }
                        throw _ctx.t0;
                    case 11:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    1,
                    7
                ]
            ]);
        }));
        return function fetcher(url, query, method) {
            return _ref.apply(this, arguments);
        };
    }();
    var response = (0,dist/* default */.ZP)(function() {
        var opts = typeof options === "function" ? options() : options;
        var cacheKeys = input.map(function(e) {
            return e[1];
        });
        // if any cache key is undefined do not fetch
        return opts && !cacheKeys.includes(undefined) ? [
            opts.url,
            opts.query,
            opts.method
        ].concat((0,_to_consumable_array/* default */.Z)(cacheKeys)) : null;
    }, fetcher, swrOptions);
    if (response.error && response.error.code === errors/* ERROR_CODES.InvalidAccessToken */.O1.InvalidAccessToken) {
        (0,react.signOut)({
            callbackUrl: "https://nzxt.com"
        });
    }
    if (!("isLoading" in response)) {
        Object.defineProperty(response, "isLoading", {
            get: function get() {
                return typeof response.data === "undefined";
            },
            enumerable: true
        });
    }
    return response;
};
/* harmony default export */ var use_data = (useData);


/***/ }),

/***/ 96758:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; }
});

// NAMESPACE OBJECT: ./locale/index.ts
var locale_namespaceObject = {};
__webpack_require__.r(locale_namespaceObject);
__webpack_require__.d(locale_namespaceObject, {
  "de": function() { return de; },
  "en": function() { return en; },
  "es": function() { return es; },
  "fr": function() { return fr; },
  "it": function() { return it; },
  "nl": function() { return nl; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/injectIntl.js
var injectIntl = __webpack_require__(74806);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/utils.js
var utils = __webpack_require__(680);
// EXTERNAL MODULE: ./node_modules/@formatjs/ecma402-abstract/lib/utils.js
var lib_utils = __webpack_require__(25687);
// EXTERNAL MODULE: ./node_modules/intl-messageformat/lib/src/core.js
var core = __webpack_require__(16284);
// EXTERNAL MODULE: ./node_modules/@formatjs/intl/lib/src/error.js
var error = __webpack_require__(88222);
// EXTERNAL MODULE: ./node_modules/@formatjs/icu-messageformat-parser/lib/index.js + 9 modules
var lib = __webpack_require__(56096);
;// CONCATENATED MODULE: ./node_modules/@formatjs/intl/lib/src/message.js





function setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function (all, k) {
        all[k] = (0,tslib_es6/* __assign */.pi)({ timeZone: timeZone }, opts[k]);
        return all;
    }, {});
}
function deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, opts1), opts2));
    return keys.reduce(function (all, k) {
        all[k] = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, (opts1[k] || {})), (opts2[k] || {}));
        return all;
    }, {});
}
function deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) {
        return f1;
    }
    var mfFormats = core/* IntlMessageFormat.formats */.C.formats;
    return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, mfFormats), f1), { date: deepMergeOptions(setTimeZoneInOptions(mfFormats.date, timeZone), setTimeZoneInOptions(f1.date || {}, timeZone)), time: deepMergeOptions(setTimeZoneInOptions(mfFormats.time, timeZone), setTimeZoneInOptions(f1.time || {}, timeZone)) });
}
function formatMessage(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) { messageDescriptor = { id: '' }; }
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0,lib_utils/* invariant */.kG)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = 
    // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages &&
        Object.prototype.hasOwnProperty.call(messages, id) &&
        messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) &&
        message.length === 1 &&
        message[0].type === lib/* TYPE.literal */.wD.literal) {
        return message[0].value;
    }
    // IMPORTANT: Hot path straight lookup for performance
    if (!values &&
        message &&
        typeof message === 'string' &&
        !defaultRichTextElements) {
        return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    }
    values = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, defaultRichTextElements), (values || {}));
    formats = deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === '') {
            return message;
        }
        if (!defaultMessage ||
            (locale && locale.toLowerCase() !== defaultLocale.toLowerCase())) {
            // This prevents warnings from littering the console in development
            // when no `messages` are passed into the <IntlProvider> for the
            // default locale.
            onError(new error/* MissingTranslationError */.$6(messageDescriptor, locale));
        }
        if (defaultMessage) {
            try {
                var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
                return formatter.format(values);
            }
            catch (e) {
                onError(new error/* MessageFormatError */.X9("Error formatting default message for: \"".concat(id, "\", rendering default message verbatim"), locale, messageDescriptor, e));
                return typeof defaultMessage === 'string' ? defaultMessage : id;
            }
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0,tslib_es6/* __assign */.pi)({ formatters: state }, (opts || {})));
        return formatter.format(values);
    }
    catch (e) {
        onError(new error/* MessageFormatError */.X9("Error formatting message: \"".concat(id, "\", using ").concat(defaultMessage ? 'default message' : 'id', " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) {
        try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        }
        catch (e) {
            onError(new error/* MessageFormatError */.X9("Error formatting the default message for: \"".concat(id, "\", rendering message verbatim"), locale, messageDescriptor, e));
        }
    }
    if (typeof message === 'string') {
        return message;
    }
    if (typeof defaultMessage === 'string') {
        return defaultMessage;
    }
    return id;
}

// EXTERNAL MODULE: ./node_modules/@formatjs/intl/lib/src/utils.js
var src_utils = __webpack_require__(82644);
;// CONCATENATED MODULE: ./node_modules/@formatjs/intl/lib/src/number.js


var NUMBER_FORMAT_OPTIONS = [
    'localeMatcher',
    'style',
    'currency',
    'currencyDisplay',
    'unit',
    'unitDisplay',
    'useGrouping',
    'minimumIntegerDigits',
    'minimumFractionDigits',
    'maximumFractionDigits',
    'minimumSignificantDigits',
    'maximumSignificantDigits',
    // ES2020 NumberFormat
    'compactDisplay',
    'currencyDisplay',
    'currencySign',
    'notation',
    'signDisplay',
    'unit',
    'unitDisplay',
    'numberingSystem',
];
function getFormatter(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) { options = {}; }
    var format = options.format;
    var defaults = ((format &&
        (0,src_utils/* getNamedFormat */.TB)(formats, 'number', format, onError)) ||
        {});
    var filteredOptions = (0,src_utils/* filterProps */.L6)(options, NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function formatNumber(config, getNumberFormat, value, options) {
    if (options === void 0) { options = {}; }
    try {
        return getFormatter(config, getNumberFormat, options).format(value);
    }
    catch (e) {
        config.onError(new error/* IntlError */.Rw(error/* IntlErrorCode.FORMAT_ERROR */.bc.FORMAT_ERROR, 'Error formatting number.', e));
    }
    return String(value);
}
function formatNumberToParts(config, getNumberFormat, value, options) {
    if (options === void 0) { options = {}; }
    try {
        return getFormatter(config, getNumberFormat, options).formatToParts(value);
    }
    catch (e) {
        config.onError(new error/* IntlError */.Rw(error/* IntlErrorCode.FORMAT_ERROR */.bc.FORMAT_ERROR, 'Error formatting number.', e));
    }
    return [];
}

// EXTERNAL MODULE: ./node_modules/intl-messageformat/lib/src/error.js
var src_error = __webpack_require__(11050);
;// CONCATENATED MODULE: ./node_modules/@formatjs/intl/lib/src/relativeTime.js



var RELATIVE_TIME_FORMAT_OPTIONS = ['numeric', 'style'];
function relativeTime_getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) { options = {}; }
    var format = options.format;
    var defaults = (!!format && (0,src_utils/* getNamedFormat */.TB)(formats, 'relative', format, onError)) || {};
    var filteredOptions = (0,src_utils/* filterProps */.L6)(options, RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function formatRelativeTime(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) { options = {}; }
    if (!unit) {
        unit = 'second';
    }
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) {
        config.onError(new src_error/* FormatError */.u_("Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-relativetimeformat\"\n", src_error/* ErrorCode.MISSING_INTL_API */.jK.MISSING_INTL_API));
    }
    try {
        return relativeTime_getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    }
    catch (e) {
        config.onError(new error/* IntlFormatError */.Qe('Error formatting relative time.', config.locale, e));
    }
    return String(value);
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/intl/lib/src/dateTime.js



var DATE_TIME_FORMAT_OPTIONS = [
    'localeMatcher',
    'formatMatcher',
    'timeZone',
    'hour12',
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName',
    'hourCycle',
    'dateStyle',
    'timeStyle',
    'calendar',
    // 'dayPeriod',
    'numberingSystem',
];
function dateTime_getFormatter(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) { options = {}; }
    var format = options.format;
    var defaults = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, (timeZone && { timeZone: timeZone })), (format && (0,src_utils/* getNamedFormat */.TB)(formats, type, format, onError)));
    var filteredOptions = (0,src_utils/* filterProps */.L6)(options, DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === 'time' &&
        !filteredOptions.hour &&
        !filteredOptions.minute &&
        !filteredOptions.second &&
        !filteredOptions.timeStyle &&
        !filteredOptions.dateStyle) {
        // Add default formatting options if hour, minute, or second isn't defined.
        filteredOptions = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, filteredOptions), { hour: 'numeric', minute: 'numeric' });
    }
    return getDateTimeFormat(locale, filteredOptions);
}
function formatDate(config, getDateTimeFormat) {
    var _a = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        _a[_i - 2] = arguments[_i];
    }
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return dateTime_getFormatter(config, 'date', getDateTimeFormat, options).format(date);
    }
    catch (e) {
        config.onError(new error/* IntlError */.Rw(error/* IntlErrorCode.FORMAT_ERROR */.bc.FORMAT_ERROR, 'Error formatting date.', e));
    }
    return String(date);
}
function formatTime(config, getDateTimeFormat) {
    var _a = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        _a[_i - 2] = arguments[_i];
    }
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return dateTime_getFormatter(config, 'time', getDateTimeFormat, options).format(date);
    }
    catch (e) {
        config.onError(new error/* IntlError */.Rw(error/* IntlErrorCode.FORMAT_ERROR */.bc.FORMAT_ERROR, 'Error formatting time.', e));
    }
    return String(date);
}
function formatDateTimeRange(config, getDateTimeFormat) {
    var _a = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        _a[_i - 2] = arguments[_i];
    }
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var timeZone = config.timeZone, locale = config.locale, onError = config.onError;
    var filteredOptions = (0,src_utils/* filterProps */.L6)(options, DATE_TIME_FORMAT_OPTIONS, timeZone ? { timeZone: timeZone } : {});
    try {
        return getDateTimeFormat(locale, filteredOptions).formatRange(from, to);
    }
    catch (e) {
        onError(new error/* IntlError */.Rw(error/* IntlErrorCode.FORMAT_ERROR */.bc.FORMAT_ERROR, 'Error formatting date time range.', e));
    }
    return String(from);
}
function formatDateToParts(config, getDateTimeFormat) {
    var _a = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        _a[_i - 2] = arguments[_i];
    }
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return dateTime_getFormatter(config, 'date', getDateTimeFormat, options).formatToParts(date);
    }
    catch (e) {
        config.onError(new error/* IntlError */.Rw(error/* IntlErrorCode.FORMAT_ERROR */.bc.FORMAT_ERROR, 'Error formatting date.', e));
    }
    return [];
}
function formatTimeToParts(config, getDateTimeFormat) {
    var _a = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        _a[_i - 2] = arguments[_i];
    }
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return dateTime_getFormatter(config, 'time', getDateTimeFormat, options).formatToParts(date);
    }
    catch (e) {
        config.onError(new error/* IntlError */.Rw(error/* IntlErrorCode.FORMAT_ERROR */.bc.FORMAT_ERROR, 'Error formatting time.', e));
    }
    return [];
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/intl/lib/src/plural.js



var PLURAL_FORMAT_OPTIONS = [
    'localeMatcher',
    'type',
];
function formatPlural(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) { options = {}; }
    if (!Intl.PluralRules) {
        onError(new src_error/* FormatError */.u_("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", src_error/* ErrorCode.MISSING_INTL_API */.jK.MISSING_INTL_API));
    }
    var filteredOptions = (0,src_utils/* filterProps */.L6)(options, PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    }
    catch (e) {
        onError(new error/* IntlFormatError */.Qe('Error formatting plural.', locale, e));
    }
    return 'other';
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/intl/lib/src/list.js




var LIST_FORMAT_OPTIONS = [
    'localeMatcher',
    'type',
    'style',
];
var now = Date.now();
function generateToken(i) {
    return "".concat(now, "_").concat(i, "_").concat(now);
}
function formatList(opts, getListFormat, values, options) {
    if (options === void 0) { options = {}; }
    var results = formatListToParts(opts, getListFormat, values, options).reduce(function (all, el) {
        var val = el.value;
        if (typeof val !== 'string') {
            all.push(val);
        }
        else if (typeof all[all.length - 1] === 'string') {
            all[all.length - 1] += val;
        }
        else {
            all.push(val);
        }
        return all;
    }, []);
    return results.length === 1 ? results[0] : results;
}
function formatListToParts(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) { options = {}; }
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) {
        onError(new src_error/* FormatError */.u_("Intl.ListFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-listformat\"\n", src_error/* ErrorCode.MISSING_INTL_API */.jK.MISSING_INTL_API));
    }
    var filteredOptions = (0,src_utils/* filterProps */.L6)(options, LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = values.map(function (v, i) {
            if (typeof v === 'object') {
                var id = generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions)
            .formatToParts(serializedValues)
            .map(function (part) {
            return part.type === 'literal'
                ? part
                : (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, part), { value: richValues_1[part.value] || part.value });
        });
    }
    catch (e) {
        onError(new error/* IntlError */.Rw(error/* IntlErrorCode.FORMAT_ERROR */.bc.FORMAT_ERROR, 'Error formatting list.', e));
    }
    // @ts-ignore
    return values;
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/intl/lib/src/displayName.js



var DISPLAY_NAMES_OPTONS = [
    'localeMatcher',
    'style',
    'type',
    'fallback',
];
function formatDisplayName(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) {
        onError(new src_error/* FormatError */.u_("Intl.DisplayNames is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-displaynames\"\n", src_error/* ErrorCode.MISSING_INTL_API */.jK.MISSING_INTL_API));
    }
    var filteredOptions = (0,src_utils/* filterProps */.L6)(options, DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    }
    catch (e) {
        onError(new error/* IntlError */.Rw(error/* IntlErrorCode.FORMAT_ERROR */.bc.FORMAT_ERROR, 'Error formatting display name.', e));
    }
}

;// CONCATENATED MODULE: ./node_modules/@formatjs/intl/lib/src/create-intl.js










function messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === 'string';
}
function verifyConfigMessages(config) {
    if (config.onWarn &&
        config.defaultRichTextElements &&
        messagesContainString(config.messages || {})) {
        config.onWarn("[@formatjs/intl] \"defaultRichTextElements\" was specified but \"message\" was not pre-compiled. \nPlease consider using \"@formatjs/cli\" to pre-compile your messages for performance.\nFor more details see https://formatjs.io/docs/getting-started/message-distribution");
    }
}
/**
 * Create intl object
 * @param config intl config
 * @param cache cache for formatter instances to prevent memory leak
 */
function createIntl(config, cache) {
    var formatters = (0,src_utils/* createFormatters */.ax)(cache);
    var resolvedConfig = (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, src_utils/* DEFAULT_INTL_CONFIG */.Z0), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) {
            onError(new error/* InvalidConfigError */.OV("\"locale\" was not configured, using \"".concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl/api#intlshape for more details")));
        }
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || 'en';
    }
    else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) {
        onError(new error/* MissingDataError */.gb("Missing locale data for locale: \"".concat(locale, "\" in Intl.NumberFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    }
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length &&
        onError) {
        onError(new error/* MissingDataError */.gb("Missing locale data for locale: \"".concat(locale, "\" in Intl.DateTimeFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.io/docs/react-intl#runtime-requirements for more details")));
    }
    verifyConfigMessages(resolvedConfig);
    return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, resolvedConfig), { formatters: formatters, formatNumber: formatNumber.bind(null, resolvedConfig, formatters.getNumberFormat), formatNumberToParts: formatNumberToParts.bind(null, resolvedConfig, formatters.getNumberFormat), formatRelativeTime: formatRelativeTime.bind(null, resolvedConfig, formatters.getRelativeTimeFormat), formatDate: formatDate.bind(null, resolvedConfig, formatters.getDateTimeFormat), formatDateToParts: formatDateToParts.bind(null, resolvedConfig, formatters.getDateTimeFormat), formatTime: formatTime.bind(null, resolvedConfig, formatters.getDateTimeFormat), formatDateTimeRange: formatDateTimeRange.bind(null, resolvedConfig, formatters.getDateTimeFormat), formatTimeToParts: formatTimeToParts.bind(null, resolvedConfig, formatters.getDateTimeFormat), formatPlural: formatPlural.bind(null, resolvedConfig, formatters.getPluralRules), formatMessage: formatMessage.bind(null, resolvedConfig, formatters), $t: formatMessage.bind(null, resolvedConfig, formatters), formatList: formatList.bind(null, resolvedConfig, formatters.getListFormat), formatListToParts: formatListToParts.bind(null, resolvedConfig, formatters.getListFormat), formatDisplayName: formatDisplayName.bind(null, resolvedConfig, formatters.getDisplayNames) });
}

// EXTERNAL MODULE: ./node_modules/intl-messageformat/lib/src/formatters.js
var formatters = __webpack_require__(61092);
;// CONCATENATED MODULE: ./node_modules/react-intl/lib/src/components/provider.js
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */






function processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements,
    };
}
function assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) {
        return values;
    }
    return Object.keys(values).reduce(function (acc, k) {
        var v = values[k];
        acc[k] = (0,formatters/* isFormatXMLElementFn */.Gt)(v)
            ? (0,utils/* assignUniqueKeysToParts */.dt)(v)
            : v;
        return acc;
    }, {});
}
var provider_formatMessage = function (config, formatters, descriptor, rawValues) {
    var rest = [];
    for (var _i = 4; _i < arguments.length; _i++) {
        rest[_i - 4] = arguments[_i];
    }
    var values = assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = formatMessage.apply(void 0, (0,tslib_es6/* __spreadArray */.ev)([config,
        formatters,
        descriptor,
        values], rest, false));
    if (Array.isArray(chunks)) {
        return react.Children.toArray(chunks);
    }
    return chunks;
};
/**
 * Create intl object
 * @param config intl config
 * @param cache cache for formatter instances to prevent memory leak
 */
var provider_createIntl = function (_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0,tslib_es6/* __rest */._T)(_a, ["defaultRichTextElements"]);
    var defaultRichTextElements = assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = createIntl((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, utils/* DEFAULT_INTL_CONFIG */.Z0), config), { defaultRichTextElements: defaultRichTextElements }), cache);
    return (0,tslib_es6/* __assign */.pi)((0,tslib_es6/* __assign */.pi)({}, coreIntl), { formatMessage: provider_formatMessage.bind(null, {
            locale: coreIntl.locale,
            timeZone: coreIntl.timeZone,
            fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
            formats: coreIntl.formats,
            defaultLocale: coreIntl.defaultLocale,
            defaultFormats: coreIntl.defaultFormats,
            messages: coreIntl.messages,
            onError: coreIntl.onError,
            defaultRichTextElements: defaultRichTextElements,
        }, coreIntl.formatters) });
};
var IntlProvider = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.ZT)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0,src_utils/* createIntlCache */.Sn)();
        _this.state = {
            cache: _this.cache,
            intl: provider_createIntl(processIntlConfig(_this.props), _this.cache),
            prevConfig: processIntlConfig(_this.props),
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function (props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = processIntlConfig(props);
        if (!(0,utils/* shallowEqual */.wU)(prevConfig, config)) {
            return {
                intl: provider_createIntl(config, cache),
                prevConfig: config,
            };
        }
        return null;
    };
    IntlProvider.prototype.render = function () {
        (0,utils/* invariantIntlContext */.lq)(this.state.intl);
        return react.createElement(injectIntl/* Provider */.zt, { value: this.state.intl }, this.props.children);
    };
    IntlProvider.displayName = 'IntlProvider';
    IntlProvider.defaultProps = utils/* DEFAULT_INTL_CONFIG */.Z0;
    return IntlProvider;
}(react.PureComponent));
/* harmony default export */ var provider = (IntlProvider);

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/nprogress/nprogress.js
var nprogress = __webpack_require__(74865);
var nprogress_default = /*#__PURE__*/__webpack_require__.n(nprogress);
// EXTERNAL MODULE: ./node_modules/next-auth/react/index.js
var next_auth_react = __webpack_require__(33299);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
;// CONCATENATED MODULE: ./utils/sessionStorage.ts
var sessionStorage_getSessionStorage = function(key) {
    var storage = globalThis === null || globalThis === void 0 ? void 0 : globalThis.sessionStorage;
    if (!storage) return null;
    try {
        return JSON.parse(storage.getItem(key));
    } catch (err) {
        return null;
    }
};
var setSessionStorage = function(key, value) {
    var storage = globalThis === null || globalThis === void 0 ? void 0 : globalThis.sessionStorage;
    if (!storage) return;
    storage.setItem(key, JSON.stringify(value));
};


;// CONCATENATED MODULE: ./stores/use-build-store/use-build-store.ts





var initialState = {
    bldOptions: {
        image: "",
        id: 0,
        name: "",
        description: "",
        short_description: "",
        price: 0,
        discountedPrice: 0,
        optionsData: []
    },
    bldPeripherals: {
        monitors: [],
        lighting: [],
        extras: [],
        peripherals: [],
        colors: [],
        buildData: null,
        isInvalid: false
    },
    bldEntryVariantId: null,
    bldMoreInfoVariantId: null,
    bldHelpInfo: {
        category: null
    },
    infoModals: [],
    prevPath: null,
    currentPath: null
};
var buildStore = function(set) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialState), {
        // Build Actions
        setBLDOptions: function(options) {
            return set(function() {
                var bldOptions = Array.isArray(options.optionsData) ? options : (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, options), {
                    optionsData: [
                        options.optionsData
                    ]
                });
                return {
                    bldOptions: bldOptions
                };
            });
        },
        setBldPeripherals: function(bldPeripherals) {
            return set(function() {
                return {
                    bldPeripherals: bldPeripherals
                };
            });
        },
        setBLDEntryVariantId: function(variantId) {
            return set(function() {
                return {
                    bldEntryVariantId: variantId
                };
            });
        },
        setBLDMoreInfoVariantId: function(variantId) {
            return set(function() {
                return {
                    bldMoreInfoVariantId: variantId
                };
            });
        },
        setBLDHelpInfo: function(bldHelpInfo) {
            return set(function() {
                return {
                    bldHelpInfo: bldHelpInfo
                };
            });
        },
        setInfoModals: function(infoModals) {
            return set(function() {
                return {
                    infoModals: infoModals
                };
            });
        },
        setPrevPath: function(pathname) {
            return set(function() {
                setSessionStorage("prevPath", pathname);
                return {
                    prevPath: pathname
                };
            });
        },
        setCurrentPath: function(pathname) {
            return set(function() {
                setSessionStorage("currentPath", pathname);
                return {
                    currentPath: pathname
                };
            });
        }
    });
};
var useBuildStore =  false ? 0 : (0,esm/* default */.Z)(buildStore);
/* harmony default export */ var use_build_store = (useBuildStore);

;// CONCATENATED MODULE: ./stores/use-build-store/selectors.ts

var getBldOptions = function(state) {
    return state.bldOptions;
};
var getBldPeripherals = function(state) {
    return state.bldPeripherals;
};
var getBldEntryVariantId = function(state) {
    return state.bldEntryVariantId;
};
var getBldMoreInfoVariantId = function(state) {
    return state.bldMoreInfoVariantId;
};
var getBldHelpInfo = function(state) {
    return state.bldHelpInfo;
};
var getSetBLDOptions = function(state) {
    return state.setBLDOptions;
};
var getSetBldPeripherals = function(state) {
    return state.setBldPeripherals;
};
var getSetBLDEntryVariantId = function(state) {
    return state.setBLDEntryVariantId;
};
var getSetBLDMoreInfoVariantId = function(state) {
    return state.setBLDMoreInfoVariantId;
};
var getSetBLDHelpInfo = function(state) {
    return state.setBLDHelpInfo;
};
var getInfoModals = function(state) {
    return state.infoModals;
};
var getSetInfoModals = function(state) {
    return state.setInfoModals;
};
var getPrevPath = function() {
    return getSessionStorage("prevPath");
};
var getSetPrevPath = function(state) {
    return state.setPrevPath;
};
var getCurrentPath = function() {
    return sessionStorage_getSessionStorage("currentPath");
};
var getSetCurrentPath = function(state) {
    return state.setCurrentPath;
};

;// CONCATENATED MODULE: ./stores/use-build-store/index.ts



// EXTERNAL MODULE: ./utils/parse-locale.ts
var parse_locale = __webpack_require__(24343);
;// CONCATENATED MODULE: ./utils/detect-adblock.ts


var checkForAdBlocker = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var blocked, Request, _Request;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    Request = function _Request1() {
                        return _Request.apply(this, arguments);
                    };
                    _Request = function __Request() {
                        _Request = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                            return runtime_default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        _ctx.prev = 0;
                                        return _ctx.abrupt("return", fetch("https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js", {
                                            method: "HEAD",
                                            mode: "no-cors"
                                        }).then(function(_) {
                                            // There is no AdBlocker
                                            blocked = false;
                                            return blocked;
                                        }).catch(function(_) {
                                            // Failed, Because of an AdBlocker
                                            blocked = true;
                                            return blocked;
                                        }));
                                    case 4:
                                        _ctx.prev = 4;
                                        _ctx.t0 = _ctx["catch"](0);
                                        console.log(_ctx.t0);
                                        blocked = true;
                                        return _ctx.abrupt("return", blocked);
                                    case 9:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee, null, [
                                [
                                    0,
                                    4
                                ]
                            ]);
                        }));
                        return _Request.apply(this, arguments);
                    };
                    ;
                    ;
                    ;
                    if (!(blocked !== undefined)) {
                        _ctx.next = 9;
                        break;
                    }
                    _ctx.t0 = blocked;
                    _ctx.next = 12;
                    break;
                case 9:
                    _ctx.next = 11;
                    return Request();
                case 11:
                    _ctx.t0 = _ctx.sent;
                case 12:
                    return _ctx.abrupt("return", _ctx.t0);
                case 13:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function checkForAdBlocker() {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var detect_adblock = (checkForAdBlocker);

// EXTERNAL MODULE: ./framework/index.tsx
var framework = __webpack_require__(43695);
// EXTERNAL MODULE: ./utils/hooks/index.ts + 16 modules
var hooks = __webpack_require__(83307);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_extends.mjs
function extends_() {
  extends_ = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return extends_.apply(this, arguments);
}

function _extends() {
  return extends_.apply(this, arguments);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./constants/index.ts + 15 modules
var constants = __webpack_require__(47041);
;// CONCATENATED MODULE: ./components/CookieControl/on-load.ts
/* eslint-disable @typescript-eslint/no-explicit-any */ 

var onLoad = function(config) {
    if (true) {
        if (window.location.href.includes("localhost")) {
            var open = window.XMLHttpRequest.prototype.open;
            // eslint-disable-next-line func-names
            window.XMLHttpRequest.prototype.open = function onLoad(method, url) {
                for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
                    args[_key - 2] = arguments[_key];
                }
                var _open;
                // eslint-disable-next-line no-param-reassign
                url = url.replace(constants/* LOCALHOST_OVERRIDE_SRC */.BgR, constants/* LOCALHOST_OVERRIDE_DEST */.ACo);
                return (_open = open).call.apply(_open, [
                    this,
                    method,
                    url
                ].concat((0,_to_consumable_array/* default */.Z)(args)));
            };
        }
        window.CookieControl.load(config);
    }
};
/* harmony default export */ var on_load = (onLoad);

// EXTERNAL MODULE: ./utils/gtm/index.ts + 3 modules
var gtm = __webpack_require__(96870);
;// CONCATENATED MODULE: ./components/CookieControl/GoogleTagManager/init-analytics-js.js
/* eslint-disable prefer-destructuring */ /* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable dot-notation */ /* eslint-disable no-sequences */ /* eslint-disable prefer-rest-params */ /* eslint-disable no-param-reassign */ /* eslint-disable no-unused-expressions */ /* eslint-disable func-names */ var initAnalyticsJs = function() {
    (function(i, s, o, g, r, a, m) {
        i["GoogleAnalyticsObject"] = r;
        i[r] = i[r] || function() {
            (i[r].q = i[r].q || []).push(arguments);
        }, i[r].l = 1 * new Date();
        a = s.createElement(o), m = s.getElementsByTagName(o)[0];
        a.async = 1;
        a.src = g;
        m.parentNode.insertBefore(a, m);
    })(window, document, "script", "https://www.google-analytics.com/analytics.js", "ga");
    window.ga("create", "UA-1138231-27", "auto");
};
/* harmony default export */ var init_analytics_js = (initAnalyticsJs);

;// CONCATENATED MODULE: ./components/CookieControl/GoogleTagManager/on-accept.ts



function gtag() {
    for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++){
        rest[_key] = arguments[_key];
    }
    var _dataLayer;
    (_dataLayer = window.dataLayer).push.apply(_dataLayer, (0,_to_consumable_array/* default */.Z)(rest));
}
var onAccept = function(gtmId, serverUrl) {
    if (true) {
        gtm/* default.initialize */.Z.initialize({
            gtmId: gtmId,
            serverUrl: serverUrl
        });
        window["ga-disable-".concat("G-M9DB9RH7NG")] = false;
        window["ga-disable-".concat("UA-1138231-27")] = false;
        window.dataLayer = window.dataLayer || [];
        gtag("js", new Date());
        gtag("config", "G-M9DB9RH7NG", {
            anonymize_ip: true,
            linker: {
                domains: [
                    "https://nzxt.com".replace(/^https?:\/\//, ""),
                    "nzxtau.myshopify.com",
                    "nzxtdach.myshopify.com",
                    "letsbld-com.myshopify.com",
                    "nzxtuk.myshopify.com",
                    "nzxtnz.myshopify.com", 
                ]
            }
        });
        gtag("config", "UA-1138231-27", {
            anonymize_ip: true,
            linker: {
                domains: [
                    "https://nzxt.com".replace(/^https?:\/\//, ""),
                    "nzxtau.myshopify.com",
                    "nzxtdach.myshopify.com",
                    "letsbld-com.myshopify.com",
                    "nzxtuk.myshopify.com",
                    "nzxtnz.myshopify.com", 
                ]
            }
        });
        gtag("consent", "update", {
            ad_storage: "granted",
            analytics_storage: "granted"
        });
        window.gtag = gtag;
        init_analytics_js();
    }
};
/* harmony default export */ var on_accept = (onAccept);

;// CONCATENATED MODULE: ./components/CookieControl/GoogleTagManager/on-revoke.ts

function on_revoke_gtag() {
    for(var _len = arguments.length, rest = new Array(_len), _key = 0; _key < _len; _key++){
        rest[_key] = arguments[_key];
    }
    var _dataLayer;
    (_dataLayer = window.dataLayer).push.apply(_dataLayer, (0,_to_consumable_array/* default */.Z)(rest));
}
var onRevoke = function() {
    if (true) {
        window["ga-disable-".concat("G-M9DB9RH7NG")] = true;
        window["ga-disable-".concat("UA-1138231-27")] = true;
        on_revoke_gtag("consent", "update", {
            ad_storage: "denied",
            analytics_storage: "denied"
        });
    }
};
/* harmony default export */ var on_revoke = (onRevoke);

;// CONCATENATED MODULE: ./components/CookieControl/GoogleTagManager/constants.ts
/* eslint-disable import/prefer-default-export */ var COOKIES = [
    "_ga",
    "_gid",
    "_gat",
    "__utma",
    "__utmt",
    "__utmb",
    "__utmc",
    "__utmz",
    "__utmv",
    "gtm_debug",
    "gtm_auth",
    "ANID",
    "SEARCH_SAMESITE",
    "S",
    "__Secure-",
    "SAPISID",
    "SSID",
    "APISID",
    "HSID",
    "SIDCC",
    "SID",
    "1P_JAR",
    "NID", 
];

;// CONCATENATED MODULE: ./components/CookieControl/GoogleTagManager/index.ts





// EXTERNAL MODULE: ./node_modules/nookies/dist/index.js
var dist = __webpack_require__(62286);
;// CONCATENATED MODULE: ./framework/api/utils/heap/get-id.ts


var getId = function() {
    var cookies = (0,dist.parseCookies)();
    return cookies[constants/* HEAP_ID_COOKIE_NAME */.i2Q];
};
/* harmony default export */ var get_id = (getId);

// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 4 modules
var v4 = __webpack_require__(25934);
;// CONCATENATED MODULE: ./framework/api/utils/heap/set-id.ts



var setId = function() {
    var id = (0,v4/* default */.Z)();
    (0,dist.setCookie)(null, constants/* HEAP_ID_COOKIE_NAME */.i2Q, "".concat(id), {
        maxAge: constants/* SYSTEM_COOKIE_MAX_AGE */.qHr,
        expires: new Date(Date.now() + constants/* SYSTEM_COOKIE_MAX_AGE */.qHr * 1000),
        secure: "production" === "production",
        path: "/",
        sameSite: "lax"
    });
    return id;
};
/* harmony default export */ var set_id = (setId);

;// CONCATENATED MODULE: ./framework/api/utils/heap/index.ts




;// CONCATENATED MODULE: ./components/CookieControl/Heap/constants.ts
var SCRIPT_ID = "heap-script";
var constants_COOKIES = [
    "_mkto_trk",
    "_hp2_*",
    "_gcl_au",
    "_gid",
    "_ga",
    "_fbp",
    "_attribution_landing_page",
    "_gd_session",
    "_gd_visitor",
    "_an_uid",
    "_attribution_referrer",
    "_csrf",
    "_gd_svisitor",
    "heap", 
];

;// CONCATENATED MODULE: ./components/CookieControl/Heap/on-accept.ts
/* eslint-disable func-names */ /* eslint-disable no-shadow */ /* eslint-disable no-sequences */ /* eslint-disable no-param-reassign */ /* eslint-disable prefer-rest-params */ /* eslint-disable no-multi-assign */ /* eslint-disable no-plusplus */ /* eslint-disable no-unused-expressions */ 

var on_accept_onAccept = function(heapId) {
    if (true) {
        if (window.heap && window.heap.loaded === false) {
            window.heap.loaded = true;
        } else {
            window.heap = window.heap || [], window.heap.load = function onAccept(e, t) {
                window.heap.appid = e, window.heap.config = t = t || {
                    secureCookie: true
                };
                var r = document.createElement("script");
                r.type = "text/javascript", r.async = !0, r.id = SCRIPT_ID, r.src = "https://cdn.heapanalytics.com/js/heap-".concat(e, ".js");
                var a = document.getElementsByTagName("script")[0];
                a.parentNode.insertBefore(r, a);
                for(var n = function n(error) {
                    return function() {
                        if (window.heap && window.heap.push) {
                            window.heap.push([
                                error
                            ].concat(Array.prototype.slice.call(arguments, 0)));
                        }
                    };
                }, p = [
                    "addEventProperties",
                    "addUserProperties",
                    "clearEventProperties",
                    "identify",
                    "resetIdentity",
                    "removeEventProperty",
                    "setEventProperties",
                    "track",
                    "unsetEventProperty", 
                ], o = 0; o < p.length; o++)window.heap[p[o]] = n(p[o]);
            };
            window.heap.load(heapId);
            var id = get_id() || set_id();
            window.heap.identify(id);
        }
    }
};
/* harmony default export */ var Heap_on_accept = (on_accept_onAccept);

;// CONCATENATED MODULE: ./components/CookieControl/Heap/on-revoke.ts
var on_revoke_onRevoke = function() {
    if (true) {
        window.heap.loaded = false;
    }
};
/* harmony default export */ var Heap_on_revoke = (on_revoke_onRevoke);

;// CONCATENATED MODULE: ./components/CookieControl/Heap/index.ts





;// CONCATENATED MODULE: ./components/CookieControl/ZendeskChat/constants.ts
/* eslint-disable import/prefer-default-export */ var ZendeskChat_constants_COOKIES = [
    "__zlcprivacy",
    "__zlcmid"
];

;// CONCATENATED MODULE: ./utils/wait-for-global.ts
var waitForGlobal = function(key, cb) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 10;
    if (false) {}
    var timer = null;
    if (window[key]) {
        if (timer) {
            clearTimeout(timer);
        }
        cb();
    } else if (n > 0) {
        timer = setTimeout(function() {
            waitForGlobal(key, cb, n - 1);
        }, 100);
    }
    if (n <= 0) {
        clearTimeout(timer);
    }
};
/* harmony default export */ var wait_for_global = (waitForGlobal);

;// CONCATENATED MODULE: ./components/CookieControl/ZendeskChat/on-accept.ts

var ZendeskChat_on_accept_onAccept = function() {
    wait_for_global("zE", function() {
        window.zE("webWidget", "updateSettings", {
            cookies: true
        });
    });
};
/* harmony default export */ var ZendeskChat_on_accept = (ZendeskChat_on_accept_onAccept);

;// CONCATENATED MODULE: ./components/CookieControl/ZendeskChat/on-revoke.ts

var ZendeskChat_on_revoke_onRevoke = function() {
    wait_for_global("zE", function() {
        window.zE("webWidget", "updateSettings", {
            cookies: false
        });
    });
};
/* harmony default export */ var ZendeskChat_on_revoke = (ZendeskChat_on_revoke_onRevoke);

;// CONCATENATED MODULE: ./components/CookieControl/Facebook/constants.ts
var Facebook_constants_COOKIES = [
    "fr",
    "datr",
    "sb",
    "wd",
    "_fbp"
];
var SCRIPT_SRC = "https://connect.facebook.net/en_US/fbevents.js";

;// CONCATENATED MODULE: ./components/CookieControl/Facebook/on-accept.ts
/* eslint-disable no-underscore-dangle */ /* eslint-disable prefer-rest-params */ /* eslint-disable prefer-spread */ /* eslint-disable no-unused-expressions */ /* eslint-disable no-multi-assign */ /* eslint-disable no-param-reassign */ /* eslint-disable func-names */ /* eslint-disable prefer-destructuring */ // import { SCRIPT_SRC } from './constants';
// TODO - commenting out the lines below to allow for fbq to be started via GTM
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var Facebook_on_accept_onAccept = function() {
    if (true) {
        // (function (f, b, e, v, n, t, s) {
        //   if (f.fbq) return;
        //   n = f.fbq = function () {
        //     n.callMethod
        //       ? n.callMethod.apply(n, arguments)
        //       : n.queue.push(arguments);
        //   };
        //   if (!f._fbq) f._fbq = n;
        //   n.push = n;
        //   n.loaded = !0;
        //   n.version = '2.0';
        //   n.queue = [];
        //   t = b.createElement(e);
        //   t.async = !0;
        //   t.src = v;
        //   s = b.getElementsByTagName(e)[0];
        //   s.parentNode.insertBefore(t, s);
        // })(window, document, 'script', SCRIPT_SRC);
        // window.fbq('init', facebookId);
        if (window.fbq) {
            window.fbq("track", "PageView");
            window.fbq("consent", "grant");
        }
    }
};
/* harmony default export */ var Facebook_on_accept = (Facebook_on_accept_onAccept);

;// CONCATENATED MODULE: ./components/CookieControl/Facebook/on-revoke.ts
var Facebook_on_revoke_onRevoke = function() {
    if ( true && window.fbq) {
        window.fbq("consent", "revoke");
    }
};
/* harmony default export */ var Facebook_on_revoke = (Facebook_on_revoke_onRevoke);

// EXTERNAL MODULE: ./components/CookieControl/Klaviyo/index.ts + 4 modules
var Klaviyo = __webpack_require__(77944);
;// CONCATENATED MODULE: ./components/CookieControl/Klarna/constants.ts
var constants_SCRIPT_SRC = "https://eu-library.klarnaservices.com/lib.js";
var CLIENT_ID = "5c0974fa-c231-5997-8978-4b3593bb9ccc";
var Klarna_constants_COOKIES = [
    "ku1-vid",
    "ku1-sid"
];

;// CONCATENATED MODULE: ./components/CookieControl/Klarna/on-accept.ts

var Klarna_on_accept_onAccept = function() {
    if (true) {
        var klarnaScript = document.getElementById("klarna-script");
        if (!klarnaScript) {
            var script = document.createElement("script");
            script.async = true;
            script.src = constants_SCRIPT_SRC;
            script.id = "klarna-script";
            script.setAttribute("data-client-id", CLIENT_ID);
            var firstScript = document.getElementsByTagName("script")[0];
            firstScript.parentNode.insertBefore(script, firstScript);
        }
    }
};
/* harmony default export */ var Klarna_on_accept = (Klarna_on_accept_onAccept);

;// CONCATENATED MODULE: ./components/CookieControl/start-cookie-control.ts









/**
 * NOTE: If adding or removing new cookie(s), please remember to update
 * the STATEMENT_UPDATED constant in cookie-control.ts with the new date.
 */ var startCookieControl = function() {
    var opts = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!opts.scriptSrc) {
        // eslint-disable-next-line no-console
        console.error("Missing required scriptSrc param for Cookie Control");
    }
    if (!opts.apiKey) {
        // eslint-disable-next-line no-console
        console.error("Missing required apiKey param for Cookie Control");
    }
    if (!opts.gtmId && !opts.heapId && !opts.facebookId) {
        // eslint-disable-next-line no-console
        console.warn("No optional cookies are present in Cookie Control config");
    }
    var config = {
        apiKey: opts.apiKey,
        product: "PRO",
        position: "right",
        theme: "dark",
        initialState: "notify",
        layout: "slideout",
        toggleType: "checkbox",
        statement: (0,constants/* getStatement */.WVX)(opts.locale),
        branding: constants/* BRANDING_DEFAULT */.b4W,
        text: constants/* TEXT */.lD3,
        locales: (0,constants/* getLocales */.IPS)(opts.locale),
        consentCookieExpiry: constants/* CONSENT_COOKIE_EXPIRY */.FL2,
        necessaryCookies: constants/* NECESSARY_COOKIES */.XiA,
        optionalCookies: [
            opts.gtmId || opts.heapId ? {
                name: "analytics",
                label: constants/* LABEL_ANALYTICS */.E9q,
                recommendedState: true,
                lawfulBasis: "legitimate interest",
                description: constants/* DESCRIPTION_ANALYTICS */.Znm,
                cookies: (0,_to_consumable_array/* default */.Z)(COOKIES).concat((0,_to_consumable_array/* default */.Z)(constants_COOKIES), (0,_to_consumable_array/* default */.Z)(ZendeskChat_constants_COOKIES)),
                onAccept: function() {
                    if (opts.gtmId && opts.gtmServerId) {
                        on_accept(opts.gtmId, opts.gtmServerId);
                    }
                    if (opts.heapId) {
                        Heap_on_accept(opts.heapId);
                    }
                    ZendeskChat_on_accept();
                },
                onRevoke: function() {
                    if (opts.gtmId && opts.gtmServerId) {
                        on_revoke();
                    }
                    if (opts.heapId) {
                        Heap_on_revoke();
                    }
                    ZendeskChat_on_revoke();
                }
            } : null,
            {
                name: "marketing",
                label: constants/* LABEL_MARKETING */._sm,
                recommendedState: true,
                description: constants/* DESCRIPTION_MARKETING */.yVv,
                cookies: (0,_to_consumable_array/* default */.Z)(Facebook_constants_COOKIES).concat((0,_to_consumable_array/* default */.Z)(Klaviyo/* COOKIES */.E9), (0,_to_consumable_array/* default */.Z)(Klarna_constants_COOKIES), [
                    "IDE",
                    "__ncuid",
                    "u", 
                ]),
                onAccept: function() {
                    Facebook_on_accept();
                    (0,Klaviyo/* onAccept */.Jj)(opts.locale);
                    Klarna_on_accept();
                },
                onRevoke: function() {
                    Facebook_on_revoke();
                    (0,Klaviyo/* onRevoke */.Qt)();
                    window.location.reload();
                }
            }, 
        ].filter(Boolean)
    };
    var scriptEl = document.createElement("script");
    scriptEl.type = "text/javascript";
    scriptEl.src = opts.scriptSrc;
    scriptEl.onload = function() {
        return on_load(config);
    };
    document.head.appendChild(scriptEl);
};
/* harmony default export */ var start_cookie_control = (startCookieControl);

;// CONCATENATED MODULE: ./components/CookieControl/CookieControl.tsx



var CookieControl = function(_param) {
    var rest = _extends({}, _param);
    var ref = (0,react.useState)(false), hasInitialized = ref[0], setHasInitialized = ref[1];
    (0,react.useEffect)(function() {
        if (!hasInitialized) {
            start_cookie_control(rest);
            setHasInitialized(true);
        }
    }, [
        hasInitialized,
        rest
    ]);
    return null;
};
/* harmony default export */ var CookieControl_CookieControl = (/*#__PURE__*/(0,react.memo)(CookieControl));

;// CONCATENATED MODULE: ./components/CookieControl/index.ts


;// CONCATENATED MODULE: ./locale/en.ts
/* eslint-disable max-len */ 
var userAccount = {
    user_settings_title: "Account",
    user_settings_change_password: "Change Password",
    user_settings_save: "Save",
    user_settings_cancel: "Cancel",
    user_profile_heading: "Profile",
    user_saved_builds_heading: "Saved Builds",
    user_saved_builds_bld_name: "Build name",
    user_saved_builds_bld_date: "Date created",
    user_saved_builds_bld_item_part: "Part",
    user_saved_builds_delete_bld: "Delete BLD",
    user_saved_builds_resume_bld: "Resume BLD",
    user_saved_builds_hero_title: "Designed to Show Off Your Build",
    user_saved_builds_hero_text: "The compact vertical design maintains support for most full-sized GPU’s on the market so you can maintain your desk real estate without sacrificing graphics power.",
    user_saved_builds_pc_heading: "PC Builds",
    user_saved_builds_keyboard_heading: "Keyboard Builds",
    user_saved_builds_view_pc: "View PC Builds",
    user_saved_builds_view_keyboard: "View Keyboard Builds",
    user_saved_builds_no_pc: "You have no saved PC Builds",
    user_saved_builds_no_kb: "You have no saved Keyboard Builds",
    user_order_history_heading: "Order History",
    user_order_history_date: "Date",
    user_order_history_order_number: "Order Number",
    user_order_history_status: "Status",
    user_order_history_amount: "Amount",
    user_order_history_view: "View receipt",
    user_order_history_empty_view: "You have no order history.",
    user_order_history_shipping: "Shipping Address",
    user_order_history_billing: "Billing Address",
    user_order_history_item: "Item",
    user_order_history_item_image: "Item image",
    user_order_history_quantity: "Quantity",
    user_order_history_order: "Order #",
    user_support_heading: "Support + Returns",
    user_data_heading: "Data Request",
    user_terms_heading: "Terms",
    user_terms_empty: "You have no signed terms yet.",
    user_support_subject_min_length: "Subject must be at least 3 characters",
    user_support_message_placeholder: "Please detail reasons for contact. If return, please include order number",
    user_support_update_button: "Update",
    user_active_tickets_heading: "Active Tickets",
    user_active_tickets_chat: "Add a message",
    user_active_tickets_no_chat_history: "You have no chat history",
    view_chat_button: "View Chat",
    close_chat_button: "Close Chat",
    field_required_message: "This field is required",
    label_accept: "Accept",
    label_reason_for_contact: "Reason for Contact",
    label_country: "Country",
    label_subject: "Subject",
    label_product: "Product",
    label_message: "Message",
    label_requestor_type: "Requestor Type",
    label_country_of_residence: "Country of Residence",
    label_description: "Description",
    placeholder_description: "Description of your request",
    label_submit: "Submit",
    message_no_support_requests: "You have no active support requests",
    label_ticket_number: "Ticket Number",
    label_date_created: "Date Created",
    label_status: "Status",
    label_department: "Department",
    subheading_active_ticket: "If you require any help or are looking to return an item, please contact support.",
    label_create_support_request: "Create Support Request",
    button_comment: "Comment",
    label_for_myself: "For Myself",
    label_parent: "Parent",
    label_legal_rep: "Legal Representative",
    label_relative: "Relative",
    label_guardian: "Guardian",
    label_accept_generic_terms: "I have read and accept these terms",
    error_view_message: "Oops! Something went wrong. Please try again.",
    signout_view_message: "You have been logged out.",
    birthday_error_message: "Please enter a valid birth date",
    label_view_saved: "View all saved builds"
};
var formErrors = {
    invalid_email: "Please enter a valid email",
    username_full_pattern_message: "Username must be 6 to 30 characters long. You can use letters, numbers and periods but cannot start, end or contain consecutive periods.",
    password_pattern_message: "Password must contain at least six characters, one uppercase letter, one lowercase letter and one number",
    username_min_length_message: "Use 6 characters or more for your username",
    passwords_must_match: "Passwords must match",
    invalid_current_password: "Unable to update the password. The value provided as the current password is incorrect",
    must_accept_partner_program_terms: "You must accept the Partner Program Terms to become an NZXT partner",
    must_accept_tos_terms: "You must accept the Terms of Service to create a NZXT Account",
    must_accept_generic_terms: "You must agree to these terms"
};
var auth = {
    user_auth_agreement: "I accept the NZXT's",
    user_auth_privacy_policy: "Privacy Policy",
    user_auth_and: "and have read the",
    user_auth_terms: "Terms of Use",
    error_invalid_request: "Invalid request.",
    error_invalid_token: "Invalid user authentication token",
    error_session_expired: "Your session has expired. Please login again to continue.",
    user_forgot_required_email: "Email address is required",
    user_forgot_success_message: "Thanks! If there's an account associated with this email, we'll send the password reset instructions immediately.",
    error_email_exists: "The email is already in use",
    user_email_verification_heading: "Email Verification",
    error_email_not_verified: "The Email address is not yet verified. To resend the verification email, click",
    error_email_already_verified: "The Email address has already been verified. Please continue to login.",
    user_email_verification_success_message: "Your Email address has been verified successfully!. Please continue to login.",
    error_username_unavailable: "The username is unavailable",
    error_reset_password_same_as_old_password: "This password is the same as before. Please select another.",
    error_reset_password_link_expired: "The link to reset your password has expired.",
    error_reset_password_link_invalid: "The link to reset your password is invalid.",
    user_forgot_password_subheading: "Enter your email to receive instructions on how to reset your password.",
    user_reset_password_heading: "Reset your password",
    user_reset_password_subheading: "Please enter a new password.",
    user_reset_password: "Reset password",
    user_reset_success_message: "You have successfully reset your password!",
    user_login_text: "Sign in with Google",
    user_login_remember: "Remember me",
    user_login_forgot_password: "Forgot password?",
    user_login_wrong_email_or_password: "Incorrect email address or password",
    user_login_success_message: "You have successfully logged in!",
    error_too_many_requests: "You have made too many requests. Please wait a few minutes or contact support",
    error_user_not_found: "User was not found",
    user_sign_in_sign_up: "Sign In / Sign Up",
    user_sign_out: "Sign Out",
    user_sign_in: "Sign In",
    user_account_updates: "NZXT Updates",
    user_account_no_updates: "No recent updates, check back later.",
    support_center_link: "Support Center",
    error_google_account_exists: "You already created an account using Google. Please login instead.",
    error_local_account_exists: "Looks like you already have an account. Please login instead.",
    user_sign_up: "Sign up",
    user_sign_up_text: "Sign up with Google",
    user_sign_up_opt_in: "Sign up for emails to get updates from NZXT on products, BLD, and CAM",
    user_sign_up_check_email_message: "Check your email and click the link to activate your account.",
    user_sign_up_success_verify_message: "The account will remain inactive until verified. Please check your spam folder if you do not receive the email within a few minutes.",
    user_info_updated_success_message: "Your information has been updated successfully!",
    user_info_newsletter_confirmation_message: "Please check your email for confirmation.",
    user_email_sign_in: "Or continue with",
    user_no_account: "Not a member?",
    user_create_account: "Create account",
    user_email_sign_up_text: "Or sign up with",
    user_have_account: "Have an account?",
    open_login_view: "Open login view",
    error_newsletter_subscription: "Unable to subscribe/unsubscribe to newsletter at the moment. Please try again later.",
    label_email_address: "Email Address",
    label_password: "Password",
    label_current_password: "Current Password",
    label_confirm_password: "Confirm Password",
    label_new_password: "New Password",
    label_confirm_new_password: "Confirm New Password",
    label_username: "Username",
    label_first_name: "First Name",
    label_last_name: "Last Name",
    label_preferred_pronouns: "Preferred pronouns",
    label_search_for_help_articles: "Search for help articles",
    label_birthday: "Birthday",
    label_location: "Location",
    app_access: "wants access to your NZXT account to access:",
    app_access_has_scopes: "wants access to your NZXT account",
    scope_profile: "Your profile, including your name and image",
    scope_email: "Your email address",
    scope_address: "Your physical address",
    scope_phone: "Your phone number",
    grant_offline_access: "Have offline access",
    grant_offline_access_previous: "which you've previously granted"
};
var build = {
    custom_bld_modal_heading: "Build your PC",
    custom_bld_modal_subheading: "Select your chipset and budget",
    custom_bld_unavailable: "Please select a different item",
    custom_bld_issue: "The following item(s) need resolving: ",
    custom_bld_title: "Custom BLD",
    custom_bld_lets_get_started: "Let's get started",
    custom_bld_destrutive_action: "Warning: Build Reset",
    custom_bld_confirm_reset: "Your build will be reset with the following chipset:",
    custom_bld_keyboard_confirm_reset: "Your build will be reset with this change",
    custom_bld_choose_chipset: "Choose your Chipset",
    custom_bld_chipset: "Chipset",
    custom_bld_intel: "Intel",
    custom_bld_amd: "AMD",
    custom_bld_explore: "Explore",
    custom_bld_select: "Select",
    review_bld_button: "Review BLD",
    custom_bld_summary: "Summary",
    custom_bld_budget: "Budget",
    custom_bld_specs: "Specs",
    custom_bld_case: "Case",
    custom_bld_cases: "Cases",
    custom_bld_caseCooling: "Cooling",
    custom_bld_fans: "Fans",
    custom_bld_cpu: "CPU",
    custom_bld_gpu: "GPU",
    custom_bld_ram: "RAM",
    custom_bld_ssd: "SSD",
    custom_bld_hdd: "HDD",
    custom_bld_specials: "Specials",
    custom_bld_colors: "Colors",
    custom_bld_color: "Color",
    custom_bld_black: "Black",
    custom_bld_red: "Red",
    custom_bld_white: "White",
    custom_bld_grey: "Grey",
    custom_bld_blue: "Blue",
    custom_bld_purple: "Purple",
    custom_bld_yellow: "Yellow",
    custom_bld_audio: "Audio",
    custom_bld_extras: "Extras",
    custom_bld_core: "Core",
    custom_bld_motherboard: "Motherboard",
    custom_bld_motherboards: "Motherboards",
    custom_bld_powerSupplies: "Power Supplies",
    custom_bld_powerSupply: "Power Supply",
    custom_bld_services: "Services",
    custom_bld_software: "Software",
    custom_bld_monitors: "Monitors",
    custom_bld_peripherals: "Peripherals",
    custom_bld_lighting: "Lighting",
    custom_bld_headset: "Headset",
    custom_bld_keyboard: "Keyboard",
    custom_bld_all: "All",
    custom_bld_mouse: "Mouse",
    custom_bld_storage: "Storage",
    custom_bld_streaming_ready: "Stream Ready",
    custom_bld_rgb_lighting: "RGB Lighting",
    custom_bld_vr_ready: "VR Ready",
    custom_bld_wifi: "WiFi",
    custom_bld_from: "From",
    custom_bld_bluetooth: "Bluetooth",
    custom_bld_save_build_message: 'Your build has been saved successfully! You can view it in "Saved Builds" in your Account.',
    custom_bld_save_modal_message: "Do you want to save this build for later?",
    custom_bld_confirm_save_modal_message: "You will lose unsaved changes by leaving this page.",
    custom_bld_share_build_message: "Your build has been saved and copied successfully!",
    help_me_decide: "Help me decide",
    save_build: "Save Build",
    start_over: "Start Over",
    summary: "Summary",
    build_summary: "Build Summary",
    load_build: "Load Build",
    load: "Load",
    save: "Save",
    restart: "Restart",
    share: "Share",
    my_build_label: "My Build",
    est_shipping: "Estimated Shipping",
    add_to_build: "Add to Build",
    message_invalid: "Temporarily unavailable",
    message_out_of_stock: "Sold Out",
    message_low_stock: "Low Stock",
    message_new_item: "New",
    message_coming_soon: "Coming Soon",
    message_best_seller: "Best Seller",
    message_is_locked: "Not Compatible",
    button_label_select: "Select",
    button_label_selected: "Selected",
    button_label_add: "Add",
    button_label_added: "Added",
    button_label_update: "Update",
    button_label_remove: "Remove",
    button_label_info: "Info",
    button_label_more_info: "More Info",
    button_label_options_info: "Options & Info",
    button_label_continue_to: "Continue to Build",
    button_label_edit: "Edit",
    build_fps_label: "FPS Speeds are measured at 2560x1440 resolution using each game's highest graphic setting",
    build_includes: "Includes",
    custom_bld_boost: "Boost your Build",
    custom_bld_fps_unavailable: "Pending",
    custom_bld_amd_help: "Intel based PCs have been the norm for the last few years but AMD PCs are amazing for gaming now. We’ll help you build for both and we’ve picked motherboards and coolers that work well together so that you don’t have to figure it out. We recommend balancing the FPS performance that we show with builds with what you’re willing to budget for it.",
    custom_bld_to_see_this: "To see this selection you'll have to",
    custom_bld_change_chipset: "change your chipset.",
    custom_bld_prebuild_upsell: "Or pick quick and easy prebuilds",
    no_item_selected: "No Item Selected",
    build_change_label: "Build Modified",
    invalid_action_label: "Prevented",
    success_label: "Success",
    build_info_message: "Info",
    reset_label: "Build Reset",
    complete_build_label: "Complete Your Build",
    back_to_build_label: "Back to Your Build",
    complete_build_sub_label: "Extras & Peripherals",
    back_to_build_sub_label: "Core components of your build",
    capacity_label: "Capacity",
    option_label: "Option",
    options_label: "Options",
    max_speed: "Max Speed",
    modular_label: "Modular",
    midtower_label: "Mid-Tower",
    streaming_label: "Streaming",
    save_and_exit: "Save and Exit",
    exit: "Exit",
    view_cart_label: "View Cart",
    cart_subtotal_label: "Cart Subtotal",
    start_build_label: "Start Build",
    new_build_label: "New Build",
    continue_saved_build_label: "Continue your saved build",
    continue_progress_build_label: "Continue the build you have in progress",
    continue_cart_build_label: "Review build in cart",
    core_label: "Base",
    extras_label: "Add-ons",
    summary_label: "Summary",
    share_build_pc: "Custom build PC",
    share_build_kb: "Custom build Keyboard",
    build_summary_label: "Overview of your keyboard build.",
    pc_hub_card_heading: "Custom Gaming PCs",
    pc_hub_card_subheading: "Build your dream PC around your budget and optimized for the games you love.",
    kb_hub_card_heading: "Custom Keyboards",
    kb_hub_card_subheading: "Build a custom keyboard and mouse to match your space and game style"
};
var keyboard = {
    keyboard_label: "Keyboard",
    keyboard_size: "Keyboard Size",
    keyboard_base: "Keyboard Base",
    keyboard_primay_base_color: "Base Color",
    keyboard_layout: "Keyboard Layout",
    keyboard_summary: "Keyboard Summary",
    accent_keycaps: "Accent Keycaps",
    cabletype: "Accent Cable",
    additional_cable_color: "Cable Color",
    cable: "Cable",
    additional_cable: "Additional Cable",
    primary_keycaps: "Base Keycaps",
    switches: "Switches",
    size: "Size",
    layout: "Layout",
    language: "Language",
    mouse_pad_label: "Mouse Pad",
    desk_mat_label: "Desk Mat",
    tools_label: "Tools",
    wrist_rest_label: "Wrist Rest",
    mouse_label: "Mouse",
    cable_description: "Optional colored cable. A standard black 2-meter cable will be included.",
    cable_color_description: "The color of the premium cable.",
    language_description: "Determines the position of Q, W, Z and A keys.",
    layout_description: "Determines the size and position of the keys.",
    keycap_accent_description: "Optional color for Escape, Enter, Arrow, and Numpad Enter keys.",
    primary_keycap_description: "PBT dye-sublimated, Cherry profile.",
    switch_description: "Defines the typing experience of each key press.",
    keyboard_base_color_description: "The main color of the keyboard base.",
    keyboard_base_size_description: "Size determines the number of keys and dimension of the keyboard.",
    mouse_description: "Lightweight ambidextrous mouse.",
    summary_description: "Overview of your keyboard build",
    premium_label: "Premium",
    base_label: "Base",
    keyboard_warning: "Please select the following items to proceed with your build:",
    switch_reset_warning: "Your switches have been reset. Please select new switches.",
    keycap_reset_warning: "Your keycaps have been reset. Please select new keycaps.",
    base_type: "Build Type",
    build_type_description: "Select the type of keyboard you'd like to configure",
    full_custom_label: "Full Custom",
    barebones_disclaimer: "Change your Build Type to select this item",
    none_label: "None"
};
var camCta = {
    cam_description: "Manage performance, temperatures, and devices all from a single application.",
    cam_windows_10: "WINDOWS 10 64BIT"
};
var helpCta = {
    help_description: "Get extensive guides and support for all your NZXT products as well as help for warranties, return and anything technical"
};
var emailSignUp = {
    email_stay_in_touch: "Stay In Touch",
    email_sub_copy: "Keep up to date on the latest releases, offers, and news from NZXT",
    email_legal: "By signing up you agree to NZXT, CAM, and BLD's ",
    email_notify: "Notify Me",
    email_notify_stock: "Get notified when this item is available."
};
var generic = {
    explore: "Explore",
    cam_title: "NZXT CAM",
    free_download: "Free Download",
    details: "Details",
    help_amp_support: "Help & Support",
    help_and_support: "Help and Support",
    read_more: "Read More",
    privacy_policy: "Privacy Policy",
    terms_conditions: "Terms & Conditions",
    and: "and",
    or: "or",
    send: "send",
    return_to: "return to",
    previous: "Previous",
    next: "Next",
    home: "Home",
    keep_browsing: "Keep Browsing",
    create_build: "Create Build",
    learn_more: "Learn More",
    add_to_cart: "Add to Cart",
    share_build: "Share Build",
    view: "View",
    close: "Close",
    price: "Price",
    allow: "Allow",
    cancel: "Cancel",
    here: "here",
    ok: "Ok",
    button_start_bld: "Start BLD",
    message_on_sale: "Sale",
    button_buy: "Buy",
    button_start_build: "Start Build",
    view_build: "View Build",
    button_back: "Back",
    build: "Build",
    performance: "Performance",
    error_generic: "Something Went Wrong, Please try again later.",
    label_support: "Support",
    contact_support: "Contact Support",
    browse_articles: "Browse Articles",
    search_support_articles: "Search for help articles",
    message_error: "Uh-oh, looks like something went wrong",
    estimated_performance_label: "Performance",
    see_estimated_performance_label: "See Estimated Performance",
    estimated_fps: "Estimated frames per second (FPS)",
    title_related_items: "You may also like",
    qty: "QTY",
    category_from: "From",
    reviews_label: "Reviews",
    message_out_of_stock: "Sold Out",
    message_low_stock: "Low Stock",
    message_new_item: "New",
    message_coming_soon: "Coming Soon",
    message_best_seller: "Best Seller",
    message_unavailable: "Unavailable",
    message_invalid: "Temporarily unavailable",
    message_featured_items: "Featured Products in Image",
    message_colors: "Colors",
    message_color: "Color",
    label_return_policy: "Return Policy",
    label_warranty_policy: "Warranty Policy",
    label_shop: "Shop",
    label_days: "Days",
    label_hours: "Hours",
    label_minutes: "Minutes",
    label_seconds: "Seconds",
    label_promotion: "See Promotion",
    label_promotions: "Promotions",
    monthly_payments: "Monthly payments available.",
    message_promotion: "Promotion",
    discount_label: "Off",
    off_label: "Off",
    on_label: "On",
    choose_label: "Choose",
    move_to_previous_label: "Move to previous slide",
    move_to_next_label: "Move to next slide",
    active_slide_label: "Active Slide",
    move_to_inactive_slide: "Move to inactive slide",
    color_options: "Color Options",
    of: "of",
    product_images: "Product images",
    for: "for",
    carousel: "Carousel",
    go_to_image: "Go to image",
    button_label_add: "Add",
    button_label_remove: "Remove",
    increase_price_label: "Increase Price",
    decrease_price_label: "Decrease Price",
    select_video_label: "Select Video",
    play_label: "Play",
    pause_label: "Pause",
    buttons: "Buttons",
    open_modal_label: "Open Image Zoom Modal",
    close_modal_label: "Close Image Zoom Modal",
    image_zoom_modal: "Image Zoom Modal",
    vr_ready_label: "VR Ready",
    vr_not_ready_label: "Not VR Ready",
    streaming_ready_label: "Stream Ready",
    streaming_not_ready_label: "Not Stream Ready",
    has_wifi_label: "Has WiFi",
    no_wifi_label: "No WiFi",
    has_bluetooth_label: "Has Bluetooth",
    no_bluetooth_label: "No Bluetooth",
    has_usbc_label: "has USB-C",
    no_usbc_label: "No USB-C",
    rgb_included_label: "RGB Lighting Included",
    rgb_not_included_label: "RGB Lighting Not Included",
    products_label: "Products",
    upsell_modal_label: "Frequently bought together",
    no_thanks_label: "No Thanks",
    label_deal_ends: "Deal ends in",
    label_show_more: "Show More",
    label_show_less: "Show Less",
    label_case: "Case",
    label_software: "Software",
    label_services: "Services",
    label_ram: "RAM",
    label_cpu: "CPU",
    label_gpu: "GPU",
    label_motherboard: "Motherboard",
    label_storage: "Storage",
    label_cooling: "Cooling",
    label_psu: "PSU",
    label_warranty: "Warranty",
    label_accessories: "Accessories",
    label_fps: "FPS",
    label_feature: "Feature"
};
var cart = {
    cart_heading: "Your Cart",
    cart_heading_empty: "Your cart is empty",
    cart_subheading_empty: "Find products you'll love",
    cart_free_shipping_cta: "You're $25 away from free shipping!",
    cart_free_shipping_exclusion: "(Excludes Custom and Prebuilt PCs)",
    cart_free_shipping_promo_cta: "Free shipping on all orders",
    cart_heading_error: "Something went wrong. Please try again.",
    cart_heading_success: "Thank you!",
    cart_label_subtotal: "Subtotal",
    cart_label_taxes: "Taxes",
    cart_value_taxes: "Calculated at checkout",
    cart_label_shipping: "Estimated shipping",
    cart_value_shipping_free: "FREE",
    cart_value_disclaimer: "*New and/or refurbished products may process and ship at different times.",
    cart_label_total: "Total",
    cart_button_checkout: "Proceed to Checkout",
    cart_terms_message: "I accept the",
    cart_terms_link_text: "terms and conditions of service",
    cart_value_taxes_non_us: "Included",
    cart_value_shipping_calculated: "Calculated at checkout",
    cart_consent_i_have_read: "I have read the",
    cart_consent_privacy_policy: "privacy policy",
    cart_consent_privacy_policy_after: " ",
    cart_au_terms_message: "I accept the",
    cart_au_terms_link: "Terms of Service",
    cart_au_consent_message: "I consent to my personal information being collected and used in accordance with the",
    cart_au_consent_link: "Privacy Policy",
    cart_au_terms_text_1: "NZXT Pty Ltd (ABN 47 645 981 559) supplies the goods and services you have ordered pursuant to its",
    cart_au_terms_text_terms_link: "Terms and Conditions",
    cart_au_terms_text_2: "and collects, uses, and discloses the personal information it collects from you in accordance with its",
    cart_au_terms_text_privacy_link: "Privacy Policy",
    cart_label_ssd: "SSD",
    cart_label_hdd: "HDD",
    cart_label_service: "Service",
    cart_label_software: "Software",
    cart_label_case: "Case",
    cart_label_motherboard: "Motherboard",
    cart_label_cpu: "CPU",
    cart_label_gpu: "GPU",
    cart_label_power_supply: "Power Supply",
    cart_label_cpu_cooler: "CPU Cooler",
    cart_label_rgb: "RGB",
    cart_label_fans: "Fans",
    cart_label_ram: "RAM",
    cart_label_monitors: "Monitors",
    cart_label_peripherals: "Peripherals",
    cart_label_extras: "Extras",
    cart_label_keycaps: "Keycaps",
    cart_label_keycap_accents: "Keycap Accents",
    cart_label_switches: "Switches",
    cart_label_keyboard_base: "Keyboard Base",
    cart_label_keycap_accent: "Accent Keycaps",
    cart_label_accent_cable: "Accent Cable",
    cart_label_mouse: "Mouse",
    cart_message_item_fallback: "This item",
    cart_message_build_item_oos_before: "An item in your",
    cart_message_build_item_oos_after: "has sold out. Please click here to update your build in order to add it to cart.",
    cart_message_oos: "is currently out of stock.  Please remove this item to proceed to checkout."
};
var category = {
    explore_refurbished: "Explore Builds",
    explore_bulk: "Explore Bulk",
    bulk: "Bulk",
    refurbished: "Refurbished",
    refurbished_cta: "Check out deals on our refurbished builds and parts that are fully tested and inspected.",
    bulk_cta: "We’ve helped provide builds in bulk to gaming companies, universities, esport organizations and more."
};
var geoipBanner = {
    currently_browsing: "Currently browsing",
    banner_region_text: "Switch your region to shop and see content specific to your location.",
    banner_button: "Switch to",
    banner_country_text_shop: "Shop",
    banner_counrty_text: "or select a different country specific to your location.",
    country_us: "United States",
    country_canada: "Canada",
    country_belgium: "Belgium",
    country_germany: "Germany",
    country_luxembourg: "Luxembourg",
    country_netherlands: "Netherlands",
    country_austria: "Austria",
    country_france: "France",
    country_italy: "Italy",
    country_spain: "Spain",
    country_uk: "United Kingdom",
    country_australia: "Australia",
    country_nz: "New Zealand",
    country_japan: "Japan",
    region_na: "North America",
    region_europe: "Europe",
    region_oceania: "Oceania"
};
var ui = {
    loading: "Loading"
};
var footer = {
    label_language: "Language",
    label_country: "Country",
    manage_cookie_preferences: "Manage Cookie Preferences",
    all_rights_reserved: "All Rights Reserved"
};
var search = {
    label_suggested_queries: "Suggested Queries",
    label_suggested_results: "Suggested Results",
    label_serp_heading: "Search results for",
    label_serp_not_found: "No results found for",
    label_serp_total: "total results",
    label_serp_suggested: "Try searching for"
};
var about = {
    label_customer_support_hours: "Customer Support Hours",
    label_headquarters: "Headquarters"
};
var product = {
    overview: "Overview",
    tech_specs: "Tech Specs",
    downloads: "Downloads",
    message_invalid: "Temporarily unavailable",
    message_out_of_stock: "Sold Out",
    message_low_stock: "Low Stock",
    message_new_item: "New",
    message_coming_soon: "Coming Soon",
    message_unavailable: "Unavailable",
    title_highlights: "Highlights",
    title_shipping: "Shipping",
    title_in_the_box: "Inside the Box",
    button_buy_now: "Buy Now",
    message_colors: "Colors",
    message_color: "Color",
    message_size: "Size",
    message_series: "Series",
    overview_anchor: "Overview",
    tech_specs_anchor: "Tech Specs",
    downloads_anchor: "Downloads",
    related_anchor: "Related",
    customize_build_header: "Or Build",
    customize_build_subheader: "Build a custom PC with this item",
    customize_kb_build_subheader: "Build a custom keyboard",
    buy_product_header: "DIY",
    buy_product_subheader: "Dream it. Build it. Do it.",
    buy_label: "Buy",
    retailers_subheader: "Shop with our partners.",
    link_all_retailers: "View all retailers",
    series_label: "Series",
    label_header_bundle: "Buy Together",
    label_subheader_bundle: "Take your build to the next level with expert recommended products",
    help_button_label: "Chat Now",
    help_button_heading: "Have questions?",
    help_button_subheading: "Our experts are ready to help.",
    configure_label: "Configure",
    documentation_label: "Documentation",
    drivers_label: "Drivers",
    miscellaneous_label: "Miscellaneous",
    resources_label: "Resources",
    everything_you_need_label: "Everything you need",
    good_rating_label: "Good",
    better_rating_label: "Better",
    best_rating_label: "Best",
    key_specs_label: "Key Specs"
};
var collection = {
    message_invalid: "Temporarily unavailable",
    message_out_of_stock: "Sold Out",
    message_low_stock: "Low Stock",
    message_unavailable: "Unavailable",
    message_new_item: "New",
    message_coming_soon: "Coming Soon",
    button_buy_now: "Buy Now",
    message_colors: "Colors",
    learn_more: "Learn More",
    help_button_label: "Chat Now",
    help_button_heading: "Have questions?",
    help_button_subheading: "Our experts are ready to help."
};
var news = {
    label_all_news: "All News"
};
var retailers = {
    label_regions: "Regions",
    label_locations: "Locations",
    label_reseller_type: "Type",
    option_label_all_regions: "All Regions",
    option_label_all_locations: "All Locations",
    option_label_all_reseller_type: "All Options",
    message_empty_state: "No retailers match selected criteria.",
    hero_text: "NZXT products can be purchased through our partners in all regions"
};
var searchResults = {
    message_invalid: "Temporarily unavailable",
    message_out_of_stock: "Sold Out",
    message_low_stock: "Low Stock",
    message_new_item: "New",
    message_coming_soon: "Coming Soon",
    message_unavailable: "Unavailable"
};
var orderTracking = {
    title_order_status: "Order Status",
    label_cancelled_on: "Cancelled On",
    label_shipping_date: "Estimated Shipping Date",
    label_case: "Case",
    label_software: "Software",
    label_services: "Services",
    label_ram: "RAM",
    label_cpu: "CPU",
    label_gpu: "GPU",
    label_motherboard: "Motherboard",
    label_storage: "Storage",
    label_cooling: "Cooling",
    label_psu: "PSU"
};
var orderTrackingRoot = {
    title_order_tracking_root: "Enter your order ID",
    label_build_id: "Order ID",
    button_track: "Track Order",
    message_not_found: "not found, please try again"
};
var refurb = {
    label_all_products: "All Products",
    label_relevance: "Relevance",
    label_price_low_high: "Price Low to High",
    label_price_high_low: "Price High to Low",
    label_name_a_z: "Name A-Z",
    label_name_z_a: "Name Z-A",
    label_case: "Case",
    label_software: "Software",
    label_services: "Services",
    label_ram: "RAM",
    label_cpu: "CPU",
    label_gpu: "GPU",
    label_motherboard: "Motherboard",
    label_storage: "Storage",
    label_cooling: "Cooling",
    label_psu: "PSU",
    label_other: "Other",
    label_accessories: "Accessories",
    label_fan: "Fans",
    label_any_price: "Any Price",
    label_no_products: "There are no refurbished components available at this time.",
    label_no_builds: "There are no refurbished builds available at this time."
};
var orderStatus = {
    confirmed_title: "Order Placed",
    step_label: "Step",
    confirmed_sub: "Your order has been received.",
    processed_title: "Order Confirmed",
    processed_sub: "Your order has been received and your payment has been processed.",
    in_progress_title: "In Progress",
    in_progress_sub: "Picking & assembly for your order has begun. Your order is now locked and changes/cancellations cannot be guaranteed.",
    shipped_title: "Shipped",
    shipped_sub: "Your order is on its way!",
    cancelled_title: "Cancelled",
    cancelled_sub: "Your order has been successfully cancelled.",
    enh_ordered_sub: "Your order has been received and is in queue.",
    enh_picking_title_bld: "Preparing Build",
    enh_picking_title: "Processing Your Order",
    enh_picking_sub_bld: "Picking & assembly for your order has begun. Modifications to your order cannot be guaranteed.",
    enh_picking_sub: "We are preparing your order. Modifications to your order cannot be guaranteed.",
    enh_build_title: "Building",
    enh_build_sub: "Your order is being built and tested.",
    enh_packing_title: "Preparing to Ship",
    enh_packing_sub_bld: "Your order has been built and tested. It is being packed for delivery.",
    enh_packing_sub: "Your order has been processed and is being packed for delivery.",
    enh_shipping_title: "Shipping",
    enh_shipping_sub: "Your order has been sent to the shipping carrier for delivery. Your tracking number will be updated and emailed to you within 1 business day."
};
var universal = (0,_object_spread/* default */.Z)({}, cart, userAccount, auth, formErrors, camCta, generic, helpCta, emailSignUp, geoipBanner, ui, footer, search, about, orderStatus);
// eslint-disable-next-line import/prefer-default-export
var en = {
    "/": (0,_object_spread/* default */.Z)({}, universal),
    "/product/[slug]": (0,_object_spread/* default */.Z)({}, product, universal),
    "/collection/[slug]": (0,_object_spread/* default */.Z)({}, collection, universal),
    "/partner/[slug]": (0,_object_spread/* default */.Z)({}, collection, universal),
    "/sale/[slug]": (0,_object_spread/* default */.Z)({}, collection, universal),
    "/about": (0,_object_spread/* default */.Z)({}, universal, about),
    "/about/[slug]": (0,_object_spread/* default */.Z)({}, universal, about),
    "/legal": (0,_object_spread/* default */.Z)({}, universal),
    "/legal/[slug]": (0,_object_spread/* default */.Z)({}, universal),
    "/news/[slug]": (0,_object_spread/* default */.Z)({}, news, universal, category),
    "/news/page/[page]": (0,_object_spread/* default */.Z)({}, universal, category),
    "/news/category/[category]": (0,_object_spread/* default */.Z)({}, universal, category),
    "/news/category/[category]/page/[page]": (0,_object_spread/* default */.Z)({}, universal, category),
    "/user/[slug]": (0,_object_spread/* default */.Z)({}, universal, build, keyboard),
    "/software/[slug]": (0,_object_spread/* default */.Z)({}, universal),
    "/category/[slug]": (0,_object_spread/* default */.Z)({}, category, universal),
    "/category/[slug]/[subcategory-slug]": (0,_object_spread/* default */.Z)({}, category, universal),
    "/build": (0,_object_spread/* default */.Z)({}, universal, build),
    "/build/[slug]": (0,_object_spread/* default */.Z)({}, universal, build),
    "/build/pc": (0,_object_spread/* default */.Z)({}, universal, build),
    "/build/pc/[slug]": (0,_object_spread/* default */.Z)({}, universal, build),
    "/build/keyboard/[slug]": (0,_object_spread/* default */.Z)({}, universal, build, keyboard),
    "/build/[slug]/summary": (0,_object_spread/* default */.Z)({}, universal, build),
    "/support": (0,_object_spread/* default */.Z)({}, universal),
    "/refurbished/[slug]": (0,_object_spread/* default */.Z)({}, universal, refurb),
    "/careers": (0,_object_spread/* default */.Z)({}, universal),
    "/reviews/page/[page]": (0,_object_spread/* default */.Z)({}, universal),
    "/careers/available-positions": (0,_object_spread/* default */.Z)({}, universal),
    "/order-tracking/[slug]": (0,_object_spread/* default */.Z)({}, orderTracking, orderTrackingRoot, universal),
    "/order-tracking": (0,_object_spread/* default */.Z)({}, orderTrackingRoot, universal),
    "/retailers": (0,_object_spread/* default */.Z)({}, retailers, universal),
    "/search": (0,_object_spread/* default */.Z)({}, searchResults, universal),
    "/auth/[slug]": (0,_object_spread/* default */.Z)({}, universal),
    "/oauth/[slug]": (0,_object_spread/* default */.Z)({}, universal),
    universal: universal
};

;// CONCATENATED MODULE: ./locale/de.ts
/* eslint-disable max-len */ 
var de_userAccount = {
    user_settings_title: "Kundenkonto",
    user_settings_change_password: "Passwort \xe4ndern",
    user_settings_save: "Speichern",
    user_settings_cancel: "Abbrechen",
    user_profile_heading: "Profil",
    user_saved_builds_heading: "Gespeicherte Builds",
    user_saved_builds_bld_name: "Build-Name",
    user_saved_builds_bld_date: "Erstellungsdatum",
    user_saved_builds_bld_item_part: "Artikel",
    user_saved_builds_delete_bld: "BLD l\xf6schen",
    user_saved_builds_resume_bld: "BLD fortsetzen",
    user_saved_builds_hero_title: "Entwickelt, um deinen Build in Szene zu setzen",
    user_saved_builds_hero_text: "Das kompakte vertikale Design unterst\xfctzt die meisten Grafikkarten in voller Gr\xf6\xdfe auf dem Markt, sodass du deine Schreibtischfl\xe4che voll ausnutzen kannst, ohne Einbu\xdfen bei der Grafikleistung.",
    user_saved_builds_pc_heading: "PC-Aufbauten",
    user_saved_builds_keyboard_heading: "Tastatur baut auf",
    user_saved_builds_view_pc: "PC-Aufbauten ansehen",
    user_saved_builds_view_keyboard: "Tastatur-Builds anzeigen",
    user_saved_builds_no_pc: "Sie haben keine gespeicherten PC Builds",
    user_saved_builds_no_kb: "Sie haben keine gespeicherten Keyboard Builds",
    user_order_history_heading: "Bestellverlauf",
    user_order_history_date: "Datum",
    user_order_history_order_number: "Bestellnummer",
    user_order_history_status: "Status",
    user_order_history_amount: "Betrag",
    user_order_history_view: "Beleg anzeigen",
    user_order_history_empty_view: "Du hast keinen Bestellverlauf.",
    user_order_history_shipping: "Versandadresse",
    user_order_history_billing: "Rechnungsadresse",
    user_order_history_item: "Artikel",
    user_order_history_item_image: "Produktfoto",
    user_order_history_quantity: "Anzahl",
    user_order_history_order: "Auftrag #",
    user_support_heading: "Support + R\xfccksendungen",
    user_data_heading: "Datenanforderung",
    user_terms_heading: "Bedingungen",
    user_terms_empty: "Sie haben noch keine unterschriebenen Bedingungen.",
    user_support_subject_min_length: "Betreff muss mindestens 3 Zeichen lang sein",
    user_support_message_placeholder: "Bitte Gr\xfcnde f\xfcr den Kontakt angeben. Bei R\xfccksendung bitte Bestellnummer angeben",
    user_support_update_button: "Aktualisieren",
    user_active_tickets_heading: "Aktive Tickets",
    user_active_tickets_chat: "Nachricht hinzuf\xfcgen",
    user_active_tickets_no_chat_history: "Du hast keinen Chat-Verlauf",
    view_chat_button: "Chat anzeigen",
    close_chat_button: "Chat schlie\xdfen",
    field_required_message: "Dieses Feld ist erforderlich",
    label_accept: "Akzeptieren",
    label_reason_for_contact: "Grund der Kontaktaufnahme",
    label_country: "Land",
    label_subject: "Betreff",
    label_product: "Produkt",
    label_message: "Nachricht",
    label_requestor_type: "Anfragetyp",
    label_country_of_residence: "Land des Wohnsitzes",
    label_description: "Beschreibung",
    placeholder_description: "Beschreibung deiner Anfrage",
    label_submit: "Abschicken",
    message_no_support_requests: "Du hast keine aktiven Supportanfragen",
    label_ticket_number: "Ticketnummer",
    label_date_created: "Datum erstellt",
    label_status: "Status",
    label_department: "Abteilung",
    subheading_active_ticket: "Wenn du Hilfe ben\xf6tigst oder einen Artikel zur\xfccksenden m\xf6chtest, wende dich bitte an den Support.",
    label_create_support_request: "Supportanfrage erstellen",
    button_comment: "Kommentar",
    label_for_myself: "F\xfcr mich selbst",
    label_parent: "Elternteil",
    label_legal_rep: "Gesetzlicher Vertreter",
    label_relative: "Anegh\xf6riger",
    label_guardian: "Erziehungsberechtigter",
    label_accept_generic_terms: "Ich habe diese Bedingungen gelesen und akzeptiere sie",
    error_view_message: "Ups, etwas ist schief gelaufen.",
    signout_view_message: "Du wurdest abgemeldet.",
    user_order_history_close: "Schlie\xdfen",
    birthday_error_message: "Bitte gib ein g\xfcltiges Geburtsdatum ein",
    label_view_saved: "Alle gespeicherten Builds anzeigen"
};
var de_formErrors = {
    required_error: "Erforderlich",
    invalid_email: "Bitte gib eine g\xfcltige E-Mail ein",
    username_full_pattern_message: "Der Benutzername muss 6 bis 30 Zeichen lang sein. Sie k\xf6nnen Buchstaben, Zahlen und Punkte verwenden, d\xfcrfen jedoch keine aufeinanderfolgenden Punkte beginnen, enden oder enthalten.",
    password_pattern_message: "Das Passwort muss mindestens sechs Zeichen, einen Gro\xdfbuchstaben, einen Kleinbuchstaben und eine Zahl enthalten",
    username_min_length_message: "Verwende 6 Zeichen oder mehr f\xfcr deinen Benutzernamen",
    passwords_must_match: "Passw\xf6rter m\xfcssen \xfcbereinstimmen",
    invalid_current_password: "Das Passwort kann nicht aktualisiert werden. Der als aktuelles Passwort angegebene Wert ist falsch",
    must_accept_partner_program_terms: "Sie m\xfcssen die Bedingungen des Partnerprogramms akzeptieren, um ein NZXT-Partner zu werden",
    must_accept_tos_terms: "Du musst den Nutzungsbedingungen zustimmen, um einen NZXT Account anzulegen",
    must_accept_generic_terms: "Sie m\xfcssen diesen Bedingungen zustimmen"
};
var de_auth = {
    user_auth_agreement: "Ich akzeptiere NZXT's.",
    user_auth_privacy_policy: "Datenschutzrichtlinie",
    user_auth_and: "und habe die",
    user_auth_terms: "Nutzungsbedingungen gelesen.",
    error_invalid_request: "Ung\xfcltige Anfrage.",
    error_invalid_token: "Ung\xfcltiges Benutzerauthentifizierungstoken",
    error_session_expired: "Deine Sitzung ist abgelaufen. Bitte melde dich erneut an, um fortzufahren.",
    user_forgot_required_email: "E-Mailadresse wird ben\xf6tigt",
    user_forgot_success_message: "Vielen Dank! Wenn mit dieser E-Mail ein Konto verkn\xfcpft ist, senden wir die Anweisungen zum Zur\xfccksetzen des Kennworts sofort.",
    error_email_exists: "Die E-Mail wird bereits verwendet",
    user_email_verification_heading: "E-Mail-Verifizierung",
    error_email_not_verified: "Die E-Mail-Adresse ist noch nicht best\xe4tigt. Um die Best\xe4tigungs-E-Mail erneut zu senden, klicken Sie auf",
    error_email_already_verified: "Die E-Mail-Adresse wurde bereits verifiziert. Bitte melden Sie sich weiter an.",
    user_email_verification_success_message: "Ihre E-Mail-Adresse wurde erfolgreich verifiziert!. Bitte melden Sie sich weiter an.",
    error_username_unavailable: "Der Benutzername ist nicht verf\xfcgbar",
    error_reset_password_same_as_old_password: "Dieses Passwort ist das gleiche wie zuvor. Bitte w\xe4hle ein anderes.",
    error_reset_password_link_expired: "Der Link zum Zur\xfccksetzen deines Passworts ist abgelaufen.",
    error_reset_password_link_invalid: "Der Link zum Zur\xfccksetzen deines Passworts ist ung\xfcltig.",
    user_forgot_password_subheading: "Gib deine E-Mail-Adresse ein, um Anweisungen zum Zur\xfccksetzen deines Passworts zu erhalten.",
    user_reset_password_heading: "Setze dein Passwort zur\xfcck",
    user_reset_password_subheading: "Bitte gib ein neues Passwort ein.",
    user_reset_password: "Passwort zur\xfccksetzen",
    user_reset_success_message: "Du hast dein Passwort erfolgreich zur\xfcckgesetzt!",
    user_login_text: "Mit Google anmelden",
    user_login_remember: "Angemeldet bleiben",
    user_login_forgot_password: "Passwort vergessen?",
    user_login_wrong_email_or_password: "Falsche E-Mail-Adresse oder Passwort",
    user_login_success_message: "Du hast dich erfolgreich angemeldet!",
    error_too_many_requests: "Du hast zu viele Anfragen gestellt. Bitte warte einige Minuten oder wende dich an den Support",
    error_user_not_found: "Benutzer wurde nicht gefunden",
    user_sign_in_sign_up: "Anmelden / Registrieren",
    user_sign_out: "Abmelden",
    user_sign_in: "Anmelden",
    user_account_updates: "NZXT-Updates",
    user_account_no_updates: "Keine aktuellen Updates, schauen Sie sp\xe4ter noch einmal vorbei.",
    support_center_link: "Hilfe & Support",
    error_google_account_exists: "Du hast schon einen Account, der mit diesem Google Konto verkn\xfcpft ist. Bitte logge dich stattdessen ein.",
    error_local_account_exists: "Sieht so aus, als h\xe4ttest du bereits einen Account. Bitte logge dich stattdessen ein.",
    user_sign_up: "Registrieren",
    user_sign_up_text: "Mit Google registrieren",
    user_sign_up_opt_in: "Melde dich f\xfcr E-Mails an und erhalte Updates von NZXT \xfcber Produkte, BLD und CAM",
    user_sign_up_check_email_message: "Sieh in deinem Postfach nach und klicke auf den Link zum Aktivieren deines Kontos.",
    user_sign_up_success_verify_message: "Das Konto wird erst nach der Verifizierung aktiviert. Bitte sieh in deinem Spam-Ordner nach, wenn du die E-Mail nach einigen Minuten noch nicht erhalten hast.",
    user_info_updated_success_message: "Deine Informationen wurden erfolgreich aktualisiert!",
    user_info_newsletter_confirmation_message: "Bitte \xfcberpr\xfcfe dein E-Mail-Postfach zur Best\xe4tigung.",
    user_username_min_length_text: "Benutzername muss aus mindestens 5 Zeichen bestehen",
    user_email_sign_in: "Oder fortfahren mit",
    user_no_account: "Noch kein Kundenkonto?",
    user_create_account: "Kundenkonto anlegen",
    user_email_sign_up_text: "Oder registrieren mit",
    user_have_account: "Hast du ein Kundenkonto?",
    open_login_view: "Login-Ansicht \xf6ffnen",
    error_newsletter_subscription: "Newsletter kann derzeit nicht abonniert / abbestellt werden. Bitte versuche es sp\xe4ter noch einmal.",
    user_login_too_many_requests: "Du hast zu viele Anfragen gestellt. Bitte warte ein paar Minuten oder kontaktiere den Support",
    label_email_address: "E-Mail Addresse",
    label_password: "Passwort",
    label_current_password: "Jetziges Passwort",
    label_confirm_password: "Passwort wiederholen",
    label_new_password: "Neues Kennwort",
    label_confirm_new_password: "Best\xe4tige neues Passwort",
    label_username: "Nutzername",
    label_first_name: "Vorname",
    label_last_name: "Nachname",
    label_preferred_pronouns: "Bevorzugte Pronomen",
    label_search_for_help_articles: "Suche nach Hilfeartikeln",
    label_birthday: "Geburtstag",
    label_location: "Ort",
    app_access: "m\xf6chte auf dein NZXT Konto zugreifen, um Folgendes abzurufen:",
    app_access_has_scopes: "m\xf6chte auf dein NZXT Konto zugreifen",
    scope_profile: "Dein Profil mit deinem Namen und Bild",
    scope_email: "Deine E-Mail-Adresse",
    scope_address: "Ihre physische Adresse",
    scope_phone: "Deine Telefonnummer",
    grant_offline_access: "Offline-Zugriff haben",
    grant_offline_access_previous: "die Sie zuvor gew\xe4hrt haben"
};
var de_build = {
    custom_bld_modal_heading: "Baue deinen PC",
    custom_bld_modal_subheading: "W\xe4hle deinen Chipsatz und dein Budget",
    custom_bld_unavailable: "Bitte w\xe4hle einen anderen Artikel aus",
    custom_bld_issue: "Die folgenden Probleme m\xfcssen gel\xf6st werden: ",
    custom_bld_title: "Dein BLD",
    custom_bld_choose_chipset: "W\xe4hle dein Chipsatz",
    custom_bld_lets_get_started: "Los geht‘s",
    custom_bld_destrutive_action: "Warnung: Build zur\xfcckgesetzt",
    custom_bld_confirm_reset: "Dein Build wird mit dem folgenden Chipsatz zur\xfcckgesetzt:",
    custom_bld_keyboard_confirm_reset: "Ihr Build wird mit dieser \xc4nderung zur\xfcckgesetzt",
    custom_bld_chipset: "Chipsatz",
    custom_bld_intel: "Intel",
    custom_bld_amd: "AMD",
    custom_bld_explore: "Mehr Erfahren",
    custom_bld_select: "Ausw\xe4hlen",
    review_bld_button: "BLD \xdcbersicht",
    custom_bld_summary: "Zusammenfassung",
    custom_bld_budget: "Budget",
    custom_bld_specs: "Technische Daten",
    custom_bld_case: "Geh\xe4use ",
    custom_bld_cases: "Geh\xe4use",
    custom_bld_caseCooling: "K\xfchlung",
    custom_bld_fans: "L\xfcfter",
    custom_bld_cpu: "CPU",
    custom_bld_gpu: "Grafikkarte",
    custom_bld_ram: "RAM",
    custom_bld_ssd: "SSD",
    custom_bld_hdd: "HDD",
    custom_bld_specials: "Extras",
    custom_bld_colors: "Farben",
    custom_bld_color: "Farbe",
    custom_bld_black: "Schwarz",
    custom_bld_red: "Rot",
    custom_bld_white: "Wei\xdf",
    custom_bld_grey: "Grau",
    custom_bld_blue: "Blau",
    custom_bld_purple: "Lila",
    custom_bld_yellow: "Gelb",
    custom_bld_audio: "Audio",
    custom_bld_extras: "Extras",
    custom_bld_motherboard: "Motherboard",
    custom_bld_motherboards: "Motherboards",
    custom_bld_powerSupplies: "Netzteile",
    custom_bld_powerSupply: "Netzteil",
    custom_bld_services: "Services",
    custom_bld_software: "Software",
    custom_bld_monitors: "Monitore",
    custom_bld_peripherals: "Peripherieger\xe4te",
    custom_bld_lighting: "Beleuchtung",
    custom_bld_headset: "Headset",
    custom_bld_keyboard: "Tastatur",
    custom_bld_all: "Alle",
    custom_bld_mouse: "Maus",
    custom_bld_storage: "Speicher",
    custom_bld_streaming_ready: "Stream Ready",
    custom_bld_rgb_lighting: "RGB-Beleuchtung",
    custom_bld_vr_ready: "VR Ready",
    custom_bld_wifi: "WLAN",
    custom_bld_share_build_message: "Dein Build wurde erfolgreich gespeichert und kopiert!",
    custom_bld_from: "Von",
    custom_bld_bluetooth: "Bluetooth",
    custom_bld_save_build_message: 'Dein Build wurde erfolgreich gespeichert! Du kannst ihn unter "Gespeicherte Builds" in deinem Konto ansehen.',
    custom_bld_save_modal_message: "M\xf6chten Sie diesen Build f\xfcr sp\xe4ter speichern?",
    custom_bld_confirm_save_modal_message: "Wenn Sie diese Seite verlassen, gehen nicht gespeicherte \xc4nderungen verloren.",
    help_me_decide: "Entscheidungshilfe",
    save_build: "Build speichern",
    start_over: "Neu starten",
    summary: "Zusammenfassung",
    build_summary: "Build Zusammenfassung",
    load_build: "Build laden",
    load: "Laden",
    save: "Speichern",
    restart: "Neu starten",
    share: "Teilen",
    my_build_label: "Mein Build",
    est_shipping: "Voraussichtliches Versanddatum",
    add_to_build: "Zum Build hinzuf\xfcgen",
    message_invalid: "Momentan nicht verf\xfcgbar",
    message_out_of_stock: "Nicht auf Lager",
    message_low_stock: "Niedriger Bestand",
    message_best_seller: "Bestseller",
    message_coming_soon: "Bald verf\xfcgbar",
    message_is_locked: "Nicht Kompatibel",
    message_new_item: "Neu",
    button_label_select: "Ausw\xe4hlen",
    button_label_selected: "Ausgew\xe4hlt",
    button_label_add: "Hinzuf\xfcgen",
    button_label_remove: "Entfernen",
    button_label_added: "Hinzugef\xfcgt",
    button_label_update: "Aktualisieren",
    button_label_info: "Infos",
    button_label_more_info: "Mehr Info",
    button_label_options_info: "Optionen und Info",
    button_label_continue_to: "Mit dem Build fortfahren",
    button_label_edit: "Bearbeiten",
    build_fps_label: "Die FPS-Geschwindigkeiten werden mit einer Aufl\xf6sung von 2560 x 1440 gemessen, wobei die h\xf6chste Grafikeinstellung jedes Spiels verwendet wird",
    build_includes: "Beinhaltet",
    custom_bld_boost: "Erweitere deinen Build",
    custom_bld_fps_unavailable: "steht aus",
    custom_bld_amd_help: "Intel-basierte PCs waren in den letzten Jahren der Standard, aber AMD-PCs haben aufgeholt und eignen sich jetzt bestens f\xfcr Gaming. Wir helfen dir, beide zu bauen, indem wir Motherboards und K\xfchler ausgew\xe4hlt haben, die gut zusammen passen, sodass du dir keine Gedanken darum machen musst. Wir empfehlen dir, die Balance zwischen der hier angezeigten FPS Performance und deinem Budget zu finden.",
    custom_bld_to_see_this: "Um diese Auswahl zu sehen musst du",
    custom_bld_change_chipset: "deinen Chipsatz \xe4ndern.",
    custom_bld_prebuild_upsell: "Oder w\xe4hle einfach und schnell einen Prebuild",
    no_item_selected: "Kein Produkt ausgew\xe4hlt",
    build_change_label: "Build angepasst",
    invalid_action_label: "Verhindert",
    success_label: "Erfolg",
    build_info_message: "Info",
    reset_label: "Build zur\xfcckgesetzt",
    complete_build_label: "Vervollst\xe4ndige dein Build",
    back_to_build_label: "Zur\xfcck zu deinem Build",
    complete_build_sub_label: "Extras & Peripherie",
    back_to_build_sub_label: "Core components of your build",
    performance: "Leistung",
    message_error: "Oh nein, offenbar ist etwas schiefgegangen",
    capacity_label: "Kapazit\xe4t",
    option_label: "Option",
    options_label: "Optionen",
    max_speed: "H\xf6chstgeschwindigkeit",
    modular_label: "Modular",
    midtower_label: "Mid-Tower",
    streaming_label: "Streaming",
    save_and_exit: "Speichern und Beenden",
    exit: "Ausgang",
    view_cart_label: "Warenkorb ansehen",
    cart_subtotal_label: "Warenkorb Zwischensumme",
    start_build_label: "Build starten",
    new_build_label: "Neuer Build",
    continue_saved_build_label: "Setzen Sie Ihr gespeichertes Build fort",
    continue_progress_build_label: "Setzen Sie den laufenden Bau fort",
    continue_cart_build_label: "\xdcberpr\xfcfen Sie das Build in Ihrem Warenkorb",
    core_label: "Basis",
    extras_label: "Add-ons",
    summary_label: "Zusammenfassung",
    share_build_pc: "Benutzerdefinierter PC",
    share_build_kb: "Benutzerdefinierte Tastatur",
    build_summary_label: "\xdcbersicht \xfcber deinen Tastatur-Build.",
    pc_hub_card_heading: "Individuelle Gaming-PCs",
    pc_hub_card_subheading: "Baue deinen Traum-PC f\xfcr dein Budget und optimiert f\xfcr die Games, die du liebst.",
    kb_hub_card_heading: "Individuelle Tastaturen",
    kb_hub_card_subheading: "Erstelle eine individuelle Tastatur und Maus, die zu deinem Setup und Spielstil passen."
};
var de_keyboard = {
    keyboard_label: "Tastatur",
    keyboard_size: "Tastaturgr\xf6\xdfe",
    keyboard_base: "Tastatursockel",
    keyboard_primay_base_color: "Grundfarbe",
    keyboard_layout: "Tastaturlayout",
    keyboard_summary: "Zusammenfassung Tastatur",
    accent_keycaps: "Akzent-Tastenkappen",
    cabletype: "Accent Cable",
    additional_cable_color: "Kabel Farbe",
    cable: "Kabel",
    additional_cable: "Zus\xe4tzliches Kabel",
    primary_keycaps: "Base Keycaps",
    switches: "Switches",
    size: "Gr\xf6\xdfe",
    layout: "Layout",
    language: "Sprache",
    mouse_pad_label: "Mauspad",
    desk_mat_label: "Schreibtischunterlage",
    tools_label: "Werkzeuge",
    wrist_rest_label: "Handballenauflage",
    mouse_label: "Maus",
    cable_description: "Optionales farbiges Kabel. Ein standardm\xe4\xdfiges schwarzes 2-Meter-Kabel wird mitgeliefert.",
    cable_color_description: "Die Farbe des Premium-Kabels.",
    language_description: "Bestimmt die Position der Tasten Q, W, Z und A.",
    layout_description: "Bestimmt die Gr\xf6\xdfe und Position der Tasten.",
    keycap_accent_description: "Optionale Farbe f\xfcr Escape-, Enter-, Pfeil- und Numpad-Enter-Tasten.",
    primary_keycap_description: "PBT farbstoffsublimiert, Cherry Profil",
    switch_description: "Definiert das Tipperlebnis bei jedem Tastendruck.",
    keyboard_base_color_description: "Die Hauptfarbe des Tastatursockels.",
    keyboard_base_size_description: "Bestimmt die Anzahl der Tasten und die Gr\xf6\xdfe der Tastatur.",
    mouse_description: "Leichte beidh\xe4ndige Maus.",
    summary_description: "\xdcbersicht \xfcber deinen Tastatur-Build",
    premium_label: "Premium",
    base_label: "Basis",
    keyboard_warning: "Bitte w\xe4hle die folgenden Punkte aus, um mit deinem Build fortzufahren:",
    switch_reset_warning: "Ihre Schalter wurden zur\xfcckgesetzt. Bitte w\xe4hlen Sie neue Schalter aus.",
    keycap_reset_warning: "Ihre Tastenkappen wurden zur\xfcckgesetzt. Bitte w\xe4hlen Sie neue Tastenkappen.",
    base_type: "Art des Builds",
    build_type_description: "W\xe4hlen Sie die Art der Tastatur, die Sie konfigurieren m\xf6chten",
    full_custom_label: "vollst\xe4ndige Anpassung",
    barebones_disclaimer: "\xc4ndern Sie Ihre Art des Builds, um dieses Element auszuw\xe4hlen",
    none_label: "Keine"
};
var de_camCta = {
    cam_description: "Leistung, Temperaturen und Ger\xe4te mit einer einzigen Anwendung steuern.",
    cam_windows_10: "WINDOWS 10 64BIT"
};
var de_helpCta = {
    help_description: "Hol dir umfangreiche Anleitungen und Support f\xfcr alle deine NZXT Produkte sowie Unterst\xfctzung bei Garantief\xe4llen, R\xfccksendung und technischen Fragen"
};
var de_emailSignUp = {
    email_stay_in_touch: "Bleib auf dem Laufenden",
    email_sub_copy: "Erfahre zuerst von den neuesten Produkten, Angeboten und Neuigkeiten von NZXT",
    email_legal: "Mit deiner Anmeldung stimmst du den Nutzungsbedingungen f\xfcr NZXT, CAM und BLD zu. ",
    email_notify: "Benachrichtigt mich",
    email_notify_stock: "Lass dich benachrichtigen, wenn dieser Artikel verf\xfcgbar ist."
};
var de_generic = {
    explore: "Mehr Erfahren",
    cam_title: "NZXT CAM",
    free_download: "Kostenloser Download",
    details: "Details",
    help_amp_support: "Hilfe & Support",
    help_and_support: "Hilfe und Support",
    read_more: "Weiterlesen",
    privacy_policy: "Datenschutzrichtlinie",
    terms_conditions: "Gesch\xe4ftsbedingungen",
    and: "und",
    or: "oder",
    send: "senden",
    return_to: "zur\xfcckkehren zu",
    previous: "Zur\xfcck",
    next: "Weiter",
    home: "Home",
    keep_browsing: "Weiter st\xf6bern",
    create_build: "Erstelle deinen Build",
    learn_more: "Erfahre mehr",
    add_to_cart: "Zum Warenkorb hinzuf\xfcgen",
    share_build: "Build teilen",
    view: "Anzeigen",
    close: "Schlie\xdfen",
    price: "Preis",
    allow: "Erlauben",
    cancel: "Abbrechen",
    here: "Hier",
    ok: "OK",
    button_start_bld: "BLD starten",
    message_on_sale: "Angebot",
    button_buy: "Kaufen",
    button_start_build: "Build starten",
    view_build: "Build anzeigen",
    button_back: "Zur\xfcck",
    performance: "Leistung",
    build: "Bauen",
    error_generic: "Etwas ist falsch gelaufen. Bitte versuche es sp\xe4ter erneut.",
    label_support: "Hilfe",
    contact_support: "Kontaktiere den Support",
    browse_articles: "Artikel durchsuchen",
    search_support_articles: "Nach Hilfeartikeln suchen",
    message_error: "Ups, etwas ist schiefgelaufen",
    estimated_performance_label: "Gesch\xe4tzte Performance",
    see_estimated_performance_label: "Siehe gesch\xe4tzte Performance",
    estimated_fps: "Gesch\xe4tzte Bilder pro Sekunde (FPS)",
    title_related_items: "Dir k\xf6nnte auch gefallen",
    qty: "STK",
    category_from: "Von",
    reviews_label: "Bewertungen",
    message_invalid: "Momentan nicht verf\xfcgbar",
    message_out_of_stock: "Nicht auf Lager",
    message_low_stock: "Niedriger Bestand",
    message_best_seller: "Bestseller",
    message_coming_soon: "Bald verf\xfcgbar",
    message_new_item: "Neu",
    message_featured_items: "Ausgew\xe4hlte Produkte im Bild",
    message_unavailable: "Nicht verf\xfcgbar",
    message_colors: "Farben",
    message_color: "Farbe",
    label_return_policy: "R\xfccknahmegarantie",
    label_warranty_policy: "Garantiebestimmungen",
    label_shop: "Kaufen",
    label_days: "Tag",
    label_hours: "Stunden",
    label_minutes: "Minuten",
    label_seconds: "Sekunden",
    label_promotion: "Siehe Aktion",
    label_promotions: "Werbeaktionen",
    monthly_payments: "Monatliche Zahlungen verf\xfcgbar.",
    message_promotion: "F\xf6rderung",
    discount_label: "Rabatt",
    off_label: "Inaktiv",
    on_label: "Ein",
    choose_label: "W\xe4hlen Sie",
    move_to_previous_label: "Zur vorherigen Folie wechseln",
    move_to_next_label: "Zur n\xe4chsten Folie wechseln",
    active_slide_label: "Aktive Folie",
    move_to_inactive_slide: "Zur inaktiven Folie wechseln",
    color_options: "Farboptionen",
    of: "von",
    product_images: "Produktbilder",
    for: "f\xfcr",
    carousel: "Karussell",
    go_to_image: "Zum Bild gehen",
    button_label_add: "Hinzuf\xfcgen",
    button_label_remove: "Entfernen",
    increase_price_label: "Preis erh\xf6hen",
    decrease_price_label: "Senkung des Preises",
    select_video_label: "Video ausw\xe4hlen",
    play_label: "Spielen",
    pause_label: "Pause",
    buttons: "Buttons",
    open_modal_label: "Bildzoom-Modal \xf6ffnen",
    close_modal_label: "Bildzoom-Modal schlie\xdfen",
    image_zoom_modal: "Bildzoom-Modal",
    vr_ready_label: "VR Ready",
    vr_not_ready_label: "Nicht VR Ready",
    streaming_ready_label: "Stream Ready",
    streaming_not_ready_label: "Nicht Stream Ready",
    has_wifi_label: "Hat WiFi",
    no_wifi_label: "Kein WiFi",
    has_bluetooth_label: "Hat Bluetooth",
    no_bluetooth_label: "Kein Bluetooth",
    has_usbc_label: "Hat USB-C",
    no_usbc_label: "Kein USB-C",
    rgb_included_label: "Inklusive RGB-Beleuchtung",
    rgb_not_included_label: "RGB-Beleuchtung nicht inbegriffen",
    products_label: "Produkte",
    upsell_modal_label: "H\xe4ufig zusammen gekauft",
    no_thanks_label: "Nein danke",
    label_deal_ends: "Deal endet in",
    label_show_less: "Weniger anzeigen",
    label_show_more: "Mehr anzeigen",
    label_case: "Geh\xe4use",
    label_software: "Software",
    label_services: "Dienstleistungen",
    label_ram: "RAM",
    label_cpu: "CPU",
    label_gpu: "Grafikkarte",
    label_motherboard: "Motherboard",
    label_storage: "Speicher",
    label_cooling: "K\xfchlung",
    label_psu: "Netzteil",
    label_warranty: "Garantie",
    label_accessories: "Zubeh\xf6r",
    label_fps: "FPS",
    label_feature: "Feature"
};
var de_cart = {
    cart_heading: "Dein Warenkorb",
    cart_heading_empty: "Dein Warenkorb ist leer",
    cart_subheading_empty: "Finde Produkte, die du lieben wirst",
    cart_free_shipping_cta: "Nur noch 25 € bis zum kostenfreien Versand!",
    cart_free_shipping_exclusion: "(Schlie\xdft benutzerdefinierte und vorgefertigte PCs aus)",
    cart_free_shipping_promo_cta: "Kostenloser Versand f\xfcr alle Bestellungen",
    cart_heading_error: "Es ist ein Fehler aufgetreten. Bitte versuche es erneut.",
    cart_heading_success: "Vielen Dank!",
    cart_label_subtotal: "Zwischensumme",
    cart_label_taxes: "MwSt",
    cart_value_taxes: "Wird im n\xe4chsten Schritt berechnet",
    cart_label_shipping: "Versand",
    cart_value_shipping_free: "KOSTENLOS",
    cart_value_disclaimer: "*Neue und/oder \xfcberholte Produkte werden gegebenenfalls zu unterschiedlichen Zeiten bearbeitet und versendet.",
    cart_label_total: "Gesamt",
    cart_button_checkout: "Weiter zur Kasse",
    cart_terms_message: "Ich akzeptiere die",
    cart_terms_link_text: "Gesch\xe4ftsbedingungen",
    cart_value_taxes_non_us: "Inklusive",
    cart_value_shipping_calculated: "Wird im n\xe4chsten Schritt berechnet",
    cart_consent_i_have_read: "Ich habe die",
    cart_consent_privacy_policy: "Datenschutzbestimmungen",
    cart_consent_privacy_policy_after: "gelesen",
    cart_au_terms_message: "Ich akzeptiere die",
    cart_au_terms_link: "Nutzungsbedingungen",
    cart_au_consent_message: "Ich bin einverstanden, dass meine pers\xf6nlichen Daten gespeichert und in \xdcbereinstimmung mit den",
    cart_au_consent_link: "Datenschutzbestimmungen genutzt werden",
    cart_au_terms_text_1: "NZXT Pty Ltd (ABN 47 645 981 559) liefert die G\xfcter und Services, die du bestellt hast gem\xe4\xdf ihrer",
    cart_au_terms_text_terms_link: "Nutzungsbedingungen",
    cart_au_terms_text_2: "und speichert, verwendet und ver\xf6ffentlicht deine pers\xf6nlichen Informationen in \xdcbereinstimmung mit der",
    cart_au_terms_text_privacy_link: "Datenschutzerkl\xe4rung",
    cart_label_ssd: "SSD",
    cart_label_hdd: "HDD",
    cart_label_service: "Dienstleistungen",
    cart_label_software: "Software",
    cart_label_case: "Geh\xe4use",
    cart_label_motherboard: "Motherboard",
    cart_label_cpu: "CPU",
    cart_label_gpu: "Grafikkarte",
    cart_label_power_supply: "Netzteil",
    cart_label_cpu_cooler: "CPU K\xfchlung",
    cart_label_rgb: "RGB",
    cart_label_fans: "L\xfcfter",
    cart_label_ram: "RAM",
    cart_label_monitors: "Monitore",
    cart_label_peripherals: "Peripherieger\xe4te",
    cart_label_extras: "Extras",
    cart_label_keycaps: "Tastenkappen",
    cart_label_keycap_accents: "Tastenkappen-Akzente",
    cart_label_switches: "Schalter",
    cart_label_keyboard_base: "Tastaturbasis",
    cart_label_keycap_accent: "Akzent-Tastenkappen",
    cart_label_accent_cable: "Akzentkabel",
    cart_label_mouse: "Maus",
    cart_message_item_fallback: "Dieser Gegenstand",
    cart_message_build_item_oos_before: "Ein Artikel in deinem",
    cart_message_build_item_oos_after: "ist ausverkauft. Bitte klicken Sie hier, um Ihr Build zu aktualisieren und es in den Warenkorb zu legen.",
    cart_message_oos: "ist derzeit nicht auf Lager. Bitte entfernen Sie diesen Artikel, um zur Kasse zu gehen."
};
var de_category = {
    explore_builds: "Builds entdecken",
    explore_bulk: "Bulk entdecken",
    bulk: "Bulk",
    refurbished: "\xdcberholt",
    refurbished_cta: "Schau dir unser Angebot von \xfcberholten Builds und Komponenten an, die vollst\xe4ndig getestet und inspiziert wurden.",
    bulk_cta: "Wir bieten Builds in Gro\xdfmengen f\xfcr Gaming-Unternehmen, Universit\xe4ten, E-Sport-Organisationen und andere an.",
    explore_refurbished: "Builds entdecken"
};
var de_geoipBanner = {
    currently_browsing: "Gerade angesehen",
    banner_region_text: "Wechsle deine Region, um Produkte und spezielle Angebote in deinem Land zu sehen.",
    banner_button: "Wechseln zu",
    banner_country_text_shop: "Shop",
    banner_counrty_text: "oder w\xe4hlen Sie ein anderes Land f\xfcr Ihren Standort aus.",
    country_us: "Vereinigte Staaten",
    country_canada: "Kanada",
    country_belgium: "Belgien",
    country_germany: "Deutschland",
    country_luxembourg: "Luxemburg",
    country_netherlands: "Niederlande",
    country_austria: "\xd6sterreich",
    country_france: "Frankreich",
    country_italy: "Italien",
    country_spain: "Spanien",
    country_uk: "Vereinigtes K\xf6nigreich",
    country_australia: "Australien",
    country_nz: "Neuseeland",
    country_japan: "Japan",
    region_na: "Nordamerika",
    region_europe: "Europa",
    region_oceania: "Ozeanien"
};
var de_ui = {
    loading: "Laden"
};
var de_footer = {
    label_language: "Sprache",
    label_country: "Land",
    manage_cookie_preferences: "Cookie-Einstellungen verwalten",
    all_rights_reserved: "Alle Rechte vorbehalten"
};
var de_search = {
    label_suggested_queries: "Empfohlene Abfragen",
    label_suggested_results: "Empfohlene Ergebnisse",
    label_serp_heading: "Suchergebnisse f\xfcr",
    label_serp_not_found: "Keine Ergebnisse gefunden f\xfcr",
    label_serp_total: "Alle Ergebnisse",
    label_serp_suggested: "Suche lieber nach"
};
var de_about = {
    label_customer_support_hours: "Arbeitszeiten des Kunden-Support",
    label_headquarters: "Hauptsitz"
};
var de_product = {
    add_to_cart: "In den Warenkorb",
    overview: "\xdcbersicht",
    tech_specs: "Technische Daten",
    downloads: "Downloads",
    message_size: "Gr\xf6\xdfe",
    message_series: "Serie",
    message_invalid: "Momentan nicht verf\xfcgbar",
    message_out_of_stock: "Nicht auf Lager",
    message_low_stock: "Geringer Bestand",
    message_new_item: "Neu",
    message_coming_soon: "Bald verf\xfcgbar",
    message_unavailable: "Nicht verf\xfcgbar",
    title_highlights: "Highlights",
    title_shipping: "Versand",
    title_in_the_box: "Lieferumfang",
    title_related_items: "Das k\xf6nnte dir auch gefallen",
    button_buy_now: "Jetzt kaufen",
    message_colors: "Farben",
    message_color: "Farbe",
    overview_anchor: "\xdcbersicht",
    tech_specs_anchor: "Technische Daten",
    downloads_anchor: "Downloads",
    related_anchor: "\xc4hnliche Produkte",
    customize_build_header: "Anpassen",
    customize_build_subheader: "Starte einen Build mit diesem Produkt",
    customize_kb_build_subheader: "Erstellen einer eigenen Tastatur",
    buy_product_header: "DIY",
    buy_product_subheader: "Tr\xe4um davon. Builde es. Tu es.",
    buy_label: "Kaufen",
    retailers_subheader: "Kauf bei unseren Partnern.",
    link_all_retailers: "Alle H\xe4ndler anzeigen",
    series_label: "Serie",
    label_header_bundle: "Zusammen kaufen",
    label_subheader_bundle: "Bringen Sie Ihren Build mit von Experten empfohlenen Produkten auf die n\xe4chste Stufe",
    help_button_label: "Jetzt chatten",
    help_button_heading: "Hast du Fragen?",
    help_button_subheading: "Unsere Experten sind bereit zu helfen.",
    configure_label: "Konfigurieren",
    documentation_label: "Dokumente",
    drivers_label: "Treiber",
    miscellaneous_label: "Sonstiges",
    resources_label: "Ressourcen",
    everything_you_need_label: "Everything you need",
    good_rating_label: "Gut",
    better_rating_label: "Besser",
    best_rating_label: "Am Besten",
    key_specs_label: "Spezifikationen"
};
var de_collection = {
    message_invalid: "Momentan nicht verf\xfcgbar",
    message_out_of_stock: "Nicht auf Lager",
    message_low_stock: "Geringer Bestand",
    message_unavailable: "Nicht verf\xfcgbar",
    message_new_item: "Neu",
    message_coming_soon: "Bald verf\xfcgbar",
    button_buy_now: "Jetzt kaufen",
    message_colors: "Farben",
    learn_more: "Mehr erfahren",
    label_show_less: "Weniger anzeigen",
    label_show_more: "Mehr anzeigen",
    help_button_label: "Jetzt chatten",
    help_button_heading: "Hast du Fragen?",
    help_button_subheading: "Unsere Experten sind bereit zu helfen."
};
var de_news = {
    label_all_news: "Alle Neuigkeiten"
};
var de_retailers = {
    label_regions: "Regionen",
    label_locations: "Orte",
    label_reseller_type: "Typ",
    option_label_all_regions: "Alle Regionen",
    option_label_all_locations: "Alle Orte",
    option_label_all_reseller_type: "Alle Optionen",
    message_empty_state: "Kein Einzelh\xe4ndler erf\xfcllt die ausgew\xe4hlten Kriterien.",
    hero_text: "NZXT-Produkte sind \xfcber unsere Partner in allen Regionen erh\xe4ltlich"
};
var de_searchResults = {
    message_invalid: "Momentan nicht verf\xfcgbar",
    message_out_of_stock: "Nicht auf Lager",
    message_low_stock: "Geringer Bestand",
    message_unavailable: "Nicht verf\xfcgbar",
    message_coming_soon: "Bald verf\xfcgbar"
};
var de_orderTracking = {
    title_order_status: "Bestellstatus",
    label_cancelled_on: "Storniert am",
    label_shipping_date: "Voraussichtliches Versanddatum",
    label_case: "Geh\xe4use",
    label_software: "Software",
    label_services: "Service",
    label_ram: "RAM",
    label_cpu: "CPU",
    label_gpu: "Grafikkarte",
    label_motherboard: "Motherboard",
    label_storage: "Speicher",
    label_cooling: "K\xfchlung",
    label_psu: "Netzteil"
};
var de_orderTrackingRoot = {
    title_order_tracking_root: "Gib deine Bestellnummer ein",
    label_build_id: "Auftragsnummer",
    button_track: "Bestellung verfolgen",
    message_not_found: "nicht gefunden, bitte versuche es erneut"
};
var de_refurb = {
    label_all_products: "Alle Produkte",
    label_relevance: "Relevanz",
    label_price_low_high: "Preis aufsteigend",
    label_price_high_low: "Preis absteigend",
    label_name_a_z: "Name A-Z",
    label_name_z_a: "Name Z-A",
    label_case: "Geh\xe4use",
    label_software: "Software",
    label_services: "Service",
    label_ram: "RAM",
    label_cpu: "CPU",
    label_gpu: "Grafikkarte",
    label_motherboard: "Motherboard",
    label_storage: "Speicher",
    label_cooling: "K\xfchlung",
    label_psu: "Netzteil",
    label_other: "Sonstiges",
    label_accessories: "Zubeh\xf6r",
    label_fan: "L\xfcfter",
    label_any_price: "Jeder Preis",
    label_no_products: "Derzeit sind keine \xfcberholten Bauteile verf\xfcgbar.",
    label_no_builds: "Derzeit sind keine \xfcberholten Builds verf\xfcgbar."
};
var de_orderStatus = {
    confirmed_title: "Bestellung aufgegeben",
    step_label: "Schritt",
    confirmed_sub: "Deine Bestellung ist eingegangen.",
    processed_title: "Bestellung best\xe4tigt",
    processed_sub: "Deine Bestellung ist eingegangen und deine Zahlung wurde verarbeitet.",
    in_progress_title: "In Bearbeitung",
    in_progress_sub: "Die Kommissionierung und Montage f\xfcr deine Bestellung hat begonnen. Deine Bestellung ist nun gesperrt und \xc4nderungen/Stornierungen k\xf6nnen nicht mehr garantiert werden.",
    shipped_title: "Versand",
    shipped_sub: "Deine Bestellung ist unterwegs!",
    cancelled_title: "Abgesagt",
    cancelled_sub: "Ihre Bestellung wurde erfolgreich storniert.",
    enh_ordered_sub: "Ihre Bestellung ist eingegangen und befindet sich in der Warteschlange.",
    enh_picking_title_bld: "Build vorbereiten",
    enh_picking_title: "Bearbeitung Ihrer Bestellung",
    enh_picking_sub_bld: "Die Kommissionierung & Montage f\xfcr Ihre Bestellung hat begonnen. \xc4nderungen an Ihrer Bestellung k\xf6nnen nicht garantiert werden.",
    enh_picking_sub: "Wir bereiten Ihre Bestellung vor. \xc4nderungen an Ihrer Bestellung k\xf6nnen nicht garantiert werden.",
    enh_build_title: "Geb\xe4ude",
    enh_build_sub: "Ihre Bestellung wird gebaut und getestet.",
    enh_packing_title: "Vorbereiten, um zu versenden",
    enh_packing_sub_bld: "Ihre Bestellung wurde erstellt und getestet. Es wird f\xfcr die Lieferung verpackt.",
    enh_packing_sub: "Ihre Bestellung wurde bearbeitet und wird f\xfcr die Lieferung verpackt.",
    enh_shipping_title: "Versand",
    enh_shipping_sub: "Ihre Bestellung wurde zur Lieferung an das Versandunternehmen gesendet. Ihre Tracking-Nummer wird aktualisiert und Ihnen innerhalb von 1 Werktag per E-Mail zugesendet."
};
var de_universal = (0,_object_spread/* default */.Z)({}, de_cart, de_userAccount, de_auth, de_formErrors, de_camCta, de_generic, de_helpCta, de_emailSignUp, de_geoipBanner, de_ui, de_footer, de_search, de_about, de_orderStatus);
// eslint-disable-next-line import/prefer-default-export
var de = {
    "/": (0,_object_spread/* default */.Z)({}, de_universal),
    "/product/[slug]": (0,_object_spread/* default */.Z)({}, de_product, de_universal),
    "/collection/[slug]": (0,_object_spread/* default */.Z)({}, de_collection, de_universal),
    "/partner/[slug]": (0,_object_spread/* default */.Z)({}, de_collection, de_universal),
    "/sale/[slug]": (0,_object_spread/* default */.Z)({}, de_collection, de_universal),
    "/about": (0,_object_spread/* default */.Z)({}, de_about, de_universal),
    "/about/[slug]": (0,_object_spread/* default */.Z)({}, de_about, de_universal),
    "/legal": (0,_object_spread/* default */.Z)({}, de_universal),
    "/legal/[slug]": (0,_object_spread/* default */.Z)({}, de_universal),
    "/news/[slug]": (0,_object_spread/* default */.Z)({}, de_news, de_universal, de_category),
    "/news/page/[page]": (0,_object_spread/* default */.Z)({}, de_universal, de_category),
    "/news/category/[category]": (0,_object_spread/* default */.Z)({}, de_universal, de_category),
    "/news/category/[category]/page/[page]": (0,_object_spread/* default */.Z)({}, de_universal, de_category),
    "/user/[slug]": (0,_object_spread/* default */.Z)({}, de_universal, de_build, de_keyboard),
    "/software/[slug]": (0,_object_spread/* default */.Z)({}, de_universal),
    "/category/[slug]": (0,_object_spread/* default */.Z)({}, de_category, de_universal),
    "/category/[slug]/[subcategory-slug]": (0,_object_spread/* default */.Z)({}, de_category, de_universal),
    "/build": (0,_object_spread/* default */.Z)({}, de_universal, de_build),
    "/build/[slug]": (0,_object_spread/* default */.Z)({}, de_universal, de_build),
    "/build/pc": (0,_object_spread/* default */.Z)({}, de_universal, de_build),
    "/build/pc/[slug]": (0,_object_spread/* default */.Z)({}, de_universal, de_build),
    "/build/[slug]/summary": (0,_object_spread/* default */.Z)({}, de_universal, de_build),
    "/build/keyboard/[slug]": (0,_object_spread/* default */.Z)({}, de_universal, de_build, de_keyboard),
    "/support": (0,_object_spread/* default */.Z)({}, de_universal),
    "/refurbished/[slug]": (0,_object_spread/* default */.Z)({}, de_universal, de_refurb),
    "/careers": (0,_object_spread/* default */.Z)({}, de_universal),
    "/reviews/page/[page]": (0,_object_spread/* default */.Z)({}, de_universal),
    "/careers/available-positions": (0,_object_spread/* default */.Z)({}, de_universal),
    "/order-tracking/[slug]": (0,_object_spread/* default */.Z)({}, de_orderTracking, de_orderTrackingRoot, de_universal),
    "/order-tracking": (0,_object_spread/* default */.Z)({}, de_orderTrackingRoot, de_universal),
    "/retailers": (0,_object_spread/* default */.Z)({}, de_retailers, de_universal),
    "/search": (0,_object_spread/* default */.Z)({}, de_searchResults, de_universal),
    "/auth/[slug]": (0,_object_spread/* default */.Z)({}, de_universal),
    universal: de_universal
};

;// CONCATENATED MODULE: ./locale/nl.ts
/* eslint-disable max-len */ 
var nl_userAccount = {
    user_settings_title: "Account",
    user_settings_change_password: "Wijzig wachtwoord",
    user_settings_save: "Opslaan",
    user_settings_cancel: "Annuleren",
    user_profile_heading: "Profiel",
    user_saved_builds_heading: "Opgeslagen samenstellingen",
    user_saved_builds_bld_name: "Build naam",
    user_saved_builds_bld_date: "Aanmaakdatum",
    user_saved_builds_bld_item_part: "Deel",
    user_saved_builds_delete_bld: "Verwijder BLD",
    user_saved_builds_resume_bld: "Hervat BLD",
    user_saved_builds_hero_title: "Ontworpen om te pronken met je build",
    user_saved_builds_hero_text: "Het compacte verticale ontwerp behoudt ondersteuning voor de meeste full-size GPU's op de markt, zodat je jouw bureau kunt behouden zonder in te boeten aan grafische kracht.",
    user_saved_builds_pc_heading: "PC Gebouwen",
    user_saved_builds_keyboard_heading: "Toetsenbord Bouwt",
    user_saved_builds_view_pc: "PC-bouwsels bekijken",
    user_saved_builds_view_keyboard: "Toetsenbordbouwsels bekijken",
    user_saved_builds_no_pc: "U heeft geen opgeslagen PC Builds",
    user_saved_builds_no_kb: "U heeft geen opgeslagen Keyboard Builds",
    user_order_history_heading: "Bestelgeschiedenis",
    user_order_history_date: "Datum",
    user_order_history_order_number: "Bestelnummer",
    user_order_history_status: "Status",
    user_order_history_amount: "Hoeveelheid",
    user_order_history_view: "Bekijk bon",
    user_order_history_empty_view: "Je hebt geen bestelgeschiedenis.",
    user_order_history_shipping: "Verzendadres",
    user_order_history_billing: "Factuur Adres",
    user_order_history_item: "Artikel",
    user_order_history_order: "Bestellen #",
    user_order_history_item_image: "Item afbeelding",
    user_order_history_quantity: "Hoeveelheid",
    user_support_heading: "Support + Retourneringen",
    user_data_heading: "Data verzoek",
    user_terms_heading: "Voorwaarden",
    user_terms_empty: "Je hebt nog geen ondertekende voorwaarden.",
    user_support_subject_min_length: "Het onderwerp moet langer zijn dan 3 tekens",
    user_support_message_placeholder: "Geef de redenen voor contact op. Vermeld bij retournering het bestelnummer",
    user_support_update_button: "Update",
    user_active_tickets_heading: "Actieve tickets",
    user_active_tickets_chat: "Voeg een bericht toe",
    user_active_tickets_no_chat_history: "Je hebt geen chatgeschiedenis",
    view_chat_button: "Bekijk chat",
    close_chat_button: "Sluit chat",
    field_required_message: "dit veld is verplicht",
    label_accept: "Aanvaarden",
    label_reason_for_contact: "Reden voor contact",
    label_country: "Land",
    label_subject: "Onderwerpen",
    label_product: "Product",
    label_message: "Bericht",
    label_requestor_type: "Type aanvrager",
    label_country_of_residence: "Het land waar je woont",
    label_description: "Omschrijving",
    placeholder_description: "Beschrijving van jouw verzoek",
    label_submit: "Verzenden",
    message_no_support_requests: "Je hebt geen actieve ondersteuningsverzoeken",
    label_ticket_number: "Ticket nummer",
    label_date_created: "Datum gecree\xebrd",
    label_status: "Status",
    label_department: "Afdeling",
    subheading_active_ticket: "Als je hulp nodig hebt of een artikel wilt retourneren, neem dan contact op met onze support.",
    label_create_support_request: "Maak een supportsverzoek",
    button_comment: "Comment",
    label_for_myself: "Voor mezelf",
    label_parent: "Ouder",
    label_legal_rep: "Wettelijke vertegenwoordiger",
    label_relative: "Familielid",
    label_guardian: "Voogd",
    label_accept_generic_terms: "Ik heb deze voorwaarden gelezen en accepteer deze",
    error_view_message: "Oeps, er is iets misgegaan.",
    signout_view_message: "Je bent uitgelogd.",
    user_order_history_close: "Sluiten",
    birthday_error_message: "Voer een geldige geboortedatum in",
    label_view_saved: "Bekijk alle opgeslagen builds"
};
var nl_formErrors = {
    invalid_email: "Voer een geldig e-mailadres in",
    username_full_pattern_message: "De gebruikersnaam moet 6 tot 30 tekens lang zijn. U kunt letters, cijfers en punten gebruiken, maar mogen geen opeenvolgende punten beginnen, eindigen of bevatten.",
    password_pattern_message: "Wachtwoord moet minimaal zes tekens, \xe9\xe9n hoofdletter, \xe9\xe9n kleine letter en \xe9\xe9n cijfer bevatten",
    username_min_length_message: "Gebruik minimaal 6 tekens voor je gebruikersnaam",
    passwords_must_match: "Wachtwoorden moeten overeenkomen",
    invalid_current_password: "Kan het wachtwoord niet bijwerken. De waarde die is opgegeven als het huidige wachtwoord is onjuist",
    must_accept_partner_program_terms: "U moet de voorwaarden van het partnerprogramma accepteren om een ​​NZXT-partner te worden",
    must_accept_tos_terms: "Je moet de Servicevoorwaarden accepteren om een NZXT-account aan te maken",
    must_accept_generic_terms: "U moet akkoord gaan met deze voorwaarden"
};
var nl_auth = {
    user_auth_agreement: "Ik accepteer NZXT's",
    user_auth_privacy_policy: "privacybeleid",
    user_auth_and: "en heb de",
    user_auth_terms: "de algemene voorwaarden gelezen",
    error_invalid_request: "Ongeldig verzoek.",
    error_invalid_token: "Ongeldig token voor gebruikersverificatie",
    error_session_expired: "Jouw sessie is verlopen. Log opnieuw in om door te gaan.",
    user_forgot_required_email: "E-mailadres is vereist",
    user_forgot_success_message: "Bedankt! Als er een account aan deze e-mail is gekoppeld, sturen we de instructies voor het opnieuw instellen van het wachtwoord onmiddellijk.",
    error_email_exists: "De e-mail is al in gebruik",
    user_email_verification_heading: "email verificatie",
    error_email_not_verified: "Het e-mailadres is nog niet geverifieerd. Om de verificatie-e-mail opnieuw te verzenden, klikt u op",
    error_email_already_verified: "Het e-mailadres is al geverifieerd. Ga verder met inloggen.",
    user_email_verification_success_message: "Uw e-mailadres is succesvol geverifieerd!. Ga verder met inloggen.",
    error_username_unavailable: "De gebruikersnaam is niet beschikbaar",
    error_reset_password_same_as_old_password: "Dit wachtwoord is hetzelfde als voorheen. Selecteer een andere.",
    error_reset_password_link_expired: "De link om jouw wachtwoord opnieuw in te stellen is verlopen.",
    error_reset_password_link_invalid: "De link om jouw wachtwoord opnieuw in te stellen is ongeldig.",
    user_forgot_password_subheading: "Voer jouw e-mailadres in om instructies te ontvangen om jouw wachtwoord opnieuw in te stellen.",
    user_reset_password_heading: "Stel je wachtwoord opnieuw in",
    user_reset_password_subheading: "Voer een nieuw wachtwoord in.",
    user_reset_password: "Wachtwoord opnieuw instellen",
    user_reset_success_message: "Je hebt je wachtwoord succesvol gereset!",
    user_login_text: "Registreren met Google",
    user_login_remember: "Onthoud mij",
    user_login_forgot_password: "Wachtwoord vergeten?",
    user_login_wrong_email_or_password: "Verkeerd e-mailadres of wachtwoord",
    user_login_success_message: "Je bent succesvol ingelogd!",
    error_too_many_requests: "Je hebt te veel verzoeken gedaan. Wacht een paar minuten of neem contact op met de support",
    error_user_not_found: "Gebruiker is niet gevonden",
    user_sign_in_sign_up: "Aanmelden / Registreren",
    user_sign_out: "Afmelden",
    user_sign_in: "Aanmelden",
    user_account_updates: "NZXT-updates",
    user_account_no_updates: "Geen recente updates, kom later terug.",
    support_center_link: "Help & Support",
    error_google_account_exists: "Je hebt al een account aangemaakt met Google.",
    error_local_account_exists: "Het lijkt erop dat je al een account hebt.",
    user_sign_up: "Registreren",
    user_sign_up_text: "Registreren met Google",
    user_sign_up_opt_in: "Meld je aan om via e-mail updates van NZXT te ontvangen over producten, BLD en CAM",
    user_sign_up_check_email_message: "Controleer je e-mail en klik op de link om je account te activeren.",
    user_sign_up_success_verify_message: "Het account blijft inactief totdat het geverifieerd is. Kijk in je spammap als je niet binnen enkele minuten een e-mail ontvangt.",
    user_info_updated_success_message: "Jouw gegevens zijn succesvol bijgewerkt!",
    user_info_newsletter_confirmation_message: "Controleer je e-mail voor de bevestiging.",
    user_email_sign_in: "Of ga door met",
    user_no_account: "Geen lid?",
    user_create_account: "Account aanmaken",
    user_email_sign_up_text: "Of meld je aan met",
    user_have_account: "Heb je al een account?",
    open_login_view: "Open inlogscherm",
    error_newsletter_subscription: "Kan momenteel niet in- / uitschrijven voor de nieuwsbrief. Probeer het later nog eens.",
    user_login_too_many_requests: "Je hebt te veel aanvragen ingediend. Wacht enkele minuten of neem contact op met de support",
    label_email_address: "E-mailadres",
    label_password: "Wachtwoord",
    label_current_password: "huidig ​​wachtwoord",
    label_confirm_password: "bevestig wachtwoord",
    label_new_password: "nieuw paswoord",
    label_confirm_new_password: "Bevestig nieuw wachtwoord",
    label_username: "gebruikersnaam",
    label_first_name: "Voornaam",
    label_last_name: "Achternaam",
    label_preferred_pronouns: "Geprefereerde voornaamwoorden",
    label_search_for_help_articles: "Help-artikelen zoeken",
    label_birthday: "Verjaardag",
    label_location: "Plaats",
    app_access: "wil toegang tot je NZXT-account om toegang te krijgen tot:",
    app_access_has_scopes: "wil toegang tot je NZXT account",
    scope_profile: "je profiel, naam en foto",
    scope_email: "je e-mailadres",
    scope_address: "Uw fysieke adres",
    scope_phone: "Jouw telefoon nummer",
    grant_offline_access: "Offline toegang hebben",
    grant_offline_access_previous: "die je eerder hebt verleend"
};
var nl_build = {
    custom_bld_modal_heading: "Bouw jouw PC",
    custom_bld_modal_subheading: "Selecteer jouw chipset en budget",
    custom_bld_unavailable: "Selecteer een item",
    custom_bld_issue: "De volgende items moeten worden opgelost: ",
    custom_bld_title: "Aangepaste BLD",
    custom_bld_lets_get_started: "Aan de slag",
    custom_bld_destrutive_action: "Waarschuwing: Reset samenstelling",
    custom_bld_confirm_reset: "Je samenstelling wordt gereset met de volgende chipset:",
    custom_bld_keyboard_confirm_reset: "Uw bouw zal worden gereset met deze verandering",
    custom_bld_choose_chipset: "Kies je chipset",
    custom_bld_chipset: "Chipset",
    custom_bld_intel: "Intel",
    custom_bld_amd: "AMD",
    custom_bld_explore: "Ontdekken",
    custom_bld_select: "Selecteren",
    review_bld_button: "Bekijk BLD",
    custom_bld_summary: "Overzicht",
    custom_bld_budget: "Budget",
    custom_bld_specs: "Specificaties",
    custom_bld_case: "Behuizing",
    custom_bld_cases: "Behuizingen",
    custom_bld_caseCooling: "Koeling",
    custom_bld_fans: "Ventilatoren",
    custom_bld_cpu: "CPU",
    custom_bld_gpu: "GPU",
    custom_bld_ram: "RAM",
    custom_bld_ssd: "SSD",
    custom_bld_hdd: "HDD",
    custom_bld_specials: "Specials",
    custom_bld_colors: "Kleuren",
    custom_bld_color: "Kleur",
    custom_bld_black: "Zwart",
    custom_bld_red: "Rood",
    custom_bld_white: "Wit",
    custom_bld_grey: "Grijs",
    custom_bld_blue: "Blauw",
    custom_bld_purple: "Paars",
    custom_bld_yellow: "Geel",
    custom_bld_audio: "Audio",
    custom_bld_extras: "Extra's",
    custom_bld_core: "Core",
    custom_bld_motherboard: "Moederbord",
    custom_bld_motherboards: "Moederborden",
    custom_bld_powerSupplies: "Voedingen",
    custom_bld_powerSupply: "Voeding",
    custom_bld_services: "Services",
    custom_bld_software: "Software",
    custom_bld_monitors: "Beeldschermen",
    custom_bld_peripherals: "Randapparatuur",
    custom_bld_lighting: "Verlichting",
    custom_bld_headset: "Headset",
    custom_bld_keyboard: "Toetsenbord",
    custom_bld_all: "All",
    custom_bld_mouse: "Muis",
    custom_bld_storage: "Opslag",
    custom_bld_streaming_ready: "Stream Ready",
    custom_bld_rgb_lighting: "RGB-verlichting",
    custom_bld_vr_ready: "VR Ready",
    custom_bld_wifi: "Wifi",
    custom_bld_from: "Van",
    custom_bld_bluetooth: "Bluetooth",
    custom_bld_save_build_message: "Je build is succesvol opgeslagen! Je kunt het bekijken in 'Opgeslagen builds' in jouw account.",
    custom_bld_save_modal_message: "Wil je deze build opslaan voor later?",
    custom_bld_confirm_save_modal_message: "Je verliest niet-opgeslagen wijzigingen door deze pagina te verlaten.",
    custom_bld_share_build_message: "Je build is succesvol opgeslagen en gekopieerd!",
    help_me_decide: "Help mij kiezen",
    save_build: "Samenstelling opslaan",
    start_over: "Opnieuw beginnen",
    summary: "Samenvatting",
    build_summary: "Build Samenvatting",
    load_build: "Samenstelling laden",
    est_shipping: "Geschatte datum van verzending",
    add_to_build: "Toevoegen aan samenstelling",
    message_best_seller: "Bestseller",
    message_invalid: "Tijdelijk niet verkrijgbaar",
    message_out_of_stock: "Niet op voorraad",
    message_low_stock: "Beperkte voorraad beschikbaar",
    message_new_item: "Nieuw",
    message_coming_soon: "Binnenkort beschikbaar",
    message_is_locked: "Niet Compatibel",
    load: "Laden",
    save: "Opslaan",
    restart: "Herstarten",
    share: "Delen",
    my_build_label: "Mijn build",
    button_label_select: "Selecteren",
    button_label_selected: "Geselecteerd",
    button_label_add: "Toevoegen",
    button_label_added: "Toegevoegd",
    button_label_update: "Update",
    button_label_remove: "Verwijderen",
    button_label_info: "Info",
    button_label_more_info: "Meer info",
    button_label_options_info: "Opties & info",
    button_label_continue_to: "Doorgaan met bouwen",
    button_label_edit: "Bewerken",
    build_fps_label: "FPS wordt gemeten bij een resolutie van 2560 x 1440 met de hoogste grafische settings van de game",
    build_includes: "Omvat",
    custom_bld_boost: "Boost je Build",
    custom_bld_fps_unavailable: "In afwachting",
    custom_bld_amd_help: "Intel gebaseerde pc's zijn de afgelopen jaren de norm geweest maar AMD-pc's zijn tegenwoordig ook geweldig om mee te gamen. We helpen hebben systemen voor beide processoren en kiezen altijd voor moederborden en koelers die goet samenwerken. Zodat jij je geen zorgen hoeft te maken. We raden wel aan om een balans te zoeken met de FPS-prestaties die je zoekt en het budget wat je uit wilt geven.",
    custom_bld_to_see_this: "Om deze selectie te zien, moet je",
    custom_bld_change_chipset: "jouw selectie wijzigen.",
    performance: "Prestaties",
    message_error: "Oeps, er is iets misgegaan",
    custom_bld_prebuild_upsell: "Of kies snel en gemakkelijk \xe9\xe9n van onze prebuilds",
    no_item_selected: "Geen Item Geselecteerd",
    build_change_label: "Build Gewijzigd",
    invalid_action_label: "Voorkomen",
    success_label: "Succes",
    build_info_message: "Info",
    reset_label: "Build Reset",
    complete_build_label: "Voltooi je Build",
    back_to_build_label: "Terug Naar Je Build",
    complete_build_sub_label: "Extra's en Randapparatuur",
    back_to_build_sub_label: "Kerncomponenten van jouw build",
    capacity_label: "Capaciteit",
    option_label: "Optie",
    options_label: "Opties",
    max_speed: "Maximale snelheid",
    modular_label: "Modulair",
    midtower_label: "Miditower",
    streaming_label: "Streaming",
    save_and_exit: "Opslaan en afsluiten",
    exit: "Exit",
    view_cart_label: "Winkelmandje",
    cart_subtotal_label: "Winkelwagen Subtotaal",
    start_build_label: "Start bouwen",
    new_build_label: "Start met Bouwen",
    continue_saved_build_label: "Ga verder met je opgeslagen bouw",
    continue_progress_build_label: "Ga verder met jouw vorige build",
    continue_cart_build_label: "Controleer de build in uw winkelwagen",
    core_label: "Basis",
    extras_label: "Uitbreidingen",
    summary_label: "Samenvatting",
    share_build_pc: "Op maat gemaakte PC",
    share_build_kb: "Op maat gemaakt toetsenbord",
    build_summary_label: "Overzicht van je toetsenbord-build.",
    pc_hub_card_heading: "Aangepaste Gaming PC's",
    pc_hub_card_subheading: "Bouw jouw droom-PC rond jouw budget en geoptimaliseerd voor de games waar jij van houdt.",
    kb_hub_card_heading: "Aangepaste toetsenborden",
    kb_hub_card_subheading: "Stel een toetsenbord en muis samen die bij jouw ruimte en gamestijl passen."
};
var nl_keyboard = {
    keyboard_label: "Toetsenbord",
    keyboard_size: "Toetsenbordgrootte",
    keyboard_base: "Toetsenbordbasis",
    keyboard_primay_base_color: "Basis Kleur",
    keyboard_layout: "Toetsenbordindeling",
    keyboard_summary: "Toetsenbordoverzicht",
    accent_keycaps: "Accent Keycaps",
    cabletype: "Accent Cable",
    additional_cable_color: "Kabel Kleur",
    cable: "Cable",
    additional_cable: "Extra kabe",
    primary_keycaps: "Basis Keycaps",
    switches: "Switches",
    size: "Grootte",
    layout: "Layout",
    language: "Taal",
    mouse_pad_label: "Muismat",
    desk_mat_label: "Mousepad",
    tools_label: "Hulpmiddelen",
    mouse_label: "Mouse",
    wrist_rest_label: "Polssteun",
    cable_description: "Optionele gekleurde kabel. Een standaard zwarte kabel van 2 meter wordt meegeleverd.",
    cable_color_description: "De kleur van de premiumkabel.",
    language_description: "Bepaalt de positie van de Q, W, Z en A toetsen. ",
    layout_description: "Bepaalt de grootte en positie van de toetsen.",
    keycap_accent_description: "Optionele kleur voor Escape, Enter, Pijl, en Numpad Enter toetsen.",
    primary_keycap_description: "PBT dye-sublimated, Cherry profiel.",
    switch_description: "Bepaalt de type-ervaring van elke toetsaanslag.",
    keyboard_base_color_description: "De hoofdkleur van de toetsenbordbasis.",
    keyboard_base_size_description: "Bepaalt het aantal toetsen en de afmeting van het toetsenbord.",
    mouse_description: "Lichtgewicht muis voor links- en rechtshandig gebruik.",
    summary_description: "Overzicht van je toetsenbord-build",
    premium_label: "Premium",
    base_label: "Basis",
    keyboard_warning: "Selecteer de volgende items om verder te gaan met uw bouw:",
    switch_reset_warning: "Uw schakelaars zijn gereset. Gelieve nieuwe schakelaars te kiezen.",
    keycap_reset_warning: "Uw keycaps zijn gereset. Kies alstublieft nieuwe keycaps.",
    base_type: "Build type",
    build_type_description: "Selecteer het type toetsenbord dat u wilt configureren",
    full_custom_label: "Volledig custom",
    barebones_disclaimer: "Verander je Build type om dit item te selecteren",
    none_label: "Geen"
};
var nl_camCta = {
    cam_description: "Beheer prestaties, temperaturen en apparaten met \xe9\xe9n applicatie.",
    cam_windows_10: "WINDOWS 10 64BIT"
};
var nl_helpCta = {
    help_description: "Krijg uitgebreide begeleiding en support voor al je NZXT-producten en hulp bij garanties, retourneringen en technische zaken."
};
var nl_emailSignUp = {
    email_stay_in_touch: "Blijf op de hoogte",
    email_sub_copy: "Blijf op de hoogte van de nieuwste releases, aanbiedingen en nieuws van NZXT.",
    email_legal: "Door te registreren, ga je akkoord met NZXT, CAM en BLD's",
    email_notify: "Geef mij een seintje",
    email_notify_stock: "Ontvang een melding wanneer dit item beschikbaar is.",
    estimated_performance_label: "Geschatte FPS",
    see_estimated_performance_label: "Zie Geschatte FPS"
};
var nl_generic = {
    explore: "Ontdek",
    cam_title: "NZXT CAM",
    free_download: "Gratis download",
    details: "Details",
    help_amp_support: "Help & support",
    help_and_support: "Help en support",
    read_more: "Meer info",
    privacy_policy: "Privacybeleid",
    terms_conditions: "Algemene voorwaarden",
    and: "en",
    or: "of",
    send: "sturen",
    return_to: "terug keren naar",
    previous: "Vorige",
    next: "Volgende",
    home: "Start",
    keep_browsing: "Verder browsen",
    create_build: "Samenstelling maken",
    learn_more: "Meer informatie",
    add_to_cart: "Toevoegen aan winkelwagen",
    share_build: "Samenstelling delen",
    view: "Bekijken",
    close: "Sluiten",
    price: "Prijs",
    allow: "Toestaan",
    cancel: "Annuleren",
    here: "hier",
    ok: "Ok",
    button_start_bld: "Start BLD",
    message_on_sale: "In de aanbieding",
    button_buy: "Kopen",
    button_start_build: "Samenstelling starten",
    view_build: "Samenstelling bekijken",
    button_back: "Terug",
    performance: "Prestatie",
    build: "Bouwen",
    error_generic: "Er is iets misgegaan. Probeer het later opnieuw.",
    label_support: "Support",
    contact_support: "Contact opnemen",
    browse_articles: "Blader Door Artikelen",
    search_support_articles: "Zoek naar helpartikelen",
    message_error: "Uh-oh, het ziet eruit als er iets mis is",
    estimated_performance_label: "Geschatte FPS",
    see_estimated_performance_label: "Zie Geschatte FPS",
    estimated_fps: "Estimated Frames per second (FPS)",
    title_related_items: "Dit vind je misschien ook leuk",
    qty: "QTY",
    category_from: "Van",
    reviews_label: "Beoordelingen",
    message_best_seller: "Bestseller",
    message_invalid: "Tijdelijk niet verkrijgbaar",
    message_out_of_stock: "Niet op voorraad",
    message_low_stock: "Beperkte voorraad beschikbaar",
    message_new_item: "Nieuw",
    message_coming_soon: "Binnenkort beschikbaar",
    message_featured_items: "Aanbevolen producten in afbeelding",
    message_unavailable: "Niet beschikbaar",
    message_colors: "Kleuren",
    message_color: "Kleur",
    label_return_policy: "TERUGSTUURBELEID",
    label_warranty_policy: "Garantie beleid",
    label_shop: "Koop nu",
    label_days: "Dagen",
    label_hours: "Uren",
    label_minutes: "Minuten",
    label_seconds: "Seconden",
    label_promotion: "Zie Promotie",
    label_promotions: "Promoties",
    monthly_payments: "Maandelijkse betalingen beschikbaar.",
    message_promotion: "Promotie",
    discount_label: "korting",
    off_label: "Inactief",
    on_label: "Aan",
    choose_label: "Kies",
    move_to_previous_label: "Ga naar vorige dia",
    move_to_next_label: "Ga naar de volgende dia",
    active_slide_label: "Actieve dia",
    move_to_inactive_slide: "Ga naar inactieve dia",
    color_options: "Kleur Opties",
    of: "van",
    product_images: "Product afbeeldingen",
    for: "voor",
    carousel: "Carrousel",
    go_to_image: "Ga naar afbeelding",
    button_label_add: "Toevoegen",
    button_label_remove: "Verwijderen",
    increase_price_label: "Prijsverhoging",
    decrease_price_label: "Prijsverlaging",
    select_video_label: "Video kiezen",
    play_label: "Speel",
    pause_label: "Pauzeer",
    buttons: "Knoppen",
    open_modal_label: "Open afbeelding zoom modal",
    close_modal_label: "Sluit afbeelding Zoom Modal",
    image_zoom_modal: "Afbeelding zoom modal",
    vr_ready_label: "VR Ready",
    vr_not_ready_label: "Niet VR Ready",
    streaming_ready_label: "Stream Ready",
    streaming_not_ready_label: "Niet Stream Ready",
    has_wifi_label: "Heeft WiFi",
    no_wifi_label: "Geen WiFi",
    has_bluetooth_label: "Heeft Bluetooth",
    no_bluetooth_label: "Geen Bluetooth",
    has_usbc_label: "Heeft USB-C",
    no_usbc_label: "Geen USB-C",
    rgb_included_label: "Inclusief RGB-verlichting",
    rgb_not_included_label: "RGB-verlichting niet inbegrepen",
    products_label: "Producten",
    upsell_modal_label: "Vaak samen gekocht",
    no_thanks_label: "Nee bedankt",
    label_deal_ends: "Deal eindigt in",
    label_show_less: "Laat minder zien",
    label_show_more: "Laat meer zien",
    label_case: "Case",
    label_software: "Software",
    label_services: "Diensten",
    label_ram: "RAM",
    label_cpu: "CPU",
    label_gpu: "GPU",
    label_motherboard: "Moederbord",
    label_storage: "Opslag",
    label_cooling: "Koeling",
    label_psu: "PSU",
    label_warranty: "Garantie",
    label_accessories: "Accessoires",
    label_fps: "FPS",
    label_feature: "Functies"
};
var nl_cart = {
    cart_heading: "Je winkelwagen",
    cart_heading_empty: "Je winkelwagen is leeg",
    cart_subheading_empty: "Ontdek je toekomstige lievelingsproducten",
    cart_free_shipping_cta: "Nog maar €25 en je betaalt geen verzendkosten!",
    cart_free_shipping_exclusion: "(Exclusief aangepaste en voorgebouwde pc's)",
    cart_free_shipping_promo_cta: "Gratis verzending op alle bestellingen",
    cart_heading_error: "Er is iets misgegaan. Probeer het nog een keer.",
    cart_heading_success: "Bedankt!",
    cart_label_subtotal: "Subtotaal",
    cart_label_taxes: "btw",
    cart_value_taxes: "Wordt in de volgende stap berekend",
    cart_label_shipping: "Verzending",
    cart_value_shipping_free: "GRATIS",
    cart_value_disclaimer: "*Nieuwe en refurbished producten kunnen op verschillende momenten worden verwerkt en verzonden.",
    cart_label_total: "Totaal",
    cart_button_checkout: "Naar de kassa",
    cart_terms_message: "Ik accepteer de",
    cart_terms_link_text: "algemene servicevoorwaarden",
    cart_value_taxes_non_us: "Inbegrepen",
    cart_value_shipping_calculated: "Wordt in de volgende stap berekend",
    cart_consent_i_have_read: "Ik heb het",
    cart_consent_privacy_policy: "privacybeleid gelezen",
    cart_consent_privacy_policy_after: " ",
    cart_au_terms_message: "Ik accepteer de",
    cart_au_terms_link: "Servicevoorwaarden",
    cart_au_consent_message: "Ik stem ermee in dat mijn persoonlijke gegevens worden verzameld en gebruikt in overeenstemming met het",
    cart_au_consent_link: "Privacybeleid",
    cart_au_terms_text_1: "NZXT Pty Ltd (ABN 47 645 981 559) levert de goederen en diensten die jij hebt besteld op grond van haar",
    cart_au_terms_text_terms_link: "Voorwaarden",
    cart_au_terms_text_2: "en verzamelt, gebruikt en onthult de persoonlijke informatie die het van jou verzamelt in overeenstemming met zijn",
    cart_au_terms_text_privacy_link: "Privacybeleid",
    cart_label_ssd: "SSD",
    cart_label_hdd: "HDD",
    cart_label_service: "Diensten",
    cart_label_software: "Software",
    cart_label_case: "Behuizing",
    cart_label_motherboard: "Moederbord",
    cart_label_cpu: "CPU",
    cart_label_gpu: "GPU",
    cart_label_power_supply: "Voeding",
    cart_label_cpu_cooler: "Koeling",
    cart_label_rgb: "RGB",
    cart_label_fans: "Ventilatoren",
    cart_label_ram: "RAM",
    cart_label_monitors: "Beeldschermen",
    cart_label_peripherals: "Randapparatuur",
    cart_label_extras: "Extra's",
    cart_label_keycaps: "Toetsen",
    cart_label_keycap_accents: "Toetsaccenten",
    cart_label_switches: "Schakelaars",
    cart_label_keyboard_base: "Toetsenbordbasis",
    cart_label_keycap_accent: "Accenttoetsen",
    cart_label_accent_cable: "Accentkabel",
    cart_label_mouse: "Muis",
    cart_message_item_fallback: "Dit item",
    cart_message_build_item_oos_before: "Een item in uw",
    cart_message_build_item_oos_after: "is uitverkocht. Klik hier om uw gebouw bij te werken en toe te voegen aan uw winkelwagen.",
    cart_message_oos: "is momenteel niet op voorraad. Verwijder dit item om verder te gaan naar de kassa."
};
var nl_category = {
    explore_refurbished: "Samenstellingen ontdekken",
    explore_bulk: "Bulk ontdekken",
    bulk: "Bulk",
    refurbished: "Refurbished",
    refurbished_cta: "We hebben Builds in bulk geleverd aan gamingbedrijven, universiteiten, e-sport-organisaties en meer.",
    bulk_cta: "We hebben Builds in bulk geleverd aan gamingbedrijven, universiteiten, e-sport-organisaties en meer."
};
var nl_geoipBanner = {
    currently_browsing: "Op dit moment aan het bekijken",
    banner_region_text: "Ga naar jouw regio om te shoppen of om content voor jouw regio te bekijken.",
    banner_button: "Schakel naar",
    banner_country_text_shop: "Winkel",
    banner_counrty_text: "of selecteer een ander land dat specifiek is voor uw locatie.",
    country_us: "Verenigde Staten",
    country_canada: "Canada",
    country_belgium: "Belgi\xeb",
    country_germany: "Duitsland",
    country_luxembourg: "Luxemburg",
    country_netherlands: "Nederland",
    country_austria: "Oostenrijk",
    country_france: "Frankrijk",
    country_italy: "Itali\xeb",
    country_spain: "Spanje",
    country_uk: "Verenigd Koninkrijk",
    country_australia: "Australi\xeb",
    country_nz: "Nieuw Zeeland",
    country_japan: "Japan",
    region_na: "Noord-Amerika",
    region_europe: "Europa",
    region_oceania: "Oceani\xeb"
};
var nl_ui = {
    loading: "Laden"
};
var nl_footer = {
    label_language: "Taal",
    label_country: "Land",
    manage_cookie_preferences: "Cookie-instellingen beheren",
    all_rights_reserved: "Alle rechten voorbehouden"
};
var nl_search = {
    label_suggested_queries: "Voorgestelde zoekopdrachten",
    label_suggested_results: "Voorgestelde resultaten",
    label_serp_heading: "Zoek in resultaten op",
    label_serp_not_found: "Geen resultaten gevonden voor",
    label_serp_total: "totale resultaten",
    label_serp_suggested: "Probeer te zoeken naar"
};
var nl_about = {
    label_customer_support_hours: "Openingstijden klantenservice",
    label_headquarters: "Hoofdkantoor"
};
var nl_product = {
    overview: "Overzicht",
    tech_specs: "Technische specificaties",
    downloads: "Downloads",
    message_invalid: "Tijdelijk niet verkrijgbaar",
    message_out_of_stock: "Niet op voorraad",
    message_low_stock: "Beperkte voorraad beschikbaar",
    message_new_item: "Nieuw",
    message_coming_soon: "Binnenkort Beschikbaar",
    message_unavailable: "Niet beschikbaar",
    title_highlights: "Belangrijkste kenmerken",
    title_shipping: "Verzendkosten",
    title_in_the_box: "In de doos",
    button_buy_now: "Nu kopen",
    message_colors: "Kleuren",
    message_color: "Kleur",
    message_size: "Grootte",
    message_series: "Serie",
    overview_anchor: "Overzicht",
    tech_specs_anchor: "Technische specificaties",
    downloads_anchor: "Downloads",
    related_anchor: "Gerelateerd",
    customize_build_header: "Aanpassen",
    customize_build_subheader: "Begin een Build met dit item",
    customize_kb_build_subheader: "Bouw een aangepast toetsenbord",
    buy_product_header: "Doe het zelf",
    buy_product_subheader: "Droom het. Build het. Doe het.",
    buy_label: "Kopen",
    retailers_subheader: "Winkel bij onze partners.",
    link_all_retailers: "Bekijk alle winkels",
    series_label: "Serie",
    label_header_bundle: "Samen kopen",
    label_subheader_bundle: "Breng je build naar een hoger niveau met door experts aanbevolen producten",
    help_button_label: "Chat nu",
    help_button_heading: "Heb je vragen?",
    help_button_subheading: "Onze experts staan ​​klaar om te helpen.",
    configure_label: "Configureren",
    documentation_label: "Documentatie",
    drivers_label: "Drivers",
    miscellaneous_label: "Diversen",
    resources_label: "Bronnen",
    everything_you_need_label: "Everything you need",
    good_rating_label: "Goed",
    better_rating_label: "Beter",
    best_rating_label: "Best",
    key_specs_label: "Belangrijkste specificaties"
};
var nl_collection = {
    message_invalid: "Tijdelijk niet verkrijgbaar",
    message_out_of_stock: "Niet op voorraad",
    message_low_stock: "Beperkte voorraad beschikbaar",
    message_new_item: "Nieuw",
    message_coming_soon: "Binnenkort beschikbaar",
    message_unavailable: "Niet beschikbaar",
    button_buy_now: "Nu kopen",
    message_colors: "Kleuren",
    learn_more: "Meer informatie",
    help_button_label: "Chat nu",
    help_button_heading: "Heb je vragen?",
    help_button_subheading: "Onze experts staan ​​klaar om te helpen."
};
var nl_news = {
    label_all_news: "Al het nieuws"
};
var nl_retailers = {
    label_regions: "Regio's",
    label_locations: "Locaties",
    label_reseller_type: "Type",
    option_label_all_regions: "Alle regio's",
    option_label_all_locations: "Alle locaties",
    option_label_all_reseller_type: "Alle opties",
    message_empty_state: "Geen enkele detailhandelaar voldoet aan de geselecteerde criteria.",
    hero_text: "NZXT-producten kunnen in alle regio's via onze partners worden gekocht"
};
var nl_searchResults = {
    message_invalid: "Tijdelijk niet verkrijgbaar",
    message_out_of_stock: "Niet op voorraad",
    message_low_stock: "Beperkte voorraad beschikbaar",
    message_new_item: "Nieuw",
    message_coming_soon: "Binnenkort beschikbaar",
    message_unavailable: "Niet beschikbaar"
};
var nl_orderTracking = {
    title_order_status: "Bestelstatus",
    label_cancelled_on: "Geannuleerd op",
    label_shipping_date: "verwachtte Verzenddatum",
    label_case: "Geval",
    label_software: "Software",
    label_services: "Diensten",
    label_ram: "RAM",
    label_cpu: "CPU",
    label_gpu: "GPU",
    label_motherboard: "Moederbord",
    label_storage: "Opslag",
    label_cooling: "Koeling",
    label_psu: "PSU"
};
var nl_orderTrackingRoot = {
    title_order_tracking_root: "Voer jouw bestellings-ID in",
    label_build_id: "Order ID",
    button_track: "Order volgen",
    message_not_found: "niet gevonden, probeer het opnieuw"
};
var nl_refurb = {
    label_all_products: "Alle producten",
    label_relevance: "Relevantie",
    label_price_low_high: "Prijs laag naar hoog",
    label_price_high_low: "Prijs van hoog naar laag",
    label_name_a_z: "Noem A-Z",
    label_name_z_a: "Noem Z-A",
    label_case: "Geval",
    label_software: "Software",
    label_services: "Diensten",
    label_ram: "RAM",
    label_cpu: "CPU",
    label_gpu: "GPU",
    label_motherboard: "Moederbord",
    label_storage: "Opslag",
    label_cooling: "Koeling",
    label_psu: "PSU",
    label_other: "Ander",
    label_accessories: "Accessoires",
    label_fan: "Ventilatoren",
    label_any_price: "Iedere Prijs",
    label_no_products: "Op dit moment zijn er geen refurbished compenenten beschikbaar.",
    label_no_builds: "Op dit moment zijn er geen refurbished samenstellingen beschikbaar."
};
var nl_orderStatus = {
    order_status_title: "Order Status",
    step_label: "Stap",
    confirmed_title: "Bestelling geplaatst",
    confirmed_sub: "Je bestelling is ontvangen.",
    processed_title: "Bestelling bevestigd",
    processed_sub: "Je bestelling is ontvangen en de betaling is verwerkt.",
    in_progress_title: "In uitvoering",
    in_progress_sub: "Het orderpicken en monteren van uw bestelling is begonnen. Uw bestelling is nu vergrendeld en wijzigingen/annuleringen kunnen niet worden gegarandeerd.",
    shipped_title: "verzonden",
    shipped_sub: "Uw bestelling is onderweg!",
    cancelled_title: "Geannuleerd",
    cancelled_sub: "Uw bestelling is succesvol geannuleerd.",
    enh_ordered_sub: "Uw bestelling is ontvangen en staat in de wachtrij.",
    enh_picking_title_bld: "Bouw voorbereiden",
    enh_picking_title: "Uw bestelling verwerken",
    enh_picking_sub_bld: "Het picken en monteren van uw bestelling is begonnen. Wijzigingen in uw bestelling kunnen niet worden gegarandeerd.",
    enh_picking_sub: "We zijn je bestelling aan het voorbereiden. Wijzigingen in uw bestelling kunnen niet worden gegarandeerd.",
    enh_build_title: "Gebouw",
    enh_build_sub: "Uw bestelling wordt gebouwd en getest.",
    enh_packing_title: "Het voorbereiden voor verzending",
    enh_packing_sub_bld: "Uw bestelling is gebouwd en getest. Het wordt ingepakt voor bezorging.",
    enh_packing_sub: "Uw bestelling is verwerkt en wordt ingepakt voor levering.",
    enh_shipping_title: "Verzending",
    enh_shipping_sub: "Uw bestelling is verzonden naar de vervoerder voor levering. Uw trackingnummer wordt binnen 1 werkdag bijgewerkt en naar u gemaild."
};
var nl_universal = (0,_object_spread/* default */.Z)({}, nl_cart, nl_userAccount, nl_auth, nl_formErrors, nl_camCta, nl_generic, nl_helpCta, nl_emailSignUp, nl_geoipBanner, nl_ui, nl_footer, nl_search, nl_about, nl_orderStatus);
// eslint-disable-next-line import/prefer-default-export
var nl = {
    "/": (0,_object_spread/* default */.Z)({}, nl_universal),
    "/product/[slug]": (0,_object_spread/* default */.Z)({}, nl_product, nl_universal),
    "/collection/[slug]": (0,_object_spread/* default */.Z)({}, nl_collection, nl_universal),
    "/partner/[slug]": (0,_object_spread/* default */.Z)({}, nl_collection, nl_universal),
    "/sale/[slug]": (0,_object_spread/* default */.Z)({}, nl_collection, nl_universal),
    "/about": (0,_object_spread/* default */.Z)({}, nl_about, nl_universal),
    "/about/[slug]": (0,_object_spread/* default */.Z)({}, nl_about, nl_universal),
    "/legal": (0,_object_spread/* default */.Z)({}, nl_universal),
    "/legal/[slug]": (0,_object_spread/* default */.Z)({}, nl_universal),
    "/news/[slug]": (0,_object_spread/* default */.Z)({}, nl_news, nl_universal, nl_category),
    "/news/page/[page]": (0,_object_spread/* default */.Z)({}, nl_universal, nl_category),
    "/news/category/[category]": (0,_object_spread/* default */.Z)({}, nl_universal, nl_category),
    "/news/category/[category]/page/[page]": (0,_object_spread/* default */.Z)({}, nl_universal, nl_category),
    "/user/[slug]": (0,_object_spread/* default */.Z)({}, nl_universal, nl_build, nl_keyboard),
    "/software/[slug]": (0,_object_spread/* default */.Z)({}, nl_universal),
    "/category/[slug]": (0,_object_spread/* default */.Z)({}, nl_category, nl_universal),
    "/category/[slug]/[subcategory-slug]": (0,_object_spread/* default */.Z)({}, nl_category, nl_universal),
    "/build": (0,_object_spread/* default */.Z)({}, nl_universal, nl_build),
    "/build/[slug]": (0,_object_spread/* default */.Z)({}, nl_universal, nl_build),
    "/build/pc": (0,_object_spread/* default */.Z)({}, nl_universal, nl_build),
    "/build/pc/[slug]": (0,_object_spread/* default */.Z)({}, nl_universal, nl_build),
    "/build/keyboard/[slug]": (0,_object_spread/* default */.Z)({}, nl_universal, nl_build, nl_keyboard),
    "/build/[slug]/summary": (0,_object_spread/* default */.Z)({}, nl_universal, nl_build),
    "/support": (0,_object_spread/* default */.Z)({}, nl_universal),
    "/refurbished/[slug]": (0,_object_spread/* default */.Z)({}, nl_universal, nl_refurb),
    "/careers": (0,_object_spread/* default */.Z)({}, nl_universal),
    "/reviews/page/[page]": (0,_object_spread/* default */.Z)({}, nl_universal),
    "/careers/available-positions": (0,_object_spread/* default */.Z)({}, nl_universal),
    "/order-tracking/[slug]": (0,_object_spread/* default */.Z)({}, nl_orderTracking, nl_orderTrackingRoot, nl_universal),
    "/order-tracking": (0,_object_spread/* default */.Z)({}, nl_orderTrackingRoot, nl_universal),
    "/retailers": (0,_object_spread/* default */.Z)({}, nl_retailers, nl_universal),
    "/search": (0,_object_spread/* default */.Z)({}, nl_searchResults, nl_universal),
    "/auth/[slug]": (0,_object_spread/* default */.Z)({}, nl_universal),
    universal: nl_universal
};

;// CONCATENATED MODULE: ./locale/fr.ts
/* eslint-disable max-len */ 
var fr_userAccount = {
    user_settings_title: "Compte",
    user_settings_change_password: "Modifier le mot de passe",
    user_settings_save: "Sauvegarder",
    user_settings_cancel: "Annuler",
    user_profile_heading: "Profil",
    user_saved_builds_heading: "BLD enregistr\xe9s",
    user_saved_builds_bld_name: "Nom du BLD",
    user_saved_builds_bld_date: "Date de cr\xe9ation",
    user_saved_builds_bld_item_part: "Composant",
    user_saved_builds_delete_bld: "Supprimer BLD",
    user_saved_builds_resume_bld: "Reprendre BLD",
    user_saved_builds_hero_title: "Con\xe7u pour \xeatre montr\xe9",
    user_saved_builds_hero_text: "Le design compact et vertical de nos tours est compatible avec la plupart des tailles de GPU sur le march\xe9, ce qui te permet de gagner de l'espace sur ton bureau sans sacrifier la puissance graphique.",
    user_saved_builds_pc_heading: "Constructions de PC",
    user_saved_builds_keyboard_heading: "Constructions de claviers",
    user_saved_builds_view_pc: "Voir les constructions de PC",
    user_saved_builds_view_keyboard: "Voir les constructions de claviers",
    user_saved_builds_no_pc: "Vous n'avez pas sauvegard\xe9 de PC Builds",
    user_saved_builds_no_kb: "Vous n'avez pas enregistr\xe9 de constructions de clavier",
    user_order_history_heading: "Historique des commandes",
    user_order_history_date: "Date",
    user_order_history_order_number: "Num\xe9ro de commande",
    user_order_history_status: "\xc9tat",
    user_order_history_amount: "Montant",
    user_order_history_view: "Voir le re\xe7u",
    user_order_history_empty_view: "Tu n'as pas d'historique de commandes.",
    user_order_history_shipping: "Adresse de livraison",
    user_order_history_billing: "Adresse de facturation",
    user_order_history_item: "Article",
    user_order_history_item_image: "Image de l'article",
    user_order_history_quantity: "Quantit\xe9",
    user_order_history_order: "# de commande",
    user_support_heading: "Assistance + Retours",
    user_data_heading: "Demande de donn\xe9es",
    user_terms_heading: "Termes",
    user_terms_empty: "Tu n'as pas encore de conditions sign\xe9es.",
    user_support_subject_min_length: "L'objet doit comporter au moins 3 caract\xe8res",
    user_support_message_placeholder: "Merci de d\xe9tailler les raisons pour lesquelles tu nous contactes. Pour un retour, merci d'inclure le num\xe9ro de commande",
    user_support_update_button: "Mettre \xe0 jour",
    user_active_tickets_heading: "Tickets ouverts",
    user_active_tickets_chat: "Ajouter un message",
    user_active_tickets_no_chat_history: "Ton historique de chat est vide",
    view_chat_button: "Voir le chat",
    close_chat_button: "Fermer le chat",
    field_required_message: "Ce champ est requis",
    label_accept: "J'accepte",
    label_reason_for_contact: "Motif de contact",
    label_country: "Pays",
    label_subject: "Sujet",
    label_product: "Produit",
    label_message: "Message",
    label_requestor_type: "Type de demandeur",
    label_country_of_residence: "Pays de r\xe9sidence",
    label_description: "Description",
    placeholder_description: "Description de ta demande",
    label_submit: "Soumettre",
    message_no_support_requests: "Tu n'as aucune demande d'assistance active",
    label_ticket_number: "Num\xe9ro de billet",
    label_date_created: "date de cr\xe9ation",
    label_status: "Statut",
    label_department: "D\xe9partement",
    subheading_active_ticket: "Si tu as besoin d'aide ou souhaites retourner un article, merci de contacter le support.",
    label_create_support_request: "Cr\xe9er une demande d'assistance",
    button_comment: "Commentaire",
    label_for_myself: "Pour moi-m\xeame",
    label_parent: "Parent",
    label_legal_rep: "Repr\xe9sentant l\xe9gal",
    label_relative: "Un membre de ma famille",
    label_guardian: "Gardien",
    label_accept_generic_terms: "J'ai lu et j'accepte ces conditions",
    error_view_message: "Oups, une erreur s'est produite.",
    signout_view_message: "Tu as \xe9t\xe9 d\xe9connect\xe9.",
    user_order_history_close: "Fermer",
    birthday_error_message: "Merci de saisir une date de naissance valide",
    label_view_saved: "Voir toutes les constructions sauvegard\xe9es"
};
var fr_formErrors = {
    invalid_email: "Ton adresse e-mail n'est pas valide",
    username_full_pattern_message: "Le nom d'utilisateur doit comporter entre 6 et 30\xa0caract\xe8res. Vous pouvez utiliser des lettres, des chiffres et des points mais ne pouvez pas commencer, terminer ou contenir des points cons\xe9cutifs.",
    password_pattern_message: "Le mot de passe doit contenir au moins six caract\xe8res dont une lettre majuscule, une lettre minuscule et un chiffre",
    username_min_length_message: "Utilisez 6 caract\xe8res minimum pour votre nom d'utilisateur",
    passwords_must_match: "Les mots de passe doivent concorder",
    invalid_current_password: "Impossible de mettre \xe0 jour le mot de passe. La valeur fournie comme mot de passe actuel est incorrecte",
    must_accept_partner_program_terms: "Vous devez accepter les conditions du programme de partenariat pour devenir un partenaire NZXT",
    must_accept_tos_terms: "Tu dois accepter les conditions d'utilisation pour cr\xe9er un compte NZXT",
    must_accept_generic_terms: "Vous devez accepter ces conditions"
};
var fr_auth = {
    user_auth_agreement: "J'accepte",
    user_auth_privacy_policy: "la politique de confidentialit\xe9",
    user_auth_and: "et j'ai lu",
    user_auth_terms: "les conditions d'utilisation.",
    error_invalid_request: "Requ\xeate invalide.",
    error_invalid_token: "Tentative de connexion utilisateur non valide",
    error_session_expired: "Ta session a expir\xe9. Merci de te reconnecter pour continuer.",
    user_forgot_required_email: "Une adresse e-mail est n\xe9cessaire",
    user_forgot_success_message: "Merci! Si un compte est associ\xe9 \xe0 cet e-mail, nous vous enverrons imm\xe9diatement les instructions de r\xe9initialisation du mot de passe.",
    error_email_exists: "L'e-mail est d\xe9j\xe0 utilis\xe9",
    user_email_verification_heading: "v\xe9rification de l'E-mail",
    error_email_not_verified: "L'adresse e-mail n'est pas encore v\xe9rifi\xe9e. Pour renvoyer l'e-mail de v\xe9rification, cliquez sur",
    error_email_already_verified: "L'adresse e-mail a d\xe9j\xe0 \xe9t\xe9 v\xe9rifi\xe9e. Veuillez continuer \xe0 vous connecter.",
    user_email_verification_success_message: "Votre adresse e-mail a \xe9t\xe9 v\xe9rifi\xe9e avec succ\xe8s\xa0!. Veuillez continuer \xe0 vous connecter.",
    error_username_unavailable: "Le nom d'utilisateur n'est pas disponible",
    error_reset_password_same_as_old_password: "Ce mot de passe est le m\xeame que le pr\xe9c\xe9dent. Merci d'en choisir un autre.",
    error_reset_password_link_expired: "Le lien pour r\xe9initialiser ton mot de passe a expir\xe9.",
    error_reset_password_link_invalid: "Le lien pour r\xe9initialiser ton mot de passe n'est pas valide.",
    user_forgot_password_subheading: "Saisis ton adresse e-mail pour recevoir les instructions de r\xe9initialisation de ton mot de passe.",
    user_reset_password_heading: "r\xe9initialise ton mot de passe",
    user_reset_password_subheading: "Merci de saisir un nouveau mot de passe.",
    user_reset_password: "R\xe9initialiser le mot de passe",
    user_reset_success_message: "Tu as r\xe9initialis\xe9 ton mot de passe avec succ\xe8s !",
    user_login_text: "Se connecter avec Google",
    user_login_remember: "Se souvenir de moi",
    user_login_forgot_password: "Mot de passe oubli\xe9 ?",
    user_login_wrong_email_or_password: "Adresse e-mail ou mot de passe incorrects",
    user_login_success_message: "Tu es connect\xe9 !",
    user_sign_up_success_verify_message: "Le compte restera inactif tant qu'il n'aura pas \xe9t\xe9 v\xe9rifi\xe9. Pense \xe0 consulter ton dossier de courrier ind\xe9sirable si tu ne re\xe7ois pas l'e-mail dans quelques minutes.",
    error_too_many_requests: "Tu as fait trop de tentatives. Merci de patienter quelques minutes ou contacter l'assistance",
    error_user_not_found: "L'utilisateur n'a pas \xe9t\xe9 trouv\xe9",
    user_sign_in_sign_up: "Se connecter/S'inscrire",
    user_sign_out: "Se d\xe9connecter",
    user_sign_in: "Se connecter",
    user_account_updates: "Mises \xe0 jour NZXT",
    user_account_no_updates: "Aucune mise \xe0 jour r\xe9cente, revenez plus tard.",
    support_center_link: "Aide & Assistance",
    error_google_account_exists: "Tu as d\xe9j\xe0 cr\xe9\xe9 un compte avec Google. Merci d'essayer de te connecter.",
    error_local_account_exists: "Il semble que tu as d\xe9j\xe0 un compte. Merci d'essayer de te connecter.",
    user_sign_up: "S'inscrire",
    user_sign_up_text: "S'inscrire avec Google",
    user_sign_up_opt_in: "Enregistre-toi pour recevoir des informations par e-mail de la part de NZXT sur les nouveaux produits, les BLD et les CAM",
    user_sign_up_check_email_message: "Consulte tes e-mails et clique sur le lien pour activer ton compte.",
    user_info_updated_success_message: "Tes informations ont \xe9t\xe9 mises \xe0 jour avec succ\xe8s!",
    user_info_newsletter_confirmation_message: "Merci de v\xe9rifier ton e-mail pour confirmation.",
    user_email_sign_in: "Ou continue avec",
    user_no_account: "Tu n'es pas membre ?",
    user_create_account: "Cr\xe9er un compte",
    user_email_sign_up_text: "Ou enregistre-toi avec",
    user_have_account: "Tu as un compte ?",
    open_login_view: "Ouvrir la fen\xeatre de connexion",
    error_newsletter_subscription: "Impossible de s'abonner / se d\xe9sabonner \xe0 la newsletter pour le moment. Merci de r\xe9essayer plus tard.",
    user_login_too_many_requests: "Tu as d\xe9pass\xe9 le nombre maximum autoris\xe9 de requ\xeates. Merci de patienter quelques minutes ou contacter le service clients",
    label_email_address: "Adresse E-mail",
    label_password: "Mot de Passe",
    label_current_password: "Mot de passe actuel",
    label_confirm_password: "Confirmez le mot de passe",
    label_new_password: "nouveau mot de passe",
    label_confirm_new_password: "Confirmer le nouveau mot de passe",
    label_username: "Nom d'utilisateur",
    label_first_name: "Pr\xe9nom",
    label_last_name: "Nom de famille",
    label_preferred_pronouns: "Pronoms pr\xe9f\xe9r\xe9s",
    label_search_for_help_articles: "Rechercher des articles d'aide",
    label_birthday: "Date d'anniversaire",
    label_location: "Emplacement",
    app_access: "souhaite acc\xe9der \xe0 ton compte NZXT pour consulter:",
    app_access_has_scopes: "souhaite acc\xe9der \xe0 ton compte NZXT",
    scope_profile: "Ton profil, y compris ton nom et ton image",
    scope_email: "Ton adresse e-mail",
    scope_address: "Votre adresse physique",
    scope_phone: "Votre num\xe9ro de t\xe9l\xe9phone",
    grant_offline_access: "Avoir un acc\xe8s hors ligne",
    grant_offline_access_previous: "que vous avez pr\xe9c\xe9demment accord\xe9"
};
var fr_build = {
    custom_bld_modal_heading: "Configure ton PC",
    custom_bld_modal_subheading: "Choisis ton chipset et s\xe9lectionne ton budget",
    custom_bld_unavailable: "Merci de s\xe9lectionner un autre composant",
    custom_bld_issue: "Il y a un probl\xe8me avec le(s) composant(s) suivant(s) : ",
    custom_bld_title: "Configuration sur mesure",
    custom_bld_lets_get_started: "D\xe9marrons",
    custom_bld_destrutive_action: "Avertissement : Remise \xe0 z\xe9ro de ton BLD",
    custom_bld_confirm_reset: "Ton BLD va \xeatre remis \xe0 z\xe9ro avec le chipset suivant:",
    custom_bld_keyboard_confirm_reset: "Votre build sera r\xe9initialis\xe9 avec ce changement",
    custom_bld_choose_chipset: "S\xe9lectionne ton chipset",
    custom_bld_chipset: "Chipset",
    custom_bld_intel: "Intel",
    custom_bld_amd: "AMD",
    custom_bld_explore: "Explorer",
    custom_bld_select: "S\xe9lectionner",
    review_bld_button: "V\xe9rifier le BLD",
    custom_bld_summary: "R\xe9capitulatif",
    custom_bld_budget: "Budget",
    custom_bld_specs: "Sp\xe9cifications",
    custom_bld_case: "Bo\xeetier",
    custom_bld_cases: "Bo\xeetiers",
    custom_bld_caseCooling: "Refroidissement",
    custom_bld_fans: "Ventilateurs",
    custom_bld_cpu: "CPU",
    custom_bld_gpu: "GPU",
    custom_bld_ram: "RAM",
    custom_bld_ssd: "SSD",
    custom_bld_hdd: "Disque dur",
    custom_bld_specials: "Points sp\xe9ciaux",
    custom_bld_colors: "Couleurs",
    custom_bld_color: "Couleur",
    custom_bld_black: "Noir",
    custom_bld_red: "Rouge",
    custom_bld_white: "Blanc",
    custom_bld_grey: "Gris",
    custom_bld_blue: "Bleu",
    custom_bld_purple: "Violet",
    custom_bld_yellow: "Jaune",
    custom_bld_audio: "Audio",
    custom_bld_extras: "Extras",
    custom_bld_core: "Core",
    custom_bld_motherboard: "Carte m\xe8re",
    custom_bld_motherboards: "Cartes M\xe8res Gaming",
    custom_bld_powerSupplies: "Alimentations",
    custom_bld_powerSupply: "Bloc d'alimentation",
    custom_bld_services: "Services",
    custom_bld_software: "Logiciels",
    custom_bld_monitors: "Moniteurs",
    custom_bld_peripherals: "P\xe9riph\xe9riques",
    custom_bld_lighting: "\xc9clairage",
    custom_bld_headset: "Casque",
    custom_bld_keyboard: "Clavier",
    custom_bld_all: "Tout",
    custom_bld_mouse: "Souris",
    custom_bld_storage: "Stockage",
    custom_bld_streaming_ready: "Pr\xeat pour le stream",
    custom_bld_rgb_lighting: "\xc9clairage RGB",
    custom_bld_vr_ready: "Compatible VR",
    custom_bld_wifi: "WiFi",
    custom_bld_from: "\xc0 partir de",
    custom_bld_bluetooth: "Bluetooth",
    custom_bld_save_build_message: 'Ton BLD a bien \xe9t\xe9 enregistr\xe9 ! Tu peux le retrouver dans "BLD enregistr\xe9es" sur ton compte.',
    custom_bld_save_modal_message: "Voulez-vous enregistrer cette construction pour plus tard?",
    custom_bld_confirm_save_modal_message: "Vous perdrez les modifications non sauvegard\xe9es en quittant cette page",
    custom_bld_share_build_message: "Ton BLD a bien \xe9t\xe9 enregistr\xe9 et copi\xe9 !",
    help_me_decide: "Aide-moi \xe0 faire le bon choix",
    save_build: "Sauvegarder la configuration",
    start_over: "Recommencer \xe0 z\xe9ro",
    summary: "R\xe9capitulatif",
    build_summary: "R\xe9capitulatif de configuration",
    load_build: "Charger la configuration",
    load: "Charger",
    save: "Sauvegarder",
    restart: "Red\xe9marrer",
    share: "Partager",
    my_build_label: "Mon BLD",
    est_shipping: "Date d’exp\xe9dition estim\xe9e",
    add_to_build: "Ajouter au BLD",
    message_invalid: "Temporairement indisponible",
    message_out_of_stock: "En rupture de stock",
    message_low_stock: "Disponible en quantit\xe9 limit\xe9e",
    message_new_item: "Nouveau",
    message_coming_soon: "Bient\xf4t disponible",
    message_best_seller: "Meilleure vente",
    message_is_locked: "Pas Compatible",
    button_label_select: "S\xe9lectionner",
    button_label_selected: "S\xe9lectionn\xe9",
    button_label_add: "Ajouter",
    button_label_remove: "Supprimer",
    button_label_added: "Ajout\xe9",
    button_label_update: "Mettre \xe0 jour",
    button_label_info: "Info",
    button_label_more_info: "Plus d'infos",
    button_label_options_info: "Options et informations",
    button_label_continue_to: "Continuer la configuration",
    button_label_edit: "Modifier",
    build_fps_label: "Le nombre d'images par seconde (FPS) est mesur\xe9 \xe0 la r\xe9solution 2560x1440 en utilisant les param\xe8tres graphiques les plus \xe9lev\xe9s de chaque jeu",
    build_includes: "Comprend",
    custom_bld_boost: "Booste ton build",
    custom_bld_fps_unavailable: "En attente",
    custom_bld_amd_help: "Les PC Intel ont longtemps \xe9t\xe9 majoritaires mais les PC AMD sont aujourd'hui aussi excellents pour les jeux. Nous allons t'aider \xe0 assembler les deux types de PC et nous avons choisi des cartes m\xe8res et des refroidisseurs qui sont compatibles pour te faciliter la t\xe2che. Nous te recommandons de choisir un bon \xe9quilibre entre le nombre d'images par seconde (FPS) et le budget que tu as pour ton BLD.",
    custom_bld_to_see_this: "Pour choisir ce composant, tu dois",
    custom_bld_change_chipset: "changer de chipset.",
    performance: "Performances",
    message_error: "Houston, nous avons un probl\xe8me",
    custom_bld_prebuild_upsell: "Ou choisis tout simplement un PC pr\xe9-assembl\xe9",
    no_item_selected: "Aucun \xc9l\xe9ment S\xe9lectionn\xe9",
    build_change_label: "BLD Modifi\xe9",
    invalid_action_label: "Arr\xeat\xe9",
    success_label: "Succ\xe8s",
    build_info_message: "Info",
    reset_label: "R\xe9initialiser le BLD",
    complete_build_label: "Termine ton BLD",
    back_to_build_label: "Retour vers ton BLD",
    complete_build_sub_label: "Extras et P\xe9riph\xe9riques",
    back_to_build_sub_label: "Composants de base de ton BLD",
    capacity_label: "Capacit\xe9",
    option_label: "Option",
    options_label: "Options",
    max_speed: "Vitesse maximale",
    modular_label: "Modulaire",
    midtower_label: "Moyen Tour",
    streaming_label: "Streaming",
    save_and_exit: "Sauvegarder et quitter",
    exit: "Quitter",
    view_cart_label: "Voir le panier",
    cart_subtotal_label: "Sous-total du panier",
    start_build_label: "Nouvelle configuration",
    new_build_label: "Nouvelle configuration",
    continue_saved_build_label: "Finalise ta configuration",
    continue_progress_build_label: "Finalise la configuration de tes p\xe9riph\xe9riques",
    continue_cart_build_label: "V\xe9rifiez la construction dans votre panier",
    core_label: "Base",
    extras_label: "Options",
    summary_label: "R\xe9capitulatif",
    share_build_pc: "PC personnalis\xe9",
    share_build_kb: "Clavier personnalis\xe9",
    build_summary_label: "Aper\xe7u de ton clavier personnalis\xe9.",
    pc_hub_card_heading: "PC Gaming personnalis\xe9s",
    pc_hub_card_subheading: "Configure le PC de tes r\xeaves en fonction de ton budget et optimis\xe9 pour les jeux que tu aimes.",
    kb_hub_card_heading: "Claviers personnalis\xe9s",
    kb_hub_card_subheading: "Cr\xe9e un clavier et une souris personnalis\xe9s en fonction de ton espace et de ton style de jeu."
};
var fr_keyboard = {
    keyboard_label: "Clavier",
    keyboard_size: "Taille du clavier",
    keyboard_base: "Base du clavier",
    keyboard_primay_base_color: "Couleur de base",
    keyboard_layout: "Disposition du clavier",
    keyboard_summary: "R\xe9capitulatif du clavier",
    accent_keycaps: "Couleur d'accentuation",
    cabletype: "C\xe2ble Accent",
    additional_cable_color: "Couleur du c\xe2ble",
    cable: "C\xe2ble",
    additional_cable: "C\xe2ble suppl\xe9mentaire",
    primary_keycaps: "Keycaps de base",
    switches: "Switches",
    size: "Taille",
    layout: "Disposition",
    language: "Langue",
    mouse_pad_label: "Tapis de souris",
    desk_mat_label: "Tapis de bureau",
    tools_label: "Outils",
    mouse_label: "Souris",
    wrist_rest_label: "Repose-poignets",
    cable_description: "C\xe2ble color\xe9 en option. Un c\xe2ble noir standard de 2 m\xe8tres sera inclus.",
    cable_color_description: "La couleur du c\xe2ble premium.",
    language_description: "D\xe9termine la position des touches Q, W, Z et A.",
    layout_description: "D\xe9termine la taille et la position des touches.",
    keycap_accent_description: "Couleur optionnelle pour les touches Echap, Entr\xe9e, les fl\xe8ches et Entr\xe9e du pav\xe9 num\xe9rique.",
    primary_keycap_description: "PBT sublim\xe9, profil Cherry.",
    switch_description: "D\xe9finit l'exp\xe9rience de frappe gr\xe2ce aux touches du clavier.",
    keyboard_base_color_description: "La couleur principale de la base du clavier.",
    keyboard_base_size_description: "D\xe9termine le nombre de touches et la dimension du clavier.",
    mouse_description: "Souris ambidextre l\xe9g\xe8re.",
    summary_description: "Aper\xe7u de ton clavier personnalis\xe9",
    premium_label: "Premium",
    base_label: "Base",
    keyboard_warning: "Veuillez s\xe9lectionner les \xe9l\xe9ments suivants pour proc\xe9der \xe0 votre construction :",
    switch_reset_warning: "Vos interrupteurs ont \xe9t\xe9 r\xe9initialis\xe9s. Veuillez s\xe9lectionner de nouveaux interrupteurs.",
    keycap_reset_warning: "Vos porte-cl\xe9s ont \xe9t\xe9 r\xe9initialis\xe9s. Veuillez choisir de nouveaux porte-cl\xe9s.",
    base_type: "Type de build",
    build_type_description: "S\xe9lectionnez le type de clavier que vous souhaitez configurer.",
    full_custom_label: "Enti\xe8rement personnalis\xe9",
    barebones_disclaimer: "Modifie ton type de build pour s\xe9lectionner cet \xe9l\xe9ment",
    none_label: "Aucun"
};
var fr_camCta = {
    cam_description: "G\xe8re les performances, les temp\xe9ratures et les composants \xe0 partir d'une seule application.",
    cam_windows_10: "WINDOWS 10 64 BITS"
};
var fr_helpCta = {
    help_description: "Obtiens des guides et un support complets pour tous tes produits NZXT, ainsi qu'une aide pour les garanties, les retours et tout aspect technique."
};
var fr_emailSignUp = {
    email_stay_in_touch: "Rester en contact",
    email_sub_copy: "Sois inform\xe9 des derni\xe8res sorties, offres et nouveaut\xe9s de NZXT.",
    email_legal: "En t'inscrivant, tu acceptes la politique de confidentialit\xe9 et les conditions d'utilisation de NZXT, CAM et de BLD",
    email_notify: "Me pr\xe9venir",
    email_notify_stock: "Sois averti lorsque cet article est disponible."
};
var fr_generic = {
    explore: "Explorer",
    cam_title: "NZXT CAM",
    free_download: "T\xe9l\xe9chargement gratuit",
    details: "D\xe9tails",
    help_amp_support: "Aide & assistance",
    help_and_support: "Aide et assistance",
    read_more: "En savoir plus",
    privacy_policy: "Politique de confidentialit\xe9",
    terms_conditions: "Conditions g\xe9n\xe9rales",
    and: "et",
    or: "ou",
    send: "envoyer",
    return_to: "retourner \xe0",
    previous: "Pr\xe9c\xe9dent",
    next: "Suivant",
    home: "Accueil",
    keep_browsing: "Poursuivre la navigation",
    create_build: "Cr\xe9er un BLD",
    learn_more: "En savoir plus",
    add_to_cart: "Ajouter au panier",
    share_build: "Partager le BLD",
    view: "Voir",
    close: "Fermer",
    price: "Prix",
    allow: "Permettre",
    cancel: "Annuler",
    here: "ici",
    ok: "D'accord",
    button_start_bld: "D\xe9marrer le BLD",
    message_on_sale: "Promotion",
    button_buy: "Acheter",
    button_start_build: "D\xe9marrer le BLD",
    view_build: "Voir le BLD",
    button_back: "Retour",
    performance: "Performance",
    build: "Assembler",
    error_generic: "Quelque chose s'est mal pass\xe9. Merci de r\xe9essayer plus tard.",
    label_support: "Assistance",
    contact_support: "Contacte l'assistance",
    browse_articles: "Parcourir les articles",
    search_support_articles: "Rechercher des articles d'aide",
    message_error: "Oh, quelque chose s'est mal pass\xe9",
    estimated_performance_label: "Performance estim\xe9e",
    estimated_fps: "Nombre d'images par seconde (FPS) estim\xe9",
    see_estimated_performance_label: "Voir les performances estim\xe9es",
    title_related_items: "Tu pourrais aussi aimer",
    qty: "Quantit\xe9",
    category_from: "\xc0 partir de",
    reviews_label: "Avis",
    message_invalid: "Temporairement indisponible",
    message_out_of_stock: "En rupture de stock",
    message_low_stock: "Disponible en quantit\xe9 limit\xe9e",
    message_new_item: "Nouveau",
    message_coming_soon: "Bient\xf4t disponible",
    message_best_seller: "Meilleure vente",
    message_featured_items: "Produits en vedette dans l'image",
    message_unavailable: "Indisponible",
    message_colors: "Couleurs",
    message_color: "Couleur",
    label_return_policy: "Politique de retour",
    label_warranty_policy: "Politique de garantie",
    label_shop: "Acheter",
    label_days: "Jours",
    label_hours: "Heures",
    label_minutes: "Minutes",
    label_seconds: "Secondes",
    monthly_payments: "Paiements mensuels disponibles.",
    message_promotion: "Promotion",
    discount_label: "de r\xe9duction",
    off_label: "Inactif",
    on_label: "Activ\xe9",
    choose_label: "Choisissez",
    move_to_previous_label: "Diapositive pr\xe9c\xe9dente",
    move_to_next_label: "Diapositive suivante",
    active_slide_label: "Diapositive active",
    move_to_inactive_slide: "Diapositive inactive",
    color_options: "Options de couleur",
    of: "de",
    product_images: "Images du produit",
    for: "pour",
    carousel: "Carrousel",
    go_to_image: "Aller \xe0 l'image",
    button_label_add: "Ajouter",
    button_label_remove: "Supprimer",
    increase_price_label: "Augmenter le prix",
    decrease_price_label: "Diminution du prix",
    select_video_label: "S\xe9lectionnez la vid\xe9o",
    play_label: "Jouer",
    pause_label: "Pause",
    buttons: "Boutons",
    open_modal_label: "Ouvrir la modale de zoom sur l'image",
    close_modal_label: "Fermer l'image Zoom modal",
    image_zoom_modal: "Modalit\xe9 de zoom de l'image",
    vr_ready_label: "VR Ready",
    vr_not_ready_label: "Non VR Ready",
    streaming_ready_label: "Stream Ready",
    streaming_not_ready_label: "Non Stream Ready",
    has_wifi_label: "Poss\xe8de l'WiFi",
    no_wifi_label: "Pas d'WiFi",
    has_bluetooth_label: "Poss\xe8de l'Bluetooth",
    no_bluetooth_label: "Pas d'Bluetooth",
    has_usbc_label: "Poss\xe8de l'USB-C",
    no_usbc_label: "Pas d'USB-C",
    rgb_included_label: "\xc9clairage RGB inclus",
    rgb_not_included_label: "Eclairage RGB non inclus",
    products_label: "Produits",
    upsell_modal_label: "Fr\xe9quemment achet\xe9s ensemble",
    no_thanks_label: "Non merci",
    label_deal_ends: "L'offre se termine dans",
    label_show_less: "Montrer moins",
    label_show_more: "Montrer plus",
    label_case: "Bo\xeetier",
    label_software: "Logiciel",
    label_services: "Services",
    label_ram: "RAM",
    label_cpu: "CPU",
    label_gpu: "GPU",
    label_motherboard: "Carte m\xe8re",
    label_storage: "Stockage",
    label_cooling: "Refroidissement",
    label_psu: "Bloc d'alimentation",
    label_warranty: "Garantie",
    label_accessories: "Accessoires",
    label_fps: "Images par seconde (FPS)",
    label_feature: "Caract\xe9ristiques"
};
var fr_cart = {
    cart_heading: "Ton panier",
    cart_heading_empty: "Ton panier est vide",
    cart_subheading_empty: "D\xe9couvre des produits que tu vas adorer",
    cart_free_shipping_cta: "Plus que 20 $ et la livraison est gratuite !",
    cart_free_shipping_exclusion: "(Exclut les ordinateurs personnalis\xe9s et pr\xe9cieux)",
    cart_free_shipping_promo_cta: "Livraison gratuite pour toutes les commandes",
    cart_heading_error: "Une erreur s'est produite. Merci de r\xe9essayer.",
    cart_heading_success: "Merci !",
    cart_label_subtotal: "Sous-total",
    cart_label_taxes: "TVA",
    cart_value_taxes: "Calcul\xe9s \xe0 la prochaine \xe9tape",
    cart_label_shipping: "Frais de livraison",
    cart_value_shipping_free: "GRATUIT",
    cart_value_disclaimer: "*Les produits neufs et/ou reconditionn\xe9s peuvent \xeatre trait\xe9s et exp\xe9di\xe9s \xe0 de diff\xe9rents moments.",
    cart_label_total: "Total",
    cart_button_checkout: "Proc\xe9der au paiement",
    cart_terms_message: "J'accepte les",
    cart_terms_link_text: "conditions g\xe9n\xe9rales du service",
    cart_value_taxes_non_us: "Inclus",
    cart_value_shipping_calculated: "Calcul\xe9s \xe0 la prochaine \xe9tape",
    cart_consent_i_have_read: "J'ai lu la",
    cart_consent_privacy_policy: "politique de confidentialit\xe9",
    cart_consent_privacy_policy_after: " ",
    cart_au_terms_message: "J'accepte les",
    cart_au_terms_link: "conditions d'utilisation",
    cart_au_consent_message: "J'accepte que mes informations personnelles soient collect\xe9es et utilis\xe9es conform\xe9ment \xe0 la",
    cart_au_consent_link: "politique de confidentialit\xe9",
    cart_au_terms_text_1: "NZXT Pty Ltd (ABN 47 645 981 559) fournit les biens et les services que tu as command\xe9s conform\xe9ment \xe0 ses",
    cart_au_terms_text_terms_link: "termes et conditions",
    cart_au_terms_text_2: "et collecte, utilise et divulgue les informations personnelles qu'il recueille aupr\xe8s de toi conform\xe9ment \xe0 sa",
    cart_au_terms_text_privacy_link: "politique de confidentialit\xe9",
    cart_label_ssd: "SSD",
    cart_label_hdd: "HDD",
    cart_label_service: "Services",
    cart_label_software: "Software",
    cart_label_case: "Case",
    cart_label_motherboard: "Carte m\xe8re",
    cart_label_cpu: "CPU",
    cart_label_gpu: "GPU",
    cart_label_power_supply: "Bloc d'alimentation",
    cart_label_cpu_cooler: "CPU Refroidissement",
    cart_label_rgb: "RGB",
    cart_label_fans: "Ventilateurs",
    cart_label_ram: "RAM",
    cart_label_monitors: "Moniteurs",
    cart_label_peripherals: "P\xe9riph\xe9riques",
    cart_label_extras: "Extras",
    label_promotion: "Voir la promotion",
    label_promotions: "Promotions",
    cart_label_keycaps: "Touches",
    cart_label_keycap_accents: "Accents sur les touches",
    cart_label_switches: "Commutateurs",
    cart_label_keyboard_base: "Base de clavier",
    cart_label_keycap_accent: "Touches d'accentuation",
    cart_label_accent_cable: "C\xe2ble d'accentuation",
    cart_label_mouse: "Souris",
    cart_message_item_fallback: "Cet objet",
    cart_message_build_item_oos_before: "Un article de votre",
    cart_message_build_item_oos_after: "est \xe9puis\xe9. Veuillez cliquer ici pour mettre \xe0 jour votre build afin de l'ajouter au panier.",
    cart_message_oos: "est actuellement en rupture de stock. Veuillez retirer cet article pour passer \xe0 la caisse."
};
var fr_category = {
    explore_refurbished: "D\xe9couvre les configurations",
    explore_bulk: "Achats en gros",
    bulk: "En gros",
    refurbished: "Reconditionn\xe9s",
    refurbished_cta: "D\xe9couvre nos deals sur les BLD et les composants reconditionn\xe9s qui ont \xe9t\xe9 minutieusement v\xe9rifi\xe9s et test\xe9s.",
    bulk_cta: "Nous avons aid\xe9 des entreprises dans le gaming, des universit\xe9s, des organisations esport et plus encore, \xe0 acheter des PC en gros."
};
var fr_geoipBanner = {
    currently_browsing: "Visiteurs actuels",
    banner_region_text: "S\xe9lectionne ta r\xe9gion pour acheter en ligne ou pour afficher le contenu sp\xe9cifique \xe0 ton emplacement g\xe9ographique.",
    banner_button: "Passer \xe0",
    banner_country_text_shop: "Magasinez",
    banner_counrty_text: "ou s\xe9lectionnez un autre pays sp\xe9cifique \xe0 votre emplacement.",
    country_us: "\xc9tats-Unis",
    country_canada: "Canada",
    country_belgium: "Belgique",
    country_germany: "Allemagne",
    country_luxembourg: "Luxembourg",
    country_netherlands: "Pays-Bas",
    country_austria: "Autriche",
    country_france: "France",
    country_italy: "Italie",
    country_spain: "Espagne",
    country_uk: "Royaume-Uni",
    country_australia: "Australie",
    country_nz: "Nouvelle-Z\xe9lande",
    country_japan: "Japon",
    region_na: "Am\xe9rique du Nord",
    region_europe: "Europe",
    region_oceania: "Oc\xe9anie"
};
var fr_ui = {
    loading: "Loading"
};
var fr_footer = {
    label_language: "Langue",
    label_country: "Pays",
    manage_cookie_preferences: "G\xe9rer les pr\xe9f\xe9rences pour les cookies",
    all_rights_reserved: "Tous droits r\xe9serv\xe9s"
};
var fr_search = {
    label_suggested_queries: "Recherches sugg\xe9r\xe9es",
    label_suggested_results: "R\xe9sultats sugg\xe9r\xe9s",
    label_serp_heading: "Rechercher les r\xe9sultats pour",
    label_serp_not_found: "Aucun r\xe9sultat trouv\xe9 pour",
    label_serp_total: "total des r\xe9sultats",
    label_serp_suggested: "Essaye de rechercher"
};
var fr_about = {
    label_customer_support_hours: "Horaires du service clients",
    label_headquarters: "Si\xe8ge social"
};
var fr_product = {
    overview: "Vue d'ensemble",
    tech_specs: "Caract\xe9ristiques techniques",
    downloads: "T\xe9l\xe9chargements",
    message_invalid: "Temporairement indisponible",
    message_out_of_stock: "En rupture de stock",
    message_low_stock: "Disponible en quantit\xe9 limit\xe9e",
    message_new_item: "Nouveau",
    message_coming_soon: "Bient\xf4t Disponible",
    message_unavailable: "Indisponible",
    title_highlights: "Points forts",
    title_shipping: "Exp\xe9dition",
    title_in_the_box: "Contenu du coffret",
    button_buy_now: "Acheter maintenant",
    message_colors: "Couleurs",
    message_color: "Couleur",
    message_size: "Taille",
    message_series: "S\xe9rie",
    overview_anchor: "Pr\xe9sentation",
    tech_specs_anchor: "Caract\xe9ristiques techniques",
    downloads_anchor: "T\xe9l\xe9chargements",
    related_anchor: "Associ\xe9",
    customize_build_header: "Ou d\xe9marre un BLD",
    customize_build_subheader: "D\xe9marre un BLD avec cet article",
    customize_kb_build_subheader: "Construire un clavier personnalis\xe9",
    buy_product_header: "Assemble par toi-m\xeame",
    buy_product_subheader: "Tu en r\xeaves. Assemble-le. Fais-le.",
    buy_label: "Acheter",
    retailers_subheader: "Ach\xe8te chez nos partenaires.",
    link_all_retailers: "Voir tous les revendeurs",
    series_label: "S\xe9ries",
    label_header_bundle: "Acheter ensemble",
    label_subheader_bundle: "Faites passer votre construction au niveau sup\xe9rieur avec des produits recommand\xe9s par des experts",
    help_button_label: "Discuter maintenant",
    help_button_heading: "Tu as des questions ?",
    help_button_subheading: "Nos experts sont pr\xeats \xe0 t'aider.",
    configure_label: "Configurer",
    documentation_label: "Documentation",
    drivers_label: "Pilotes",
    miscellaneous_label: "Divers",
    resources_label: "Ressources",
    everything_you_need_label: "Everything you need",
    good_rating_label: "Bien",
    better_rating_label: "Mieux",
    best_rating_label: "Meilleur",
    key_specs_label: "Coup d'oeil"
};
var fr_collection = {
    message_invalid: "Temporairement indisponible",
    message_out_of_stock: "En rupture de stock",
    message_low_stock: "Disponible en quantit\xe9 limit\xe9e",
    message_new_item: "Nouveau",
    message_coming_soon: "Bient\xf4t disponible",
    message_unavailable: "Indisponible",
    button_buy_now: "Acheter maintenant",
    message_colors: "Couleurs",
    learn_more: "En savoir plus",
    message_color: "Couleur",
    message_size: "Taille",
    help_button_label: "Discuter maintenant",
    help_button_heading: "Tu as des questions ?",
    help_button_subheading: "Nos experts sont pr\xeats \xe0 t'aider."
};
var fr_news = {
    label_all_news: "Toutes les nouvelles"
};
var fr_retailers = {
    label_regions: "R\xe9gions",
    label_locations: "Pays",
    label_reseller_type: "Types",
    option_label_all_regions: "Toutes les r\xe9gions",
    option_label_all_locations: "Tous les pays",
    option_label_all_reseller_type: "Toutes les options",
    message_empty_state: "Aucun revendeur ne correspond aux crit\xe8res s\xe9lectionn\xe9s.",
    hero_text: "Les produits NZXT peuvent \xeatre achet\xe9s via nos partenaires dans toutes les r\xe9gions"
};
var fr_searchResults = {
    message_invalid: "Temporairement indisponible",
    message_out_of_stock: "En rupture de stock",
    message_low_stock: "Disponible en quantit\xe9 limit\xe9e",
    message_new_item: "Nouveau",
    message_coming_soon: "Bient\xf4t disponible",
    message_unavailable: "Indisponible"
};
var fr_orderTracking = {
    title_order_status: "Statut de la commande",
    label_cancelled_on: "Annul\xe9 le",
    label_shipping_date: "Date d'exp\xe9dition estim\xe9e",
    label_case: "Bo\xeetier",
    label_software: "Logiciel",
    label_services: "Services",
    label_ram: "RAM",
    label_cpu: "CPU",
    label_gpu: "GPU",
    label_motherboard: "Carte m\xe8re",
    label_storage: "Stockage",
    label_cooling: "Refroidissement",
    label_psu: "Bloc d'alimentation"
};
var fr_orderTrackingRoot = {
    title_order_tracking_root: "Saisis ton num\xe9ro de commande",
    label_build_id: "num\xe9ro de commande",
    button_track: "Suivi de commande",
    message_not_found: "introuvable, merci de r\xe9essayer"
};
var fr_refurb = {
    label_all_products: "Tous les produits",
    label_relevance: "Pertinence",
    label_price_low_high: "Prix croissant",
    label_price_high_low: "Prix d\xe9croissant",
    label_name_a_z: "Nom de A-Z",
    label_name_z_a: "Nom de Z-A",
    label_case: "Bo\xeetier",
    label_software: "Logiciel",
    label_services: "Services",
    label_ram: "RAM",
    label_cpu: "CPU",
    label_gpu: "GPU",
    label_motherboard: "Carte m\xe8re",
    label_storage: "Stockage",
    label_cooling: "Refroidissement",
    label_psu: "Bloc d'alimentation",
    label_other: "Autre",
    label_accessories: "Accessoires",
    label_fan: "Ventilateurs",
    label_any_price: "N'importe quel prix",
    label_no_products: "Aucun mat\xe9riel assembl\xe9 remis \xe0 neuf n'est actuellement disponible.",
    label_no_builds: "Aucun mat\xe9riel assembl\xe9 remis \xe0 neuf n'est actuellement disponible."
};
var fr_orderStatus = {
    confirmed_title: "Commande effectu\xe9e",
    step_label: "\xc9tape",
    confirmed_sub: "Ta commande a \xe9t\xe9 enregistr\xe9e.",
    processed_title: " Commande confirm\xe9e",
    processed_sub: "Ta commande a \xe9t\xe9 enregistr\xe9e et ton paiement a \xe9t\xe9 trait\xe9.",
    in_progress_title: "En cours",
    in_progress_sub: "Le traitement et l’assemblage de ta commande ont commenc\xe9. Ta commande est maintenant verrouill\xe9e et les modifications/annulations ne peuvent \xeatre garanties.",
    shipped_title: "Exp\xe9di\xe9",
    shipped_sub: "Votre commande est sur son chemin!",
    cancelled_title: "Annul\xe9",
    cancelled_sub: "Votre commande a \xe9t\xe9 annul\xe9e avec succ\xe8s.",
    enh_ordered_sub: "Votre commande a \xe9t\xe9 re\xe7ue et est en attente.",
    enh_picking_title_bld: "Pr\xe9paration de la construction",
    enh_picking_title: "Traitement de votre commande",
    enh_picking_sub_bld: "La cueillette et l'assemblage de votre commande ont commenc\xe9. Les modifications de votre commande ne peuvent \xeatre garanties.",
    enh_picking_sub: "Nous pr\xe9parons votre commande. Les modifications de votre commande ne peuvent \xeatre garanties.",
    enh_build_title: "Imeuble",
    enh_build_sub: "Votre commande est en cours de construction et de test.",
    enh_packing_title: "Pr\xe9paration \xe0 l'exp\xe9dition",
    enh_packing_sub_bld: "Votre commande a \xe9t\xe9 construite et test\xe9e. Il est emball\xe9 pour la livraison.",
    enh_packing_sub: "Votre commande a \xe9t\xe9 trait\xe9e et est en cours d'emballage pour la livraison.",
    enh_shipping_title: "Exp\xe9dition",
    enh_shipping_sub: "Votre commande a \xe9t\xe9 envoy\xe9e au transporteur pour livraison. Votre num\xe9ro de suivi sera mis \xe0 jour et vous sera envoy\xe9 par e-mail dans un d\xe9lai d'un jour ouvrable."
};
var fr_universal = (0,_object_spread/* default */.Z)({}, fr_cart, fr_userAccount, fr_auth, fr_formErrors, fr_camCta, fr_generic, fr_helpCta, fr_emailSignUp, fr_geoipBanner, fr_ui, fr_footer, fr_search, fr_about, fr_orderStatus);
// eslint-disable-next-line import/prefer-default-export
var fr = {
    "/": (0,_object_spread/* default */.Z)({}, fr_universal),
    "/product/[slug]": (0,_object_spread/* default */.Z)({}, fr_product, fr_universal),
    "/collection/[slug]": (0,_object_spread/* default */.Z)({}, fr_collection, fr_universal),
    "/partner/[slug]": (0,_object_spread/* default */.Z)({}, fr_collection, fr_universal),
    "/sale/[slug]": (0,_object_spread/* default */.Z)({}, fr_collection, fr_universal),
    "/about/[slug]": (0,_object_spread/* default */.Z)({}, fr_universal),
    "/legal": (0,_object_spread/* default */.Z)({}, fr_universal),
    "/legal/[slug]": (0,_object_spread/* default */.Z)({}, fr_universal),
    "/news/[slug]": (0,_object_spread/* default */.Z)({}, fr_news, fr_universal, fr_category),
    "/news/page/[page]": (0,_object_spread/* default */.Z)({}, fr_universal, fr_category),
    "/news/category/[category]": (0,_object_spread/* default */.Z)({}, fr_universal, fr_category),
    "/news/category/[category]/page/[page]": (0,_object_spread/* default */.Z)({}, fr_universal, fr_category),
    "/user/[slug]": (0,_object_spread/* default */.Z)({}, fr_universal, fr_build, fr_keyboard),
    "/software/[slug]": (0,_object_spread/* default */.Z)({}, fr_universal),
    "/category/[slug]": (0,_object_spread/* default */.Z)({}, fr_category, fr_universal),
    "/category/[slug]/[subcategory-slug]": (0,_object_spread/* default */.Z)({}, fr_category, fr_universal),
    "/build": (0,_object_spread/* default */.Z)({}, fr_universal, fr_build),
    "/build/[slug]": (0,_object_spread/* default */.Z)({}, fr_universal, fr_build),
    "/build/pc": (0,_object_spread/* default */.Z)({}, fr_universal, fr_build),
    "/build/pc/[slug]": (0,_object_spread/* default */.Z)({}, fr_universal, fr_build),
    "/build/keyboard/[slug]": (0,_object_spread/* default */.Z)({}, fr_universal, fr_build, fr_keyboard),
    "/build/[slug]/summary": (0,_object_spread/* default */.Z)({}, fr_universal, fr_build),
    "/support": (0,_object_spread/* default */.Z)({}, fr_universal),
    "/refurbished/[slug]": (0,_object_spread/* default */.Z)({}, fr_universal, fr_refurb),
    "/careers": (0,_object_spread/* default */.Z)({}, fr_universal),
    "/reviews/page/[page]": (0,_object_spread/* default */.Z)({}, fr_universal),
    "/careers/available-positions": (0,_object_spread/* default */.Z)({}, fr_universal),
    "/order-tracking/[slug]": (0,_object_spread/* default */.Z)({}, fr_orderTracking, fr_orderTrackingRoot, fr_universal),
    "/order-tracking": (0,_object_spread/* default */.Z)({}, fr_orderTrackingRoot, fr_universal),
    "/retailers": (0,_object_spread/* default */.Z)({}, fr_retailers, fr_universal),
    "/search": (0,_object_spread/* default */.Z)({}, fr_searchResults, fr_universal),
    "/auth/[slug]": (0,_object_spread/* default */.Z)({}, fr_universal),
    universal: fr_universal
};

;// CONCATENATED MODULE: ./locale/it.ts
/* eslint-disable max-len */ 
var it_userAccount = {
    user_settings_title: "Account",
    user_settings_change_password: "Cambia la password",
    user_settings_save: "Salva",
    user_settings_cancel: "Annulla",
    user_profile_heading: "Profilo",
    user_saved_builds_heading: "Build salvate",
    user_saved_builds_bld_name: "Nome build",
    user_saved_builds_bld_date: "Data di creazione",
    user_saved_builds_bld_item_part: "Parte",
    user_saved_builds_delete_bld: "Elimina BLD",
    user_saved_builds_resume_bld: "Riprendi BLD",
    user_saved_builds_hero_title: "Progettato per mostrare la tua build",
    user_saved_builds_hero_text: "Il design verticale compatto mantiene il supporto per la maggior parte delle GPU di dimensioni standard sul mercato in modo da poter mantenere lo spazio sulla scrivania senza sacrificare la potenza grafica.",
    user_saved_builds_pc_heading: "Costruzioni di PC",
    user_saved_builds_keyboard_heading: "Costruzioni di tastiere",
    user_saved_builds_view_pc: "Visualizza i PC costruiti",
    user_saved_builds_view_keyboard: "Visualizza le costruzioni della tastiera",
    user_saved_builds_no_pc: "Non hai build salvate per il PC",
    user_saved_builds_no_kb: "Non hai memorizzato nessuna build di tastiera",
    user_order_history_heading: "Cronologia degli ordini",
    user_order_history_date: "Data",
    user_order_history_order_number: "Numero dell’ordine",
    user_order_history_status: "Stato",
    user_order_history_amount: "Quantit\xe0",
    user_order_history_view: "Visualizza ricevuta",
    user_order_history_empty_view: "Non hai cronologia ordini.",
    user_order_history_shipping: "Indirizzo di spedizione",
    user_order_history_billing: "Indirizzo di fatturazione",
    user_order_history_item: "Articolo",
    user_order_history_item_image: "Immagine articolo",
    user_order_history_quantity: "Quantit\xe0",
    user_order_history_order: "Ordine #",
    user_support_heading: "Assistenza + resi",
    user_data_heading: "Richiesta dati",
    user_terms_heading: "Termini",
    user_terms_empty: "Non hai ancora firmato i termini.",
    user_support_subject_min_length: "L’oggetto deve contenere almeno 3 caratteri",
    user_support_message_placeholder: "Esponi i motivi per cui ci contatti. Se \xe8 una restituzione, includi il numero",
    user_support_update_button: "Aggiornamento",
    user_active_tickets_heading: "Ticket attivi",
    user_active_tickets_chat: "Aggiungi un messaggio",
    user_active_tickets_no_chat_history: "Non hai una cronologia della chat",
    view_chat_button: "Visualizza chat",
    close_chat_button: "Chiudi chat",
    field_required_message: "Questo campo \xe8 obbligatorio",
    label_accept: "Accettare",
    label_reason_for_contact: "Motivo del contatto",
    label_country: "Paese",
    label_subject: "Soggetto",
    label_product: "Prodotto",
    label_message: "Messaggio",
    label_requestor_type: "Tipo richiedente",
    label_country_of_residence: "Paese di residenza",
    label_description: "Descrizione",
    placeholder_description: "Descrizione della tua richiesta",
    label_submit: "Invia",
    message_no_support_requests: "Non hai richieste di supporto attive",
    label_ticket_number: "Numero del ticket",
    label_date_created: "data di creazione",
    label_status: "Stato",
    label_department: "Dipartimento",
    subheading_active_ticket: "Se hai bisogno di aiuto o stai cercando di restituire un articolo, contatta l'assistenza.",
    label_create_support_request: "Crea richiesta di supporto",
    button_comment: "Commento",
    label_for_myself: "Per me",
    label_parent: "Genitore",
    label_legal_rep: "Rappresentante legale",
    label_relative: "Parente",
    label_guardian: "Custode",
    label_accept_generic_terms: "Ho letto e accetto questi termini",
    error_view_message: "Spiacenti, si \xe8 verificato un problema.",
    signout_view_message: "Sei stato disconnesso.",
    user_order_history_close: "Chiudi",
    birthday_error_message: "Inserisci una data di nascita valida",
    label_view_saved: "Visualizza tutte le build salvate"
};
var it_formErrors = {
    invalid_email: "Digita un indirizzo e-mail valido",
    username_full_pattern_message: "Il nome utente deve essere lungo da 6 a 30 caratteri. Puoi utilizzare lettere, numeri e punti ma non puoi iniziare, finire o contenere punti consecutivi.",
    password_pattern_message: "La password deve contenere almeno sei caratteri, una lettera maiuscola, una lettera minuscola e un numero",
    username_min_length_message: "Utilizza 6 caratteri o pi\xf9 per il nome utente",
    passwords_must_match: "Le password devono combaciare",
    invalid_current_password: "Impossibile aggiornare la password. Il valore fornito come password corrente non \xe8 corretto",
    must_accept_partner_program_terms: "Devi accettare i Termini del Programma Partner per diventare un partner NZXT",
    must_accept_tos_terms: "Devi accettare i Termini di Servizio per creare un account NZXT",
    must_accept_generic_terms: "Devi accettare questi termini"
};
var it_auth = {
    user_auth_agreement: "Accetto NZXT's",
    user_auth_privacy_policy: "Informativa sulla privacy",
    user_auth_and: "e ho letto la",
    user_auth_terms: "ai Termini di utilizzo.",
    error_invalid_request: "Richiesta non valida.",
    error_invalid_token: "Token di autenticazione utente non valido",
    error_session_expired: "La tua sessione \xe8 scaduta. Effettua nuovamente il login per continuare.",
    user_forgot_required_email: "\xc8 richiesto un indirizzo e-mail",
    user_forgot_success_message: "Grazie! Se \xe8 presente un account associato a questa email, invieremo immediatamente le istruzioni per la reimpostazione della password.",
    error_email_exists: "L'email \xe8 gi\xe0 in uso",
    user_email_verification_heading: "verifica email",
    error_email_not_verified: "L'indirizzo email non \xe8 ancora verificato. Per inviare nuovamente l'e-mail di verifica, fare clic su",
    error_email_already_verified: "L'indirizzo email \xe8 gi\xe0 stato verificato. Si prega di continuare ad accedere.",
    user_email_verification_success_message: "Il tuo indirizzo email \xe8 stato verificato con successo!. Si prega di continuare ad accedere.",
    error_username_unavailable: "Il nome utente non \xe8 disponibile",
    error_reset_password_same_as_old_password: "Questa password \xe8 la stessa di prima. Selezionane un altra.",
    error_reset_password_link_expired: "Il collegamento per reimpostare la password \xe8 scaduto.",
    error_reset_password_link_invalid: "Il collegamento per reimpostare la password non \xe8 valido.",
    user_forgot_password_subheading: "Inserisci la tua email per ricevere istruzioni su come reimpostare la password.",
    user_reset_password_heading: "reimposta la tua password",
    user_reset_password_subheading: "Per favore inserisci una nuova password.",
    user_reset_password: "Resetta la password",
    user_reset_success_message: "Hai reimpostato con successo la tua password!",
    user_login_text: "Accedi con Google",
    user_login_remember: "Ricordami",
    user_login_forgot_password: "Hai dimenticato la password?",
    user_login_wrong_email_or_password: "Indirizzo e-mail o password errato/a",
    user_login_success_message: "Hai effettuato il log in con successo!",
    user_sign_up_success_verify_message: "Fino all’avvenuta verifica l’account non sar\xe0 attivo. Se non ricevi il messaggio e-mail entro qualche minuto controlla anche la cartella spam.",
    error_too_many_requests: "Hai fatto troppe richieste. Attendi qualche minuto o contatta l'assistenza",
    error_user_not_found: "L'utente non \xe8 stato trovato",
    user_sign_in_sign_up: "Accedi / registrati",
    user_sign_out: "Esci",
    user_sign_in: "Accedi",
    user_account_updates: "Aggiornamenti NZXT",
    user_account_no_updates: "Nessun aggiornamento recente, ricontrolla pi\xf9 tardi.",
    support_center_link: "Aiuto e Assistenza",
    error_google_account_exists: "Hai gi\xe0 creato un account utilizzando Google. Effettua invece il login.",
    error_local_account_exists: "Sembra che tu abbia gi\xe0 un account. Effettua invece il login.",
    user_sign_up: "Registrati",
    user_sign_up_text: "Registrati con Google",
    user_sign_up_opt_in: "Iscriviti alla Mailing List per ricevere aggiornamenti su prodotti, BLD e CAM da parte di NZXT",
    user_sign_up_check_email_message: "Controlla la tua casella e-mail e clicca sul link per attivare il tuo account.",
    user_info_updated_success_message: "Le tue informazioni sono state aggiornate con successo!",
    user_info_newsletter_confirmation_message: "Controlla la tua email per la conferma.",
    user_email_sign_in: "Oppure continua con",
    user_no_account: "Non sei ancora registrato?",
    user_create_account: "Crea account",
    user_email_sign_up_text: "Oppure iscriviti con",
    user_have_account: "Hai gi\xe0 un account?",
    open_login_view: "Apri la visualizzazione dell’accesso",
    error_newsletter_subscription: "Al momento non \xe8 possibile iscriversi / annullare l'iscrizione alla newsletter. Per favore riprova pi\xf9 tardi.",
    user_login_too_many_requests: "Hai effettuato troppe richieste. Attendi qualche minuto o contatta l’assistenza",
    label_email_address: "Indirizzo E-mail",
    label_password: "Password",
    label_current_password: "password attuale",
    label_confirm_password: "conferma password",
    label_new_password: "nuova password",
    label_confirm_new_password: "Conferma la nuova password",
    label_username: "Nome utente",
    label_first_name: "Nome di battesimo",
    label_last_name: "Cognome",
    label_preferred_pronouns: "Pronomi preferiti",
    label_search_for_help_articles: "Cerca articoli di aiuto",
    label_birthday: "Compleanno",
    label_location: "Posizione",
    app_access: "desidera accedere ai seguenti dati del tuo account NZXT:",
    app_access_has_scopes: "vuole accedere al tuo account NZXT",
    scope_profile: "il tuo profilo, compresi il nome e l’immagine",
    scope_email: "il tuo indirizzo e-mail",
    scope_address: "Il tuo indirizzo fisico",
    scope_phone: "Il tuo numero di telefono",
    grant_offline_access: "Avere accesso offline",
    grant_offline_access_previous: "che hai precedentemente concesso"
};
var it_build = {
    custom_bld_modal_heading: "Costruisci il tuo PC",
    custom_bld_modal_subheading: "Seleziona il tuo chipset e il tuo budget",
    custom_bld_unavailable: "Seleziona un articolo",
    custom_bld_issue: "I seguenti elementi devono essere risolti: ",
    custom_bld_title: "Build personalizzata",
    custom_bld_lets_get_started: "Cominciamo",
    custom_bld_destrutive_action: "Attenzione: Reimpostazione della build",
    custom_bld_confirm_reset: "La tua build sar\xe0 reimpostata con il seguente chipset:",
    custom_bld_keyboard_confirm_reset: "La tua build sar\xe0 resettata con questo cambiamento",
    custom_bld_choose_chipset: "Scegli il tuo chipset",
    custom_bld_chipset: "Chipset",
    custom_bld_intel: "Intel",
    custom_bld_amd: "AMD",
    custom_bld_explore: "Esplora",
    custom_bld_select: "Seleziona",
    review_bld_button: "Rivedi Build",
    custom_bld_summary: "Riepilogo",
    custom_bld_budget: "Budget",
    custom_bld_specs: "Specifiche",
    custom_bld_case: "Case",
    custom_bld_cases: "Case",
    custom_bld_caseCooling: "Raffreddamento",
    custom_bld_fans: "Ventole",
    custom_bld_cpu: "CPU",
    custom_bld_gpu: "GPU",
    custom_bld_ram: "RAM",
    custom_bld_ssd: "SSD",
    custom_bld_hdd: "HDD",
    custom_bld_specials: "Elementi speciali",
    custom_bld_colors: "Colori",
    custom_bld_color: "Colore",
    custom_bld_black: "Nero",
    custom_bld_red: "Rosso",
    custom_bld_white: "Bianca",
    custom_bld_grey: "Grigio",
    custom_bld_blue: "Blu",
    custom_bld_purple: "Viola",
    custom_bld_yellow: "Giallo",
    custom_bld_audio: "Audio",
    custom_bld_extras: "Elementi supplementari",
    custom_bld_core: "Core",
    custom_bld_motherboard: "Scheda madre",
    custom_bld_motherboards: "Schede madri",
    custom_bld_powerSupplies: "Alimentatori",
    custom_bld_powerSupply: "Alimentatore",
    custom_bld_services: "Servizi",
    custom_bld_software: "Software",
    custom_bld_monitors: "Monitor",
    custom_bld_peripherals: "Periferiche",
    custom_bld_lighting: "Illuminazione",
    custom_bld_headset: "Cuffie",
    custom_bld_keyboard: "Tastiere",
    custom_bld_all: "Tutti",
    custom_bld_mouse: "Mouse",
    custom_bld_storage: "Supporti di memoria",
    custom_bld_streaming_ready: "Pronto per lo streaming",
    custom_bld_rgb_lighting: "Illuminazione RGB",
    custom_bld_vr_ready: "Pronto per la VR",
    custom_bld_wifi: "WiFi",
    custom_bld_from: "Da",
    custom_bld_bluetooth: "Bluetooth",
    custom_bld_save_build_message: 'La tua build \xe8 stata salvata con successo! Puoi visualizzarla in "Build salvate" nel tuo account.',
    custom_bld_save_modal_message: "Vuoi salvare questa configurazione per dopo?",
    custom_bld_confirm_save_modal_message: "Lasciando questa pagina perderai le modifiche non salvate",
    custom_bld_share_build_message: "La tua build \xe8 stata salvata e copiata con successo!",
    help_me_decide: "Aiutami a Decidere",
    save_build: "Salva Build",
    start_over: "Ricomincia da Capo",
    summary: "Riepilogo",
    build_summary: "Riepilogo Build",
    load_build: "Carica Build",
    est_shipping: "Spedizione stimata il",
    add_to_build: "Aggiungi alla Build",
    load: "Caricare",
    save: "Salva",
    restart: "Ricomincia",
    share: "Condividere",
    my_build_label: "La mia build",
    message_invalid: "Temporaneamente non disponibile",
    message_out_of_stock: "Esaurito",
    message_low_stock: "Disponibile in quantit\xe0 limitate",
    message_new_item: "Nuovo",
    message_coming_soon: "Prossimamente",
    message_best_seller: "Miglior venditore",
    message_is_locked: "Non Compatibile",
    button_label_select: "Seleziona",
    button_label_selected: "Selezionata",
    button_label_add: "Aggiungi",
    button_label_remove: "Rimuovi",
    button_label_added: "Aggiunta",
    button_label_update: "Aggiornamento",
    button_label_info: "Informazioni",
    button_label_more_info: "Maggiori informazioni",
    button_label_options_info: "Opzioni e Informazioni",
    button_label_continue_to: "Continua a configurare la build",
    button_label_edit: "Modifica",
    build_fps_label: "Le velocit\xe0 FPS sono misurate a una risoluzione di 2560x1440 utilizzando l'impostazione grafica pi\xf9 alta di ogni gioco",
    build_includes: "Include",
    custom_bld_boost: "Potenzia la tua build",
    custom_bld_fps_unavailable: "In attesa di",
    custom_bld_amd_help: "I PC basati su Intel sono stati la norma negli ultimi anni ma i PC AMD sono fantastici per i giochi ora. Ti aiuteremo a costruirli entrambi e abbiamo scelto per te schede madri e dispositivi di raffreddamento compatibili tra loro. TI consigliamo di bilanciare le prestazioni FPS suggerite nelle build con altri componenti che preferisci e su cui sei disposto a investire.",
    custom_bld_to_see_this: "Per vedere questa selezione dovrai",
    custom_bld_change_chipset: "modificare la tua selezione.",
    performance: "Prestazioni",
    message_error: "Oh-oh, sembra si sia verificato un errore",
    custom_bld_prebuild_upsell: "Oppure scegli preassemblati facili e veloci",
    no_item_selected: "Nessun Elemento Selezionato",
    build_change_label: "Build Modificata",
    invalid_action_label: "Errore",
    success_label: "Successo",
    build_info_message: "Informazioni",
    reset_label: "Ripristina Build",
    complete_build_label: "Completa la tua Build",
    back_to_build_label: "Torna alla tua Build",
    complete_build_sub_label: "Extra e Periferiche",
    back_to_build_sub_label: "Componenti principali della tua build",
    capacity_label: "Capacit\xe0",
    option_label: "Opzione",
    options_label: "Opzioni",
    max_speed: "Massima velocit\xe0",
    modular_label: "Modulare",
    midtower_label: "Mid-Tower",
    streaming_label: "Streaming",
    save_and_exit: "Salvare e uscire",
    exit: "Uscire",
    view_cart_label: "Visualizza Carrello",
    cart_subtotal_label: "Subtotale del carrello",
    start_build_label: "Nuova build",
    new_build_label: "Nuova build",
    continue_saved_build_label: "Continua la tua build salvata",
    continue_progress_build_label: "Continua la costruzione che hai in corso",
    continue_cart_build_label: "Rivedi la build nel tuo carrello",
    core_label: "Base",
    extras_label: "Add-ons",
    summary_label: "Riepilogo",
    share_build_pc: "PC personalizzato",
    share_build_kb: "Tastiera personalizzata",
    build_summary_label: "Panoramica della configurazione di tastiera.",
    pc_hub_card_heading: "PC da gioco personalizzati",
    pc_hub_card_subheading: "Crea il tuo PC da sogno in base al tuo budget e ottimizzato per i giochi che ami.",
    kb_hub_card_heading: "Tastiere personalizzate",
    kb_hub_card_subheading: "Crea una tastiera e un mouse personalizzati da abbinare al tuo spazio e stile di gioco."
};
var it_keyboard = {
    keyboard_label: "Tastiera",
    keyboard_size: "Dimensione della tastiera",
    keyboard_base: "Base tastiera",
    keyboard_primay_base_color: "Colore di base",
    keyboard_layout: "Layout tastiera",
    keyboard_summary: "Riepilogo tastiera",
    accent_keycaps: "Tasti colorati",
    cabletype: "Cavo colorato",
    additional_cable_color: "Colore del cavo",
    cable: "Cavo",
    additional_cable: "Cavo aggiuntivo",
    primary_keycaps: "Tasti di base",
    switches: "Switch",
    size: "Dimensione",
    layout: "Layout",
    language: "Lingua",
    mouse_pad_label: "Tappetino per mouse",
    desk_mat_label: "Tappetino per scrivania",
    tools_label: "Strumenti",
    mouse_label: "Mouse",
    wrist_rest_label: "Strumenti",
    cable_description: "Cavo colorato opzionale. Un cavo nero standard di 2 metri sar\xe0 incluso.",
    cable_color_description: "Colore del cavo premium.",
    language_description: "Determina la posizione dei tasti Q, W, Z e A. ",
    layout_description: "Determina la dimensione e la posizione dei tasti.",
    keycap_accent_description: "Colore opzionale per i tasti Escape, Enter, Frecce e Enter del tastierino numerico",
    primary_keycap_description: "PBT a sublimazione termica, profilo Cherry.",
    switch_description: "Definisce l'esperienza di digitazione di ogni tasto premuto.",
    keyboard_base_color_description: "Colore primario della base tastiera.",
    keyboard_base_size_description: "Determina il numero di tasti e la dimensione della tastiera.",
    mouse_description: "Mouse ambidestro leggero.",
    summary_description: "Panoramica della configurazione della tua tastiera",
    premium_label: "Premium",
    base_label: "Base",
    keyboard_warning: "Si prega di selezionare i seguenti elementi per procedere con la costruzione:",
    switch_reset_warning: "I tuoi interruttori sono stati resettati. Si prega di selezionare nuovi interruttori.",
    keycap_reset_warning: "I tuoi cappucci sono stati resettati. Si prega di selezionare nuovi keycaps.",
    base_type: "Tipo di configurazione",
    build_type_description: "Seleziona il tipo di tastiera che vuoi configurare",
    full_custom_label: "Personalizzazione completa",
    barebones_disclaimer: "Cambia la tua build per selezionare questo elemento",
    none_label: "Nessuno"
};
var it_camCta = {
    cam_description: "Gestisci Performance, Temperature e Dispositivi con un’unica applicazione.",
    cam_windows_10: "WINDOWS 10 64BIT"
};
var it_helpCta = {
    help_description: "Ricevi guide approfondite e assistenza su tutti i prodotti NZXT, oltre che sulle garanzie, i resi e qualsiasi questione di natura tecnica."
};
var it_emailSignUp = {
    email_stay_in_touch: "Resta in Contatto",
    email_sub_copy: "Rimani aggiornato sulle ultime uscite, offerte e notizie riguardanti NZXT",
    email_legal: "Registrandoti acconsenti a NZXT, CAM e BLD ",
    email_notify: "Avvisami",
    email_notify_stock: "Ricevi una notifica quando questo articolo \xe8 disponibile.",
    estimated_performance_label: "Prestazioni stimate",
    see_estimated_performance_label: "Visualizza le prestazioni stimate"
};
var it_generic = {
    explore: "Esplora",
    cam_title: "NZXT CAM",
    free_download: "Download Gratuito",
    details: "Dettagli",
    help_amp_support: "Aiuto e Assistenza",
    help_and_support: "Aiuto e Assistenza",
    read_more: "Continua a leggere",
    privacy_policy: "Informativa sulla privacy",
    terms_conditions: "Termini e Condizioni",
    and: "e",
    or: "o",
    send: "Spedire",
    return_to: "Ritornare a",
    previous: "Precedente",
    next: "Successivo",
    home: "Home",
    keep_browsing: "Continua a navigare",
    create_build: "Crea Build",
    learn_more: "Scopri di pi\xf9",
    add_to_cart: "Aggiungi al Carrello",
    share_build: "Condividi Build",
    view: "Visualizza",
    close: "Chiudi",
    price: "Prezzo",
    allow: "Permettere",
    cancel: "Annulla",
    here: "Qui",
    ok: "Ok",
    button_start_bld: "Inizia Build",
    message_on_sale: "In Sconto",
    button_buy: "Compra",
    button_start_build: "Inizia Build",
    view_build: "Visualizza Build",
    button_back: "Indietro",
    performance: "Prestazione",
    build: "Build",
    error_generic: "Qualcosa \xe8 andato storto, riprova pi\xf9 tardi.",
    label_support: "Servizio clienti",
    contact_support: "Contatta il supporto",
    browse_articles: "Sfoglia Gli Articoli",
    search_support_articles: "Cerca articoli della guida",
    message_error: "Uh-oh, qualcosa \xe8 andato storto",
    title_related_items: "Potrebbe piacerti anche",
    estimated_performance_label: "Prestazioni Stimate",
    see_estimated_performance_label: "Vedi Prestazioni Stimate",
    estimated_fps: "FPS (fotogrammi al secondo) stimati",
    qty: "QTY",
    category_from: "Da",
    reviews_label: "Recensioni",
    message_invalid: "Temporaneamente non disponibile",
    message_out_of_stock: "Esaurito",
    message_low_stock: "Disponibile in quantit\xe0 limitate",
    message_new_item: "Nuovo",
    message_coming_soon: "Prossimamente",
    message_best_seller: "Miglior venditore",
    message_unavailable: "Non disponibile",
    message_featured_items: "Prodotti in evidenza nell'immagine",
    message_colors: "Colori",
    message_color: "Colore",
    label_return_policy: "Politica di ritorno",
    label_warranty_policy: "Politica di garanzia",
    label_shop: "Acquista",
    label_days: "Giorni",
    label_hours: "Ore",
    label_minutes: "Minuti",
    label_seconds: "Secondi",
    label_promotion: "Vedi promozione",
    label_promotions: "Promozioni",
    monthly_payments: "Pagamenti mensili disponibili.",
    message_promotion: "Promozione",
    discount_label: "di sconto",
    off_label: "Inattivo",
    on_label: "acceso",
    choose_label: "Scegliere",
    move_to_previous_label: "Vai alla diapositiva precedente",
    move_to_next_label: "Passa alla prossima diapositiva",
    active_slide_label: "Diapositiva attiva",
    move_to_inactive_slide: "Passa alla diapositiva inattiva",
    color_options: "Opzioni di colore",
    of: "di",
    product_images: "Immagini del prodotto",
    for: "per",
    carousel: "Carosello",
    go_to_image: "Vai all'immagine",
    button_label_add: "Aggiungi",
    button_label_remove: "Rimuovi",
    increase_price_label: "Aumentare il prezzo",
    decrease_price_label: "Diminuire il prezzo",
    select_video_label: "Seleziona il video",
    play_label: "Gioca",
    pause_label: "Pausa",
    buttons: "Pulsanti",
    open_modal_label: "Aprire la modalit\xe0 di zoom dell'immagine",
    close_modal_label: "Chiudi immagine Zoom modale",
    image_zoom_modal: "Zoom modale dell'immagine",
    vr_ready_label: "VR Ready",
    vr_not_ready_label: "Non VR Ready",
    streaming_ready_label: "Stream Ready",
    streaming_not_ready_label: "Non Stream Ready",
    has_wifi_label: "Dispone di WiFi",
    no_wifi_label: "No WiFi",
    has_bluetooth_label: "Dispone di Bluetooth",
    no_bluetooth_label: "No Bluetooth",
    has_usbc_label: "Dispone di USB-C",
    no_usbc_label: "No USB-C",
    rgb_included_label: "Illuminazione RGB inclusa",
    rgb_not_included_label: "Illuminazione RGB non inclusa",
    products_label: "Prodotti",
    upsell_modal_label: "Acquistati spesso insieme",
    no_thanks_label: "No grazie",
    label_deal_ends: "L'offerta termina in",
    label_show_less: "Mostra meno",
    label_show_more: "Mostra di pi\xf9",
    label_case: "Case",
    label_software: "Software",
    label_services: "Servizi",
    label_ram: "RAM",
    label_cpu: "Processore",
    label_gpu: "GPU",
    label_motherboard: "Scheda madre",
    label_storage: "Supporto di memoria",
    label_cooling: "Raffreddamento",
    label_psu: "Alimentatore",
    label_warranty: "Garanzia",
    label_accessories: "Accessori",
    label_fps: "FPS",
    label_feature: "Caratteristica"
};
var it_cart = {
    cart_heading: "Il tuo carrello",
    cart_heading_empty: "Il tuo carrello \xe8 vuoto",
    cart_subheading_empty: "Trova prodotti di tuo gusto",
    cart_free_shipping_cta: "Ti mancano 25 $ per usufruire della spedizione gratuita!",
    cart_free_shipping_exclusion: "(Esclude i PC personalizzati e pre-assemblati)",
    cart_free_shipping_promo_cta: "Spedizione gratuita su tutti gli ordini",
    cart_heading_error: "Si \xe8 verificato un errore. Ritenta.",
    cart_heading_success: "Grazie!",
    cart_label_subtotal: "Totale parziale",
    cart_label_taxes: "IVA",
    cart_value_taxes: "Calcolata al momento del pagamento",
    cart_label_shipping: "Spedizione",
    cart_value_shipping_free: "GRATIS",
    cart_value_disclaimer: "*I prodotti nuovi o ricondizionati potrebbero essere lavorati e spediti con tempistiche diverse.",
    cart_label_total: "Totale",
    cart_button_checkout: "Vai alla cassa",
    cart_terms_message: "Accetto i",
    cart_terms_link_text: "termini e le condizioni di servizio",
    cart_value_taxes_non_us: "Inclusa",
    cart_value_shipping_calculated: "Calcolato al momento del pagamento",
    cart_consent_i_have_read: "Ho letto il",
    cart_consent_privacy_policy: "politica sulla riservatezza",
    cart_consent_privacy_policy_after: " ",
    cart_au_terms_message: "Accetto il",
    cart_au_terms_link: "Termini di Servizio",
    cart_au_consent_message: "Acconsento alla raccolta e all'utilizzo delle mie informazioni personali in conformit\xe0 con il",
    cart_au_consent_link: "Politica Sulla Riservatezza",
    cart_au_terms_text_1: "NZXT Pty Ltd (ABN 47 645 981 559) fornisce i beni e servizi che hai ordinato ai sensi della sua",
    cart_au_terms_text_terms_link: "Termini e Condizioni",
    cart_au_terms_text_2: "e raccoglie, utilizza e divulga le informazioni personali che raccoglie da te in conformit\xe0 con le sue",
    cart_au_terms_text_privacy_link: "Politica Sulla Riservatezza",
    cart_label_ssd: "SSD",
    cart_label_hdd: "HDD",
    cart_label_service: "Servizi",
    cart_label_software: "Software",
    cart_label_case: "Case",
    cart_label_motherboard: "Scheda madre",
    cart_label_cpu: "CPU",
    cart_label_gpu: "GPU",
    cart_label_power_supply: "Alimentatore",
    cart_label_cpu_cooler: "CPU Raffreddamento",
    cart_label_rgb: "RGB",
    cart_label_fans: "Ventole",
    cart_label_ram: "RAM",
    cart_label_monitors: "Monitor",
    cart_label_peripherals: "Periferiche",
    cart_label_extras: "Elementi Supplementari",
    message_colors: "Colori",
    cart_label_keycaps: "Copritasti",
    cart_label_keycap_accents: "Accenti dei tasti",
    cart_label_switches: "Interruttori",
    cart_label_keyboard_base: "Base della tastiera",
    cart_label_keycap_accent: "Tasti accentati",
    cart_label_accent_cable: "Cavo d'accento",
    cart_label_mouse: "Mouse",
    cart_message_item_fallback: "Questo oggetto",
    cart_message_build_item_oos_before: "Un articolo della tua",
    cart_message_build_item_oos_after: "\xe8 esaurito. Fai clic qui per aggiornare la tua build e aggiungerla al carrello.",
    cart_message_oos: "\xe8 attualmente esaurito. Si prega di rimuovere questo articolo per procedere al pagamento."
};
var it_category = {
    explore_refurbished: "Esplora le Build",
    explore_bulk: "Esplora quantit\xe0 all’ingrosso",
    bulk: "Quantit\xe0 all’ingrosso",
    refurbished: "Ricondizionata",
    refurbished_cta: "Abbiamo contribuito a fornire build in grandi quantit\xe0 ad aziende di videogiochi, universit\xe0, organizzazioni di sport elettronici e altri..",
    bulk_cta: "Abbiamo contribuito a fornire build in grandi quantit\xe0 ad aziende di videogiochi, universit\xe0, organizzazioni di sport elettronici e altri."
};
var it_geoipBanner = {
    currently_browsing: "Navigazione attuale",
    banner_region_text: "Passa alla tua regione per acquistare o visualizzare contenuti specifici per la tua localit\xe0.",
    banner_button: "Passa a",
    banner_country_text_shop: "Negozio",
    banner_counrty_text: "o seleziona un altro paese specifico per la tua posizione.",
    country_us: "Stati Uniti",
    country_canada: "Canada",
    country_belgium: "Belgio",
    country_germany: "Germania",
    country_luxembourg: "Lussemburgo",
    country_netherlands: "Olanda",
    country_austria: "Austria",
    country_france: "Francia",
    country_italy: "Italia",
    country_spain: "Spagna",
    country_uk: "Regno Unito",
    country_australia: "Australia",
    country_nz: "Nuova Zelanda",
    country_japan: "Giappone",
    region_na: "Nord America",
    region_europe: "Europa",
    region_oceania: "Oceania"
};
var it_ui = {
    loading: "Caricamento in corso"
};
var it_footer = {
    label_language: "Lingua",
    label_country: "Paese",
    manage_cookie_preferences: "Gestisci le preferenze sui cookie",
    all_rights_reserved: "Tutti i diritti sono riservati"
};
var it_search = {
    label_suggested_queries: "Ricerche suggerite",
    label_suggested_results: "Risultati suggeriti",
    label_serp_heading: "Cerca i risultati per",
    label_serp_not_found: "Nessun risultato trovato per",
    label_serp_total: "tutti i risultati",
    label_serp_suggested: "Prova a cercare"
};
var it_about = {
    label_customer_support_hours: "Orari dell’assistenza clienti",
    label_headquarters: "Sede centrale"
};
var it_product = {
    overview: "Panoramica",
    tech_specs: "Specifiche tecniche",
    downloads: "Download",
    message_invalid: "Temporaneamente non disponibile",
    message_out_of_stock: "Esaurito",
    message_low_stock: "Disponibile in quantit\xe0 limitate",
    message_new_item: "Nuova",
    message_coming_soon: "Prossimamente",
    message_unavailable: "Non disponibile",
    title_highlights: "Punti di forza",
    title_shipping: "Spedizione",
    title_in_the_box: "Cosa contiene la scatola",
    button_buy_now: "Compra ora",
    message_colors: "Colori",
    message_color: "Colore",
    message_size: "Dimensione",
    message_series: "Serie",
    overview_anchor: "Panoramica",
    tech_specs_anchor: "Specifiche tecniche",
    downloads_anchor: "Download",
    related_anchor: "Correlato/a",
    customize_build_header: "Personalizza",
    customize_build_subheader: "Inizia una build con questo articolo",
    customize_kb_build_subheader: "Costruire una tastiera personalizzata",
    buy_product_header: "Fai da te",
    buy_product_subheader: "Sognala. Costruiscila. Creala.",
    buy_label: "Compra",
    retailers_subheader: "Acquista dai nostri partner.",
    link_all_retailers: "Visualizza tutti i rivenditori",
    series_label: "Serie",
    label_header_bundle: "Acquista insieme",
    label_subheader_bundle: "Porta la tua build al livello successivo con i prodotti consigliati dagli esperti",
    help_button_label: "Chatta adesso",
    help_button_heading: "Hai domande?",
    help_button_subheading: "I nostri esperti sono pronti ad aiutare.",
    configure_label: "Configura",
    documentation_label: "Documentazione",
    drivers_label: "Driver",
    miscellaneous_label: "Varie",
    resources_label: "Risorse",
    everything_you_need_label: "Everything you need",
    good_rating_label: "Buono",
    better_rating_label: "Ottimo",
    best_rating_label: "Il migliore",
    key_specs_label: "Specifiche Principali"
};
var it_collection = {
    message_invalid: "Temporaneamente non disponibile",
    message_out_of_stock: "Esaurito",
    message_low_stock: "Disponibile in quantit\xe0 limitate",
    message_new_item: "Nuova",
    message_coming_soon: "Prossimamente",
    message_unavailable: "Non disponibile",
    button_buy_now: "Compra ora",
    message_colors: "Colori",
    learn_more: "Scopri di pi\xf9",
    message_color: "Colore",
    message_size: "Dimensione",
    help_button_label: "Chatta adesso",
    help_button_heading: "Hai domande?",
    help_button_subheading: "I nostri esperti sono pronti ad aiutare."
};
var it_news = {
    label_all_news: "All News"
};
var it_retailers = {
    label_regions: "Regioni",
    label_locations: "Localit\xe0",
    label_reseller_type: "Tipo",
    option_label_all_regions: "Tutte le regioni",
    option_label_all_locations: "Tutte le localit\xe0",
    option_label_all_reseller_type: "Tutte le opzioni",
    message_empty_state: "Nessun rivenditore corrisponde ai criteri selezionati.",
    hero_text: "I prodotti NZXT possono essere acquistati dai nostri partner in tutte le regioni"
};
var it_searchResults = {
    message_invalid: "Temporaneamente non disponibile",
    message_out_of_stock: "Esaurito",
    message_low_stock: "Disponibile in quantit\xe0 limitate",
    message_new_item: "Nuovo",
    message_coming_soon: "Prossimamente",
    message_unavailable: "Non disponibile"
};
var it_orderTracking = {
    title_order_status: "Stato dell'ordine",
    label_cancelled_on: "Annullato il",
    label_shipping_date: "data di spedizione stimata",
    label_case: "Case",
    label_software: "Software",
    label_services: "Servizi",
    label_ram: "RAM",
    label_cpu: "Processore",
    label_gpu: "GPU",
    label_motherboard: "Scheda madre",
    label_storage: "Supporto di memoria",
    label_cooling: "Raffreddamento",
    label_psu: "Alimentatore"
};
var it_orderTrackingRoot = {
    title_order_tracking_root: "Inserisci il tuo ID ordine",
    label_build_id: "ID ordine",
    button_track: "Ordine di tracciamento",
    message_not_found: "non trovato, riprova"
};
var it_refurb = {
    label_all_products: "Tutti i prodotti",
    label_relevance: "Rilevanza",
    label_price_low_high: "Prezzo dal pi\xf9 basso al pi\xf9 alto",
    label_price_high_low: "Prezzo dal pi\xf9 alto al pi\xf9 basso",
    label_name_a_z: "Nome A-Z",
    label_name_z_a: "Nome Z-A",
    label_case: "Case",
    label_software: "Software",
    label_services: "Servizi",
    label_ram: "RAM",
    label_cpu: "Processore",
    label_gpu: "GPU",
    label_motherboard: "Scheda madre",
    label_storage: "Supporto di memoria",
    label_cooling: "Raffreddamento",
    label_psu: "Alimentatore",
    label_other: "Altro",
    label_accessories: "Accessori",
    label_fan: "Ventole",
    label_any_price: "Qualsiasi prezzo",
    label_no_products: "Al momento non ci sono componenti ricondizionate disponibili.",
    label_no_builds: "Al momento non ci sono build ricondizionate disponibili."
};
var it_orderStatus = {
    confirmed_title: "Ordine effettuato",
    step_label: "Passo",
    confirmed_sub: "Il tuo ordine \xe8 stato ricevuto.",
    processed_title: "Ordine confermato",
    processed_sub: "Il tuo ordine \xe8 stato ricevuto e il tuo pagamento \xe8 stato elaborato.",
    in_progress_title: "In corso",
    in_progress_sub: "Il prelievo e l’assemblaggio del tuo ordine sono iniziati. Il tuo ordine \xe8 ora bloccato e modifiche/cancellazioni non possono essere garantite.",
    shipped_title: "Spedito",
    shipped_sub: "Il tuo ordine \xe8 in arrivo!",
    cancelled_title: "Annullato",
    cancelled_sub: "Il tuo ordine \xe8 stato annullato con successo.",
    enh_ordered_sub: "Il tuo ordine \xe8 stato ricevuto ed \xe8 in coda.",
    enh_picking_title_bld: "Preparazione della build",
    enh_picking_title: "Elaborazione del tuo ordine",
    enh_picking_sub_bld: "Il ritiro e l'assemblaggio del tuo ordine sono iniziati. Le modifiche al tuo ordine non possono essere garantite.",
    enh_picking_sub: "Stiamo preparando il tuo ordine. Le modifiche al tuo ordine non possono essere garantite.",
    enh_build_title: "Costruzione",
    enh_build_sub: "Il tuo ordine \xe8 in fase di creazione e test.",
    enh_packing_title: "Preparazione alla spedizione",
    enh_packing_sub_bld: "Il tuo ordine \xe8 stato creato e testato. Viene imballato per la consegna.",
    enh_packing_sub: "Il tuo ordine \xe8 stato elaborato e sta per essere imballato per la consegna.",
    enh_shipping_title: "Spedizione",
    enh_shipping_sub: "Il tuo ordine \xe8 stato inviato al corriere per la consegna. Il tuo numero di tracciamento verr\xe0 aggiornato e inviato via email entro 1 giorno lavorativo."
};
var it_universal = (0,_object_spread/* default */.Z)({}, it_cart, it_userAccount, it_auth, it_formErrors, it_camCta, it_generic, it_helpCta, it_emailSignUp, it_geoipBanner, it_ui, it_footer, it_search, it_about, it_orderStatus);
// eslint-disable-next-line import/prefer-default-export
var it = {
    "/": (0,_object_spread/* default */.Z)({}, it_universal),
    "/product/[slug]": (0,_object_spread/* default */.Z)({}, it_product, it_universal),
    "/collection/[slug]": (0,_object_spread/* default */.Z)({}, it_collection, it_universal),
    "/partner/[slug]": (0,_object_spread/* default */.Z)({}, it_collection, it_universal),
    "/sale/[slug]": (0,_object_spread/* default */.Z)({}, it_collection, it_universal),
    "/about": (0,_object_spread/* default */.Z)({}, it_about, it_universal),
    "/about/[slug]": (0,_object_spread/* default */.Z)({}, it_about, it_universal),
    "/legal": (0,_object_spread/* default */.Z)({}, it_universal),
    "/legal/[slug]": (0,_object_spread/* default */.Z)({}, it_universal),
    "/news/[slug]": (0,_object_spread/* default */.Z)({}, it_news, it_universal, it_category),
    "/news/page/[page]": (0,_object_spread/* default */.Z)({}, it_universal, it_category),
    "/news/category/[category]": (0,_object_spread/* default */.Z)({}, it_universal, it_category),
    "/news/category/[category]/page/[page]": (0,_object_spread/* default */.Z)({}, it_universal, it_category),
    "/user/[slug]": (0,_object_spread/* default */.Z)({}, it_universal, it_build, it_keyboard),
    "/software/[slug]": (0,_object_spread/* default */.Z)({}, it_universal),
    "/category/[slug]": (0,_object_spread/* default */.Z)({}, it_category, it_universal),
    "/category/[slug]/[subcategory-slug]": (0,_object_spread/* default */.Z)({}, it_category, it_universal),
    "/build": (0,_object_spread/* default */.Z)({}, it_universal, it_build),
    "/build/[slug]": (0,_object_spread/* default */.Z)({}, it_universal, it_build),
    "/build/pc": (0,_object_spread/* default */.Z)({}, it_universal, it_build),
    "/build/pc/[slug]": (0,_object_spread/* default */.Z)({}, it_universal, it_build),
    "/build/keyboard/[slug]": (0,_object_spread/* default */.Z)({}, it_universal, it_build, it_keyboard),
    "/build/[slug]/summary": (0,_object_spread/* default */.Z)({}, it_universal, it_build),
    "/support": (0,_object_spread/* default */.Z)({}, it_universal),
    "/refurbished/[slug]": (0,_object_spread/* default */.Z)({}, it_universal, it_refurb),
    "/careers": (0,_object_spread/* default */.Z)({}, it_universal),
    "/reviews/page/[page]": (0,_object_spread/* default */.Z)({}, it_universal),
    "/careers/available-positions": (0,_object_spread/* default */.Z)({}, it_universal),
    "/order-tracking/[slug]": (0,_object_spread/* default */.Z)({}, it_orderTracking, it_orderTrackingRoot, it_universal),
    "/order-tracking": (0,_object_spread/* default */.Z)({}, it_orderTrackingRoot, it_universal),
    "/retailers": (0,_object_spread/* default */.Z)({}, it_retailers, it_universal),
    "/search": (0,_object_spread/* default */.Z)({}, it_searchResults, it_universal),
    "/auth/[slug]": (0,_object_spread/* default */.Z)({}, it_universal),
    universal: it_universal
};

;// CONCATENATED MODULE: ./locale/es.ts
/* eslint-disable max-len */ 
var es_userAccount = {
    user_settings_title: "Cuenta",
    user_settings_change_password: "Cambiar contrase\xf1a",
    user_settings_save: "Guardar",
    user_settings_cancel: "Cancelar",
    user_profile_heading: "Perfil",
    user_saved_builds_heading: "Sistemas guardados",
    user_saved_builds_bld_name: "Nombre del sistema",
    user_saved_builds_bld_date: "Fecha de creaci\xf3n",
    user_saved_builds_bld_item_part: "Componente",
    user_saved_builds_delete_bld: "Eliminar BLD",
    user_saved_builds_resume_bld: "Reanudar BLD",
    user_saved_builds_hero_title: "Dise\xf1ado para exhibir tu montaje",
    user_saved_builds_hero_text: "El compacto dise\xf1o vertical es compatible con la mayor\xeda de las gr\xe1ficas de tama\xf1o completo del mercado, y as\xed puedas conservar el espacio en tu escritorio sin sacrificar la potencia gr\xe1fica.",
    user_saved_builds_pc_heading: "Montajes de PC",
    user_saved_builds_keyboard_heading: "Montajes de teclado",
    user_saved_builds_view_pc: "Ver montajes de PC",
    user_saved_builds_view_keyboard: "Ver montajes de teclado",
    user_saved_builds_no_pc: "No tienes ning\xfan montaje de PC guardado",
    user_saved_builds_no_kb: "No has guardado tu montaje de teclado",
    user_order_history_heading: "Historial de pedidos",
    user_order_history_date: "Fecha",
    user_order_history_order_number: "N\xfamero de pedido",
    user_order_history_status: "Estado",
    user_order_history_amount: "Importe",
    user_order_history_view: "Ver recibo",
    user_order_history_empty_view: "No tienes pedidos en el historial.",
    user_order_history_shipping: "Direcci\xf3n de env\xedo",
    user_order_history_billing: "Direcci\xf3n de facturaci\xf3n",
    user_order_history_item: "Art\xedculo",
    user_order_history_item_image: "Imagen del art\xedculo",
    user_order_history_quantity: "Cantidad",
    user_order_history_order: "N.\xb0 de pedido",
    user_support_heading: "Asistencia y devoluciones",
    user_data_heading: "Petici\xf3n de datos",
    user_terms_heading: "Condiciones",
    user_terms_empty: "A\xfan no tienes condiciones firmadas.",
    user_support_subject_min_length: "El asunto debe tener al menos tres caracteres.",
    user_support_message_placeholder: "Detalla los motivos del contacto. Si es una devoluci\xf3n, indica el n\xfamero del pedido.",
    user_support_update_button: "Actualizar",
    user_active_tickets_heading: "Incidencias activas",
    user_active_tickets_chat: "A\xf1adir un mensaje",
    user_active_tickets_no_chat_history: "No tienes chats en el historial.",
    view_chat_button: "Ver chat",
    close_chat_button: "Cerrar chat",
    field_required_message: "Este campo es obligatorio.",
    label_accept: "Aceptar",
    label_reason_for_contact: "Motivo del contacto",
    label_country: "Pa\xeds",
    label_region: "Regi\xf3n",
    label_subject: "Asunto",
    label_product: "Producto",
    label_message: "Mensaje",
    label_requestor_type: "Tipo de solicitante",
    label_country_of_residence: "Pa\xeds de residencia",
    label_description: "Descripci\xf3n",
    placeholder_description: "Descripci\xf3n de tu solicitud",
    label_submit: "Enviar",
    message_no_support_requests: "No tienes solicitudes de asistencia activas.",
    label_ticket_number: "N\xfamero de incidencia",
    label_date_created: "Fecha de creaci\xf3n",
    label_status: "Estado",
    label_department: "Departamento",
    subheading_active_ticket: "Si necesitas ayuda o quieres devolver un art\xedculo, ponte en contacto con el servicio de soporte.",
    label_create_support_request: "Crear solicitud de soporte",
    button_comment: "Comentario",
    label_for_myself: "Para m\xed",
    label_parent: "Progenitor",
    label_legal_rep: "Representante legal",
    label_relative: "Familiar",
    label_guardian: "Tutor legal",
    label_accept_generic_terms: "He le\xeddo las condiciones y las acepto.",
    error_view_message: "\xa1Uy! Algo ha salido mal. Vuelve a intentarlo.",
    signout_view_message: "Se ha cerrado la sesi\xf3n.",
    birthday_error_message: "Introduce una fecha de nacimiento v\xe1lida.",
    label_view_saved: "Ver todos los montajes guardados"
};
var es_formErrors = {
    invalid_email: "Introduce una direcci\xf3n de correo electr\xf3nico v\xe1lida.",
    username_full_pattern_message: "El nombre de usuario debe tener entre 6 y 30 caracteres. Puedes usar letras, n\xfameros y puntos, pero el nombre no puede empezar ni acabar con puntos consecutivos ni tampoco contenerlos.",
    password_pattern_message: "La contrase\xf1a debe contener al menos seis caracteres, una may\xfascula, una min\xfascula y un n\xfamero.",
    username_min_length_message: "Usa seis caracteres o m\xe1s para el nombre de usuario.",
    passwords_must_match: "Las contrase\xf1as deben que coincidir.",
    invalid_current_password: "No se ha podido actualizar la contrase\xf1a. El valor indicado como contrase\xf1a actual es incorrecto.",
    must_accept_partner_program_terms: "Debes aceptar las condiciones del programa de socios para hacerte socio de NZXT.",
    must_accept_tos_terms: "Debes aceptar las condiciones del servicio para abrirte una cuenta en NZXT.",
    must_accept_generic_terms: "Debes aceptar estas condiciones."
};
var es_auth = {
    user_auth_agreement: "Acepto la",
    user_auth_privacy_policy: "Pol\xedtica de privacidad de NZXT",
    user_auth_and: "y he le\xeddo las",
    user_auth_terms: "Condiciones de uso",
    error_invalid_request: "Solicitud no v\xe1lida",
    error_invalid_token: "Token de autentificaci\xf3n de usuario no v\xe1lido",
    error_session_expired: "La sesi\xf3n ha expirado. Vuelve a iniciar sesi\xf3n para continuar.",
    user_forgot_required_email: "La direcci\xf3n de correo electr\xf3nico es necesaria.",
    user_forgot_success_message: "\xa1Gracias! Si hay una cuenta asociada a esta direcci\xf3n de correo electr\xf3nico, enviaremos las instrucciones para restablecer la contrase\xf1a inmediatamente.",
    error_email_exists: "Esta direcci\xf3n de correo electr\xf3nico ya est\xe1 en uso.",
    user_email_verification_heading: "Verificaci\xf3n de la direcci\xf3n de correo electr\xf3nico",
    error_email_not_verified: "La direcci\xf3n de correo electr\xf3nico a\xfan no se ha verificado. Para volver a enviar el correo electr\xf3nico de verificaci\xf3n, haz clic en",
    error_email_already_verified: "La direcci\xf3n de correo electr\xf3nico ya ha sido verificada. Inicia la sesi\xf3n a continuaci\xf3n.",
    user_email_verification_success_message: "Tu direcci\xf3n de correo electr\xf3nico se ha verificado correctamente. Inicia la sesi\xf3n a continuaci\xf3n.",
    error_username_unavailable: "Este nombre de usuario no est\xe1 disponible.",
    error_reset_password_same_as_old_password: "Esta contrase\xf1a es la misma que la anterior. Por favor, elige otra.",
    error_reset_password_link_expired: "El enlace para restablecer la contrase\xf1a ha expirado.",
    error_reset_password_link_invalid: "El enlace para restablecer la contrase\xf1a no es v\xe1lido.",
    user_forgot_password_subheading: "Introduce tu direcci\xf3n de correo electr\xf3nico para recibir instrucciones sobre c\xf3mo restablecer la contrase\xf1a.",
    user_reset_password_heading: "Restablece tu contrase\xf1a",
    user_reset_password_subheading: "Por favor, introduce una contrase\xf1a nueva.",
    user_reset_password: "Restablecer contrase\xf1a",
    user_reset_success_message: "Has restablecido tu contrase\xf1a correctamente.",
    user_login_text: "Inicia sesi\xf3n con Google",
    user_login_remember: "Recu\xe9rdame.",
    user_login_forgot_password: "He olvidado mi contrase\xf1a.",
    user_login_wrong_email_or_password: "Direcci\xf3n de correo electr\xf3nico o contrase\xf1a incorrectas",
    user_login_success_message: "Has iniciado sesi\xf3n correctamente.",
    error_too_many_requests: "Has hecho demasiados intentos. Espera unos minutos o ponte en contacto con el servicio de soporte.",
    error_user_not_found: "Usuario no encontrado",
    user_sign_in_sign_up: "Iniciar sesi\xf3n / Registrarse",
    user_sign_out: "Cerrar sesi\xf3n",
    user_sign_in: "Iniciar sesi\xf3n",
    user_account_updates: "Actualizaciones de NZXT",
    user_account_no_updates: "No hay actualizaciones recientes. Vuelve m\xe1s tarde.",
    support_center_link: "Centro de soporte",
    error_google_account_exists: "Ya has creado una cuenta con Google. Por favor, inicia sesi\xf3n.",
    error_local_account_exists: "Parece que ya tienes una cuenta. Por favor, inicia sesi\xf3n.",
    user_sign_up: "Registrarse",
    user_sign_up_text: "Registrarse con Google",
    user_sign_up_opt_in: "Reg\xedstrate para recibir correos electr\xf3nicos con actualizaciones de NZXT sobre productos, BLD y CAM.",
    user_sign_up_check_email_message: "Comprueba tu correo electr\xf3nico y haz clic en el enlace para activar tu cuenta.",
    user_sign_up_success_verify_message: "Esta permanecer\xe1 inactiva hasta que se verifique. Si pasados unos minutos no recibes el correo electr\xf3nico, echa un vistazo a tu carpeta de correo no deseado.",
    user_info_updated_success_message: "Tu informaci\xf3n se ha actualizado correctamente.",
    user_info_newsletter_confirmation_message: "Consulta tu correo electr\xf3nico para realizar la confirmaci\xf3n.",
    user_email_sign_in: "O sigue con",
    user_no_account: "\xbfNo eres miembro?",
    user_create_account: "Crear cuenta",
    user_email_sign_up_text: "O reg\xedstrate con",
    user_have_account: "\xbfYa tienes cuenta?",
    open_login_view: "Abrir vista de inicio de sesi\xf3n",
    error_newsletter_subscription: "No podemos suscribirte / darte de baja del bolet\xedn de noticias en estos momentos. Vuelve a intentarlo m\xe1s tarde.",
    label_email_address: "Direcci\xf3n de correo electr\xf3nico",
    label_password: "Contrase\xf1a",
    label_current_password: "Contrase\xf1a actual",
    label_confirm_password: "Confirma la contrase\xf1a",
    label_new_password: "Contrase\xf1a nueva",
    label_confirm_new_password: "Confirma la contrase\xf1a nueva",
    label_username: "Nombre de usuario",
    label_first_name: "Nombre",
    label_last_name: "Apellidos",
    label_preferred_pronouns: "Pronombres preferidos",
    label_search_for_help_articles: "Buscar art\xedculos de ayuda",
    label_birthday: "Cumplea\xf1os",
    label_location: "Ubicaci\xf3n",
    app_access: "quiere tener acceso a tu cuenta de NZXT para acceder a lo siguiente:",
    app_access_has_scopes: "quiere tener acceso a tu cuenta de NZXT",
    scope_profile: "Tu perfil, incluidos tu nombre e imagen",
    scope_email: "Tu direcci\xf3n de correo electr\xf3nico",
    scope_address: "Tu direcci\xf3n f\xedsica",
    scope_phone: "Su n\xfamero de tel\xe9fono",
    grant_offline_access: "Tener acceso sin conexi\xf3n",
    grant_offline_access_previous: "que has concedido previamente"
};
var es_build = {
    custom_bld_modal_heading: "Monta tu PC",
    custom_bld_modal_subheading: "Selecciona tu chipset y presupuesto",
    custom_bld_unavailable: "Selecciona otro art\xedculo.",
    custom_bld_issue: "Los art\xedculos siguientes requieren una soluci\xf3n.",
    custom_bld_title: "BLD personalizado",
    custom_bld_lets_get_started: "Empecemos",
    custom_bld_destrutive_action: "Advertencia: Restablecimiento del sistema",
    custom_bld_confirm_reset: "El sistema se va a restablecer con el chipset siguiente",
    custom_bld_keyboard_confirm_reset: "Su construcci\xf3n se restablecer\xe1 con el siguiente conjunto de chips:",
    custom_bld_choose_chipset: "Elige tu chipset",
    custom_bld_chipset: "Chipset",
    custom_bld_intel: "Intel",
    custom_bld_amd: "AMD",
    custom_bld_explore: "Explorar",
    custom_bld_select: "Seleccionar",
    review_bld_button: "Revisar BLD",
    custom_bld_summary: "Resumen",
    custom_bld_budget: "Presupuesto",
    custom_bld_specs: "Especificaciones",
    custom_bld_case: "Caja",
    custom_bld_cases: "Cajas",
    custom_bld_caseCooling: "Refrigeraci\xf3n",
    custom_bld_fans: "Ventiladores",
    custom_bld_cpu: "Procesador",
    custom_bld_gpu: "Gr\xe1fica",
    custom_bld_ram: "RAM",
    custom_bld_ssd: "SSD",
    custom_bld_hdd: "HDD",
    custom_bld_specials: "Promociones",
    custom_bld_colors: "Colores",
    custom_bld_color: "Color",
    custom_bld_black: "Negro",
    custom_bld_red: "Rojo",
    custom_bld_white: "Blanco",
    custom_bld_grey: "Gris",
    custom_bld_blue: "Azul",
    custom_bld_purple: "Morado",
    custom_bld_audio: "Sonido",
    custom_bld_extras: "Extras",
    custom_bld_core: "N\xfacleo",
    custom_bld_motherboard: "Placa base",
    custom_bld_motherboards: "Placas base",
    custom_bld_powerSupplies: "Fuentes de alimentaci\xf3n",
    custom_bld_powerSupply: "Fuente de alimentaci\xf3n",
    custom_bld_services: "Servicios",
    custom_bld_software: "Software",
    custom_bld_monitors: "Monitores",
    custom_bld_peripherals: "Perif\xe9ricos",
    custom_bld_lighting: "Iluminaci\xf3n",
    custom_bld_headset: "Auriculares",
    custom_bld_keyboard: "Teclado",
    custom_bld_all: "Todo",
    custom_bld_mouse: "Rat\xf3n",
    custom_bld_storage: "Almacenamiento",
    custom_bld_streaming_ready: "Preparado para streaming",
    custom_bld_rgb_lighting: "Iluminaci\xf3n RGB",
    custom_bld_vr_ready: "Preparado para RV",
    custom_bld_wifi: "Wifi",
    custom_bld_from: "Desde",
    custom_bld_bluetooth: "Bluetooth",
    custom_bld_save_build_message: "Tu sistema se ha guardado correctamente. Puedes verlo en el apartado \xabSistemas guardados\xbb de tu cuenta.",
    custom_bld_share_build_message: "Tu sistema se ha guardado y copiado correctamente.",
    help_me_decide: "Ay\xfadame a decidir.",
    save_build: "Guardar sistema",
    start_over: "Volver a empezar",
    summary: "Resumen",
    build_summary: "Resumen del sistema",
    load_build: "Cargar sistema",
    load: "Cargar",
    save: "Guardar",
    restart: "Reiniciar",
    share: "Compartir",
    my_build_label: "Mi sistema",
    est_shipping: "Gastos de env\xedo previstos",
    add_to_build: "A\xf1adir al sistema",
    message_invalid: "No disponible temporalmente",
    message_out_of_stock: "Agotado",
    message_low_stock: "Stock bajo",
    message_new_item: "Nuevo",
    message_coming_soon: "Pr\xf3ximamente",
    message_best_seller: "Top ventas",
    message_is_locked: "No compatible",
    button_label_select: "Seleccionar",
    button_label_selected: "Seleccionado",
    button_label_add: "A\xf1adir",
    button_label_added: "A\xf1adido",
    button_label_update: "Actualizar",
    button_label_remove: "Quitar",
    button_label_info: "Informaci\xf3n",
    button_label_more_info: "M\xe1s informaci\xf3n",
    button_label_options_info: "Opciones e informaci\xf3n",
    button_label_continue_to: "Continuar con el sistema",
    button_label_edit: "Editar",
    build_fps_label: "Las velocidades de FPS se miden a una resoluci\xf3n de 2560 x 1440 utilizando el ajuste gr\xe1fico m\xe1s alto de cada juego.",
    build_includes: "Incluye",
    custom_bld_boost: "Potencia tu configuraci\xf3n",
    custom_bld_fps_unavailable: "Pendiente",
    custom_bld_amd_help: "Los PC Intel han sido los m\xe1s vendidos durante los \xfaltimos a\xf1os, aunque ahora los PC AMD son incre\xedbles para jugar. Te ayudaremos con ambas opciones, seleccionando placas base y sistemas de refrigeraci\xf3n compatibles, para que no tengas que pensarlo t\xfa. Te recomendamos que equilibres el rendimiento de FPS que presentamos con tu presupuesto.",
    custom_bld_to_see_this: "Para ver esta selecci\xf3n, tienes que",
    custom_bld_change_chipset: "cambiar el chipset.",
    custom_bld_prebuild_upsell: "O elige sistemas premontados r\xe1pidos y sencillos.",
    no_item_selected: "No has seleccionado ning\xfan art\xedculo.",
    build_change_label: "Sistema modificado",
    invalid_action_label: "No permitido",
    success_label: "\xc9xito",
    build_info_message: "Informaci\xf3n",
    reset_label: "Restablecimiento del sistema",
    complete_build_label: "Termina tu sistema.",
    back_to_build_label: "Volver a tu sistema",
    complete_build_sub_label: "Extras y perif\xe9ricos",
    back_to_build_sub_label: "Componentes esenciales de tu sistema",
    capacity_label: "Capacidad",
    option_label: "Opci\xf3n",
    options_label: "Opciones",
    max_speed: "Velocidad m\xe1x.",
    modular_label: "Modular",
    midtower_label: "Mid-Tower",
    streaming_label: "Streaming",
    save_and_exit: "Guardar y Salir",
    exit: "Salir",
    view_cart_label: "Ver carrito",
    cart_subtotal_label: "Subtotal del carrito",
    start_build_label: "Iniciar construcci\xf3n",
    new_build_label: "Nuevo montaje",
    continue_saved_build_label: "Continuar montaje guardado",
    continue_progress_build_label: "Continuar con el montaje en progreso",
    continue_cart_build_label: "Revisar montaje en el carrito",
    core_label: "Base",
    extras_label: "Complementos",
    summary_label: "Resumen",
    share_build_pc: "Montaje de PC personaliado",
    share_build_kb: "Montaje de Teclados personalizados",
    build_summary_label: "Resumen del montaje de tu teclado",
    pc_hub_card_heading: "Ordenadores gaming custom",
    pc_hub_card_subheading: "Monta el PC de tus sue\xf1os en funci\xf3n de tu presupuesto y optimizado para los juegos que mas te gustan.",
    kb_hub_card_heading: "Teclados personalizados",
    kb_hub_card_subheading: "Monta un teclado y un rat\xf3n personalizados que se adapten a tu espacio y estilo de juego"
};
var es_keyboard = {
    keyboard_label: "Teclado",
    keyboard_size: "Tama\xf1o del teclado",
    keyboard_base: "Base del teclado",
    keyboard_primay_base_color: "Color de la base",
    keyboard_layout: "Disposici\xf3n del teclado",
    keyboard_summary: "Resumen del teclado",
    accent_keycaps: "Teclas destacadas",
    cabletype: "Cable personalizado",
    additional_cable_color: "Color del cable",
    cable: "Cable",
    additional_cable: "Cable adicional",
    primary_keycaps: "Teclas base",
    switches: "Switches",
    size: "Tama\xf1o",
    layout: "Dise\xf1o",
    language: "Idioma",
    mouse_pad_label: "Alfombrilla de rat\xf3n",
    desk_mat_label: "Alfombrilla de escritorio",
    tools_label: "Herramientas",
    wrist_rest_label: "Reposamu\xf1ecas",
    mouse_label: "Rat\xf3n",
    cable_description: "Cable de color opcional. Se incluir\xe1 un cable negro est\xe1ndar de 2 metros.",
    cable_color_description: "Color del cable premium",
    language_description: "Determina la posici\xf3n de las teclas Q, W, Z y A.",
    layout_description: "Determina el tama\xf1o y la posici\xf3n de las teclas.",
    keycap_accent_description: "Color opcional para las teclas Escape, Enter, Flecha y Numpad Enter.",
    primary_keycap_description: "PBT sublimado, perfil Cherry.",
    switch_description: "Los switches de un teclado definen la experiencia de tecleo cada vez que se pulsa una tecla.",
    keyboard_base_color_description: "Color principal de la base del teclado",
    keyboard_base_size_description: "El tama\xf1o del teclado determina el n\xfamero de teclas y las dimensiones que tiene.",
    mouse_description: "Rat\xf3n ligero y ambidiestro",
    summary_description: "Resumen de la construcci\xf3n del teclado",
    premium_label: "Premium",
    base_label: "Base",
    keyboard_warning: "Por favor, selecciona los siguientes art\xedculos para continuar tu montaje:",
    switch_reset_warning: "Tus switches se han reestablecido. Por favor, selecciona nuevos switches.",
    keycap_reset_warning: "Tus teclas se han reestablecido. Por favor, selecciona nuevas teclas.",
    base_type: "Tipo de montaje",
    build_type_description: "Selecciona el tipo de teclado que te gustar\xeda configurar",
    full_custom_label: "Personalizado",
    barebones_disclaimer: "Cambia el tipo de montaje para seleccionar este art\xedculo",
    none_label: "Ninguno"
};
var es_camCta = {
    cam_description: "Gestiona el rendimiento, las temperaturas y los dispositivos desde una sola aplicaci\xf3n.",
    cam_windows_10: "WINDOWS 10 DE 64 BITS"
};
var es_helpCta = {
    help_description: "Consigue gu\xedas exhaustivas y asistencia para todos tus productos NZXT, as\xed como ayuda sobre la garant\xeda, las devoluciones y cualquier cuesti\xf3n t\xe9cnica."
};
var es_emailSignUp = {
    email_stay_in_touch: "Estemos en contacto",
    email_sub_copy: "Mantente al d\xeda sobre los \xfaltimos lanzamientos, ofertas y noticias de NZXT.",
    email_legal: "Al registrarte, est\xe1s de acuerdo con la Pol\xedtica de privacidad y las Condiciones de NZXT, CAM y BLD.",
    email_notify: "Notif\xedcame",
    email_notify_stock: "Recibe una notificaci\xf3n cuando este art\xedculo est\xe9 disponible."
};
var es_generic = {
    explore: "Explorar",
    cam_title: "NZXT CAM",
    free_download: "Descarga gratuita",
    details: "Detalles",
    help_amp_support: "Ayuda y asistencia t\xe9cnica",
    help_and_support: "Ayuda y asistencia t\xe9cnica",
    read_more: "M\xe1s informaci\xf3n",
    privacy_policy: "Pol\xedtica de privacidad",
    terms_conditions: "Condiciones",
    and: "y",
    or: "o",
    send: "enviar",
    return_to: "volver a",
    previous: "Anterior",
    next: "Siguiente",
    home: "Inicio",
    keep_browsing: "Seguir explorando",
    create_build: "Crear sistema",
    learn_more: "M\xe1s informaci\xf3n",
    add_to_cart: "A\xf1adir al carrito",
    share_build: "Compartir sistema",
    view: "Ver",
    close: "Cerrar",
    price: "Precio",
    allow: "Permitir",
    cancel: "Cancelar",
    here: "aqu\xed",
    ok: "Aceptar",
    button_start_bld: "Empezar BLD",
    message_on_sale: "Rebajas",
    button_buy: "Comprar",
    button_start_build: "Empieza tu monaje",
    view_build: "Ver sistema",
    button_back: "Volver",
    build: "Sistema",
    performance: "Rendimiento",
    error_generic: "Algo ha salido mal. Vuelve a intentarlo m\xe1s tarde.",
    label_support: "Asistencia",
    contact_support: "Contactar con el servicio de asistencia",
    browse_articles: "Explorar art\xedculos",
    search_support_articles: "Buscar art\xedculos de ayuda",
    message_error: "\xa1Vaya! Parece que algo ha salido mal.",
    estimated_performance_label: "Rendimiento previsto",
    see_estimated_performance_label: "Ver rendimiento previsto",
    title_related_items: "Puede que tambi\xe9n te guste",
    qty: "Cant.",
    category_from: "Desde",
    reviews_label: "Rese\xf1as",
    message_out_of_stock: "Agotado",
    message_low_stock: "Stock bajo",
    message_new_item: "Nuevo",
    message_coming_soon: "Pr\xf3ximamente",
    message_best_seller: "Top ventas",
    message_unavailable: "No disponible",
    message_invalid: "No disponible temporalmente",
    message_featured_items: "Productos presentados en la imagen",
    message_colors: "Colores",
    message_color: "Color",
    label_return_policy: "Pol\xedtica de devoluciones",
    label_warranty_policy: "Condiciones de garant\xeda",
    label_shop: "Tienda",
    label_days: "D\xedas",
    label_hours: "Horas",
    label_minutes: "Minutos",
    label_seconds: "Segundos",
    label_promotion: "Ver promoci\xf3n",
    label_promotions: "Promociones",
    monthly_payments: "Pagos mensuales disponibles",
    message_promotion: "Promoci\xf3n",
    discount_label: "de descuento",
    off_label: "Apagado",
    on_label: "Encendido",
    choose_label: "Elige",
    move_to_previous_label: "Ir a la diapositiva anterior",
    move_to_next_label: "Pasar a la diapositiva siguiente",
    active_slide_label: "Diapositiva activaa",
    move_to_inactive_slide: "Mover a la diapositiva inactiva",
    color_options: "Opciones de color",
    upsell_modal_label: "A menudo se compran juntos",
    no_thanks_label: "No, gracias",
    label_deal_ends: "La oferta termina en",
    label_show_more: "Ver m\xe1s",
    label_show_less: "Ver menos",
    label_case: "Caja",
    label_software: "Software",
    label_services: "Servicios",
    label_ram: "RAM",
    label_cpu: "Procesador",
    label_gpu: "Gr\xe1fica",
    label_motherboard: "Placa base",
    label_storage: "Almacenamiento",
    label_cooling: "Refrigeraci\xf3n",
    label_psu: "Fuente de alimentaci\xf3n",
    label_warranty: "Garant\xeda",
    label_accessories: "Accesorios",
    label_fps: "FPS",
    label_feature: "Caracter\xedstica"
};
var es_cart = {
    cart_heading: "Tu carrito",
    cart_heading_empty: "Tu carrito est\xe1 vac\xedo.",
    cart_subheading_empty: "Busca productos que te encantar\xe1n.",
    cart_free_shipping_cta: "Te faltan 25 € para que el env\xedo te salga gratis.",
    cart_free_shipping_exclusion: "(excepto PC personalizados y premontados)",
    cart_free_shipping_promo_cta: "Env\xedo gratuito en todos los pedidos",
    cart_heading_error: "Algo ha salido mal. Vuelve a intentarlo.",
    cart_heading_success: "\xa1Gracias!",
    cart_label_subtotal: "Subtotal",
    cart_label_taxes: "Impuestos",
    cart_value_taxes: "Calculados en la p\xe1gina de pago",
    cart_label_shipping: "Gastos de env\xedo previstos",
    cart_value_shipping_free: "GRATIS",
    cart_value_disclaimer: "*Puede que los productos nuevos o reacondicionados se tramiten y env\xeden en plazos distintos.",
    cart_label_total: "Total",
    cart_button_checkout: "Ir al pago",
    cart_terms_message: "Acepto las",
    cart_terms_link_text: "Condiciones del servicio",
    cart_value_taxes_non_us: "Incluidos",
    cart_value_shipping_calculated: "Calculados en la p\xe1gina de pago",
    cart_consent_i_have_read: "He le\xeddo la",
    cart_consent_privacy_policy: "Pol\xedtica de privacidad",
    cart_consent_privacy_policy_after: " ",
    cart_au_terms_message: "Acepto las",
    cart_au_terms_link: "Condiciones del servicio",
    cart_au_consent_message: "Doy mi consentimiento para que se recojan y se usen mis datos personales conforme a la",
    cart_au_consent_link: "Pol\xedtica de privacidad",
    cart_au_terms_text_1: "NZXT Pty Ltd (ABN 47 645 981 559) ofrece los productos y servicios que has pedido conforme con sus",
    cart_au_terms_text_terms_link: "Condiciones",
    cart_au_terms_text_2: "y recoge, utiliza y difunde los datos personales que recopila sobre usted seg\xfan su",
    cart_au_terms_text_privacy_link: "Pol\xedtica de privacidad",
    cart_label_ssd: "SSD",
    cart_label_hdd: "HDD",
    cart_label_service: "Servicio",
    cart_label_software: "Software",
    cart_label_case: "Caja",
    cart_label_motherboard: "Placa base",
    cart_label_cpu: "Procesador",
    cart_label_gpu: "Gr\xe1fica",
    cart_label_power_supply: "Fuente de alimentaci\xf3n",
    cart_label_cpu_cooler: "Refrigerador de procesador",
    cart_label_rgb: "RGB",
    cart_label_fans: "Ventiladores",
    cart_label_ram: "RAM",
    cart_label_monitors: "Monitores",
    cart_label_peripherals: "Perif\xe9ricos",
    cart_label_extras: "Extras",
    cart_label_keycaps: "Teclas",
    cart_label_keycap_accents: "Teclas destacadas",
    cart_label_switches: "Interruptores",
    cart_label_keyboard_base: "Base del teclado",
    cart_label_keycap_accent: "Tapas de teclado acentuadas",
    cart_label_accent_cable: "Cable personalizado",
    cart_label_mouse: "Rat\xf3n"
};
var es_category = {
    explore_refurbished: "Explorar sistemas",
    explore_bulk: "Explorar art\xedculos al por mayor",
    bulk: "Art\xedculos al por mayor",
    refurbished: "Reacondicionado",
    refurbished_cta: "Echa un vistazo a nuestros ordenadores y componentes reacondicionados, totalmente revisados y probados.",
    bulk_cta: "Hemos ayudado a suministrar ordenadores al por mayor a empresas de gaming, universidades, organizaciones de eSports y m\xe1s."
};
var es_geoipBanner = {
    currently_browsing: "Explorando ahora",
    banner_region_text: "Cambia de regi\xf3n para comprar o ver contenido espec\xedfico de tu ubicaci\xf3n.",
    banner_button: "Cambiar a",
    banner_country_text_shop: "Compre",
    banner_counrty_text: "o seleccione un pa\xeds diferente espec\xedfico para su ubicaci\xf3n.",
    country_us: "Estados Unidos",
    country_canada: "Canad\xe1",
    country_belgium: "B\xe9lgica",
    country_germany: "Alemania",
    country_luxembourg: "Luxemburgo",
    country_netherlands: "Pa\xedses Bajos",
    country_austria: "Austria",
    country_france: "Francia",
    country_italy: "Italia",
    country_spain: "Espa\xf1a",
    country_uk: "Reino Unido",
    country_australia: "Australia",
    country_nz: "Nueva Zelanda",
    country_japan: "Jap\xf3n",
    region_na: "Am\xe9rica del Norte",
    region_europe: "Europa",
    region_oceania: "Ocean\xeda"
};
var es_ui = {
    loading: "Cargando"
};
var es_footer = {
    label_language: "Idioma",
    label_region: "Regi\xf3n",
    manage_cookie_preferences: "Gestionar preferencias de cookies",
    all_rights_reserved: "Todos los derechos reservados"
};
var es_search = {
    label_suggested_queries: "Consultas sugeridas",
    label_suggested_results: "Resultados sugeridos",
    label_serp_heading: "Buscar resultados de",
    label_serp_not_found: "Ning\xfan resultado de",
    label_serp_total: "resultados en total",
    label_serp_suggested: "Prueba a buscar"
};
var es_about = {
    label_customer_support_hours: "Horario de atenci\xf3n al cliente",
    label_headquarters: "Sede central"
};
var es_product = {
    overview: "Resumen",
    tech_specs: "Especificaciones t\xe9cnicas",
    downloads: "Descargas",
    message_invalid: "No disponible temporalmente",
    message_out_of_stock: "Agotado",
    message_low_stock: "Stock bajo",
    message_new_item: "Nuevo",
    message_coming_soon: "Pr\xf3ximamente",
    message_unavailable: "No disponible",
    title_highlights: "Destacados",
    title_shipping: "Env\xedo",
    title_in_the_box: "En el interior de la caja",
    button_buy_now: "Comprar",
    message_colors: "Colores",
    message_color: "Color",
    message_size: "Tama\xf1o",
    message_series: "Serie",
    overview_anchor: "Resumen",
    tech_specs_anchor: "Especificaciones t\xe9cnicas",
    downloads_anchor: "Descargas",
    related_anchor: "Relacionado",
    customize_build_header: "O monta",
    customize_build_subheader: "Monta un PC personalizado con este art\xedculo",
    buy_product_header: "Hazlo t\xfa mismo/a",
    buy_product_subheader: "Imag\xednatelo. M\xf3ntalo. Hazlo.",
    buy_label: "Comprar",
    retailers_subheader: "Compra a nuestros distribuidores.",
    link_all_retailers: "Ver todos los distribuidores",
    series_label: "Serie",
    label_header_bundle: "Comprar juntos",
    label_subheader_bundle: "Lleva tu sistema al siguiente nivel con productos recomendados por expertos.",
    help_button_label: "Chatear",
    help_button_heading: "\xbfTienes preguntas?",
    help_button_subheading: "Nuestros expertos est\xe1n aqu\xed para ayudarte.",
    configure_label: "Configurar",
    documentation_label: "Documentaci\xf3n",
    drivers_label: "Controladores",
    miscellaneous_label: "Varios",
    resources_label: "Recursos",
    everything_you_need_label: "Todo lo que necesitas",
    good_rating_label: "Bueno",
    better_rating_label: "Mejor",
    best_rating_label: "Lo mejor",
    key_specs_label: "Especificaciones clave"
};
var es_collection = {
    message_invalid: "No disponible temporalmente",
    message_out_of_stock: "Agotado",
    message_low_stock: "Stock bajo",
    message_unavailable: "No disponible",
    message_new_item: "Nuevo",
    message_coming_soon: "Pr\xf3ximamente",
    button_buy_now: "Comprar",
    message_colors: "Colores",
    learn_more: "M\xe1s informaci\xf3n",
    label_show_more: "Ver m\xe1s",
    label_show_less: "Ver menos",
    help_button_label: "Chatear",
    help_button_heading: "\xbfTienes preguntas?",
    help_button_subheading: "Nuestros expertos est\xe1n aqu\xed para ayudarte."
};
var es_news = {
    label_all_news: "Todas las noticias"
};
var es_retailers = {
    label_regions: "Regiones",
    label_locations: "Ubicaciones",
    label_reseller_type: "Tipo",
    option_label_all_regions: "Todas las regiones",
    option_label_all_locations: "Todas las ubicaciones",
    option_label_all_reseller_type: "Todas las opciones",
    message_empty_state: "No hay ning\xfan distribuidor que re\xfana los criterios seleccionados.",
    hero_text: "Los productos NZXT se pueden comprar a trav\xe9s de nuestros distribuidores en todas las regiones."
};
var es_searchResults = {
    message_invalid: "No disponible temporalmente",
    message_out_of_stock: "Agotado",
    message_low_stock: "Stock bajo",
    message_new_item: "Nuevo",
    message_coming_soon: "Pr\xf3ximamente",
    message_unavailable: "No disponible"
};
var es_orderTracking = {
    title_order_status: "Estado del pedido",
    label_cancelled_on: "Cancelado el",
    label_shipping_date: "Fecha de env\xedo prevista",
    label_case: "Caja",
    label_software: "Software",
    label_services: "Servicios",
    label_ram: "RAM",
    label_cpu: "Procesador",
    label_gpu: "Gr\xe1fica",
    label_motherboard: "Placa base",
    label_storage: "Almacenamiento",
    label_cooling: "Refrigeraci\xf3n",
    label_psu: "Fuente de alimentaci\xf3n"
};
var es_orderTrackingRoot = {
    title_order_tracking_root: "Introduce el ID de tu pedido",
    label_build_id: "ID del pedido",
    button_track: "Rastrear pedido",
    message_not_found: "no encontrado; vuelve a intentarlo."
};
var es_refurb = {
    label_all_products: "Todos los productos",
    label_relevance: "Relevancia",
    label_price_low_high: "Precio ascendente",
    label_price_high_low: "Precio descendente",
    label_name_a_z: "Nombre A-Z",
    label_name_z_a: "Nombre Z-A",
    label_case: "Caja",
    label_software: "Software",
    label_services: "Servicios",
    label_ram: "RAM",
    label_cpu: "Procesador",
    label_gpu: "Gr\xe1fica",
    label_motherboard: "Placa base",
    label_storage: "Almacenamiento",
    label_cooling: "Refrigeraci\xf3n",
    label_psu: "Fuente de alimentaci\xf3n",
    label_other: "Otro",
    label_accessories: "Accesorios",
    label_fan: "Ventiladores",
    label_any_price: "Cualquier precio",
    label_no_products: "No hay ning\xfan componente reacondicionado disponible en estos momentos.",
    label_no_builds: "No hay ning\xfan ordenador reacondicionado disponible en estos momentos."
};
var es_orderStatus = {
    confirmed_title: "Pedido realizado",
    step_label: "Paso",
    confirmed_sub: "Hemos recibido tu pedido.",
    processed_title: "Pedido confirmado",
    processed_sub: "Hemos recibido tu pedido y el pago se ha procesado.",
    in_progress_title: "En curso",
    in_progress_sub: "Hemos empezado con la selecci\xf3n y el montaje de componentes para tu pedido. Ahora el pedido est\xe1 bloqueado y los cambios o cancelaciones no se pueden garantizar.",
    shipped_title: "Enviado",
    shipped_sub: "\xa1Tu pedido est\xe1 en camino!",
    cancelled_title: "Cancelado",
    cancelled_sub: "Tu pedido se ha cancelado correctamente.",
    enh_ordered_sub: "Hemos recibido tu pedido y lo hemos puesto en la cola.",
    enh_picking_title_bld: "Preparando el montaje",
    enh_picking_title: "Tramitando el pedido",
    enh_picking_sub_bld: "Hemos empezado con la selecci\xf3n y el montaje de componentes para tu pedido. Los cambios ya no se pueden garantizar.",
    enh_picking_sub: "Estamos preparando tu pedido. Los cambios ya no se pueden garantizar.",
    enh_build_title: "Montando",
    enh_build_sub: "Estamos montando y probando tu pedido.",
    enh_packing_title: "Preparando para el env\xedo",
    enh_packing_sub_bld: "Ya hemos montado y probado tu pedido. Ahora lo estamos embalando para enviarlo.",
    enh_packing_sub: "Ya hemos tramitado tu pedido y lo estamos embalando para enviarlo.",
    enh_shipping_title: "Env\xedo",
    enh_shipping_sub: "Hemos enviado tu pedido al transportista para su entrega. El n\xfamero de seguimiento se actualizar\xe1 y lo recibir\xe1s por correo electr\xf3nico en un d\xeda laborable."
};
var es_universal = (0,_object_spread/* default */.Z)({}, es_userAccount, es_cart, es_auth, es_formErrors, es_camCta, es_generic, es_helpCta, es_emailSignUp, es_geoipBanner, es_ui, es_footer, es_search, es_about, es_orderStatus);
// eslint-disable-next-line import/prefer-default-export
var es = {
    "/": (0,_object_spread/* default */.Z)({}, es_universal),
    "/product/[slug]": (0,_object_spread/* default */.Z)({}, es_product, es_universal),
    "/collection/[slug]": (0,_object_spread/* default */.Z)({}, es_collection, es_universal),
    "/partner/[slug]": (0,_object_spread/* default */.Z)({}, es_collection, es_universal),
    "/sale/[slug]": (0,_object_spread/* default */.Z)({}, es_collection, es_universal),
    "/about": (0,_object_spread/* default */.Z)({}, es_universal, es_about),
    "/about/[slug]": (0,_object_spread/* default */.Z)({}, es_universal, es_about),
    "/legal": (0,_object_spread/* default */.Z)({}, es_universal),
    "/legal/[slug]": (0,_object_spread/* default */.Z)({}, es_universal),
    "/news/[slug]": (0,_object_spread/* default */.Z)({}, es_news, es_universal, es_category),
    "/news/page/[page]": (0,_object_spread/* default */.Z)({}, es_universal, es_category),
    "/news/category/[category]": (0,_object_spread/* default */.Z)({}, es_universal, es_category),
    "/news/category/[category]/page/[page]": (0,_object_spread/* default */.Z)({}, es_universal, es_category),
    "/user/[slug]": (0,_object_spread/* default */.Z)({}, es_universal, es_build, es_keyboard),
    "/software/[slug]": (0,_object_spread/* default */.Z)({}, es_universal),
    "/category/[slug]": (0,_object_spread/* default */.Z)({}, es_category, es_universal),
    "/category/[slug]/[subcategory-slug]": (0,_object_spread/* default */.Z)({}, es_category, es_universal),
    "/build": (0,_object_spread/* default */.Z)({}, es_universal, es_build),
    "/build/[slug]": (0,_object_spread/* default */.Z)({}, es_universal, es_build),
    "/build/pc": (0,_object_spread/* default */.Z)({}, es_universal, es_build),
    "/build/pc/[slug]": (0,_object_spread/* default */.Z)({}, es_universal, es_build),
    "/build/keyboard/[slug]": (0,_object_spread/* default */.Z)({}, es_universal, es_build, es_keyboard),
    "/build/[slug]/summary": (0,_object_spread/* default */.Z)({}, es_universal, es_build),
    "/support": (0,_object_spread/* default */.Z)({}, es_universal),
    "/refurbished/[slug]": (0,_object_spread/* default */.Z)({}, es_universal, es_refurb),
    "/careers": (0,_object_spread/* default */.Z)({}, es_universal),
    "/reviews/page/[page]": (0,_object_spread/* default */.Z)({}, es_universal),
    "/careers/available-positions": (0,_object_spread/* default */.Z)({}, es_universal),
    "/order-tracking/[slug]": (0,_object_spread/* default */.Z)({}, es_orderTracking, es_orderTrackingRoot, es_universal),
    "/order-tracking": (0,_object_spread/* default */.Z)({}, es_orderTrackingRoot, es_universal),
    "/retailers": (0,_object_spread/* default */.Z)({}, es_retailers, es_universal),
    "/search": (0,_object_spread/* default */.Z)({}, es_searchResults, es_universal),
    "/auth/[slug]": (0,_object_spread/* default */.Z)({}, es_universal),
    universal: es_universal
};

;// CONCATENATED MODULE: ./locale/index.ts







// EXTERNAL MODULE: ./css/fonts.css
var fonts = __webpack_require__(77334);
// EXTERNAL MODULE: ./css/index.css
var css = __webpack_require__(61751);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./components/Extend/ExtendConfig.tsx
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable no-param-reassign */ /* eslint-disable no-return-assign */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable func-names */ /* eslint-disable max-len */ /* eslint-disable prefer-template */ /* eslint-disable object-shorthand */ /* eslint-disable arrow-body-style */ 

var ExtendConfig = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "extend-sdk",
                src: "https://sdk.helloextend.com/extend-sdk-client/v1/extend-sdk-client.min.js",
                strategy: "lazyOnload",
                onLoad: function() {
                    if (true) {
                        window.Extend.config({
                            storeId: "4160045f-5f2a-42b3-a3b5-b5d798aa93f1",
                            environment: "production"
                        });
                    }
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                id: "extend-shopify-sdk",
                src: "https://sdk.helloextend.com/extend-sdk-client-shopify-addon/v1/extend-sdk-client-shopify-addon.min.js",
                strategy: "lazyOnload",
                onLoad: function() {
                    window.setTimeout(function() {
                        window.dispatchEvent(new CustomEvent("ExtendLoaded"));
                    }, 1000);
                }
            })
        ]
    });
};
/* harmony default export */ var Extend_ExtendConfig = (ExtendConfig);

// EXTERNAL MODULE: ./framework/cart/use-add-item.tsx + 1 modules
var use_add_item = __webpack_require__(2165);
// EXTERNAL MODULE: ./stores/use-ui-store/index.ts + 2 modules
var use_ui_store = __webpack_require__(86649);
;// CONCATENATED MODULE: ./components/Extend/ExtendAfterMarket.tsx
/* eslint-disable prefer-template */ /* eslint-disable consistent-return */ /* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable object-shorthand */ /* eslint-disable @typescript-eslint/no-unused-vars */ /* eslint-disable no-unused-expressions */ 




var InitializeAftermarket = function() {
    var ref = (0,react.useState)(false), loading = ref[0], setLoading = ref[1];
    var openCart = (0,use_ui_store/* default */.ZP)(use_ui_store/* getOpenCart */.r2);
    var addItem = (0,use_add_item/* default */.ZP)();
    if (true) {
        window.addEventListener("ExtendLoaded", function() {
            // Finds name parameter
            var getQueryParam = function(name) {
                var results = new RegExp("[?&]" + name + "=([^&#]*)").exec(window.location.href);
                if (results == null) {
                    return null;
                }
                /* eslint-disable @typescript-eslint/explicit-function-return-type */ return decodeURI(results[1]) || 0;
            };
            // Searches URL for both leadToken or leadtoken and sets it to the leadToken variable
            var leadToken;
            getQueryParam("leadToken") ? leadToken = getQueryParam("leadToken") : leadToken = getQueryParam("leadtoken");
            // If leadToken show modal containing lead offer
            if (leadToken) {
                window.Extend.aftermarketModal.open({
                    leadToken: leadToken,
                    onClose: function onClose(plan, product, quantity) {
                        if (plan && product) {
                            window.ExtendShopify.getPlanVariant({
                                referenceId: product.id,
                                termLength: plan.term
                            }, function() {
                                var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(err, planVariant) {
                                    var items;
                                    return runtime_default().wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                if (!(plan && window.ExtendShopify)) {
                                                    _ctx.next = 6;
                                                    break;
                                                }
                                                if (!err) {
                                                    _ctx.next = 3;
                                                    break;
                                                }
                                                return _ctx.abrupt("return", err);
                                            case 3:
                                                items = [
                                                    {
                                                        shopify_variants_id: planVariant.variantId,
                                                        quantity: quantity,
                                                        attributes: [
                                                            {
                                                                key: "Extend.IsExtendWarranty",
                                                                value: "true"
                                                            },
                                                            {
                                                                key: "Extend.LeadToken",
                                                                value: leadToken
                                                            },
                                                            {
                                                                key: "Extend.LeadQuantity",
                                                                value: quantity.toString()
                                                            }, 
                                                        ]
                                                    }, 
                                                ];
                                                _ctx.next = 6;
                                                return addItem(items).then(function() {
                                                    openCart();
                                                    setLoading(false);
                                                });
                                            case 6:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee);
                                }));
                                return function(err, planVariant) {
                                    return _ref.apply(this, arguments);
                                };
                            }());
                        }
                    }
                });
            }
        });
    }
    return null;
};
/* harmony default export */ var ExtendAfterMarket = (InitializeAftermarket);

;// CONCATENATED MODULE: ./pages/_app.tsx
/* eslint-disable react/jsx-no-useless-fragment */ /* eslint-disable no-console */ 























nprogress_default().configure({
    showSpinner: false
});
var vercelEnv = "production";
var cookieControlId = "b3b681cf7b519e7d5c7693b1c42542b6255ade91";
var cookieControlSrc = "https://cc.cdn.civiccomputing.com/9/cookieControl-9.x.min.js";
var gtmId = "GTM-NKJPMN6";
var gtmServerId = "https://www.googletagmanager.com";
var heapId = "3136564282";
var Noop = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    });
};
var MyApp = function(_param) {
    var Component = _param.Component, pageProps = _param.pageProps, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "Component",
        "pageProps"
    ]);
    var router = (0,next_router.useRouter)();
    var locale = router.locale, defaultLocale = router.defaultLocale, pathname = router.pathname;
    var parsedLocale = (0,parse_locale/* default */.Z)(defaultLocale, locale);
    var lang = parsedLocale[0];
    var ref = (0,hooks/* useLocationBasedCookies */.ce)({
        locale: locale,
        defaultLocale: defaultLocale
    }), _locationBasedCookies = ref.locationBasedCookies, cartCookie = _locationBasedCookies.cartCookie, localeCookie = _locationBasedCookies.localeCookie, shopifyCartCookie = _locationBasedCookies.shopifyCartCookie, updateLocationBasedCookies = ref.updateLocationBasedCookies;
    // eslint-disable-next-line import/namespace
    var localeCopy = locale_namespaceObject[lang];
    var messages = localeCopy[pathname] || localeCopy.universal;
    var Layout = Component.Layout || Noop;
    // detect adblock
    (0,react.useEffect)(function() {
        function detect() {
            return _detect.apply(this, arguments);
        }
        function _detect() {
            _detect = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var usingBlocker;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return detect_adblock();
                        case 2:
                            usingBlocker = _ctx.sent;
                            window.blocker = usingBlocker;
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return _detect.apply(this, arguments);
        }
        detect();
    }, []);
    (0,react.useEffect)(function() {
        var splitUrl = window.location.pathname.split("/");
        var regex = /[a-z]{2}-[A-Z]{2}$/;
        var isLocaleInUrl = splitUrl[1] ? regex.test(splitUrl[1]) : false;
        var localeFromUrl = isLocaleInUrl ? splitUrl[1] : constants/* DEFAULT_LOCALE */.ZWN;
        updateLocationBasedCookies(localeFromUrl);
    }, [
        updateLocationBasedCookies
    ]);
    (0,react.useEffect)(function() {
        var handleRouteChange = function(url) {
            var splitUrl = url.split("/");
            var regex = /[a-z]{2}-[A-Z]{2}$/;
            var isLocaleInUrl = splitUrl[1] ? regex.test(splitUrl[1]) : false;
            var localeFromUrl = isLocaleInUrl ? splitUrl[1] : constants/* DEFAULT_LOCALE */.ZWN;
            updateLocationBasedCookies(localeFromUrl);
        };
        router.events.on("routeChangeComplete", handleRouteChange);
        return function() {
            router.events.off("routeChangeComplete", handleRouteChange);
        };
    }, [
        router.events,
        updateLocationBasedCookies
    ]);
    (0,react.useEffect)(function() {
        var handleRouteChangeStart = function() {
            nprogress_default().start();
        };
        var handleRouteChangeEnd = function() {
            nprogress_default().done();
        };
        router.events.on("routeChangeStart", handleRouteChangeStart);
        router.events.on("routeChangeComplete", handleRouteChangeEnd);
        return function() {
            router.events.off("routeChangeStart", handleRouteChangeStart);
            router.events.off("routeChangeComplete", handleRouteChangeEnd);
        };
    }, [
        router.events
    ]);
    // Workaround for https://github.com/vercel/next.js/issues/8592
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var err = rest.err;
    var setPrevPath = use_build_store(getSetPrevPath);
    var setCurrentPath = use_build_store(getSetCurrentPath);
    var currentPath = use_build_store(getCurrentPath);
    (0,react.useEffect)(function() {
        if (router.asPath !== currentPath) {
            if (currentPath && !currentPath.startsWith("/".concat(constants/* ROUTE_BUILD */.fOR))) {
                setPrevPath(currentPath);
            }
            setCurrentPath(router.asPath);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        router.asPath
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(next_auth_react.SessionProvider, {
        session: pageProps.session,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(provider, {
            locale: locale,
            defaultLocale: defaultLocale,
            messages: messages,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* DefaultSeo */.lX, (0,_object_spread/* default */.Z)({}, constants/* SEO_DEFAULTS */.nIU)),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(framework/* CommerceProvider */.SN, {
                    locale: localeCookie,
                    cartCookieValue: cartCookie,
                    shopifyCartCookie: shopifyCartCookie,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout, {
                        pageProps: pageProps,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pageProps), {
                                err: err
                            })),
                            cookieControlId && cookieControlSrc && (vercelEnv === "production" || vercelEnv === "preview" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CookieControl_CookieControl, {
                                scriptSrc: cookieControlSrc,
                                apiKey: cookieControlId,
                                heapId: heapId,
                                gtmId: gtmId,
                                gtmServerId: gtmServerId,
                                locale: locale
                            }) : null),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Extend_ExtendConfig, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ExtendAfterMarket, {})
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var _app = (MyApp);


/***/ }),

/***/ 35222:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/version.js
var version = __webpack_require__(40105);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/sdk.js + 30 modules
var sdk = __webpack_require__(19985);
;// CONCATENATED MODULE: ./node_modules/@sentry/react/esm/sdk.js


/**
 * Inits the React SDK
 */
function init(options) {
  options._metadata = options._metadata || {};
  options._metadata.sdk = options._metadata.sdk || {
    name: 'sentry.javascript.react',
    packages: [
      {
        name: 'npm:@sentry/react',
        version: version/* SDK_VERSION */.J,
      },
    ],
    version: version/* SDK_VERSION */.J,
  };
  (0,sdk/* init */.S1)(options);
}


//# sourceMappingURL=sdk.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/hub/esm/exports.js
var esm_exports = __webpack_require__(92876);
// EXTERNAL MODULE: ./node_modules/@sentry/tracing/esm/hubextensions.js + 1 modules
var hubextensions = __webpack_require__(62758);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/buildPolyfills/_optionalChain.js
/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 * See https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */
function _optionalChain(ops) {
  let lastAccessLHS = undefined;
  let value = ops[0];
  let i = 1;
  while (i < ops.length) {
    var op = ops[i] ;
    var fn = ops[i + 1] ;
    i += 2;
    // by checking for loose equality to `null`, we catch both `null` and `undefined`
    if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
      // really we're meaning to return `undefined` as an actual value here, but it saves bytes not to write it
      return;
    }
    if (op === 'access' || op === 'optionalAccess') {
      lastAccessLHS = value;
      value = fn(value);
    } else if (op === 'call' || op === 'optionalCall') {
      value = fn((...args) => (value ).call(lastAccessLHS, ...args));
      lastAccessLHS = undefined;
    }
  }
  return value;
}

// Sucrase version
// function _optionalChain(ops) {
//   let lastAccessLHS = undefined;
//   let value = ops[0];
//   let i = 1;
//   while (i < ops.length) {
//     var op = ops[i];
//     var fn = ops[i + 1];
//     i += 2;
//     if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
//       return undefined;
//     }
//     if (op === 'access' || op === 'optionalAccess') {
//       lastAccessLHS = value;
//       value = fn(value);
//     } else if (op === 'call' || op === 'optionalCall') {
//       value = fn((...args) => value.call(lastAccessLHS, ...args));
//       lastAccessLHS = undefined;
//     }
//   }
//   return value;
// }


//# sourceMappingURL=_optionalChain.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(12343);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/global.js
var global = __webpack_require__(82991);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/tracing.js
var TRACEPARENT_REGEXP = new RegExp(
  '^[ \\t]*' + // whitespace
    '([0-9a-f]{32})?' + // trace_id
    '-?([0-9a-f]{16})?' + // span_id
    '-?([01])?' + // sampled
    '[ \\t]*$', // whitespace
);

/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */
function extractTraceparentData(traceparent) {
  var matches = traceparent.match(TRACEPARENT_REGEXP);
  if (matches) {
    let parentSampled;
    if (matches[3] === '1') {
      parentSampled = true;
    } else if (matches[3] === '0') {
      parentSampled = false;
    }
    return {
      traceId: matches[1],
      parentSampled,
      parentSpanId: matches[2],
    };
  }
  return undefined;
}


//# sourceMappingURL=tracing.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/baggage.js
var esm_baggage = __webpack_require__(99181);
// EXTERNAL MODULE: ./node_modules/@sentry/tracing/esm/idletransaction.js
var idletransaction = __webpack_require__(16458);
// EXTERNAL MODULE: ./node_modules/@sentry/tracing/esm/utils.js
var utils = __webpack_require__(63233);
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/backgroundtab.js



var backgroundtab_global = (0,global/* getGlobalObject */.R)();

/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */
function registerBackgroundTabDetection() {
  if (backgroundtab_global && backgroundtab_global.document) {
    backgroundtab_global.document.addEventListener('visibilitychange', () => {
      var activeTransaction = (0,utils/* getActiveTransaction */.x1)() ;
      if (backgroundtab_global.document.hidden && activeTransaction) {
        var statusType = 'cancelled';

        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
          logger/* logger.log */.kg.log(
            `[Tracing] Transaction: ${statusType} -> since tab moved to the background, op: ${activeTransaction.op}`,
          );
        // We should not set status if it is already set, this prevent important statuses like
        // error or data loss from being overwritten on transaction.
        if (!activeTransaction.status) {
          activeTransaction.setStatus(statusType);
        }
        activeTransaction.setTag('visibilitychange', 'document.hidden');
        activeTransaction.finish();
      }
    });
  } else {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.warn */.kg.warn('[Tracing] Could not set up background tab detection due to lack of global document');
  }
}


//# sourceMappingURL=backgroundtab.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/buildPolyfills/_nullishCoalesce.js
var _nullishCoalesce = __webpack_require__(45375);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/time.js
var time = __webpack_require__(21170);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/browser.js
var browser = __webpack_require__(58464);
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/lib/bindReporter.js
var bindReporter = (
  callback,
  metric,
  reportAllChanges,
) => {
  let prevValue;
  return (forceReport) => {
    if (metric.value >= 0) {
      if (forceReport || reportAllChanges) {
        metric.delta = metric.value - (prevValue || 0);

        // Report the metric if there's a non-zero delta or if no previous
        // value exists (which can happen in the case of the document becoming
        // hidden when the metric value is 0).
        // See: https://github.com/GoogleChrome/web-vitals/issues/14
        if (metric.delta || prevValue === undefined) {
          prevValue = metric.value;
          callback(metric);
        }
      }
    }
  };
};


//# sourceMappingURL=bindReporter.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/lib/generateUniqueID.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */
var generateUniqueID = () => {
  return `v2-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};


//# sourceMappingURL=generateUniqueID.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/lib/initMetric.js



var initMetric = (name, value) => {
  return {
    name,
    value: (0,_nullishCoalesce/* _nullishCoalesce */.h)(value, () => ( -1)),
    delta: 0,
    entries: [],
    id: generateUniqueID(),
  };
};


//# sourceMappingURL=initMetric.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/lib/observe.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */
var observe = (type, callback) => {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(type)) {
      // More extensive feature detect needed for Firefox due to:
      // https://github.com/GoogleChrome/web-vitals/issues/142
      if (type === 'first-input' && !('PerformanceEventTiming' in self)) {
        return;
      }

      var po = new PerformanceObserver(l => l.getEntries().map(callback));

      po.observe({ type, buffered: true });
      return po;
    }
  } catch (e) {
    // Do nothing.
  }
  return;
};


//# sourceMappingURL=observe.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/lib/onHidden.js


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var onHidden = (cb, once) => {
  var onHiddenOrPageHide = (event) => {
    if (event.type === 'pagehide' || (0,global/* getGlobalObject */.R)().document.visibilityState === 'hidden') {
      cb(event);
      if (once) {
        removeEventListener('visibilitychange', onHiddenOrPageHide, true);
        removeEventListener('pagehide', onHiddenOrPageHide, true);
      }
    }
  };
  addEventListener('visibilitychange', onHiddenOrPageHide, true);
  // Some browsers have buggy implementations of visibilitychange,
  // so we use pagehide in addition, just to be safe.
  addEventListener('pagehide', onHiddenOrPageHide, true);
};


//# sourceMappingURL=onHidden.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/getCLS.js





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// https://wicg.github.io/layout-instability/#sec-layout-shift

var getCLS = (onReport, reportAllChanges) => {
  var metric = initMetric('CLS', 0);
  let report;

  let sessionValue = 0;
  let sessionEntries = [];

  var entryHandler = (entry) => {
    // Only count layout shifts without recent user input.
    // TODO: Figure out why entry can be undefined
    if (entry && !entry.hadRecentInput) {
      var firstSessionEntry = sessionEntries[0];
      var lastSessionEntry = sessionEntries[sessionEntries.length - 1];

      // If the entry occurred less than 1 second after the previous entry and
      // less than 5 seconds after the first entry in the session, include the
      // entry in the current session. Otherwise, start a new session.
      if (
        sessionValue &&
        sessionEntries.length !== 0 &&
        entry.startTime - lastSessionEntry.startTime < 1000 &&
        entry.startTime - firstSessionEntry.startTime < 5000
      ) {
        sessionValue += entry.value;
        sessionEntries.push(entry);
      } else {
        sessionValue = entry.value;
        sessionEntries = [entry];
      }

      // If the current session value is larger than the current CLS value,
      // update CLS and the entries contributing to it.
      if (sessionValue > metric.value) {
        metric.value = sessionValue;
        metric.entries = sessionEntries;
        if (report) {
          report();
        }
      }
    }
  };

  var po = observe('layout-shift', entryHandler );
  if (po) {
    report = bindReporter(onReport, metric, reportAllChanges);

    onHidden(() => {
      po.takeRecords().map(entryHandler );
      report(true);
    });
  }
};


//# sourceMappingURL=getCLS.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/lib/getVisibilityWatcher.js



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

let firstHiddenTime = -1;

var initHiddenTime = () => {
  return (0,global/* getGlobalObject */.R)().document.visibilityState === 'hidden' ? 0 : Infinity;
};

var trackChanges = () => {
  // Update the time if/when the document becomes hidden.
  onHidden(({ timeStamp }) => {
    firstHiddenTime = timeStamp;
  }, true);
};

var getVisibilityWatcher = (

) => {
  if (firstHiddenTime < 0) {
    // If the document is hidden when this code runs, assume it was hidden
    // since navigation start. This isn't a perfect heuristic, but it's the
    // best we can do until an API is available to support querying past
    // visibilityState.
    firstHiddenTime = initHiddenTime();
    trackChanges();
  }
  return {
    get firstHiddenTime() {
      return firstHiddenTime;
    },
  };
};


//# sourceMappingURL=getVisibilityWatcher.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/getFID.js






/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var getFID = (onReport, reportAllChanges) => {
  var visibilityWatcher = getVisibilityWatcher();
  var metric = initMetric('FID');
  let report;

  var entryHandler = (entry) => {
    // Only report if the page wasn't hidden prior to the first input.
    if (report && entry.startTime < visibilityWatcher.firstHiddenTime) {
      metric.value = entry.processingStart - entry.startTime;
      metric.entries.push(entry);
      report(true);
    }
  };

  var po = observe('first-input', entryHandler );
  if (po) {
    report = bindReporter(onReport, metric, reportAllChanges);
    onHidden(() => {
      po.takeRecords().map(entryHandler );
      po.disconnect();
    }, true);
  }
};


//# sourceMappingURL=getFID.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/getLCP.js






/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// https://wicg.github.io/largest-contentful-paint/#sec-largest-contentful-paint-interface

var reportedMetricIDs = {};

var getLCP = (onReport, reportAllChanges) => {
  var visibilityWatcher = getVisibilityWatcher();
  var metric = initMetric('LCP');
  let report;

  var entryHandler = (entry) => {
    // The startTime attribute returns the value of the renderTime if it is not 0,
    // and the value of the loadTime otherwise.
    var value = entry.startTime;

    // If the page was hidden prior to paint time of the entry,
    // ignore it and mark the metric as final, otherwise add the entry.
    if (value < visibilityWatcher.firstHiddenTime) {
      metric.value = value;
      metric.entries.push(entry);
    }

    if (report) {
      report();
    }
  };

  var po = observe('largest-contentful-paint', entryHandler);

  if (po) {
    report = bindReporter(onReport, metric, reportAllChanges);

    var stopListening = () => {
      if (!reportedMetricIDs[metric.id]) {
        po.takeRecords().map(entryHandler );
        po.disconnect();
        reportedMetricIDs[metric.id] = true;
        report(true);
      }
    };

    // Stop listening after input. Note: while scrolling is an input that
    // stop LCP observation, it's unreliable since it can be programmatically
    // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
    ['keydown', 'click'].forEach(type => {
      addEventListener(type, stopListening, { once: true, capture: true });
    });

    onHidden(stopListening, true);
  }
};


//# sourceMappingURL=getLCP.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/metrics/utils.js
/**
 * Checks if a given value is a valid measurement value.
 */
function isMeasurementValue(value) {
  return typeof value === 'number' && isFinite(value);
}

/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 */
function _startChild(transaction, { startTimestamp, ...ctx }) {
  if (startTimestamp && transaction.startTimestamp > startTimestamp) {
    transaction.startTimestamp = startTimestamp;
  }

  return transaction.startChild({
    startTimestamp,
    ...ctx,
  });
}


//# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/metrics/index.js










var metrics_global = (0,global/* getGlobalObject */.R)();

function getBrowserPerformanceAPI() {
  return metrics_global && metrics_global.addEventListener && metrics_global.performance;
}

let _performanceCursor = 0;

let _measurements = {};
let _lcpEntry;
let _clsEntry;

/**
 * Start tracking web vitals
 */
function startTrackingWebVitals(reportAllChanges = false) {
  var performance = getBrowserPerformanceAPI();
  if (performance && time/* browserPerformanceTimeOrigin */.Z1) {
    if (performance.mark) {
      metrics_global.performance.mark('sentry-tracing-init');
    }
    _trackCLS();
    _trackLCP(reportAllChanges);
    _trackFID();
  }
}

/**
 * Start tracking long tasks.
 */
function startTrackingLongTasks() {
  var entryHandler = (entry) => {
    var transaction = (0,utils/* getActiveTransaction */.x1)() ;
    if (!transaction) {
      return;
    }
    var startTime = (0,utils/* msToSec */.XL)((time/* browserPerformanceTimeOrigin */.Z1 ) + entry.startTime);
    var duration = (0,utils/* msToSec */.XL)(entry.duration);
    transaction.startChild({
      description: 'Long Task',
      op: 'ui.long-task',
      startTimestamp: startTime,
      endTimestamp: startTime + duration,
    });
  };

  observe('longtask', entryHandler);
}

/** Starts tracking the Cumulative Layout Shift on the current page. */
function _trackCLS() {
  // See:
  // https://web.dev/evolving-cls/
  // https://web.dev/cls-web-tooling/
  getCLS(metric => {
    var entry = metric.entries.pop();
    if (!entry) {
      return;
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Measurements] Adding CLS');
    _measurements['cls'] = { value: metric.value, unit: '' };
    _clsEntry = entry ;
  });
}

/** Starts tracking the Largest Contentful Paint on the current page. */
function _trackLCP(reportAllChanges) {
  getLCP(metric => {
    var entry = metric.entries.pop();
    if (!entry) {
      return;
    }

    var timeOrigin = (0,utils/* msToSec */.XL)(time/* browserPerformanceTimeOrigin */.Z1 );
    var startTime = (0,utils/* msToSec */.XL)(entry.startTime);
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Measurements] Adding LCP');
    _measurements['lcp'] = { value: metric.value, unit: 'millisecond' };
    _measurements['mark.lcp'] = { value: timeOrigin + startTime, unit: 'second' };
    _lcpEntry = entry ;
  }, reportAllChanges);
}

/** Starts tracking the First Input Delay on the current page. */
function _trackFID() {
  getFID(metric => {
    var entry = metric.entries.pop();
    if (!entry) {
      return;
    }

    var timeOrigin = (0,utils/* msToSec */.XL)(time/* browserPerformanceTimeOrigin */.Z1 );
    var startTime = (0,utils/* msToSec */.XL)(entry.startTime);
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Measurements] Adding FID');
    _measurements['fid'] = { value: metric.value, unit: 'millisecond' };
    _measurements['mark.fid'] = { value: timeOrigin + startTime, unit: 'second' };
  });
}

/** Add performance related spans to a transaction */
function addPerformanceEntries(transaction) {
  var performance = getBrowserPerformanceAPI();
  if (!performance || !metrics_global.performance.getEntries || !time/* browserPerformanceTimeOrigin */.Z1) {
    // Gatekeeper if performance API not available
    return;
  }

  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Tracing] Adding & adjusting spans using Performance API');
  var timeOrigin = (0,utils/* msToSec */.XL)(time/* browserPerformanceTimeOrigin */.Z1);

  var performanceEntries = performance.getEntries();

  let responseStartTimestamp;
  let requestStartTimestamp;

    performanceEntries.slice(_performanceCursor).forEach((entry) => {
    var startTime = (0,utils/* msToSec */.XL)(entry.startTime);
    var duration = (0,utils/* msToSec */.XL)(entry.duration);

    if (transaction.op === 'navigation' && timeOrigin + startTime < transaction.startTimestamp) {
      return;
    }

    switch (entry.entryType) {
      case 'navigation': {
        _addNavigationSpans(transaction, entry, timeOrigin);
        responseStartTimestamp = timeOrigin + (0,utils/* msToSec */.XL)(entry.responseStart);
        requestStartTimestamp = timeOrigin + (0,utils/* msToSec */.XL)(entry.requestStart);
        break;
      }
      case 'mark':
      case 'paint':
      case 'measure': {
        var startTimestamp = _addMeasureSpans(transaction, entry, startTime, duration, timeOrigin);

        // capture web vitals
        var firstHidden = getVisibilityWatcher();
        // Only report if the page wasn't hidden prior to the web vital.
        var shouldRecord = entry.startTime < firstHidden.firstHiddenTime;

        if (entry.name === 'first-paint' && shouldRecord) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Measurements] Adding FP');
          _measurements['fp'] = { value: entry.startTime, unit: 'millisecond' };
          _measurements['mark.fp'] = { value: startTimestamp, unit: 'second' };
        }
        if (entry.name === 'first-contentful-paint' && shouldRecord) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Measurements] Adding FCP');
          _measurements['fcp'] = { value: entry.startTime, unit: 'millisecond' };
          _measurements['mark.fcp'] = { value: startTimestamp, unit: 'second' };
        }
        break;
      }
      case 'resource': {
        var resourceName = (entry.name ).replace(metrics_global.location.origin, '');
        _addResourceSpans(transaction, entry, resourceName, startTime, duration, timeOrigin);
        break;
      }
      default:
      // Ignore other entry types.
    }
  });

  _performanceCursor = Math.max(performanceEntries.length - 1, 0);

  _trackNavigator(transaction);

  // Measurements are only available for pageload transactions
  if (transaction.op === 'pageload') {
    // Generate TTFB (Time to First Byte), which measured as the time between the beginning of the transaction and the
    // start of the response in milliseconds
    if (typeof responseStartTimestamp === 'number') {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Measurements] Adding TTFB');
      _measurements['ttfb'] = {
        value: (responseStartTimestamp - transaction.startTimestamp) * 1000,
        unit: 'millisecond',
      };

      if (typeof requestStartTimestamp === 'number' && requestStartTimestamp <= responseStartTimestamp) {
        // Capture the time spent making the request and receiving the first byte of the response.
        // This is the time between the start of the request and the start of the response in milliseconds.
        _measurements['ttfb.requestTime'] = {
          value: (responseStartTimestamp - requestStartTimestamp) * 1000,
          unit: 'millisecond',
        };
      }
    }

    ['fcp', 'fp', 'lcp'].forEach(name => {
      if (!_measurements[name] || timeOrigin >= transaction.startTimestamp) {
        return;
      }
      // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
      // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
      // to be adjusted to be relative to transaction.startTimestamp.
      var oldValue = _measurements[name].value;
      var measurementTimestamp = timeOrigin + (0,utils/* msToSec */.XL)(oldValue);

      // normalizedValue should be in milliseconds
      var normalizedValue = Math.abs((measurementTimestamp - transaction.startTimestamp) * 1000);
      var delta = normalizedValue - oldValue;

      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        logger/* logger.log */.kg.log(`[Measurements] Normalized ${name} from ${oldValue} to ${normalizedValue} (${delta})`);
      _measurements[name].value = normalizedValue;
    });

    if (_measurements['mark.fid'] && _measurements['fid']) {
      // create span for FID
      _startChild(transaction, {
        description: 'first input delay',
        endTimestamp: _measurements['mark.fid'].value + (0,utils/* msToSec */.XL)(_measurements['fid'].value),
        op: 'web.vitals',
        startTimestamp: _measurements['mark.fid'].value,
      });
    }

    // If FCP is not recorded we should not record the cls value
    // according to the new definition of CLS.
    if (!('fcp' in _measurements)) {
      delete _measurements.cls;
    }

    Object.keys(_measurements).forEach(measurementName => {
      transaction.setMeasurement(
        measurementName,
        _measurements[measurementName].value,
        _measurements[measurementName].unit,
      );
    });

    _tagMetricInfo(transaction);
  }

  _lcpEntry = undefined;
  _clsEntry = undefined;
  _measurements = {};
}

/** Create measure related spans */
function _addMeasureSpans(
  transaction,
    entry,
  startTime,
  duration,
  timeOrigin,
) {
  var measureStartTimestamp = timeOrigin + startTime;
  var measureEndTimestamp = measureStartTimestamp + duration;

  _startChild(transaction, {
    description: entry.name ,
    endTimestamp: measureEndTimestamp,
    op: entry.entryType ,
    startTimestamp: measureStartTimestamp,
  });

  return measureStartTimestamp;
}

/** Instrument navigation entries */
function _addNavigationSpans(transaction, entry, timeOrigin) {
  ['unloadEvent', 'redirect', 'domContentLoadedEvent', 'loadEvent', 'connect'].forEach(event => {
    _addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
  });
  _addPerformanceNavigationTiming(transaction, entry, 'secureConnection', timeOrigin, 'TLS/SSL', 'connectEnd');
  _addPerformanceNavigationTiming(transaction, entry, 'fetch', timeOrigin, 'cache', 'domainLookupStart');
  _addPerformanceNavigationTiming(transaction, entry, 'domainLookup', timeOrigin, 'DNS');
  _addRequest(transaction, entry, timeOrigin);
}

/** Create performance navigation related spans */
function _addPerformanceNavigationTiming(
  transaction,
    entry,
  event,
  timeOrigin,
  description,
  eventEnd,
) {
  var end = eventEnd ? (entry[eventEnd] ) : (entry[`${event}End`] );
  var start = entry[`${event}Start`] ;
  if (!start || !end) {
    return;
  }
  _startChild(transaction, {
    op: 'browser',
    description: (0,_nullishCoalesce/* _nullishCoalesce */.h)(description, () => ( event)),
    startTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(start),
    endTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(end),
  });
}

/** Create request and response related spans */
function _addRequest(transaction, entry, timeOrigin) {
  _startChild(transaction, {
    op: 'browser',
    description: 'request',
    startTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(entry.requestStart ),
    endTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(entry.responseEnd ),
  });

  _startChild(transaction, {
    op: 'browser',
    description: 'response',
    startTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(entry.responseStart ),
    endTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(entry.responseEnd ),
  });
}

/** Create resource-related spans */
function _addResourceSpans(
  transaction,
  entry,
  resourceName,
  startTime,
  duration,
  timeOrigin,
) {
  // we already instrument based on fetch and xhr, so we don't need to
  // duplicate spans here.
  if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') {
    return;
  }

    var data = {};
  if ('transferSize' in entry) {
    data['Transfer Size'] = entry.transferSize;
  }
  if ('encodedBodySize' in entry) {
    data['Encoded Body Size'] = entry.encodedBodySize;
  }
  if ('decodedBodySize' in entry) {
    data['Decoded Body Size'] = entry.decodedBodySize;
  }

  var startTimestamp = timeOrigin + startTime;
  var endTimestamp = startTimestamp + duration;

  _startChild(transaction, {
    description: resourceName,
    endTimestamp,
    op: entry.initiatorType ? `resource.${entry.initiatorType}` : 'resource',
    startTimestamp,
    data,
  });
}

/**
 * Capture the information of the user agent.
 */
function _trackNavigator(transaction) {
  var navigator = metrics_global.navigator ;
  if (!navigator) {
    return;
  }

  // track network connectivity
  var connection = navigator.connection;
  if (connection) {
    if (connection.effectiveType) {
      transaction.setTag('effectiveConnectionType', connection.effectiveType);
    }

    if (connection.type) {
      transaction.setTag('connectionType', connection.type);
    }

    if (isMeasurementValue(connection.rtt)) {
      _measurements['connection.rtt'] = { value: connection.rtt, unit: 'millisecond' };
    }

    if (isMeasurementValue(connection.downlink)) {
      _measurements['connection.downlink'] = { value: connection.downlink, unit: '' }; // unit is empty string for now, while relay doesn't support download speed units
    }
  }

  if (isMeasurementValue(navigator.deviceMemory)) {
    transaction.setTag('deviceMemory', `${navigator.deviceMemory} GB`);
  }

  if (isMeasurementValue(navigator.hardwareConcurrency)) {
    transaction.setTag('hardwareConcurrency', String(navigator.hardwareConcurrency));
  }
}

/** Add LCP / CLS data to transaction to allow debugging */
function _tagMetricInfo(transaction) {
  if (_lcpEntry) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Measurements] Adding LCP Data');

    // Capture Properties of the LCP element that contributes to the LCP.

    if (_lcpEntry.element) {
      transaction.setTag('lcp.element', (0,browser/* htmlTreeAsString */.R)(_lcpEntry.element));
    }

    if (_lcpEntry.id) {
      transaction.setTag('lcp.id', _lcpEntry.id);
    }

    if (_lcpEntry.url) {
      // Trim URL to the first 200 characters.
      transaction.setTag('lcp.url', _lcpEntry.url.trim().slice(0, 200));
    }

    transaction.setTag('lcp.size', _lcpEntry.size);
  }

  // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
  if (_clsEntry && _clsEntry.sources) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log('[Measurements] Adding CLS Data');
    _clsEntry.sources.forEach((source, index) =>
      transaction.setTag(`cls.source.${index + 1}`, (0,browser/* htmlTreeAsString */.R)(source.node)),
    );
  }
}


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/string.js
var string = __webpack_require__(57321);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/instrument.js
var instrument = __webpack_require__(9732);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(67597);
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/request.js



var DEFAULT_TRACING_ORIGINS = ['localhost', /^\//];

/** Options for Request Instrumentation */

var defaultRequestInstrumentationOptions = {
  traceFetch: true,
  traceXHR: true,
  tracingOrigins: DEFAULT_TRACING_ORIGINS,
};

/** Registers span creators for xhr and fetch requests  */
function instrumentOutgoingRequests(_options) {
    const { traceFetch, traceXHR, tracingOrigins, shouldCreateSpanForRequest } = {
    ...defaultRequestInstrumentationOptions,
    ..._options,
  };

  // We should cache url -> decision so that we don't have to compute
  // regexp everytime we create a request.
  var urlMap = {};

  var defaultShouldCreateSpan = (url) => {
    if (urlMap[url]) {
      return urlMap[url];
    }
    var origins = tracingOrigins;
    urlMap[url] =
      origins.some((origin) => (0,string/* isMatchingPattern */.zC)(url, origin)) &&
      !(0,string/* isMatchingPattern */.zC)(url, 'sentry_key');
    return urlMap[url];
  };

  // We want that our users don't have to re-implement shouldCreateSpanForRequest themselves
  // That's why we filter out already unwanted Spans from tracingOrigins
  let shouldCreateSpan = defaultShouldCreateSpan;
  if (typeof shouldCreateSpanForRequest === 'function') {
    shouldCreateSpan = (url) => {
      return defaultShouldCreateSpan(url) && shouldCreateSpanForRequest(url);
    };
  }

  var spans = {};

  if (traceFetch) {
    (0,instrument/* addInstrumentationHandler */.o)('fetch', (handlerData) => {
      fetchCallback(handlerData, shouldCreateSpan, spans);
    });
  }

  if (traceXHR) {
    (0,instrument/* addInstrumentationHandler */.o)('xhr', (handlerData) => {
      xhrCallback(handlerData, shouldCreateSpan, spans);
    });
  }
}

/**
 * Create and track fetch request spans
 */
function fetchCallback(
  handlerData,
  shouldCreateSpan,
  spans,
) {
  if (!(0,utils/* hasTracingEnabled */.zu)() || !(handlerData.fetchData && shouldCreateSpan(handlerData.fetchData.url))) {
    return;
  }

  if (handlerData.endTimestamp) {
    var spanId = handlerData.fetchData.__span;
    if (!spanId) return;

    var span = spans[spanId];
    if (span) {
      if (handlerData.response) {
        // TODO (kmclb) remove this once types PR goes through
                span.setHttpStatus(handlerData.response.status);
      } else if (handlerData.error) {
        span.setStatus('internal_error');
      }
      span.finish();

            delete spans[spanId];
    }
    return;
  }

  var activeTransaction = (0,utils/* getActiveTransaction */.x1)();
  if (activeTransaction) {
    var span = activeTransaction.startChild({
      data: {
        ...handlerData.fetchData,
        type: 'fetch',
      },
      description: `${handlerData.fetchData.method} ${handlerData.fetchData.url}`,
      op: 'http.client',
    });

    handlerData.fetchData.__span = span.spanId;
    spans[span.spanId] = span;

    var request = (handlerData.args[0] = handlerData.args[0] );
        var options = (handlerData.args[1] = (handlerData.args[1] ) || {});
    options.headers = addTracingHeaders(request, activeTransaction.getBaggage(), span, options);
  }
}

function addTracingHeaders(
  request,
  incomingBaggage,
  span,
  options,
) {
  let headers = options.headers;

  if ((0,is/* isInstanceOf */.V9)(request, Request)) {
    headers = (request ).headers;
  }

  if (headers) {
        if (typeof headers.append === 'function') {
            headers.append('sentry-trace', span.toTraceparent());
            headers.append(esm_baggage/* BAGGAGE_HEADER_NAME */.bU, (0,esm_baggage/* mergeAndSerializeBaggage */.J8)(incomingBaggage, headers.get(esm_baggage/* BAGGAGE_HEADER_NAME */.bU)));
    } else if (Array.isArray(headers)) {
      const [, headerBaggageString] = headers.find(([key, _]) => key === esm_baggage/* BAGGAGE_HEADER_NAME */.bU);
      headers = [
        ...headers,
        ['sentry-trace', span.toTraceparent()],
        [esm_baggage/* BAGGAGE_HEADER_NAME */.bU, (0,esm_baggage/* mergeAndSerializeBaggage */.J8)(incomingBaggage, headerBaggageString)],
      ];
    } else {
      headers = {
        ...headers,
        'sentry-trace': span.toTraceparent(),
                baggage: (0,esm_baggage/* mergeAndSerializeBaggage */.J8)(incomingBaggage, headers.baggage),
      };
    }
  } else {
    headers = { 'sentry-trace': span.toTraceparent(), baggage: (0,esm_baggage/* mergeAndSerializeBaggage */.J8)(incomingBaggage) };
  }
  return headers;
}

/**
 * Create and track xhr request spans
 */
function xhrCallback(
  handlerData,
  shouldCreateSpan,
  spans,
) {
  if (
    !(0,utils/* hasTracingEnabled */.zu)() ||
    (handlerData.xhr && handlerData.xhr.__sentry_own_request__) ||
    !(handlerData.xhr && handlerData.xhr.__sentry_xhr__ && shouldCreateSpan(handlerData.xhr.__sentry_xhr__.url))
  ) {
    return;
  }

  var xhr = handlerData.xhr.__sentry_xhr__;

  // check first if the request has finished and is tracked by an existing span which should now end
  if (handlerData.endTimestamp) {
    var spanId = handlerData.xhr.__sentry_xhr_span_id__;
    if (!spanId) return;

    var span = spans[spanId];
    if (span) {
      span.setHttpStatus(xhr.status_code);
      span.finish();

            delete spans[spanId];
    }
    return;
  }

  // if not, create a new span to track it
  var activeTransaction = (0,utils/* getActiveTransaction */.x1)();
  if (activeTransaction) {
    var span = activeTransaction.startChild({
      data: {
        ...xhr.data,
        type: 'xhr',
        method: xhr.method,
        url: xhr.url,
      },
      description: `${xhr.method} ${xhr.url}`,
      op: 'http.client',
    });

    handlerData.xhr.__sentry_xhr_span_id__ = span.spanId;
    spans[handlerData.xhr.__sentry_xhr_span_id__] = span;

    if (handlerData.xhr.setRequestHeader) {
      try {
        handlerData.xhr.setRequestHeader('sentry-trace', span.toTraceparent());

        var headerBaggageString =
          handlerData.xhr.getRequestHeader && handlerData.xhr.getRequestHeader(esm_baggage/* BAGGAGE_HEADER_NAME */.bU);

        handlerData.xhr.setRequestHeader(
          esm_baggage/* BAGGAGE_HEADER_NAME */.bU,
          (0,esm_baggage/* mergeAndSerializeBaggage */.J8)(activeTransaction.getBaggage(), headerBaggageString),
        );
      } catch (_) {
        // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
      }
    }
  }
}


//# sourceMappingURL=request.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/router.js


var router_global = (0,global/* getGlobalObject */.R)();

/**
 * Default function implementing pageload and navigation transactions
 */
function instrumentRoutingWithDefaults(
  customStartTransaction,
  startTransactionOnPageLoad = true,
  startTransactionOnLocationChange = true,
) {
  if (!router_global || !router_global.location) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn('Could not initialize routing instrumentation due to invalid location');
    return;
  }

  let startingUrl = router_global.location.href;

  let activeTransaction;
  if (startTransactionOnPageLoad) {
    activeTransaction = customStartTransaction({
      name: router_global.location.pathname,
      op: 'pageload',
      metadata: { source: 'url' },
    });
  }

  if (startTransactionOnLocationChange) {
    (0,instrument/* addInstrumentationHandler */.o)('history', ({ to, from }) => {
      /**
       * This early return is there to account for some cases where a navigation transaction starts right after
       * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
       * create an uneccessary navigation transaction.
       *
       * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
       * only be caused in certain development environments where the usage of a hot module reloader is causing
       * errors.
       */
      if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
        startingUrl = undefined;
        return;
      }

      if (from !== to) {
        startingUrl = undefined;
        if (activeTransaction) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log(`[Tracing] Finishing current transaction with op: ${activeTransaction.op}`);
          // If there's an open transaction on the scope, we need to finish it before creating an new one.
          activeTransaction.finish();
        }
        activeTransaction = customStartTransaction({
          name: router_global.location.pathname,
          op: 'navigation',
          metadata: { source: 'url' },
        });
      }
    });
  }
}


//# sourceMappingURL=router.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/browsertracing.js










var BROWSER_TRACING_INTEGRATION_ID = 'BrowserTracing';

/** Options for Browser Tracing integration */

var DEFAULT_BROWSER_TRACING_OPTIONS = {
  idleTimeout: idletransaction/* DEFAULT_IDLE_TIMEOUT */.nT,
  finalTimeout: idletransaction/* DEFAULT_FINAL_TIMEOUT */.mg,
  markBackgroundTransactions: true,
  routingInstrumentation: instrumentRoutingWithDefaults,
  startTransactionOnLocationChange: true,
  startTransactionOnPageLoad: true,
  _experiments: { enableLongTask: true },
  ...defaultRequestInstrumentationOptions,
};

/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 */
class BrowserTracing  {
  // This class currently doesn't have a static `id` field like the other integration classes, because it prevented
  // @sentry/tracing from being treeshaken. Tree shakers do not like static fields, because they behave like side effects.
  // TODO: Come up with a better plan, than using static fields on integration classes, and use that plan on all
  // integrations.

  /** Browser Tracing integration options */
  

  /**
   * @inheritDoc
   */
   __init() {this.name = BROWSER_TRACING_INTEGRATION_ID;}

   constructor(_options) {;BrowserTracing.prototype.__init.call(this);
    let tracingOrigins = defaultRequestInstrumentationOptions.tracingOrigins;
    // NOTE: Logger doesn't work in constructors, as it's initialized after integrations instances
    if (_options) {
      if (_options.tracingOrigins && Array.isArray(_options.tracingOrigins)) {
        tracingOrigins = _options.tracingOrigins;
      } else {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (this._emitOptionsWarning = true);
      }
    }

    this.options = {
      ...DEFAULT_BROWSER_TRACING_OPTIONS,
      ..._options,
      tracingOrigins,
    };

    const { _metricOptions } = this.options;
    startTrackingWebVitals(_metricOptions && _metricOptions._reportAllChanges);
    if (_optionalChain([this, 'access', _2 => _2.options, 'access', _3 => _3._experiments, 'optionalAccess', _4 => _4.enableLongTask])) {
      startTrackingLongTasks();
    }
  }

  /**
   * @inheritDoc
   */
   setupOnce(_, getCurrentHub) {
    this._getCurrentHub = getCurrentHub;

    if (this._emitOptionsWarning) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        logger/* logger.warn */.kg.warn(
          '[Tracing] You need to define `tracingOrigins` in the options. Set an array of urls or patterns to trace.',
        );
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        logger/* logger.warn */.kg.warn(
          `[Tracing] We added a reasonable default for you: ${defaultRequestInstrumentationOptions.tracingOrigins}`,
        );
    }

        const {
      routingInstrumentation: instrumentRouting,
      startTransactionOnLocationChange,
      startTransactionOnPageLoad,
      markBackgroundTransactions,
      traceFetch,
      traceXHR,
      tracingOrigins,
      shouldCreateSpanForRequest,
    } = this.options;

    instrumentRouting(
      (context) => this._createRouteTransaction(context),
      startTransactionOnPageLoad,
      startTransactionOnLocationChange,
    );

    if (markBackgroundTransactions) {
      registerBackgroundTabDetection();
    }

    instrumentOutgoingRequests({ traceFetch, traceXHR, tracingOrigins, shouldCreateSpanForRequest });
  }

  /** Create routing idle transaction. */
   _createRouteTransaction(context) {
    if (!this._getCurrentHub) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        logger/* logger.warn */.kg.warn(`[Tracing] Did not create ${context.op} transaction because _getCurrentHub is invalid.`);
      return undefined;
    }

        const { beforeNavigate, idleTimeout, finalTimeout } = this.options;

    var parentContextFromHeader = context.op === 'pageload' ? extractTraceDataFromMetaTags() : undefined;

    var expandedContext = {
      ...context,
      ...parentContextFromHeader,
      ...(parentContextFromHeader && {
        metadata: {
          ...context.metadata,
          ...parentContextFromHeader.metadata,
        },
      }),
      trimEnd: true,
    };
    var modifiedContext = typeof beforeNavigate === 'function' ? beforeNavigate(expandedContext) : expandedContext;

    // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
    // from being sent to Sentry).
    var finalContext = modifiedContext === undefined ? { ...expandedContext, sampled: false } : modifiedContext;

    // If `beforeNavigate` set a custom name, record that fact
    finalContext.metadata =
      finalContext.name !== expandedContext.name
        ? { ...finalContext.metadata, source: 'custom' }
        : finalContext.metadata;

    if (finalContext.sampled === false) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        logger/* logger.log */.kg.log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log(`[Tracing] Starting ${finalContext.op} transaction on scope`);

    var hub = this._getCurrentHub();
    const { location } = (0,global/* getGlobalObject */.R)() ;

    var idleTransaction = (0,hubextensions/* startIdleTransaction */.lb)(
      hub,
      finalContext,
      idleTimeout,
      finalTimeout,
      true,
      { location }, // for use in the tracesSampler
    );
    idleTransaction.registerBeforeFinishCallback(transaction => {
      addPerformanceEntries(transaction);
      transaction.setTag(
        'sentry_reportAllChanges',
        Boolean(this.options._metricOptions && this.options._metricOptions._reportAllChanges),
      );
    });

    return idleTransaction ;
  }
}

/**
 * Gets transaction context data from `sentry-trace` and `baggage` <meta> tags.
 * @returns Transaction context data or undefined neither tag exists or has valid data
 */
function extractTraceDataFromMetaTags() {
  var sentrytraceValue = getMetaContent('sentry-trace');
  var baggageValue = getMetaContent('baggage');

  var sentrytraceData = sentrytraceValue ? extractTraceparentData(sentrytraceValue) : undefined;
  var baggage = (0,esm_baggage/* parseBaggageSetMutability */.rg)(baggageValue, sentrytraceValue);

  // TODO more extensive checks for baggage validity/emptyness?
  if (sentrytraceData || baggage) {
    return {
      ...(sentrytraceData && sentrytraceData),
      ...(baggage && { metadata: { baggage } }),
    };
  }

  return undefined;
}

/** Returns the value of a meta tag */
function getMetaContent(metaName) {
  var globalObject = (0,global/* getGlobalObject */.R)();

  // DOM/querySelector is not available in all environments
  if (globalObject.document && globalObject.document.querySelector) {
    var el = globalObject.document.querySelector(`meta[name=${metaName}]`);
    return el ? el.getAttribute('content') : null;
  } else {
    return null;
  }
}


//# sourceMappingURL=browsertracing.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/index.js














;
;

// Treeshakable guard to remove all code related to tracing

// Guard for tree
if (typeof __SENTRY_TRACING__ === 'undefined' || __SENTRY_TRACING__) {
  // We are patching the global object with our hub extension methods
  (0,hubextensions/* addExtensionMethods */.ro)();
}
//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/hub/esm/hub.js
var hub = __webpack_require__(38641);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/object.js
var object = __webpack_require__(20535);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/url.js
var esm_url = __webpack_require__(26956);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/performance/client.js




var client_global = (0,global/* getGlobalObject */.R)();

/**
 * Every Next.js page (static and dynamic ones) comes with a script tag with the id "__NEXT_DATA__". This script tag
 * contains a JSON object with data that was either generated at build time for static pages (`getStaticProps`), or at
 * runtime with data fetchers like `getServerSideProps.`.
 *
 * We can use this information to:
 * - Always get the parameterized route we're in when loading a page.
 * - Send trace information (trace-id, baggage) from the server to the client.
 *
 * This function extracts this information.
 */
function extractNextDataTagInformation() {
  let nextData;
  // Let's be on the safe side and actually check first if there is really a __NEXT_DATA__ script tag on the page.
  // Theoretically this should always be the case though.
  var nextDataTag = client_global.document.getElementById('__NEXT_DATA__');
  if (nextDataTag && nextDataTag.innerHTML) {
    try {
      nextData = JSON.parse(nextDataTag.innerHTML);
    } catch (e) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn('Could not extract __NEXT_DATA__');
    }
  }

  if (!nextData) {
    return {};
  }

  var nextDataTagInfo = {};

  const { page, query, props } = nextData;

  // `nextData.page` always contains the parameterized route
  nextDataTagInfo.route = page;
  nextDataTagInfo.params = query;

  if (props) {
    const { pageProps } = props;

    var getInitialPropsBaggage = props._sentryGetInitialPropsBaggage;
    var getServerSidePropsBaggage = pageProps && pageProps._sentryGetServerSidePropsBaggage;
    var getStaticPropsBaggage = pageProps && pageProps._sentryGetStaticPropsBaggage;
    // Ordering of the following shouldn't matter but `getInitialProps` generally runs before `getServerSideProps` or `getStaticProps` so we give it priority.
    var baggage = getInitialPropsBaggage || getServerSidePropsBaggage || getStaticPropsBaggage;
    if (baggage) {
      nextDataTagInfo.baggage = baggage;
    }

    var getInitialPropsTraceData = props._sentryGetInitialPropsTraceData;
    var getServerSidePropsTraceData = pageProps && pageProps._sentryGetServerSidePropsTraceData;
    var getStaticPropsTraceData = pageProps && pageProps._sentryGetStaticPropsTraceData;
    // Ordering of the following shouldn't matter but `getInitialProps` generally runs before `getServerSideProps` or `getStaticProps` so we give it priority.
    var traceData = getInitialPropsTraceData || getServerSidePropsTraceData || getStaticPropsTraceData;
    if (traceData) {
      nextDataTagInfo.traceParentData = extractTraceparentData(traceData);
    }
  }

  return nextDataTagInfo;
}

var DEFAULT_TAGS = {
  'routing.instrumentation': 'next-router',
} ;

let activeTransaction = undefined;
let prevTransactionName = undefined;
let startTransaction = undefined;

var client = (0,hub/* getCurrentHub */.Gd)().getClient();

/**
 * Creates routing instrumention for Next Router. Only supported for
 * client side routing. Works for Next >= 10.
 *
 * Leverages the SingletonRouter from the `next/router` to
 * generate pageload/navigation transactions and parameterize
 * transaction names.
 */
function nextRouterInstrumentation(
  startTransactionCb,
  startTransactionOnPageLoad = true,
  startTransactionOnLocationChange = true,
) {
  startTransaction = startTransactionCb;

  if (startTransactionOnPageLoad) {
    const { route, traceParentData, baggage, params } = extractNextDataTagInformation();

    prevTransactionName = route || client_global.location.pathname;
    var source = route ? 'route' : 'url';

    activeTransaction = startTransactionCb({
      name: prevTransactionName,
      op: 'pageload',
      tags: DEFAULT_TAGS,
      ...(params && client && client.getOptions().sendDefaultPii && { data: params }),
      ...traceParentData,
      metadata: {
        source,
        ...(baggage && { baggage: (0,esm_baggage/* parseBaggageHeader */.XM)(baggage) }),
      },
    });
  }

  router_default().ready(() => {
    // Spans that aren't attached to any transaction are lost; so if transactions aren't
    // created (besides potentially the onpageload transaction), no need to wrap the router.
    if (!startTransactionOnLocationChange) return;

    // `withRouter` uses `useRouter` underneath:
    // https://github.com/vercel/next.js/blob/de42719619ae69fbd88e445100f15701f6e1e100/packages/next/client/with-router.tsx#L21
    // Router events also use the router:
    // https://github.com/vercel/next.js/blob/de42719619ae69fbd88e445100f15701f6e1e100/packages/next/client/router.ts#L92
    // `Router.changeState` handles the router state changes, so it may be enough to only wrap it
    // (instead of wrapping all of the Router's functions).
    var routerPrototype = Object.getPrototypeOf((router_default()).router);
    (0,object/* fill */.hl)(routerPrototype, 'changeState', changeStateWrapper);
  });
}

/**
 * Wraps Router.changeState()
 * https://github.com/vercel/next.js/blob/da97a18dafc7799e63aa7985adc95f213c2bf5f3/packages/next/next-server/lib/router/router.ts#L1204
 * Start a navigation transaction every time the router changes state.
 */
function changeStateWrapper(originalChangeStateWrapper) {
  return function wrapper(
    
    method,
    // The parameterized url, ex. posts/[id]/[comment]
    url,
    // The actual url, ex. posts/85/my-comment
    as,
    options,
    // At the moment there are no additional arguments (meaning the rest parameter is empty).
    // This is meant to protect from future additions to Next.js API, especially since this is an
    // internal API.
    ...args
  ) {
    var newTransactionName = (0,esm_url/* stripUrlQueryAndFragment */.rt)(url);
    // do not start a transaction if it's from the same page
    if (startTransaction !== undefined && prevTransactionName !== newTransactionName) {
      if (activeTransaction) {
        activeTransaction.finish();
      }
      var tags = {
        ...DEFAULT_TAGS,
        method,
        ...options,
      };
      if (prevTransactionName) {
        tags.from = prevTransactionName;
      }
      prevTransactionName = newTransactionName;
      activeTransaction = startTransaction({
        name: prevTransactionName,
        op: 'navigation',
        tags,
        metadata: { source: 'route' },
      });
    }
    return originalChangeStateWrapper.call(this, method, url, as, options, ...args);
  };
}


//# sourceMappingURL=client.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/utils/metadata.js


var PACKAGE_NAME_PREFIX = 'npm:@sentry/';

/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 * @param options sdk options object that gets mutated
 * @param names list of package names
 */
function buildMetadata(options, names) {
  options._metadata = options._metadata || {};
  options._metadata.sdk =
    options._metadata.sdk ||
    ({
      name: 'sentry.javascript.nextjs',
      packages: names.map(name => ({
        name: `${PACKAGE_NAME_PREFIX}${name}`,
        version: version/* SDK_VERSION */.J,
      })),
      version: version/* SDK_VERSION */.J,
    } );
}


//# sourceMappingURL=metadata.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/utils/userIntegrations.js
/**
 * Recursively traverses an object to update an existing nested key.
 * Note: The provided key path must include existing properties,
 * the function will not create objects while traversing.
 *
 * @param obj An object to update
 * @param value The value to update the nested key with
 * @param keyPath The path to the key to update ex. fizz.buzz.foo
 */
function setNestedKey(obj, keyPath, value) {
  // Ex. foo.bar.zoop will extract foo and bar.zoop
  var match = keyPath.match(/([a-z]+)\.(.*)/i);
  if (match === null) {
    obj[keyPath] = value;
  } else {
    setNestedKey(obj[match[1]], match[2], value);
  }
}

/**
 * Retrieves the patched integrations with the provided integration.
 *
 * The integration must be present in the final user integrations, and they are compared
 * by integration name. If the user has defined one, there's nothing to patch; if not,
 * the provided integration is added.
 *
 * @param integration The integration to patch, if necessary.
 * @param userIntegrations Integrations defined by the user.
 * @param options options to update for a particular integration
 * @returns Final integrations, patched if necessary.
 */
function addIntegration(
  integration,
  userIntegrations,
  options = {},
) {
  if (Array.isArray(userIntegrations)) {
    return addIntegrationToArray(integration, userIntegrations, options);
  } else {
    return addIntegrationToFunction(integration, userIntegrations, options);
  }
}

function addIntegrationToArray(
  integration,
  userIntegrations,
  options,
) {
  let includesName = false;
    for (let x = 0; x < userIntegrations.length; x++) {
    if (userIntegrations[x].name === integration.name) {
      includesName = true;
    }

    var op = options[userIntegrations[x].name];
    if (op) {
      setNestedKey(userIntegrations[x], op.keyPath, op.value);
    }
  }

  if (includesName) {
    return userIntegrations;
  }
  return [...userIntegrations, integration];
}

function addIntegrationToFunction(
  integration,
  userIntegrationsFunc,
  options,
) {
  var wrapper = defaultIntegrations => {
    var userFinalIntegrations = userIntegrationsFunc(defaultIntegrations);
    return addIntegrationToArray(integration, userFinalIntegrations, options);
  };
  return wrapper;
}


//# sourceMappingURL=userIntegrations.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/index.client.js













// Treeshakable guard to remove all code related to tracing

/** Inits the Sentry NextJS SDK on the browser with the React SDK. */
function index_client_init(options) {
  buildMetadata(options, ['nextjs', 'react']);
  options.environment = options.environment || "production";

  let integrations = options.integrations;

  // Guard below evaluates to true unless __SENTRY_TRACING__ is text-replaced with "false"
  if (typeof __SENTRY_TRACING__ === 'undefined' || __SENTRY_TRACING__) {
    // Only add BrowserTracing if a tracesSampleRate or tracesSampler is set
    if (options.tracesSampleRate !== undefined || options.tracesSampler !== undefined) {
      integrations = createClientIntegrations(options.integrations);
    }
  }

  init({
    ...options,
    integrations,
  });

  (0,esm_exports/* configureScope */.e)(scope => {
    scope.setTag('runtime', 'browser');
    var filterTransactions = event =>
      event.type === 'transaction' && event.transaction === '/404' ? null : event;
    filterTransactions.id = 'NextClient404Filter';
    scope.addEventProcessor(filterTransactions);
  });
}

function createClientIntegrations(integrations) {
  var defaultBrowserTracingIntegration = new BrowserTracing({
    tracingOrigins: [...defaultRequestInstrumentationOptions.tracingOrigins, /^(api\/)/],
    routingInstrumentation: nextRouterInstrumentation,
  });

  if (integrations) {
    return addIntegration(defaultBrowserTracingIntegration, integrations, {
      BrowserTracing: { keyPath: 'options.routingInstrumentation', value: nextRouterInstrumentation },
    });
  } else {
    return [defaultBrowserTracingIntegration];
  }
}


//# sourceMappingURL=index.client.js.map

// EXTERNAL MODULE: ./constants/index.ts + 15 modules
var constants = __webpack_require__(47041);
;// CONCATENATED MODULE: ./sentry.client.config.js
/* provided dependency */ var process = __webpack_require__(34155);
// This file configures the intialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/


var SENTRY_DSN = process.env.SENTRY_DSN || "https://9f2ff2ff57684a7cbb56f9386a1b50a5@o195198.ingest.sentry.io/6748341";
var environment = process.env.VERCEL_GITHUB_COMMIT_REF === constants/* STAGING */.eEW ? process.env.NEXT_PUBLIC_STAGING_ENV_NAME : "sec_ddeez595T3HpNz1mzjx9ZNnT";
index_client_init({
    enabled: "production" !== "development",
    dsn: SENTRY_DSN || "https://785f98e05ef24ca1b6428473599e262d@o195198.ingest.sentry.io/5493557",
    environment: environment,
    sampleRate: 0.5
});


/***/ }),

/***/ 86649:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* reexport */ use_ui_store; },
  "Lo": function() { return /* reexport */ getClearCartStockNotices; },
  "AQ": function() { return /* reexport */ getClickOverlay; },
  "Vw": function() { return /* reexport */ getCloseDesktopNav; },
  "od": function() { return /* reexport */ getCloseDrawer; },
  "Af": function() { return /* reexport */ getCloseMarketingBanner; },
  "MK": function() { return /* reexport */ getCloseModal; },
  "tt": function() { return /* reexport */ getCloseNav; },
  "sD": function() { return /* reexport */ getClosePreviewBanner; },
  "NO": function() { return /* reexport */ getDisplayBuildNav; },
  "wt": function() { return /* reexport */ getDisplayCart; },
  "dg": function() { return /* reexport */ getDisplayDesktopNav; },
  "Md": function() { return /* reexport */ getDisplayMarketingBanner; },
  "Fl": function() { return /* reexport */ getDisplayModal; },
  "gK": function() { return /* reexport */ getDisplayNav; },
  "R2": function() { return /* reexport */ getDisplayOverlay; },
  "mm": function() { return /* reexport */ getDisplayPreviewBanner; },
  "KO": function() { return /* reexport */ getIsShopifyCartCookieLoading; },
  "Kb": function() { return /* reexport */ getModalContent; },
  "WM": function() { return /* reexport */ getModalView; },
  "r2": function() { return /* reexport */ getOpenCart; },
  "yt": function() { return /* reexport */ getOpenMarketingBanner; },
  "Qe": function() { return /* reexport */ getOpenModal; },
  "in": function() { return /* reexport */ getSetIsShopifyCartCookieLoading; },
  "NX": function() { return /* reexport */ getSetModalOnCloseAction; },
  "Bz": function() { return /* reexport */ getSetModalView; },
  "zR": function() { return /* reexport */ getShowPreviewBanner; },
  "i6": function() { return /* reexport */ getToggleBuildNav; },
  "tN": function() { return /* reexport */ getToggleNav; }
});

// UNUSED EXPORTS: getAdditionalProductContent, getCartStockNotices, getCloseAccountNav, getCloseBuildNav, getCloseCart, getCloseSearch, getDisplayAccountNav, getDisplayDrawer, getDisplaySearch, getIsTermsAccepted, getModalAction, getModalOnCloseAction, getModalOnOpenAction, getModalWarning, getOpenAccountNav, getOpenDesktopNav, getOpenDrawer, getOpenSearch, getPlayingId, getProductDetails, getRemoveCartStockNotice, getSelectedVariant, getSetAdditionalProductContent, getSetCartStockNotice, getSetIsTermsAccepted, getSetLogout, getSetModalAction, getSetModalContent, getSetModalOnOpenAction, getSetModalProductDetails, getSetProductDetails, getSetSelectedVariant, getShowWarning, getToggleAccountNav, getToggleCart, getToggleDesktopNav, getToggleSearch, setPlayingId

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/zustand/esm/index.js
var esm = __webpack_require__(14671);
// EXTERNAL MODULE: ./constants/ui.ts
var ui = __webpack_require__(66138);
;// CONCATENATED MODULE: ./stores/use-ui-store/use-ui-store.ts
/* eslint-disable @typescript-eslint/no-explicit-any */ 





var initialModalState = {
    displayModal: false,
    modalView: ui/* MODAL_VIEW_LOGIN */.ef,
    modalAction: function() {
        return null;
    },
    modalOnOpenAction: function() {
        return null;
    },
    modalOnCloseAction: function() {
        return null;
    },
    modalContent: {
        markdownCopy: null,
        markdownContent: null,
        internalLink: null
    },
    selectedVariant: {
        color: [],
        images: [],
        price: null,
        stock: null,
        id: null,
        shopify_variants_id: null,
        isValid: false,
        isLowStock: false,
        isOutOfStock: false,
        collectionPageMainImage: null,
        isOnSale: false,
        discounted_price: null,
        isComingSoon: false,
        isNewItem: false
    },
    productDetails: {
        product: null,
        selectedVariant: null
    },
    product: null,
    additionalProducts: null
};
var initialNavState = {
    displayNav: false,
    displayBuildNav: false,
    displayCart: false,
    displayOverlay: false,
    displayDrawer: false,
    displaySearch: false,
    displayDesktopNav: false,
    displayAccountNav: false
};
var initialBannerState = {
    displayPreviewBanner: false,
    displayMarketingBanner: true
};
var initialAuthState = {
    auth: {
        isTermsAccepted: false
    }
};
var initialSoundButtonState = {
    soundButtonId: "0"
};
var initialCartStockNoticeState = {
    cartStockNotices: []
};
var initialShopifyCartCookieLoadingState = {
    isShopifyCartCookieLoading: false
};
var uiStore = function(set) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialModalState, initialNavState, initialBannerState, initialAuthState, initialSoundButtonState, initialCartStockNoticeState, initialShopifyCartCookieLoadingState), {
        // Modal Actions
        openModal: function() {
            return set(function(state) {
                state.modalOnOpenAction();
                return {
                    displayModal: true,
                    displayNav: false,
                    displayBuildNav: false,
                    displayCart: false,
                    displaySearch: false,
                    displayDesktopNav: false
                };
            });
        },
        closeModal: function() {
            return set(function(state) {
                state.modalOnCloseAction();
                return {
                    displayModal: false
                };
            });
        },
        setModalView: function(view) {
            return set(function() {
                return {
                    modalView: view
                };
            });
        },
        setModalAction: function(fn) {
            return set(function() {
                return {
                    modalAction: fn
                };
            });
        },
        setModalOnOpenAction: function(fn) {
            return set(function() {
                return {
                    modalOnOpenAction: fn
                };
            });
        },
        setModalOnCloseAction: function(fn) {
            return set(function() {
                return {
                    modalOnCloseAction: fn
                };
            });
        },
        setSelectedVariant: function(selectedVariant) {
            return set(function() {
                return {
                    selectedVariant: selectedVariant
                };
            });
        },
        setProductDetails: function(productDetails) {
            return set(function() {
                return {
                    productDetails: productDetails
                };
            });
        },
        setModalContent: function(modalContent) {
            return set(function() {
                return {
                    modalContent: modalContent
                };
            });
        },
        setAdditionalProductContent: function(additionalProducts, showWarning, modalWarning) {
            return set(function() {
                return {
                    additionalProducts: additionalProducts,
                    showWarning: showWarning,
                    modalWarning: modalWarning
                };
            });
        },
        // Nav Actions
        toggleNav: function() {
            return set(function(state) {
                return {
                    displayNav: !state.displayNav,
                    displayBuildNav: !state.displayBuildNav,
                    displayOverlay: !state.displayNav,
                    displayCart: false,
                    displayDrawer: false,
                    displaySearch: false,
                    displayDesktopNav: false
                };
            });
        },
        closeNav: function() {
            return set(function() {
                return {
                    displayNav: false,
                    displayBuildNav: false,
                    displayOverlay: false,
                    displayCart: false,
                    displaySearch: false,
                    displayDesktopNav: false
                };
            });
        },
        // Nav Build Actions
        toggleBuildNav: function() {
            return set(function(state) {
                return {
                    displayNav: !state.displayNav,
                    displayBuildNav: !state.displayBuildNav,
                    displayOverlay: false,
                    displayCart: false,
                    displayDrawer: false,
                    displaySearch: false,
                    displayDesktopNav: false
                };
            });
        },
        closeBuildNav: function() {
            return set(function() {
                return {
                    displayNav: false,
                    displayBuildNav: false,
                    displayOverlay: false,
                    displayCart: false,
                    displaySearch: false,
                    displayDesktopNav: false
                };
            });
        },
        // Cart Actions
        openCart: function() {
            return set(function() {
                return {
                    displayCart: true,
                    displayOverlay: true,
                    displayNav: false,
                    displayBuildNav: false,
                    displayDrawer: false,
                    displaySearch: false,
                    displayDesktopNav: false
                };
            });
        },
        closeCart: function() {
            return set(function() {
                return {
                    displayCart: false,
                    displayOverlay: false
                };
            });
        },
        toggleCart: function() {
            return set(function(state) {
                return {
                    displayCart: !state.displayCart,
                    displayOverlay: !state.displayCart,
                    displayNav: false,
                    displayBuildNav: false,
                    displayDrawer: false,
                    displaySearch: false,
                    displayDesktopNav: false
                };
            });
        },
        // Drawer actions
        openDrawer: function() {
            return set(function() {
                return {
                    displayDrawer: true,
                    displayOverlay: true,
                    displayNav: false,
                    displayBuildNav: false,
                    displayCart: false,
                    displaySearch: false,
                    displayDesktopNav: false
                };
            });
        },
        closeDrawer: function() {
            return set(function() {
                return {
                    displayDrawer: false,
                    displayOverlay: false
                };
            });
        },
        // Overlay actions
        clickOverlay: function() {
            return set(function() {
                return {
                    displayNav: false,
                    displayBuildNav: false,
                    displayCart: false,
                    displayOverlay: false,
                    displayDrawer: false,
                    displaySearch: false,
                    displayDesktopNav: false
                };
            });
        },
        // Search actions
        openSearch: function() {
            return set(function() {
                return {
                    displayCart: false,
                    displayOverlay: true,
                    displayNav: false,
                    displayBuildNav: false,
                    displayDrawer: false,
                    displaySearch: true,
                    displayDesktopNav: false
                };
            });
        },
        closeSearch: function() {
            return set(function() {
                return {
                    displaySearch: false,
                    displayOverlay: false
                };
            });
        },
        toggleSearch: function() {
            return set(function(state) {
                return {
                    displayCart: false,
                    displayOverlay: !state.displaySearch,
                    displayNav: false,
                    displayBuildNav: false,
                    displayDrawer: false,
                    displaySearch: !state.displaySearch,
                    displayDesktopNav: false
                };
            });
        },
        // Desktop Nav Actions
        toggleDesktopNav: function() {
            return set(function(state) {
                return {
                    displayNav: false,
                    displayBuildNav: false,
                    displayOverlay: !state.displayDesktopNav,
                    displayCart: false,
                    displayDrawer: false,
                    displaySearch: false,
                    displayDesktopNav: !state.displayDesktopNav
                };
            });
        },
        openDesktopNav: function() {
            return set(function() {
                return {
                    displayDesktopNav: true,
                    displayOverlay: true,
                    displaySearch: false
                };
            });
        },
        closeDesktopNav: function() {
            return set(function() {
                return {
                    displayDesktopNav: false,
                    displayOverlay: false
                };
            });
        },
        // Desktop Account Nav Actions
        toggleAccountNav: function() {
            return set(function(state) {
                return {
                    displayNav: false,
                    displayBuildNav: false,
                    displayCart: false,
                    displayDrawer: false,
                    displaySearch: false,
                    displayDesktopNav: false,
                    displayAccountNav: !state.displayAccountNav,
                    displayOverlay: !state.displayAccountNav
                };
            });
        },
        openAccountNav: function() {
            return set(function() {
                return {
                    displayAccountNav: true
                };
            });
        },
        closeAccountNav: function() {
            return set(function() {
                return {
                    displayAccountNav: false,
                    displayOverlay: false
                };
            });
        },
        // Banner actions
        showPreviewBanner: function() {
            return set(function() {
                return {
                    displayPreviewBanner: true
                };
            });
        },
        closePreviewBanner: function() {
            return set(function() {
                return {
                    displayPreviewBanner: false
                };
            });
        },
        openMarketingBanner: function() {
            return set(function() {
                return {
                    displayMarketingBanner: true
                };
            });
        },
        closeMarketingBanner: function() {
            return set(function() {
                return {
                    displayMarketingBanner: false
                };
            });
        },
        // Auth actions
        setIsTermsAccepted: function(isTermsAccepted) {
            return set(function(state) {
                return {
                    auth: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state.auth), {
                        isTermsAccepted: isTermsAccepted
                    })
                };
            });
        },
        setLogout: function() {
            return set(function() {
                return {
                    auth: {}
                };
            });
        },
        // Button sound actions
        setSoundButtonId: function(id) {
            return set({
                soundButtonId: id
            });
        },
        // Cart stock notice actions
        setCartStockNotice: function(cartStockNotice) {
            return set(function(state) {
                var allCartStockNotices = (0,_to_consumable_array/* default */.Z)(state.cartStockNotices).concat([
                    cartStockNotice
                ]);
                var cartStockNotices = (0,_to_consumable_array/* default */.Z)(new Map(allCartStockNotices.map(function(v) {
                    return [
                        v.buildLink,
                        v
                    ];
                })).values());
                return {
                    cartStockNotices: cartStockNotices
                };
            });
        },
        removeCartStockNotice: function(cartStockNotice) {
            return set(function(state) {
                var cartStockNotices = state.cartStockNotices.filter(function(n) {
                    return n.buildLink !== cartStockNotice.buildLink;
                });
                return {
                    cartStockNotices: cartStockNotices
                };
            });
        },
        clearCartStockNotices: function() {
            return set(function() {
                return {
                    cartStockNotices: []
                };
            });
        },
        setIsShopifyCartCookieLoading: function(isShopifyCartCookieLoading) {
            return set(function() {
                return {
                    isShopifyCartCookieLoading: isShopifyCartCookieLoading
                };
            });
        }
    });
};
var useUiStore =  false ? 0 : (0,esm/* default */.Z)(uiStore);
/* harmony default export */ var use_ui_store = (useUiStore);

;// CONCATENATED MODULE: ./stores/use-ui-store/selectors.ts
/* eslint-disable @typescript-eslint/no-explicit-any */ // Modals
var getDisplayModal = function(state) {
    return state.displayModal;
};
var getModalView = function(state) {
    return state.modalView;
};
var getModalAction = function(state) {
    return state.modalAction;
};
var getModalOnOpenAction = function(state) {
    return state.modalOnOpenAction;
};
var getModalOnCloseAction = function(state) {
    return state.modalOnCloseAction;
};
var getOpenModal = function(state) {
    return state.openModal;
};
var getCloseModal = function(state) {
    return state.closeModal;
};
var getSetModalView = function(state) {
    return state.setModalView;
};
var getSetModalAction = function(state) {
    return state.setModalAction;
};
var getSetModalProductDetails = function(state) {
    return state.setModalAction;
};
var getSetModalOnOpenAction = function(state) {
    return state.setModalOnOpenAction;
};
var getSetModalOnCloseAction = function(state) {
    return state.setModalOnCloseAction;
};
// Nav
var getDisplayNav = function(state) {
    return state.displayNav;
};
var getDisplayBuildNav = function(state) {
    return state.displayBuildNav;
};
var getDisplayCart = function(state) {
    return state.displayCart;
};
var getDisplayOverlay = function(state) {
    return state.displayOverlay;
};
var getDisplayDrawer = function(state) {
    return state.displayDrawer;
};
var getDisplaySearch = function(state) {
    return state.displaySearch;
};
var getDisplayAccountNav = function(state) {
    return state.displayAccountNav;
};
var getToggleNav = function(state) {
    return state.toggleNav;
};
var getCloseNav = function(state) {
    return state.closeNav;
};
var getToggleBuildNav = function(state) {
    return state.toggleBuildNav;
};
var getCloseBuildNav = function(state) {
    return state.closeBuildNav;
};
var getOpenCart = function(state) {
    return state.openCart;
};
var getCloseCart = function(state) {
    return state.closeCart;
};
var getToggleCart = function(state) {
    return state.toggleCart;
};
var getClickOverlay = function(state) {
    return state.clickOverlay;
};
var getOpenDrawer = function(state) {
    return state.openDrawer;
};
var getCloseDrawer = function(state) {
    return state.closeDrawer;
};
var getOpenSearch = function(state) {
    return state.openSearch;
};
var getCloseSearch = function(state) {
    return state.closeSearch;
};
var getToggleSearch = function(state) {
    return state.toggleSearch;
};
var getDisplayDesktopNav = function(state) {
    return state.displayDesktopNav;
};
var getToggleDesktopNav = function(state) {
    return state.toggleDesktopNav;
};
var getOpenDesktopNav = function(state) {
    return state.openDesktopNav;
};
var getCloseDesktopNav = function(state) {
    return state.closeDesktopNav;
};
var getToggleAccountNav = function(state) {
    return state.toggleAccountNav;
};
var getOpenAccountNav = function(state) {
    return state.openAccountNav;
};
var getCloseAccountNav = function(state) {
    return state.closeAccountNav;
};
var getDisplayPreviewBanner = function(state) {
    return state.displayPreviewBanner;
};
var getShowPreviewBanner = function(state) {
    return state.showPreviewBanner;
};
var getClosePreviewBanner = function(state) {
    return state.closePreviewBanner;
};
var getDisplayMarketingBanner = function(state) {
    return state.displayMarketingBanner;
};
var getOpenMarketingBanner = function(state) {
    return state.openMarketingBanner;
};
var getCloseMarketingBanner = function(state) {
    return state.closeMarketingBanner;
};
var getSetSelectedVariant = function(state) {
    return state.setSelectedVariant;
};
var getSelectedVariant = function(state) {
    return state.selectedVariant;
};
var getSetProductDetails = function(state) {
    return state.setProductDetails;
};
var getProductDetails = function(state) {
    return state.productDetails;
};
var getSetModalContent = function(state) {
    return state.setModalContent;
};
var getModalContent = function(state) {
    return state.modalContent;
};
var getSetAdditionalProductContent = function(state) {
    return state.setAdditionalProductContent;
};
var getShowWarning = function(state) {
    return state.showWarning;
};
var getModalWarning = function(state) {
    return state.modalWarning;
};
var getAdditionalProductContent = function(state) {
    return state.additionalProducts;
};
var getSetLogout = function(state) {
    return state.setLogout;
};
var getSetIsTermsAccepted = function(state) {
    return state.setIsTermsAccepted;
};
var getIsTermsAccepted = function(state) {
    return state.auth.isTermsAccepted;
};
var getPlayingId = function(state) {
    return state.soundButtonId;
};
var setPlayingId = function(state) {
    return state.setSoundButtonId;
};
var getCartStockNotices = function(state) {
    return state.cartStockNotices;
};
var getSetCartStockNotice = function(state) {
    return state.setCartStockNotice;
};
var getRemoveCartStockNotice = function(state) {
    return state.removeCartStockNotice;
};
var getClearCartStockNotices = function(state) {
    return state.clearCartStockNotices;
};
var getSetIsShopifyCartCookieLoading = function(state) {
    return state.setIsShopifyCartCookieLoading;
};
var getIsShopifyCartCookieLoading = function(state) {
    return state.isShopifyCartCookieLoading;
};

;// CONCATENATED MODULE: ./stores/use-ui-store/index.ts




/***/ }),

/***/ 96870:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ gtm; }
});

;// CONCATENATED MODULE: ./utils/gtm/warn.ts
/* eslint-disable no-console */ var warn = function(s) {
    console.warn("[gtm]", s);
};
/* harmony default export */ var gtm_warn = (warn);

;// CONCATENATED MODULE: ./utils/gtm/snippets.ts

// Basic script/noscript implementation:
// https://developers.google.com/tag-manager/quickstart
var Snippets = {
    tags: function tags(param) {
        var id = param.id, events = param.events, serverUrl = param.serverUrl, dataLayer = param.dataLayer, dataLayerName = param.dataLayerName, preview = param.preview, auth = param.auth;
        if (!id) {
            gtm_warn("GTM Id is required");
        }
        var gtmAuth = "&gtm_auth=".concat(auth);
        var gtmPreview = "&gtm_preview=".concat(preview);
        var iframe = '\n      <iframe src="'.concat(serverUrl, "/ns.html?id=").concat(id).concat(gtmAuth).concat(gtmPreview, '&gtm_cookies_win=x"\n        height="0" width="0" style="display:none;visibility:hidden" id="tag-manager"></iframe>');
        var script = "\n      (function(w,d,s,l,i){w[l]=w[l]||[];\n        w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js', ".concat(JSON.stringify(events).slice(1, -1), "});\n        var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';\n        j.async=true;j.src='").concat(serverUrl, "/gtm.js?id='+i+dl+'").concat(gtmAuth).concat(gtmPreview, "&gtm_cookies_win=x';\n        f.parentNode.insertBefore(j,f);\n      })(window,document,'script','").concat(dataLayerName, "','").concat(id, "');");
        var dataLayerVar = this.dataLayer(dataLayer, dataLayerName);
        return {
            iframe: iframe,
            script: script,
            dataLayerVar: dataLayerVar
        };
    },
    dataLayer: function dataLayer(dataLayer1, dataLayerName) {
        return "\n      window.".concat(dataLayerName, " = window.").concat(dataLayerName, " || [];\n      window.").concat(dataLayerName, ".push(").concat(JSON.stringify(dataLayer1), ")");
    }
};
/* harmony default export */ var gtm_snippets = (Snippets);

;// CONCATENATED MODULE: ./utils/gtm/gtm.ts

// inspired by https://github.com/alinemorelli/react-gtm
var GTM = {
    dataScript: function dataScript(dataLayer) {
        var scriptEl = document.createElement("script");
        scriptEl.innerHTML = dataLayer;
        return scriptEl;
    },
    gtm: function gtm(args) {
        var snippets = gtm_snippets.tags(args);
        var noScript = function() {
            var noscriptEl = document.createElement("noscript");
            noscriptEl.innerHTML = snippets.iframe;
            return noscriptEl;
        };
        var script = function() {
            var scriptEl = document.createElement("script");
            scriptEl.innerHTML = snippets.script;
            return scriptEl;
        };
        var dataScript = this.dataScript(snippets.dataLayerVar);
        return {
            noScript: noScript,
            script: script,
            dataScript: dataScript
        };
    },
    initialize: function initialize(param) {
        var gtmId = param.gtmId, _events = param.events, events = _events === void 0 ? {} : _events, _serverUrl = param.serverUrl, serverUrl = _serverUrl === void 0 ? "https://www.googletagmanager.com" : _serverUrl, dataLayer = param.dataLayer, _dataLayerName = param.dataLayerName, dataLayerName = _dataLayerName === void 0 ? "dataLayer" : _dataLayerName, _auth = param.auth, auth = _auth === void 0 ? "" : _auth, _preview = param.preview, preview = _preview === void 0 ? "" : _preview;
        var gtm = this.gtm({
            id: gtmId,
            events: events,
            serverUrl: serverUrl,
            dataLayer: dataLayer || undefined,
            dataLayerName: dataLayerName,
            auth: auth,
            preview: preview
        });
        if (dataLayer) {
            document.head.appendChild(gtm.dataScript);
        }
        document.head.insertBefore(gtm.script(), document.head.childNodes[0]);
        document.body.insertBefore(gtm.noScript(), document.body.childNodes[0]);
    },
    // eslint-disable-next-line consistent-return
    dataLayer: function dataLayer(param) {
        var dataLayer1 = param.dataLayer, _dataLayerName = param.dataLayerName, dataLayerName = _dataLayerName === void 0 ? "dataLayer" : _dataLayerName;
        if (window[dataLayerName]) {
            return window[dataLayerName].push(dataLayer1);
        }
        var snippets = gtm_snippets.dataLayer(dataLayer1, dataLayerName);
        var dataScript = this.dataScript(snippets);
        document.head.insertBefore(dataScript, document.head.childNodes[0]);
    }
};
/* harmony default export */ var gtm = (GTM);

;// CONCATENATED MODULE: ./utils/gtm/index.ts



/***/ }),

/***/ 83307:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "aC": function() { return /* reexport */ hooks_useAuth; },
  "LP": function() { return /* reexport */ hooks_useFormatMessage; },
  "ce": function() { return /* reexport */ hooks_useLocationBasedCookies; },
  "GS": function() { return /* reexport */ hooks_useMedia; },
  "KS": function() { return /* reexport */ hooks_useTimeout; },
  "$G": function() { return /* reexport */ hooks_useTranslation; }
});

// UNUSED EXPORTS: useCountdown, useInterval, usePrevious, useRootClass

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-auth/react/index.js
var next_auth_react = __webpack_require__(33299);
// EXTERNAL MODULE: ./framework/utils/errors.ts + 12 modules
var errors = __webpack_require__(2063);
;// CONCATENATED MODULE: ./utils/hooks/useAuth.ts



var useAuth = function() {
    var ref = (0,next_auth_react.useSession)(), session = ref.data, status = ref.status;
    var loading = status === "loading";
    var ref1 = (0,react.useState)({
        isLoggedIn: (session === null || session === void 0 ? void 0 : session.accessToken) && (session === null || session === void 0 ? void 0 : session.error) !== errors/* ERROR_CODES.RefreshAccessTokenError */.O1.RefreshAccessTokenError && !loading,
        token: session === null || session === void 0 ? void 0 : session.accessToken,
        user: session === null || session === void 0 ? void 0 : session.user
    }), newSession = ref1[0], setNewSession = ref1[1];
    (0,react.useEffect)(function() {
        setNewSession({
            isLoggedIn: (session === null || session === void 0 ? void 0 : session.accessToken) && (session === null || session === void 0 ? void 0 : session.error) !== errors/* ERROR_CODES.RefreshAccessTokenError */.O1.RefreshAccessTokenError && !loading,
            token: session === null || session === void 0 ? void 0 : session.accessToken,
            user: session === null || session === void 0 ? void 0 : session.user
        });
    }, [
        session,
        loading
    ]);
    return newSession;
};
/* harmony default export */ var hooks_useAuth = (useAuth);

;// CONCATENATED MODULE: ./utils/hooks/useCountdown.ts

var useCountdown = function(endDate) {
    var countdownToDate = new Date(endDate).getTime();
    var ref = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
        initialized: false,
        isExpired: false
    }), state = ref[0], setState = ref[1];
    var setNewTime = function() {
        if (countdownToDate) {
            var startDate = new Date().getTime();
            var distanceToDate = Math.abs(countdownToDate.valueOf() - startDate.valueOf());
            var isExpired = startDate > countdownToDate;
            var days = Math.floor(distanceToDate / (1000 * 60 * 60 * 24));
            var hours = Math.floor(distanceToDate % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
            var minutes = Math.floor(distanceToDate % (1000 * 60 * 60) / (1000 * 60));
            var seconds = Math.floor(distanceToDate % (1000 * 60) / 1000);
            var numbersToAddZeroTo = [
                1,
                2,
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                0
            ];
            if (numbersToAddZeroTo.includes(days)) {
                days = "0".concat(days);
            }
            if (numbersToAddZeroTo.includes(hours)) {
                hours = "0".concat(hours);
            }
            if (numbersToAddZeroTo.includes(minutes)) {
                minutes = "0".concat(minutes);
            }
            if (numbersToAddZeroTo.includes(seconds)) {
                seconds = "0".concat(seconds);
            }
            setState({
                days: days || "".concat(days),
                hours: hours,
                minutes: minutes,
                seconds: seconds,
                initialized: true,
                isExpired: isExpired
            });
        }
    };
    // eslint-disable-next-line consistent-return
    useEffect(function() {
        if (endDate) {
            var tick = setInterval(function() {
                return setNewTime();
            }, 1000);
            return function() {
                return clearInterval(tick);
            };
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        endDate
    ]);
    return state;
};
/* harmony default export */ var hooks_useCountdown = ((/* unused pure expression or super */ null && (useCountdown)));

// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/injectIntl.js
var injectIntl = __webpack_require__(74806);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/utils.js
var utils = __webpack_require__(680);
;// CONCATENATED MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js



function useIntl() {
    var intl = react.useContext(injectIntl/* Context */._y);
    (0,utils/* invariantIntlContext */.lq)(intl);
    return intl;
}

;// CONCATENATED MODULE: ./utils/hooks/useFormatMessage.ts

var useFormatMessage = function() {
    var formatMessage = useIntl().formatMessage;
    return function(id) {
        return formatMessage({
            id: id
        });
    };
};
/* harmony default export */ var hooks_useFormatMessage = (useFormatMessage);

;// CONCATENATED MODULE: ./utils/hooks/useInterval.ts
/* eslint-disable consistent-return */ 
/* https://overreacted.io/making-setinterval-declarative-with-react-hooks/ */ var useInterval = function(callback, delay) {
    var savedCallback = useRef(null);
    // Remember the latest callback.
    useEffect(function() {
        savedCallback.current = callback;
    }, [
        callback
    ]);
    // Set up the interval.
    useEffect(function() {
        var tick = function tick() {
            savedCallback.current();
        };
        if (delay !== null) {
            var id = setInterval(tick, delay);
            return function() {
                return clearInterval(id);
            };
        }
    }, [
        delay
    ]);
};
/* harmony default export */ var hooks_useInterval = ((/* unused pure expression or super */ null && (useInterval)));

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./framework/api/utils/maxify/index.ts + 5 modules
var maxify = __webpack_require__(55469);
// EXTERNAL MODULE: ./node_modules/nookies/dist/index.js
var dist = __webpack_require__(62286);
// EXTERNAL MODULE: ./constants/index.ts + 15 modules
var constants = __webpack_require__(47041);
;// CONCATENATED MODULE: ./framework/api/utils/locale-cookie/get-locale-cookie.ts


var getToken = function() {
    var cookies = (0,dist.parseCookies)();
    return cookies[constants/* SYSTEM_LOCALE_COOKIE_NAME */.A9k];
};
/* harmony default export */ var get_locale_cookie = (getToken);

;// CONCATENATED MODULE: ./framework/api/utils/locale-cookie/set-locale-cookie.ts


var setLocaleCookie = function() {
    var locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : constants/* DEFAULT_LOCALE */.ZWN;
    (0,dist.setCookie)(null, constants/* SYSTEM_LOCALE_COOKIE_NAME */.A9k, locale, {
        maxAge: constants/* SYSTEM_COOKIE_MAX_AGE */.qHr,
        expires: new Date(Date.now() + constants/* SYSTEM_COOKIE_MAX_AGE */.qHr * 1000),
        secure: "production" === "production",
        path: "/",
        sameSite: "lax"
    });
};
/* harmony default export */ var set_locale_cookie = (setLocaleCookie);

;// CONCATENATED MODULE: ./framework/api/utils/locale-cookie/index.ts




// EXTERNAL MODULE: ./framework/api/utils/shopify-cart-cookie/index.ts + 3 modules
var shopify_cart_cookie = __webpack_require__(56560);
// EXTERNAL MODULE: ./stores/use-ui-store/index.ts + 2 modules
var use_ui_store = __webpack_require__(86649);
// EXTERNAL MODULE: ./utils/parse-locale.ts
var parse_locale = __webpack_require__(24343);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./framework/cart/use-cart.tsx + 1 modules
var use_cart = __webpack_require__(37305);
;// CONCATENATED MODULE: ./framework/cart/use-cart-id.tsx
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable @typescript-eslint/no-non-null-assertion */ 





function extendHook() {
    var useCartId = function() {
        var mutate = (0,use_cart/* default */.ZP)().mutate;
        return (0,react.useCallback)(function() {
            var _getCartId = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var country, cartId, data, _args = arguments;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            country = _args.length > 0 && _args[0] !== void 0 ? _args[0] : constants/* DEFAULT_COUNTRY_CODE */.ss5;
                            if (false) {}
                            _ctx.next = 4;
                            return fetch("/api/maxify/cart", {
                                method: "PATCH"
                            }).then(function(r) {
                                return r.json();
                            });
                        case 4:
                            cartId = _ctx.sent;
                            data = cartId.data;
                            (0,shopify_cart_cookie/* setShopifyCartCookie */.HR)(country, data);
                            _ctx.next = 9;
                            return mutate();
                        case 9:
                            return _ctx.abrupt("return", data);
                        case 10:
                            return _ctx.abrupt("return", null);
                        case 11:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            function getCartId() {
                return _getCartId.apply(this, arguments);
            }
            return getCartId;
        }(), [
            mutate
        ]);
    };
    useCartId.extend = extendHook;
    return useCartId;
}
/* harmony default export */ var use_cart_id = (extendHook());

// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var swr_dist = __webpack_require__(8100);
;// CONCATENATED MODULE: ./utils/hooks/useLocationBasedCookies.ts











var useLocationBasedCookies = function(param) {
    var locale = param.locale, defaultLocale = param.defaultLocale;
    var setIsShopifyCartCookieLoading = (0,use_ui_store/* default */.ZP)(use_ui_store/* getSetIsShopifyCartCookieLoading */["in"]);
    var isShopifyCartCookieLoading = (0,use_ui_store/* default */.ZP)(use_ui_store/* getIsShopifyCartCookieLoading */.KO);
    var clearCartStockNotices = (0,use_ui_store/* default */.ZP)(use_ui_store/* getClearCartStockNotices */.Lo);
    var getCartId = use_cart_id();
    var mutate = (0,swr_dist/* useSWRConfig */.kY)().mutate;
    var getInitialValues = function() {
        var initialValues = {
            cartCookie: "",
            localeCookie: "",
            shopifyCartCookie: ""
        };
        var parsedLocale = (0,parse_locale/* default */.Z)(defaultLocale, locale);
        var country = parsedLocale[1] || constants/* DEFAULT_COUNTRY_CODE */.ss5;
        var cartIdFromCookie = (0,maxify/* getToken */.LP)();
        var localeFromCookie = get_locale_cookie();
        var shopifyCartFromCookie = (0,shopify_cart_cookie/* getShopifyCartCookie */.Tb)(country);
        if (cartIdFromCookie) {
            initialValues.cartCookie = cartIdFromCookie;
        } else {
            (0,maxify/* setToken */.o4)(country);
            initialValues.cartCookie = (0,maxify/* getToken */.LP)();
        }
        if (localeFromCookie) {
            initialValues.localeCookie = localeFromCookie;
        } else {
            set_locale_cookie(locale);
            initialValues.localeCookie = get_locale_cookie();
        }
        if (shopifyCartFromCookie) {
            initialValues.shopifyCartCookie = (0,shopify_cart_cookie/* getShopifyCartCookie */.Tb)(country);
        } else {
            // eslint-disable-next-line no-lonely-if
            if (!isShopifyCartCookieLoading) {
                setIsShopifyCartCookieLoading(true);
                getCartId(country).then(function() {
                    initialValues.shopifyCartCookie = (0,shopify_cart_cookie/* getShopifyCartCookie */.Tb)(country);
                    setIsShopifyCartCookieLoading(false);
                });
            }
        }
        return initialValues;
    };
    var ref = (0,react.useState)(getInitialValues()), locationBasedCookies = ref[0], setLocationBasedCookies = ref[1];
    var cookieRef = (0,react.useRef)({});
    (0,react.useEffect)(function() {
        cookieRef.current = locationBasedCookies;
    }, [
        locationBasedCookies
    ]);
    var updateLocationBasedCookies = (0,react.useCallback)(function(newLocale) {
        var cartCookie = cookieRef.current.cartCookie;
        var prevTokenLocale = cartCookie === null || cartCookie === void 0 ? void 0 : cartCookie.slice(-2);
        var prevTokenWithoutLocale = cartCookie === null || cartCookie === void 0 ? void 0 : cartCookie.slice(0, -3);
        var parsedLocale = (0,parse_locale/* default */.Z)(defaultLocale, newLocale);
        var newCountry = parsedLocale[1] || constants/* DEFAULT_COUNTRY_CODE */.ss5;
        set_locale_cookie(newLocale);
        if (prevTokenLocale !== newCountry) {
            (0,maxify/* setToken */.o4)(newCountry, prevTokenWithoutLocale);
            if (!(0,shopify_cart_cookie/* getShopifyCartCookie */.Tb)(newCountry) && !isShopifyCartCookieLoading) {
                setIsShopifyCartCookieLoading(true);
                getCartId(newCountry).then(function() {
                    setIsShopifyCartCookieLoading(false);
                });
            }
            clearCartStockNotices();
        }
        if ((0,shopify_cart_cookie/* getShopifyCartCookie */.Tb)(newCountry) && !isShopifyCartCookieLoading) {
            // TODO: fix cachey key format
            mutate([
                "/api/maxify/cart",
                undefined,
                "GET",
                (0,shopify_cart_cookie/* getShopifyCartCookie */.Tb)(newCountry), 
            ]);
        }
        setLocationBasedCookies(function(prevState) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                cartCookie: (0,maxify/* getToken */.LP)(),
                localeCookie: get_locale_cookie(),
                shopifyCartCookie: (0,shopify_cart_cookie/* getShopifyCartCookie */.Tb)(newCountry)
            });
        });
    }, [
        cookieRef,
        defaultLocale,
        clearCartStockNotices
    ]);
    return {
        locationBasedCookies: locationBasedCookies,
        updateLocationBasedCookies: updateLocationBasedCookies
    };
};
/* harmony default export */ var hooks_useLocationBasedCookies = (useLocationBasedCookies);

;// CONCATENATED MODULE: ./utils/hooks/mediaQueries.ts
/* eslint-disable max-len */ /* harmony default export */ var mediaQueries = ({
    sm: "(min-width: 0px) and (max-width: 767px)",
    md: "(min-width: 768px) and (max-width: 1023px)",
    lg: "(min-width: 1024px) and (max-width: 1279px)",
    xl: "(min-width: 1280px) and (max-width: 1536px)",
    "2xl": "(min-width: 1537px) and (max-width: 2000px)",
    "3xl": "(min-width: 2000px)",
    tallScreen: "(min-height: 950px)",
    shortScreen: "(max-height: 650px)",
    xlTallScreen: "(min-height: 2000px)",
    ipadPro: "(min-width: 1024px) and (max-height: 1366px) and (orientation: portrait)and (-webkit-min-device-pixel-ratio: 1.5)",
    smLandscape: "(min-width: 0px) and (max-width: 812px) and (-webkit-min-device-pixel-ratio: 3) and (orientation: landscape)",
    mdLandscape: "(min-width: 813px) and (max-width : 1023px) and (orientation: landscape) and (-webkit-min-device-pixel-ratio: 1)"
});

;// CONCATENATED MODULE: ./utils/hooks/useMedia.ts
/* eslint-disable */ /* tslint:disable */ 

var useMedia = function(query) {
    if (false) {}
    if (!window.matchMedia) return;
    var queryToMatch = mediaQueries[query];
    var ref = (0,react.useState)(false), match = ref[0], setMatch = ref[1];
    (0,react.useEffect)(function() {
        var mounted = true;
        var mediaQueryWindow = window.matchMedia(queryToMatch);
        var onChange = function() {
            if (!mounted) {
                return;
            }
            setMatch(Boolean(mediaQueryWindow.matches));
        };
        mediaQueryWindow.hasOwnProperty("addEventListener") ? mediaQueryWindow.addEventListener("change", onChange) : mediaQueryWindow.addListener(onChange);
        setMatch(mediaQueryWindow.matches);
        return function() {
            mounted = false;
            mediaQueryWindow.hasOwnProperty("removeEventListener") ? mediaQueryWindow.removeEventListener("change", onChange) : mediaQueryWindow.removeListener(onChange);
        };
    }, [
        queryToMatch
    ]);
    return match;
};
/* harmony default export */ var hooks_useMedia = (useMedia);

;// CONCATENATED MODULE: ./utils/hooks/usePrevious.ts

// eslint-disable-next-line @typescript-eslint/no-explicit-any
var usePrevious = function(value) {
    var ref = useRef();
    useEffect(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};
/* harmony default export */ var hooks_usePrevious = ((/* unused pure expression or super */ null && (usePrevious))); // use:
 // get the previous value of props or state
 // const [count, setCount] = useState(0)
 // const prevCount = usePrevious(count)

;// CONCATENATED MODULE: ./utils/hooks/useRootClass.ts

var useRootClass = function(className) {
    useEffect(function() {
        var root = document.documentElement;
        var addRootClass = function(c) {
            return root.classList.add(c);
        };
        var removeRootClass = function(c) {
            return root.classList.remove(c);
        };
        if (Array.isArray(className)) className.forEach(addRootClass);
        else addRootClass(className);
        return function() {
            if (Array.isArray(className)) className.forEach(removeRootClass);
            else removeRootClass(className);
        };
    }, [
        className
    ]);
};
/* harmony default export */ var hooks_useRootClass = ((/* unused pure expression or super */ null && (useRootClass)));

;// CONCATENATED MODULE: ./utils/hooks/useTimeout.ts
/* eslint-disable consistent-return */ 
/* https://overreacted.io/making-setinterval-declarative-with-react-hooks/ */ var useTimeout = function(callback, delay) {
    var savedCallback = (0,react.useRef)(null);
    // Remember the latest callback.
    (0,react.useEffect)(function() {
        savedCallback.current = callback;
    }, [
        callback
    ]);
    // Set up the interval.
    (0,react.useEffect)(function() {
        var tick = function tick() {
            savedCallback.current();
        };
        if (delay !== null) {
            var id = setTimeout(tick, delay);
            return function() {
                return clearTimeout(id);
            };
        }
    }, [
        delay
    ]);
};
/* harmony default export */ var hooks_useTimeout = (useTimeout);

;// CONCATENATED MODULE: ./utils/hooks/useTranslation.ts

var useTranslation = function(id) {
    var formatMessage = useIntl().formatMessage;
    return formatMessage({
        id: id
    });
};
/* harmony default export */ var hooks_useTranslation = (useTranslation);

;// CONCATENATED MODULE: ./utils/hooks/index.ts













/***/ }),

/***/ 24343:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var parseLocale = function(defaultLocale, locale) {
    return locale ? locale.split("-") : defaultLocale.split("-");
};
/* harmony default export */ __webpack_exports__["Z"] = (parseLocale);


/***/ }),

/***/ 77334:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 61751:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ }),

/***/ 11163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(90387)


/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(20699)


/***/ }),

/***/ 62286:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.destroyCookie = exports.setCookie = exports.parseCookies = void 0;
var cookie = __webpack_require__(76489);
var setCookieParser = __webpack_require__(69328);
var utils_1 = __webpack_require__(51022);
/**
 * Parses cookies.
 *
 * @param ctx NextJS page or API context, express context, null or undefined.
 * @param options Options that we pass down to `cookie` library.
 */
function parseCookies(ctx, options) {
    var _a, _b;
    if ((_b = (_a = ctx === null || ctx === void 0 ? void 0 : ctx.req) === null || _a === void 0 ? void 0 : _a.headers) === null || _b === void 0 ? void 0 : _b.cookie) {
        return cookie.parse(ctx.req.headers.cookie, options);
    }
    if (utils_1.isBrowser()) {
        return cookie.parse(document.cookie, options);
    }
    return {};
}
exports.parseCookies = parseCookies;
/**
 * Sets a cookie.
 *
 * @param ctx NextJS page or API context, express context, null or undefined.
 * @param name The name of your cookie.
 * @param value The value of your cookie.
 * @param options Options that we pass down to `cookie` library.
 */
function setCookie(ctx, name, value, options) {
    var _a, _b;
    if (options === void 0) { options = {}; }
    // SSR
    if (((_a = ctx === null || ctx === void 0 ? void 0 : ctx.res) === null || _a === void 0 ? void 0 : _a.getHeader) && ctx.res.setHeader) {
        // Check if response has finished and warn about it.
        if ((_b = ctx === null || ctx === void 0 ? void 0 : ctx.res) === null || _b === void 0 ? void 0 : _b.finished) {
            console.warn("Not setting \"" + name + "\" cookie. Response has finished.");
            console.warn("You should set cookie before res.send()");
            return {};
        }
        /**
         * Load existing cookies from the header and parse them.
         */
        var cookies = ctx.res.getHeader('Set-Cookie') || [];
        if (typeof cookies === 'string')
            cookies = [cookies];
        if (typeof cookies === 'number')
            cookies = [];
        /**
         * Parse cookies but ignore values - we've already encoded
         * them in the previous call.
         */
        var parsedCookies = setCookieParser.parse(cookies, {
            decodeValues: false,
        });
        /**
         * We create the new cookie and make sure that none of
         * the existing cookies match it.
         */
        var newCookie_1 = utils_1.createCookie(name, value, options);
        var cookiesToSet_1 = [];
        parsedCookies.forEach(function (parsedCookie) {
            if (!utils_1.areCookiesEqual(parsedCookie, newCookie_1)) {
                /**
                 * We serialize the cookie back to the original format
                 * if it isn't the same as the new one.
                 */
                var serializedCookie = cookie.serialize(parsedCookie.name, parsedCookie.value, __assign({ 
                    // we prevent reencoding by default, but you might override it
                    encode: function (val) { return val; } }, parsedCookie));
                cookiesToSet_1.push(serializedCookie);
            }
        });
        cookiesToSet_1.push(cookie.serialize(name, value, options));
        // Update the header.
        ctx.res.setHeader('Set-Cookie', cookiesToSet_1);
    }
    // Browser
    if (utils_1.isBrowser()) {
        if (options && options.httpOnly) {
            throw new Error('Can not set a httpOnly cookie in the browser.');
        }
        document.cookie = cookie.serialize(name, value, options);
    }
    return {};
}
exports.setCookie = setCookie;
/**
 * Destroys a cookie with a particular name.
 *
 * @param ctx NextJS page or API context, express context, null or undefined.
 * @param name Cookie name.
 * @param options Options that we pass down to `cookie` library.
 */
function destroyCookie(ctx, name, options) {
    /**
     * We forward the request destroy to setCookie function
     * as it is the same function with modified maxAge value.
     */
    return setCookie(ctx, name, '', __assign(__assign({}, (options || {})), { maxAge: -1 }));
}
exports.destroyCookie = destroyCookie;
/* Utility Exports */
exports["default"] = {
    set: setCookie,
    get: parseCookies,
    destroy: destroyCookie,
};
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 51022:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.areCookiesEqual = exports.hasSameProperties = exports.createCookie = exports.isBrowser = void 0;
/**
 * Tells whether we are in a browser or server.
 */
function isBrowser() {
    return typeof window !== 'undefined';
}
exports.isBrowser = isBrowser;
/**
 * Create an instance of the Cookie interface
 */
function createCookie(name, value, options) {
    var sameSite = options.sameSite;
    if (sameSite === true) {
        sameSite = 'strict';
    }
    if (sameSite === undefined || sameSite === false) {
        sameSite = 'lax';
    }
    var cookieToSet = __assign(__assign({}, options), { sameSite: sameSite });
    delete cookieToSet.encode;
    return __assign({ name: name, value: value }, cookieToSet);
}
exports.createCookie = createCookie;
/**
 * Tells whether given objects have the same properties.
 */
function hasSameProperties(a, b) {
    var aProps = Object.getOwnPropertyNames(a);
    var bProps = Object.getOwnPropertyNames(b);
    if (aProps.length !== bProps.length) {
        return false;
    }
    for (var i = 0; i < aProps.length; i++) {
        var propName = aProps[i];
        if (a[propName] !== b[propName]) {
            return false;
        }
    }
    return true;
}
exports.hasSameProperties = hasSameProperties;
/**
 * Compare the cookie and return true if the cookies have equivalent
 * options and the cookies would be overwritten in the browser storage.
 *
 * @param a first Cookie for comparison
 * @param b second Cookie for comparison
 */
function areCookiesEqual(a, b) {
    var sameSiteSame = a.sameSite === b.sameSite;
    if (typeof a.sameSite === 'string' && typeof b.sameSite === 'string') {
        sameSiteSame = a.sameSite.toLowerCase() === b.sameSite.toLowerCase();
    }
    return (hasSameProperties(__assign(__assign({}, a), { sameSite: undefined }), __assign(__assign({}, b), { sameSite: undefined })) && sameSiteSame);
}
exports.areCookiesEqual = areCookiesEqual;
/* Functions */
//# sourceMappingURL=utils.js.map

/***/ }),

/***/ 74865:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/* NProgress, (c) 2013, 2014 Rico Sta. Cruz - http://ricostacruz.com/nprogress
 * @license MIT */

;(function(root, factory) {

  if (true) {
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}

})(this, function() {
  var NProgress = {};

  NProgress.version = '0.2.0';

  var Settings = NProgress.settings = {
    minimum: 0.08,
    easing: 'ease',
    positionUsing: '',
    speed: 200,
    trickle: true,
    trickleRate: 0.02,
    trickleSpeed: 800,
    showSpinner: true,
    barSelector: '[role="bar"]',
    spinnerSelector: '[role="spinner"]',
    parent: 'body',
    template: '<div class="bar" role="bar"><div class="peg"></div></div><div class="spinner" role="spinner"><div class="spinner-icon"></div></div>'
  };

  /**
   * Updates configuration.
   *
   *     NProgress.configure({
   *       minimum: 0.1
   *     });
   */
  NProgress.configure = function(options) {
    var key, value;
    for (key in options) {
      value = options[key];
      if (value !== undefined && options.hasOwnProperty(key)) Settings[key] = value;
    }

    return this;
  };

  /**
   * Last number.
   */

  NProgress.status = null;

  /**
   * Sets the progress bar status, where `n` is a number from `0.0` to `1.0`.
   *
   *     NProgress.set(0.4);
   *     NProgress.set(1.0);
   */

  NProgress.set = function(n) {
    var started = NProgress.isStarted();

    n = clamp(n, Settings.minimum, 1);
    NProgress.status = (n === 1 ? null : n);

    var progress = NProgress.render(!started),
        bar      = progress.querySelector(Settings.barSelector),
        speed    = Settings.speed,
        ease     = Settings.easing;

    progress.offsetWidth; /* Repaint */

    queue(function(next) {
      // Set positionUsing if it hasn't already been set
      if (Settings.positionUsing === '') Settings.positionUsing = NProgress.getPositioningCSS();

      // Add transition
      css(bar, barPositionCSS(n, speed, ease));

      if (n === 1) {
        // Fade out
        css(progress, { 
          transition: 'none', 
          opacity: 1 
        });
        progress.offsetWidth; /* Repaint */

        setTimeout(function() {
          css(progress, { 
            transition: 'all ' + speed + 'ms linear', 
            opacity: 0 
          });
          setTimeout(function() {
            NProgress.remove();
            next();
          }, speed);
        }, speed);
      } else {
        setTimeout(next, speed);
      }
    });

    return this;
  };

  NProgress.isStarted = function() {
    return typeof NProgress.status === 'number';
  };

  /**
   * Shows the progress bar.
   * This is the same as setting the status to 0%, except that it doesn't go backwards.
   *
   *     NProgress.start();
   *
   */
  NProgress.start = function() {
    if (!NProgress.status) NProgress.set(0);

    var work = function() {
      setTimeout(function() {
        if (!NProgress.status) return;
        NProgress.trickle();
        work();
      }, Settings.trickleSpeed);
    };

    if (Settings.trickle) work();

    return this;
  };

  /**
   * Hides the progress bar.
   * This is the *sort of* the same as setting the status to 100%, with the
   * difference being `done()` makes some placebo effect of some realistic motion.
   *
   *     NProgress.done();
   *
   * If `true` is passed, it will show the progress bar even if its hidden.
   *
   *     NProgress.done(true);
   */

  NProgress.done = function(force) {
    if (!force && !NProgress.status) return this;

    return NProgress.inc(0.3 + 0.5 * Math.random()).set(1);
  };

  /**
   * Increments by a random amount.
   */

  NProgress.inc = function(amount) {
    var n = NProgress.status;

    if (!n) {
      return NProgress.start();
    } else {
      if (typeof amount !== 'number') {
        amount = (1 - n) * clamp(Math.random() * n, 0.1, 0.95);
      }

      n = clamp(n + amount, 0, 0.994);
      return NProgress.set(n);
    }
  };

  NProgress.trickle = function() {
    return NProgress.inc(Math.random() * Settings.trickleRate);
  };

  /**
   * Waits for all supplied jQuery promises and
   * increases the progress as the promises resolve.
   *
   * @param $promise jQUery Promise
   */
  (function() {
    var initial = 0, current = 0;

    NProgress.promise = function($promise) {
      if (!$promise || $promise.state() === "resolved") {
        return this;
      }

      if (current === 0) {
        NProgress.start();
      }

      initial++;
      current++;

      $promise.always(function() {
        current--;
        if (current === 0) {
            initial = 0;
            NProgress.done();
        } else {
            NProgress.set((initial - current) / initial);
        }
      });

      return this;
    };

  })();

  /**
   * (Internal) renders the progress bar markup based on the `template`
   * setting.
   */

  NProgress.render = function(fromStart) {
    if (NProgress.isRendered()) return document.getElementById('nprogress');

    addClass(document.documentElement, 'nprogress-busy');
    
    var progress = document.createElement('div');
    progress.id = 'nprogress';
    progress.innerHTML = Settings.template;

    var bar      = progress.querySelector(Settings.barSelector),
        perc     = fromStart ? '-100' : toBarPerc(NProgress.status || 0),
        parent   = document.querySelector(Settings.parent),
        spinner;
    
    css(bar, {
      transition: 'all 0 linear',
      transform: 'translate3d(' + perc + '%,0,0)'
    });

    if (!Settings.showSpinner) {
      spinner = progress.querySelector(Settings.spinnerSelector);
      spinner && removeElement(spinner);
    }

    if (parent != document.body) {
      addClass(parent, 'nprogress-custom-parent');
    }

    parent.appendChild(progress);
    return progress;
  };

  /**
   * Removes the element. Opposite of render().
   */

  NProgress.remove = function() {
    removeClass(document.documentElement, 'nprogress-busy');
    removeClass(document.querySelector(Settings.parent), 'nprogress-custom-parent');
    var progress = document.getElementById('nprogress');
    progress && removeElement(progress);
  };

  /**
   * Checks if the progress bar is rendered.
   */

  NProgress.isRendered = function() {
    return !!document.getElementById('nprogress');
  };

  /**
   * Determine which positioning CSS rule to use.
   */

  NProgress.getPositioningCSS = function() {
    // Sniff on document.body.style
    var bodyStyle = document.body.style;

    // Sniff prefixes
    var vendorPrefix = ('WebkitTransform' in bodyStyle) ? 'Webkit' :
                       ('MozTransform' in bodyStyle) ? 'Moz' :
                       ('msTransform' in bodyStyle) ? 'ms' :
                       ('OTransform' in bodyStyle) ? 'O' : '';

    if (vendorPrefix + 'Perspective' in bodyStyle) {
      // Modern browsers with 3D support, e.g. Webkit, IE10
      return 'translate3d';
    } else if (vendorPrefix + 'Transform' in bodyStyle) {
      // Browsers without 3D support, e.g. IE9
      return 'translate';
    } else {
      // Browsers without translate() support, e.g. IE7-8
      return 'margin';
    }
  };

  /**
   * Helpers
   */

  function clamp(n, min, max) {
    if (n < min) return min;
    if (n > max) return max;
    return n;
  }

  /**
   * (Internal) converts a percentage (`0..1`) to a bar translateX
   * percentage (`-100%..0%`).
   */

  function toBarPerc(n) {
    return (-1 + n) * 100;
  }


  /**
   * (Internal) returns the correct CSS for changing the bar's
   * position given an n percentage, and speed and ease from Settings
   */

  function barPositionCSS(n, speed, ease) {
    var barCSS;

    if (Settings.positionUsing === 'translate3d') {
      barCSS = { transform: 'translate3d('+toBarPerc(n)+'%,0,0)' };
    } else if (Settings.positionUsing === 'translate') {
      barCSS = { transform: 'translate('+toBarPerc(n)+'%,0)' };
    } else {
      barCSS = { 'margin-left': toBarPerc(n)+'%' };
    }

    barCSS.transition = 'all '+speed+'ms '+ease;

    return barCSS;
  }

  /**
   * (Internal) Queues a function to be executed.
   */

  var queue = (function() {
    var pending = [];
    
    function next() {
      var fn = pending.shift();
      if (fn) {
        fn(next);
      }
    }

    return function(fn) {
      pending.push(fn);
      if (pending.length == 1) next();
    };
  })();

  /**
   * (Internal) Applies css properties to an element, similar to the jQuery 
   * css method.
   *
   * While this helper does assist with vendor prefixed property names, it 
   * does not perform any manipulation of values prior to setting styles.
   */

  var css = (function() {
    var cssPrefixes = [ 'Webkit', 'O', 'Moz', 'ms' ],
        cssProps    = {};

    function camelCase(string) {
      return string.replace(/^-ms-/, 'ms-').replace(/-([\da-z])/gi, function(match, letter) {
        return letter.toUpperCase();
      });
    }

    function getVendorProp(name) {
      var style = document.body.style;
      if (name in style) return name;

      var i = cssPrefixes.length,
          capName = name.charAt(0).toUpperCase() + name.slice(1),
          vendorName;
      while (i--) {
        vendorName = cssPrefixes[i] + capName;
        if (vendorName in style) return vendorName;
      }

      return name;
    }

    function getStyleProp(name) {
      name = camelCase(name);
      return cssProps[name] || (cssProps[name] = getVendorProp(name));
    }

    function applyCss(element, prop, value) {
      prop = getStyleProp(prop);
      element.style[prop] = value;
    }

    return function(element, properties) {
      var args = arguments,
          prop, 
          value;

      if (args.length == 2) {
        for (prop in properties) {
          value = properties[prop];
          if (value !== undefined && properties.hasOwnProperty(prop)) applyCss(element, prop, value);
        }
      } else {
        applyCss(element, args[1], args[2]);
      }
    }
  })();

  /**
   * (Internal) Determines if an element or space separated list of class names contains a class name.
   */

  function hasClass(element, name) {
    var list = typeof element == 'string' ? element : classList(element);
    return list.indexOf(' ' + name + ' ') >= 0;
  }

  /**
   * (Internal) Adds a class to an element.
   */

  function addClass(element, name) {
    var oldList = classList(element),
        newList = oldList + name;

    if (hasClass(oldList, name)) return; 

    // Trim the opening space.
    element.className = newList.substring(1);
  }

  /**
   * (Internal) Removes a class from an element.
   */

  function removeClass(element, name) {
    var oldList = classList(element),
        newList;

    if (!hasClass(element, name)) return;

    // Replace the class name.
    newList = oldList.replace(' ' + name + ' ', ' ');

    // Trim the opening and closing spaces.
    element.className = newList.substring(1, newList.length - 1);
  }

  /**
   * (Internal) Gets a space separated list of the class names on the element. 
   * The list is wrapped with a single space on each end to facilitate finding 
   * matches within the list.
   */

  function classList(element) {
    return (' ' + (element.className || '') + ' ').replace(/\s+/gi, ' ');
  }

  /**
   * (Internal) Removes an element from the DOM.
   */

  function removeElement(element) {
    element && element.parentNode && element.parentNode.removeChild(element);
  }

  return NProgress;
});



/***/ }),

/***/ 34155:
/***/ (function(module) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 74806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_y": function() { return /* binding */ Context; },
/* harmony export */   "zt": function() { return /* binding */ Provider; }
/* harmony export */ });
/* unused harmony export default */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8679);
/* harmony import */ var hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics__WEBPACK_IMPORTED_MODULE_1__);




function getDisplayName(Component) {
    return Component.displayName || Component.name || 'Component';
}
// TODO: We should provide initial value here
var IntlContext = react__WEBPACK_IMPORTED_MODULE_0__.createContext(null);
var IntlConsumer = IntlContext.Consumer, IntlProvider = IntlContext.Provider;
var Provider = IntlProvider;
var Context = IntlContext;
function injectIntl(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? 'intl' : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function (props) { return (React.createElement(IntlConsumer, null, function (intl) {
        var _a;
        if (enforceContext) {
            invariantIntlContext(intl);
        }
        var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
        return (React.createElement(WrappedComponent, __assign({}, props, intlProp, { ref: forwardRef ? props.forwardedRef : null })));
    })); };
    WithIntl.displayName = "injectIntl(".concat(getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) {
        return hoistNonReactStatics(React.forwardRef(function (props, ref) { return (React.createElement(WithIntl, __assign({}, props, { forwardedRef: ref }))); }), WrappedComponent);
    }
    return hoistNonReactStatics(WithIntl, WrappedComponent);
}


/***/ }),

/***/ 680:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z0": function() { return /* binding */ DEFAULT_INTL_CONFIG; },
/* harmony export */   "dt": function() { return /* binding */ assignUniqueKeysToParts; },
/* harmony export */   "lq": function() { return /* binding */ invariantIntlContext; },
/* harmony export */   "wU": function() { return /* binding */ shallowEqual; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _formatjs_ecma402_abstract__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25687);
/* harmony import */ var _formatjs_intl__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82644);




function invariantIntlContext(intl) {
    (0,_formatjs_ecma402_abstract__WEBPACK_IMPORTED_MODULE_1__/* .invariant */ .kG)(intl, '[React Intl] Could not find required `intl` object. ' +
        '<IntlProvider> needs to exist in the component ancestry.');
}
var DEFAULT_INTL_CONFIG = (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)((0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__assign */ .pi)({}, _formatjs_intl__WEBPACK_IMPORTED_MODULE_3__/* .DEFAULT_INTL_CONFIG */ .Z0), { textComponent: react__WEBPACK_IMPORTED_MODULE_0__.Fragment });
/**
 * Takes a `formatXMLElementFn`, and composes it in function, which passes
 * argument `parts` through, assigning unique key to each part, to prevent
 * "Each child in a list should have a unique "key"" React error.
 * @param formatXMLElementFn
 */
function assignUniqueKeysToParts(formatXMLElementFn) {
    return function (parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn(react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(parts));
    };
}
function shallowEqual(objA, objB) {
    if (objA === objB) {
        return true;
    }
    if (!objA || !objB) {
        return false;
    }
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) {
        return false;
    }
    for (var i = 0; i < len; i++) {
        var key = aKeys[i];
        if (objA[key] !== objB[key] ||
            !Object.prototype.hasOwnProperty.call(objB, key)) {
            return false;
        }
    }
    return true;
}


/***/ }),

/***/ 69921:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 59864:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(69921);
} else {}


/***/ }),

/***/ 35666:
/***/ (function(module) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = GeneratorFunctionPrototype;
  define(Gp, "constructor", GeneratorFunctionPrototype);
  define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  });
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  define(Gp, iteratorSymbol, function() {
    return this;
  });

  define(Gp, "toString", function() {
    return "[object Generator]";
  });

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   true ? module.exports : 0
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, in modern engines
  // we can explicitly access globalThis. In older engines we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}


/***/ }),

/***/ 69328:
/***/ (function(module) {

"use strict";


var defaultParseOptions = {
  decodeValues: true,
  map: false,
  silent: false,
};

function isNonEmptyString(str) {
  return typeof str === "string" && !!str.trim();
}

function parseString(setCookieValue, options) {
  var parts = setCookieValue.split(";").filter(isNonEmptyString);
  var nameValue = parts.shift().split("=");
  var name = nameValue.shift();
  var value = nameValue.join("="); // everything after the first =, joined by a "=" if there was more than one part

  options = options
    ? Object.assign({}, defaultParseOptions, options)
    : defaultParseOptions;

  try {
    value = options.decodeValues ? decodeURIComponent(value) : value; // decode cookie value
  } catch (e) {
    console.error(
      "set-cookie-parser encountered an error while decoding a cookie with value '" +
        value +
        "'. Set options.decodeValues to false to disable this feature.",
      e
    );
  }

  var cookie = {
    name: name, // grab everything before the first =
    value: value,
  };

  parts.forEach(function (part) {
    var sides = part.split("=");
    var key = sides.shift().trimLeft().toLowerCase();
    var value = sides.join("=");
    if (key === "expires") {
      cookie.expires = new Date(value);
    } else if (key === "max-age") {
      cookie.maxAge = parseInt(value, 10);
    } else if (key === "secure") {
      cookie.secure = true;
    } else if (key === "httponly") {
      cookie.httpOnly = true;
    } else if (key === "samesite") {
      cookie.sameSite = value;
    } else {
      cookie[key] = value;
    }
  });

  return cookie;
}

function parse(input, options) {
  options = options
    ? Object.assign({}, defaultParseOptions, options)
    : defaultParseOptions;

  if (!input) {
    if (!options.map) {
      return [];
    } else {
      return {};
    }
  }

  if (input.headers && input.headers["set-cookie"]) {
    // fast-path for node.js (which automatically normalizes header names to lower-case
    input = input.headers["set-cookie"];
  } else if (input.headers) {
    // slow-path for other environments - see #25
    var sch =
      input.headers[
        Object.keys(input.headers).find(function (key) {
          return key.toLowerCase() === "set-cookie";
        })
      ];
    // warn if called on a request-like object with a cookie header rather than a set-cookie header - see #34, 36
    if (!sch && input.headers.cookie && !options.silent) {
      console.warn(
        "Warning: set-cookie-parser appears to have been called on a request object. It is designed to parse Set-Cookie headers from responses, not Cookie headers from requests. Set the option {silent: true} to suppress this warning."
      );
    }
    input = sch;
  }
  if (!Array.isArray(input)) {
    input = [input];
  }

  options = options
    ? Object.assign({}, defaultParseOptions, options)
    : defaultParseOptions;

  if (!options.map) {
    return input.filter(isNonEmptyString).map(function (str) {
      return parseString(str, options);
    });
  } else {
    var cookies = {};
    return input.filter(isNonEmptyString).reduce(function (cookies, str) {
      var cookie = parseString(str, options);
      cookies[cookie.name] = cookie;
      return cookies;
    }, cookies);
  }
}

/*
  Set-Cookie header field-values are sometimes comma joined in one string. This splits them without choking on commas
  that are within a single set-cookie field-value, such as in the Expires portion.

  This is uncommon, but explicitly allowed - see https://tools.ietf.org/html/rfc2616#section-4.2
  Node.js does this for every header *except* set-cookie - see https://github.com/nodejs/node/blob/d5e363b77ebaf1caf67cd7528224b651c86815c1/lib/_http_incoming.js#L128
  React Native's fetch does this for *every* header, including set-cookie.

  Based on: https://github.com/google/j2objc/commit/16820fdbc8f76ca0c33472810ce0cb03d20efe25
  Credits to: https://github.com/tomball for original and https://github.com/chrusart for JavaScript implementation
*/
function splitCookiesString(cookiesString) {
  if (Array.isArray(cookiesString)) {
    return cookiesString;
  }
  if (typeof cookiesString !== "string") {
    return [];
  }

  var cookiesStrings = [];
  var pos = 0;
  var start;
  var ch;
  var lastComma;
  var nextStart;
  var cookiesSeparatorFound;

  function skipWhitespace() {
    while (pos < cookiesString.length && /\s/.test(cookiesString.charAt(pos))) {
      pos += 1;
    }
    return pos < cookiesString.length;
  }

  function notSpecialChar() {
    ch = cookiesString.charAt(pos);

    return ch !== "=" && ch !== ";" && ch !== ",";
  }

  while (pos < cookiesString.length) {
    start = pos;
    cookiesSeparatorFound = false;

    while (skipWhitespace()) {
      ch = cookiesString.charAt(pos);
      if (ch === ",") {
        // ',' is a cookie separator if we have later first '=', not ';' or ','
        lastComma = pos;
        pos += 1;

        skipWhitespace();
        nextStart = pos;

        while (pos < cookiesString.length && notSpecialChar()) {
          pos += 1;
        }

        // currently special character
        if (pos < cookiesString.length && cookiesString.charAt(pos) === "=") {
          // we found cookies separator
          cookiesSeparatorFound = true;
          // pos is inside the next cookie, so back up and return it.
          pos = nextStart;
          cookiesStrings.push(cookiesString.substring(start, lastComma));
          start = pos;
        } else {
          // in param ',' or param separator ';',
          // we continue from that comma
          pos = lastComma + 1;
        }
      } else {
        pos += 1;
      }
    }

    if (!cookiesSeparatorFound || pos >= cookiesString.length) {
      cookiesStrings.push(cookiesString.substring(start, cookiesString.length));
    }
  }

  return cookiesStrings;
}

module.exports = parse;
module.exports.parse = parse;
module.exports.parseString = parseString;
module.exports.splitCookiesString = splitCookiesString;


/***/ }),

/***/ 70655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZT": function() { return /* binding */ __extends; },
/* harmony export */   "_T": function() { return /* binding */ __rest; },
/* harmony export */   "ev": function() { return /* binding */ __spreadArray; },
/* harmony export */   "pi": function() { return /* binding */ __assign; }
/* harmony export */ });
/* unused harmony exports __decorate, __param, __metadata, __awaiter, __generator, __createBinding, __exportStar, __values, __read, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault, __classPrivateFieldGet, __classPrivateFieldSet, __classPrivateFieldIn */
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}


/***/ }),

/***/ 25934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm_browser_v4; }
});

;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/rng.js
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
    // find the complete implementation of crypto (msCrypto) on IE11.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/regex.js
/* harmony default export */ var regex = (/^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i);
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/validate.js


function validate(uuid) {
  return typeof uuid === 'string' && regex.test(uuid);
}

/* harmony default export */ var esm_browser_validate = (validate);
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/stringify.js

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

var byteToHex = [];

for (var i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).substr(1));
}

function stringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!esm_browser_validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

/* harmony default export */ var esm_browser_stringify = (stringify);
;// CONCATENATED MODULE: ./node_modules/uuid/dist/esm-browser/v4.js



function v4(options, buf, offset) {
  options = options || {};
  var rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (var i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return esm_browser_stringify(rnds);
}

/* harmony default export */ var esm_browser_v4 = (v4);

/***/ }),

/***/ 14671:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ create; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function create$1(createState) {
  let state;
  const listeners = new Set();
  const setState = (partial, replace) => {
    const nextState = typeof partial === "function" ? partial(state) : partial;
    if (nextState !== state) {
      const previousState = state;
      state = replace ? nextState : Object.assign({}, state, nextState);
      listeners.forEach((listener) => listener(state, previousState));
    }
  };
  const getState = () => state;
  const subscribeWithSelector = (listener, selector = getState, equalityFn = Object.is) => {
    console.warn("[DEPRECATED] Please use `subscribeWithSelector` middleware");
    let currentSlice = selector(state);
    function listenerToAdd() {
      const nextSlice = selector(state);
      if (!equalityFn(currentSlice, nextSlice)) {
        const previousSlice = currentSlice;
        listener(currentSlice = nextSlice, previousSlice);
      }
    }
    listeners.add(listenerToAdd);
    return () => listeners.delete(listenerToAdd);
  };
  const subscribe = (listener, selector, equalityFn) => {
    if (selector || equalityFn) {
      return subscribeWithSelector(listener, selector, equalityFn);
    }
    listeners.add(listener);
    return () => listeners.delete(listener);
  };
  const destroy = () => listeners.clear();
  const api = { setState, getState, subscribe, destroy };
  state = createState(setState, getState, api);
  return api;
}

const isSSR = typeof window === "undefined" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent);
const useIsomorphicLayoutEffect = isSSR ? react__WEBPACK_IMPORTED_MODULE_0__.useEffect : react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect;
function create(createState) {
  const api = typeof createState === "function" ? create$1(createState) : createState;
  const useStore = (selector = api.getState, equalityFn = Object.is) => {
    const [, forceUpdate] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useReducer)((c) => c + 1, 0);
    const state = api.getState();
    const stateRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(state);
    const selectorRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(selector);
    const equalityFnRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(equalityFn);
    const erroredRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    const currentSliceRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    if (currentSliceRef.current === void 0) {
      currentSliceRef.current = selector(state);
    }
    let newStateSlice;
    let hasNewStateSlice = false;
    if (stateRef.current !== state || selectorRef.current !== selector || equalityFnRef.current !== equalityFn || erroredRef.current) {
      newStateSlice = selector(state);
      hasNewStateSlice = !equalityFn(currentSliceRef.current, newStateSlice);
    }
    useIsomorphicLayoutEffect(() => {
      if (hasNewStateSlice) {
        currentSliceRef.current = newStateSlice;
      }
      stateRef.current = state;
      selectorRef.current = selector;
      equalityFnRef.current = equalityFn;
      erroredRef.current = false;
    });
    const stateBeforeSubscriptionRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(state);
    useIsomorphicLayoutEffect(() => {
      const listener = () => {
        try {
          const nextState = api.getState();
          const nextStateSlice = selectorRef.current(nextState);
          if (!equalityFnRef.current(currentSliceRef.current, nextStateSlice)) {
            stateRef.current = nextState;
            currentSliceRef.current = nextStateSlice;
            forceUpdate();
          }
        } catch (error) {
          erroredRef.current = true;
          forceUpdate();
        }
      };
      const unsubscribe = api.subscribe(listener);
      if (api.getState() !== stateBeforeSubscriptionRef.current) {
        listener();
      }
      return unsubscribe;
    }, []);
    const sliceToReturn = hasNewStateSlice ? newStateSlice : currentSliceRef.current;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useDebugValue)(sliceToReturn);
    return sliceToReturn;
  };
  Object.assign(useStore, api);
  useStore[Symbol.iterator] = function() {
    console.warn("[useStore, api] = create() is deprecated and will be removed in v4");
    const items = [useStore, api];
    return {
      next() {
        const done = items.length <= 0;
        return { value: items.shift(), done };
      }
    };
  };
  return useStore;
}




/***/ }),

/***/ 20943:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 47568:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ }),

/***/ 14924:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}


/***/ }),

/***/ 13375:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 26042:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpread; }
/* harmony export */ });
/* harmony import */ var _define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);


function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      (0,_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    });
  }

  return target;
}

/***/ }),

/***/ 69396:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ }),

/***/ 99534:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _objectWithoutProperties; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties_loose.mjs
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs


function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),

/***/ 29815:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(20943);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ }),

/***/ 91566:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20943);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ }),

/***/ 8100:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZP": function() { return /* binding */ useSWR; },
/* harmony export */   "kY": function() { return /* binding */ useSWRConfig; }
/* harmony export */ });
/* unused harmony exports SWRConfig, mutate, unstable_serialize */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var noop = function () { };
// Using noop() as the undefined value as undefined can possibly be replaced
// by something else.  Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
var UNDEFINED = ( /*#__NOINLINE__*/noop());
var OBJECT = Object;
var isUndefined = function (v) { return v === UNDEFINED; };
var isFunction = function (v) { return typeof v == 'function'; };
var mergeObjects = function (a, b) { return OBJECT.assign({}, a, b); };
var STR_UNDEFINED = 'undefined';
// NOTE: Use function to guarantee it's re-evaluated between jsdom and node runtime for tests.
var hasWindow = function () { return typeof window != STR_UNDEFINED; };
var hasDocument = function () { return typeof document != STR_UNDEFINED; };
var hasRequestAnimationFrame = function () {
    return hasWindow() && typeof window['requestAnimationFrame'] != STR_UNDEFINED;
};

// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
var table = new WeakMap();
// counter of the key
var counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsible.
var stableHash = function (arg) {
    var type = typeof arg;
    var constructor = arg && arg.constructor;
    var isDate = constructor == Date;
    var result;
    var index;
    if (OBJECT(arg) === arg && !isDate && constructor != RegExp) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = table.get(arg);
        if (result)
            return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++counter + '~';
        table.set(arg, result);
        if (constructor == Array) {
            // Array.
            result = '@';
            for (index = 0; index < arg.length; index++) {
                result += stableHash(arg[index]) + ',';
            }
            table.set(arg, result);
        }
        if (constructor == OBJECT) {
            // Object, sort keys.
            result = '#';
            var keys = OBJECT.keys(arg).sort();
            while (!isUndefined((index = keys.pop()))) {
                if (!isUndefined(arg[index])) {
                    result += index + ':' + stableHash(arg[index]) + ',';
                }
            }
            table.set(arg, result);
        }
    }
    else {
        result = isDate
            ? arg.toJSON()
            : type == 'symbol'
                ? arg.toString()
                : type == 'string'
                    ? JSON.stringify(arg)
                    : '' + arg;
    }
    return result;
};

/**
 * Due to bug https://bugs.chromium.org/p/chromium/issues/detail?id=678075,
 * it's not reliable to detect if the browser is currently online or offline
 * based on `navigator.onLine`.
 * As a work around, we always assume it's online on first load, and change
 * the status upon `online` or `offline` events.
 */
var online = true;
var isOnline = function () { return online; };
var hasWin = hasWindow();
var hasDoc = hasDocument();
// For node and React Native, `add/removeEventListener` doesn't exist on window.
var onWindowEvent = hasWin && window.addEventListener
    ? window.addEventListener.bind(window)
    : noop;
var onDocumentEvent = hasDoc ? document.addEventListener.bind(document) : noop;
var offWindowEvent = hasWin && window.removeEventListener
    ? window.removeEventListener.bind(window)
    : noop;
var offDocumentEvent = hasDoc
    ? document.removeEventListener.bind(document)
    : noop;
var isVisible = function () {
    var visibilityState = hasDoc && document.visibilityState;
    return isUndefined(visibilityState) || visibilityState !== 'hidden';
};
var initFocus = function (callback) {
    // focus revalidate
    onDocumentEvent('visibilitychange', callback);
    onWindowEvent('focus', callback);
    return function () {
        offDocumentEvent('visibilitychange', callback);
        offWindowEvent('focus', callback);
    };
};
var initReconnect = function (callback) {
    // revalidate on reconnected
    var onOnline = function () {
        online = true;
        callback();
    };
    // nothing to revalidate, just update the status
    var onOffline = function () {
        online = false;
    };
    onWindowEvent('online', onOnline);
    onWindowEvent('offline', onOffline);
    return function () {
        offWindowEvent('online', onOnline);
        offWindowEvent('offline', onOffline);
    };
};
var preset = {
    isOnline: isOnline,
    isVisible: isVisible
};
var defaultConfigOptions = {
    initFocus: initFocus,
    initReconnect: initReconnect
};

var IS_SERVER = !hasWindow() || 'Deno' in window;
// Polyfill requestAnimationFrame
var rAF = function (f) {
    return hasRequestAnimationFrame() ? window['requestAnimationFrame'](f) : setTimeout(f, 1);
};
// React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
var useIsomorphicLayoutEffect = IS_SERVER ? react__WEBPACK_IMPORTED_MODULE_0__.useEffect : react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect;
// This assignment is to extend the Navigator type to use effectiveType.
var navigatorConnection = typeof navigator !== 'undefined' &&
    navigator.connection;
// Adjust the config based on slow connection status (<= 70Kbps).
var slowConnection = !IS_SERVER &&
    navigatorConnection &&
    (['slow-2g', '2g'].includes(navigatorConnection.effectiveType) ||
        navigatorConnection.saveData);

var serialize = function (key) {
    if (isFunction(key)) {
        try {
            key = key();
        }
        catch (err) {
            // dependencies not ready
            key = '';
        }
    }
    var args = [].concat(key);
    // If key is not falsy, or not an empty array, hash it.
    key =
        typeof key == 'string'
            ? key
            : (Array.isArray(key) ? key.length : key)
                ? stableHash(key)
                : '';
    var infoKey = key ? '$swr$' + key : '';
    return [key, args, infoKey];
};

// Global state used to deduplicate requests and store listeners
var SWRGlobalState = new WeakMap();

var FOCUS_EVENT = 0;
var RECONNECT_EVENT = 1;
var MUTATE_EVENT = 2;

var broadcastState = function (cache, key, data, error, isValidating, revalidate, broadcast) {
    if (broadcast === void 0) { broadcast = true; }
    var _a = SWRGlobalState.get(cache), EVENT_REVALIDATORS = _a[0], STATE_UPDATERS = _a[1], FETCH = _a[3];
    var revalidators = EVENT_REVALIDATORS[key];
    var updaters = STATE_UPDATERS[key];
    // Cache was populated, update states of all hooks.
    if (broadcast && updaters) {
        for (var i = 0; i < updaters.length; ++i) {
            updaters[i](data, error, isValidating);
        }
    }
    // If we also need to revalidate, only do it for the first hook.
    if (revalidate) {
        // Invalidate the key by deleting the concurrent request markers so new
        // requests will not be deduped.
        delete FETCH[key];
        if (revalidators && revalidators[0]) {
            return revalidators[0](MUTATE_EVENT).then(function () {
                return cache.get(key);
            });
        }
    }
    return cache.get(key);
};

// Global timestamp.
var __timestamp = 0;
var getTimestamp = function () { return ++__timestamp; };

var internalMutate = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return __awaiter(void 0, void 0, void 0, function () {
        var cache, _key, _data, _opts, options, populateCache, revalidate, rollbackOnError, customOptimisticData, _a, key, keyInfo, _b, MUTATION, data, error, beforeMutationTs, hasCustomOptimisticData, rollbackData, optimisticData, res;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    cache = args[0], _key = args[1], _data = args[2], _opts = args[3];
                    options = typeof _opts === 'boolean' ? { revalidate: _opts } : _opts || {};
                    populateCache = isUndefined(options.populateCache)
                        ? true
                        : options.populateCache;
                    revalidate = options.revalidate !== false;
                    rollbackOnError = options.rollbackOnError !== false;
                    customOptimisticData = options.optimisticData;
                    _a = serialize(_key), key = _a[0], keyInfo = _a[2];
                    if (!key)
                        return [2 /*return*/];
                    _b = SWRGlobalState.get(cache), MUTATION = _b[2];
                    // If there is no new data provided, revalidate the key with current state.
                    if (args.length < 3) {
                        // Revalidate and broadcast state.
                        return [2 /*return*/, broadcastState(cache, key, cache.get(key), UNDEFINED, UNDEFINED, revalidate, true)];
                    }
                    data = _data;
                    beforeMutationTs = getTimestamp();
                    MUTATION[key] = [beforeMutationTs, 0];
                    hasCustomOptimisticData = !isUndefined(customOptimisticData);
                    rollbackData = cache.get(key);
                    // Do optimistic data update.
                    if (hasCustomOptimisticData) {
                        optimisticData = isFunction(customOptimisticData)
                            ? customOptimisticData(rollbackData)
                            : customOptimisticData;
                        cache.set(key, optimisticData);
                        broadcastState(cache, key, optimisticData);
                    }
                    if (isFunction(data)) {
                        // `data` is a function, call it passing current cache value.
                        try {
                            data = data(cache.get(key));
                        }
                        catch (err) {
                            // If it throws an error synchronously, we shouldn't update the cache.
                            error = err;
                        }
                    }
                    if (!(data && isFunction(data.then))) return [3 /*break*/, 2];
                    return [4 /*yield*/, data.catch(function (err) {
                            error = err;
                        })
                        // Check if other mutations have occurred since we've started this mutation.
                        // If there's a race we don't update cache or broadcast the change,
                        // just return the data.
                    ];
                case 1:
                    // This means that the mutation is async, we need to check timestamps to
                    // avoid race conditions.
                    data = _c.sent();
                    // Check if other mutations have occurred since we've started this mutation.
                    // If there's a race we don't update cache or broadcast the change,
                    // just return the data.
                    if (beforeMutationTs !== MUTATION[key][0]) {
                        if (error)
                            throw error;
                        return [2 /*return*/, data];
                    }
                    else if (error && hasCustomOptimisticData && rollbackOnError) {
                        // Rollback. Always populate the cache in this case but without
                        // transforming the data.
                        populateCache = true;
                        data = rollbackData;
                        cache.set(key, rollbackData);
                    }
                    _c.label = 2;
                case 2:
                    // If we should write back the cache after request.
                    if (populateCache) {
                        if (!error) {
                            // Transform the result into data.
                            if (isFunction(populateCache)) {
                                data = populateCache(data, rollbackData);
                            }
                            // Only update cached data if there's no error. Data can be `undefined` here.
                            cache.set(key, data);
                        }
                        // Always update or reset the error.
                        cache.set(keyInfo, mergeObjects(cache.get(keyInfo), { error: error }));
                    }
                    // Reset the timestamp to mark the mutation has ended.
                    MUTATION[key][1] = getTimestamp();
                    return [4 /*yield*/, broadcastState(cache, key, data, error, UNDEFINED, revalidate, !!populateCache)
                        // Throw error or return data
                    ];
                case 3:
                    res = _c.sent();
                    // Throw error or return data
                    if (error)
                        throw error;
                    return [2 /*return*/, populateCache ? res : data];
            }
        });
    });
};

var revalidateAllKeys = function (revalidators, type) {
    for (var key in revalidators) {
        if (revalidators[key][0])
            revalidators[key][0](type);
    }
};
var initCache = function (provider, options) {
    // The global state for a specific provider will be used to deduplicate
    // requests and store listeners. As well as a mutate function that bound to
    // the cache.
    // Provider's global state might be already initialized. Let's try to get the
    // global state associated with the provider first.
    if (!SWRGlobalState.has(provider)) {
        var opts = mergeObjects(defaultConfigOptions, options);
        // If there's no global state bound to the provider, create a new one with the
        // new mutate function.
        var EVENT_REVALIDATORS = {};
        var mutate = internalMutate.bind(UNDEFINED, provider);
        var unmount = noop;
        // Update the state if it's new, or the provider has been extended.
        SWRGlobalState.set(provider, [EVENT_REVALIDATORS, {}, {}, {}, mutate]);
        // This is a new provider, we need to initialize it and setup DOM events
        // listeners for `focus` and `reconnect` actions.
        if (!IS_SERVER) {
            // When listening to the native events for auto revalidations,
            // we intentionally put a delay (setTimeout) here to make sure they are
            // fired after immediate JavaScript executions, which can possibly be
            // React's state updates.
            // This avoids some unnecessary revalidations such as
            // https://github.com/vercel/swr/issues/1680.
            var releaseFocus_1 = opts.initFocus(setTimeout.bind(UNDEFINED, revalidateAllKeys.bind(UNDEFINED, EVENT_REVALIDATORS, FOCUS_EVENT)));
            var releaseReconnect_1 = opts.initReconnect(setTimeout.bind(UNDEFINED, revalidateAllKeys.bind(UNDEFINED, EVENT_REVALIDATORS, RECONNECT_EVENT)));
            unmount = function () {
                releaseFocus_1 && releaseFocus_1();
                releaseReconnect_1 && releaseReconnect_1();
                // When un-mounting, we need to remove the cache provider from the state
                // storage too because it's a side-effect. Otherwise when re-mounting we
                // will not re-register those event listeners.
                SWRGlobalState.delete(provider);
            };
        }
        // We might want to inject an extra layer on top of `provider` in the future,
        // such as key serialization, auto GC, etc.
        // For now, it's just a `Map` interface without any modifications.
        return [provider, mutate, unmount];
    }
    return [provider, SWRGlobalState.get(provider)[4]];
};

// error retry
var onErrorRetry = function (_, __, config, revalidate, opts) {
    var maxRetryCount = config.errorRetryCount;
    var currentRetryCount = opts.retryCount;
    // Exponential backoff
    var timeout = ~~((Math.random() + 0.5) *
        (1 << (currentRetryCount < 8 ? currentRetryCount : 8))) * config.errorRetryInterval;
    if (!isUndefined(maxRetryCount) && currentRetryCount > maxRetryCount) {
        return;
    }
    setTimeout(revalidate, timeout, opts);
};
// Default cache provider
var _a = initCache(new Map()), cache = _a[0], mutate = _a[1];
// Default config
var defaultConfig = mergeObjects({
    // events
    onLoadingSlow: noop,
    onSuccess: noop,
    onError: noop,
    onErrorRetry: onErrorRetry,
    onDiscarded: noop,
    // switches
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    revalidateIfStale: true,
    shouldRetryOnError: true,
    // timeouts
    errorRetryInterval: slowConnection ? 10000 : 5000,
    focusThrottleInterval: 5 * 1000,
    dedupingInterval: 2 * 1000,
    loadingTimeout: slowConnection ? 5000 : 3000,
    // providers
    compare: function (currentData, newData) {
        return stableHash(currentData) == stableHash(newData);
    },
    isPaused: function () { return false; },
    cache: cache,
    mutate: mutate,
    fallback: {}
}, 
// use web preset by default
preset);

var mergeConfigs = function (a, b) {
    // Need to create a new object to avoid mutating the original here.
    var v = mergeObjects(a, b);
    // If two configs are provided, merge their `use` and `fallback` options.
    if (b) {
        var u1 = a.use, f1 = a.fallback;
        var u2 = b.use, f2 = b.fallback;
        if (u1 && u2) {
            v.use = u1.concat(u2);
        }
        if (f1 && f2) {
            v.fallback = mergeObjects(f1, f2);
        }
    }
    return v;
};

var SWRConfigContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({});
var SWRConfig$1 = function (props) {
    var value = props.value;
    // Extend parent context values and middleware.
    var extendedConfig = mergeConfigs((0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(SWRConfigContext), value);
    // Should not use the inherited provider.
    var provider = value && value.provider;
    // Use a lazy initialized state to create the cache on first access.
    var cacheContext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(function () {
        return provider
            ? initCache(provider(extendedConfig.cache || cache), value)
            : UNDEFINED;
    })[0];
    // Override the cache if a new provider is given.
    if (cacheContext) {
        extendedConfig.cache = cacheContext[0];
        extendedConfig.mutate = cacheContext[1];
    }
    // Unsubscribe events.
    useIsomorphicLayoutEffect(function () { return (cacheContext ? cacheContext[2] : UNDEFINED); }, []);
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.createElement)(SWRConfigContext.Provider, mergeObjects(props, {
        value: extendedConfig
    }));
};

/**
 * An implementation of state with dependency-tracking.
 */
var useStateWithDeps = function (state, unmountedRef) {
    var rerender = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({})[1];
    var stateRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(state);
    // If a state property (data, error or isValidating) is accessed by the render
    // function, we mark the property as a dependency so if it is updated again
    // in the future, we trigger a rerender.
    // This is also known as dependency-tracking.
    var stateDependenciesRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)({
        data: false,
        error: false,
        isValidating: false
    });
    /**
     * @param payload To change stateRef, pass the values explicitly to setState:
     * @example
     * ```js
     * setState({
     *   isValidating: false
     *   data: newData // set data to newData
     *   error: undefined // set error to undefined
     * })
     *
     * setState({
     *   isValidating: false
     *   data: undefined // set data to undefined
     *   error: err // set error to err
     * })
     * ```
     */
    var setState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (payload) {
        var shouldRerender = false;
        var currentState = stateRef.current;
        for (var _ in payload) {
            var k = _;
            // If the property has changed, update the state and mark rerender as
            // needed.
            if (currentState[k] !== payload[k]) {
                currentState[k] = payload[k];
                // If the property is accessed by the component, a rerender should be
                // triggered.
                if (stateDependenciesRef.current[k]) {
                    shouldRerender = true;
                }
            }
        }
        if (shouldRerender && !unmountedRef.current) {
            rerender({});
        }
    }, 
    // config.suspense isn't allowed to change during the lifecycle
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // Always update the state reference.
    useIsomorphicLayoutEffect(function () {
        stateRef.current = state;
    });
    return [stateRef, stateDependenciesRef.current, setState];
};

var normalize = function (args) {
    return isFunction(args[1])
        ? [args[0], args[1], args[2] || {}]
        : [args[0], null, (args[1] === null ? args[2] : args[1]) || {}];
};

var useSWRConfig = function () {
    return mergeObjects(defaultConfig, (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(SWRConfigContext));
};

// It's tricky to pass generic types as parameters, so we just directly override
// the types here.
var withArgs = function (hook) {
    return function useSWRArgs() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        // Get the default and inherited configuration.
        var fallbackConfig = useSWRConfig();
        // Normalize arguments.
        var _a = normalize(args), key = _a[0], fn = _a[1], _config = _a[2];
        // Merge configurations.
        var config = mergeConfigs(fallbackConfig, _config);
        // Apply middleware
        var next = hook;
        var use = config.use;
        if (use) {
            for (var i = use.length; i-- > 0;) {
                next = use[i](next);
            }
        }
        return next(key, fn || config.fetcher, config);
    };
};

// Add a callback function to a list of keyed callback functions and return
// the unsubscribe function.
var subscribeCallback = function (key, callbacks, callback) {
    var keyedRevalidators = callbacks[key] || (callbacks[key] = []);
    keyedRevalidators.push(callback);
    return function () {
        var index = keyedRevalidators.indexOf(callback);
        if (index >= 0) {
            // O(1): faster than splice
            keyedRevalidators[index] = keyedRevalidators[keyedRevalidators.length - 1];
            keyedRevalidators.pop();
        }
    };
};

var WITH_DEDUPE = { dedupe: true };
var useSWRHandler = function (_key, fetcher, config) {
    var cache = config.cache, compare = config.compare, fallbackData = config.fallbackData, suspense = config.suspense, revalidateOnMount = config.revalidateOnMount, refreshInterval = config.refreshInterval, refreshWhenHidden = config.refreshWhenHidden, refreshWhenOffline = config.refreshWhenOffline;
    var _a = SWRGlobalState.get(cache), EVENT_REVALIDATORS = _a[0], STATE_UPDATERS = _a[1], MUTATION = _a[2], FETCH = _a[3];
    // `key` is the identifier of the SWR `data` state, `keyInfo` holds extra
    // states such as `error` and `isValidating` inside,
    // all of them are derived from `_key`.
    // `fnArgs` is an array of arguments parsed from the key, which will be passed
    // to the fetcher.
    var _b = serialize(_key), key = _b[0], fnArgs = _b[1], keyInfo = _b[2];
    // If it's the initial render of this hook.
    var initialMountedRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    // If the hook is unmounted already. This will be used to prevent some effects
    // to be called after unmounting.
    var unmountedRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    // Refs to keep the key and config.
    var keyRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(key);
    var fetcherRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(fetcher);
    var configRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(config);
    var getConfig = function () { return configRef.current; };
    var isActive = function () { return getConfig().isVisible() && getConfig().isOnline(); };
    var patchFetchInfo = function (info) {
        return cache.set(keyInfo, mergeObjects(cache.get(keyInfo), info));
    };
    // Get the current state that SWR should return.
    var cached = cache.get(key);
    var fallback = isUndefined(fallbackData)
        ? config.fallback[key]
        : fallbackData;
    var data = isUndefined(cached) ? fallback : cached;
    var info = cache.get(keyInfo) || {};
    var error = info.error;
    var isInitialMount = !initialMountedRef.current;
    // - Suspense mode and there's stale data for the initial render.
    // - Not suspense mode and there is no fallback data and `revalidateIfStale` is enabled.
    // - `revalidateIfStale` is enabled but `data` is not defined.
    var shouldRevalidate = function () {
        // If `revalidateOnMount` is set, we take the value directly.
        if (isInitialMount && !isUndefined(revalidateOnMount))
            return revalidateOnMount;
        // If it's paused, we skip revalidation.
        if (getConfig().isPaused())
            return false;
        // Under suspense mode, it will always fetch on render if there is no
        // stale data so no need to revalidate immediately on mount again.
        // If data exists, only revalidate if `revalidateIfStale` is true.
        if (suspense)
            return isUndefined(data) ? false : config.revalidateIfStale;
        // If there is no stale data, we need to revalidate on mount;
        // If `revalidateIfStale` is set to true, we will always revalidate.
        return isUndefined(data) || config.revalidateIfStale;
    };
    // Resolve the current validating state.
    var resolveValidating = function () {
        if (!key || !fetcher)
            return false;
        if (info.isValidating)
            return true;
        // If it's not mounted yet and it should revalidate on mount, revalidate.
        return isInitialMount && shouldRevalidate();
    };
    var isValidating = resolveValidating();
    var _c = useStateWithDeps({
        data: data,
        error: error,
        isValidating: isValidating
    }, unmountedRef), stateRef = _c[0], stateDependencies = _c[1], setState = _c[2];
    // The revalidation function is a carefully crafted wrapper of the original
    // `fetcher`, to correctly handle the many edge cases.
    var revalidate = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function (revalidateOpts) { return __awaiter(void 0, void 0, void 0, function () {
        var currentFetcher, newData, startAt, loading, opts, shouldStartNewRequest, isCurrentKeyMounted, cleanupState, newState, finishRequestAndUpdateState, mutationInfo, err_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    currentFetcher = fetcherRef.current;
                    if (!key ||
                        !currentFetcher ||
                        unmountedRef.current ||
                        getConfig().isPaused()) {
                        return [2 /*return*/, false];
                    }
                    loading = true;
                    opts = revalidateOpts || {};
                    shouldStartNewRequest = !FETCH[key] || !opts.dedupe;
                    isCurrentKeyMounted = function () {
                        return !unmountedRef.current &&
                            key === keyRef.current &&
                            initialMountedRef.current;
                    };
                    cleanupState = function () {
                        // Check if it's still the same request before deleting.
                        var requestInfo = FETCH[key];
                        if (requestInfo && requestInfo[1] === startAt) {
                            delete FETCH[key];
                        }
                    };
                    newState = { isValidating: false };
                    finishRequestAndUpdateState = function () {
                        patchFetchInfo({ isValidating: false });
                        // We can only set state if it's safe (still mounted with the same key).
                        if (isCurrentKeyMounted()) {
                            setState(newState);
                        }
                    };
                    // Start fetching. Change the `isValidating` state, update the cache.
                    patchFetchInfo({
                        isValidating: true
                    });
                    setState({ isValidating: true });
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    if (shouldStartNewRequest) {
                        // Tell all other hooks to change the `isValidating` state.
                        broadcastState(cache, key, stateRef.current.data, stateRef.current.error, true);
                        // If no cache being rendered currently (it shows a blank page),
                        // we trigger the loading slow event.
                        if (config.loadingTimeout && !cache.get(key)) {
                            setTimeout(function () {
                                if (loading && isCurrentKeyMounted()) {
                                    getConfig().onLoadingSlow(key, config);
                                }
                            }, config.loadingTimeout);
                        }
                        // Start the request and save the timestamp.
                        FETCH[key] = [currentFetcher.apply(void 0, fnArgs), getTimestamp()];
                    }
                    _a = FETCH[key], newData = _a[0], startAt = _a[1];
                    return [4 /*yield*/, newData];
                case 2:
                    newData = _b.sent();
                    if (shouldStartNewRequest) {
                        // If the request isn't interrupted, clean it up after the
                        // deduplication interval.
                        setTimeout(cleanupState, config.dedupingInterval);
                    }
                    // If there're other ongoing request(s), started after the current one,
                    // we need to ignore the current one to avoid possible race conditions:
                    //   req1------------------>res1        (current one)
                    //        req2---------------->res2
                    // the request that fired later will always be kept.
                    // The timestamp maybe be `undefined` or a number
                    if (!FETCH[key] || FETCH[key][1] !== startAt) {
                        if (shouldStartNewRequest) {
                            if (isCurrentKeyMounted()) {
                                getConfig().onDiscarded(key);
                            }
                        }
                        return [2 /*return*/, false];
                    }
                    // Clear error.
                    patchFetchInfo({
                        error: UNDEFINED
                    });
                    newState.error = UNDEFINED;
                    mutationInfo = MUTATION[key];
                    if (!isUndefined(mutationInfo) &&
                        // case 1
                        (startAt <= mutationInfo[0] ||
                            // case 2
                            startAt <= mutationInfo[1] ||
                            // case 3
                            mutationInfo[1] === 0)) {
                        finishRequestAndUpdateState();
                        if (shouldStartNewRequest) {
                            if (isCurrentKeyMounted()) {
                                getConfig().onDiscarded(key);
                            }
                        }
                        return [2 /*return*/, false];
                    }
                    // Deep compare with latest state to avoid extra re-renders.
                    // For local state, compare and assign.
                    if (!compare(stateRef.current.data, newData)) {
                        newState.data = newData;
                    }
                    else {
                        // data and newData are deeply equal
                        // it should be safe to broadcast the stale data
                        newState.data = stateRef.current.data;
                        // At the end of this function, `brocastState` invokes the `onStateUpdate` function,
                        // which takes care of avoiding the re-render
                    }
                    // For global state, it's possible that the key has changed.
                    // https://github.com/vercel/swr/pull/1058
                    if (!compare(cache.get(key), newData)) {
                        cache.set(key, newData);
                    }
                    // Trigger the successful callback if it's the original request.
                    if (shouldStartNewRequest) {
                        if (isCurrentKeyMounted()) {
                            getConfig().onSuccess(newData, key, config);
                        }
                    }
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _b.sent();
                    cleanupState();
                    // Not paused, we continue handling the error. Otherwise discard it.
                    if (!getConfig().isPaused()) {
                        // Get a new error, don't use deep comparison for errors.
                        patchFetchInfo({ error: err_1 });
                        newState.error = err_1;
                        // Error event and retry logic. Only for the actual request, not
                        // deduped ones.
                        if (shouldStartNewRequest && isCurrentKeyMounted()) {
                            getConfig().onError(err_1, key, config);
                            if ((typeof config.shouldRetryOnError === 'boolean' &&
                                config.shouldRetryOnError) ||
                                (isFunction(config.shouldRetryOnError) &&
                                    config.shouldRetryOnError(err_1))) {
                                // When retrying, dedupe is always enabled
                                if (isActive()) {
                                    // If it's active, stop. It will auto revalidate when refocusing
                                    // or reconnecting.
                                    getConfig().onErrorRetry(err_1, key, config, revalidate, {
                                        retryCount: (opts.retryCount || 0) + 1,
                                        dedupe: true
                                    });
                                }
                            }
                        }
                    }
                    return [3 /*break*/, 4];
                case 4:
                    // Mark loading as stopped.
                    loading = false;
                    // Update the current hook's state.
                    finishRequestAndUpdateState();
                    // Here is the source of the request, need to tell all other hooks to
                    // update their states.
                    if (isCurrentKeyMounted() && shouldStartNewRequest) {
                        broadcastState(cache, key, newState.data, newState.error, false);
                    }
                    return [2 /*return*/, true];
            }
        });
    }); }, 
    // `setState` is immutable, and `eventsCallback`, `fnArgs`, `keyInfo`,
    // and `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [key]);
    // Similar to the global mutate, but bound to the current cache and key.
    // `cache` isn't allowed to change during the lifecycle.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var boundMutate = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(
    // By using `bind` we don't need to modify the size of the rest arguments.
    // Due to https://github.com/microsoft/TypeScript/issues/37181, we have to
    // cast it to any for now.
    internalMutate.bind(UNDEFINED, cache, function () { return keyRef.current; }), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // Always update fetcher and config refs.
    useIsomorphicLayoutEffect(function () {
        fetcherRef.current = fetcher;
        configRef.current = config;
    });
    // After mounted or key changed.
    useIsomorphicLayoutEffect(function () {
        if (!key)
            return;
        var keyChanged = key !== keyRef.current;
        var softRevalidate = revalidate.bind(UNDEFINED, WITH_DEDUPE);
        // Expose state updater to global event listeners. So we can update hook's
        // internal state from the outside.
        var onStateUpdate = function (updatedData, updatedError, updatedIsValidating) {
            setState(mergeObjects({
                error: updatedError,
                isValidating: updatedIsValidating
            }, 
            // Since `setState` only shallowly compares states, we do a deep
            // comparison here.
            compare(stateRef.current.data, updatedData)
                ? UNDEFINED
                : {
                    data: updatedData
                }));
        };
        // Expose revalidators to global event listeners. So we can trigger
        // revalidation from the outside.
        var nextFocusRevalidatedAt = 0;
        var onRevalidate = function (type) {
            if (type == FOCUS_EVENT) {
                var now = Date.now();
                if (getConfig().revalidateOnFocus &&
                    now > nextFocusRevalidatedAt &&
                    isActive()) {
                    nextFocusRevalidatedAt = now + getConfig().focusThrottleInterval;
                    softRevalidate();
                }
            }
            else if (type == RECONNECT_EVENT) {
                if (getConfig().revalidateOnReconnect && isActive()) {
                    softRevalidate();
                }
            }
            else if (type == MUTATE_EVENT) {
                return revalidate();
            }
            return;
        };
        var unsubUpdate = subscribeCallback(key, STATE_UPDATERS, onStateUpdate);
        var unsubEvents = subscribeCallback(key, EVENT_REVALIDATORS, onRevalidate);
        // Mark the component as mounted and update corresponding refs.
        unmountedRef.current = false;
        keyRef.current = key;
        initialMountedRef.current = true;
        // When `key` updates, reset the state to the initial value
        // and trigger a rerender if necessary.
        if (keyChanged) {
            setState({
                data: data,
                error: error,
                isValidating: isValidating
            });
        }
        // Trigger a revalidation.
        if (shouldRevalidate()) {
            if (isUndefined(data) || IS_SERVER) {
                // Revalidate immediately.
                softRevalidate();
            }
            else {
                // Delay the revalidate if we have data to return so we won't block
                // rendering.
                rAF(softRevalidate);
            }
        }
        return function () {
            // Mark it as unmounted.
            unmountedRef.current = true;
            unsubUpdate();
            unsubEvents();
        };
    }, [key, revalidate]);
    // Polling
    useIsomorphicLayoutEffect(function () {
        var timer;
        function next() {
            // Use the passed interval
            // ...or invoke the function with the updated data to get the interval
            var interval = isFunction(refreshInterval)
                ? refreshInterval(data)
                : refreshInterval;
            // We only start next interval if `refreshInterval` is not 0, and:
            // - `force` is true, which is the start of polling
            // - or `timer` is not 0, which means the effect wasn't canceled
            if (interval && timer !== -1) {
                timer = setTimeout(execute, interval);
            }
        }
        function execute() {
            // Check if it's OK to execute:
            // Only revalidate when the page is visible, online and not errored.
            if (!stateRef.current.error &&
                (refreshWhenHidden || getConfig().isVisible()) &&
                (refreshWhenOffline || getConfig().isOnline())) {
                revalidate(WITH_DEDUPE).then(next);
            }
            else {
                // Schedule next interval to check again.
                next();
            }
        }
        next();
        return function () {
            if (timer) {
                clearTimeout(timer);
                timer = -1;
            }
        };
    }, [refreshInterval, refreshWhenHidden, refreshWhenOffline, revalidate]);
    // Display debug info in React DevTools.
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useDebugValue)(data);
    // In Suspense mode, we can't return the empty `data` state.
    // If there is `error`, the `error` needs to be thrown to the error boundary.
    // If there is no `error`, the `revalidation` promise needs to be thrown to
    // the suspense boundary.
    if (suspense && isUndefined(data) && key) {
        // Always update fetcher and config refs even with the Suspense mode.
        fetcherRef.current = fetcher;
        configRef.current = config;
        unmountedRef.current = false;
        throw isUndefined(error) ? revalidate(WITH_DEDUPE) : error;
    }
    return {
        mutate: boundMutate,
        get data() {
            stateDependencies.data = true;
            return data;
        },
        get error() {
            stateDependencies.error = true;
            return error;
        },
        get isValidating() {
            stateDependencies.isValidating = true;
            return isValidating;
        }
    };
};
var SWRConfig = OBJECT.defineProperty(SWRConfig$1, 'default', {
    value: defaultConfig
});
var unstable_serialize = function (key) { return serialize(key)[0]; };
var useSWR = withArgs(useSWRHandler);

// useSWR




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,179], function() { return __webpack_exec__(16395), __webpack_exec__(35222), __webpack_exec__(6840), __webpack_exec__(90387); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);